var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Opera, Internet Explorer 8+
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2022 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 9.7.3
 * @date    2022-03-04
 */
!function (e, t) {
  exports = t();
}(self, function () {
  return i = {
    897: function (e, t, i) {
      "use strict";

      i.d(t, {
        x: function () {
          return r;
        }
      });
      var c = i(2602),
          h = i(9791),
          d = i(7907);

      function n(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var r = function () {
        function l(t, e) {
          if (!((this || _global) instanceof l)) throw new TypeError("Cannot call a class as a function");
          (this || _global).dom = {};
          var h = this || _global,
              i = (this || _global).dom,
              e = ((this || _global).anchor = void 0, (this || _global).items = t, (this || _global).eventListeners = {}, (this || _global).selection = void 0, (this || _global).onClose = e ? e.close : void 0, (this || _global).limitHeight = !!e && e.limitHeight, document.createElement("div")),
              n = (e.className = "jsoneditor-contextmenu-root", i.root = e, document.createElement("div")),
              e = (n.className = "jsoneditor-contextmenu", i.menu = n, e.appendChild(n), document.createElement("ul")),
              n = (e.className = "jsoneditor-menu", n.appendChild(e), i.list = e, i.items = [], document.createElement("button")),
              i = (n.type = "button", i.focusButton = n, document.createElement("li"));
          i.style.overflow = "hidden", i.style.height = "0", i.appendChild(n), e.appendChild(i), function a(l, c, e) {
            e.forEach(function (t) {
              var i, e, n, r, o, s;
              "separator" === t.type ? ((o = document.createElement("div")).className = "jsoneditor-separator", (e = document.createElement("li")).appendChild(o), l.appendChild(e)) : (i = {}, o = document.createElement("li"), l.appendChild(o), (e = document.createElement("button")).type = "button", e.className = t.className, i.button = e, t.title && (e.title = t.title), t.click && (e.onclick = function (e) {
                e.preventDefault(), h.hide(), t.click();
              }), o.appendChild(e), t.submenu ? ((r = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(r), (r = document.createElement("div")).className = "jsoneditor-text" + (t.click ? "" : " jsoneditor-right-margin"), r.appendChild(document.createTextNode(t.text)), e.appendChild(r), (n = t.click ? (e.className += " jsoneditor-default", (r = document.createElement("button")).type = "button", (i.buttonExpand = r).className = "jsoneditor-expand", (s = document.createElement("div")).className = "jsoneditor-expand", r.appendChild(s), o.appendChild(r), t.submenuTitle && (r.title = t.submenuTitle), r) : ((s = document.createElement("div")).className = "jsoneditor-expand", e.appendChild(s), e)).onclick = function (e) {
                e.preventDefault(), h._onExpandItem(i), n.focus();
              }, i.subItems = r = [], s = document.createElement("ul"), (i.ul = s).className = "jsoneditor-menu", s.style.height = "0", o.appendChild(s), a(s, r, t.submenu)) : ((o = document.createElement("div")).className = "jsoneditor-icon", e.appendChild(o), (s = document.createElement("div")).className = "jsoneditor-text", s.appendChild(document.createTextNode((0, d.Iu)(t.text))), e.appendChild(s)), c.push(i));
            });
          }(e, (this || _global).dom.items, t), (this || _global).maxHeight = 0, t.forEach(function (e) {
            e = 24 * (t.length + (e.submenu ? e.submenu.length : 0));
            h.maxHeight = Math.max(h.maxHeight, e);
          });
        }

        var e, t, i;
        return e = l, (t = [{
          key: "_getVisibleButtons",
          value: function () {
            var t = [],
                i = this || _global;
            return (this || _global).dom.items.forEach(function (e) {
              t.push(e.button), e.buttonExpand && t.push(e.buttonExpand), e.subItems && e === i.expandedItem && e.subItems.forEach(function (e) {
                t.push(e.button), e.buttonExpand && t.push(e.buttonExpand);
              });
            }), t;
          }
        }, {
          key: "show",
          value: function (e, t, i) {
            this.hide();
            var n = !0,
                r = e.parentNode,
                o = e.getBoundingClientRect(),
                r = r.getBoundingClientRect(),
                s = t.getBoundingClientRect(),
                a = this || _global,
                t = ((this || _global).dom.absoluteAnchor = (0, c.w)(e, t, function () {
              a.hide();
            }), o.bottom + (this || _global).maxHeight < s.bottom || o.top - (this || _global).maxHeight > s.top && (n = !1), i ? 0 : o.top - r.top);
            n ? (i = e.offsetHeight, (this || _global).dom.menu.style.left = "0", (this || _global).dom.menu.style.top = t + i + "px", (this || _global).dom.menu.style.bottom = "") : ((this || _global).dom.menu.style.left = "0", (this || _global).dom.menu.style.top = "", (this || _global).dom.menu.style.bottom = "0px"), (this || _global).limitHeight && (r = n ? s.bottom - o.bottom - 10 : o.top - s.top - 10, (this || _global).dom.list.style.maxHeight = r + "px", (this || _global).dom.list.style.overflowY = "auto"), (this || _global).dom.absoluteAnchor.appendChild((this || _global).dom.root), (this || _global).selection = (0, h.getSelection)(), (this || _global).anchor = e, setTimeout(function () {
              a.dom.focusButton.focus();
            }, 0), l.visibleMenu && l.visibleMenu.hide(), l.visibleMenu = this || _global;
          }
        }, {
          key: "hide",
          value: function () {
            (this || _global).dom.absoluteAnchor && ((this || _global).dom.absoluteAnchor.destroy(), delete (this || _global).dom.absoluteAnchor), (this || _global).dom.root.parentNode && ((this || _global).dom.root.parentNode.removeChild((this || _global).dom.root), (this || _global).onClose && this.onClose()), l.visibleMenu === (this || _global) && (l.visibleMenu = void 0);
          }
        }, {
          key: "_onExpandItem",
          value: function (i) {
            var n,
                r = this || _global,
                e = i === (this || _global).expandedItem,
                t = (this || _global).expandedItem;
            t && (t.ul.style.height = "0", t.ul.style.padding = "", setTimeout(function () {
              r.expandedItem !== t && (t.ul.style.display = "", h.removeClassName)(t.ul.parentNode, "jsoneditor-selected");
            }, 300), (this || _global).expandedItem = void 0), e || ((n = i.ul).style.display = "block", n.clientHeight, setTimeout(function () {
              if (r.expandedItem === i) {
                for (var e = 0, t = 0; t < n.childNodes.length; t++) e += n.childNodes[t].clientHeight;

                n.style.height = e + "px", n.style.padding = "5px 10px";
              }
            }, 0), (0, h.addClassName)(n.parentNode, "jsoneditor-selected"), (this || _global).expandedItem = i);
          }
        }, {
          key: "_onKeyDown",
          value: function (e) {
            var t,
                i,
                n,
                r,
                o = e.target,
                s = e.which,
                a = !1;
            27 === s ? ((this || _global).selection && (0, h.setSelection)((this || _global).selection), (this || _global).anchor && (this || _global).anchor.focus(), this.hide(), a = !0) : 9 === s ? e.shiftKey ? 0 === (i = (t = this._getVisibleButtons()).indexOf(o)) && (t[t.length - 1].focus(), a = !0) : (i = (t = this._getVisibleButtons()).indexOf(o)) === t.length - 1 && (t[0].focus(), a = !0) : 37 === s ? ("jsoneditor-expand" === o.className && (i = (t = this._getVisibleButtons()).indexOf(o), (n = t[i - 1]) && n.focus()), a = !0) : 38 === s ? (i = (t = this._getVisibleButtons()).indexOf(o), (n = (n = (n = t[i - 1]) && "jsoneditor-expand" === n.className ? t[i - 2] : n) || t[t.length - 1]) && n.focus(), a = !0) : 39 === s ? (i = (t = this._getVisibleButtons()).indexOf(o), (r = t[i + 1]) && "jsoneditor-expand" === r.className && r.focus(), a = !0) : 40 === s && (i = (t = this._getVisibleButtons()).indexOf(o), (r = (r = (r = t[i + 1]) && "jsoneditor-expand" === r.className ? t[i + 2] : r) || t[0]) && (r.focus(), a = !0), a = !0), a && (e.stopPropagation(), e.preventDefault());
          }
        }]) && n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), l;
      }();

      r.visibleMenu = void 0;
    },
    6436: function (e, t, i) {
      "use strict";

      function r(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      i.d(t, {
        Q: function () {
          return n;
        }
      });

      var n = function () {
        function i(e) {
          if (!((this || _global) instanceof i)) throw new TypeError("Cannot call a class as a function");
          (this || _global).errorTableVisible = e.errorTableVisible, (this || _global).onToggleVisibility = e.onToggleVisibility, (this || _global).onFocusLine = e.onFocusLine || function () {}, (this || _global).onChangeHeight = e.onChangeHeight, (this || _global).dom = {};
          var e = document.createElement("div"),
              t = (e.className = "jsoneditor-validation-errors-container", (this || _global).dom.validationErrorsContainer = e, document.createElement("div")),
              e = (t.style.display = "none", t.className = "jsoneditor-additional-errors fadein", t.textContent = "Scroll for more \u25BF", (this || _global).dom.additionalErrorsIndication = t, e.appendChild(t), document.createElement("span")),
              t = (e.className = "jsoneditor-validation-error-icon", e.style.display = "none", (this || _global).dom.validationErrorIcon = e, document.createElement("span"));
          t.className = "jsoneditor-validation-error-count", t.style.display = "none", (this || _global).dom.validationErrorCount = t, (this || _global).dom.parseErrorIndication = document.createElement("span"), (this || _global).dom.parseErrorIndication.className = "jsoneditor-parse-error-icon", (this || _global).dom.parseErrorIndication.style.display = "none";
        }

        var e, t, n;
        return e = i, (t = [{
          key: "getErrorTable",
          value: function () {
            return (this || _global).dom.validationErrorsContainer;
          }
        }, {
          key: "getErrorCounter",
          value: function () {
            return (this || _global).dom.validationErrorCount;
          }
        }, {
          key: "getWarningIcon",
          value: function () {
            return (this || _global).dom.validationErrorIcon;
          }
        }, {
          key: "getErrorIcon",
          value: function () {
            return (this || _global).dom.parseErrorIndication;
          }
        }, {
          key: "toggleTableVisibility",
          value: function () {
            (this || _global).errorTableVisible = !(this || _global).errorTableVisible, this.onToggleVisibility((this || _global).errorTableVisible);
          }
        }, {
          key: "setErrors",
          value: function (e, o) {
            var s,
                t,
                a = this || _global,
                i = ((this || _global).dom.validationErrors && ((this || _global).dom.validationErrors.parentNode.removeChild((this || _global).dom.validationErrors), (this || _global).dom.validationErrors = null, (this || _global).dom.additionalErrorsIndication.style.display = "none"), (this || _global).errorTableVisible && 0 < e.length ? ((i = document.createElement("div")).className = "jsoneditor-validation-errors", (t = document.createElement("table")).className = "jsoneditor-text-errors", i.appendChild(t), s = document.createElement("tbody"), t.appendChild(s), e.forEach(function (t) {
              isNaN(t.line) ? t.dataPath && (i = o.find(function (e) {
                return e.path === t.dataPath;
              })) && (e = i.line + 1) : e = t.line;
              var e,
                  i = document.createElement("tr"),
                  n = (i.className = isNaN(e) ? "" : "jump-to-line", "error" === t.type ? i.className += " parse-error" : i.className += " validation-error", document.createElement("td")),
                  r = document.createElement("button"),
                  r = (r.className = "jsoneditor-schema-error", n.appendChild(r), i.appendChild(n), document.createElement("td"));
              r.style = "white-space: nowrap;", r.textContent = isNaN(e) ? "" : "Ln " + e, i.appendChild(r), "string" == typeof t ? ((n = document.createElement("td")).colSpan = 2, (r = document.createElement("pre")).appendChild(document.createTextNode(t)), n.appendChild(r), i.appendChild(n)) : ((r = document.createElement("td")).appendChild(document.createTextNode(t.dataPath || "")), i.appendChild(r), n = document.createElement("td"), (r = document.createElement("pre")).appendChild(document.createTextNode(t.message.replace(/<br>/gi, "\n"))), n.appendChild(r), i.appendChild(n)), i.onclick = function () {
                a.onFocusLine(e);
              }, s.appendChild(i);
            }), (this || _global).dom.validationErrors = i, (this || _global).dom.validationErrorsContainer.appendChild(i), (this || _global).dom.additionalErrorsIndication.title = e.length + " errors total", (this || _global).dom.validationErrorsContainer.clientHeight < (this || _global).dom.validationErrorsContainer.scrollHeight ? ((this || _global).dom.additionalErrorsIndication.style.display = "block", (this || _global).dom.validationErrorsContainer.onscroll = function () {
              a.dom.additionalErrorsIndication.style.display = 0 < a.dom.validationErrorsContainer.clientHeight && 0 === a.dom.validationErrorsContainer.scrollTop ? "block" : "none";
            }) : (this || _global).dom.validationErrorsContainer.onscroll = void 0, t = (this || _global).dom.validationErrorsContainer.clientHeight + ((this || _global).dom.statusBar ? (this || _global).dom.statusBar.clientHeight : 0), this.onChangeHeight(t)) : this.onChangeHeight(0), e.filter(function (e) {
              return "error" !== e.type;
            }).length);
            0 < i ? ((this || _global).dom.validationErrorCount.style.display = "inline", (this || _global).dom.validationErrorCount.innerText = i, (this || _global).dom.validationErrorCount.onclick = (this || _global).toggleTableVisibility.bind(this || _global), (this || _global).dom.validationErrorIcon.style.display = "inline", (this || _global).dom.validationErrorIcon.title = i + " schema validation error(s) found", (this || _global).dom.validationErrorIcon.onclick = (this || _global).toggleTableVisibility.bind(this || _global)) : ((this || _global).dom.validationErrorCount.style.display = "none", (this || _global).dom.validationErrorIcon.style.display = "none"), e.some(function (e) {
              return "error" === e.type;
            }) ? (t = e[0].line, (this || _global).dom.parseErrorIndication.style.display = "block", (this || _global).dom.parseErrorIndication.title = isNaN(t) ? "parse error - check that the json is valid" : "parse error on line " + t, (this || _global).dom.parseErrorIndication.onclick = (this || _global).toggleTableVisibility.bind(this || _global)) : (this || _global).dom.parseErrorIndication.style.display = "none";
          }
        }]) && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), i;
      }();
    },
    2474: function (e, t, i) {
      "use strict";

      function r(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      i.d(t, {
        R: function () {
          return n;
        }
      });

      var n = function () {
        function t(e) {
          if (!((this || _global) instanceof t)) throw new TypeError("Cannot call a class as a function");
          if ((this || _global).target = e.target || null, !(this || _global).target) throw new Error("FocusTracker constructor called without a \"target\" to track.");
          (this || _global).onFocus = "function" == typeof e.onFocus ? e.onFocus : null, (this || _global).onBlur = "function" == typeof e.onBlur ? e.onBlur : null, (this || _global)._onClick = (this || _global)._onEvent.bind(this || _global), (this || _global)._onKeyUp = function (e) {
            9 !== e.which && 9 !== e.keyCode || this._onEvent(e);
          }.bind(this || _global), (this || _global).focusFlag = !1, (this || _global).firstEventFlag = !0, ((this || _global).onFocus || (this || _global).onBlur) && (document.addEventListener("click", (this || _global)._onClick), document.addEventListener("keyup", (this || _global)._onKeyUp));
        }

        var e, i, n;
        return e = t, (i = [{
          key: "destroy",
          value: function () {
            document.removeEventListener("click", (this || _global)._onClick), document.removeEventListener("keyup", (this || _global)._onKeyUp), this._onEvent({
              target: document.body
            });
          }
        }, {
          key: "_onEvent",
          value: function (e) {
            e = e.target, e = e === (this || _global).target || !(!(this || _global).target.contains(e) && !(this || _global).target.contains(document.activeElement));
            e ? (this || _global).focusFlag || ((this || _global).onFocus && this.onFocus({
              type: "focus",
              target: (this || _global).target
            }), (this || _global).focusFlag = !0) : ((this || _global).focusFlag || (this || _global).firstEventFlag) && ((this || _global).onBlur && this.onBlur({
              type: "blur",
              target: (this || _global).target
            }), (this || _global).focusFlag = !1, (this || _global).firstEventFlag && ((this || _global).firstEventFlag = !1));
          }
        }]) && r(e.prototype, i), n && r(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t;
      }();
    },
    3161: function (e, t, r) {
      "use strict";

      var i = r(8170),
          n = r(8037),
          o = r(8038).treeModeMixins,
          s = r(5956).textModeMixins,
          a = r(341).previewModeMixins,
          l = r(9791),
          c = l.clear,
          h = l.extend,
          d = l.getInnerText,
          u = l.getInternetExplorerVersion,
          g = l.parse,
          l = r(2744).tryRequireAjv,
          p = r(2558).showTransformModal,
          m = r(6210).showSortModal,
          f = l();

      function C(e, t, i) {
        if (!((this || _global) instanceof C)) throw new Error("JSONEditor constructor called without \"new\".");
        var n = u();
        if (-1 !== n && n < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
        t && (t.error && (console.warn("Option \"error\" has been renamed to \"onError\""), t.onError = t.error, delete t.error), t.change && (console.warn("Option \"change\" has been renamed to \"onChange\""), t.onChange = t.change, delete t.change), t.editable && (console.warn("Option \"editable\" has been renamed to \"onEditable\""), t.onEditable = t.editable, delete t.editable), t.onChangeJSON && ("text" === t.mode || "code" === t.mode || t.modes && (-1 !== t.modes.indexOf("text") || -1 !== t.modes.indexOf("code"))) && console.warn("Option \"onChangeJSON\" is not applicable to modes \"text\" and \"code\". Use \"onChangeText\" or \"onChange\" instead."), t && Object.keys(t).forEach(function (e) {
          -1 === C.VALID_OPTIONS.indexOf(e) && console.warn("Unknown option \"" + e + "\". This option will be ignored");
        })), arguments.length && this._create(e, t, i);
      }

      "undefined" == typeof Promise && console.error("Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor"), C.modes = {}, C.prototype.DEBOUNCE_INTERVAL = 150, C.VALID_OPTIONS = ["ajv", "schema", "schemaRefs", "templates", "ace", "theme", "autocomplete", "onChange", "onChangeJSON", "onChangeText", "onEditable", "onError", "onEvent", "onModeChange", "onNodeName", "onValidate", "onCreateMenu", "onSelectionChange", "onTextSelectionChange", "onClassName", "onFocus", "onBlur", "colorPicker", "onColorPicker", "timestampTag", "timestampFormat", "escapeUnicode", "history", "search", "mode", "modes", "name", "indentation", "sortObjectKeys", "navigationBar", "statusBar", "mainMenuBar", "languages", "language", "enableSort", "enableTransform", "limitDragging", "maxVisibleChilds", "onValidationError", "modalAnchor", "popupAnchor", "createQuery", "executeQuery", "queryDescription"], C.prototype._create = function (e, t, i) {
        (this || _global).container = e, (this || _global).options = t || {}, (this || _global).json = i || {};
        e = (this || _global).options.mode || (this || _global).options.modes && (this || _global).options.modes[0] || "tree";
        this.setMode(e);
      }, C.prototype.destroy = function () {}, C.prototype.set = function (e) {
        (this || _global).json = e;
      }, C.prototype.get = function () {
        return (this || _global).json;
      }, C.prototype.setText = function (e) {
        (this || _global).json = g(e);
      }, C.prototype.getText = function () {
        return JSON.stringify((this || _global).json);
      }, C.prototype.setName = function (e) {
        (this || _global).options || ((this || _global).options = {}), (this || _global).options.name = e;
      }, C.prototype.getName = function () {
        return (this || _global).options && (this || _global).options.name;
      }, C.prototype.setMode = function (e) {
        if (e !== (this || _global).options.mode || !(this || _global).create) {
          var t = (this || _global).container,
              i = h({}, (this || _global).options),
              n = i.mode,
              r = (i.mode = e, C.modes[e]);
          if (!r) throw new Error("Unknown mode \"" + i.mode + "\"");
          var o = "text" === r.data,
              s = this.getName(),
              a = this[o ? "getText" : "get"]();
          if (this.destroy(), c(this || _global), h(this || _global, r.mixin), this.create(t, i), this.setName(s), this[o ? "setText" : "set"](a), "function" == typeof r.load) try {
            r.load.call(this || _global);
          } catch (e) {
            console.error(e);
          }
          if ("function" == typeof i.onModeChange && e !== n) try {
            i.onModeChange(e, n);
          } catch (e) {
            console.error(e);
          }
        }
      }, C.prototype.getMode = function () {
        return (this || _global).options.mode;
      }, C.prototype._onError = function (e) {
        (this || _global).options && "function" == typeof (this || _global).options.onError ? (this || _global).options.onError(e) : alert(e.toString());
      }, C.prototype.setSchema = function (e, t) {
        if (e) {
          var i;

          try {
            (this || _global).options.ajv ? i = (this || _global).options.ajv : ((i = f({
              allErrors: !0,
              verbose: !0,
              schemaId: "auto",
              $data: !0
            })).addMetaSchema(r(7171)), i.addMetaSchema(r(6273)));
          } catch (e) {
            console.warn("Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.");
          }

          if (i) {
            if (t) {
              for (var n in t) i.removeSchema(n), t[n] && i.addSchema(t[n], n);

              (this || _global).options.schemaRefs = t;
            }

            (this || _global).validateSchema = i.compile(e), (this || _global).options.schema = e, (this || _global).options.schemaRefs = t, this.validate();
          }

          this.refresh();
        } else (this || _global).validateSchema = null, (this || _global).options.schema = null, (this || _global).options.schemaRefs = null, this.validate(), this.refresh();
      }, C.prototype.validate = function () {}, C.prototype.refresh = function () {}, (C.registerMode = function (e) {
        var t;
        if (Array.isArray(e)) for (r = 0; r < e.length; r++) C.registerMode(e[r]);else {
          if (!("mode" in e)) throw new Error("Property \"mode\" missing");
          if (!("mixin" in e)) throw new Error("Property \"mixin\" missing");
          if (!("data" in e)) throw new Error("Property \"data\" missing");
          var i = e.mode;
          if (i in C.modes) throw new Error("Mode \"" + i + "\" already registered");
          if ("function" != typeof e.mixin.create) throw new Error("Required function \"create\" missing on mixin");

          for (var n = ["setMode", "registerMode", "modes"], r = 0; r < n.length; r++) if ((t = n[r]) in e.mixin) throw new Error("Reserved property \"" + t + "\" not allowed in mixin");

          C.modes[i] = e;
        }
      })(o), C.registerMode(s), C.registerMode(a), C.ace = i, C.Ajv = f, C.VanillaPicker = n, C.showTransformModal = p, C.showSortModal = m, C.getInnerText = d, e.exports = C.default = C;
    },
    6617: function (e, t, i) {
      "use strict";

      i.d(t, {
        x: function () {
          return r;
        }
      });
      var u = i(897),
          g = i(7907);

      function n(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var r = function () {
        function d(e, t, i, n) {
          if (!((this || _global) instanceof d)) throw new TypeError("Cannot call a class as a function");

          for (var r = {
            code: {
              text: (0, g.Iu)("modeCodeText"),
              title: (0, g.Iu)("modeCodeTitle"),
              click: function () {
                n("code");
              }
            },
            form: {
              text: (0, g.Iu)("modeFormText"),
              title: (0, g.Iu)("modeFormTitle"),
              click: function () {
                n("form");
              }
            },
            text: {
              text: (0, g.Iu)("modeTextText"),
              title: (0, g.Iu)("modeTextTitle"),
              click: function () {
                n("text");
              }
            },
            tree: {
              text: (0, g.Iu)("modeTreeText"),
              title: (0, g.Iu)("modeTreeTitle"),
              click: function () {
                n("tree");
              }
            },
            view: {
              text: (0, g.Iu)("modeViewText"),
              title: (0, g.Iu)("modeViewTitle"),
              click: function () {
                n("view");
              }
            },
            preview: {
              text: (0, g.Iu)("modePreviewText"),
              title: (0, g.Iu)("modePreviewTitle"),
              click: function () {
                n("preview");
              }
            }
          }, o = [], s = 0; s < t.length; s++) {
            var a = t[s],
                l = r[a];
            if (!l) throw new Error("Unknown mode \"" + a + "\"");
            l.className = "jsoneditor-type-modes" + (i === a ? " jsoneditor-selected" : ""), o.push(l);
          }

          var c = r[i];
          if (!c) throw new Error("Unknown mode \"" + i + "\"");
          var c = c.text,
              h = document.createElement("button"),
              c = (h.type = "button", h.className = "jsoneditor-modes jsoneditor-separator", h.textContent = c + " \u25BE", h.title = (0, g.Iu)("modeEditorTitle"), h.onclick = function () {
            new u.x(o).show(h, e);
          }, document.createElement("div"));
          c.className = "jsoneditor-modes", c.style.position = "relative", c.appendChild(h), e.appendChild(c), (this || _global).dom = {
            container: e,
            box: h,
            frame: c
          };
        }

        var e, t, i;
        return e = d, (t = [{
          key: "focus",
          value: function () {
            (this || _global).dom.box.focus();
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).dom && (this || _global).dom.frame && (this || _global).dom.frame.parentNode && (this || _global).dom.frame.parentNode.removeChild((this || _global).dom.frame), (this || _global).dom = null;
          }
        }]) && n(e.prototype, t), i && n(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), d;
      }();
    },
    8170: function (e, t, i) {
      var n;
      if (window.ace) n = window.ace;else try {
        n = i(6225), i(4091), i(3330);
        var r = i(7923);
        n.config.setModuleUrl("ace/mode/json_worker", r);
      } catch (e) {}
      e.exports = n;
    },
    4864: function () {
      window.ace.define("ace/theme/jsoneditor", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        t.isDark = !1, t.cssClass = "ace-jsoneditor", t.cssText = ".ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y\n}", e("../lib/dom").importCssString(t.cssText, t.cssClass);
      });
    },
    6589: function (e, t) {
      (i = {
        trace: function () {},
        yy: {},
        symbols_: {
          error: 2,
          JSONString: 3,
          STRING: 4,
          JSONNumber: 5,
          NUMBER: 6,
          JSONNullLiteral: 7,
          NULL: 8,
          JSONBooleanLiteral: 9,
          TRUE: 10,
          FALSE: 11,
          JSONText: 12,
          JSONValue: 13,
          EOF: 14,
          JSONObject: 15,
          JSONArray: 16,
          "{": 17,
          "}": 18,
          JSONMemberList: 19,
          JSONMember: 20,
          ":": 21,
          ",": 22,
          "[": 23,
          "]": 24,
          JSONElementList: 25,
          $accept: 0,
          $end: 1
        },
        terminals_: {
          2: "error",
          4: "STRING",
          6: "NUMBER",
          8: "NULL",
          10: "TRUE",
          11: "FALSE",
          14: "EOF",
          17: "{",
          18: "}",
          21: ":",
          22: ",",
          23: "[",
          24: "]"
        },
        productions_: [0, [3, 1], [5, 1], [7, 1], [9, 1], [9, 1], [12, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [15, 2], [15, 3], [20, 3], [19, 1], [19, 3], [16, 2], [16, 3], [25, 1], [25, 3]],
        performAction: function (e, t, i, n, r, o, s) {
          var a = o.length - 1;

          switch (r) {
            case 1:
              (this || _global).$ = e.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "\t").replace(/\\v/g, "\x0B").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
              break;

            case 2:
              (this || _global).$ = Number(e);
              break;

            case 3:
              (this || _global).$ = null;
              break;

            case 4:
              (this || _global).$ = !0;
              break;

            case 5:
              (this || _global).$ = !1;
              break;

            case 6:
              return (this || _global).$ = o[a - 1];

            case 13:
              (this || _global).$ = {};
              break;

            case 14:
              (this || _global).$ = o[a - 1];
              break;

            case 15:
              (this || _global).$ = [o[a - 2], o[a]];
              break;

            case 16:
              (this || _global).$ = {}, (this || _global).$[o[a][0]] = o[a][1];
              break;

            case 17:
              (this || _global).$ = o[a - 2], o[a - 2][o[a][0]] = o[a][1];
              break;

            case 18:
              (this || _global).$ = [];
              break;

            case 19:
              (this || _global).$ = o[a - 1];
              break;

            case 20:
              (this || _global).$ = [o[a]];
              break;

            case 21:
              (this || _global).$ = o[a - 2], o[a - 2].push(o[a]);
          }
        },
        table: [{
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          12: 1,
          13: 2,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          1: [3]
        }, {
          14: [1, 16]
        }, {
          14: [2, 7],
          18: [2, 7],
          22: [2, 7],
          24: [2, 7]
        }, {
          14: [2, 8],
          18: [2, 8],
          22: [2, 8],
          24: [2, 8]
        }, {
          14: [2, 9],
          18: [2, 9],
          22: [2, 9],
          24: [2, 9]
        }, {
          14: [2, 10],
          18: [2, 10],
          22: [2, 10],
          24: [2, 10]
        }, {
          14: [2, 11],
          18: [2, 11],
          22: [2, 11],
          24: [2, 11]
        }, {
          14: [2, 12],
          18: [2, 12],
          22: [2, 12],
          24: [2, 12]
        }, {
          14: [2, 3],
          18: [2, 3],
          22: [2, 3],
          24: [2, 3]
        }, {
          14: [2, 4],
          18: [2, 4],
          22: [2, 4],
          24: [2, 4]
        }, {
          14: [2, 5],
          18: [2, 5],
          22: [2, 5],
          24: [2, 5]
        }, {
          14: [2, 1],
          18: [2, 1],
          21: [2, 1],
          22: [2, 1],
          24: [2, 1]
        }, {
          14: [2, 2],
          18: [2, 2],
          22: [2, 2],
          24: [2, 2]
        }, {
          3: 20,
          4: [1, 12],
          18: [1, 17],
          19: 18,
          20: 19
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 23,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15],
          24: [1, 21],
          25: 22
        }, {
          1: [2, 6]
        }, {
          14: [2, 13],
          18: [2, 13],
          22: [2, 13],
          24: [2, 13]
        }, {
          18: [1, 24],
          22: [1, 25]
        }, {
          18: [2, 16],
          22: [2, 16]
        }, {
          21: [1, 26]
        }, {
          14: [2, 18],
          18: [2, 18],
          22: [2, 18],
          24: [2, 18]
        }, {
          22: [1, 28],
          24: [1, 27]
        }, {
          22: [2, 20],
          24: [2, 20]
        }, {
          14: [2, 14],
          18: [2, 14],
          22: [2, 14],
          24: [2, 14]
        }, {
          3: 20,
          4: [1, 12],
          20: 29
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 30,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          14: [2, 19],
          18: [2, 19],
          22: [2, 19],
          24: [2, 19]
        }, {
          3: 5,
          4: [1, 12],
          5: 6,
          6: [1, 13],
          7: 3,
          8: [1, 9],
          9: 4,
          10: [1, 10],
          11: [1, 11],
          13: 31,
          15: 7,
          16: 8,
          17: [1, 14],
          23: [1, 15]
        }, {
          18: [2, 17],
          22: [2, 17]
        }, {
          18: [2, 15],
          22: [2, 15]
        }, {
          22: [2, 21],
          24: [2, 21]
        }],
        defaultActions: {
          16: [2, 6]
        },
        parseError: function (e, t) {
          throw new Error(e);
        },
        parse: function (e) {
          var t = this || _global,
              i = [0],
              n = [null],
              r = [],
              o = (this || _global).table,
              s = "",
              a = 0,
              l = 0,
              c = 0,
              h = ((this || _global).lexer.setInput(e), (this || _global).lexer.yy = (this || _global).yy, (this || _global).yy.lexer = (this || _global).lexer, void 0 === (this || _global).lexer.yylloc && ((this || _global).lexer.yylloc = {}), (this || _global).lexer.yylloc);

          function d() {
            var e = t.lexer.lex() || 1;
            return e = "number" != typeof e ? t.symbols_[e] || e : e;
          }

          r.push(h), "function" == typeof (this || _global).yy.parseError && ((this || _global).parseError = (this || _global).yy.parseError);

          for (var u, g, p, m, f, C, I, v, A, b = {};;) {
            if (p = i[i.length - 1], void 0 === (m = (this || _global).defaultActions[p] || (null == u && (u = d()), o[p] && o[p][u])) || !m.length || !m[0]) {
              if (!c) {
                for (f in v = [], o[p]) (this || _global).terminals_[f] && 2 < f && v.push("'" + (this || _global).terminals_[f] + "'");

                var y = "",
                    y = (this || _global).lexer.showPosition ? "Parse error on line " + (a + 1) + ":\n" + (this || _global).lexer.showPosition() + "\nExpecting " + v.join(", ") + ", got '" + (this || _global).terminals_[u] + "'" : "Parse error on line " + (a + 1) + ": Unexpected " + (1 == u ? "end of input" : "'" + ((this || _global).terminals_[u] || u) + "'");
                this.parseError(y, {
                  text: (this || _global).lexer.match,
                  token: (this || _global).terminals_[u] || u,
                  line: (this || _global).lexer.yylineno,
                  loc: h,
                  expected: v
                });
              }

              if (3 == c) {
                if (1 == u) throw new Error(y || "Parsing halted.");
                l = (this || _global).lexer.yyleng, s = (this || _global).lexer.yytext, a = (this || _global).lexer.yylineno, h = (this || _global).lexer.yylloc, u = d();
              }

              for (;;) {
                if (2 .toString() in o[p]) break;
                if (0 == p) throw new Error(y || "Parsing halted.");
                A = 1, i.length = i.length - 2 * A, n.length = n.length - A, r.length = r.length - A, p = i[i.length - 1];
              }

              g = u, u = 2, m = o[p = i[i.length - 1]] && o[p][2], c = 3;
            }

            if (m[0] instanceof Array && 1 < m.length) throw new Error("Parse Error: multiple actions possible at state: " + p + ", token: " + u);

            switch (m[0]) {
              case 1:
                i.push(u), n.push((this || _global).lexer.yytext), r.push((this || _global).lexer.yylloc), i.push(m[1]), u = null, g ? (u = g, g = null) : (l = (this || _global).lexer.yyleng, s = (this || _global).lexer.yytext, a = (this || _global).lexer.yylineno, h = (this || _global).lexer.yylloc, 0 < c && c--);
                break;

              case 2:
                if (C = (this || _global).productions_[m[1]][1], b.$ = n[n.length - C], b._$ = {
                  first_line: r[r.length - (C || 1)].first_line,
                  last_line: r[r.length - 1].last_line,
                  first_column: r[r.length - (C || 1)].first_column,
                  last_column: r[r.length - 1].last_column
                }, void 0 !== (I = (this || _global).performAction.call(b, s, l, a, (this || _global).yy, m[1], n, r))) return I;
                C && (i = i.slice(0, -1 * C * 2), n = n.slice(0, -1 * C), r = r.slice(0, -1 * C)), i.push((this || _global).productions_[m[1]][0]), n.push(b.$), r.push(b._$), I = o[i[i.length - 2]][i[i.length - 1]], i.push(I);
                break;

              case 3:
                return !0;
            }
          }

          return !0;
        }
      }).lexer = {
        EOF: 1,
        parseError: function (e, t) {
          if (!(this || _global).yy.parseError) throw new Error(e);

          (this || _global).yy.parseError(e, t);
        },
        setInput: function (e) {
          return (this || _global)._input = e, (this || _global)._more = (this || _global)._less = (this || _global).done = !1, (this || _global).yylineno = (this || _global).yyleng = 0, (this || _global).yytext = (this || _global).matched = (this || _global).match = "", (this || _global).conditionStack = ["INITIAL"], (this || _global).yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          }, this || _global;
        },
        input: function () {
          var e = (this || _global)._input[0];
          return (this || _global).yytext += e, (this || _global).yyleng++, (this || _global).match += e, (this || _global).matched += e, e.match(/\n/) && (this || _global).yylineno++, (this || _global)._input = (this || _global)._input.slice(1), e;
        },
        unput: function (e) {
          return (this || _global)._input = e + (this || _global)._input, this || _global;
        },
        more: function () {
          return (this || _global)._more = !0, this || _global;
        },
        less: function (e) {
          (this || _global)._input = (this || _global).match.slice(e) + (this || _global)._input;
        },
        pastInput: function () {
          var e = (this || _global).matched.substr(0, (this || _global).matched.length - (this || _global).match.length);

          return (20 < e.length ? "..." : "") + e.substr(-20).replace(/\n/g, "");
        },
        upcomingInput: function () {
          var e = (this || _global).match;
          return e.length < 20 && (e += (this || _global)._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (20 < e.length ? "..." : "")).replace(/\n/g, "");
        },
        showPosition: function () {
          var e = this.pastInput(),
              t = new Array(e.length + 1).join("-");
          return e + this.upcomingInput() + "\n" + t + "^";
        },
        next: function () {
          if ((this || _global).done) return (this || _global).EOF;
          (this || _global)._input || ((this || _global).done = !0), (this || _global)._more || ((this || _global).yytext = "", (this || _global).match = "");

          for (var e, t, i, n, r = this._currentRules(), o = 0; o < r.length && (!(t = (this || _global)._input.match((this || _global).rules[r[o]])) || e && !(t[0].length > e[0].length) || (e = t, i = o, (this || _global).options.flex)); o++);

          return e ? ((n = e[0].match(/\n.*/g)) && ((this || _global).yylineno += n.length), (this || _global).yylloc = {
            first_line: (this || _global).yylloc.last_line,
            last_line: (this || _global).yylineno + 1,
            first_column: (this || _global).yylloc.last_column,
            last_column: n ? n[n.length - 1].length - 1 : (this || _global).yylloc.last_column + e[0].length
          }, (this || _global).yytext += e[0], (this || _global).match += e[0], (this || _global).yyleng = (this || _global).yytext.length, (this || _global)._more = !1, (this || _global)._input = (this || _global)._input.slice(e[0].length), (this || _global).matched += e[0], n = (this || _global).performAction.call(this || _global, (this || _global).yy, this || _global, r[i], (this || _global).conditionStack[(this || _global).conditionStack.length - 1]), (this || _global).done && (this || _global)._input && ((this || _global).done = !1), n || void 0) : "" === (this || _global)._input ? (this || _global).EOF : void this.parseError("Lexical error on line " + ((this || _global).yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
            text: "",
            token: null,
            line: (this || _global).yylineno
          });
        },
        lex: function () {
          var e = this.next();
          return void 0 !== e ? e : this.lex();
        },
        begin: function (e) {
          (this || _global).conditionStack.push(e);
        },
        popState: function () {
          return (this || _global).conditionStack.pop();
        },
        _currentRules: function () {
          return (this || _global).conditions[(this || _global).conditionStack[(this || _global).conditionStack.length - 1]].rules;
        },
        topState: function () {
          return (this || _global).conditionStack[(this || _global).conditionStack.length - 2];
        },
        pushState: function (e) {
          this.begin(e);
        },
        options: {},
        performAction: function (e, t, i, n) {
          switch (i) {
            case 0:
              break;

            case 1:
              return 6;

            case 2:
              return t.yytext = t.yytext.substr(1, t.yyleng - 2), 4;

            case 3:
              return 17;

            case 4:
              return 18;

            case 5:
              return 23;

            case 6:
              return 24;

            case 7:
              return 22;

            case 8:
              return 21;

            case 9:
              return 10;

            case 10:
              return 11;

            case 11:
              return 8;

            case 12:
              return 14;

            case 13:
              return "INVALID";
          }
        },
        rules: [/^(?:\s+)/, /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/, /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/, /^(?:\{)/, /^(?:\})/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?::)/, /^(?:true\b)/, /^(?:false\b)/, /^(?:null\b)/, /^(?:$)/, /^(?:.)/],
        conditions: {
          INITIAL: {
            rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            inclusive: !0
          }
        }
      };
      var i;
      t.parser = i, t.parse = i.parse.bind(i);
    },
    3879: function (e) {
      "use strict";

      function n() {}

      var i = {
        defaultSelected: !0,
        width: "auto",
        disabled: !1,
        searchable: !0,
        clearable: !1,
        sortSelected: !1,
        allowDeselect: !1,
        closeOnScroll: !1,
        nativeDropdown: !1,
        placeholder: "Select an option...",
        taggable: !1,
        tagPlaceholder: "Enter a tag..."
      },
          h = (n.prototype = {
        on: function (e, t) {
          (this || _global)._events = (this || _global)._events || {}, (this || _global)._events[e] = (this || _global)._events[e] || [], (this || _global)._events[e].push(t);
        },
        off: function (e, t) {
          (this || _global)._events = (this || _global)._events || {}, e in (this || _global)._events != !1 && (this || _global)._events[e].splice((this || _global)._events[e].indexOf(t), 1);
        },
        emit: function (e) {
          if ((this || _global)._events = (this || _global)._events || {}, e in (this || _global)._events != !1) for (var t = 0; t < (this || _global)._events[e].length; t++) (this || _global)._events[e][t].apply(this || _global, Array.prototype.slice.call(arguments, 1));
        }
      }, n.mixin = function (e) {
        for (var t = ["on", "off", "emit"], i = 0; i < t.length; i++) "function" == typeof e ? e.prototype[t[i]] = n.prototype[t[i]] : e[t[i]] = n.prototype[t[i]];

        return e;
      }, {
        extend: function (e, t) {
          for (var i in t = t || {}, e) !e.hasOwnProperty(i) || t.hasOwnProperty(i) || (t[i] = e[i]);

          return t;
        },
        each: function (e, t, i) {
          if ("[object Object]" === Object.prototype.toString.call(e)) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.call(i, n, e[n], e);else for (var r = 0, o = e.length; r < o; r++) t.call(i, r, e[r], e);
        },
        createElement: function (e, t) {
          var i,
              n,
              r = document,
              o = r.createElement(e);
          if (t && "[object Object]" === Object.prototype.toString.call(t)) for (i in t) i in o ? o[i] = t[i] : "html" === i ? o.textContent = t[i] : "text" === i ? (n = r.createTextNode(t[i]), o.appendChild(n)) : o.setAttribute(i, t[i]);
          return o;
        },
        hasClass: function (e, t) {
          if (e) return e.classList ? e.classList.contains(t) : !!e.className && !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
        },
        addClass: function (e, t) {
          h.hasClass(e, t) || (e.classList ? e.classList.add(t) : e.className = e.className.trim() + " " + t);
        },
        removeClass: function (e, t) {
          h.hasClass(e, t) && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " "));
        },
        closest: function (e, t) {
          return e && e !== document.body && (t(e) ? e : h.closest(e.parentNode, t));
        },
        isInt: function (e) {
          return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
        },
        debounce: function (n, r, o) {
          var s;
          return function () {
            var e = this || _global,
                t = arguments,
                i = o && !s;
            clearTimeout(s), s = setTimeout(function () {
              s = null, o || n.apply(e, t);
            }, r), i && n.apply(e, t);
          };
        },
        rect: function (e, t) {
          var i = window,
              e = e.getBoundingClientRect(),
              n = t ? i.pageXOffset : 0,
              t = t ? i.pageYOffset : 0;
          return {
            bottom: e.bottom + t,
            height: e.height,
            left: e.left + n,
            right: e.right + n,
            top: e.top + t,
            width: e.width
          };
        },
        includes: function (e, t) {
          return -1 < e.indexOf(t);
        },
        truncate: function (e) {
          for (; e.firstChild;) e.removeChild(e.firstChild);
        }
      });

      function l(e, t) {
        return e.hasOwnProperty(t) && (!0 === e[t] || e[t].length);
      }

      function a(e, t, i) {
        e.parentNode ? e.parentNode.parentNode || t.appendChild(e.parentNode) : t.appendChild(e), h.removeClass(e, "excluded"), i || (e.textContent = e.textContent + "");
      }

      function r() {
        var i, e;
        (this || _global).items.length && (i = document.createDocumentFragment(), (this || _global).config.pagination ? (e = (this || _global).pages.slice(0, (this || _global).pageIndex), h.each(e, function (e, t) {
          h.each(t, function (e, t) {
            a(t, i, (this || _global).customOption);
          }, this || _global);
        }, this || _global)) : h.each((this || _global).items, function (e, t) {
          a(t, i, (this || _global).customOption);
        }, this || _global), i.childElementCount && (h.removeClass((this || _global).items[(this || _global).navIndex], "active"), (this || _global).navIndex = i.querySelector(".selectr-option").idx, h.addClass((this || _global).items[(this || _global).navIndex], "active")), (this || _global).tree.appendChild(i));
      }

      function c(e, t) {
        return t = t || e, t = (this || _global).customOption ? (this || _global).config.renderOption(t) : e.textContent, (t = h.createElement("li", {
          class: "selectr-option",
          html: t,
          role: "treeitem",
          "aria-selected": !1
        })).idx = e.idx, (this || _global).items.push(t), e.defaultSelected && (this || _global).defaultSelected.push(e.idx), e.disabled && (t.disabled = !0, h.addClass(t, "disabled")), t;
      }

      function o() {
        var i,
            e = (this || _global).tree,
            t = e.scrollTop;
        e.scrollHeight - e.offsetHeight <= t && (this || _global).pageIndex < (this || _global).pages.length && (i = document.createDocumentFragment(), h.each((this || _global).pages[(this || _global).pageIndex], function (e, t) {
          a(t, i, (this || _global).customOption);
        }, this || _global), e.appendChild(i), (this || _global).pageIndex++, this.emit("selectr.paginate", {
          items: (this || _global).items.length,
          total: (this || _global).data.length,
          page: (this || _global).pageIndex,
          pages: (this || _global).pages.length
        }));
      }

      function t() {
        ((this || _global).config.searchable || (this || _global).config.taggable) && ((this || _global).input.value = null, (this || _global).searching = !1, (this || _global).config.searchable && h.removeClass((this || _global).inputContainer, "active"), h.hasClass((this || _global).container, "notice") && (h.removeClass((this || _global).container, "notice"), h.addClass((this || _global).container, "open"), (this || _global).input.focus()), h.each((this || _global).items, function (e, t) {
          h.removeClass(t, "excluded"), (this || _global).customOption || (t.textContent = t.textContent + "");
        }, this || _global));
      }

      function s(e, t) {
        if (t = t || {}, !e) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
        if ("string" == typeof ((this || _global).el = e) && ((this || _global).el = document.querySelector(e)), null === (this || _global).el) throw new Error("The element you passed to Selectr can not be found.");
        if ("select" !== (this || _global).el.nodeName.toLowerCase()) throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
        this.render(t);
      }

      s.prototype.render = function (e) {
        var t;
        (this || _global).rendered || ((this || _global).config = h.extend(i, e), (this || _global).originalType = (this || _global).el.type, (this || _global).originalIndex = (this || _global).el.tabIndex, (this || _global).defaultSelected = [], (this || _global).originalOptionCount = (this || _global).el.options.length, ((this || _global).config.multiple || (this || _global).config.taggable) && ((this || _global).el.multiple = !0), (this || _global).disabled = l((this || _global).config, "disabled"), (this || _global).opened = !1, (this || _global).config.taggable && ((this || _global).config.searchable = !1), (this || _global).navigating = !1, (this || _global).mobileDevice = !1, /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent) && ((this || _global).mobileDevice = !0), (this || _global).customOption = (this || _global).config.hasOwnProperty("renderOption") && "function" == typeof (this || _global).config.renderOption, (this || _global).customSelected = (this || _global).config.hasOwnProperty("renderSelection") && "function" == typeof (this || _global).config.renderSelection, n.mixin(this || _global), function () {
          (this || _global).requiresPagination = (this || _global).config.pagination && 0 < (this || _global).config.pagination, l((this || _global).config, "width") && (h.isInt((this || _global).config.width) ? (this || _global).width = (this || _global).config.width + "px" : "auto" === (this || _global).config.width ? (this || _global).width = "100%" : h.includes((this || _global).config.width, "%") && ((this || _global).width = (this || _global).config.width)), (this || _global).container = h.createElement("div", {
            class: "selectr-container"
          }), (this || _global).config.customClass && h.addClass((this || _global).container, (this || _global).config.customClass), (this || _global).mobileDevice ? h.addClass((this || _global).container, "selectr-mobile") : h.addClass((this || _global).container, "selectr-desktop"), (this || _global).el.tabIndex = -1, (this || _global).config.nativeDropdown || (this || _global).mobileDevice ? h.addClass((this || _global).el, "selectr-visible") : h.addClass((this || _global).el, "selectr-hidden"), (this || _global).selected = h.createElement("div", {
            class: "selectr-selected",
            disabled: (this || _global).disabled,
            tabIndex: 1,
            "aria-expanded": !1
          }), (this || _global).label = h.createElement((this || _global).el.multiple ? "ul" : "span", {
            class: "selectr-label"
          });
          var e,
              i,
              n,
              t,
              r = h.createElement("div", {
            class: "selectr-options-container"
          }),
              o = ((this || _global).tree = h.createElement("ul", {
            class: "selectr-options",
            role: "tree",
            "aria-hidden": !0,
            "aria-expanded": !1
          }), (this || _global).notice = h.createElement("div", {
            class: "selectr-notice"
          }), (this || _global).el.setAttribute("aria-hidden", !0), (this || _global).disabled && ((this || _global).el.disabled = !0), (this || _global).el.multiple && (h.addClass((this || _global).label, "selectr-tags"), h.addClass((this || _global).container, "multiple"), (this || _global).tags = [], (this || _global).selectedValues = this.getSelectedProperties("value"), (this || _global).selectedIndexes = this.getSelectedProperties("idx")), (this || _global).selected.appendChild((this || _global).label), (this || _global).config.clearable && ((this || _global).selectClear = h.createElement("button", {
            class: "selectr-clear",
            type: "button"
          }), (this || _global).container.appendChild((this || _global).selectClear), h.addClass((this || _global).container, "clearable")), (this || _global).config.taggable && (e = h.createElement("li", {
            class: "input-tag"
          }), (this || _global).input = h.createElement("input", {
            class: "selectr-tag-input",
            placeholder: (this || _global).config.tagPlaceholder,
            tagIndex: 0,
            autocomplete: "off",
            autocorrect: "off",
            autocapitalize: "off",
            spellcheck: "false",
            role: "textbox",
            type: "search"
          }), e.appendChild((this || _global).input), (this || _global).label.appendChild(e), h.addClass((this || _global).container, "taggable"), (this || _global).tagSeperators = [","], (this || _global).config.tagSeperators && ((this || _global).tagSeperators = (this || _global).tagSeperators.concat((this || _global).config.tagSeperators))), (this || _global).config.searchable && ((this || _global).input = h.createElement("input", {
            class: "selectr-input",
            tagIndex: -1,
            autocomplete: "off",
            autocorrect: "off",
            autocapitalize: "off",
            spellcheck: "false",
            role: "textbox",
            type: "search"
          }), (this || _global).inputClear = h.createElement("button", {
            class: "selectr-input-clear",
            type: "button"
          }), (this || _global).inputContainer = h.createElement("div", {
            class: "selectr-input-container"
          }), (this || _global).inputContainer.appendChild((this || _global).input), (this || _global).inputContainer.appendChild((this || _global).inputClear), r.appendChild((this || _global).inputContainer)), r.appendChild((this || _global).notice), r.appendChild((this || _global).tree), (this || _global).items = [], (this || _global).options = [], (this || _global).el.options.length && ((this || _global).options = [].slice.call((this || _global).el.options)), !1),
              s = 0;
          (this || _global).el.children.length && h.each((this || _global).el.children, function (e, t) {
            "OPTGROUP" === t.nodeName ? (o = h.createElement("ul", {
              class: "selectr-optgroup",
              role: "group",
              html: "<li class='selectr-optgroup--label'>" + t.label + "</li>"
            }), h.each(t.children, function (e, t) {
              t.idx = s, o.appendChild(c.call(this || _global, t, o)), s++;
            }, this || _global)) : (t.idx = s, c.call(this || _global, t), s++);
          }, this || _global), (this || _global).config.data && Array.isArray((this || _global).config.data) && (i = !((this || _global).data = []), o = !1, s = 0, h.each((this || _global).config.data, function (e, t) {
            l(t, "children") ? (i = h.createElement("optgroup", {
              label: t.text
            }), o = h.createElement("ul", {
              class: "selectr-optgroup",
              role: "group",
              html: "<li class='selectr-optgroup--label'>" + t.text + "</li>"
            }), h.each(t.children, function (e, t) {
              (n = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = l(t, "disabled"), (this || _global).options.push(n), i.appendChild(n), n.idx = s, o.appendChild(c.call(this || _global, n, t)), (this || _global).data[s] = t, s++;
            }, this || _global)) : ((n = new Option(t.text, t.value, !1, t.hasOwnProperty("selected") && !0 === t.selected)).disabled = l(t, "disabled"), (this || _global).options.push(n), n.idx = s, c.call(this || _global, n, t), (this || _global).data[s] = t, s++);
          }, this || _global)), this.setSelected(!0);

          for (var a = (this || _global).navIndex = 0; a < (this || _global).items.length; a++) if (t = (this || _global).items[a], !h.hasClass(t, "disabled")) {
            h.addClass(t, "active"), (this || _global).navIndex = a;
            break;
          }

          (this || _global).requiresPagination && ((this || _global).pageIndex = 1, this.paginate()), (this || _global).container.appendChild((this || _global).selected), (this || _global).container.appendChild(r), (this || _global).placeEl = h.createElement("div", {
            class: "selectr-placeholder"
          }), this.setPlaceholder(), (this || _global).selected.appendChild((this || _global).placeEl), (this || _global).disabled && this.disable(), (this || _global).el.parentNode.insertBefore((this || _global).container, (this || _global).el), (this || _global).container.appendChild((this || _global).el);
        }.call(this || _global), this.bindEvents(), this.update(), (this || _global).optsRect = h.rect((this || _global).tree), (this || _global).rendered = !0, (this || _global).el.multiple || ((this || _global).el.selectedIndex = (this || _global).selectedIndex), t = this || _global, setTimeout(function () {
          t.emit("selectr.init");
        }, 20));
      }, s.prototype.getSelected = function () {
        return (this || _global).el.querySelectorAll("option:checked");
      }, s.prototype.getSelectedProperties = function (t) {
        var e = this.getSelected();
        return [].slice.call(e).map(function (e) {
          return e[t];
        }).filter(function (e) {
          return null != e;
        });
      }, s.prototype.bindEvents = function () {
        var n = this || _global;
        (this || _global).events = {}, (this || _global).events.dismiss = function (e) {
          e = e.target;
          (this || _global).container.contains(e) || !(this || _global).opened && !h.hasClass((this || _global).container, "notice") || this.close();
        }.bind(this || _global), (this || _global).events.navigate = function (e) {
          if (e = e || window.event, (this || _global).items.length && (this || _global).opened && h.includes([13, 38, 40], e.which)) {
            if (e.preventDefault(), 13 === e.which) return !((this || _global).config.taggable && 0 < (this || _global).input.value.length) && this.change((this || _global).navIndex);
            var t,
                i = (this || _global).items[(this || _global).navIndex];

            switch (e.which) {
              case 38:
                (t = 0) < (this || _global).navIndex && (this || _global).navIndex--;
                break;

              case 40:
                (this || _global).navIndex < (this || _global).items.length - (t = 1) && (this || _global).navIndex++;
            }

            for ((this || _global).navigating = !0; h.hasClass((this || _global).items[(this || _global).navIndex], "disabled") || h.hasClass((this || _global).items[(this || _global).navIndex], "excluded");) if (t ? (this || _global).navIndex++ : (this || _global).navIndex--, (this || _global).searching) {
              if ((this || _global).navIndex > (this || _global).tree.lastElementChild.idx) {
                (this || _global).navIndex = (this || _global).tree.lastElementChild.idx;
                break;
              }

              if ((this || _global).navIndex < (this || _global).tree.firstElementChild.idx) {
                (this || _global).navIndex = (this || _global).tree.firstElementChild.idx;
                break;
              }
            }

            e = h.rect((this || _global).items[(this || _global).navIndex]);
            t ? (0 === (this || _global).navIndex ? (this || _global).tree.scrollTop = 0 : e.top + e.height > (this || _global).optsRect.top + (this || _global).optsRect.height && ((this || _global).tree.scrollTop = (this || _global).tree.scrollTop + (e.top + e.height - ((this || _global).optsRect.top + (this || _global).optsRect.height))), (this || _global).navIndex === (this || _global).tree.childElementCount - 1 && (this || _global).requiresPagination && o.call(this || _global)) : 0 === (this || _global).navIndex ? (this || _global).tree.scrollTop = 0 : e.top - (this || _global).optsRect.top < 0 && ((this || _global).tree.scrollTop = (this || _global).tree.scrollTop + (e.top - (this || _global).optsRect.top)), i && h.removeClass(i, "active"), h.addClass((this || _global).items[(this || _global).navIndex], "active");
          } else (this || _global).navigating = !1;
        }.bind(this || _global), (this || _global).events.reset = (this || _global).reset.bind(this || _global), ((this || _global).config.nativeDropdown || (this || _global).mobileDevice) && ((this || _global).container.addEventListener("touchstart", function (e) {
          e.changedTouches[0].target === n.el && n.toggle();
        }), ((this || _global).config.nativeDropdown || (this || _global).mobileDevice) && (this || _global).container.addEventListener("click", function (e) {
          e.preventDefault(), e.stopPropagation(), e.target === n.el && n.toggle();
        }), (this || _global).el.addEventListener("change", function (e) {
          var t;
          n.el.multiple ? (t = n.getSelectedProperties("idx"), t = function (e, t) {
            for (var i, n = [], r = e.slice(0), o = 0; o < t.length; o++) -1 < (i = r.indexOf(t[o])) ? r.splice(i, 1) : n.push(t[o]);

            return [n, r];
          }(n.selectedIndexes, t), h.each(t[0], function (e, t) {
            n.select(t);
          }, n), h.each(t[1], function (e, t) {
            n.deselect(t);
          }, n)) : -1 < n.el.selectedIndex && n.select(n.el.selectedIndex);
        })), (this || _global).config.nativeDropdown && (this || _global).container.addEventListener("keydown", function (e) {
          "Enter" === e.key && n.selected === document.activeElement && (n.toggle(), setTimeout(function () {
            n.el.focus();
          }, 200));
        }), (this || _global).selected.addEventListener("click", function (e) {
          n.disabled || n.toggle(), e.preventDefault(), e.stopPropagation();
        }), (this || _global).label.addEventListener("click", function (e) {
          h.hasClass(e.target, "selectr-tag-remove") && n.deselect(e.target.parentNode.idx);
        }), (this || _global).selectClear && (this || _global).selectClear.addEventListener("click", (this || _global).clear.bind(this || _global)), (this || _global).tree.addEventListener("mousedown", function (e) {
          e.preventDefault();
        }), (this || _global).tree.addEventListener("click", function (e) {
          e.preventDefault(), e.stopPropagation();
          e = h.closest(e.target, function (e) {
            return e && h.hasClass(e, "selectr-option");
          });
          e && !h.hasClass(e, "disabled") && (h.hasClass(e, "selected") ? (n.el.multiple || !n.el.multiple && n.config.allowDeselect) && n.deselect(e.idx) : n.select(e.idx), n.opened && !n.el.multiple && n.close());
        }), (this || _global).tree.addEventListener("mouseover", function (e) {
          !h.hasClass(e.target, "selectr-option") || h.hasClass(e.target, "disabled") || (h.removeClass(n.items[n.navIndex], "active"), h.addClass(e.target, "active"), n.navIndex = [].slice.call(n.items).indexOf(e.target));
        }), (this || _global).config.searchable && ((this || _global).input.addEventListener("focus", function (e) {
          n.searching = !0;
        }), (this || _global).input.addEventListener("blur", function (e) {
          n.searching = !1;
        }), (this || _global).input.addEventListener("keyup", function (e) {
          n.search(), n.config.taggable || ((this || _global).value.length ? h.addClass((this || _global).parentNode, "active") : h.removeClass((this || _global).parentNode, "active"));
        }), (this || _global).inputClear.addEventListener("click", function (e) {
          n.input.value = null, t.call(n), n.tree.childElementCount || r.call(n);
        })), (this || _global).config.taggable && (this || _global).input.addEventListener("keyup", function (e) {
          var i;
          n.search(), n.config.taggable && (this || _global).value.length && (i = (this || _global).value.trim(), 13 !== e.which && !h.includes(n.tagSeperators, e.key) || (h.each(n.tagSeperators, function (e, t) {
            i = i.replace(t, "");
          }), n.add({
            value: i,
            text: i,
            selected: !0
          }, !0) ? (n.close(), t.call(n)) : ((this || _global).value = "", n.setMessage("That tag is already in use."))));
        }), (this || _global).update = h.debounce(function () {
          n.opened && n.config.closeOnScroll && n.close(), n.width && (n.container.style.width = n.width), n.invert();
        }, 50), (this || _global).requiresPagination && ((this || _global).paginateItems = h.debounce(function () {
          o.call(this || _global);
        }, 50), (this || _global).tree.addEventListener("scroll", (this || _global).paginateItems.bind(this || _global))), document.addEventListener("click", (this || _global).events.dismiss), window.addEventListener("keydown", (this || _global).events.navigate), window.addEventListener("resize", (this || _global).update), window.addEventListener("scroll", (this || _global).update), (this || _global).el.form && (this || _global).el.form.addEventListener("reset", (this || _global).events.reset);
      }, s.prototype.setSelected = function (e) {
        var i;
        (this || _global).config.data || (this || _global).el.multiple || !(this || _global).el.options.length || (0 !== (this || _global).el.selectedIndex || (this || _global).el.options[0].defaultSelected || (this || _global).config.defaultSelected || ((this || _global).el.selectedIndex = -1), (this || _global).selectedIndex = (this || _global).el.selectedIndex, -1 < (this || _global).selectedIndex && this.select((this || _global).selectedIndex)), (this || _global).config.multiple && "select-one" === (this || _global).originalType && !(this || _global).config.data && (this || _global).el.options[0].selected && !(this || _global).el.options[0].defaultSelected && ((this || _global).el.options[0].selected = !1), h.each((this || _global).options, function (e, t) {
          t.selected && t.defaultSelected && this.select(t.idx);
        }, this || _global), (this || _global).config.selectedValue && this.setValue((this || _global).config.selectedValue), (this || _global).config.data && (!(this || _global).el.multiple && (this || _global).config.defaultSelected && (this || _global).el.selectedIndex < 0 && this.select(0), i = 0, h.each((this || _global).config.data, function (e, t) {
          l(t, "children") ? h.each(t.children, function (e, t) {
            t.hasOwnProperty("selected") && !0 === t.selected && this.select(i), i++;
          }, this || _global) : (t.hasOwnProperty("selected") && !0 === t.selected && this.select(i), i++);
        }, this || _global));
      }, s.prototype.destroy = function () {
        (this || _global).rendered && (this.emit("selectr.destroy"), "select-one" === (this || _global).originalType && ((this || _global).el.multiple = !1), (this || _global).config.data && ((this || _global).el.textContent = ""), h.removeClass((this || _global).el, "selectr-hidden"), (this || _global).el.form && h.off((this || _global).el.form, "reset", (this || _global).events.reset), h.off(document, "click", (this || _global).events.dismiss), h.off(document, "keydown", (this || _global).events.navigate), h.off(window, "resize", (this || _global).update), h.off(window, "scroll", (this || _global).update), (this || _global).container.parentNode.replaceChild((this || _global).el, (this || _global).container), (this || _global).rendered = !1);
      }, s.prototype.change = function (e) {
        var t = (this || _global).items[e],
            i = (this || _global).options[e];
        i.disabled || (i.selected && h.hasClass(t, "selected") ? this.deselect(e) : this.select(e), (this || _global).opened && !(this || _global).el.multiple && this.close());
      }, s.prototype.select = function (n) {
        var e = (this || _global).items[n],
            t = [].slice.call((this || _global).el.options),
            i = (this || _global).options[n];

        if ((this || _global).el.multiple) {
          if (h.includes((this || _global).selectedIndexes, n)) return !1;
          if ((this || _global).config.maxSelections && (this || _global).tags.length === (this || _global).config.maxSelections) return this.setMessage("A maximum of " + (this || _global).config.maxSelections + " items can be selected.", !0), !1;
          (this || _global).selectedValues.push(i.value), (this || _global).selectedIndexes.push(n), !function (e) {
            var l,
                c = this || _global,
                i = document.createDocumentFragment(),
                t = (this || _global).options[e.idx],
                n = (this || _global).data ? (this || _global).data[e.idx] : t,
                n = (this || _global).customSelected ? (this || _global).config.renderSelection(n) : t.textContent,
                n = h.createElement("li", {
              class: "selectr-tag",
              html: n
            }),
                r = h.createElement("button", {
              class: "selectr-tag-remove",
              type: "button"
            });
            n.appendChild(r), n.idx = e.idx, n.tag = t.value, (this || _global).tags.push(n), (this || _global).config.sortSelected ? (r = (this || _global).tags.slice(), l = function (e, n) {
              e.replace(/(\d+)|(\D+)/g, function (e, t, i) {
                n.push([t || 1 / 0, i || ""]);
              });
            }, r.sort(function (e, t) {
              var i,
                  n,
                  r = [],
                  o = [];

              for (!0 === c.config.sortSelected ? (i = e.tag, n = t.tag) : "text" === c.config.sortSelected && (i = e.textContent, n = t.textContent), l(i, r), l(n, o); r.length && o.length;) {
                var s = r.shift(),
                    a = o.shift(),
                    s = s[0] - a[0] || s[1].localeCompare(a[1]);
                if (s) return s;
              }

              return r.length - o.length;
            }), h.each(r, function (e, t) {
              i.appendChild(t);
            }), (this || _global).label.textContent = "") : i.appendChild(n), (this || _global).config.taggable ? (this || _global).label.insertBefore(i, (this || _global).input.parentNode) : (this || _global).label.appendChild(i);
          }.call(this || _global, e);
        } else {
          var r = (this || _global).data ? (this || _global).data[n] : i;
          (this || _global).label.textContent = (this || _global).customSelected ? (this || _global).config.renderSelection(r) : i.textContent, (this || _global).selectedValue = i.value, (this || _global).selectedIndex = n, h.each((this || _global).options, function (e, t) {
            var i = (this || _global).items[e];
            e !== n && (i && h.removeClass(i, "selected"), t.selected = !1, t.removeAttribute("selected"));
          }, this || _global);
        }

        h.includes(t, i) || (this || _global).el.add(i), e.setAttribute("aria-selected", !0), h.addClass(e, "selected"), h.addClass((this || _global).container, "has-selected"), i.selected = !0, i.setAttribute("selected", ""), this.emit("selectr.change", i), this.emit("selectr.select", i);
      }, s.prototype.deselect = function (e, t) {
        var i = (this || _global).items[e],
            n = (this || _global).options[e];

        if ((this || _global).el.multiple) {
          var r = (this || _global).selectedIndexes.indexOf(e),
              r = ((this || _global).selectedIndexes.splice(r, 1), (this || _global).selectedValues.indexOf(n.value));

          (this || _global).selectedValues.splice(r, 1), !function (i) {
            var n = !1;
            h.each((this || _global).tags, function (e, t) {
              t.idx === i.idx && (n = t);
            }, this || _global), n && ((this || _global).label.removeChild(n), (this || _global).tags.splice((this || _global).tags.indexOf(n), 1));
          }.call(this || _global, i), (this || _global).tags.length || h.removeClass((this || _global).container, "has-selected");
        } else {
          if (!t && !(this || _global).config.clearable && !(this || _global).config.allowDeselect) return !1;
          (this || _global).label.textContent = "", (this || _global).selectedValue = null, (this || _global).el.selectedIndex = (this || _global).selectedIndex = -1, h.removeClass((this || _global).container, "has-selected");
        }

        (this || _global).items[e].setAttribute("aria-selected", !1), h.removeClass((this || _global).items[e], "selected"), n.selected = !1, n.removeAttribute("selected"), this.emit("selectr.change", null), this.emit("selectr.deselect", n);
      }, s.prototype.setValue = function (i) {
        var n = Array.isArray(i);
        if (n || (i = i.toString().trim()), !(this || _global).el.multiple && n) return !1;
        h.each((this || _global).options, function (e, t) {
          (n && h.includes(i.toString(), t.value) || t.value === i) && this.change(t.idx);
        }, this || _global);
      }, s.prototype.getValue = function (e, t) {
        var i, n;
        return (this || _global).el.multiple ? e ? (this || _global).selectedIndexes.length && (n = {
          values: []
        }, h.each((this || _global).selectedIndexes, function (e, t) {
          t = (this || _global).options[t];
          n.values[e] = {
            value: t.value,
            text: t.textContent
          };
        }, this || _global)) : n = (this || _global).selectedValues.slice() : n = e ? {
          value: (i = (this || _global).options[(this || _global).selectedIndex]).value,
          text: i.textContent
        } : (this || _global).selectedValue, n = e && t ? JSON.stringify(n) : n;
      }, s.prototype.add = function (i, n) {
        if (i) {
          if ((this || _global).data = (this || _global).data || [], (this || _global).items = (this || _global).items || [], (this || _global).options = (this || _global).options || [], Array.isArray(i)) h.each(i, function (e, t) {
            this.add(t, n);
          }, this || _global);else if ("[object Object]" === Object.prototype.toString.call(i)) {
            if (n) {
              var r = !1;
              if (h.each((this || _global).options, function (e, t) {
                t.value.toLowerCase() === i.value.toLowerCase() && (r = !0);
              }), r) return !1;
            }

            var e = h.createElement("option", i);
            return (this || _global).data.push(i), (this || _global).options.push(e), e.idx = 0 < (this || _global).options.length ? (this || _global).options.length - 1 : 0, c.call(this || _global, e), i.selected && this.select(e.idx), e;
          }
          return this.setPlaceholder(), (this || _global).config.pagination && this.paginate(), !0;
        }
      }, s.prototype.remove = function (i) {
        var n,
            r = [];
        Array.isArray(i) ? h.each(i, function (e, t) {
          h.isInt(t) ? r.push(this.getOptionByIndex(t)) : "string" == typeof i && r.push(this.getOptionByValue(t));
        }, this || _global) : h.isInt(i) ? r.push(this.getOptionByIndex(i)) : "string" == typeof i && r.push(this.getOptionByValue(i)), r.length && (h.each(r, function (e, t) {
          n = t.idx, (this || _global).el.remove(t), (this || _global).options.splice(n, 1);
          t = (this || _global).items[n].parentNode;
          t && t.removeChild((this || _global).items[n]), (this || _global).items.splice(n, 1), h.each((this || _global).options, function (e, t) {
            t.idx = e, (this || _global).items[e].idx = e;
          }, this || _global);
        }, this || _global), this.setPlaceholder(), (this || _global).config.pagination && this.paginate());
      }, s.prototype.removeAll = function () {
        this.clear(!0), h.each((this || _global).el.options, function (e, t) {
          (this || _global).el.remove(t);
        }, this || _global), h.truncate((this || _global).tree), (this || _global).items = [], (this || _global).options = [], (this || _global).data = [], (this || _global).navIndex = 0, (this || _global).requiresPagination && ((this || _global).requiresPagination = !1, (this || _global).pageIndex = 1, (this || _global).pages = []), this.setPlaceholder();
      }, s.prototype.search = function (o) {
        var s, e, t;
        (this || _global).navigating || (o = o || (this || _global).input.value, s = document.createDocumentFragment(), this.removeMessage(), h.truncate((this || _global).tree), 1 < o.length ? (h.each((this || _global).options, function (e, t) {
          var i,
              n,
              r = (this || _global).items[t.idx];
          h.includes(t.textContent.toLowerCase(), o.toLowerCase()) && !t.disabled ? (a(r, s, (this || _global).customOption), h.removeClass(r, "excluded"), (this || _global).customOption || (r.textContent = "", i = o, t = t.textContent, (n = (i = new RegExp(i, "i").exec(t)) ? (n = i.index, i = i.index + i[0].length, {
            before: t.substring(0, n),
            match: t.substring(n, i),
            after: t.substring(i)
          }) : null) && (r.appendChild(document.createTextNode(n.before)), (t = document.createElement("span")).className = "selectr-match", t.appendChild(document.createTextNode(n.match)), r.appendChild(t), r.appendChild(document.createTextNode(n.after))))) : h.addClass(r, "excluded");
        }, this || _global), s.childElementCount ? (e = (this || _global).items[(this || _global).navIndex], t = s.firstElementChild, h.removeClass(e, "active"), (this || _global).navIndex = t.idx, h.addClass(t, "active")) : (this || _global).config.taggable || this.setMessage("no results.")) : r.call(this || _global), (this || _global).tree.appendChild(s));
      }, s.prototype.toggle = function () {
        (this || _global).disabled || ((this || _global).opened ? this.close() : this.open());
      }, s.prototype.open = function () {
        var e = this || _global;
        return !!(this || _global).options.length && ((this || _global).opened || this.emit("selectr.open"), (this || _global).opened = !0, (this || _global).mobileDevice || (this || _global).config.nativeDropdown ? (h.addClass((this || _global).container, "native-open"), void ((this || _global).config.data && h.each((this || _global).options, function (e, t) {
          (this || _global).el.add(t);
        }, this || _global))) : (h.addClass((this || _global).container, "open"), r.call(this || _global), this.invert(), (this || _global).tree.scrollTop = 0, h.removeClass((this || _global).container, "notice"), (this || _global).selected.setAttribute("aria-expanded", !0), (this || _global).tree.setAttribute("aria-hidden", !1), (this || _global).tree.setAttribute("aria-expanded", !0), void ((this || _global).config.searchable && !(this || _global).config.taggable && setTimeout(function () {
          e.input.focus(), e.input.tabIndex = 0;
        }, 10))));
      }, s.prototype.close = function () {
        var e;
        (this || _global).opened && this.emit("selectr.close"), (this || _global).opened = !1, (this || _global).mobileDevice || (this || _global).config.nativeDropdown ? h.removeClass((this || _global).container, "native-open") : (e = h.hasClass((this || _global).container, "notice"), (this || _global).config.searchable && !e && ((this || _global).input.blur(), (this || _global).input.tabIndex = -1, (this || _global).searching = !1), e && (h.removeClass((this || _global).container, "notice"), (this || _global).notice.textContent = ""), h.removeClass((this || _global).container, "open"), h.removeClass((this || _global).container, "native-open"), (this || _global).selected.setAttribute("aria-expanded", !1), (this || _global).tree.setAttribute("aria-hidden", !0), (this || _global).tree.setAttribute("aria-expanded", !1), h.truncate((this || _global).tree), t.call(this || _global));
      }, s.prototype.enable = function () {
        (this || _global).disabled = !1, (this || _global).el.disabled = !1, (this || _global).selected.tabIndex = (this || _global).originalIndex, (this || _global).el.multiple && h.each((this || _global).tags, function (e, t) {
          t.lastElementChild.tabIndex = 0;
        }), h.removeClass((this || _global).container, "selectr-disabled");
      }, s.prototype.disable = function (e) {
        e || ((this || _global).el.disabled = !0), (this || _global).selected.tabIndex = -1, (this || _global).el.multiple && h.each((this || _global).tags, function (e, t) {
          t.lastElementChild.tabIndex = -1;
        }), (this || _global).disabled = !0, h.addClass((this || _global).container, "selectr-disabled");
      }, s.prototype.reset = function () {
        (this || _global).disabled || (this.clear(), this.setSelected(!0), h.each((this || _global).defaultSelected, function (e, t) {
          this.select(t);
        }, this || _global), this.emit("selectr.reset"));
      }, s.prototype.clear = function (e) {
        var t;
        (this || _global).el.multiple ? (this || _global).selectedIndexes.length && (t = (this || _global).selectedIndexes.slice(), h.each(t, function (e, t) {
          this.deselect(t);
        }, this || _global)) : -1 < (this || _global).selectedIndex && this.deselect((this || _global).selectedIndex, e), this.emit("selectr.clear");
      }, s.prototype.serialise = function (e) {
        var n = [];
        return h.each((this || _global).options, function (e, t) {
          var i = {
            value: t.value,
            text: t.textContent
          };
          t.selected && (i.selected = !0), t.disabled && (i.disabled = !0), n[e] = i;
        }), e ? JSON.stringify(n) : n;
      }, s.prototype.serialize = function (e) {
        return this.serialise(e);
      }, s.prototype.setPlaceholder = function (e) {
        e = e || (this || _global).config.placeholder || (this || _global).el.getAttribute("placeholder"), (this || _global).options.length || (e = "No options available"), (this || _global).placeEl.textContent = e;
      }, s.prototype.paginate = function () {
        var i;
        if ((this || _global).items.length) return (i = this || _global).pages = (this || _global).items.map(function (e, t) {
          return t % i.config.pagination == 0 ? i.items.slice(t, t + i.config.pagination) : null;
        }).filter(function (e) {
          return e;
        }), (this || _global).pages;
      }, s.prototype.setMessage = function (e, t) {
        t && this.close(), h.addClass((this || _global).container, "notice"), (this || _global).notice.textContent = e;
      }, s.prototype.removeMessage = function () {
        h.removeClass((this || _global).container, "notice"), (this || _global).notice.textContent = "";
      }, s.prototype.invert = function () {
        var e = h.rect((this || _global).selected),
            t = (this || _global).tree.parentNode.offsetHeight,
            i = window.innerHeight;
        e.top + e.height + t > i ? (h.addClass((this || _global).container, "inverted"), (this || _global).isInverted = !0) : (h.removeClass((this || _global).container, "inverted"), (this || _global).isInverted = !1), (this || _global).optsRect = h.rect((this || _global).tree);
      }, s.prototype.getOptionByIndex = function (e) {
        return (this || _global).options[e];
      }, s.prototype.getOptionByValue = function (e) {
        for (var t = !1, i = 0, n = (this || _global).options.length; i < n; i++) if ((this || _global).options[i].value.trim() === e.toString().trim()) {
          t = (this || _global).options[i];
          break;
        }

        return t;
      }, e.exports = s;
    },
    4188: function (e, t, i) {
      "use strict";

      i.d(t, {
        EX: function () {
          return r;
        },
        WF: function () {
          return o;
        },
        oW: function () {
          return s;
        },
        qD: function () {
          return n;
        }
      });
      var n = document.body,
          r = 10485760,
          o = 20000,
          s = 2147483648;
    },
    2602: function (e, t, i) {
      "use strict";

      i.d(t, {
        w: function () {
          return n;
        }
      });
      var u = i(9791);

      function n(i, e, n) {
        var t,
            r = 3 < arguments.length && void 0 !== arguments[3] && arguments[3],
            o = "function" == typeof (a = i).getRootNode ? a.getRootNode() : window,
            s = {},
            a = i.getBoundingClientRect(),
            l = e.getBoundingClientRect(),
            c = document.createElement("div");

        function h() {
          if (c && c.parentNode) {
            for (var e in c.parentNode.removeChild(c), s) t = e, Object.prototype.hasOwnProperty.call(s, t) && ((t = s[e]) && (0, u.removeEventListener)(o, e, t), delete s[e]);

            "function" == typeof n && n(i);
          }

          var t;
        }

        function d(e) {
          (e = e.target) === c || (0, u.isChildOf)(e, c) || h();
        }

        return c.className = "jsoneditor-anchor", c.style.position = "absolute", c.style.left = a.left - l.left + "px", c.style.top = a.top - l.top + "px", c.style.width = a.width - 2 + "px", c.style.height = a.height - 2 + "px", c.style.boxSizing = "border-box", e.appendChild(c), s.mousedown = (0, u.addEventListener)(o, "mousedown", d), s.mousewheel = (0, u.addEventListener)(o, "mousewheel", d), r && (t = null, c.onmouseover = function () {
          clearTimeout(t), t = null;
        }, c.onmouseout = function () {
          t = t || setTimeout(h, 200);
        }), c.destroy = h, c;
      }
    },
    7923: function (e) {
      e.exports = "data:application/javascript;base64,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";
    },
    7907: function (e, t, i) {
      "use strict";

      i.d(t, {
        Iu: function () {
          return h;
        },
        cC: function () {
          return c;
        },
        m0: function () {
          return l;
        }
      });
      i(4987);
      var o = {
        en: {
          array: "Array",
          auto: "Auto",
          appendText: "Append",
          appendTitle: "Append a new field with type 'auto' after this field (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "Select the type of the field to be appended",
          appendTitleAuto: "Append a new field with type 'auto' (Ctrl+Shift+Ins)",
          ascending: "Ascending",
          ascendingTitle: "Sort the childs of this ${type} in ascending order",
          actionsMenu: "Click to open the actions menu (Ctrl+M)",
          cannotParseFieldError: "Cannot parse field into JSON",
          cannotParseValueError: "Cannot parse value into JSON",
          collapseAll: "Collapse all fields",
          compactTitle: "Compact JSON data, remove all whitespaces (Ctrl+Shift+I)",
          descending: "Descending",
          descendingTitle: "Sort the childs of this ${type} in descending order",
          drag: "Drag to move this field (Alt+Shift+Arrows)",
          duplicateKey: "duplicate key",
          duplicateText: "Duplicate",
          duplicateTitle: "Duplicate selected fields (Ctrl+D)",
          duplicateField: "Duplicate this field (Ctrl+D)",
          duplicateFieldError: "Duplicate field name",
          empty: "empty",
          expandAll: "Expand all fields",
          expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
          formatTitle: "Format JSON data, with proper indentation and line feeds (Ctrl+I)",
          insert: "Insert",
          insertTitle: "Insert a new field with type 'auto' before this field (Ctrl+Ins)",
          insertSub: "Select the type of the field to be inserted",
          object: "Object",
          ok: "Ok",
          redo: "Redo (Ctrl+Shift+Z)",
          removeText: "Remove",
          removeTitle: "Remove selected fields (Ctrl+Del)",
          removeField: "Remove this field (Ctrl+Del)",
          repairTitle: "Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.",
          searchTitle: "Search fields and values",
          searchNextResultTitle: "Next result (Enter)",
          searchPreviousResultTitle: "Previous result (Shift + Enter)",
          selectNode: "Select a node...",
          showAll: "show all",
          showMore: "show more",
          showMoreStatus: "displaying ${visibleChilds} of ${totalChilds} items.",
          sort: "Sort",
          sortTitle: "Sort the childs of this ${type}",
          sortTitleShort: "Sort contents",
          sortFieldLabel: "Field:",
          sortDirectionLabel: "Direction:",
          sortFieldTitle: "Select the nested field by which to sort the array or object",
          sortAscending: "Ascending",
          sortAscendingTitle: "Sort the selected field in ascending order",
          sortDescending: "Descending",
          sortDescendingTitle: "Sort the selected field in descending order",
          string: "String",
          transform: "Transform",
          transformTitle: "Filter, sort, or transform the childs of this ${type}",
          transformTitleShort: "Filter, sort, or transform contents",
          extract: "Extract",
          extractTitle: "Extract this ${type}",
          transformQueryTitle: "Enter a JMESPath query",
          transformWizardLabel: "Wizard",
          transformWizardFilter: "Filter",
          transformWizardSortBy: "Sort by",
          transformWizardSelectFields: "Select fields",
          transformQueryLabel: "Query",
          transformPreviewLabel: "Preview",
          type: "Type",
          typeTitle: "Change the type of this field",
          openUrl: "Ctrl+Click or Ctrl+Enter to open url in new window",
          undo: "Undo last action (Ctrl+Z)",
          validationCannotMove: "Cannot move a field into a child of itself",
          autoType: "Field type \"auto\". The field type is automatically determined from the value and can be a string, number, boolean, or null.",
          objectType: "Field type \"object\". An object contains an unordered set of key/value pairs.",
          arrayType: "Field type \"array\". An array contains an ordered collection of values.",
          stringType: "Field type \"string\". Field type is not determined from the value, but always returned as string.",
          modeEditorTitle: "Switch Editor Mode",
          modeCodeText: "Code",
          modeCodeTitle: "Switch to code highlighter",
          modeFormText: "Form",
          modeFormTitle: "Switch to form editor",
          modeTextText: "Text",
          modeTextTitle: "Switch to plain text editor",
          modeTreeText: "Tree",
          modeTreeTitle: "Switch to tree editor",
          modeViewText: "View",
          modeViewTitle: "Switch to tree view",
          modePreviewText: "Preview",
          modePreviewTitle: "Switch to preview mode",
          examples: "Examples",
          default: "Default",
          containsInvalidProperties: "Contains invalid properties",
          containsInvalidItems: "Contains invalid items"
        },
        es: {
          array: "Matriz",
          auto: "Auto",
          appendText: "Agregar",
          appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xE9s de este campo (Ctrl + Shift + Ins)",
          appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xE1",
          appendTitleAuto: "Agregue un nuevo campo con el tipo 'auto' (Ctrl + Shift + Ins)",
          ascending: "Ascendente",
          ascendingTitle: "Ordene los elementos secundarios de este ${type} en orden ascendente",
          actionsMenu: "Haga clic para abrir el men\xFA de acciones (Ctrl + M)",
          cannotParseFieldError: "No se puede parsear el campo en JSON",
          cannotParseValueError: "No se puede parsear el valor en JSON",
          collapseAll: "Contraer todos los campos",
          compactTitle: "Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)",
          descending: "Descendente",
          descendingTitle: "Ordene los hijos de este ${type} en orden descendente",
          drag: "Arrastre para mover este campo (Alt + May\xFAs + Flechas)",
          duplicateKey: "llave duplicada",
          duplicateText: "Duplicar",
          duplicateTitle: "Duplicar campos seleccionados (Ctrl + D)",
          duplicateField: "Duplicar este campo (Ctrl + D)",
          duplicateFieldError: "Nombre de campo duplicado",
          empty: "vacio",
          expandAll: "Expandir todos los campos",
          expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xF1os.",
          formatTitle: "Formatee los datos JSON, con la sangr\xEDa y los avances de l\xEDnea adecuados (Ctrl + I)",
          insert: "Insertar",
          insertTitle: "Inserte un nuevo campo con el tipo 'auto' antes de este campo (Ctrl + Ins)",
          insertSub: "Seleccione el tipo de campo a insertar",
          object: "Objeto",
          ok: "Ok",
          redo: "Rehacer (Ctrl+May\xFAs+Z)",
          removeText: "Eliminar",
          removeTitle: "Eliminar campos seleccionados (Ctrl+Supr)",
          removeField: "Eliminar este campo (Ctrl+Supr)",
          repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xF3n JSONP, convierta objetos JavaScript en JSON.",
          searchTitle: "Campos de b\xFAsqueda y valores",
          searchNextResultTitle: "Siguiente resultado (Entrar)",
          searchPreviousResultTitle: "Resultado anterior (Shift + Enter)",
          selectNode: "Seleccione un nodo...",
          showAll: "mostrar todo",
          showMore: "mostrar m\xE1s",
          showMoreStatus: "mostrando ${visibleChilds} de ${totalChilds} elementos.",
          sort: "Ordenar",
          sortTitle: "Ordene los hijos de este ${type}",
          sortTitleShort: "Ordenar contenidos",
          sortFieldLabel: "Campo:",
          sortDirectionLabel: "Direcci\xF3n:",
          sortFieldTitle: "Seleccione el campo anidado por el cual ordenar la matriz u objeto",
          sortAscending: "Ascendente",
          sortAscendingTitle: "Ordenar el campo seleccionado en orden ascendente",
          sortDescending: "Descendente",
          sortDescendingTitle: "Ordenar por el campo seleccionado, en orden descendente",
          string: "Texto",
          transform: "Transformar",
          transformTitle: "Filtrar, ordenar o transformar los hijos de este ${type}",
          transformTitleShort: "Filtrar, ordenar o transformar contenidos",
          extract: "Extraer",
          extractTitle: "Extrae este ${type}",
          transformQueryTitle: "Ingrese una consulta JMESPath",
          transformWizardLabel: "Wizard",
          transformWizardFilter: "Filtro",
          transformWizardSortBy: "Ordenar por",
          transformWizardSelectFields: "Seleccione un campo",
          transformQueryLabel: "Consulta",
          transformPreviewLabel: "Vista Previa",
          type: "Tipo",
          typeTitle: "Cambiar el tipo de campo",
          openUrl: "Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana",
          undo: "Deshacer la \xFAltima acci\xF3n (Ctrl+Z)",
          validationCannotMove: "No se puede mover un campo a un hijo de s\xED mismo.",
          autoType: "Field type \"auto\". The field type is automatically determined from the value and can be a string, number, boolean, or null.",
          objectType: "Tipo de campo \"objeto\".  Un objeto contiene un conjunto desordenado de pares clave/valor.",
          arrayType: "Tipo de campo \"matriz\".  Una matriz contiene una colecci\xF3n ordenada de valores.",
          stringType: "Tipo de campo \"cadena\".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.",
          modeEditorTitle: "Cambiar modo de editor",
          modeCodeText: "Codigo",
          modeCodeTitle: "Cambiar al resaltador de c\xF3digo",
          modeFormText: "Formulario",
          modeFormTitle: "Cambiar al editor de formularios",
          modeTextText: "Texto",
          modeTextTitle: "Cambiar al editor de texto sin formato",
          modeTreeText: "Arbol",
          modeTreeTitle: "Cambiar al editor de \xE1rbol",
          modeViewText: "Vista",
          modeViewTitle: "Cambiar a la vista de \xE1rbol",
          modePreviewText: "Vista Previa",
          modePreviewTitle: "Cambiar al modo de vista previa",
          examples: "Ejemplos",
          default: "Predeterminado",
          containsInvalidProperties: "Contiene propiedades no validas",
          containsInvalidItems: "Contiene items no validos"
        },
        "zh-CN": {
          array: "\u6570\u7EC4",
          auto: "\u81EA\u52A8",
          appendText: "\u8FFD\u52A0",
          appendTitle: "\u5728\u6B64\u5B57\u6BB5\u540E\u8FFD\u52A0\u4E00\u4E2A\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "\u9009\u62E9\u8981\u8FFD\u52A0\u7684\u5B57\u6BB5\u7C7B\u578B",
          appendTitleAuto: "\u8FFD\u52A0\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
          ascending: "\u5347\u5E8F",
          ascendingTitle: "\u5347\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
          actionsMenu: "\u70B9\u51FB\u6253\u5F00\u52A8\u4F5C\u83DC\u5355(Ctrl+M)",
          cannotParseFieldError: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u89E3\u6790\u4E3AJSON",
          cannotParseValueError: "\u65E0\u6CD5\u5C06\u503C\u89E3\u6790\u4E3AJSON",
          collapseAll: "\u7F29\u8FDB\u6240\u6709\u5B57\u6BB5",
          compactTitle: "\u538B\u7F29JSON\u6570\u636E\uFF0C\u5220\u9664\u6240\u6709\u7A7A\u683C (Ctrl+Shift+I)",
          descending: "\u964D\u5E8F",
          descendingTitle: "\u964D\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
          drag: "\u62D6\u62FD\u79FB\u52A8\u8BE5\u8282\u70B9(Alt+Shift+Arrows)",
          duplicateKey: "\u91CD\u590D\u952E",
          duplicateText: "\u590D\u5236",
          duplicateTitle: "\u590D\u5236\u9009\u4E2D\u5B57\u6BB5(Ctrl+D)",
          duplicateField: "\u590D\u5236\u8BE5\u5B57\u6BB5(Ctrl+D)",
          duplicateFieldError: "\u91CD\u590D\u7684\u5B57\u6BB5\u540D\u79F0",
          empty: "\u6E05\u7A7A",
          expandAll: "\u5C55\u5F00\u6240\u6709\u5B57\u6BB5",
          expandTitle: "\u70B9\u51FB \u5C55\u5F00/\u6536\u7F29 \u8BE5\u5B57\u6BB5(Ctrl+E). \nCtrl+Click \u5C55\u5F00/\u6536\u7F29 \u5305\u542B\u6240\u6709\u5B50\u8282\u70B9.",
          formatTitle: "\u4F7F\u7528\u9002\u5F53\u7684\u7F29\u8FDB\u548C\u6362\u884C\u7B26\u683C\u5F0F\u5316JSON\u6570\u636E (Ctrl+I)",
          insert: "\u63D2\u5165",
          insertTitle: "\u5728\u6B64\u5B57\u6BB5\u524D\u63D2\u5165\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Ins)",
          insertSub: "\u9009\u62E9\u8981\u63D2\u5165\u7684\u5B57\u6BB5\u7C7B\u578B",
          object: "\u5BF9\u8C61",
          ok: "Ok",
          redo: "\u91CD\u505A (Ctrl+Shift+Z)",
          removeText: "\u79FB\u9664",
          removeTitle: "\u79FB\u9664\u9009\u4E2D\u5B57\u6BB5 (Ctrl+Del)",
          removeField: "\u79FB\u9664\u8BE5\u5B57\u6BB5 (Ctrl+Del)",
          repairTitle: "\u4FEE\u590DJSON\uFF1A\u4FEE\u590D\u5F15\u53F7\u548C\u8F6C\u4E49\u7B26\uFF0C\u5220\u9664\u6CE8\u91CA\u548CJSONP\u8868\u793A\u6CD5\uFF0C\u5C06JavaScript\u5BF9\u8C61\u8F6C\u6362\u4E3AJSON\u3002",
          selectNode: "\u9009\u62E9\u4E00\u4E2A\u8282\u70B9...",
          showAll: "\u5C55\u793A\u5168\u90E8",
          showMore: "\u5C55\u793A\u66F4\u591A",
          showMoreStatus: "\u663E\u793A${totalChilds}\u7684${visibleChilds}\u9879\u76EE.",
          sort: "\u6392\u5E8F",
          sortTitle: "\u6392\u5E8F${type}\u7684\u5B50\u8282\u70B9",
          sortTitleShort: "\u5185\u5BB9\u6392\u5E8F",
          sortFieldLabel: "\u5B57\u6BB5\uFF1A",
          sortDirectionLabel: "\u65B9\u5411\uFF1A",
          sortFieldTitle: "\u9009\u62E9\u7528\u4E8E\u5BF9\u6570\u7EC4\u6216\u5BF9\u8C61\u6392\u5E8F\u7684\u5D4C\u5957\u5B57\u6BB5",
          sortAscending: "\u5347\u5E8F\u6392\u5E8F",
          sortAscendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u5347\u5E8F\u6392\u5E8F",
          sortDescending: "\u964D\u5E8F\u6392\u5E8F",
          sortDescendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u964D\u5E8F\u6392\u5E8F",
          string: "\u5B57\u7B26\u4E32",
          transform: "\u53D8\u6362",
          transformTitle: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362${type}\u7684\u5B50\u8282\u70B9",
          transformTitleShort: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362\u5185\u5BB9",
          extract: "\u63D0\u53D6",
          extractTitle: "\u63D0\u53D6\u8FD9\u4E2A ${type}",
          transformQueryTitle: "\u8F93\u5165JMESPath\u67E5\u8BE2",
          transformWizardLabel: "\u5411\u5BFC",
          transformWizardFilter: "\u7B5B\u9009",
          transformWizardSortBy: "\u6392\u5E8F",
          transformWizardSelectFields: "\u9009\u62E9\u5B57\u6BB5",
          transformQueryLabel: "\u67E5\u8BE2",
          transformPreviewLabel: "\u9884\u89C8",
          type: "\u7C7B\u578B",
          typeTitle: "\u66F4\u6539\u5B57\u6BB5\u7C7B\u578B",
          openUrl: "Ctrl+Click \u6216\u8005 Ctrl+Enter \u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
          undo: "\u64A4\u9500\u4E0A\u6B21\u52A8\u4F5C (Ctrl+Z)",
          validationCannotMove: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u79FB\u5165\u5176\u5B50\u8282\u70B9",
          autoType: "\u5B57\u6BB5\u7C7B\u578B \"auto\". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A \u53EF\u4EE5\u4E3A string\uFF0Cnumber\uFF0Cboolean\uFF0C\u6216\u8005 null.",
          objectType: "\u5B57\u6BB5\u7C7B\u578B \"object\". \u5BF9\u8C61\u5305\u542B\u4E00\u7EC4\u65E0\u5E8F\u7684\u952E/\u503C\u5BF9.",
          arrayType: "\u5B57\u6BB5\u7C7B\u578B \"array\". \u6570\u7EC4\u5305\u542B\u503C\u7684\u6709\u5E8F\u96C6\u5408.",
          stringType: "\u5B57\u6BB5\u7C7B\u578B \"string\". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A\uFF0C\u4F46\u59CB\u7EC8\u4F5C\u4E3A\u5B57\u7B26\u4E32\u8FD4\u56DE.",
          modeCodeText: "\u4EE3\u7801",
          modeCodeTitle: "\u5207\u6362\u81F3\u4EE3\u7801\u9AD8\u4EAE",
          modeFormText: "\u8868\u5355",
          modeFormTitle: "\u5207\u6362\u81F3\u8868\u5355\u7F16\u8F91",
          modeTextText: "\u6587\u672C",
          modeTextTitle: "\u5207\u6362\u81F3\u6587\u672C\u7F16\u8F91",
          modeTreeText: "\u6811",
          modeTreeTitle: "\u5207\u6362\u81F3\u6811\u7F16\u8F91",
          modeViewText: "\u89C6\u56FE",
          modeViewTitle: "\u5207\u6362\u81F3\u6811\u89C6\u56FE",
          modePreviewText: "\u9884\u89C8",
          modePreviewTitle: "\u5207\u6362\u81F3\u9884\u89C8\u6A21\u5F0F",
          examples: "\u4F8B\u5B50",
          default: "\u7F3A\u7701",
          containsInvalidProperties: "\u5305\u542B\u65E0\u6548\u7684\u5C5E\u6027",
          containsInvalidItems: "\u5305\u542B\u65E0\u6548\u9879\u76EE"
        },
        "pt-BR": {
          array: "Lista",
          auto: "Automatico",
          appendText: "Adicionar",
          appendTitle: "Adicionar novo campo com tipo 'auto' depois deste campo (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "Selecione o tipo do campo a ser adicionado",
          appendTitleAuto: "Adicionar novo campo com tipo 'auto' (Ctrl+Shift+Ins)",
          ascending: "Ascendente",
          ascendingTitle: "Organizar filhor do tipo ${type} em crescente",
          actionsMenu: "Clique para abrir o menu de a\xE7\xF5es (Ctrl+M)",
          cannotParseFieldError: "N\xE3o \xE9 poss\xEDvel analisar o campo no JSON",
          cannotParseValueError: "N\xE3o \xE9 poss\xEDvel analisar o valor em JSON",
          collapseAll: "Fechar todos campos",
          compactTitle: "Dados JSON compactos, remova todos os espa\xE7os em branco (Ctrl+Shift+I)",
          descending: "Descendente",
          descendingTitle: "Organizar o filhos do tipo ${type} em decrescente",
          duplicateKey: "chave duplicada",
          drag: "Arraste para mover este campo (Alt+Shift+Arrows)",
          duplicateText: "Duplicar",
          duplicateTitle: "Duplicar campos selecionados (Ctrl+D)",
          duplicateField: "Duplicar este campo (Ctrl+D)",
          duplicateFieldError: "Nome do campo duplicado",
          empty: "vazio",
          expandAll: "Expandir todos campos",
          expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
          formatTitle: "Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)",
          insert: "Inserir",
          insertTitle: "Inserir um novo campo do tipo 'auto' antes deste campo (Ctrl+Ins)",
          insertSub: "Selecionar o tipo de campo a ser inserido",
          object: "Objeto",
          ok: "Ok",
          redo: "Refazer (Ctrl+Shift+Z)",
          removeText: "Remover",
          removeTitle: "Remover campos selecionados (Ctrl+Del)",
          removeField: "Remover este campo (Ctrl+Del)",
          repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xE1rios e nota\xE7\xE3o JSONP, transforme objetos JavaScript em JSON.",
          selectNode: "Selecione um n\xF3dulo...",
          showAll: "mostrar todos",
          showMore: "mostrar mais",
          showMoreStatus: "exibindo ${visibleChilds} de ${totalChilds} itens.",
          sort: "Organizar",
          sortTitle: "Organizar os filhos deste ${type}",
          sortTitleShort: "Organizar os filhos",
          sortFieldLabel: "Campo:",
          sortDirectionLabel: "Dire\xE7\xE3o:",
          sortFieldTitle: "Selecione um campo filho pelo qual ordenar o array ou objeto",
          sortAscending: "Ascendente",
          sortAscendingTitle: "Ordenar o campo selecionado por ordem ascendente",
          sortDescending: "Descendente",
          sortDescendingTitle: "Ordenar o campo selecionado por ordem descendente",
          string: "Texto",
          transform: "Transformar",
          transformTitle: "Filtrar, ordenar ou transformar os filhos deste ${type}",
          transformTitleShort: "Filtrar, ordenar ou transformar conte\xFAdos",
          transformQueryTitle: "Insira uma express\xE3o JMESPath",
          transformWizardLabel: "Assistente",
          transformWizardFilter: "Filtro",
          transformWizardSortBy: "Ordenar por",
          transformWizardSelectFields: "Selecionar campos",
          transformQueryLabel: "Express\xE3o",
          transformPreviewLabel: "Visualizar",
          type: "Tipo",
          typeTitle: "Mudar o tipo deste campo",
          openUrl: "Ctrl+Click ou Ctrl+Enter para abrir link em nova janela",
          undo: "Desfazer \xFAltimo a\xE7\xE3o (Ctrl+Z)",
          validationCannotMove: "N\xE3o pode mover um campo como filho dele mesmo",
          autoType: "Campo do tipo \"auto\". O tipo do campo \xE9 determinao automaticamente a partir do seu valor e pode ser texto, n\xFAmero, verdade/falso ou nulo.",
          objectType: "Campo do tipo \"objeto\". Um objeto cont\xE9m uma lista de pares com chave e valor.",
          arrayType: "Campo do tipo \"lista\". Uma lista contem uma cole\xE7\xE3o de valores ordenados.",
          stringType: "Campo do tipo \"string\". Campo do tipo nao \xE9 determinado atrav\xE9s do seu valor, mas sempre retornara um texto.",
          examples: "Exemplos",
          default: "Revelia",
          containsInvalidProperties: "Cont\xE9m propriedades inv\xE1lidas",
          containsInvalidItems: "Cont\xE9m itens inv\xE1lidos"
        },
        tr: {
          array: "Dizin",
          auto: "Otomatik",
          appendText: "Ekle",
          appendTitle: "Bu alan\u0131n alt\u0131na 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "Eklenecek alan\u0131n tipini se\xE7",
          appendTitleAuto: "'Otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
          ascending: "Artan",
          ascendingTitle: "${type}'\u0131n alt tiplerini artan d\xFCzende s\u0131rala",
          actionsMenu: "Aksiyon men\xFCs\xFCn\xFC a\xE7mak i\xE7in t\u0131klay\u0131n (Ctrl+M)",
          collapseAll: "T\xFCm alanlar\u0131 kapat",
          descending: "Azalan",
          descendingTitle: "${type}'\u0131n alt tiplerini azalan d\xFCzende s\u0131rala",
          drag: "Bu alan\u0131 ta\u015F\u0131mak i\xE7in s\xFCr\xFCkleyin (Alt+Shift+Arrows)",
          duplicateKey: "Var olan anahtar",
          duplicateText: "A\u015Fa\u011F\u0131ya kopyala",
          duplicateTitle: "Se\xE7ili alanlardan bir daha olu\u015Ftur (Ctrl+D)",
          duplicateField: "Bu alandan bir daha olu\u015Ftur (Ctrl+D)",
          duplicateFieldError: "Duplicate field name",
          cannotParseFieldError: "Alan JSON'a ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
          cannotParseValueError: "JSON'a de\u011Fer ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
          empty: "bo\u015F",
          expandAll: "T\xFCm alanlar\u0131 a\xE7",
          expandTitle: "Bu alan\u0131 a\xE7mak/kapatmak i\xE7in t\u0131kla (Ctrl+E). \nAlt alanlarda dahil t\xFCm alanlar\u0131 a\xE7mak i\xE7in Ctrl+Click ",
          insert: "Ekle",
          insertTitle: "Bu alan\u0131n \xFCst\xFCne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
          insertSub: "Araya eklenecek alan\u0131n tipini se\xE7",
          object: "Nesne",
          ok: "Tamam",
          redo: "Yeniden yap (Ctrl+Shift+Z)",
          removeText: "Kald\u0131r",
          removeTitle: "Se\xE7ilen alanlar\u0131 kald\u0131r (Ctrl+Del)",
          removeField: "Bu alan\u0131 kald\u0131r (Ctrl+Del)",
          selectNode: "Bir nesne se\xE7...",
          showAll: "t\xFCm\xFCn\xFC g\xF6ster",
          showMore: "daha fazla g\xF6ster",
          showMoreStatus: "${totalChilds} alan\u0131n ${visibleChilds} alt alanlar\u0131 g\xF6steriliyor",
          sort: "S\u0131rala",
          sortTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 s\u0131rala",
          sortTitleShort: "\u0130\xE7erikleri s\u0131rala",
          sortFieldLabel: "Alan:",
          sortDirectionLabel: "Y\xF6n:",
          sortFieldTitle: "Diziyi veya nesneyi s\u0131ralamak i\xE7in i\xE7 i\xE7e ge\xE7mi\u015F alan\u0131 se\xE7in",
          sortAscending: "Artan",
          sortAscendingTitle: "Se\xE7ili alan\u0131 artan d\xFCzende s\u0131rala",
          sortDescending: "Azalan",
          sortDescendingTitle: "Se\xE7ili alan\u0131 azalan d\xFCzende s\u0131rala",
          string: "Karakter Dizisi",
          transform: "D\xF6n\xFC\u015Ft\xFCr",
          transformTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 filtrele, s\u0131rala veya d\xF6n\xFC\u015Ft\xFCr",
          transformTitleShort: "\u0130\xE7erikleri filterele, s\u0131rala veya d\xF6n\xFC\u015Ft\xFCr",
          transformQueryTitle: "JMESPath sorgusu gir",
          transformWizardLabel: "Sihirbaz",
          transformWizardFilter: "Filtre",
          transformWizardSortBy: "S\u0131rala",
          transformWizardSelectFields: "Alanlar\u0131 se\xE7",
          transformQueryLabel: "Sorgu",
          transformPreviewLabel: "\xD6nizleme",
          type: "Tip",
          typeTitle: "Bu alan\u0131n tipini de\u011Fi\u015Ftir",
          openUrl: "URL'i yeni bir pencerede a\xE7mak i\xE7in Ctrl+Click veya Ctrl+Enter",
          undo: "Son de\u011Fi\u015Fikli\u011Fi geri al (Ctrl+Z)",
          validationCannotMove: "Alt alan olarak ta\u015F\u0131nam\u0131yor",
          autoType: "Alan tipi \"otomatik\". Alan t\xFCr\xFC otomatik olarak de\u011Ferden belirlenirve bir dize, say\u0131, boolean veya null olabilir.",
          objectType: "Alan tipi \"nesne\". Bir nesne, s\u0131ralanmam\u0131\u015F bir anahtar / de\u011Fer \xE7ifti k\xFCmesi i\xE7erir.",
          arrayType: "Alan tipi \"dizi\". Bir dizi, d\xFCzenli de\u011Ferler koleksiyonu i\xE7erir.",
          stringType: "Alan tipi \"karakter dizisi\". Alan t\xFCr\xFC de\u011Ferden belirlenmez,ancak her zaman karakter dizisi olarak d\xF6nd\xFCr\xFCl\xFCr.",
          modeCodeText: "Kod",
          modeCodeTitle: "Kod vurgulay\u0131c\u0131ya ge\xE7",
          modeFormText: "Form",
          modeFormTitle: "Form d\xFCzenleyiciye ge\xE7",
          modeTextText: "Metin",
          modeTextTitle: "D\xFCz metin d\xFCzenleyiciye ge\xE7",
          modeTreeText: "A\u011Fa\xE7",
          modeTreeTitle: "A\u011Fa\xE7 d\xFCzenleyiciye ge\xE7",
          modeViewText: "G\xF6r\xFCn\xFCm",
          modeViewTitle: "A\u011Fa\xE7 g\xF6r\xFCn\xFCm\xFCne ge\xE7",
          examples: "\xD6rnekler",
          default: "Varsay\u0131lan",
          containsInvalidProperties: "Ge\xE7ersiz \xF6zellikler i\xE7eriyor",
          containsInvalidItems: "Ge\xE7ersiz \xF6\u011Feler i\xE7eriyor"
        },
        ja: {
          array: "\u914D\u5217",
          auto: "\u30AA\u30FC\u30C8",
          appendText: "\u8FFD\u52A0",
          appendTitle: "\u6B21\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\"\u30AA\u30FC\u30C8\"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "\u8FFD\u52A0\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
          appendTitleAuto: "\"\u30AA\u30FC\u30C8\"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)",
          ascending: "\u6607\u9806",
          ascendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u6607\u9806\u306B\u4E26\u3079\u66FF\u3048",
          actionsMenu: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AF\u30B7\u30E7\u30F3\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F (Ctrl+M)",
          collapseAll: "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080",
          descending: "\u964D\u9806",
          descendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u964D\u9806\u306B\u4E26\u3079\u66FF\u3048",
          drag: "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u79FB\u52D5 (Alt+Shift+Arrows)",
          duplicateKey: "\u8907\u88FD\u30AD\u30FC",
          duplicateText: "\u8907\u88FD",
          duplicateTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
          duplicateField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
          duplicateFieldError: "\u30D5\u30A3\u30FC\u30EB\u30C9\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059",
          cannotParseFieldError: "JSON\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
          cannotParseValueError: "JSON\u306E\u5024\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
          empty: "\u7A7A",
          expandAll: "\u3059\u3079\u3066\u3092\u5C55\u958B",
          expandTitle: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080 (Ctrl+E). \nCtrl+Click \u3067\u3059\u3079\u3066\u306E\u5B50\u8981\u7D20\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080",
          insert: "\u633F\u5165",
          insertTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u524D\u306B\u65B0\u3057\u3044\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u633F\u5165 (Ctrl+Ins)",
          insertSub: "\u633F\u5165\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E",
          object: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
          ok: "\u5B9F\u884C",
          redo: "\u3084\u308A\u76F4\u3059 (Ctrl+Shift+Z)",
          removeText: "\u524A\u9664",
          removeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
          removeField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
          selectNode: "\u30CE\u30FC\u30C9\u3092\u9078\u629E...",
          showAll: "\u3059\u3079\u3066\u3092\u8868\u793A",
          showMore: "\u3082\u3063\u3068\u898B\u308B",
          showMoreStatus: "${totalChilds}\u500B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u3046\u3061 ${visibleChilds}\u500B\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002",
          sort: "\u4E26\u3079\u66FF\u3048",
          sortTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u4E26\u3079\u66FF\u3048",
          sortTitleShort: "\u4E26\u3079\u66FF\u3048",
          sortFieldLabel: "\u30D5\u30A3\u30FC\u30EB\u30C9:",
          sortDirectionLabel: "\u9806\u5E8F:",
          sortFieldTitle: "\u914D\u5217\u307E\u305F\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E26\u3073\u66FF\u3048\u308B\u305F\u3081\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
          sortAscending: "\u6607\u9806",
          sortAscendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6607\u9806\u306B\u4E26\u3073\u66FF\u3048",
          sortDescending: "\u964D\u9806",
          sortDescendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u964D\u9806\u306B\u4E26\u3073\u66FF\u3048",
          string: "\u6587\u5B57\u5217",
          transform: "\u5909\u63DB",
          transformTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
          transformTitleShort: "\u5185\u5BB9\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
          extract: "\u62BD\u51FA",
          extractTitle: "${type}\u3092\u62BD\u51FA",
          transformQueryTitle: "JMESPath\u30AF\u30A8\u30EA\u3092\u5165\u529B",
          transformWizardLabel: "\u30A6\u30A3\u30B6\u30FC\u30C9",
          transformWizardFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
          transformWizardSortBy: "\u4E26\u3073\u66FF\u3048",
          transformWizardSelectFields: "\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
          transformQueryLabel: "\u30AF\u30A8\u30EA",
          transformPreviewLabel: "\u30D7\u30EC\u30D3\u30E5\u30FC",
          type: "\u578B",
          typeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u5909\u66F4",
          openUrl: "Ctrl+Click \u307E\u305F\u306F Ctrl+Enter \u3067 \u65B0\u898F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067URL\u3092\u958B\u304F",
          undo: "\u5143\u306B\u623B\u3059 (Ctrl+Z)",
          validationCannotMove: "\u5B50\u8981\u7D20\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093 ",
          autoType: "\u30AA\u30FC\u30C8\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u306F\u5024\u304B\u3089\u81EA\u52D5\u7684\u306B\u6C7A\u5B9A\u3055\u308C\u307E\u3059\u3002 (\u6587\u5B57\u5217\u30FB\u6570\u5024\u30FB\u30D6\u30FC\u30EB\u30FBnull)",
          objectType: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF1A \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u306A\u3044\u30AD\u30FC\u3068\u5024\u306E\u30DA\u30A2\u7D44\u307F\u5408\u308F\u305B\u3067\u3059\u3002",
          arrayType: "\u914D\u5217\uFF1A \u914D\u5217\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5024\u306E\u96C6\u5408\u4F53\u3067\u3059\u3002",
          stringType: "\u6587\u5B57\u5217\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u578B\u306F\u5024\u304B\u3089\u6C7A\u5B9A\u3055\u308C\u307E\u305B\u3093\u304C\u3001\u5E38\u306B\u6587\u5B57\u5217\u3068\u3057\u3066\u8FD4\u3055\u308C\u307E\u3059\u3002",
          modeCodeText: "\u30B3\u30FC\u30C9\u30E2\u30FC\u30C9",
          modeCodeTitle: "\u30CF\u30A4\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
          modeFormText: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9",
          modeFormTitle: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
          modeTextText: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9",
          modeTextTitle: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
          modeTreeText: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9",
          modeTreeTitle: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
          modeViewText: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9",
          modeViewTitle: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
          modePreviewText: "\u30D7\u30EC\u30D3\u30E5\u30FC",
          modePreviewTitle: "\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u5207\u308A\u66FF\u3048",
          examples: "\u4F8B",
          default: "\u30C7\u30D5\u30A9\u30EB\u30C8",
          containsInvalidProperties: "\u7121\u52B9\u306A\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
          containsInvalidItems: "\u7121\u52B9\u306A\u30A2\u30A4\u30C6\u30E0\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059"
        },
        "fr-FR": {
          array: "Liste",
          auto: "Auto",
          appendText: "Ajouter",
          appendTitle: "Ajouter un champ de type 'auto' apr\xE8s ce champ (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "S\xE9lectionner le type du champ \xE0 ajouter",
          appendTitleAuto: "Ajouter un champ de type 'auto' (Ctrl+Shift+Ins)",
          ascending: "Ascendant",
          ascendingTitle: "Trier les enfants de ce ${type} par ordre ascendant",
          actionsMenu: "Ouvrir le menu des actions (Ctrl+M)",
          collapseAll: "Regrouper",
          descending: "Descendant",
          descendingTitle: "Trier les enfants de ce ${type} par ordre descendant",
          drag: "D\xE9placer (Alt+Shift+Arrows)",
          duplicateKey: "Dupliquer la cl\xE9",
          duplicateText: "Dupliquer",
          duplicateTitle: "Dupliquer les champs s\xE9lectionn\xE9s (Ctrl+D)",
          duplicateField: "Dupliquer ce champ (Ctrl+D)",
          duplicateFieldError: "Dupliquer le nom de champ",
          cannotParseFieldError: "Champ impossible \xE0 parser en JSON",
          cannotParseValueError: "Valeur impossible \xE0 parser en JSON",
          empty: "vide",
          expandAll: "\xC9tendre",
          expandTitle: "\xC9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xE9tendre/regrouper avec tous les champs.",
          insert: "Ins\xE9rer",
          insertTitle: "Ins\xE9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
          insertSub: "S\xE9lectionner le type de champ \xE0 ins\xE9rer",
          object: "Objet",
          ok: "Ok",
          redo: "Rejouer (Ctrl+Shift+Z)",
          removeText: "Supprimer",
          removeTitle: "Supprimer les champs s\xE9lectionn\xE9s (Ctrl+Del)",
          removeField: "Supprimer ce champ (Ctrl+Del)",
          searchTitle: "Rechercher champs et valeurs",
          searchNextResultTitle: "R\xE9sultat suivant (Enter)",
          searchPreviousResultTitle: "R\xE9sultat pr\xE9c\xE9dent (Shift + Enter)",
          selectNode: "S\xE9lectionner un n\u0153ud...",
          showAll: "voir tout",
          showMore: "voir plus",
          showMoreStatus: "${visibleChilds} \xE9l\xE9ments affich\xE9s de ${totalChilds}.",
          sort: "Trier",
          sortTitle: "Trier les champs de ce ${type}",
          sortTitleShort: "Trier",
          sortFieldLabel: "Champ:",
          sortDirectionLabel: "Direction:",
          sortFieldTitle: "S\xE9lectionner les champs permettant de trier les listes et objet",
          sortAscending: "Ascendant",
          sortAscendingTitle: "Trier les champs s\xE9lectionn\xE9s par ordre ascendant",
          sortDescending: "Descendant",
          sortDescendingTitle: "Trier les champs s\xE9lectionn\xE9s par ordre descendant",
          string: "Cha\xEEne",
          transform: "Transformer",
          transformTitle: "Filtrer, trier, or transformer les enfants de ce ${type}",
          transformTitleShort: "Filtrer, trier ou transformer le contenu",
          extract: "Extraire",
          extractTitle: "Extraire ce ${type}",
          transformQueryTitle: "Saisir une requ\xEAte JMESPath",
          transformWizardLabel: "Assistant",
          transformWizardFilter: "Filtrer",
          transformWizardSortBy: "Trier par",
          transformWizardSelectFields: "S\xE9lectionner les champs",
          transformQueryLabel: "Requ\xEAte",
          transformPreviewLabel: "Pr\xE9visualisation",
          type: "Type",
          typeTitle: "Changer le type de ce champ",
          openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xEAtre",
          undo: "Annuler la derni\xE8re action (Ctrl+Z)",
          validationCannotMove: "Cannot move a field into a child of itself",
          autoType: "Champe de type \"auto\". Ce type de champ est automatiquement d\xE9termin\xE9 en fonction de la valeur et peut \xEAtre de type \"cha\xEEne\", \"nombre\", \"bool\xE9en\" ou null.",
          objectType: "Champ de type \"objet\". Un objet contient un ensemble non ordonn\xE9 de paires cl\xE9/valeur.",
          arrayType: "Champ de type \"liste\". Une liste contient une collection ordonn\xE9e de valeurs.",
          stringType: "Champ de type \"cha\xEEne\". Ce type de champ n'est pas d\xE9termin\xE9 en fonction de la valeur, mais retourne syst\xE9matiquement une cha\xEEne de caract\xE8res.",
          modeEditorTitle: "Changer mode d'\xE9dition",
          modeCodeText: "Code",
          modeCodeTitle: "Activer surlignage code",
          modeFormText: "Formulaire",
          modeFormTitle: "Activer formulaire",
          modeTextText: "Texte",
          modeTextTitle: "Activer \xE9diteur texte",
          modeTreeText: "Arbre",
          modeTreeTitle: "Activer \xE9diteur arbre",
          modeViewText: "Lecture seule",
          modeViewTitle: "Activer vue arbre",
          modePreviewText: "Pr\xE9visualisation",
          modePreviewTitle: "Activer mode pr\xE9visualiser",
          examples: "Exemples",
          default: "D\xE9faut",
          containsInvalidProperties: "Contient des propri\xE9t\xE9s non valides",
          containsInvalidItems: "Contient des \xE9l\xE9ments invalides"
        },
        de: {
          array: "Auflistung",
          auto: "Auto",
          appendText: "anh\xE4ngen",
          appendTitle: "F\xFCgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
          appendSubmenuTitle: "W\xE4hlen Sie den Typ des neuen Feldes",
          appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xFCgen (Strg+Umschalt+Ein)",
          ascending: "Aufsteigend",
          ascendingTitle: "Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge",
          actionsMenu: "Klicken Sie zum \xD6ffnen des Aktionsmen\xFCs (Strg+M)",
          cannotParseFieldError: "Feld kann nicht in JSON geparst werden",
          cannotParseValueError: "Wert kann nicht in JSON geparst werden",
          collapseAll: "Alle Felder zuklappen",
          compactTitle: "JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)",
          descending: "Absteigend",
          descendingTitle: "Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge",
          drag: "Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)",
          duplicateKey: "Doppelter Schl\xFCssel",
          duplicateText: "Duplikat",
          duplicateTitle: "Ausgew\xE4hlte Felder duplizieren (Strg+D)",
          duplicateField: "Dieses Feld duplizieren (Strg+D)",
          duplicateFieldError: "Doppelter Feldname",
          empty: "leer",
          expandAll: "Alle Felder anzeigen",
          expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xDFlich aller Elemente zu erweitern/zu kollabieren.",
          formatTitle: "JSON-Daten mit korrekter Einr\xFCckung und Zeilenvorsch\xFCben formatieren (Strg+\\)",
          insert: "einf\xFCgen",
          insertTitle: "F\xFCgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
          insertSub: "W\xE4hlen Sie den Typ des neuen Feldes",
          object: "Objekt",
          ok: "Ok",
          redo: "Wiederholen (Strg+Umschalt+Z)",
          removeText: "entfernen",
          removeTitle: "Ausgew\xE4hlte Felder entfernen (Strg+Entf)",
          removeField: "Dieses Feld entfernen (Strg+Entf)",
          repairTitle: "JSON reparieren: Anf\xFChrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
          searchTitle: "Suchfelder und Werte",
          searchNextResultTitle: "N\xE4chstes Ergebnis (Enter)",
          searchPreviousResultTitle: "Vorheriges Ergebnis (Umschalt + Eingabe)",
          selectNode: "W\xE4hlen Sie einen Knoten aus...",
          showAll: "alle anzeigen",
          showMore: "mehr anzeigen",
          showMoreStatus: "Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.",
          sort: "Sortieren",
          sortTitle: "Sortieren Sie die Elemente dieses ${type}",
          sortTitleShort: "Inhalt sortieren",
          sortFieldLabel: "Feld:",
          sortDirectionLabel: "Richtung:",
          sortFieldTitle: "W\xE4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
          sortAscending: "Aufsteigend",
          sortAscendingTitle: "Sortieren Sie das ausgew\xE4hlte Feld in aufsteigender Reihenfolge",
          sortDescending: "Absteigend",
          sortDescendingTitle: "Sortieren Sie das ausgew\xE4hlte Feld in absteigender Reihenfolge",
          string: "Zeichenfolge",
          transform: "Verwandeln",
          transformTitle: "Die Elemente dieses ${type} filtern, sortieren oder transformieren",
          transformTitleShort: "Inhalte filtern, sortieren oder transformieren",
          extract: "Auszug",
          extractTitle: "Extrahieren Sie diesen ${type}",
          transformQueryTitle: "Eine JMESPath-Abfrage eingeben",
          transformWizardLabel: "Zauberer",
          transformWizardFilter: "Filter",
          transformWizardSortBy: "Sortieren nach",
          transformWizardSelectFields: "Felder ausw\xE4hlen",
          transformQueryLabel: "Anfrage",
          transformPreviewLabel: "Vorschau",
          type: "Geben Sie  ein.",
          typeTitle: "\xC4ndern Sie den Typ dieses Feldes",
          openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xF6ffnen",
          undo: "Letzte Aktion r\xFCckg\xE4ngig machen (Strg+Z)",
          validationCannotMove: "Kann ein Feld nicht in ein Kind seiner selbst verschieben",
          autoType: "Feldtyp \"auto\". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.",
          objectType: "Feldtyp \"Objekt\". Ein Objekt enth\xE4lt eine ungeordnete Menge von Schl\xFCssel/Wert-Paaren.",
          arrayType: "Feldtyp \"Array\". Ein Array enth\xE4lt eine geordnete Sammlung von Werten.",
          stringType: "Feldtyp \"Zeichenfolge\". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xFCckgegeben.",
          modeEditorTitle: "Editor-Modus umschalten",
          modeCodeText: "Code",
          modeCodeTitle: "Umschalten auf Code-Highlighter",
          modeFormText: "Formular",
          modeFormTitle: "Zum Formular-Editor wechseln",
          modeTextText: "Text",
          modeTextTitle: "Zum Editor f\xFCr einfachen Text wechseln",
          modeTreeText: "Baum",
          modeTreeTitle: "Zum Baum-Editor wechseln",
          modeViewText: "Siehe",
          modeViewTitle: "Zur Baumansicht wechseln",
          modePreviewText: "Vorschau",
          modePreviewTitle: "In den Vorschau-Modus wechseln",
          examples: "Beispiele",
          default: "Standardm\xE4\xDFig",
          containsInvalidProperties: "Enth\xE4lt ung\xFCltige Eigenschaften",
          containsInvalidItems: "Enth\xE4lt ung\xFCltige Elemente"
        },
        ru: {
          array: "\u041C\u0430\u0441\u0441\u0438\u0432",
          auto: "\u0410\u0432\u0442\u043E",
          appendText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
          appendTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Ctrl+Shift+Ins)",
          appendSubmenuTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
          appendTitleAuto: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' (Ctrl+Shift+Ins)",
          ascending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
          ascendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
          actionsMenu: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043C\u0435\u043D\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 (Ctrl+M)",
          cannotParseFieldError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 JSON",
          cannotParseValueError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 JSON",
          collapseAll: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
          compactTitle: "\u041C\u0438\u043D\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F JSON (Ctrl+Shift+I)",
          descending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
          descendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
          drag: "\u041F\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Alt+Shift+Arrows)",
          duplicateKey: "\u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0439\u0441\u044F \u043A\u043B\u044E\u0447",
          duplicateText: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
          duplicateTitle: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 (Ctrl+D)",
          duplicateField: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+D)",
          duplicateFieldError: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u044F",
          empty: "\u043F\u0443\u0441\u0442\u043E\u0439",
          expandAll: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
          expandTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u043E\u043B\u044F (Ctrl+E)\n\u0438\u043B\u0438 Ctrl+Click \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432.",
          formatTitle: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 JSON (Ctrl+I)",
          insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
          insertTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u0435\u0440\u0435\u0434 \u044D\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u043C (Ctrl+Ins)",
          insertSub: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
          object: "\u041E\u0431\u044A\u0435\u043A\u0442",
          ok: "\u041E\u041A",
          redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C (Ctrl+Shift+Z)",
          removeText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
          removeTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F (Ctrl+Del)",
          removeField: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+Del)",
          repairTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 JSON: \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043A\u0430\u0432\u044B\u0447\u043A\u0438 \u0438 escape-\u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0438 \u043D\u043E\u0442\u0430\u0446\u0438\u044E JSONP, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B JavaScript \u0432 JSON.",
          searchTitle: "\u041F\u043E\u0438\u0441\u043A",
          searchNextResultTitle: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Enter)",
          searchPreviousResultTitle: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Shift + Enter)",
          selectNode: "\u0412\u044B\u0431\u043E\u0440 \u0443\u0437\u043B\u0430...",
          showAll: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
          showMore: "\u0431\u043E\u043B\u044C\u0448\u0435",
          showMoreStatus: "${visibleChilds} \u0438\u0437 ${totalChilds}",
          sort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
          sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432 \u0442\u0438\u043F\u0430 ${type}",
          sortTitleShort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E",
          sortFieldLabel: "\u041F\u043E\u043B\u0435:",
          sortDirectionLabel: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435:",
          sortFieldTitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
          sortAscending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
          sortAscendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
          sortDescending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
          sortDescendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
          string: "\u0421\u0442\u0440\u043E\u043A\u0430",
          transform: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
          transformTitle: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0430 ${type}",
          transformTitleShort: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445",
          extract: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
          extractTitle: "\u0418\u0437\u0432\u043B\u0435\u0447\u044C \u0442\u0438\u043F ${type}",
          transformQueryTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 JMESpath \u0437\u0430\u043F\u0440\u043E\u0441",
          transformWizardLabel: "\u041C\u0430\u0441\u0442\u0435\u0440",
          transformWizardFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
          transformWizardSortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
          transformWizardSelectFields: "\u041F\u043E\u043B\u044F",
          transformQueryLabel: "\u0417\u0430\u043F\u0440\u043E\u0441",
          transformPreviewLabel: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
          type: "\u0422\u0438\u043F",
          typeTitle: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0438\u043F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
          openUrl: "Ctrl+Click \u0438\u043B\u0438 Ctrl+Enter \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F url \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
          undo: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C (Ctrl+Z)",
          validationCannotMove: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u043F\u043E\u0442\u043E\u043C\u043A\u0430",
          autoType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439, \u0447\u0438\u0441\u043B\u043E\u043C, \u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 null.",
          objectType: "\u041E\u0431\u044A\u0435\u043A\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043F\u0430\u0440 \u043A\u043B\u044E\u0447/\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
          arrayType: "\u041C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439.",
          stringType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043D\u043E \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u043A\u0430.",
          modeEditorTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
          modeCodeText: "\u041A\u043E\u0434",
          modeCodeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u043A\u043E\u0434\u0430",
          modeFormText: "\u0424\u043E\u0440\u043C\u0430",
          modeFormTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0444\u043E\u0440\u043C\u044B",
          modeTextText: "\u0422\u0435\u043A\u0441\u0442",
          modeTextTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
          modeTreeText: "\u0414\u0435\u0440\u0435\u0432\u043E",
          modeTreeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
          modeViewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0435\u0440\u0435\u0432\u0430",
          modeViewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
          modePreviewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
          modePreviewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
          examples: "\u041F\u0440\u0438\u043C\u0435\u0440\u044B",
          default: "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
          containsInvalidProperties: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
          containsInvalidItems: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
        },
        ko: {
          array: "\uBC30\uC5F4",
          auto: "\uC790\uB3D9",
          appendText: "\uCD94\uAC00",
          appendTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC544\uB798\uC5D0 \"\uC790\uB3D9\" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)",
          appendSubmenuTitle: "\uCD94\uAC00\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
          appendTitleAuto: "\"\uC790\uB3D9\" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)",
          ascending: "\uC624\uB984\uCC28\uC21C",
          ascendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C \uC815\uB82C\uD569\uB2C8\uB2E4.",
          actionsMenu: "\uBA54\uB274 \uC5F4\uAE30 (Ctrl + M)",
          cannotParseFieldError: "JSON\uC758 \uC694\uC18C\uB97C \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
          cannotParseValueError: "JSON\uC758 \uAC12\uC744 \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
          collapseAll: "\uBAA8\uB450 \uC811\uAE30",
          compactTitle: "\uBAA8\uB4E0 \uACF5\uBC31\uC744 \uC81C\uAC70\uD558\uC5EC JSON \uB370\uC774\uD130\uB97C \uC791\uAC8C \uB9CC\uB4ED\uB2C8\uB2E4. (Ctrl + Shift + I)",
          descending: "\uB0B4\uB9BC\uCC28\uC21C",
          descendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C",
          drag: "\uB4DC\uB798\uADF8\uD558\uC5EC \uC694\uC18C\uB97C \uC774\uB3D9\uD569\uB2C8\uB2E4. (Alt + Shift + Arrows)",
          duplicateKey: "\uBCF5\uC81C\uD0A4",
          duplicateText: "\uBCF5\uC81C",
          duplicateTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
          duplicateField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
          duplicateFieldError: "\uC694\uC18C \uC774\uB984\uC774 \uC911\uBCF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
          empty: "\uBE44\uC5B4\uC788\uC74C",
          expandAll: "\uBAA8\uB450 \uC5F4\uAE30",
          expandTitle: "\uD074\uB9AD\uD558\uC5EC \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4. (Ctrl + E) \nCtrl + Click\uC73C\uB85C \uBAA8\uB4E0 \uD558\uC704 \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4.",
          formatTitle: "\uC801\uC808\uD55C \uB4E4\uC5EC\uC4F0\uAE30 \uBC0F \uC904\uBC14\uAFC8\uC73C\uB85C JSON \uB370\uC774\uD130\uB97C \uC815\uD615\uD654\uD569\uB2C8\uB2E4. (Ctrl + I)",
          insert: "\uC0BD\uC785",
          insertTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC704\uC5D0 \uC0C8\uC694\uC18C\uB97C \uC0BD\uC785\uD569\uB2C8\uB2E4. (Ctrl + Ins)",
          insertSub: "\uC0BD\uC785\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
          object: "\uAC1D\uCCB4",
          ok: "\uD655\uC778",
          redo: "\uB2E4\uC2DC \uC2E4\uD589 (Ctrl + Shift + Z)",
          removeText: "\uC0AD\uC81C",
          removeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
          removeField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
          repairTitle: "JSON \uAD50\uC815: JSON \uB0B4\uC758 \uC8FC\uC11D\uACFC JSONP \uD45C\uAE30\uBC95\uC744 \uC9C0\uC6B0\uACE0 \uB530\uC634\uD45C\uC640 \uC774\uC2A4\uCF00\uC774\uD504 \uBB38\uC790\uB97C \uC218\uC815\uD569\uB2C8\uB2E4.",
          searchTitle: "\uC694\uC18C \uB610\uB294 \uAC12 \uCC3E\uAE30",
          searchNextResultTitle: "\uB2E4\uC74C\uC73C\uB85C \uCC3E\uAE30 (Enter)",
          searchPreviousResultTitle: "\uC774\uC804\uC73C\uB85C \uCC3E\uAE30 (Shift + Enter)",
          selectNode: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694...",
          showAll: "\uBAA8\uB450\uBCF4\uAE30",
          showMore: "\uB354\uBCF4\uAE30",
          showMoreStatus: "${totalChilds} \uAC1C\uC758 \uD56D\uBAA9 \uC911 ${visibleChilds} \uAC1C\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
          sort: "\uC815\uB82C",
          sortTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC815\uB82C\uD569\uB2C8\uB2E4.",
          sortTitleShort: "\uC815\uB82C",
          sortFieldLabel: "\uC694\uC18C:",
          sortDirectionLabel: "\uC21C\uC11C:",
          sortFieldTitle: "\uBC30\uC5F4\uC774\uB098 \uAC1D\uCCB4\uB97C \uC815\uB82C\uD558\uB294 \uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
          sortAscending: "\uC624\uB984\uCC28\uC21C",
          sortAscendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
          sortDescending: "\uB0B4\uB9BC\uCC28\uC21C",
          sortDescendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
          string: "\uBB38\uC790",
          transform: "\uBCC0\uD658",
          transformTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
          transformTitleShort: "\uB0B4\uC6A9\uC744 \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
          extract: "\uCD94\uCD9C",
          extractTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uAC12\uC744 \uCD5C\uC0C1\uC704\uC5D0 \uC704\uCE58\uC2DC\uD0B5\uB2C8\uB2E4.",
          transformQueryTitle: "JMESPath \uCFFC\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
          transformWizardLabel: "\uB9C8\uBC95\uC0AC",
          transformWizardFilter: "\uD544\uD130",
          transformWizardSortBy: "\uC815\uB82C",
          transformWizardSelectFields: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
          transformQueryLabel: "\uCFFC\uB9AC",
          transformPreviewLabel: "\uBBF8\uB9AC\uBCF4\uAE30",
          type: "\uC720\uD615",
          typeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uC758 \uC720\uD615\uC744 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
          openUrl: "Ctrl + Click \uB610\uB294 Ctrl + Enter\uB85C \uC0C8 \uCC3D\uC5D0\uC11C URL \uC5F4\uAE30",
          undo: "\uC2E4\uD589 \uCDE8\uC18C (Ctrl + Z)",
          validationCannotMove: "\uD558\uC704 \uC694\uC18C\uB85C \uC774\uB3D9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
          autoType: "\uC790\uB3D9: \uC694\uC18C\uC758 \uD615\uC2DD\uC774 \uAC12\uC758 \uC720\uD615\uC73C\uB85C \uACB0\uC815\uB429\uB2C8\uB2E4. \uBB38\uC790, \uC22B\uC790, \uBD80\uC6B8, \uB610\uB294 null\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.",
          objectType: "\uAC1D\uCCB4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB418\uC9C0 \uC54A\uC740 \uC774\uB984/\uAC12 \uC30D\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C4 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
          arrayType: "\uBC30\uC5F4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB41C \uAC12\uC758 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
          stringType: "\uBB38\uC790: \uC694\uC18C\uC758 \uC720\uD615\uC774 \uAC12\uC5D0\uC11C \uACB0\uC815\uB418\uC9C0 \uC54A\uC9C0\uB9CC \uD56D\uC0C1 \uBB38\uC790\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.",
          modeEditorTitle: "\uD3B8\uC9D1\uAE30 \uC720\uD615 \uBCC0\uACBD",
          modeCodeText: "\uCF54\uB4DC",
          modeCodeTitle: "\uD615\uC2DD \uAD50\uC815\uC744 \uB3C4\uC640\uC8FC\uB294 \uAE30\uB2A5\uC774 \uD3EC\uD568\uB41C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
          modeFormText: "\uC785\uB825 \uC591\uC2DD",
          modeFormTitle: "\uC815\uD574\uC9C4 \uC694\uC18C\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uB294 \uD3B8\uC9D1\uAE30",
          modeTextText: "\uBB38\uC790",
          modeTextTitle: "\uB2E8\uC21C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
          modeTreeText: "\uD2B8\uB9AC",
          modeTreeTitle: "\uD2B8\uB9AC \uAD6C\uC870\uB85C \uD45C\uC2DC\uB418\uB294 \uD3B8\uC9D1\uAE30",
          modeViewText: "\uBCF4\uAE30",
          modeViewTitle: "\uC77D\uAE30\uC804\uC6A9 \uD2B8\uB9AC \uAD6C\uC870\uB85C JSON\uC744 \uD45C\uC2DC",
          modePreviewText: "\uBBF8\uB9AC\uBCF4\uAE30",
          modePreviewTitle: "\uC77D\uAE30\uC804\uC6A9 \uBB38\uC790\uB85C JSON\uC744 \uD45C\uC2DC",
          examples: "\uC608\uC81C",
          default: "\uAE30\uBCF8\uAC12",
          containsInvalidProperties: "\uC798\uBABB\uB41C \uC18D\uC131\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
          containsInvalidItems: "\uC798\uBABB\uB41C \uD56D\uBAA9\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4"
        }
      },
          n = Object.keys(o),
          s = "en",
          r = "undefined" != typeof navigator ? navigator.language || navigator.userLanguage : void 0,
          a = n.find(function (e) {
        return e === r;
      }) || s;

      function l(t) {
        var e;
        t && ((e = n.find(function (e) {
          return e === t;
        })) ? a = e : console.error("Language not found"));
      }

      function c(e) {
        if (e) for (var t in e) !function (t) {
          n.find(function (e) {
            return e === t;
          }) || n.push(t), o[t] = Object.assign({}, o[s], o[t], e[t]);
        }(t);
      }

      function h(e, t, i) {
        var n = o[i = i || a][e] || o[s][e] || e;
        if (t) for (var r in t) n = n.replace("${" + r + "}", t[r]);
        return n;
      }
    },
    6056: function (e, t, i) {
      "use strict";

      i.d(t, {
        J: function () {
          return o;
        },
        r: function () {
          return r;
        }
      });
      var t = i(5156),
          n = i.n(t),
          s = i(9791);

      function r(e, t) {
        var i,
            n = t.sort,
            r = t.filter,
            t = t.projection,
            o = "";
        return r ? (i = "@" !== r.field ? ["0"].concat((0, s.parsePath)("." + r.field)) : ["0"], i = "string" == typeof (0, s.get)(e, i) ? r.value : (0, s.parseString)(r.value), o += "[? " + r.field + " " + r.relation + " `" + JSON.stringify(i) + "`]") : o += Array.isArray(e) ? "[*]" : "@", n && ("desc" === n.direction ? o += " | reverse(sort_by(@, &" + n.field + "))" : o += " | sort_by(@, &" + n.field + ")"), t && ("]" !== o[o.length - 1] && (o += " | [*]"), 1 === t.fields.length ? o += "." + t.fields[0] : 1 < t.fields.length && (o += ".{" + t.fields.map(function (e) {
          var t = e.split(".");
          return t[t.length - 1] + ": " + e;
        }).join(", ") + "}")), o;
      }

      function o(e, t) {
        return n().search(e, t);
      }
    },
    4987: function () {
      function e(e) {
        void 0 === e || "remove" in e || Object.defineProperty(e, "remove", {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: function () {
            void 0 !== (this || _global).parentNode && (this || _global).parentNode.removeChild(this || _global);
          }
        });
      }

      "undefined" != typeof Element && (void 0 !== window.Element && e(window.Element.prototype), void 0 !== window.CharacterData && e(window.CharacterData.prototype), void 0 !== window.DocumentType && e(window.DocumentType.prototype)), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
        value: function (e) {
          for (var t = 0; t < (this || _global).length; t++) {
            var i = (this || _global)[t];
            if (e.call(this || _global, i, t, this || _global)) return t;
          }

          return -1;
        },
        configurable: !0,
        writable: !0
      }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
        value: function (e) {
          e = this.findIndex(e);
          return (this || _global)[e];
        },
        configurable: !0,
        writable: !0
      }), String.prototype.trim || (String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      });
    },
    341: function (e, t, i) {
      "use strict";

      i.r(t), i.d(t, {
        previewModeMixins: function () {
          return m;
        }
      });
      var t = i(3860),
          n = i.n(t),
          s = i(4188),
          r = i(6436),
          o = i(2474);

      function a(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var l = function () {
        function n(e, t, i) {
          if (!((this || _global) instanceof n)) throw new TypeError("Cannot call a class as a function");
          (this || _global).onChange = e, (this || _global).calculateItemSize = t || function () {
            return 1;
          }, (this || _global).limit = i, (this || _global).items = [], (this || _global).index = -1;
        }

        var e, t, i;
        return e = n, (t = [{
          key: "add",
          value: function (e) {
            for (; this._calculateHistorySize() > (this || _global).limit && 1 < (this || _global).items.length;) (this || _global).items.shift(), (this || _global).index--;

            (this || _global).items = (this || _global).items.slice(0, (this || _global).index + 1), (this || _global).items.push(e), (this || _global).index++, this.onChange();
          }
        }, {
          key: "_calculateHistorySize",
          value: function () {
            var t = (this || _global).calculateItemSize,
                i = 0;
            return (this || _global).items.forEach(function (e) {
              i += t(e);
            }), i;
          }
        }, {
          key: "undo",
          value: function () {
            if (this.canUndo()) return (this || _global).index--, this.onChange(), (this || _global).items[(this || _global).index];
          }
        }, {
          key: "redo",
          value: function () {
            if (this.canRedo()) return (this || _global).index++, this.onChange(), (this || _global).items[(this || _global).index];
          }
        }, {
          key: "canUndo",
          value: function () {
            return 0 < (this || _global).index;
          }
        }, {
          key: "canRedo",
          value: function () {
            return (this || _global).index < (this || _global).items.length - 1;
          }
        }, {
          key: "clear",
          value: function () {
            (this || _global).items = [], (this || _global).index = -1, this.onChange();
          }
        }]) && a(e.prototype, t), i && a(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), n;
      }(),
          c = i(7907),
          h = i(6056),
          d = i(6617),
          u = i(6210),
          g = i(2558),
          t = i(5956),
          p = i(9791),
          i = t.textModeMixins[0].mixin,
          t = {
        create: function (e) {
          var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
              i = (void 0 === t.statusBar && (t.statusBar = !0), t.mainMenuBar = !1 !== t.mainMenuBar, t.enableSort = !1 !== t.enableSort, t.enableTransform = !1 !== t.enableTransform, t.createQuery = t.createQuery || h.r, t.executeQuery = t.executeQuery || h.J, "number" == typeof ((this || _global).options = t).indentation ? (this || _global).indentation = Number(t.indentation) : (this || _global).indentation = 2, (0, c.cC)((this || _global).options.languages), (0, c.m0)((this || _global).options.language), (this || _global).mode = "preview", this || _global),
              e = ((this || _global).container = e, (this || _global).dom = {}, (this || _global).json = void 0, (this || _global).text = "", (this || _global)._debouncedValidate = (0, p.debounce)((this || _global).validate.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), (this || _global).width = e.clientWidth, (this || _global).height = e.clientHeight, (this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-preview", (this || _global).frame.onclick = function (e) {
            e.preventDefault();
          }, {
            target: (this || _global).frame,
            onFocus: (this || _global).options.onFocus || null,
            onBlur: (this || _global).options.onBlur || null
          });
          (this || _global).frameFocusTracker = new o.R(e), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-outer", (this || _global).dom.busy = document.createElement("div"), (this || _global).dom.busy.className = "jsoneditor-busy", (this || _global).dom.busyContent = document.createElement("span"), (this || _global).dom.busyContent.textContent = "busy...", (this || _global).dom.busy.appendChild((this || _global).dom.busyContent), (this || _global).content.appendChild((this || _global).dom.busy), (this || _global).dom.previewContent = document.createElement("pre"), (this || _global).dom.previewContent.className = "jsoneditor-preview", (this || _global).dom.previewText = document.createTextNode(""), (this || _global).dom.previewContent.appendChild((this || _global).dom.previewText), (this || _global).content.appendChild((this || _global).dom.previewContent), (this || _global).options.mainMenuBar && ((0, p.addClassName)((this || _global).content, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, c.Iu)("formatTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
            i.executeWithBusyMessage(function () {
              try {
                i.format();
              } catch (e) {
                i._onError(e);
              }
            }, "formatting...");
          }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, c.Iu)("compactTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
            i.executeWithBusyMessage(function () {
              try {
                i.compact();
              } catch (e) {
                i._onError(e);
              }
            }, "compacting...");
          }, (this || _global).options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, c.Iu)("sortTitleShort"), e.onclick = function () {
            i._showSortModal();
          }, (this || _global).menu.appendChild(e)), (this || _global).options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, c.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function () {
            i._showTransformModal();
          }, (this || _global).dom.transform = e, (this || _global).menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, c.Iu)("repairTitle"), (this || _global).menu.appendChild(e), !(e.onclick = function () {
            void 0 === i.json && i.executeWithBusyMessage(function () {
              try {
                i.repair();
              } catch (e) {
                i._onError(e);
              }
            }, "repairing...");
          }) !== (this || _global).options.history && ((this || _global).history = new l(function () {
            i.dom.undo.disabled = !i.history.canUndo(), i.dom.redo.disabled = !i.history.canRedo();
          }, function (e) {
            return 2 * e.text.length;
          }, s.oW), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, c.Iu)("undo"), e.onclick = function () {
            var e = i.history.undo();
            e && i._applyHistory(e);
          }, (this || _global).menu.appendChild(e), (this || _global).dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, c.Iu)("redo"), e.onclick = function () {
            var e = i.history.redo();
            e && i._applyHistory(e);
          }, (this || _global).menu.appendChild(e), (this || _global).dom.redo = e, (this || _global).history.onChange()), (this || _global).options && (this || _global).options.modes && (this || _global).options.modes.length && ((this || _global).modeSwitcher = new d.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
            try {
              i.setMode(e), i.modeSwitcher.focus();
            } catch (e) {
              i._onError(e);
            }
          }))), (this || _global).errorTable = new r.Q({
            errorTableVisible: !0,
            onToggleVisibility: function () {
              i.validate();
            },
            onFocusLine: null,
            onChangeHeight: function (e) {
              e = e + (i.dom.statusBar ? i.dom.statusBar.clientHeight : 0) + 1;
              i.content.style.marginBottom = -e + "px", i.content.style.paddingBottom = e + "px";
            }
          }), (this || _global).frame.appendChild((this || _global).content), (this || _global).frame.appendChild((this || _global).errorTable.getErrorTable()), (this || _global).container.appendChild((this || _global).frame), t.statusBar && ((0, p.addClassName)((this || _global).content, "has-status-bar"), e = document.createElement("div"), ((this || _global).dom.statusBar = e).className = "jsoneditor-statusbar", (this || _global).frame.appendChild(e), (this || _global).dom.fileSizeInfo = document.createElement("span"), (this || _global).dom.fileSizeInfo.className = "jsoneditor-size-info", (this || _global).dom.fileSizeInfo.innerText = "", e.appendChild((this || _global).dom.fileSizeInfo), (this || _global).dom.arrayInfo = document.createElement("span"), (this || _global).dom.arrayInfo.className = "jsoneditor-size-info", (this || _global).dom.arrayInfo.innerText = "", e.appendChild((this || _global).dom.arrayInfo), e.appendChild((this || _global).errorTable.getErrorCounter()), e.appendChild((this || _global).errorTable.getWarningIcon()), e.appendChild((this || _global).errorTable.getErrorIcon())), this._renderPreview(), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs);
        },
        _renderPreview: function () {
          var e = this.getText();
          (this || _global).dom.previewText.nodeValue = (0, p.limitCharacters)(e, s.WF), (this || _global).dom.fileSizeInfo && ((this || _global).dom.fileSizeInfo.innerText = "Size: " + (0, p.formatSize)(e.length)), (this || _global).dom.arrayInfo && (Array.isArray((this || _global).json) ? (this || _global).dom.arrayInfo.innerText = "Array: " + (this || _global).json.length + " items" : (this || _global).dom.arrayInfo.innerText = "");
        },
        _onChange: function () {
          if (this._debouncedValidate(), (this || _global).options.onChange) try {
            (this || _global).options.onChange();
          } catch (e) {
            console.error("Error in onChange callback: ", e);
          }
          if ((this || _global).options.onChangeJSON) try {
            (this || _global).options.onChangeJSON(this.get());
          } catch (e) {
            console.error("Error in onChangeJSON callback: ", e);
          }
          if ((this || _global).options.onChangeText) try {
            (this || _global).options.onChangeText(this.getText());
          } catch (e) {
            console.error("Error in onChangeText callback: ", e);
          }
        }
      },
          m = (t._showSortModal = function () {
        var o = this || _global;
        this.executeWithBusyMessage(function () {
          var e = o.options.modalAnchor || s.qD,
              r = o.get();
          o._renderPreview(), (0, u.showSortModal)(e, r, function (n) {
            o.executeWithBusyMessage(function () {
              var e, t, i;
              e = r, t = n, Array.isArray(e) && (i = (0, p.sort)(e, t.path, t.direction), o.sortedBy = t, o._setAndFireOnChange(i)), (0, p.isObject)(e) && (i = (0, p.sortObjectKeys)(e, t.direction), o.sortedBy = t, o._setAndFireOnChange(i));
            }, "sorting...");
          }, o.sortedBy);
        }, "parsing...");
      }, t._showTransformModal = function () {
        var o = this || _global;
        this.executeWithBusyMessage(function () {
          var e = o.options,
              t = e.createQuery,
              i = e.executeQuery,
              n = e.modalAnchor,
              e = e.queryDescription,
              r = o.get();
          o._renderPreview(), (0, g.showTransformModal)({
            container: n || s.qD,
            json: r,
            queryDescription: e,
            createQuery: t,
            executeQuery: i,
            onTransform: function (t) {
              o.executeWithBusyMessage(function () {
                var e = i(r, t);

                o._setAndFireOnChange(e);
              }, "transforming...");
            }
          });
        }, "parsing...");
      }, t.destroy = function () {
        (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && (this || _global).container.removeChild((this || _global).frame), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global)._debouncedValidate = null, (this || _global).history && ((this || _global).history.clear(), (this || _global).history = null), (this || _global).frameFocusTracker.destroy();
      }, t.compact = function () {
        var e = this.get(),
            t = JSON.stringify(e);

        this._setTextAndFireOnChange(t, e);
      }, t.format = function () {
        var e = this.get(),
            t = JSON.stringify(e, null, (this || _global).indentation);

        this._setTextAndFireOnChange(t, e);
      }, t.repair = function () {
        var e = this.getText();

        try {
          var t = n()(e);

          this._setTextAndFireOnChange(t);
        } catch (e) {}
      }, t.focus = function () {
        (this || _global).dom.transform.focus();
      }, t.set = function (e) {
        (this || _global).history && (this || _global).history.clear(), this._set(e);
      }, t.update = function (e) {
        this._set(e);
      }, t._set = function (e) {
        (this || _global).text = void 0, (this || _global).json = e, this._renderPreview(), this._pushHistory(), this._debouncedValidate();
      }, t._setAndFireOnChange = function (e) {
        this._set(e), this._onChange();
      }, t.get = function () {
        var e;
        return void 0 === (this || _global).json && (e = this.getText(), (this || _global).json = (0, p.parse)(e)), (this || _global).json;
      }, t.getText = function () {
        return void 0 === (this || _global).text && ((this || _global).text = JSON.stringify((this || _global).json, null, (this || _global).indentation), !0 === (this || _global).options.escapeUnicode && ((this || _global).text = (0, p.escapeUnicodeChars)((this || _global).text))), (this || _global).text;
      }, t.setText = function (e) {
        (this || _global).history && (this || _global).history.clear(), this._setText(e);
      }, t.updateText = function (e) {
        this.getText() !== e && this._setText(e);
      }, t._setText = function (e, t) {
        var i;
        !0 === (this || _global).options.escapeUnicode ? (this || _global).text = (0, p.escapeUnicodeChars)(e) : (this || _global).text = e, (this || _global).json = t, this._renderPreview(), void 0 === (this || _global).json ? (i = this || _global).executeWithBusyMessage(function () {
          try {
            i.json = i.get(), i._renderPreview(), i._pushHistory();
          } catch (e) {}
        }, "parsing...") : this._pushHistory(), this._debouncedValidate();
      }, t._setTextAndFireOnChange = function (e, t) {
        this._setText(e, t), this._onChange();
      }, t._applyHistory = function (e) {
        (this || _global).json = e.json, (this || _global).text = e.text, this._renderPreview(), this._debouncedValidate();
      }, t._pushHistory = function () {
        var e;
        (this || _global).history && (e = {
          text: (this || _global).text,
          json: (this || _global).json
        }, (this || _global).history.add(e));
      }, t.executeWithBusyMessage = function (e, t) {
        var i;
        this.getText().length > s.EX ? ((0, p.addClassName)((i = this || _global).frame, "busy"), i.dom.busyContent.innerText = t, setTimeout(function () {
          e(), (0, p.removeClassName)(i.frame, "busy"), i.dom.busyContent.innerText = "";
        }, 100)) : e();
      }, t.validate = i.validate, t._renderErrors = i._renderErrors, [{
        mode: "preview",
        mixin: t,
        data: "json"
      }]);
    },
    6210: function (e, t, i) {
      "use strict";

      i.r(t), i.d(t, {
        showSortModal: function () {
          return s;
        }
      });
      var t = i(483),
          n = i.n(t),
          r = i(7907),
          o = i(9791);

      function s(e, t, s, i) {
        var a = Array.isArray(t) ? (0, o.getChildPaths)(t) : [""],
            l = i && i.path && (0, o.contains)(a, i.path) ? i.path : a[0],
            c = i && i.direction || "asc",
            t = "<div class=\"pico-modal-contents\"><div class=\"pico-modal-header\">" + (0, r.Iu)("sort") + "</div><form><table><tbody><tr>  <td>" + (0, r.Iu)("sortFieldLabel") + " </td>  <td class=\"jsoneditor-modal-input\">  <div class=\"jsoneditor-select-wrapper\">    <select id=\"field\" title=\"" + (0, r.Iu)("sortFieldTitle") + "\">    </select>  </div>  </td></tr><tr>  <td>" + (0, r.Iu)("sortDirectionLabel") + " </td>  <td class=\"jsoneditor-modal-input\">  <div id=\"direction\" class=\"jsoneditor-button-group\"><input type=\"button\" value=\"" + (0, r.Iu)("sortAscending") + "\" title=\"" + (0, r.Iu)("sortAscendingTitle") + "\" data-value=\"asc\" class=\"jsoneditor-button-first jsoneditor-button-asc\"/><input type=\"button\" value=\"" + (0, r.Iu)("sortDescending") + "\" title=\"" + (0, r.Iu)("sortDescendingTitle") + "\" data-value=\"desc\" class=\"jsoneditor-button-last jsoneditor-button-desc\"/>  </div>  </td></tr><tr><td colspan=\"2\" class=\"jsoneditor-modal-input jsoneditor-modal-actions\">  <input type=\"submit\" id=\"ok\" value=\"" + (0, r.Iu)("ok") + "\" /></td></tr></tbody></table></form></div>";
        n()({
          parent: e,
          content: t,
          overlayClass: "jsoneditor-modal-overlay",
          overlayStyles: {
            backgroundColor: "rgb(1,1,1)",
            opacity: 0.3
          },
          modalClass: "jsoneditor-modal jsoneditor-modal-sort"
        }).afterCreate(function (t) {
          var e = t.modalElem().querySelector("form"),
              i = t.modalElem().querySelector("#ok"),
              n = t.modalElem().querySelector("#field"),
              r = t.modalElem().querySelector("#direction");

          function o(e) {
            r.value = e, r.className = "jsoneditor-button-group jsoneditor-button-group-value-" + r.value;
          }

          a.forEach(function (e) {
            var t,
                i = document.createElement("option");
            i.text = "" === (t = e) ? "@" : "." === t[0] ? t.slice(1) : t, i.value = e, n.appendChild(i);
          }), n.value = l || a[0], o(c || "asc"), r.onclick = function (e) {
            o(e.target.getAttribute("data-value"));
          }, i.onclick = function (e) {
            e.preventDefault(), e.stopPropagation(), t.close(), s({
              path: n.value,
              direction: r.value
            });
          }, e && (e.onsubmit = i.onclick);
        }).afterClose(function (e) {
          e.destroy();
        }).show();
      }
    },
    2558: function (e, t, i) {
      "use strict";

      i.r(t), i.d(t, {
        showTransformModal: function () {
          return s;
        }
      });
      var t = i(483),
          n = i.n(t),
          t = i(3879),
          x = i.n(t),
          r = i(7907);

      function A(e) {
        return (A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function k(e, t, i, n) {
        if ("boolean" == typeof e || e instanceof Boolean || null === e || "number" == typeof e || e instanceof Number || "string" == typeof e || e instanceof String || e instanceof Date) return JSON.stringify(e);

        if (Array.isArray(e)) {
          for (var r = e, o = t, s = i, a = n, l = o ? s + o : void 0, c = o ? "[\n" : "[", h = 0; h < r.length; h++) {
            var d = r[h];
            if (o && (c += l), c += void 0 !== d && "function" != typeof d ? k(d, o, l, a) : "null", h < r.length - 1 && (c += o ? ",\n" : ","), c.length > a) return c + "...";
          }

          return c += o ? "\n" + s + "]" : "]";
        }

        if (e && "object" === A(e)) {
          var u,
              g = e,
              p = t,
              s = i,
              m = n,
              f = p ? s + p : void 0,
              C = !0,
              I = p ? "{\n" : "{";
          if ("function" == typeof g.toJSON) return k(g.toJSON(), p, s, m);

          for (u in g) if (function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }(g, u)) {
            var v = g[u];
            if (C ? C = !1 : I += p ? ",\n" : ",", (I = (I += p ? f + "\"" + u + "\": " : "\"" + u + "\":") + k(v, p, f, m)).length > m) return I + "...";
          }

          return I += p ? "\n" + s + "}" : "}";
        }
      }

      function E(e, t) {
        for (var i = ""; 0 < t--;) i += e;

        return i;
      }

      var R = i(9791),
          T = i(4188),
          o = "Enter a <a href=\"http://jmespath.org\" target=\"_blank\">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href=\"http://jmespath.org/tutorial.html\" target=\"_blank\">the interactive tutorial</a>.";

      function s(e) {
        var t = e.container,
            A = e.json,
            i = e.queryDescription,
            i = void 0 === i ? o : i,
            b = e.createQuery,
            y = e.executeQuery,
            w = e.onTransform,
            S = A,
            e = "<label class=\"pico-modal-contents\"><div class=\"pico-modal-header\">" + (0, r.Iu)("transform") + "</div><p>" + i + "</p><div class=\"jsoneditor-jmespath-label\">" + (0, r.Iu)("transformWizardLabel") + " </div><div id=\"wizard\" class=\"jsoneditor-jmespath-block jsoneditor-jmespath-wizard\">  <table class=\"jsoneditor-jmespath-wizard-table\">    <tbody>      <tr>        <th>" + (0, r.Iu)("transformWizardFilter") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-field\" >            <select id=\"filterField\">            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-relation\" >            <select id=\"filterRelation\">              <option value=\"==\">==</option>              <option value=\"!=\">!=</option>              <option value=\"<\">&lt;</option>              <option value=\"<=\">&lt;=</option>              <option value=\">\">&gt;</option>              <option value=\">=\">&gt;=</option>            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-filter-value\" >            <input type=\"text\" class=\"value\" placeholder=\"value...\" id=\"filterValue\" />          </div>        </td>      </tr>      <tr>        <th>" + (0, r.Iu)("transformWizardSortBy") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <div class=\"jsoneditor-inline jsoneditor-jmespath-sort-field\">            <select id=\"sortField\">            </select>          </div>          <div class=\"jsoneditor-inline jsoneditor-jmespath-sort-order\" >            <select id=\"sortOrder\">              <option value=\"asc\">Ascending</option>              <option value=\"desc\">Descending</option>            </select>          </div>        </td>      </tr>      <tr id=\"selectFieldsPart\">        <th>" + (0, r.Iu)("transformWizardSelectFields") + "</th>        <td class=\"jsoneditor-jmespath-filter\">          <select class=\"jsoneditor-jmespath-select-fields\" id=\"selectFields\" multiple></select>        </td>      </tr>    </tbody>  </table></div><div class=\"jsoneditor-jmespath-label\">" + (0, r.Iu)("transformQueryLabel") + " </div><div class=\"jsoneditor-jmespath-block\">  <textarea id=\"query\"             rows=\"4\"             autocomplete=\"off\"             autocorrect=\"off\"             autocapitalize=\"off\"             spellcheck=\"false\"            title=\"" + (0, r.Iu)("transformQueryTitle") + "\">[*]</textarea></div><div class=\"jsoneditor-jmespath-label\">" + (0, r.Iu)("transformPreviewLabel") + " </div><div class=\"jsoneditor-jmespath-block\">  <textarea id=\"preview\"       class=\"jsoneditor-transform-preview\"      readonly> </textarea></div><div class=\"jsoneditor-jmespath-block jsoneditor-modal-actions\">  <input type=\"submit\" id=\"ok\" value=\"" + (0, r.Iu)("ok") + "\" autofocus /></div></div>";
        n()({
          parent: t,
          content: e,
          overlayClass: "jsoneditor-modal-overlay",
          overlayStyles: {
            backgroundColor: "rgb(1,1,1)",
            opacity: 0.3
          },
          modalClass: "jsoneditor-modal jsoneditor-modal-transform",
          focus: !1
        }).afterCreate(function (t) {
          var e = t.modalElem(),
              i = e.querySelector("#wizard"),
              o = e.querySelector("#ok"),
              r = e.querySelector("#filterField"),
              s = e.querySelector("#filterRelation"),
              a = e.querySelector("#filterValue"),
              l = e.querySelector("#sortField"),
              c = e.querySelector("#sortOrder"),
              h = e.querySelector("#selectFields"),
              d = e.querySelector("#query"),
              u = e.querySelector("#preview");
          Array.isArray(S) || (i.style.fontStyle = "italic", i.textContent = "(wizard not available for objects, only for arrays)");
          (0, R.getChildPaths)(A).forEach(function (e) {
            var e = f(e),
                t = document.createElement("option"),
                t = (t.text = e, t.value = e, r.appendChild(t), document.createElement("option"));
            t.text = e, t.value = e, l.appendChild(t);
          });
          var i = (0, R.getChildPaths)(A, !0).filter(function (e) {
            return "" !== e;
          }),
              i = (0 < i.length ? i.forEach(function (e) {
            var e = f(e),
                t = document.createElement("option");
            t.text = e, t.value = e, h.appendChild(t);
          }) : (i = e.querySelector("#selectFieldsPart")) && (i.style.display = "none"), new (x())(r, {
            defaultSelected: !1,
            clearable: !0,
            allowDeselect: !0,
            placeholder: "field..."
          })),
              n = new (x())(s, {
            defaultSelected: !1,
            clearable: !0,
            allowDeselect: !0,
            placeholder: "compare..."
          }),
              g = new (x())(l, {
            defaultSelected: !1,
            clearable: !0,
            allowDeselect: !0,
            placeholder: "field..."
          }),
              p = new (x())(c, {
            defaultSelected: !1,
            clearable: !0,
            allowDeselect: !0,
            placeholder: "order..."
          }),
              m = new (x())(h, {
            multiple: !0,
            clearable: !0,
            defaultSelected: !1,
            placeholder: "select fields..."
          });

          function f(e) {
            return "" === e ? "@" : "." === e[0] ? e.slice(1) : e;
          }

          i.on("selectr.change", v), n.on("selectr.change", v), a.oninput = v, g.on("selectr.change", v), p.on("selectr.change", v), m.on("selectr.change", v), e.querySelector(".pico-modal-contents").onclick = function (e) {
            "A" !== e.target.nodeName && e.preventDefault();
          };
          var C = (0, R.debounce)(function () {
            try {
              var e = y(S, d.value);
              u.className = "jsoneditor-transform-preview", u.value = (t = e, i = 2, n = T.WF, "number" == typeof i ? 10 < i ? r = E(" ", 10) : 1 <= i && (r = E(" ", i)) : "string" == typeof i && "" !== i && (r = i), (i = k(t, r, "", n)).length > n ? (t = i, ("number" == typeof (r = n) ? t.slice(0, r) : t) + "...") : i), o.disabled = !1;
            } catch (e) {
              u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = e.toString(), o.disabled = !0;
            }

            var t, i, n, r;
          }, 300);

          function I(t, e) {
            try {
              d.value = b(t, e), o.disabled = !1, C();
            } catch (e) {
              t = "Error: an error happened when executing \"createQuery\": " + (e.message || e.toString());
              d.value = "", o.disabled = !0, u.className = "jsoneditor-transform-preview jsoneditor-error", u.value = t;
            }
          }

          function v() {
            var e = {};

            if (r.value && s.value && a.value && (e.filter = {
              field: r.value,
              relation: s.value,
              value: a.value
            }), l.value && c.value && (e.sort = {
              field: l.value,
              direction: c.value
            }), h.value) {
              for (var t, i = [], n = 0; n < h.options.length; n++) h.options[n].selected && (t = h.options[n].value, i.push(t));

              e.projection = {
                fields: i
              };
            }

            I(A, e);
          }

          d.oninput = C, o.onclick = function (e) {
            e.preventDefault(), e.stopPropagation(), t.close(), w(d.value);
          }, I(A, {}), setTimeout(function () {
            d.select(), d.focus(), d.selectionStart = 3, d.selectionEnd = 3;
          });
        }).afterClose(function (e) {
          e.destroy();
        }).show();
      }
    },
    5956: function (e, t, i) {
      "use strict";

      i.r(t), i.d(t, {
        textModeMixins: function () {
          return s;
        }
      });
      var t = i(3860),
          n = i.n(t),
          t = i(8170),
          l = i.n(t),
          a = i(4188),
          c = i(6436),
          h = i(2474),
          d = i(7907),
          u = i(6056),
          g = i(6617),
          r = i(6210),
          p = i(2558),
          m = i(9125),
          f = i(9791);

      function C(e) {
        return (C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      var t = {},
          I = "ace/theme/jsoneditor";

      function o() {
        try {
          this.format();
        } catch (e) {}
      }

      t.create = function (e) {
        var t,
            i,
            n,
            r = this || _global,
            o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
            s = (void 0 === o.statusBar && (o.statusBar = !0), o.mainMenuBar = !1 !== o.mainMenuBar, o.enableSort = !1 !== o.enableSort, o.enableTransform = !1 !== o.enableTransform, o.createQuery = o.createQuery || u.r, o.executeQuery = o.executeQuery || u.J, "number" == typeof ((this || _global).options = o).indentation ? (this || _global).indentation = Number(o.indentation) : (this || _global).indentation = 2, (0, d.cC)((this || _global).options.languages), (0, d.m0)((this || _global).options.language), o.ace || l()),
            a = ((this || _global).mode = "code" === o.mode ? "code" : "text", "code" === (this || _global).mode && void 0 === s && ((this || _global).mode = "text", console.warn("Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.")), (this || _global).theme = o.theme || I, (this || _global).theme === I && s && (0, m.O)(), o.onTextSelectionChange && this.onTextSelectionChange(o.onTextSelectionChange), this || _global),
            e = ((this || _global).container = e, (this || _global).dom = {}, (this || _global).aceEditor = void 0, (this || _global).textarea = void 0, (this || _global).validateSchema = null, (this || _global).annotations = [], (this || _global).lastSchemaErrors = void 0, (this || _global)._debouncedValidate = (0, f.debounce)((this || _global)._validateAndCatch.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), (this || _global).width = e.clientWidth, (this || _global).height = e.clientHeight, (this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-" + (this || _global).options.mode, (this || _global).frame.onclick = function (e) {
          e.preventDefault();
        }, (this || _global).frame.onkeydown = function (e) {
          a._onKeyDown(e);
        }, {
          target: (this || _global).frame,
          onFocus: (this || _global).options.onFocus || null,
          onBlur: (this || _global).options.onBlur || null
        }),
            e = ((this || _global).frameFocusTracker = new h.R(e), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-outer", (this || _global).options.mainMenuBar && ((0, f.addClassName)((this || _global).content, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-format", e.title = (0, d.Iu)("formatTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
          try {
            a.format(), a._onChange();
          } catch (e) {
            a._onError(e);
          }
        }, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-compact", e.title = (0, d.Iu)("compactTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
          try {
            a.compact(), a._onChange();
          } catch (e) {
            a._onError(e);
          }
        }, (this || _global).options.enableSort && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-sort", e.title = (0, d.Iu)("sortTitleShort"), e.onclick = function () {
          a._showSortModal();
        }, (this || _global).menu.appendChild(e)), (this || _global).options.enableTransform && ((e = document.createElement("button")).type = "button", e.title = (0, d.Iu)("transformTitleShort"), e.className = "jsoneditor-transform", e.onclick = function () {
          a._showTransformModal();
        }, (this || _global).menu.appendChild(e)), (e = document.createElement("button")).type = "button", e.className = "jsoneditor-repair", e.title = (0, d.Iu)("repairTitle"), (this || _global).menu.appendChild(e), e.onclick = function () {
          try {
            a.repair(), a._onChange();
          } catch (e) {
            a._onError(e);
          }
        }, "code" === (this || _global).mode && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, d.Iu)("undo"), e.onclick = function () {
          r.aceEditor.getSession().getUndoManager().undo();
        }, (this || _global).menu.appendChild(e), (this || _global).dom.undo = e, (e = document.createElement("button")).type = "button", e.className = "jsoneditor-redo", e.title = (0, d.Iu)("redo"), e.onclick = function () {
          r.aceEditor.getSession().getUndoManager().redo();
        }, (this || _global).menu.appendChild(e), (this || _global).dom.redo = e), (this || _global).options && (this || _global).options.modes && (this || _global).options.modes.length && ((this || _global).modeSwitcher = new g.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
          try {
            a.setMode(e), a.modeSwitcher.focus();
          } catch (e) {
            a._onError(e);
          }
        })), "code" === (this || _global).mode && ((t = document.createElement("a")).appendChild(document.createTextNode("powered by ace")), t.href = "https://ace.c9.io/", t.target = "_blank", t.className = "jsoneditor-poweredBy", t.onclick = function () {
          window.open(t.href, t.target, "noreferrer");
        }, (this || _global).menu.appendChild(t))), (this || _global).options.onEditable && C("function" === (this || _global).options.onEditable) && !(this || _global).options.onEditable({}));
        (this || _global).frame.appendChild((this || _global).content), (this || _global).container.appendChild((this || _global).frame), "code" === (this || _global).mode ? ((this || _global).editorDom = document.createElement("div"), (this || _global).editorDom.style.height = "100%", (this || _global).editorDom.style.width = "100%", (this || _global).content.appendChild((this || _global).editorDom), n = (s = s.edit((this || _global).editorDom)).getSession(), s.$blockScrolling = 1 / 0, s.setTheme((this || _global).theme), s.setOptions({
          readOnly: e
        }), s.setShowPrintMargin(!1), s.setFontSize("14px"), n.setMode("ace/mode/json"), n.setTabSize((this || _global).indentation), n.setUseSoftTabs(!0), n.setUseWrapMode(!0), i = n.setAnnotations, n.setAnnotations = function (e) {
          i.call(this || _global, e && e.length ? e : a.annotations);
        }, s.commands.bindKey("Ctrl-L", null), s.commands.bindKey("Command-L", null), s.commands.bindKey("Ctrl-\\", null), s.commands.bindKey("Command-\\", null), s.commands.bindKey("Ctrl-Shift-\\", null), s.commands.bindKey("Command-Shift-\\", null), ((this || _global).aceEditor = s).on("change", (this || _global)._onChange.bind(this || _global)), s.on("changeSelection", (this || _global)._onSelect.bind(this || _global))) : ((n = document.createElement("textarea")).className = "jsoneditor-text", n.spellcheck = !1, (this || _global).content.appendChild(n), (this || _global).textarea = n, (this || _global).textarea.readOnly = e, null === (this || _global).textarea.oninput ? (this || _global).textarea.oninput = (this || _global)._onChange.bind(this || _global) : (this || _global).textarea.onchange = (this || _global)._onChange.bind(this || _global), n.onselect = (this || _global)._onSelect.bind(this || _global), n.onmousedown = (this || _global)._onMouseDown.bind(this || _global), n.onblur = (this || _global)._onBlur.bind(this || _global)), this._updateHistoryButtons(), (this || _global).errorTable = new c.Q({
          errorTableVisible: "text" === (this || _global).mode,
          onToggleVisibility: function () {
            a._validateAndCatch();
          },
          onFocusLine: function (e) {
            a.isFocused = !0, isNaN(e) || a.setTextSelection({
              row: e,
              column: 1
            }, {
              row: e,
              column: 1000
            });
          },
          onChangeHeight: function (e) {
            e = e + (a.dom.statusBar ? a.dom.statusBar.clientHeight : 0) + 1;
            a.content.style.marginBottom = -e + "px", a.content.style.paddingBottom = e + "px";
          }
        }), (this || _global).frame.appendChild((this || _global).errorTable.getErrorTable()), o.statusBar && ((0, f.addClassName)((this || _global).content, "has-status-bar"), (this || _global).curserInfoElements = {}, s = document.createElement("div"), ((this || _global).dom.statusBar = s).className = "jsoneditor-statusbar", (this || _global).frame.appendChild(s), (e = document.createElement("span")).className = "jsoneditor-curserinfo-label", e.innerText = "Ln:", (n = document.createElement("span")).className = "jsoneditor-curserinfo-val", n.innerText = "1", s.appendChild(e), s.appendChild(n), (o = document.createElement("span")).className = "jsoneditor-curserinfo-label", o.innerText = "Col:", (e = document.createElement("span")).className = "jsoneditor-curserinfo-val", e.innerText = "1", s.appendChild(o), s.appendChild(e), (this || _global).curserInfoElements.colVal = e, (this || _global).curserInfoElements.lnVal = n, (o = document.createElement("span")).className = "jsoneditor-curserinfo-label", o.innerText = "characters selected", o.style.display = "none", (e = document.createElement("span")).className = "jsoneditor-curserinfo-count", e.innerText = "0", e.style.display = "none", (this || _global).curserInfoElements.countLabel = o, (this || _global).curserInfoElements.countVal = e, s.appendChild(e), s.appendChild(o), s.appendChild((this || _global).errorTable.getErrorCounter()), s.appendChild((this || _global).errorTable.getWarningIcon()), s.appendChild((this || _global).errorTable.getErrorIcon())), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs);
      }, t._onChange = function () {
        var e = this || _global;

        if (!(this || _global).onChangeDisabled) {
          if (setTimeout(function () {
            e._updateHistoryButtons && e._updateHistoryButtons();
          }), this._debouncedValidate(), (this || _global).options.onChange) try {
            (this || _global).options.onChange();
          } catch (e) {
            console.error("Error in onChange callback: ", e);
          }
          if ((this || _global).options.onChangeText) try {
            (this || _global).options.onChangeText(this.getText());
          } catch (e) {
            console.error("Error in onChangeText callback: ", e);
          }
        }
      }, t._updateHistoryButtons = function () {
        var e;
        (this || _global).aceEditor && (this || _global).dom.undo && (this || _global).dom.redo && (e = (this || _global).aceEditor.getSession().getUndoManager()) && e.hasUndo && e.hasRedo && ((this || _global).dom.undo.disabled = !e.hasUndo(), (this || _global).dom.redo.disabled = !e.hasRedo());
      }, t._showSortModal = function () {
        try {
          var i = this || _global,
              e = (this || _global).options.modalAnchor || a.qD,
              n = this.get();
          (0, r.showSortModal)(e, n, function (e) {
            var t;
            Array.isArray(n) && (t = (0, f.sort)(n, e.path, e.direction), i.sortedBy = e, i.update(t)), (0, f.isObject)(n) && (t = (0, f.sortObjectKeys)(n, e.direction), i.sortedBy = e, i.update(t));
          }, i.sortedBy);
        } catch (e) {
          this._onError(e);
        }
      }, t._showTransformModal = function () {
        var t = this || _global;

        try {
          var e = (this || _global).options,
              i = e.modalAnchor,
              n = e.createQuery,
              r = e.executeQuery,
              o = e.queryDescription,
              s = this.get();
          (0, p.showTransformModal)({
            container: i || a.qD,
            json: s,
            queryDescription: o,
            createQuery: n,
            executeQuery: r,
            onTransform: function (e) {
              e = r(s, e);
              t.update(e);
            }
          });
        } catch (e) {
          this._onError(e);
        }
      }, t._onSelect = function () {
        this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onKeyDown = function (e) {
        var t = !1;
        73 === (e.which || e.keyCode) && e.ctrlKey && (e.shiftKey ? this.compact() : this.format(), this._onChange(), t = !0), t && (e.preventDefault(), e.stopPropagation()), this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onMouseDown = function () {
        this._updateCursorInfo(), this._emitSelectionChange();
      }, t._onBlur = function () {
        var e = this || _global;
        setTimeout(function () {
          e.isFocused || (e._updateCursorInfo(), e._emitSelectionChange()), e.isFocused = !1;
        });
      }, t._updateCursorInfo = function () {
        var e,
            t,
            i,
            n,
            r,
            o = this || _global;

        function s() {
          o.curserInfoElements.countVal.innerText !== r && (o.curserInfoElements.countVal.innerText = r, o.curserInfoElements.countVal.style.display = r ? "inline" : "none", o.curserInfoElements.countLabel.style.display = r ? "inline" : "none"), o.curserInfoElements.lnVal.innerText = i, o.curserInfoElements.colVal.innerText = n;
        }

        (this || _global).textarea ? setTimeout(function () {
          var e = (0, f.getInputSelection)(o.textarea);
          e.startIndex !== e.endIndex && (r = e.endIndex - e.startIndex), n = r && o.cursorInfo && o.cursorInfo.line === e.end.row && o.cursorInfo.column === e.end.column ? (i = e.start.row, e.start.column) : (i = e.end.row, e.end.column), o.cursorInfo = {
            line: i,
            column: n,
            count: r
          }, o.options.statusBar && s();
        }, 0) : (this || _global).aceEditor && (this || _global).curserInfoElements && (e = (this || _global).aceEditor.getCursorPosition(), t = (this || _global).aceEditor.getSelectedText(), i = e.row + 1, n = e.column + 1, r = t.length, o.cursorInfo = {
          line: i,
          column: n,
          count: r
        }, (this || _global).options.statusBar && s());
      }, t._emitSelectionChange = function () {
        var e;
        (this || _global)._selectionChangedHandler && (e = this.getTextSelection(), this._selectionChangedHandler(e.start, e.end, e.text));
      }, t._refreshAnnotations = function () {
        var e,
            t = (this || _global).aceEditor && (this || _global).aceEditor.getSession();

        t && (e = t.getAnnotations().filter(function (e) {
          return "error" === e.type;
        }), t.setAnnotations(e));
      }, t.destroy = function () {
        (this || _global).aceEditor && ((this || _global).aceEditor.destroy(), (this || _global).aceEditor = null), (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && (this || _global).container.removeChild((this || _global).frame), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global).textarea = null, (this || _global)._debouncedValidate = null, (this || _global).frameFocusTracker.destroy();
      }, t.compact = function () {
        var e = this.get(),
            e = JSON.stringify(e);
        this.updateText(e);
      }, t.format = function () {
        var e = this.get(),
            e = JSON.stringify(e, null, (this || _global).indentation);
        this.updateText(e);
      }, t.repair = function () {
        var e = this.getText();

        try {
          var t = n()(e);
          this.updateText(t);
        } catch (e) {}
      }, t.focus = function () {
        (this || _global).textarea && (this || _global).textarea.focus(), (this || _global).aceEditor && (this || _global).aceEditor.focus();
      }, t.resize = function () {
        (this || _global).aceEditor && (this || _global).aceEditor.resize(!1);
      }, t.set = function (e) {
        this.setText(JSON.stringify(e, null, (this || _global).indentation));
      }, t.update = function (e) {
        this.updateText(JSON.stringify(e, null, (this || _global).indentation));
      }, t.get = function () {
        var e = this.getText();
        return (0, f.parse)(e);
      }, t.getText = function () {
        return (this || _global).textarea ? (this || _global).textarea.value : (this || _global).aceEditor ? (this || _global).aceEditor.getValue() : "";
      }, t._setText = function (e, t) {
        var i,
            n = this || _global,
            e = !0 === (this || _global).options.escapeUnicode ? (0, f.escapeUnicodeChars)(e) : e;
        (this || _global).textarea && ((this || _global).textarea.value = e), (this || _global).aceEditor && ((this || _global).onChangeDisabled = !0, (this || _global).aceEditor.setValue(e, -1), (this || _global).onChangeDisabled = !1, t && (i = this || _global, setTimeout(function () {
          i.aceEditor && i.aceEditor.session.getUndoManager().reset();
        })), setTimeout(function () {
          n._updateHistoryButtons && n._updateHistoryButtons();
        })), this._debouncedValidate();
      }, t.setText = function (e) {
        this._setText(e, !0);
      }, t.updateText = function (e) {
        this.getText() !== e && this._setText(e, !1);
      }, t.validate = function () {
        var t,
            i = this || _global,
            n = [],
            r = [];

        try {
          var o = this.get(),
              s = ((this || _global).validateSchema && !this.validateSchema(o) && (n = (this || _global).validateSchema.errors.map(function (e) {
            return e.type = "validation", (0, f.improveSchemaError)(e);
          })), (this || _global).validationSequence = ((this || _global).validationSequence || 0) + 1, this || _global),
              a = (this || _global).validationSequence;
          return function (e, t) {
            if (!t) return Promise.resolve([]);

            try {
              var i = t(e);
              return ((0, f.isPromise)(i) ? i : Promise.resolve(i)).then(function (e) {
                return Array.isArray(e) ? e.filter(function (e) {
                  var t = (0, f.isValidValidationError)(e);
                  return t || console.warn("Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: \"...\"}. Actual error:", e), t;
                }).map(function (e) {
                  return {
                    dataPath: (0, f.stringifyPath)(e.path),
                    message: e.message,
                    type: "customValidation"
                  };
                }) : [];
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }(o, (this || _global).options.onValidate).then(function (e) {
            return a === s.validationSequence && (e = n.concat(r).concat(e), s._renderErrors(e), "function" == typeof i.options.onValidationError && (0, f.isValidationErrorChanged)(e, i.lastSchemaErrors) && i.options.onValidationError.call(i, e), i.lastSchemaErrors = e), i.lastSchemaErrors;
          });
        } catch (e) {
          return this.getText() && ((o = /\w*line\s*(\d+)\w*/g.exec(e.message)) && (t = +o[1]), r = [{
            type: "error",
            message: e.message.replace(/\n/g, "<br>"),
            line: t
          }]), this._renderErrors(r), "function" == typeof (this || _global).options.onValidationError && (0, f.isValidationErrorChanged)(r, (this || _global).lastSchemaErrors) && (this || _global).options.onValidationError.call(this || _global, r), (this || _global).lastSchemaErrors = r, Promise.resolve((this || _global).lastSchemaErrors);
        }
      }, t._validateAndCatch = function () {
        this.validate().catch(function (e) {
          console.error("Error running validation:", e);
        });
      }, t._renderErrors = function (n) {
        var e = this.getText(),
            t = [],
            e = (n.reduce(function (e, t) {
          return "string" == typeof t.dataPath && -1 === e.indexOf(t.dataPath) && e.push(t.dataPath), e;
        }, t), (0, f.getPositionForPath)(e, t));
        (this || _global).aceEditor && ((this || _global).annotations = e.map(function (t) {
          var e = n.filter(function (e) {
            return e.dataPath === t.path;
          }),
              i = e.map(function (e) {
            return e.message;
          }).join("\n");
          return i ? {
            row: t.line,
            column: t.column,
            text: "Schema validation error" + (1 !== e.length ? "s" : "") + ": \n" + i,
            type: "warning",
            source: "jsoneditor"
          } : {};
        }), this._refreshAnnotations()), (this || _global).errorTable.setErrors(n, e), (this || _global).aceEditor && (this || _global).aceEditor.resize(!1);
      }, t.getTextSelection = function () {
        var e,
            t,
            i,
            n = {};
        return (this || _global).textarea ? (i = (0, f.getInputSelection)((this || _global).textarea), (this || _global).cursorInfo && (this || _global).cursorInfo.line === i.end.row && (this || _global).cursorInfo.column === i.end.column ? (n.start = i.end, n.end = i.start) : n = i, {
          start: n.start,
          end: n.end,
          text: (this || _global).textarea.value.substring(i.startIndex, i.endIndex)
        }) : (this || _global).aceEditor ? (i = (this || _global).aceEditor.getSelection(), e = (this || _global).aceEditor.getSelectedText(), t = i.getRange(), (i = i.getSelectionLead()).row === t.end.row && i.column === t.end.column ? n = t : (n.start = t.end, n.end = t.start), {
          start: {
            row: n.start.row + 1,
            column: n.start.column + 1
          },
          end: {
            row: n.end.row + 1,
            column: n.end.column + 1
          },
          text: e
        }) : void 0;
      }, t.onTextSelectionChange = function (e) {
        "function" == typeof e && ((this || _global)._selectionChangedHandler = (0, f.debounce)(e, (this || _global).DEBOUNCE_INTERVAL));
      }, t.setTextSelection = function (e, t) {
        var i, n, r;
        e && t && ((this || _global).textarea ? (i = (0, f.getIndexForPosition)((this || _global).textarea, e.row, e.column), r = (0, f.getIndexForPosition)((this || _global).textarea, t.row, t.column), -1 < i && -1 < r && ((this || _global).textarea.setSelectionRange ? ((this || _global).textarea.focus(), (this || _global).textarea.setSelectionRange(i, r)) : (this || _global).textarea.createTextRange && ((n = (this || _global).textarea.createTextRange()).collapse(!0), n.moveEnd("character", r), n.moveStart("character", i), n.select()), r = ((this || _global).textarea.value.match(/\n/g) || []).length + 1, i = (this || _global).textarea.scrollHeight / r, n = e.row * i, (this || _global).textarea.scrollTop = n > (this || _global).textarea.clientHeight ? n - (this || _global).textarea.clientHeight / 2 : 0)) : (this || _global).aceEditor && (r = {
          start: {
            row: e.row - 1,
            column: e.column - 1
          },
          end: {
            row: t.row - 1,
            column: t.column - 1
          }
        }, (this || _global).aceEditor.selection.setRange(r), (this || _global).aceEditor.scrollToLine(e.row - 1, !0)));
      };
      var s = [{
        mode: "text",
        mixin: t,
        data: "text",
        load: o
      }, {
        mode: "code",
        mixin: t,
        data: "text",
        load: o
      }];
    },
    8038: function (G, e, t) {
      "use strict";

      t.r(e), t.d(e, {
        treeModeMixins: function () {
          return V;
        }
      });
      var w = {
        start: function (e, t, i) {
          return 0 === t.indexOf(e);
        },
        contain: function (e, t, i) {
          return -1 < t.indexOf(e);
        }
      };
      var s = t(897),
          a = t(2474);

      function r(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var S = function () {
        function e() {
          if (!((this || _global) instanceof e)) throw new TypeError("Cannot call a class as a function");
          (this || _global).locked = !1;
        }

        var t, i, n;
        return t = e, (i = [{
          key: "highlight",
          value: function (e) {
            (this || _global).locked || ((this || _global).node !== e && ((this || _global).node && (this || _global).node.setHighlight(!1), (this || _global).node = e, (this || _global).node.setHighlight(!0)), this._cancelUnhighlight());
          }
        }, {
          key: "unhighlight",
          value: function () {
            var e;
            (this || _global).locked || (e = this || _global).node && (this._cancelUnhighlight(), (this || _global).unhighlightTimer = setTimeout(function () {
              e.node.setHighlight(!1), e.node = void 0, e.unhighlightTimer = void 0;
            }, 0));
          }
        }, {
          key: "_cancelUnhighlight",
          value: function () {
            (this || _global).unhighlightTimer && (clearTimeout((this || _global).unhighlightTimer), (this || _global).unhighlightTimer = void 0);
          }
        }, {
          key: "lock",
          value: function () {
            (this || _global).locked = !0;
          }
        }, {
          key: "unlock",
          value: function () {
            (this || _global).locked = !1;
          }
        }]) && r(t.prototype, i), n && r(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }(),
          l = t(7907),
          n = t(6056),
          c = t(6617),
          e = t(233),
          o = t.n(e),
          h = t(2602),
          k = t(9791);

      var d = t(6210),
          u = t(2558),
          g = t(4188);

      function x(e) {
        return function (e) {
          if (Array.isArray(e)) return m(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || p(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function E(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

          if (null != i) {
            var n,
                r,
                o = [],
                s = !0,
                a = !1;

            try {
              for (i = i.call(e); !(s = (n = i.next()).done) && (o.push(n.value), !t || o.length !== t); s = !0);
            } catch (e) {
              a = !0, r = e;
            } finally {
              try {
                s || null == i.return || i.return();
              } finally {
                if (a) throw r;
              }
            }

            return o;
          }
        }(e, t) || p(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      function R(e, t) {
        var i,
            n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (!n) {
          if (Array.isArray(e) || (n = p(e)) || t && e && "number" == typeof e.length) return n && (e = n), i = 0, {
            s: t = function () {},
            n: function () {
              return i >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[i++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: t
          };
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        var r,
            o = !0,
            s = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return o = e.done, e;
          },
          e: function (e) {
            s = !0, r = e;
          },
          f: function () {
            try {
              o || null == n.return || n.return();
            } finally {
              if (s) throw r;
            }
          }
        };
      }

      function p(e, t) {
        if (e) {
          if ("string" == typeof e) return m(e, t);
          var i = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (i = "Object" === i && e.constructor ? e.constructor.name : i) || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? m(e, t) : void 0;
        }
      }

      function m(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];

        return n;
      }

      function T(e) {
        return (T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function f(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var _ = function () {
        function x(e, t) {
          if (!((this || _global) instanceof x)) throw new TypeError("Cannot call a class as a function");
          (this || _global).editor = e, (this || _global).dom = {}, (this || _global).expanded = !1, t && t instanceof Object ? (this.setField(t.field, t.fieldEditable), "value" in t && this.setValue(t.value, t.type), "internalValue" in t && this.setInternalValue(t.internalValue)) : (this.setField(""), this.setValue(null)), (this || _global)._debouncedOnChangeValue = (0, k.debounce)((this || _global)._onChangeValue.bind(this || _global), x.prototype.DEBOUNCE_INTERVAL), (this || _global)._debouncedOnChangeField = (0, k.debounce)((this || _global)._onChangeField.bind(this || _global), x.prototype.DEBOUNCE_INTERVAL), (this || _global).visibleChilds = this.getMaxVisibleChilds();
        }

        var e, t, i;
        return e = x, (t = [{
          key: "getMaxVisibleChilds",
          value: function () {
            return (this || _global).editor && (this || _global).editor.options && (this || _global).editor.options.maxVisibleChilds ? (this || _global).editor.options.maxVisibleChilds : C;
          }
        }, {
          key: "_updateEditability",
          value: function () {
            var e, t;
            (this || _global).editable = {
              field: !0,
              value: !0
            }, (this || _global).editor && ((this || _global).editable.field = "tree" === (this || _global).editor.options.mode, (this || _global).editable.value = "view" !== (this || _global).editor.options.mode, "tree" !== (this || _global).editor.options.mode && "form" !== (this || _global).editor.options.mode || "function" != typeof (this || _global).editor.options.onEditable || (e = (this || _global).getValue.bind(this || _global), "boolean" == typeof (t = (this || _global).editor.options.onEditable({
              field: (this || _global).field,

              get value() {
                return e();
              },

              path: this.getPath()
            })) ? ((this || _global).editable.field = t, (this || _global).editable.value = t) : "object" === T(t) && null !== t ? ("boolean" == typeof t.field && ((this || _global).editable.field = t.field), "boolean" == typeof t.value && ((this || _global).editable.value = t.value)) : (console.error("Invalid return value for function onEditable.", "Actual value:", t, ".", "Either a boolean or object { field: boolean, value: boolean } expected."), (this || _global).editable.field = !1, (this || _global).editable.value = !1)));
          }
        }, {
          key: "getPath",
          value: function () {
            for (var e = this || _global, t = []; e;) {
              var i = e.getName();
              void 0 !== i && t.unshift(i), e = e.parent;
            }

            return t;
          }
        }, {
          key: "getInternalPath",
          value: function () {
            for (var e = this || _global, t = []; e;) e.parent && t.unshift(e.getIndex()), e = e.parent;

            return t;
          }
        }, {
          key: "getName",
          value: function () {
            return (this || _global).parent ? "array" !== (this || _global).parent.type ? (this || _global).field : (this || _global).index : void 0;
          }
        }, {
          key: "findNodeByPath",
          value: function (e) {
            if (e) {
              if (0 === e.length) return this || _global;
              if (e.length && (this || _global).childs && (this || _global).childs.length) for (var t = 0; t < (this || _global).childs.length; ++t) if ("" + e[0] == "" + (this || _global).childs[t].getName()) return (this || _global).childs[t].findNodeByPath(e.slice(1));
            }
          }
        }, {
          key: "findNodeByInternalPath",
          value: function (e) {
            if (e) {
              for (var t = this || _global, i = 0; i < e.length && t; i++) var n = e[i], t = t.childs[n];

              return t;
            }
          }
        }, {
          key: "serialize",
          value: function () {
            return {
              value: this.getValue(),
              path: this.getPath()
            };
          }
        }, {
          key: "findNode",
          value: function (e) {
            for (var i = (0, k.parsePath)(e), n = this || _global; n && 0 < i.length;) !function () {
              var t = i.shift();

              if ("number" == typeof t) {
                if ("array" !== n.type) throw new Error("Cannot get child node at index " + t + ": node is no array");
                n = n.childs[t];
              } else {
                if ("object" !== n.type) throw new Error("Cannot get child node " + t + ": node is no object");
                n = n.childs.filter(function (e) {
                  return e.field === t;
                })[0];
              }
            }();

            return n;
          }
        }, {
          key: "findParents",
          value: function () {
            for (var e = [], t = (this || _global).parent; t;) e.unshift(t), t = t.parent;

            return e;
          }
        }, {
          key: "setError",
          value: function (e, t) {
            (this || _global).error = e, (this || _global).errorChild = t, (this || _global).dom && (this || _global).dom.tr && this.updateError();
          }
        }, {
          key: "updateError",
          value: function () {
            var i = this || _global,
                n = (this || _global).fieldError || (this || _global).valueError || (this || _global).error,
                e = (this || _global).dom.tdError;

            if (n && (this || _global).dom && (this || _global).dom.tr) {
              (0, k.addClassName)((this || _global).dom.tr, "jsoneditor-validation-error"), e || (e = document.createElement("td"), (this || _global).dom.tdError = e, (this || _global).dom.tdValue.parentNode.appendChild(e));

              var r = document.createElement("button"),
                  t = (r.type = "button", r.className = "jsoneditor-button jsoneditor-schema-error", function () {
                i.dom.popupAnchor && i.dom.popupAnchor.destroy();
              }),
                  o = function () {
                delete i.dom.popupAnchor;
              },
                  s = function (e) {
                var t = i.editor.frame,
                    e = (i.dom.popupAnchor = (0, h.w)(r, i.editor.getPopupAnchor(), o, e), r.getBoundingClientRect()),
                    t = 120 < t.getBoundingClientRect().width - e.x ? "jsoneditor-above" : "jsoneditor-left",
                    e = document.createElement("div");
                e.className = "jsoneditor-popover " + t, e.appendChild(document.createTextNode(n.message)), i.dom.popupAnchor.appendChild(e);
              },
                  a = (r.onmouseover = function () {
                i.dom.popupAnchor || s(!0);
              }, r.onfocus = function () {
                t(), s(!1);
              }, r.onblur = function () {
                t();
              }, (this || _global).errorChild);

              for (a && (r.onclick = function () {
                a.findParents().forEach(function (e) {
                  e.expand(!1);
                }), a.scrollTo(function () {
                  a.focus();
                });
              }); e.firstChild;) e.removeChild(e.firstChild);

              e.appendChild(r);
            } else (this || _global).dom.tr && (0, k.removeClassName)((this || _global).dom.tr, "jsoneditor-validation-error"), e && ((this || _global).dom.tdError.parentNode.removeChild((this || _global).dom.tdError), delete (this || _global).dom.tdError);
          }
        }, {
          key: "getIndex",
          value: function () {
            var e;
            return (this || _global).parent ? -1 !== (e = (this || _global).parent.childs.indexOf(this || _global)) ? e : null : -1;
          }
        }, {
          key: "setParent",
          value: function (e) {
            (this || _global).parent = e;
          }
        }, {
          key: "setField",
          value: function (e, t) {
            (this || _global).field = e, (this || _global).previousField = e, (this || _global).fieldEditable = !0 === t;
          }
        }, {
          key: "getField",
          value: function () {
            return void 0 === (this || _global).field && this._getDomField(), (this || _global).field;
          }
        }, {
          key: "setValue",
          value: function (e, t) {
            var i,
                n,
                r,
                o,
                s,
                a,
                l = (this || _global).childs;

            if ((this || _global).type = this._getType(e), t && t !== (this || _global).type) {
              if ("string" !== t || "auto" !== (this || _global).type) throw new Error("Type mismatch: cannot cast value of type \"" + (this || _global).type + " to the specified type \"" + t + "\"");
              (this || _global).type = t;
            }

            if ("array" === (this || _global).type) {
              for ((this || _global).childs || ((this || _global).childs = []), i = 0; i < e.length; i++) void 0 === (s = e[i]) || s instanceof Function || (i < (this || _global).childs.length ? ((r = (this || _global).childs[i]).fieldEditable = !1, r.index = i, r.setValue(s)) : (r = new x((this || _global).editor, {
                value: s
              }), o = i < this.getMaxVisibleChilds(), this.appendChild(r, o, !1)));

              for (n = (this || _global).childs.length; n >= e.length; n--) this.removeChild((this || _global).childs[n], !1);
            } else if ("object" === (this || _global).type) {
              for ((this || _global).childs || ((this || _global).childs = []), n = (this || _global).childs.length - 1; 0 <= n; n--) v(e, (this || _global).childs[n].field) || this.removeChild((this || _global).childs[n], !1);

              for (var c in i = 0, e) v(e, c) && (void 0 === (s = e[c]) || s instanceof Function || ((a = this.findChildByProperty(c)) ? (a.setField(c, !0), a.setValue(s)) : (a = new x((this || _global).editor, {
                field: c,
                value: s
              }), c = i < this.getMaxVisibleChilds(), this.appendChild(a, c, !1))), i++);

              !((this || _global).value = "") === (this || _global).editor.options.sortObjectKeys && this.sort([], "asc", !1);
            } else this.hideChilds(), delete (this || _global).append, delete (this || _global).showMore, delete (this || _global).expanded, delete (this || _global).childs, (this || _global).value = e;

            Array.isArray(l) !== Array.isArray((this || _global).childs) && this.recreateDom(), this.updateDom({
              updateIndexes: !0
            }), (this || _global).previousValue = (this || _global).value;
          }
        }, {
          key: "setInternalValue",
          value: function (e) {
            var t,
                i,
                n,
                r,
                o,
                s = (this || _global).childs;

            if ((this || _global).type = e.type, "array" === e.type) {
              for ((this || _global).childs || ((this || _global).childs = []), r = 0; r < e.childs.length; r++) void 0 === (t = e.childs[r]) || t instanceof Function || (r < (this || _global).childs.length ? ((i = (this || _global).childs[r]).fieldEditable = !1, i.index = r, i.setInternalValue(t)) : (i = new x((this || _global).editor, {
                internalValue: t
              }), n = r < this.getMaxVisibleChilds(), this.appendChild(i, n, !1)));

              for (o = (this || _global).childs.length; o >= e.childs.length; o--) this.removeChild((this || _global).childs[o], !1);
            } else if ("object" === e.type) {
              for ((this || _global).childs || ((this || _global).childs = []), r = 0; r < e.childs.length; r++) void 0 === (t = e.childs[r]) || t instanceof Function || (r < (this || _global).childs.length ? (delete (i = (this || _global).childs[r]).index, i.setField(t.field, !0), i.setInternalValue(t.value)) : (i = new x((this || _global).editor, {
                field: t.field,
                internalValue: t.value
              }), n = r < this.getMaxVisibleChilds(), this.appendChild(i, n, !1)));

              for (o = (this || _global).childs.length; o >= e.childs.length; o--) this.removeChild((this || _global).childs[o], !1);
            } else this.hideChilds(), delete (this || _global).append, delete (this || _global).showMore, delete (this || _global).expanded, delete (this || _global).childs, (this || _global).value = e.value;

            Array.isArray(s) !== Array.isArray((this || _global).childs) && this.recreateDom(), this.updateDom({
              updateIndexes: !0
            }), (this || _global).previousValue = (this || _global).value;
          }
        }, {
          key: "recreateDom",
          value: function () {
            var e;
            (this || _global).dom && (this || _global).dom.tr && (this || _global).dom.tr.parentNode ? (e = this._detachFromDom(), this.clearDom(), this._attachToDom(e)) : this.clearDom();
          }
        }, {
          key: "getValue",
          value: function () {
            var t, i;
            return "array" === (this || _global).type ? (t = [], (this || _global).childs.forEach(function (e) {
              t.push(e.getValue());
            }), t) : "object" === (this || _global).type ? (i = {}, (this || _global).childs.forEach(function (e) {
              i[e.getField()] = e.getValue();
            }), i) : (void 0 === (this || _global).value && this._getDomValue(), (this || _global).value);
          }
        }, {
          key: "getInternalValue",
          value: function () {
            return "array" === (this || _global).type ? {
              type: (this || _global).type,
              childs: (this || _global).childs.map(function (e) {
                return e.getInternalValue();
              })
            } : "object" === (this || _global).type ? {
              type: (this || _global).type,
              childs: (this || _global).childs.map(function (e) {
                return {
                  field: e.getField(),
                  value: e.getInternalValue()
                };
              })
            } : (void 0 === (this || _global).value && this._getDomValue(), {
              type: (this || _global).type,
              value: (this || _global).value
            });
          }
        }, {
          key: "getLevel",
          value: function () {
            return (this || _global).parent ? (this || _global).parent.getLevel() + 1 : 0;
          }
        }, {
          key: "getNodePath",
          value: function () {
            var e = (this || _global).parent ? (this || _global).parent.getNodePath() : [];
            return e.push(this || _global), e;
          }
        }, {
          key: "clone",
          value: function () {
            var t, i;
            return (t = new x((this || _global).editor)).type = (this || _global).type, t.field = (this || _global).field, t.fieldInnerText = (this || _global).fieldInnerText, t.fieldEditable = (this || _global).fieldEditable, t.previousField = (this || _global).previousField, t.value = (this || _global).value, t.valueInnerText = (this || _global).valueInnerText, t.previousValue = (this || _global).previousValue, t.expanded = (this || _global).expanded, t.visibleChilds = (this || _global).visibleChilds, (this || _global).childs ? (i = [], (this || _global).childs.forEach(function (e) {
              e = e.clone();
              e.setParent(t), i.push(e);
            }), t.childs = i) : t.childs = void 0, t;
          }
        }, {
          key: "expand",
          value: function (t) {
            (this || _global).childs && ((this || _global).expanded = !0, (this || _global).dom.expand && ((this || _global).dom.expand.className = "jsoneditor-button jsoneditor-expanded"), this.showChilds(), !1 !== t && (this || _global).childs.forEach(function (e) {
              e.expand(t);
            }), this.updateDom({
              recurse: !1
            }));
          }
        }, {
          key: "collapse",
          value: function (t) {
            (this || _global).childs && (this.hideChilds(), !1 !== t && (this || _global).childs.forEach(function (e) {
              e.collapse(t);
            }), (this || _global).dom.expand && ((this || _global).dom.expand.className = "jsoneditor-button jsoneditor-collapsed"), (this || _global).expanded = !1, this.updateDom({
              recurse: !1
            }));
          }
        }, {
          key: "showChilds",
          value: function () {
            var e = (this || _global).childs;

            if (e && (this || _global).expanded) {
              var e = (this || _global).dom.tr,
                  t = e ? e.parentNode : void 0;

              if (t) {
                for (var i = this.getAppendDom(), n = (i.parentNode || ((r = e.nextSibling) ? t.insertBefore(i, r) : t.appendChild(i)), Math.min((this || _global).childs.length, (this || _global).visibleChilds)), r = this._getNextTr(), o = 0; o < n; o++) {
                  var s = (this || _global).childs[o];
                  s.getDom().parentNode || t.insertBefore(s.getDom(), r), s.showChilds();
                }

                e = this.getShowMoreDom();
                r = this._getNextTr(), e.parentNode || t.insertBefore(e, r), (this || _global).showMore.updateDom();
              }
            }
          }
        }, {
          key: "_getNextTr",
          value: function () {
            return (this || _global).showMore && (this || _global).showMore.getDom().parentNode ? (this || _global).showMore.getDom() : (this || _global).append && (this || _global).append.getDom().parentNode ? (this || _global).append.getDom() : void 0;
          }
        }, {
          key: "hide",
          value: function (e) {
            var t = (this || _global).dom.tr,
                i = t ? t.parentNode : void 0;
            i && i.removeChild(t), (this || _global).dom.popupAnchor && (this || _global).dom.popupAnchor.destroy(), this.hideChilds(e);
          }
        }, {
          key: "hideChilds",
          value: function (e) {
            var t;
            (this || _global).childs && (this || _global).expanded && ((t = this.getAppendDom()).parentNode && t.parentNode.removeChild(t), (this || _global).childs.forEach(function (e) {
              e.hide();
            }), (t = this.getShowMoreDom()).parentNode && t.parentNode.removeChild(t), e && !e.resetVisibleChilds || ((this || _global).visibleChilds = this.getMaxVisibleChilds()));
          }
        }, {
          key: "_updateCssClassName",
          value: function () {
            var e, t;
            (this || _global).dom.field && (this || _global).editor && (this || _global).editor.options && "function" == typeof (this || _global).editor.options.onClassName && (this || _global).dom.tree && ((0, k.removeAllClassNames)((this || _global).dom.tree), e = (this || _global).getValue.bind(this || _global), t = (this || _global).editor.options.onClassName({
              path: this.getPath(),
              field: (this || _global).field,

              get value() {
                return e();
              }

            }) || "", (0, k.addClassName)((this || _global).dom.tree, "jsoneditor-values " + t));
          }
        }, {
          key: "recursivelyUpdateCssClassesOnNodes",
          value: function () {
            if (this._updateCssClassName(), Array.isArray((this || _global).childs)) for (var e = 0; e < (this || _global).childs.length; e++) (this || _global).childs[e].recursivelyUpdateCssClassesOnNodes();
          }
        }, {
          key: "expandTo",
          value: function () {
            for (var e = (this || _global).parent; e;) e.expanded || e.expand(), e = e.parent;
          }
        }, {
          key: "appendChild",
          value: function (e, t, i) {
            var n, r;
            this._hasChilds() && (e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, "array" === (this || _global).type && (e.index = (this || _global).childs.length), "object" === (this || _global).type && void 0 === e.field && e.setField(""), (this || _global).childs.push(e), (this || _global).expanded && !1 !== t && (t = e.getDom(), r = (n = this._getNextTr()) ? n.parentNode : void 0, n && r && r.insertBefore(t, n), e.showChilds(), (this || _global).visibleChilds++), !1 !== i && (this.updateDom({
              updateIndexes: !0
            }), e.updateDom({
              recurse: !0
            })));
          }
        }, {
          key: "moveBefore",
          value: function (e, t, i) {
            var n, r, o;
            this._hasChilds() && ((n = (this || _global).dom.tr ? (this || _global).dom.tr.parentNode : void 0) && ((r = document.createElement("tr")).style.height = n.clientHeight + "px", n.appendChild(r)), e.parent && e.parent.removeChild(e), t instanceof L || !t ? (this || _global).childs.length + 1 > (this || _global).visibleChilds ? (o = (this || _global).childs[(this || _global).visibleChilds - 1], this.insertBefore(e, o, i)) : this.appendChild(e, !0, i) : this.insertBefore(e, t, i), n && r && n.removeChild(r));
          }
        }, {
          key: "insertBefore",
          value: function (e, t, i) {
            if (this._hasChilds()) {
              if ((this || _global).visibleChilds++, "object" === (this || _global).type && void 0 === e.field && e.setField(""), t === (this || _global).append) e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, (this || _global).childs.push(e);else {
                var n = (this || _global).childs.indexOf(t);

                if (-1 === n) throw new Error("Node not found");
                e.setParent(this || _global), e.fieldEditable = "object" === (this || _global).type, (this || _global).childs.splice(n, 0, e);
              }
              var r;
              (this || _global).expanded && (n = e.getDom(), r = (t = t.getDom()) ? t.parentNode : void 0, t && r && r.insertBefore(n, t), e.showChilds(), this.showChilds()), !1 !== i && (this.updateDom({
                updateIndexes: !0
              }), e.updateDom({
                recurse: !0
              }));
            }
          }
        }, {
          key: "insertAfter",
          value: function (e, t) {
            this._hasChilds() && (t = (this || _global).childs.indexOf(t), (t = (this || _global).childs[t + 1]) ? this.insertBefore(e, t) : this.appendChild(e));
          }
        }, {
          key: "search",
          value: function (t, i) {
            Array.isArray(i) || (i = []);
            var e = t ? t.toLowerCase() : void 0;
            return delete (this || _global).searchField, delete (this || _global).searchValue, void 0 !== (this || _global).field && i.length <= (this || _global).MAX_SEARCH_RESULTS && (-1 !== String((this || _global).field).toLowerCase().indexOf(e) && ((this || _global).searchField = !0, i.push({
              node: this || _global,
              elem: "field"
            })), this._updateDomField()), this._hasChilds() ? (this || _global).childs && (this || _global).childs.forEach(function (e) {
              e.search(t, i);
            }) : void 0 !== (this || _global).value && i.length <= (this || _global).MAX_SEARCH_RESULTS && (-1 !== String((this || _global).value).toLowerCase().indexOf(e) && ((this || _global).searchValue = !0, i.push({
              node: this || _global,
              elem: "value"
            })), this._updateDomValue()), i;
          }
        }, {
          key: "scrollTo",
          value: function (e) {
            this.expandPathToNode(), (this || _global).dom.tr && (this || _global).dom.tr.parentNode && (this || _global).editor.scrollTo((this || _global).dom.tr.offsetTop, e);
          }
        }, {
          key: "expandPathToNode",
          value: function () {
            for (var e = this || _global; e && e.parent;) {
              for (var t = "array" === e.parent.type ? e.index : e.parent.childs.indexOf(e); e.parent.visibleChilds < t + 1;) e.parent.visibleChilds += this.getMaxVisibleChilds();

              e.parent.expand(!1), e = e.parent;
            }
          }
        }, {
          key: "focus",
          value: function (e) {
            if (x.focusElement = e, (this || _global).dom.tr && (this || _global).dom.tr.parentNode) {
              var t = (this || _global).dom;

              switch (e) {
                case "drag":
                  (t.drag || t.menu).focus();
                  break;

                case "menu":
                  t.menu.focus();
                  break;

                case "expand":
                  this._hasChilds() ? t.expand.focus() : t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.menu.focus();
                  break;

                case "field":
                  t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : (this._hasChilds() ? t.expand : t.menu).focus();
                  break;

                default:
                  t.select ? t.select.focus() : t.value && !this._hasChilds() ? (t.value.focus(), (0, k.selectContentEditable)(t.value)) : t.field && (this || _global).fieldEditable ? (t.field.focus(), (0, k.selectContentEditable)(t.field)) : (this._hasChilds() ? t.expand : t.menu).focus();
              }
            }
          }
        }, {
          key: "containsNode",
          value: function (e) {
            if ((this || _global) === e) return !0;
            var t = (this || _global).childs;
            if (t) for (var i = 0, n = t.length; i < n; i++) if (t[i].containsNode(e)) return !0;
            return !1;
          }
        }, {
          key: "removeChild",
          value: function (e, t) {
            if ((this || _global).childs) {
              var i = (this || _global).childs.indexOf(e);

              if (-1 !== i) return i < (this || _global).visibleChilds && (this || _global).expanded && (this || _global).visibleChilds--, e.hide(), delete e.searchField, delete e.searchValue, (e = (this || _global).childs.splice(i, 1)[0]).parent = null, !1 !== t && this.updateDom({
                updateIndexes: !0
              }), e;
            }
          }
        }, {
          key: "_remove",
          value: function (e) {
            this.removeChild(e);
          }
        }, {
          key: "changeType",
          value: function (e) {
            var t,
                i = (this || _global).type;
            i !== e && ("string" !== e && "auto" !== e || "string" !== i && "auto" !== i ? (t = this._detachFromDom(), this.clearDom(), "object" === ((this || _global).type = e) ? ((this || _global).childs || ((this || _global).childs = []), (this || _global).childs.forEach(function (e) {
              e.clearDom(), delete e.index, e.fieldEditable = !0, void 0 === e.field && (e.field = "");
            }), "string" !== i && "auto" !== i || ((this || _global).expanded = !0)) : "array" === e ? ((this || _global).childs || ((this || _global).childs = []), (this || _global).childs.forEach(function (e, t) {
              e.clearDom(), e.fieldEditable = !1, e.index = t;
            }), "string" !== i && "auto" !== i || ((this || _global).expanded = !0)) : (this || _global).expanded = !1, this._attachToDom(t)) : (this || _global).type = e, "auto" !== e && "string" !== e || ((this || _global).value = "string" === e ? String((this || _global).value) : (0, k.parseString)(String((this || _global).value)), this.focus()), this.updateDom({
              updateIndexes: !0
            }));
          }
        }, {
          key: "deepEqual",
          value: function (e) {
            var t;

            if ("array" === (this || _global).type) {
              if (!Array.isArray(e)) return !1;
              if ((this || _global).childs.length !== e.length) return !1;

              for (t = 0; t < (this || _global).childs.length; t++) if (!(this || _global).childs[t].deepEqual(e[t])) return !1;
            } else if ("object" === (this || _global).type) {
              if ("object" !== T(e) || !e) return !1;
              var i = Object.keys(e);
              if ((this || _global).childs.length !== i.length) return !1;

              for (t = 0; t < i.length; t++) {
                var n = (this || _global).childs[t];
                if (n.field !== i[t] || !n.deepEqual(e[n.field])) return !1;
              }
            } else if ((this || _global).value !== e) return !1;

            return !0;
          }
        }, {
          key: "_getDomValue",
          value: function () {
            if (this._clearValueError(), (this || _global).dom.value && "array" !== (this || _global).type && "object" !== (this || _global).type && ((this || _global).valueInnerText = (0, k.getInnerText)((this || _global).dom.value), "" === (this || _global).valueInnerText && "" !== (this || _global).dom.value.innerHTML && ((this || _global).dom.value.textContent = "")), void 0 !== (this || _global).valueInnerText) try {
              var e, t;
              (t = "string" === (this || _global).type ? this._unescapeHTML((this || _global).valueInnerText) : (e = this._unescapeHTML((this || _global).valueInnerText), (0, k.parseString)(e))) !== (this || _global).value && ((this || _global).value = t, this._debouncedOnChangeValue());
            } catch (e) {
              this._setValueError((0, l.Iu)("cannotParseValueError"));
            }
          }
        }, {
          key: "_setValueError",
          value: function (e) {
            (this || _global).valueError = {
              message: e
            }, this.updateError();
          }
        }, {
          key: "_clearValueError",
          value: function () {
            (this || _global).valueError && ((this || _global).valueError = null, this.updateError());
          }
        }, {
          key: "_setFieldError",
          value: function (e) {
            (this || _global).fieldError = {
              message: e
            }, this.updateError();
          }
        }, {
          key: "_clearFieldError",
          value: function () {
            (this || _global).fieldError && ((this || _global).fieldError = null, this.updateError());
          }
        }, {
          key: "_onChangeValue",
          value: function () {
            var e,
                t = (this || _global).editor.getDomSelection(),
                i = (t.range && (i = (0, k.textDiff)(String((this || _global).value), String((this || _global).previousValue)), t.range.startOffset = i.start, t.range.endOffset = i.end), (this || _global).editor.getDomSelection());

            i.range && (e = (0, k.textDiff)(String((this || _global).previousValue), String((this || _global).value)), i.range.startOffset = e.start, i.range.endOffset = e.end), (this || _global).editor._onAction("editValue", {
              path: this.getInternalPath(),
              oldValue: (this || _global).previousValue,
              newValue: (this || _global).value,
              oldSelection: t,
              newSelection: i
            }), (this || _global).previousValue = (this || _global).value;
          }
        }, {
          key: "_onChangeField",
          value: function () {
            var e = (this || _global).editor.getDomSelection(),
                t = (this || _global).previousField || "",
                i = (e.range && (i = (0, k.textDiff)((this || _global).field, t), e.range.startOffset = i.start, e.range.endOffset = i.end), (this || _global).editor.getDomSelection());

            i.range && (t = (0, k.textDiff)(t, (this || _global).field), i.range.startOffset = t.start, i.range.endOffset = t.end), (this || _global).editor._onAction("editField", {
              parentPath: (this || _global).parent.getInternalPath(),
              index: this.getIndex(),
              oldValue: (this || _global).previousField,
              newValue: (this || _global).field,
              oldSelection: e,
              newSelection: i
            }), (this || _global).previousField = (this || _global).field;
          }
        }, {
          key: "_updateDomValue",
          value: function () {
            var e = (this || _global).dom.value;

            if (e) {
              var t = ["jsoneditor-value"],
                  i = (this || _global).value,
                  n = "auto" === (this || _global).type ? (0, k.getType)(i) : (this || _global).type,
                  r = "string" === n && (0, k.isUrl)(i);

              if (t.push("jsoneditor-" + n), r && t.push("jsoneditor-url"), "" === String((this || _global).value) && "array" !== (this || _global).type && "object" !== (this || _global).type && t.push("jsoneditor-empty"), (this || _global).searchValueActive && t.push("jsoneditor-highlight-active"), (this || _global).searchValue && t.push("jsoneditor-highlight"), e.className = t.join(" "), "array" === n || "object" === n ? (t = (this || _global).childs ? (this || _global).childs.length : 0, e.title = (this || _global).type + " containing " + t + " items") : r && (this || _global).editable.value ? e.title = (0, l.Iu)("openUrl") : e.title = "", "boolean" === n && (this || _global).editable.value ? ((this || _global).dom.checkbox || ((this || _global).dom.checkbox = document.createElement("input"), (this || _global).dom.checkbox.type = "checkbox", (this || _global).dom.tdCheckbox = document.createElement("td"), (this || _global).dom.tdCheckbox.className = "jsoneditor-tree", (this || _global).dom.tdCheckbox.appendChild((this || _global).dom.checkbox), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdCheckbox, (this || _global).dom.tdValue)), (this || _global).dom.checkbox.checked = (this || _global).value) : (this || _global).dom.tdCheckbox && ((this || _global).dom.tdCheckbox.parentNode.removeChild((this || _global).dom.tdCheckbox), delete (this || _global).dom.tdCheckbox, delete (this || _global).dom.checkbox), (this || _global).enum && (this || _global).editable.value ? ((this || _global).dom.select || ((this || _global).dom.select = document.createElement("select"), (this || _global).id = (this || _global).field + "_" + new Date().getUTCMilliseconds(), (this || _global).dom.select.id = (this || _global).id, (this || _global).dom.select.name = (this || _global).dom.select.id, (t = document.createElement("option")).value = "", t.textContent = "--", (this || _global).dom.select.appendChild(t), this._updateEnumOptions(), (this || _global).dom.tdSelect = document.createElement("td"), (this || _global).dom.tdSelect.className = "jsoneditor-tree", (this || _global).dom.tdSelect.appendChild((this || _global).dom.select), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdSelect, (this || _global).dom.tdValue)), (this || _global).dom.select.value = -1 !== (this || _global).enum.indexOf((this || _global).value) ? (this || _global).value : "", !(this || _global).schema || v((this || _global).schema, "oneOf") || v((this || _global).schema, "anyOf") || v((this || _global).schema, "allOf") ? delete (this || _global).valueFieldHTML : ((this || _global).valueFieldHTML = (this || _global).dom.tdValue.innerHTML, (this || _global).dom.tdValue.style.visibility = "hidden", (this || _global).dom.tdValue.textContent = "")) : (this || _global).dom.tdSelect && ((this || _global).dom.tdSelect.parentNode.removeChild((this || _global).dom.tdSelect), delete (this || _global).dom.tdSelect, delete (this || _global).dom.select, (this || _global).dom.tdValue.innerHTML = (this || _global).valueFieldHTML, (this || _global).dom.tdValue.style.visibility = "", delete (this || _global).valueFieldHTML, (this || _global).dom.tdValue.appendChild((this || _global).dom.value)), (this || _global).editor.options.colorPicker && "string" == typeof i && (0, k.isValidColor)(i) ? ((this || _global).dom.color || ((this || _global).dom.color = document.createElement("div"), (this || _global).dom.color.className = "jsoneditor-color", (this || _global).dom.tdColor = document.createElement("td"), (this || _global).dom.tdColor.className = "jsoneditor-tree", (this || _global).dom.tdColor.appendChild((this || _global).dom.color), (this || _global).dom.tdValue.parentNode.insertBefore((this || _global).dom.tdColor, (this || _global).dom.tdValue)), (0, k.addClassName)((this || _global).dom.value, "jsoneditor-color-value"), ((this || _global).editable.value ? (0, k.removeClassName) : (0, k.addClassName))((this || _global).dom.color, "jsoneditor-color-readonly"), (this || _global).dom.color.style.backgroundColor = i) : this._deleteDomColor(), this._showTimestampTag()) {
                (this || _global).dom.date || ((this || _global).dom.date = document.createElement("div"), (this || _global).dom.date.className = "jsoneditor-date", (this || _global).dom.value.parentNode.appendChild((this || _global).dom.date));
                r = null;

                if (r = "function" == typeof (this || _global).editor.options.timestampFormat ? (this || _global).editor.options.timestampFormat({
                  field: (this || _global).field,
                  value: (this || _global).value,
                  path: this.getPath()
                }) : r) {
                  for (; (this || _global).dom.date.firstChild;) (this || _global).dom.date.removeChild((this || _global).dom.date.firstChild);

                  (this || _global).dom.date.appendChild(document.createTextNode(r));
                } else (this || _global).dom.date.textContent = new Date(i).toISOString();

                (this || _global).dom.date.title = new Date(i).toString();
              } else (this || _global).dom.date && ((this || _global).dom.date.parentNode.removeChild((this || _global).dom.date), delete (this || _global).dom.date);

              (0, k.stripFormatting)(e), this._updateDomDefault();
            }
          }
        }, {
          key: "_updateEnumOptions",
          value: function () {
            if ((this || _global).enum && (this || _global).dom.select) {
              (this || _global).dom.select.innerHTML = "";

              for (var e = 0; e < (this || _global).enum.length; e++) {
                var t = document.createElement("option");
                t.value = (this || _global).enum[e], t.textContent = (this || _global).enum[e], (this || _global).dom.select.appendChild(t);
              }
            }
          }
        }, {
          key: "_deleteDomColor",
          value: function () {
            (this || _global).dom.color && ((this || _global).dom.tdColor.parentNode.removeChild((this || _global).dom.tdColor), delete (this || _global).dom.tdColor, delete (this || _global).dom.color, (0, k.removeClassName)((this || _global).dom.value, "jsoneditor-color-value"));
          }
        }, {
          key: "_updateDomField",
          value: function () {
            var e,
                t = (this || _global).dom.field;
            t && ((e = (0, k.makeFieldTooltip)((this || _global).schema, (this || _global).editor.options.language)) && (t.title = e), ("" === String((this || _global).field) && (this || _global).parent && "array" !== (this || _global).parent.type ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-empty"), ((this || _global).searchFieldActive ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight-active"), ((this || _global).searchField ? (0, k.addClassName) : (0, k.removeClassName))(t, "jsoneditor-highlight"), (0, k.stripFormatting)(t));
          }
        }, {
          key: "_getDomField",
          value: function (e) {
            if (this._clearFieldError(), (this || _global).dom.field && (this || _global).fieldEditable && ((this || _global).fieldInnerText = (0, k.getInnerText)((this || _global).dom.field), "" === (this || _global).fieldInnerText && "" !== (this || _global).dom.field.innerHTML && ((this || _global).dom.field.textContent = "")), void 0 !== (this || _global).fieldInnerText) try {
              var t = this._unescapeHTML((this || _global).fieldInnerText),
                  i = (this || _global).parent.getFieldNames(this || _global);

              -1 !== i.indexOf(t) ? e ? (t = (0, k.findUniqueName)(t, i)) !== (this || _global).field && ((this || _global).field = t, this._debouncedOnChangeField()) : this._setFieldError((0, l.Iu)("duplicateFieldError")) : t !== (this || _global).field && ((this || _global).field = t, this._debouncedOnChangeField());
            } catch (e) {
              this._setFieldError((0, l.Iu)("cannotParseFieldError"));
            }
          }
        }, {
          key: "_updateDomDefault",
          value: function () {
            var e;
            (this || _global).schema && void 0 !== (this || _global).schema.default && !this._hasChilds() && (e = (this || _global).dom.select || (this || _global).dom.value) && ((this || _global).value === (this || _global).schema.default ? (e.title = (0, l.Iu)("default"), (0, k.addClassName)(e, "jsoneditor-is-default"), (0, k.removeClassName)(e, "jsoneditor-is-not-default")) : (e.removeAttribute("title"), (0, k.removeClassName)(e, "jsoneditor-is-default"), (0, k.addClassName)(e, "jsoneditor-is-not-default")));
          }
        }, {
          key: "_showTimestampTag",
          value: function () {
            if ("number" != typeof (this || _global).value) return !1;
            var e,
                t = (this || _global).editor.options.timestampTag;
            return "function" == typeof t ? "boolean" == typeof (e = t({
              field: (this || _global).field,
              value: (this || _global).value,
              path: this.getPath()
            })) ? e : (0, k.isTimestamp)((this || _global).field, (this || _global).value) : !0 === t && (0, k.isTimestamp)((this || _global).field, (this || _global).value);
          }
        }, {
          key: "clearDom",
          value: function () {
            (this || _global).dom = {};
          }
        }, {
          key: "getDom",
          value: function () {
            var e,
                t = (this || _global).dom;
            if (t.tr) return t.tr;
            this._updateEditability(), t.tr = document.createElement("tr"), "tree" === (t.tr.node = this || _global).editor.options.mode && (i = document.createElement("td"), (this || _global).editable.field && (this || _global).parent && ((e = document.createElement("button")).type = "button", (t.drag = e).className = "jsoneditor-button jsoneditor-dragarea", e.title = (0, l.Iu)("drag"), i.appendChild(e)), t.tr.appendChild(i), e = document.createElement("td"), (i = document.createElement("button")).type = "button", (t.menu = i).className = "jsoneditor-button jsoneditor-contextmenu-button", i.title = (0, l.Iu)("actionsMenu"), e.appendChild(t.menu), t.tr.appendChild(e));
            var i = document.createElement("td");
            return t.tr.appendChild(i), t.tree = this._createDomTree(), i.appendChild(t.tree), this.updateDom({
              updateIndexes: !0
            }), t.tr;
          }
        }, {
          key: "isVisible",
          value: function () {
            return (this || _global).dom && (this || _global).dom.tr && (this || _global).dom.tr.parentNode || !1;
          }
        }, {
          key: "isDescendantOf",
          value: function (e) {
            for (var t = (this || _global).parent; t;) {
              if (t === e) return !0;
              t = t.parent;
            }

            return !1;
          }
        }, {
          key: "_createDomField",
          value: function () {
            return document.createElement("div");
          }
        }, {
          key: "setHighlight",
          value: function (t) {
            (this || _global).dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-highlight"), (this || _global).append && (this || _global).append.setHighlight(t), (this || _global).childs && (this || _global).childs.forEach(function (e) {
              e.setHighlight(t);
            }));
          }
        }, {
          key: "setSelected",
          value: function (t, e) {
            (this || _global).selected = t, (this || _global).dom.tr && ((t ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-selected"), (e ? (0, k.addClassName) : (0, k.removeClassName))((this || _global).dom.tr, "jsoneditor-first"), (this || _global).append && (this || _global).append.setSelected(t), (this || _global).showMore && (this || _global).showMore.setSelected(t), (this || _global).childs && (this || _global).childs.forEach(function (e) {
              e.setSelected(t);
            }));
          }
        }, {
          key: "updateValue",
          value: function (e) {
            (this || _global).value = e, (this || _global).previousValue = e, (this || _global).valueError = void 0, this.updateDom();
          }
        }, {
          key: "updateField",
          value: function (e) {
            (this || _global).field = e, (this || _global).previousField = e, (this || _global).fieldError = void 0, this.updateDom();
          }
        }, {
          key: "updateDom",
          value: function (t) {
            var e,
                i = (this || _global).dom.tree,
                i = (i && (i.style.marginLeft = 24 * this.getLevel() + "px"), (this || _global).dom.field),
                i = (i && ((this || _global).fieldEditable ? (i.contentEditable = (this || _global).editable.field, i.spellcheck = !1, i.className = "jsoneditor-field") : (i.contentEditable = !1, i.className = "jsoneditor-readonly"), e = void 0 !== (this || _global).index ? (this || _global).index : void 0 !== (this || _global).field ? (this || _global).field : (e = (this || _global).editor.options.schema ? x._findSchema((this || _global).editor.options.schema, (this || _global).editor.options.schemaRefs || {}, this.getPath()) : void 0) && e.title ? e.title : this._hasChilds() ? (this || _global).type : "", e = this._escapeHTML(e), document.activeElement !== i && e !== this._unescapeHTML((0, k.getInnerText)(i)) && (i.innerHTML = e), this._updateSchema(), this._updateEnumOptions()), (this || _global).dom.value),
                i = (i && ("array" === (this || _global).type || "object" === (this || _global).type ? this.updateNodeName() : (e = this._escapeHTML((this || _global).value), document.activeElement !== i && e !== this._unescapeHTML((0, k.getInnerText)(i)) && (i.innerHTML = e))), (this || _global).dom.tr);
            i && ("array" === (this || _global).type || "object" === (this || _global).type ? ((0, k.addClassName)(i, "jsoneditor-expandable"), (this || _global).expanded ? ((0, k.addClassName)(i, "jsoneditor-expanded"), (0, k.removeClassName)(i, "jsoneditor-collapsed")) : ((0, k.addClassName)(i, "jsoneditor-collapsed"), (0, k.removeClassName)(i, "jsoneditor-expanded"))) : ((0, k.removeClassName)(i, "jsoneditor-expandable"), (0, k.removeClassName)(i, "jsoneditor-expanded"), (0, k.removeClassName)(i, "jsoneditor-collapsed"))), this._updateDomField(), this._updateDomValue(), t && !0 === t.updateIndexes && this._updateDomIndexes(), t && !0 === t.recurse && (this || _global).childs && (this || _global).childs.forEach(function (e) {
              e.updateDom(t);
            }), (this || _global).error && this.updateError(), (this || _global).append && (this || _global).append.updateDom(), (this || _global).showMore && (this || _global).showMore.updateDom(), this._updateCssClassName();
          }
        }, {
          key: "_updateSchema",
          value: function () {
            (this || _global).editor && (this || _global).editor.options && ((this || _global).schema = (this || _global).editor.options.schema ? x._findSchema((this || _global).editor.options.schema, (this || _global).editor.options.schemaRefs || {}, this.getPath()) : null, (this || _global).schema ? (this || _global).enum = x._findEnum((this || _global).schema) : delete (this || _global).enum);
          }
        }, {
          key: "_updateDomIndexes",
          value: function () {
            var e = (this || _global).dom.value,
                t = (this || _global).childs;
            e && t && ("array" === (this || _global).type ? t.forEach(function (e, t) {
              e.index = t;
              e = e.dom.field;
              e && (e.textContent = t);
            }) : "object" === (this || _global).type && t.forEach(function (e) {
              void 0 !== e.index && (delete e.index, void 0 === e.field && (e.field = ""));
            }));
          }
        }, {
          key: "_createDomValue",
          value: function () {
            var e;
            return "array" === (this || _global).type ? (e = document.createElement("div")).textContent = "[...]" : "object" === (this || _global).type ? (e = document.createElement("div")).textContent = "{...}" : (!(this || _global).editable.value && (0, k.isUrl)((this || _global).value) ? (e = document.createElement("a")).href = (this || _global).value : ((e = document.createElement("div")).contentEditable = (this || _global).editable.value, e.spellcheck = !1), e.innerHTML = this._escapeHTML((this || _global).value)), e;
          }
        }, {
          key: "_createDomExpandButton",
          value: function () {
            var e = document.createElement("button");
            return e.type = "button", this._hasChilds() ? (e.className = (this || _global).expanded ? "jsoneditor-button jsoneditor-expanded" : "jsoneditor-button jsoneditor-collapsed", e.title = (0, l.Iu)("expandTitle")) : (e.className = "jsoneditor-button jsoneditor-invisible", e.title = ""), e;
          }
        }, {
          key: "_createDomTree",
          value: function () {
            var e = (this || _global).dom,
                t = document.createElement("table"),
                i = document.createElement("tbody"),
                n = (t.style.borderCollapse = "collapse", t.className = "jsoneditor-values", t.appendChild(i), document.createElement("tr")),
                i = (i.appendChild(n), document.createElement("td")),
                i = (i.className = "jsoneditor-tree", n.appendChild(i), e.expand = this._createDomExpandButton(), i.appendChild(e.expand), e.tdExpand = i, document.createElement("td")),
                i = (i.className = "jsoneditor-tree", n.appendChild(i), e.field = this._createDomField(), i.appendChild(e.field), e.tdField = i, document.createElement("td")),
                i = (i.className = "jsoneditor-tree", n.appendChild(i), "object" !== (this || _global).type && "array" !== (this || _global).type && (i.appendChild(document.createTextNode(":")), i.className = "jsoneditor-separator"), e.tdSeparator = i, document.createElement("td"));
            return i.className = "jsoneditor-tree", n.appendChild(i), e.value = this._createDomValue(), i.appendChild(e.value), e.tdValue = i, t;
          }
        }, {
          key: "onEvent",
          value: function (e) {
            var t,
                i = e.type,
                n = e.target || e.srcElement,
                r = (this || _global).dom,
                o = this || _global,
                s = this._hasChilds(),
                a = (n !== r.drag && n !== r.menu || ("mouseover" === i ? (this || _global).editor.highlighter.highlight(this || _global) : "mouseout" === i && (this || _global).editor.highlighter.unhighlight()), "click" === i && n === r.menu && ((t = o.editor.highlighter).highlight(o), t.lock(), (0, k.addClassName)(r.menu, "jsoneditor-selected"), this.showContextMenu(r.menu, function () {
              (0, k.removeClassName)(r.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
            })), "click" === i && n === r.expand && s && (d = e.ctrlKey, this._onExpand(d)), "click" !== i || e.target !== o.dom.tdColor && e.target !== o.dom.color || !(this || _global).editable.value || this._showColorPicker(), "change" === i && n === r.checkbox && ((this || _global).dom.value.textContent = String(!(this || _global).value), this._getDomValue(), this._updateDomDefault()), "change" === i && n === r.select && ((this || _global).dom.value.innerHTML = this._escapeHTML(r.select.value), this._getDomValue(), this._updateDomValue()), r.value);

            if (n === a) switch (i) {
              case "blur":
              case "change":
                this._getDomValue(), this._clearValueError(), this._updateDomValue();

                var l = this._escapeHTML((this || _global).value);

                l !== this._unescapeHTML((0, k.getInnerText)(a)) && (a.innerHTML = l);
                break;

              case "input":
                this._getDomValue(), this._updateDomValue();
                break;

              case "keydown":
              case "mousedown":
                (this || _global).editor.selection = (this || _global).editor.getDomSelection();
                break;

              case "click":
                e.ctrlKey && (this || _global).editable.value && (0, k.isUrl)((this || _global).value) && (e.preventDefault(), window.open((this || _global).value, "_blank", "noreferrer"));
                break;

              case "keyup":
                this._getDomValue(), this._updateDomValue();
                break;

              case "cut":
              case "paste":
                setTimeout(function () {
                  o._getDomValue(), o._updateDomValue();
                }, 1);
            }
            var c = r.field;
            if (n === c) switch (i) {
              case "blur":
                this._getDomField(!0), this._updateDomField();

                var h = this._escapeHTML((this || _global).field);

                h !== this._unescapeHTML((0, k.getInnerText)(c)) && (c.innerHTML = h);
                break;

              case "input":
                this._getDomField(), this._updateSchema(), this._updateDomField(), this._updateDomValue();
                break;

              case "keydown":
              case "mousedown":
                (this || _global).editor.selection = (this || _global).editor.getDomSelection();
                break;

              case "keyup":
                this._getDomField(), this._updateDomField();
                break;

              case "cut":
              case "paste":
                setTimeout(function () {
                  o._getDomField(), o._updateDomField();
                }, 1);
            }
            var d = r.tree;
            d && n === d.parentNode && "click" === i && !e.hasMoved && ((void 0 !== e.offsetX ? e.offsetX < 24 * (this.getLevel() + 1) : e.pageX < (0, k.getAbsoluteLeft)(r.tdSeparator)) || s ? c && ((0, k.setEndOfContentEditable)(c), c.focus()) : a && !(this || _global).enum && ((0, k.setEndOfContentEditable)(a), a.focus())), (n !== r.tdExpand || s) && n !== r.tdField && n !== r.tdSeparator || "click" !== i || e.hasMoved || c && ((0, k.setEndOfContentEditable)(c), c.focus()), "keydown" === i && this.onKeyDown(e), "function" == typeof (this || _global).editor.options.onEvent && this._onEvent(e);
          }
        }, {
          key: "_onEvent",
          value: function (e) {
            var t = e.target,
                i = t === (this || _global).dom.field,
                t = t === (this || _global).dom.value || t === (this || _global).dom.checkbox || t === (this || _global).dom.select;
            (i || t) && (i = {
              field: this.getField(),
              path: this.getPath()
            }, t && !this._hasChilds() && (i.value = this.getValue()), (this || _global).editor.options.onEvent(i, e));
          }
        }, {
          key: "onKeyDown",
          value: function (e) {
            var t,
                i,
                n,
                r,
                o,
                s,
                a,
                l,
                c,
                h,
                d,
                u,
                g,
                p,
                m = e.which || e.keyCode,
                f = e.target || e.srcElement,
                C = e.ctrlKey,
                I = e.shiftKey,
                v = e.altKey,
                A = !1,
                b = "tree" === (this || _global).editor.options.mode,
                y = 0 < (this || _global).editor.multiselection.nodes.length ? (this || _global).editor.multiselection.nodes : [this || _global],
                w = y[0],
                S = y[y.length - 1];
            13 === m ? f === (this || _global).dom.value ? (this || _global).editable.value && !e.ctrlKey || (0, k.isUrl)((this || _global).value) && (window.open((this || _global).value, "_blank", "noreferrer"), A = !0) : f === (this || _global).dom.expand && this._hasChilds() && (g = e.ctrlKey, this._onExpand(g), f.focus(), A = !0) : 68 === m ? C && b && (x.onDuplicate(y), A = !0) : 69 === m ? C && (this._onExpand(I), f.focus(), A = !0) : 77 === m && b ? C && (this.showContextMenu(f), A = !0) : 46 === m && b ? C && (x.onRemove(y), A = !0) : 45 === m && b ? C && !I ? (this._onInsertBefore(), A = !0) : C && I && (this._onInsertAfter(), A = !0) : 35 === m ? v && ((g = this._lastNode()) && g.focus(x.focusElement || this._getElementName(f)), A = !0) : 36 === m ? v && ((g = this._firstNode()) && g.focus(x.focusElement || this._getElementName(f)), A = !0) : 37 === m ? v && !I ? ((g = this._previousElement(f)) && this.focus(this._getElementName(g)), A = !0) : v && I && b && (g = S.expanded ? (g = S.getAppendDom()) ? g.nextSibling : void 0 : S.getDom().nextSibling) && (d = x.getNodeFromTarget(g), g = g.nextSibling, u = x.getNodeFromTarget(g), d && d instanceof L && 1 !== S.parent.childs.length && u && u.parent && (i = (this || _global).editor.getDomSelection(), n = (r = w.parent).childs[S.getIndex() + 1] || r.append, o = w.getIndex(), s = u.getIndex(), a = r.getInternalPath(), l = u.parent.getInternalPath(), y.forEach(function (e) {
              u.parent.moveBefore(e, u);
            }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
              count: y.length,
              fieldNames: y.map($),
              oldParentPath: r.getInternalPath(),
              newParentPath: w.parent.getInternalPath(),
              oldIndex: n.getIndex(),
              newIndex: w.getIndex(),
              oldIndexRedo: o,
              newIndexRedo: s,
              oldParentPathRedo: a,
              newParentPathRedo: l,
              oldSelection: i,
              newSelection: (this || _global).editor.getDomSelection()
            }))) : 38 === m ? v && !I ? ((t = this._previousNode()) && ((this || _global).editor.deselect(!0), t.focus(x.focusElement || this._getElementName(f))), A = !0) : !v && C && I && b ? ((t = this._previousNode()) && ((h = (this || _global).editor.multiselection).start = h.start || this || _global, h.end = t, c = (this || _global).editor._findTopLevelNodes(h.start, h.end), (this || _global).editor.select(c), t.focus("field")), A = !0) : v && I && b && ((t = w._previousNode()) && t.parent && (i = (this || _global).editor.getDomSelection(), n = (r = w.parent).childs[S.getIndex() + 1] || r.append, o = w.getIndex(), s = t.getIndex(), a = r.getInternalPath(), l = t.parent.getInternalPath(), y.forEach(function (e) {
              t.parent.moveBefore(e, t);
            }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
              count: y.length,
              fieldNames: y.map($),
              oldParentPath: r.getInternalPath(),
              newParentPath: w.parent.getInternalPath(),
              oldIndex: n.getIndex(),
              newIndex: w.getIndex(),
              oldIndexRedo: o,
              newIndexRedo: s,
              oldParentPathRedo: a,
              newParentPathRedo: l,
              oldSelection: i,
              newSelection: (this || _global).editor.getDomSelection()
            })), A = !0) : 39 === m ? v && !I ? ((g = this._nextElement(f)) && this.focus(this._getElementName(g)), A = !0) : v && I && b && (g = w.getDom().previousSibling) && (t = x.getNodeFromTarget(g)) && t.parent && !t.isVisible() && (i = (this || _global).editor.getDomSelection(), n = (r = w.parent).childs[S.getIndex() + 1] || r.append, o = w.getIndex(), s = t.getIndex(), a = r.getInternalPath(), l = t.parent.getInternalPath(), y.forEach(function (e) {
              t.parent.moveBefore(e, t);
            }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
              count: y.length,
              fieldNames: y.map($),
              oldParentPath: r.getInternalPath(),
              newParentPath: w.parent.getInternalPath(),
              oldIndex: n.getIndex(),
              newIndex: w.getIndex(),
              oldIndexRedo: o,
              newIndexRedo: s,
              oldParentPathRedo: a,
              newParentPathRedo: l,
              oldSelection: i,
              newSelection: (this || _global).editor.getDomSelection()
            })) : 40 === m && (v && !I ? ((d = this._nextNode()) && ((this || _global).editor.deselect(!0), d.focus(x.focusElement || this._getElementName(f))), A = !0) : !v && C && I && b ? ((d = this._nextNode()) && ((h = (this || _global).editor.multiselection).start = h.start || this || _global, h.end = d, c = (this || _global).editor._findTopLevelNodes(h.start, h.end), (this || _global).editor.select(c), d.focus("field")), A = !0) : v && I && b && ((p = (d = (d = (d = S.expanded ? S.append ? S.append._nextNode() : void 0 : S._nextNode()) && !d.isVisible() ? d.parent.showMore : d) && d instanceof L ? S : d) && (d._nextNode() || d.parent.append)) && p.parent && (i = (this || _global).editor.getDomSelection(), n = (r = w.parent).childs[S.getIndex() + 1] || r.append, o = w.getIndex(), s = p.getIndex(), a = r.getInternalPath(), l = p.parent.getInternalPath(), y.forEach(function (e) {
              p.parent.moveBefore(e, p);
            }), this.focus(x.focusElement || this._getElementName(f)), (this || _global).editor._onAction("moveNodes", {
              count: y.length,
              fieldNames: y.map($),
              oldParentPath: r.getInternalPath(),
              newParentPath: w.parent.getInternalPath(),
              oldParentPathRedo: a,
              newParentPathRedo: l,
              oldIndexRedo: o,
              newIndexRedo: s,
              oldIndex: n.getIndex(),
              newIndex: w.getIndex(),
              oldSelection: i,
              newSelection: (this || _global).editor.getDomSelection()
            })), A = !0)), A && (e.preventDefault(), e.stopPropagation());
          }
        }, {
          key: "_onExpand",
          value: function (e) {
            var t, i, n;
            e && (n = (i = (t = (this || _global).dom.tr.parentNode).parentNode).scrollTop, i.removeChild(t)), (this || _global).expanded ? this.collapse(e) : this.expand(e), e && (i.appendChild(t), i.scrollTop = n);
          }
        }, {
          key: "_showColorPicker",
          value: function () {
            var t, e;
            "function" == typeof (this || _global).editor.options.onColorPicker && (this || _global).dom.color && ((t = this || _global)._deleteDomColor(), t.updateDom(), e = (0, h.w)((this || _global).dom.color, (this || _global).editor.getPopupAnchor()), (this || _global).editor.options.onColorPicker(e, (this || _global).value, function (e) {
              "string" == typeof e && e !== t.value && (t._deleteDomColor(), t.value = e, t.updateDom(), t._debouncedOnChangeValue());
            }));
          }
        }, {
          key: "getFieldNames",
          value: function (t) {
            return "object" === (this || _global).type ? (this || _global).childs.filter(function (e) {
              return e !== t;
            }).map(function (e) {
              return e.field;
            }) : [];
          }
        }, {
          key: "_onInsertBefore",
          value: function (e, t, i) {
            var n = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
              field: void 0 !== e ? e : "",
              value: void 0 !== t ? t : "",
              type: i
            }),
                t = (e.expand(!0), this.getInternalPath()),
                i = ((this || _global).parent.insertBefore(e, this || _global), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());

            (this || _global).editor._onAction("insertBeforeNodes", {
              nodes: [e],
              paths: [e.getInternalPath()],
              beforePath: t,
              parentPath: (this || _global).parent.getInternalPath(),
              oldSelection: n,
              newSelection: i
            });
          }
        }, {
          key: "_onInsertAfter",
          value: function (e, t, i) {
            var n = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
              field: void 0 !== e ? e : "",
              value: void 0 !== t ? t : "",
              type: i
            }),
                t = (e.expand(!0), (this || _global).parent.insertAfter(e, this || _global), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());

            (this || _global).editor._onAction("insertAfterNodes", {
              nodes: [e],
              paths: [e.getInternalPath()],
              afterPath: this.getInternalPath(),
              parentPath: (this || _global).parent.getInternalPath(),
              oldSelection: n,
              newSelection: t
            });
          }
        }, {
          key: "_onAppend",
          value: function (e, t, i) {
            var n = (this || _global).editor.getDomSelection(),
                e = new x((this || _global).editor, {
              field: void 0 !== e ? e : "",
              value: void 0 !== t ? t : "",
              type: i
            }),
                t = (e.expand(!0), (this || _global).parent.appendChild(e), (this || _global).editor.highlighter.unhighlight(), e.focus("field"), (this || _global).editor.getDomSelection());

            (this || _global).editor._onAction("appendNodes", {
              nodes: [e],
              paths: [e.getInternalPath()],
              parentPath: (this || _global).parent.getInternalPath(),
              oldSelection: n,
              newSelection: t
            });
          }
        }, {
          key: "_onChangeType",
          value: function (e) {
            var t,
                i,
                n = (this || _global).type;
            e !== n && (t = (this || _global).editor.getDomSelection(), this.changeType(e), i = (this || _global).editor.getDomSelection(), (this || _global).editor._onAction("changeType", {
              path: this.getInternalPath(),
              oldType: n,
              newType: e,
              oldSelection: t,
              newSelection: i
            }));
          }
        }, {
          key: "sort",
          value: function (i, e) {
            var t,
                n,
                r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
            "string" == typeof i && (i = (0, k.parsePath)(i)), this._hasChilds() && (this.hideChilds(), t = (this || _global).childs, (this || _global).childs = (this || _global).childs.concat(), n = "desc" === e ? -1 : 1, "object" === (this || _global).type ? (this || _global).childs.sort(function (e, t) {
              return n * o()(e.field, t.field);
            }) : (this || _global).childs.sort(function (e, t) {
              e = e.getNestedChild(i), t = t.getNestedChild(i);
              if (!e) return n;
              if (!t) return -n;
              e = e.value, t = t.value;
              return "string" != typeof e && "string" != typeof t ? t < e ? n : e < t ? -n : 0 : n * o()(e, t);
            }), this._updateDomIndexes(), this.showChilds(), !0 === r && (this || _global).editor._onAction("sort", {
              path: this.getInternalPath(),
              oldChilds: t,
              newChilds: (this || _global).childs
            }));
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this.getInternalValue();
            this.setValue(e), (this || _global).editor._onAction("transform", {
              path: this.getInternalPath(),
              oldValue: t,
              newValue: this.getInternalValue()
            });
          }
        }, {
          key: "_detachFromDom",
          value: function () {
            var e = (this || _global).dom.tr ? (this || _global).dom.tr.parentNode : void 0,
                t = (this || _global).expanded ? this.getAppendDom() : this.getDom(),
                t = t && t.parentNode ? t.nextSibling : void 0;
            return this.hide({
              resetVisibleChilds: !1
            }), {
              table: e,
              nextTr: t
            };
          }
        }, {
          key: "_attachToDom",
          value: function (e) {
            e.table && (e.nextTr ? e.table.insertBefore(this.getDom(), e.nextTr) : e.table.appendChild(this.getDom())), (this || _global).expanded && this.showChilds();
          }
        }, {
          key: "transform",
          value: function (e) {
            if (this._hasChilds()) {
              this.hideChilds();

              try {
                var t = this.getInternalValue(),
                    i = this.getValue(),
                    n = (this || _global).editor.options.executeQuery(i, e),
                    r = (this.setValue(n), this.getInternalValue());

                (this || _global).editor._onAction("transform", {
                  path: this.getInternalPath(),
                  oldValue: t,
                  newValue: r
                }), this.showChilds();
              } catch (e) {
                this.showChilds(), (this || _global).editor._onError(e);
              }
            }
          }
        }, {
          key: "extract",
          value: function () {
            (this || _global).editor.node.hideChilds(), this.hideChilds();

            try {
              var e = (this || _global).editor.node.getInternalValue(),
                  t = ((this || _global).editor._setRoot(this || _global), (this || _global).editor.node.getInternalValue());

              (this || _global).editor._onAction("transform", {
                path: (this || _global).editor.node.getInternalPath(),
                oldValue: e,
                newValue: t
              });
            } catch (e) {
              (this || _global).editor._onError(e);
            } finally {
              this.updateDom({
                recurse: !0
              }), this.showChilds();
            }
          }
        }, {
          key: "getNestedChild",
          value: function (e) {
            for (var t = 0, i = this || _global; i && t < e.length;) i = i.findChildByProperty(e[t]), t++;

            return i;
          }
        }, {
          key: "findChildByProperty",
          value: function (t) {
            if ("object" === (this || _global).type) return (this || _global).childs.find(function (e) {
              return e.field === t;
            });
          }
        }, {
          key: "getAppendDom",
          value: function () {
            return (this || _global).append || ((this || _global).append = new L((this || _global).editor), (this || _global).append.setParent(this || _global)), (this || _global).append.getDom();
          }
        }, {
          key: "getShowMoreDom",
          value: function () {
            return (this || _global).showMore || ((this || _global).showMore = new A((this || _global).editor, this || _global)), (this || _global).showMore.getDom();
          }
        }, {
          key: "nextSibling",
          value: function () {
            var e = (this || _global).parent.childs.indexOf(this || _global);

            return (this || _global).parent.childs[e + 1] || (this || _global).parent.append;
          }
        }, {
          key: "_previousNode",
          value: function () {
            var e = null,
                t = this.getDom();
            if (t && t.parentNode) for (var i = t; i = i.previousSibling, e = x.getNodeFromTarget(i), i && e && e instanceof L && !e.isVisible(););
            return e;
          }
        }, {
          key: "_nextNode",
          value: function () {
            var e = null,
                t = this.getDom();
            if (t && t.parentNode) for (var i = t; i = i.nextSibling, e = x.getNodeFromTarget(i), i && e && e instanceof L && !e.isVisible(););
            return e;
          }
        }, {
          key: "_firstNode",
          value: function () {
            var e = null,
                t = this.getDom();
            return t && t.parentNode && (t = t.parentNode.firstChild, e = x.getNodeFromTarget(t)), e;
          }
        }, {
          key: "_lastNode",
          value: function () {
            var e = null,
                t = this.getDom();
            if (t && t.parentNode) for (var i = t.parentNode.lastChild, e = x.getNodeFromTarget(i); i && e && !e.isVisible();) i = i.previousSibling, e = x.getNodeFromTarget(i);
            return e;
          }
        }, {
          key: "_previousElement",
          value: function (e) {
            var t = (this || _global).dom;

            switch (e) {
              case t.value:
                if ((this || _global).fieldEditable) return t.field;

              case t.field:
                if (this._hasChilds()) return t.expand;

              case t.expand:
                return t.menu;

              case t.menu:
                if (t.drag) return t.drag;

              default:
                return null;
            }
          }
        }, {
          key: "_nextElement",
          value: function (e) {
            var t = (this || _global).dom;

            switch (e) {
              case t.drag:
                return t.menu;

              case t.menu:
                if (this._hasChilds()) return t.expand;

              case t.expand:
                if ((this || _global).fieldEditable) return t.field;

              case t.field:
                if (!this._hasChilds()) return t.value;

              default:
                return null;
            }
          }
        }, {
          key: "_getElementName",
          value: function (t) {
            var i = this || _global;
            return Object.keys((this || _global).dom).find(function (e) {
              return i.dom[e] === t;
            });
          }
        }, {
          key: "_hasChilds",
          value: function () {
            return "array" === (this || _global).type || "object" === (this || _global).type;
          }
        }, {
          key: "addTemplates",
          value: function (t, i) {
            var n = this || _global,
                e = n.editor.options.templates;
            null != e && (e.length && t.push({
              type: "separator"
            }), e.forEach(function (e) {
              t.push({
                text: e.text,
                className: e.className || "jsoneditor-type-object",
                title: e.title,
                click: (i ? function (e, t) {
                  n._onAppend(e, t);
                } : function (e, t) {
                  n._onInsertBefore(e, t);
                }).bind(this || _global, e.field, e.value)
              });
            }));
          }
        }, {
          key: "showContextMenu",
          value: function (e, t) {
            var i,
                n = this || _global,
                r = [];
            (this || _global).editable.value && r.push({
              text: (0, l.Iu)("type"),
              title: (0, l.Iu)("typeTitle"),
              className: "jsoneditor-type-" + (this || _global).type,
              submenu: [{
                text: (0, l.Iu)("auto"),
                className: "jsoneditor-type-auto" + ("auto" === (this || _global).type ? " jsoneditor-selected" : ""),
                title: (0, l.Iu)("autoType"),
                click: function () {
                  n._onChangeType("auto");
                }
              }, {
                text: (0, l.Iu)("array"),
                className: "jsoneditor-type-array" + ("array" === (this || _global).type ? " jsoneditor-selected" : ""),
                title: (0, l.Iu)("arrayType"),
                click: function () {
                  n._onChangeType("array");
                }
              }, {
                text: (0, l.Iu)("object"),
                className: "jsoneditor-type-object" + ("object" === (this || _global).type ? " jsoneditor-selected" : ""),
                title: (0, l.Iu)("objectType"),
                click: function () {
                  n._onChangeType("object");
                }
              }, {
                text: (0, l.Iu)("string"),
                className: "jsoneditor-type-string" + ("string" === (this || _global).type ? " jsoneditor-selected" : ""),
                title: (0, l.Iu)("stringType"),
                click: function () {
                  n._onChangeType("string");
                }
              }]
            }), this._hasChilds() && ((this || _global).editor.options.enableSort && r.push({
              text: (0, l.Iu)("sort"),
              title: (0, l.Iu)("sortTitle", {
                type: (this || _global).type
              }),
              className: "jsoneditor-sort-asc",
              click: function () {
                n.showSortModal();
              }
            }), (this || _global).editor.options.enableTransform && r.push({
              text: (0, l.Iu)("transform"),
              title: (0, l.Iu)("transformTitle", {
                type: (this || _global).type
              }),
              className: "jsoneditor-transform",
              click: function () {
                n.showTransformModal();
              }
            }), (this || _global).parent && r.push({
              text: (0, l.Iu)("extract"),
              title: (0, l.Iu)("extractTitle", {
                type: (this || _global).type
              }),
              className: "jsoneditor-extract",
              click: function () {
                n.extract();
              }
            })), (this || _global).parent && (this || _global).parent._hasChilds() && (r.length && r.push({
              type: "separator"
            }), i = n.parent.childs, n === i[i.length - 1] && (i = [{
              text: (0, l.Iu)("auto"),
              className: "jsoneditor-type-auto",
              title: (0, l.Iu)("autoType"),
              click: function () {
                n._onAppend("", "", "auto");
              }
            }, {
              text: (0, l.Iu)("array"),
              className: "jsoneditor-type-array",
              title: (0, l.Iu)("arrayType"),
              click: function () {
                n._onAppend("", []);
              }
            }, {
              text: (0, l.Iu)("object"),
              className: "jsoneditor-type-object",
              title: (0, l.Iu)("objectType"),
              click: function () {
                n._onAppend("", {});
              }
            }, {
              text: (0, l.Iu)("string"),
              className: "jsoneditor-type-string",
              title: (0, l.Iu)("stringType"),
              click: function () {
                n._onAppend("", "", "string");
              }
            }], n.addTemplates(i, !0), r.push({
              text: (0, l.Iu)("appendText"),
              title: (0, l.Iu)("appendTitle"),
              submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
              className: "jsoneditor-append",
              click: function () {
                n._onAppend("", "", "auto");
              },
              submenu: i
            })), i = [{
              text: (0, l.Iu)("auto"),
              className: "jsoneditor-type-auto",
              title: (0, l.Iu)("autoType"),
              click: function () {
                n._onInsertBefore("", "", "auto");
              }
            }, {
              text: (0, l.Iu)("array"),
              className: "jsoneditor-type-array",
              title: (0, l.Iu)("arrayType"),
              click: function () {
                n._onInsertBefore("", []);
              }
            }, {
              text: (0, l.Iu)("object"),
              className: "jsoneditor-type-object",
              title: (0, l.Iu)("objectType"),
              click: function () {
                n._onInsertBefore("", {});
              }
            }, {
              text: (0, l.Iu)("string"),
              className: "jsoneditor-type-string",
              title: (0, l.Iu)("stringType"),
              click: function () {
                n._onInsertBefore("", "", "string");
              }
            }], n.addTemplates(i, !1), r.push({
              text: (0, l.Iu)("insert"),
              title: (0, l.Iu)("insertTitle"),
              submenuTitle: (0, l.Iu)("insertSub"),
              className: "jsoneditor-insert",
              click: function () {
                n._onInsertBefore("", "", "auto");
              },
              submenu: i
            }), (this || _global).editable.field && (r.push({
              text: (0, l.Iu)("duplicateText"),
              title: (0, l.Iu)("duplicateField"),
              className: "jsoneditor-duplicate",
              click: function () {
                x.onDuplicate(n);
              }
            }), r.push({
              text: (0, l.Iu)("removeText"),
              title: (0, l.Iu)("removeField"),
              className: "jsoneditor-remove",
              click: function () {
                x.onRemove(n);
              }
            }))), (this || _global).editor.options.onCreateMenu && (i = n.getPath(), r = (this || _global).editor.options.onCreateMenu(r, {
              type: "single",
              path: i,
              paths: [i]
            })), new s.x(r, {
              close: t
            }).show(e, (this || _global).editor.getPopupAnchor());
          }
        }, {
          key: "showSortModal",
          value: function () {
            var i = this || _global,
                e = (this || _global).editor.options.modalAnchor || g.qD,
                t = this.getValue();
            (0, d.showSortModal)(e, t, function (e) {
              var t = e.path,
                  t = (0, k.parsePath)(t);
              i.sortedBy = e, i.sort(t, e.direction);
            }, i.sortedBy);
          }
        }, {
          key: "showTransformModal",
          value: function () {
            var t = this || _global,
                e = (this || _global).editor.options,
                i = e.modalAnchor,
                n = e.createQuery,
                r = e.executeQuery,
                e = e.queryDescription,
                o = this.getValue();
            (0, u.showTransformModal)({
              container: i || g.qD,
              json: o,
              queryDescription: e,
              createQuery: n,
              executeQuery: r,
              onTransform: function (e) {
                t.transform(e);
              }
            });
          }
        }, {
          key: "_getType",
          value: function (e) {
            return e instanceof Array ? "array" : e instanceof Object ? "object" : "string" == typeof e && "string" != typeof (0, k.parseString)(e) ? "string" : "auto";
          }
        }, {
          key: "_escapeHTML",
          value: function (e) {
            return "string" != typeof e ? String(e) : (e = String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ {2}/g, " &nbsp;").replace(/^ /, "&nbsp;").replace(/ $/, "&nbsp;"), e = (e = JSON.stringify(e)).substring(1, e.length - 1), !0 === (this || _global).editor.options.escapeUnicode ? (0, k.escapeUnicodeChars)(e) : e);
          }
        }, {
          key: "_unescapeHTML",
          value: function (e) {
            e = "\"" + this._escapeJSON(e) + "\"";
            return (0, k.parse)(e).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;|\u00A0/g, " ").replace(/&amp;/g, "&");
          }
        }, {
          key: "_escapeJSON",
          value: function (e) {
            for (var t = "", i = 0; i < e.length;) {
              var n = e.charAt(i);
              "\n" === n ? t += "\\n" : "\\" === n ? (t += n, i++, "" !== (n = e.charAt(i)) && -1 !== "\"\\/bfnrtu".indexOf(n) || (t += "\\"), t += n) : t += "\"" === n ? "\\\"" : n, i++;
            }

            return t;
          }
        }, {
          key: "updateNodeName",
          value: function () {
            var e = (this || _global).childs ? (this || _global).childs.length : 0;

            if ("object" === (this || _global).type || "array" === (this || _global).type) {
              if ((this || _global).editor.options.onNodeName) try {
                var t = (this || _global).getValue.bind(this || _global),
                    i = (this || _global).editor.options.onNodeName({
                  path: this.getPath(),
                  size: e,
                  type: (this || _global).type,

                  get value() {
                    return t();
                  }

                });
              } catch (e) {
                console.error("Error in onNodeName callback: ", e);
              }
              (this || _global).dom.value.textContent = "object" === (this || _global).type ? "{" + (i || e) + "}" : "[" + (i || e) + "]";
            }
          }
        }, {
          key: "recursivelyUpdateNodeName",
          value: function () {
            if ((this || _global).expanded && (this.updateNodeName(), "undefined" !== (this || _global).childs)) for (var e in (this || _global).childs) (this || _global).childs[e].recursivelyUpdateNodeName();
          }
        }]) && f(e.prototype, t), i && f(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), x;
      }(),
          C = (_.prototype.DEBOUNCE_INTERVAL = 150, _.prototype.MAX_SEARCH_RESULTS = 999, 100);

      function I(e) {
        return e.getInternalPath();
      }

      function $(e) {
        return e.getField();
      }

      function v(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      _.focusElement = void 0, _.select = function (e) {
        setTimeout(function () {
          (0, k.selectContentEditable)(e);
        }, 0);
      }, _.onDragStart = function (t, e) {
        if (!Array.isArray(t)) return _.onDragStart([t], e);
        var i, n, r, o, s;
        0 !== t.length && (i = t[0], n = t[t.length - 1], r = i.parent, s = _.getNodeFromTarget(e.target), o = i.editor, s = (0, k.getAbsoluteTop)(s.dom.tr) - (0, k.getAbsoluteTop)(i.dom.tr), o.mousemove || (o.mousemove = (0, k.addEventListener)(e.view, "mousemove", function (e) {
          _.onDrag(t, e);
        })), o.mouseup || (o.mouseup = (0, k.addEventListener)(e.view, "mouseup", function (e) {
          _.onDragEnd(t, e);
        })), o.highlighter.lock(), o.drag = {
          oldCursor: document.body.style.cursor,
          oldSelection: o.getDomSelection(),
          oldPaths: t.map(I),
          oldParent: r,
          oldNextNode: r.childs[n.getIndex() + 1] || r.append,
          oldParentPathRedo: r.getInternalPath(),
          oldIndexRedo: i.getIndex(),
          mouseX: e.pageX,
          offsetY: s,
          level: i.getLevel()
        }, document.body.style.cursor = "move", e.preventDefault());
      }, _.onDrag = function (e, t) {
        if (!Array.isArray(e)) return _.onDrag([e], t);

        if (0 !== e.length) {
          var i,
              n,
              r,
              o,
              s,
              a = e[0].editor,
              l = t.pageY - a.drag.offsetY,
              c = t.pageX,
              h = !1,
              d = e[0],
              u = d.dom.tr,
              g = (0, k.getAbsoluteTop)(u),
              p = u.offsetHeight;

          if (l < g) {
            for (I = u; I = I.previousSibling, v = _.getNodeFromTarget(I), r = I ? (0, k.getAbsoluteTop)(I) : 0, I && l < r;);

            (v = v && !v.parent ? void 0 : v) || (I = (u = u.parentNode.firstChild) ? u.nextSibling : void 0, (v = _.getNodeFromTarget(I)) === d && (v = void 0)), !(v = v && v.isVisible() && (r = (I = v.dom.tr) ? (0, k.getAbsoluteTop)(I) : 0) + p < l ? void 0 : v) || !1 !== a.options.limitDragging && v.parent !== e[0].parent || (e.forEach(function (e) {
              v.parent.moveBefore(e, v);
            }), h = !0);
          } else {
            var m = e[e.length - 1];

            if (p = (u = m.expanded && m.append ? m.append.getDom() : m.dom.tr) ? u.nextSibling : void 0) {
              for (o = (0, k.getAbsoluteTop)(p), i = p; n = _.getNodeFromTarget(i), i && (s = i.nextSibling ? (0, k.getAbsoluteTop)(i.nextSibling) : 0, s = i ? s - o : 0, n && n.parent.childs.length === e.length && n.parent.childs[e.length - 1] === m && (g += 27), i = i.nextSibling), i && g + s < l;);

              if (n && n.parent) {
                for (var p = c - a.drag.mouseX, p = Math.round(p / 24 / 2), f = a.drag.level + p, C = n.getLevel(), I = n.dom.tr && n.dom.tr.previousSibling; C < f && I;) {
                  var v = _.getNodeFromTarget(I),
                      A = e.some(function (e) {
                    return e === v || v.isDescendantOf(e);
                  });

                  if (!A) {
                    if (!(v instanceof L)) break;
                    A = v.parent.childs;
                    if (A.length === e.length && A[e.length - 1] === m) break;
                    C = (n = _.getNodeFromTarget(I)).getLevel();
                  }

                  I = I.previousSibling;
                }

                (n = n instanceof L && !n.isVisible() && n.parent.showMore.isVisible() ? n._nextNode() : n) && (!1 === a.options.limitDragging || n.parent === e[0].parent) && n.dom.tr && n.dom.tr !== u.nextSibling && (e.forEach(function (e) {
                  n.parent.moveBefore(e, n);
                }), h = !0);
              }
            }
          }

          h && (a.drag.mouseX = c, a.drag.level = d.getLevel()), a.startAutoScroll(l), t.preventDefault();
        }
      }, _.onDragEnd = function (e, t) {
        if (!Array.isArray(e)) return _.onDrag([e], t);
        var i, n, r, o, s, a, l, c, h;
        0 !== e.length && (a = e[0], i = a.editor, a && a.dom.menu && a.dom.menu.focus(), n = i.drag.oldParent.getInternalPath(), r = a.parent.getInternalPath(), o = i.drag.oldParent === a.parent, s = i.drag.oldNextNode.getIndex(), a = a.getIndex(), l = i.drag.oldParentPathRedo, c = i.drag.oldIndexRedo, h = o && c < a ? a + e.length : a, o && c === a || i._onAction("moveNodes", {
          count: e.length,
          fieldNames: e.map($),
          oldParentPath: n,
          newParentPath: r,
          oldIndex: s,
          newIndex: a,
          oldIndexRedo: c,
          newIndexRedo: h,
          oldParentPathRedo: l,
          newParentPathRedo: null,
          oldSelection: i.drag.oldSelection,
          newSelection: i.getDomSelection()
        }), document.body.style.cursor = i.drag.oldCursor, i.highlighter.unlock(), e.forEach(function (e) {
          e.updateDom(), t.target !== e.dom.drag && t.target !== e.dom.menu && i.highlighter.unhighlight();
        }), delete i.drag, i.mousemove && ((0, k.removeEventListener)(t.view, "mousemove", i.mousemove), delete i.mousemove), i.mouseup && ((0, k.removeEventListener)(t.view, "mouseup", i.mouseup), delete i.mouseup), i.stopAutoScroll(), t.preventDefault());
      }, _._findEnum = function (e) {
        if (e.enum) return e.enum;
        e = e.oneOf || e.anyOf || e.allOf;

        if (e) {
          e = e.filter(function (e) {
            return e.enum;
          });
          if (0 < e.length) return e[0].enum;
        }

        return null;
      }, _._findSchema = function (e, t, i) {
        for (var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : e, r = i.slice(1, i.length), o = i[0], s = [n], a = 0, l = [n.oneOf, n.anyOf, n.allOf]; a < l.length; a++) {
          var c = l[a];
          Array.isArray(c) && (s = s.concat(c));
        }

        var h,
            d = R(s);

        try {
          for (d.s(); !(h = d.n()).done;) {
            if ("$ref" in (n = h.value) && "string" == typeof n.$ref) {
              var u,
                  g = n.$ref;
              if (g in t) n = t[g];else {
                if (!g.startsWith("#/")) {
                  if (1 !== (null == (u = g.match(/#\//g)) ? void 0 : u.length)) throw Error("Unable to resolve reference ".concat(g));
                  var p,
                      m,
                      f,
                      C = E(g.split("#/"), 2),
                      I = C[0],
                      v = C[1];
                  if (I in t) return p = t[I], m = {
                    $ref: "#/".concat(v)
                  }, (f = []).push(o), 0 < r.length && f.push.apply(f, x(r)), _._findSchema(p, t, f, m);
                  throw Error("Unable to resolve reference ".concat(g));
                }

                var A,
                    b = g.substring(2).split("/"),
                    n = e,
                    y = R(b);

                try {
                  for (y.s(); !(A = y.n()).done;) {
                    var w = A.value;
                    if (!(w in n)) throw Error("Unable to resolve reference ".concat(g));
                    n = n[w];
                  }
                } catch (e) {
                  y.e(e);
                } finally {
                  y.f();
                }
              }
            }

            if (void 0 === o) return n;

            if ("string" == typeof o) {
              if ("object" === T(n.properties) && null !== n.properties && o in n.properties) return n = n.properties[o], _._findSchema(e, t, r, n);
              if ("object" === T(n.patternProperties) && null !== n.patternProperties) for (var S in n.patternProperties) if (o.match(S)) return n = n.patternProperties[S], _._findSchema(e, t, r, n);
              if ("object" === T(n.additionalProperties)) return n = n.additionalProperties, _._findSchema(e, t, r, n);
            } else if ("number" == typeof o && "object" === T(n.items) && null !== n.items) return n = n.items, _._findSchema(e, t, r, n);
          }
        } catch (e) {
          d.e(e);
        } finally {
          d.f();
        }

        return null;
      }, _.onRemove = function (e) {
        if (!Array.isArray(e)) return _.onRemove([e]);
        var t, i, n, r, o, s;
        e && 0 < e.length && (t = (n = e[0]).parent, i = n.editor, n = n.getIndex(), i.highlighter.unhighlight(), r = i.getDomSelection(), _.blurNodes(e), o = i.getDomSelection(), s = e.map(I), e.forEach(function (e) {
          e.parent._remove(e);
        }), i._onAction("removeNodes", {
          nodes: e,
          paths: s,
          parentPath: t.getInternalPath(),
          index: n,
          oldSelection: r,
          newSelection: o
        }));
      }, _.onDuplicate = function (e) {
        if (!Array.isArray(e)) return _.onDuplicate([e]);
        var t, n, i, r, o, s, a;
        e && 0 < e.length && (t = e[e.length - 1], n = t.parent, (i = t.editor).deselect(i.multiselection.nodes), r = i.getDomSelection(), o = t, s = e.map(function (e) {
          var t,
              i = e.clone();
          return "object" === e.parent.type && (t = e.parent.getFieldNames(), i.field = (0, k.findUniqueName)(e.field, t)), n.insertAfter(i, o), o = i;
        }), 1 === e.length ? "object" === s[0].parent.type ? (s[0].dom.field.innerHTML = e[0]._escapeHTML(e[0].field), s[0].focus("field")) : s[0].focus() : i.select(s), a = i.getDomSelection(), i._onAction("duplicateNodes", {
          paths: e.map(I),
          clonePaths: s.map(I),
          afterPath: t.getInternalPath(),
          parentPath: n.getInternalPath(),
          oldSelection: r,
          newSelection: a
        }));
      }, _.getNodeFromTarget = function (e) {
        for (; e;) {
          if (e.node) return e.node;
          e = e.parentNode;
        }
      }, _.targetIsColorPicker = function (e) {
        var t = _.getNodeFromTarget(e);

        if (t) for (var i = e && e.parentNode; i;) {
          if (i === t.dom.color) return !0;
          i = i.parentNode;
        }
        return !1;
      }, _.blurNodes = function (e) {
        var t, i;
        Array.isArray(e) ? (t = (i = e[0]).parent, i = i.getIndex(), (t.childs[i + e.length] ? t.childs[i + e.length] : t.childs[i - 1] || t).focus()) : _.blurNodes([e]);
      };
      (i.prototype = new _()).getDom = function () {
        var e = (this || _global).dom;
        if (e.tr) return e.tr;

        this._updateEditability();

        var t = document.createElement("tr"),
            i = (t.className = "jsoneditor-append", t.node = this || _global, e.tr = t, "tree" === (this || _global).editor.options.mode && (e.tdDrag = document.createElement("td"), n = document.createElement("td"), e.tdMenu = n, (i = document.createElement("button")).type = "button", i.className = "jsoneditor-button jsoneditor-contextmenu-button", i.title = "Click to open the actions menu (Ctrl+M)", e.menu = i, n.appendChild(e.menu)), document.createElement("td")),
            n = document.createElement("div");
        return n.appendChild(document.createTextNode("(" + (0, l.Iu)("empty") + ")")), n.className = "jsoneditor-readonly", i.appendChild(n), e.td = i, e.text = n, this.updateDom(), t;
      }, i.prototype.getPath = function () {
        return null;
      }, i.prototype.getIndex = function () {
        return null;
      }, i.prototype.updateDom = function (e) {
        var t = (this || _global).dom,
            i = t.td,
            n = (i && (i.style.paddingLeft = 24 * this.getLevel() + 26 + "px"), t.text),
            n = (n && (n.firstChild.nodeValue = "(" + (0, l.Iu)("empty") + " " + (this || _global).parent.type + ")"), t.tr);
        this.isVisible() ? t.tr.firstChild || (t.tdDrag && n.appendChild(t.tdDrag), t.tdMenu && n.appendChild(t.tdMenu), n.appendChild(i)) : t.tr.firstChild && (t.tdDrag && n.removeChild(t.tdDrag), t.tdMenu && n.removeChild(t.tdMenu), n.removeChild(i));
      }, i.prototype.isVisible = function () {
        return 0 === (this || _global).parent.childs.length;
      }, i.prototype.showContextMenu = function (e, t) {
        var i,
            n = this || _global,
            r = [{
          text: (0, l.Iu)("auto"),
          className: "jsoneditor-type-auto",
          title: (0, l.Iu)("autoType"),
          click: function () {
            n._onAppend("", "", "auto");
          }
        }, {
          text: (0, l.Iu)("array"),
          className: "jsoneditor-type-array",
          title: (0, l.Iu)("arrayType"),
          click: function () {
            n._onAppend("", []);
          }
        }, {
          text: (0, l.Iu)("object"),
          className: "jsoneditor-type-object",
          title: (0, l.Iu)("objectType"),
          click: function () {
            n._onAppend("", {});
          }
        }, {
          text: (0, l.Iu)("string"),
          className: "jsoneditor-type-string",
          title: (0, l.Iu)("stringType"),
          click: function () {
            n._onAppend("", "", "string");
          }
        }],
            r = (n.addTemplates(r, !0), [{
          text: (0, l.Iu)("appendText"),
          title: (0, l.Iu)("appendTitleAuto"),
          submenuTitle: (0, l.Iu)("appendSubmenuTitle"),
          className: "jsoneditor-insert",
          click: function () {
            n._onAppend("", "", "auto");
          },
          submenu: r
        }]);
        (this || _global).editor.options.onCreateMenu && (i = n.parent.getPath(), r = (this || _global).editor.options.onCreateMenu(r, {
          type: "append",
          path: i,
          paths: [i]
        })), new s.x(r, {
          close: t
        }).show(e, (this || _global).editor.getPopupAnchor());
      }, i.prototype.onEvent = function (e) {
        var t,
            i = e.type,
            n = e.target || e.srcElement,
            r = (this || _global).dom;
        n === r.menu && ("mouseover" === i ? (this || _global).editor.highlighter.highlight((this || _global).parent) : "mouseout" === i && (this || _global).editor.highlighter.unhighlight()), "click" === i && n === r.menu && ((t = (this || _global).editor.highlighter).highlight((this || _global).parent), t.lock(), (0, k.addClassName)(r.menu, "jsoneditor-selected"), this.showContextMenu(r.menu, function () {
          (0, k.removeClassName)(r.menu, "jsoneditor-selected"), t.unlock(), t.unhighlight();
        })), "keydown" === i && this.onKeyDown(e);
      };
      var L = i;

      function i(e) {
        (this || _global).editor = e, (this || _global).dom = {};
      }

      (b.prototype = new _()).getDom = function () {
        return (this || _global).dom.tr || (this._updateEditability(), (this || _global).dom.tr || (i = (t = this || _global).parent, (r = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showMore"))), r.href = "#", r.onclick = function (e) {
          return i.visibleChilds = Math.floor(i.visibleChilds / i.getMaxVisibleChilds() + 1) * i.getMaxVisibleChilds(), t.updateDom(), i.showChilds(), e.preventDefault(), !1;
        }, (o = document.createElement("a")).appendChild(document.createTextNode((0, l.Iu)("showAll"))), o.href = "#", o.onclick = function (e) {
          return i.visibleChilds = 1 / 0, t.updateDom(), i.showChilds(), e.preventDefault(), !1;
        }, e = document.createElement("div"), n = document.createTextNode(this._getShowMoreText()), e.className = "jsoneditor-show-more", e.appendChild(n), e.appendChild(r), e.appendChild(document.createTextNode(". ")), e.appendChild(o), e.appendChild(document.createTextNode(". ")), (r = document.createElement("td")).appendChild(e), o = document.createElement("tr"), "tree" === (this || _global).editor.options.mode && (o.appendChild(document.createElement("td")), o.appendChild(document.createElement("td"))), o.appendChild(r), o.className = "jsoneditor-show-more", (this || _global).dom.tr = o, (this || _global).dom.moreContents = e, (this || _global).dom.moreText = n), this.updateDom(), (this || _global).dom.tr);
        var t, i, e, n, r, o;
      }, b.prototype.updateDom = function (e) {
        var t;
        this.isVisible() ? ((this || _global).dom.tr.node = (this || _global).parent.childs[(this || _global).parent.visibleChilds], (this || _global).dom.tr.parentNode || (t = (this || _global).parent._getNextTr()) && t.parentNode.insertBefore((this || _global).dom.tr, t), (this || _global).dom.moreText.nodeValue = this._getShowMoreText(), (this || _global).dom.moreContents.style.marginLeft = 24 * (this.getLevel() + 1) + "px") : (this || _global).dom.tr && (this || _global).dom.tr.parentNode && (this || _global).dom.tr.parentNode.removeChild((this || _global).dom.tr);
      }, b.prototype._getShowMoreText = function () {
        return (0, l.Iu)("showMoreStatus", {
          visibleChilds: (this || _global).parent.visibleChilds,
          totalChilds: (this || _global).parent.childs.length
        }) + " ";
      }, b.prototype.isVisible = function () {
        return (this || _global).parent.expanded && (this || _global).parent.childs.length > (this || _global).parent.visibleChilds;
      }, b.prototype.onEvent = function (e) {
        "keydown" === e.type && this.onKeyDown(e);
      };
      var A = b;

      function b(e, t) {
        (this || _global).editor = e, (this || _global).parent = t, (this || _global).dom = {};
      }

      function y(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var P = function () {
        function e(t) {
          if (!((this || _global) instanceof e)) throw new TypeError("Cannot call a class as a function");

          function o(e) {
            return t.node.findNodeByInternalPath(e);
          }

          (this || _global).editor = t, (this || _global).history = [], (this || _global).index = -1, this.clear(), (this || _global).actions = {
            editField: {
              undo: function (e) {
                o(e.parentPath).childs[e.index].updateField(e.oldValue);
              },
              redo: function (e) {
                o(e.parentPath).childs[e.index].updateField(e.newValue);
              }
            },
            editValue: {
              undo: function (e) {
                o(e.path).updateValue(e.oldValue);
              },
              redo: function (e) {
                o(e.path).updateValue(e.newValue);
              }
            },
            changeType: {
              undo: function (e) {
                o(e.path).changeType(e.oldType);
              },
              redo: function (e) {
                o(e.path).changeType(e.newType);
              }
            },
            appendNodes: {
              undo: function (e) {
                var t = o(e.parentPath);
                e.paths.map(o).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = o(e.parentPath);
                e.nodes.forEach(function (e) {
                  t.appendChild(e);
                });
              }
            },
            insertBeforeNodes: {
              undo: function (e) {
                var t = o(e.parentPath);
                e.paths.map(o).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = o(e.parentPath),
                    i = o(e.beforePath);
                e.nodes.forEach(function (e) {
                  t.insertBefore(e, i);
                });
              }
            },
            insertAfterNodes: {
              undo: function (e) {
                var t = o(e.parentPath);
                e.paths.map(o).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var t = o(e.parentPath),
                    i = o(e.afterPath);
                e.nodes.forEach(function (e) {
                  t.insertAfter(e, i), i = e;
                });
              }
            },
            removeNodes: {
              undo: function (e) {
                var t = o(e.parentPath),
                    i = t.childs[e.index] || t.append;
                e.nodes.forEach(function (e) {
                  t.insertBefore(e, i);
                });
              },
              redo: function (e) {
                var t = o(e.parentPath);
                e.paths.map(o).forEach(function (e) {
                  t.removeChild(e);
                });
              }
            },
            duplicateNodes: {
              undo: function (e) {
                var t = o(e.parentPath);
                e.clonePaths.map(o).forEach(function (e) {
                  t.removeChild(e);
                });
              },
              redo: function (e) {
                var n = o(e.parentPath),
                    r = o(e.afterPath);
                e.paths.map(o).forEach(function (e) {
                  var t,
                      i = e.clone();
                  "object" === n.type && (t = n.getFieldNames(), i.field = (0, k.findUniqueName)(e.field, t)), n.insertAfter(i, r), r = i;
                });
              }
            },
            moveNodes: {
              undo: function (i) {
                var n = o(i.oldParentPath),
                    e = o(i.newParentPath),
                    r = n.childs[i.oldIndex] || n.append;
                e.childs.slice(i.newIndex, i.newIndex + i.count).forEach(function (e, t) {
                  e.field = i.fieldNames[t], n.moveBefore(e, r);
                }), null === i.newParentPathRedo && (i.newParentPathRedo = e.getInternalPath());
              },
              redo: function (i) {
                var e = o(i.oldParentPathRedo),
                    n = o(i.newParentPathRedo),
                    r = n.childs[i.newIndexRedo] || n.append;
                e.childs.slice(i.oldIndexRedo, i.oldIndexRedo + i.count).forEach(function (e, t) {
                  e.field = i.fieldNames[t], n.moveBefore(e, r);
                });
              }
            },
            sort: {
              undo: function (e) {
                var t = o(e.path);
                t.hideChilds(), t.childs = e.oldChilds, t.updateDom({
                  updateIndexes: !0
                }), t.showChilds();
              },
              redo: function (e) {
                var t = o(e.path);
                t.hideChilds(), t.childs = e.newChilds, t.updateDom({
                  updateIndexes: !0
                }), t.showChilds();
              }
            },
            transform: {
              undo: function (e) {
                o(e.path).setInternalValue(e.oldValue);
              },
              redo: function (e) {
                o(e.path).setInternalValue(e.newValue);
              }
            }
          };
        }

        var t, i, n;
        return t = e, (i = [{
          key: "onChange",
          value: function () {}
        }, {
          key: "add",
          value: function (e, t) {
            (this || _global).index++, (this || _global).history[(this || _global).index] = {
              action: e,
              params: t,
              timestamp: new Date()
            }, (this || _global).index < (this || _global).history.length - 1 && (this || _global).history.splice((this || _global).index + 1, (this || _global).history.length - (this || _global).index - 1), this.onChange();
          }
        }, {
          key: "clear",
          value: function () {
            (this || _global).history = [], (this || _global).index = -1, this.onChange();
          }
        }, {
          key: "canUndo",
          value: function () {
            return 0 <= (this || _global).index;
          }
        }, {
          key: "canRedo",
          value: function () {
            return (this || _global).index < (this || _global).history.length - 1;
          }
        }, {
          key: "undo",
          value: function () {
            if (this.canUndo()) {
              var e = (this || _global).history[(this || _global).index];

              if (e) {
                var t = (this || _global).actions[e.action];

                if (t && t.undo) {
                  if (t.undo(e.params), e.params.oldSelection) try {
                    (this || _global).editor.setDomSelection(e.params.oldSelection);
                  } catch (e) {
                    console.error(e);
                  }
                } else console.error(new Error("unknown action \"" + e.action + "\""));
              }

              (this || _global).index--, this.onChange();
            }
          }
        }, {
          key: "redo",
          value: function () {
            if (this.canRedo()) {
              (this || _global).index++;
              var e = (this || _global).history[(this || _global).index];

              if (e) {
                var t = (this || _global).actions[e.action];

                if (t && t.redo) {
                  if (t.redo(e.params), e.params.newSelection) try {
                    (this || _global).editor.setDomSelection(e.params.newSelection);
                  } catch (e) {
                    console.error(e);
                  }
                } else console.error(new Error("unknown action \"" + e.action + "\""));
              }

              this.onChange();
            }
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).editor = null, (this || _global).history = [], (this || _global).index = -1;
          }
        }]) && y(t.prototype, i), n && y(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }();

      function B(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var F = function () {
        function r(e, t) {
          if (!((this || _global) instanceof r)) throw new TypeError("Cannot call a class as a function");
          var i = this || _global,
              e = ((this || _global).editor = e, (this || _global).timeout = void 0, (this || _global).delay = 200, (this || _global).lastText = void 0, (this || _global).results = null, (this || _global).dom = {}, (this || _global).dom.container = t, document.createElement("div")),
              t = (((this || _global).dom.wrapper = e).className = "jsoneditor-search", t.appendChild(e), document.createElement("div")),
              t = (((this || _global).dom.results = t).className = "jsoneditor-results", e.appendChild(t), document.createElement("div")),
              e = (((this || _global).dom.input = t).className = "jsoneditor-frame", t.title = (0, l.Iu)("searchTitle"), e.appendChild(t), document.createElement("button")),
              n = (e.type = "button", e.className = "jsoneditor-refresh", t.appendChild(e), document.createElement("input")),
              e = (n.type = "text", ((this || _global).dom.search = n).oninput = function (e) {
            i._onDelayedSearch(e);
          }, n.onchange = function (e) {
            i._onSearch();
          }, n.onkeydown = function (e) {
            i._onKeyDown(e);
          }, n.onkeyup = function (e) {
            i._onKeyUp(e);
          }, e.onclick = function (e) {
            n.select();
          }, t.appendChild(n), document.createElement("button")),
              e = (e.type = "button", e.title = (0, l.Iu)("searchNextResultTitle"), e.className = "jsoneditor-next", e.onclick = function () {
            i.next();
          }, t.appendChild(e), document.createElement("button"));
          e.type = "button", e.title = (0, l.Iu)("searchPreviousResultTitle"), e.className = "jsoneditor-previous", e.onclick = function () {
            i.previous();
          }, t.appendChild(e);
        }

        var e, t, i;
        return e = r, (t = [{
          key: "next",
          value: function (e) {
            var t;
            (this || _global).results && ((t = null !== (this || _global).resultIndex ? (this || _global).resultIndex + 1 : 0) > (this || _global).results.length - 1 && (t = 0), this._setActiveResult(t, e));
          }
        }, {
          key: "previous",
          value: function (e) {
            var t, i;
            (this || _global).results && (t = (this || _global).results.length - 1, i = null !== (this || _global).resultIndex ? (this || _global).resultIndex - 1 : t, this._setActiveResult(i = i < 0 ? t : i, e));
          }
        }, {
          key: "_setActiveResult",
          value: function (e, t) {
            var i;
            if ((this || _global).activeResult && (i = (this || _global).activeResult.node, "field" === (this || _global).activeResult.elem ? delete i.searchFieldActive : delete i.searchValueActive, i.updateDom()), !(this || _global).results || !(this || _global).results[e]) return (this || _global).resultIndex = void 0, void ((this || _global).activeResult = void 0);
            (this || _global).resultIndex = e;
            var n = (this || _global).results[(this || _global).resultIndex].node,
                r = (this || _global).results[(this || _global).resultIndex].elem;
            "field" === r ? n.searchFieldActive = !0 : n.searchValueActive = !0, (this || _global).activeResult = (this || _global).results[(this || _global).resultIndex], n.updateDom(), n.scrollTo(function () {
              t && n.focus(r);
            });
          }
        }, {
          key: "_clearDelay",
          value: function () {
            void 0 !== (this || _global).timeout && (clearTimeout((this || _global).timeout), delete (this || _global).timeout);
          }
        }, {
          key: "_onDelayedSearch",
          value: function (e) {
            this._clearDelay();

            var t = this || _global;
            (this || _global).timeout = setTimeout(function (e) {
              t._onSearch();
            }, (this || _global).delay);
          }
        }, {
          key: "_onSearch",
          value: function (e) {
            this._clearDelay();

            var t = (this || _global).dom.search.value,
                t = 0 < t.length ? t : void 0;

            if (t !== (this || _global).lastText || e) {
              (this || _global).lastText = t, (this || _global).results = (this || _global).editor.search(t);
              var e = (this || _global).results[0] ? (this || _global).results[0].node.MAX_SEARCH_RESULTS : 1 / 0,
                  i = 0;
              if ((this || _global).activeResult) for (var n = 0; n < (this || _global).results.length; n++) if ((this || _global).results[n].node === (this || _global).activeResult.node) {
                i = n;
                break;
              }
              this._setActiveResult(i, !1), void 0 !== t ? (t = (this || _global).results.length, (this || _global).dom.results.textContent = 0 === t ? "no\xA0results" : 1 === t ? "1\xA0result" : e < t ? e + "+\xA0results" : t + "\xA0results") : (this || _global).dom.results.textContent = "";
            }
          }
        }, {
          key: "_onKeyDown",
          value: function (e) {
            var t = e.which;
            27 === t ? ((this || _global).dom.search.value = "", this._onSearch(), e.preventDefault(), e.stopPropagation()) : 13 === t && (e.ctrlKey ? this._onSearch(!0) : e.shiftKey ? this.previous() : this.next(), e.preventDefault(), e.stopPropagation());
          }
        }, {
          key: "_onKeyUp",
          value: function (e) {
            var t = e.keyCode;
            27 !== t && 13 !== t && this._onDelayedSearch(e);
          }
        }, {
          key: "clear",
          value: function () {
            (this || _global).dom.search.value = "", this._onSearch();
          }
        }, {
          key: "forceSearch",
          value: function () {
            this._onSearch(!0);
          }
        }, {
          key: "isEmpty",
          value: function () {
            return "" === (this || _global).dom.search.value;
          }
        }, {
          key: "destroy",
          value: function () {
            (this || _global).editor = null, (this || _global).dom.container.removeChild((this || _global).dom.wrapper), (this || _global).dom = null, (this || _global).results = null, (this || _global).activeResult = null, this._clearDelay();
          }
        }]) && B(e.prototype, t), i && B(e, i), Object.defineProperty(e, "prototype", {
          writable: !1
        }), r;
      }();

      function W(e, t) {
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      var H = function () {
        function i(e, t) {
          if (!((this || _global) instanceof i)) throw new TypeError("Cannot call a class as a function");
          e && ((this || _global).root = t, (this || _global).path = document.createElement("div"), (this || _global).path.className = "jsoneditor-treepath", (this || _global).path.setAttribute("tabindex", 0), (this || _global).contentMenuClicked = !1, e.appendChild((this || _global).path), this.reset());
        }

        var e, t, n;
        return e = i, (t = [{
          key: "reset",
          value: function () {
            (this || _global).path.textContent = (0, l.Iu)("selectNode");
          }
        }, {
          key: "setPath",
          value: function (r) {
            var o = this || _global;
            (this || _global).path.textContent = "", r && r.length && r.forEach(function (i, n) {
              var e,
                  t = document.createElement("span");
              t.className = "jsoneditor-treepath-element", t.innerText = i.name, t.onclick = function (e) {
                (this || _global).selectionCallback && this.selectionCallback(e);
              }.bind(o, i), o.path.appendChild(t), i.children.length && ((e = document.createElement("span")).className = "jsoneditor-treepath-seperator", e.textContent = "\u25BA", e.onclick = function () {
                o.contentMenuClicked = !0;
                var t = [];
                i.children.forEach(function (e) {
                  t.push({
                    text: e.name,
                    className: "jsoneditor-type-modes" + (r[n + 1] + 1 && r[n + 1].name === e.name ? " jsoneditor-selected" : ""),
                    click: function (e, t) {
                      (this || _global).contextMenuCallback && this.contextMenuCallback(e, t);
                    }.bind(o, i, e.name)
                  });
                }), new s.x(t, {
                  limitHeight: !0
                }).show(e, o.root, !0);
              }, o.path.appendChild(e)), n === r.length - 1 && (t = (e || t).getBoundingClientRect().right, o.path.offsetWidth < t && (o.path.scrollLeft = t), o.path.scrollLeft && ((t = document.createElement("span")).className = "jsoneditor-treepath-show-all-btn", t.title = "show all path", t.textContent = "...", t.onclick = function (e) {
                (o.contentMenuClicked = !1, k.addClassName)(o.path, "show-all"), o.path.style.width = o.path.parentNode.getBoundingClientRect().width - 10 + "px", o.path.onblur = function () {
                  if (o.contentMenuClicked) return o.contentMenuClicked = !1, void o.path.focus();
                  (0, k.removeClassName)(o.path, "show-all"), o.path.onblur = void 0, o.path.style.width = "", o.setPath(e);
                };
              }.bind(o, r), o.path.insertBefore(t, o.path.firstChild)));
            });
          }
        }, {
          key: "onSectionSelected",
          value: function (e) {
            "function" == typeof e && ((this || _global).selectionCallback = e);
          }
        }, {
          key: "onContextMenuItemSelected",
          value: function (e) {
            "function" == typeof e && ((this || _global).contextMenuCallback = e);
          }
        }]) && W(e.prototype, t), n && W(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), i;
      }(),
          e = t(8037),
          N = t.n(e),
          t = {},
          V = (t.create = function (e, t) {
        if (!e) throw new Error("No container element provided.");

        function o(e) {
          var t, i;
          document.createRange ? ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (i = window.getSelection()).removeAllRanges(), i.addRange(t)) : document.selection && ((t = document.body.createTextRange()).moveToElementText(e), t.collapse(!1), t.select());
        }

        function s(e) {
          return void 0 === i && ((i = document.createElement("span")).style.visibility = "hidden", i.style.position = "fixed", i.style.outline = "0", i.style.margin = "0", i.style.padding = "0", i.style.border = "0", i.style.left = "0", i.style.whiteSpace = "pre", i.style.fontSize = r, i.style.fontFamily = u, i.style.fontWeight = "normal", document.body.appendChild(i)), i.textContent = e, i.getBoundingClientRect().right;
        }

        function a() {
          (this || _global).style.backgroundColor = "#ddd";
        }

        function l() {
          (this || _global).style.backgroundColor = "";
        }

        function c() {
          I.hide(), I.onmouseselection((this || _global).__hint, I.rs);
        }

        var h, i, d, r, u, g, p, m, f, C, n, I, v, A, b, y;
        (this || _global).container = e, (this || _global).dom = {}, (this || _global).highlighter = new S(), (this || _global).selection = void 0, (this || _global).multiselection = {
          nodes: []
        }, (this || _global).validateSchema = null, (this || _global).validationSequence = 0, (this || _global).errorNodes = [], (this || _global).lastSchemaErrors = void 0, (this || _global).node = null, (this || _global).focusTarget = null, this._setOptions(t), t.autocomplete && ((this || _global).autocomplete = ((h = (h = t.autocomplete) || {}).filter = h.filter || "start", h.trigger = h.trigger || "keydown", h.confirmKeys = h.confirmKeys || [39, 35, 9], h.caseSensitive = h.caseSensitive || !1, u = r = "", (g = document.createElement("div")).style.position = "relative", g.style.outline = "0", g.style.border = "0", g.style.margin = "0", g.style.padding = "0", (p = document.createElement("div")).className = "autocomplete dropdown", p.style.position = "absolute", p.style.visibility = "hidden", m = p, f = [], n = -1, A = I = {
          rs: v = {
            onArrowDown: function () {},
            onArrowUp: function () {},
            onEnter: function () {},
            onTab: function () {},
            startFrom: C = 0,
            options: [],
            element: null,
            elementHint: null,
            elementStyle: null,
            wrapper: g,
            show: function (e, t, i) {
              var n = this || _global;
              (this || _global).startFrom = t, (this || _global).wrapper.remove(), (this || _global).elementHint && ((this || _global).elementHint.remove(), (this || _global).elementHint = null), "" === r && (r = window.getComputedStyle(e).getPropertyValue("font-size")), "" === u && (u = window.getComputedStyle(e).getPropertyValue("font-family")), p.style.marginLeft = "0", p.style.marginTop = e.getBoundingClientRect().height + "px", (this || _global).options = i.map(String), (this || _global).element !== e && ((this || _global).element = e, (this || _global).elementStyle = {
                zIndex: (this || _global).element.style.zIndex,
                position: (this || _global).element.style.position,
                backgroundColor: (this || _global).element.style.backgroundColor,
                borderColor: (this || _global).element.style.borderColor
              }), (this || _global).element.style.zIndex = 3, (this || _global).element.style.position = "relative", (this || _global).element.style.backgroundColor = "transparent", (this || _global).element.style.borderColor = "transparent", (this || _global).elementHint = e.cloneNode(), (this || _global).elementHint.className = "autocomplete hint", (this || _global).elementHint.style.zIndex = 2, (this || _global).elementHint.style.position = "absolute", (this || _global).elementHint.onfocus = function () {
                n.element.focus();
              }, (this || _global).element.addEventListener && ((this || _global).element.removeEventListener("keydown", b), (this || _global).element.addEventListener("keydown", b, !1), (this || _global).element.removeEventListener("blur", y), (this || _global).element.addEventListener("blur", y, !1)), g.appendChild((this || _global).elementHint), g.appendChild(p), e.parentElement.appendChild(g), this.repaint(e);
            },
            setText: function (e) {
              (this || _global).element.innerText = e;
            },
            getText: function () {
              return (this || _global).element.innerText;
            },
            hideDropDown: function () {
              (this || _global).wrapper.remove(), (this || _global).elementHint && ((this || _global).elementHint.remove(), (this || _global).elementHint = null, A.hide(), (this || _global).element.style.zIndex = (this || _global).elementStyle.zIndex, (this || _global).element.style.position = (this || _global).elementStyle.position, (this || _global).element.style.backgroundColor = (this || _global).elementStyle.backgroundColor, (this || _global).element.style.borderColor = (this || _global).elementStyle.borderColor);
            },
            repaint: function (e) {
              var e = (e = e.innerText).replace("\n", ""),
                  t = (this || _global).options.length,
                  i = e.substring((this || _global).startFrom);
              d = e.substring(0, (this || _global).startFrom);

              for (var n = 0; n < t; n++) {
                var r = (this || _global).options[n];

                if (!h.caseSensitive && 0 === r.toLowerCase().indexOf(i.toLowerCase()) || h.caseSensitive && 0 === r.indexOf(i)) {
                  (this || _global).elementHint.innerText = d + i + r.substring(i.length), (this || _global).elementHint.realInnerText = d + r;
                  break;
                }
              }

              p.style.left = s(d) + "px", A.refresh(i, (this || _global).options), (this || _global).elementHint.style.width = s((this || _global).elementHint.innerText) + 10 + "px", "hidden" !== p.style.visibility && ((this || _global).elementHint.style.width = s((this || _global).elementHint.innerText) + p.clientWidth + "px");
            }
          },
          hide: function () {
            m.style.visibility = "hidden";
          },
          refresh: function (n, e) {
            m.style.visibility = "hidden", C = 0, m.textContent = "";
            var t = window.innerHeight || document.documentElement.clientHeight,
                i = m.parentNode.getBoundingClientRect(),
                r = i.top - 6,
                t = t - i.bottom - 6,
                o = (f = [], "function" == typeof h.filter ? h.filter : w[h.filter]),
                i = o ? e.filter(function (e) {
              return o(h.caseSensitive ? n : n.toLowerCase(), h.caseSensitive ? e : e.toLowerCase(), h);
            }) : [];
            0 === (f = i.map(function (e) {
              var t = document.createElement("div"),
                  i = (t.className = "item", t.onmouseover = a, t.onmouseout = l, t.onmousedown = c, t.__hint = e, t.textContent = "", t.appendChild(document.createTextNode(e.substring(0, n.length))), document.createElement("b"));
              return i.appendChild(document.createTextNode(e.substring(n.length))), t.appendChild(i), m.appendChild(t), t;
            })).length || 1 === f.length && (n.toLowerCase() === f[0].__hint.toLowerCase() && !h.caseSensitive || n === f[0].__hint && h.caseSensitive) || f.length < 2 || (I.highlight(0), 3 * t < r ? (m.style.maxHeight = r + "px", m.style.top = "", m.style.bottom = "100%") : (m.style.top = "100%", m.style.bottom = "", m.style.maxHeight = t + "px"), m.style.visibility = "visible");
          },
          highlight: function (e) {
            -1 !== n && f[n] && (f[n].className = "item"), f[e].className = "item hover", n = e;
          },
          move: function (e) {
            return "hidden" === m.style.visibility ? "" : (C + e === -1 || C + e === f.length || (C += e, I.highlight(C)), f[C].__hint);
          },
          onmouseselection: function () {}
        }, b = function (e) {
          var t = (e = e || window.event).keyCode;

          if (null != (this || _global).elementHint && 33 !== t && 34 !== t) {
            if (27 === t) return v.hideDropDown(), v.element.focus(), e.preventDefault(), void e.stopPropagation();

            var i,
                n = (n = (this || _global).element.innerText).replace("\n", "");

            if (0 <= h.confirmKeys.indexOf(t)) return 9 === t && 0 === (this || _global).elementHint.innerText.length && v.onTab(), void (0 < (this || _global).elementHint.innerText.length && (this || _global).element.innerText !== (this || _global).elementHint.realInnerText && ((this || _global).element.innerText = (this || _global).elementHint.realInnerText, v.hideDropDown(), o((this || _global).element), 9 === t && (v.element.focus(), e.preventDefault(), e.stopPropagation())));
            if (13 === t) {
              if (0 === (this || _global).elementHint.innerText.length) v.onEnter();else {
                var r = "hidden" === p.style.visibility;
                if (A.hide(), r) return v.hideDropDown(), v.element.focus(), void v.onEnter();
                (this || _global).element.innerText = (this || _global).elementHint.realInnerText, v.hideDropDown(), o((this || _global).element), e.preventDefault(), e.stopPropagation();
              }
            } else {
              if (40 === t) return r = n.substring((this || _global).startFrom), "" === (i = A.move(1)) && v.onArrowDown(), (this || _global).elementHint.innerText = d + r + i.substring(r.length), (this || _global).elementHint.realInnerText = d + i, e.preventDefault(), void e.stopPropagation();
              38 === t && (r = n.substring((this || _global).startFrom), "" === (i = A.move(-1)) && v.onArrowUp(), (this || _global).elementHint.innerText = d + r + i.substring(r.length), (this || _global).elementHint.realInnerText = d + i, e.preventDefault(), e.stopPropagation());
            }
          }
        }.bind(v), y = function (e) {
          v.hideDropDown();
        }, A.onmouseselection = function (e, t) {
          t.element.innerText = t.elementHint.innerText = d + e, t.hideDropDown(), window.setTimeout(function () {
            t.element.focus(), o(t.element);
          }, 1);
        }, v)), (this || _global).options.history && "view" !== (this || _global).options.mode && ((this || _global).history = new P(this || _global)), this._createFrame(), this._createTable();
      }, t.destroy = function () {
        (this || _global).frame && (this || _global).container && (this || _global).frame.parentNode === (this || _global).container && ((this || _global).container.removeChild((this || _global).frame), (this || _global).frame = null), (this || _global).container = null, (this || _global).dom = null, this.clear(), (this || _global).node = null, (this || _global).focusTarget = null, (this || _global).selection = null, (this || _global).multiselection = null, (this || _global).errorNodes = null, (this || _global).validateSchema = null, (this || _global)._debouncedValidate = null, (this || _global).history && ((this || _global).history.destroy(), (this || _global).history = null), (this || _global).searchBox && ((this || _global).searchBox.destroy(), (this || _global).searchBox = null), (this || _global).modeSwitcher && ((this || _global).modeSwitcher.destroy(), (this || _global).modeSwitcher = null), (this || _global).frameFocusTracker.destroy();
      }, t._setOptions = function (t) {
        var i = this || _global;
        (this || _global).options = {
          search: !0,
          history: !0,
          mode: "tree",
          name: void 0,
          schema: null,
          schemaRefs: null,
          autocomplete: null,
          navigationBar: !0,
          mainMenuBar: !0,
          limitDragging: !1,
          onSelectionChange: null,
          colorPicker: !0,
          onColorPicker: function (e, t, i) {
            var n;
            N() ? (n = e.getBoundingClientRect().top, n = (0, k.getWindow)(e).innerHeight - n < 300 && 300 < n, new (N())({
              parent: e,
              color: t,
              popup: n ? "top" : "bottom",
              onDone: function (e) {
                e = 1 === e.rgba[3] ? e.hex.substr(0, 7) : e.hex;
                i(e);
              }
            }).show()) : console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
          },
          timestampTag: !0,
          timestampFormat: null,
          createQuery: n.r,
          executeQuery: n.J,
          onEvent: null,
          enableSort: !0,
          enableTransform: !0
        }, t && (Object.keys(t).forEach(function (e) {
          i.options[e] = t[e];
        }), null == t.limitDragging && null != t.schema && ((this || _global).options.limitDragging = !0)), this.setSchema((this || _global).options.schema, (this || _global).options.schemaRefs), (this || _global)._debouncedValidate = (0, k.debounce)((this || _global)._validateAndCatch.bind(this || _global), (this || _global).DEBOUNCE_INTERVAL), t.onSelectionChange && this.onSelectionChange(t.onSelectionChange), (0, l.cC)((this || _global).options.languages), (0, l.m0)((this || _global).options.language);
      }, t.set = function (e) {
        e instanceof Function || void 0 === e ? this.clear() : ((this || _global).content.removeChild((this || _global).table), e = {
          field: (this || _global).options.name,
          value: e
        }, e = new _(this || _global, e), this._setRoot(e), this._validateAndCatch(), (this || _global).node.expand(!1), (this || _global).content.appendChild((this || _global).table)), (this || _global).history && (this || _global).history.clear(), (this || _global).searchBox && (this || _global).searchBox.clear();
      }, t.update = function (e) {
        var t, i;
        (this || _global).node.deepEqual(e) || (t = this.getSelection(), (this || _global).onChangeDisabled = !0, (this || _global).node.update(e), (this || _global).onChangeDisabled = !1, this._validateAndCatch(), (this || _global).searchBox && !(this || _global).searchBox.isEmpty() && (this || _global).searchBox.forceSearch(), t && t.start && t.end ? (e = (this || _global).node.findNodeByPath(t.start.path), i = (this || _global).node.findNodeByPath(t.end.path), e && i ? this.setSelection(t.start, t.end) : this.setSelection({}, {})) : this.setSelection({}, {}));
      }, t.get = function () {
        if ((this || _global).node) return (this || _global).node.getValue();
      }, t.getText = function () {
        return JSON.stringify(this.get());
      }, t.setText = function (t) {
        try {
          this.set((0, k.parse)(t));
        } catch (e) {
          t = (0, k.tryJsonRepair)(t);
          this.set((0, k.parse)(t));
        }
      }, t.updateText = function (t) {
        try {
          this.update((0, k.parse)(t));
        } catch (e) {
          t = (0, k.tryJsonRepair)(t);
          this.update((0, k.parse)(t));
        }
      }, t.setName = function (e) {
        (this || _global).options.name = e, (this || _global).node && (this || _global).node.updateField((this || _global).options.name);
      }, t.getName = function () {
        return (this || _global).options.name;
      }, t.focus = function () {
        var e = (this || _global).scrollableContent.querySelector("[contenteditable=true]");

        e ? e.focus() : (this || _global).node.dom.expand ? (this || _global).node.dom.expand.focus() : (this || _global).node.dom.menu ? (this || _global).node.dom.menu.focus() : (e = (this || _global).frame.querySelector("button")) && e.focus();
      }, t.clear = function () {
        (this || _global).node && ((this || _global).node.hide(), delete (this || _global).node), (this || _global).treePath && (this || _global).treePath.reset();
      }, t._setRoot = function (e) {
        this.clear(), ((this || _global).node = e).setParent(null), e.setField(this.getName(), !1), delete e.index, (this || _global).tbody.appendChild(e.getDom());
      }, t.search = function (e) {
        var t;
        return (this || _global).node ? ((this || _global).content.removeChild((this || _global).table), t = (this || _global).node.search(e), (this || _global).content.appendChild((this || _global).table)) : t = [], t;
      }, t.expandAll = function () {
        (this || _global).node && ((this || _global).content.removeChild((this || _global).table), (this || _global).node.expand(), (this || _global).content.appendChild((this || _global).table));
      }, t.collapseAll = function () {
        (this || _global).node && ((this || _global).content.removeChild((this || _global).table), (this || _global).node.collapse(), (this || _global).content.appendChild((this || _global).table));
      }, t._onAction = function (e, t) {
        (this || _global).history && (this || _global).history.add(e, t), this._onChange();
      }, t._onChange = function () {
        if (!(this || _global).onChangeDisabled) {
          var e;
          if ((this || _global).selection = this.getDomSelection(), this._debouncedValidate(), (this || _global).treePath && ((e = (this || _global).node && (this || _global).selection ? (this || _global).node.findNodeByInternalPath((this || _global).selection.path) : (this || _global).multiselection ? (this || _global).multiselection.nodes[0] : void 0) ? this._updateTreePath(e.getNodePath()) : (this || _global).treePath.reset()), (this || _global).options.onChange) try {
            (this || _global).options.onChange();
          } catch (e) {
            console.error("Error in onChange callback: ", e);
          }
          if ((this || _global).options.onChangeJSON) try {
            (this || _global).options.onChangeJSON(this.get());
          } catch (e) {
            console.error("Error in onChangeJSON callback: ", e);
          }
          if ((this || _global).options.onChangeText) try {
            (this || _global).options.onChangeText(this.getText());
          } catch (e) {
            console.error("Error in onChangeText callback: ", e);
          }
          if ((this || _global).options.onClassName && (this || _global).node.recursivelyUpdateCssClassesOnNodes(), (this || _global).options.onNodeName && (this || _global).node.childs) try {
            (this || _global).node.recursivelyUpdateNodeName();
          } catch (e) {
            console.error("Error in onNodeName callback: ", e);
          }
        }
      }, t.validate = function () {
        var t = this || _global,
            i = (this || _global).node;

        if (i) {
          var e = i.getValue(),
              n = [];
          (this || _global).validateSchema && !this.validateSchema(e) && (n = (this || _global).validateSchema.errors.map(function (e) {
            return (0, k.improveSchemaError)(e);
          }).map(function (e) {
            return {
              node: i.findNode(e.dataPath),
              error: e,
              type: "validation"
            };
          }).filter(function (e) {
            return null != e.node;
          }));

          try {
            (this || _global).validationSequence++;
            var r = this || _global,
                o = (this || _global).validationSequence;
            return this._validateCustom(e).then(function (e) {
              return o === r.validationSequence && (e = [].concat(n, e || []), r._renderValidationErrors(e), "function" == typeof t.options.onValidationError && (0, k.isValidationErrorChanged)(e, t.lastSchemaErrors) && t.options.onValidationError.call(t, e), t.lastSchemaErrors = e), t.lastSchemaErrors;
            });
          } catch (e) {
            return Promise.reject(e);
          }
        }
      }, t._validateAndCatch = function () {
        this.validate().catch(function (e) {
          console.error("Error running validation:", e);
        });
      }, t._renderValidationErrors = function (e) {
        (this || _global).errorNodes && (this || _global).errorNodes.forEach(function (e) {
          e.setError(null);
        });
        var t = e.reduce(function (e, t) {
          return t.node.findParents().filter(function (t) {
            return !e.some(function (e) {
              return e[0] === t;
            });
          }).map(function (e) {
            return [e, t.node];
          }).concat(e);
        }, []);
        (this || _global).errorNodes = t.map(function (e) {
          return {
            node: e[0],
            child: e[1],
            error: {
              message: "object" === e[0].type ? (0, l.Iu)("containsInvalidProperties") : (0, l.Iu)("containsInvalidItems")
            }
          };
        }).concat(e).map(function (e) {
          return e.node.setError(e.error, e.child), e.node;
        });
      }, t._validateCustom = function (e) {
        try {
          var i, t;
          if ((this || _global).options.onValidate) return i = (this || _global).node, t = (this || _global).options.onValidate(e), ((0, k.isPromise)(t) ? t : Promise.resolve(t)).then(function (e) {
            return Array.isArray(e) ? e.filter(function (e) {
              var t = (0, k.isValidValidationError)(e);
              return t || console.warn("Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: \"...\"}. Actual error:", e), t;
            }).map(function (e) {
              var t;

              try {
                t = e && e.path ? i.findNodeByPath(e.path) : null;
              } catch (e) {}

              return t || console.warn("Ignoring validation error: node not found. Path:", e.path, "Error:", e), {
                node: t,
                error: e,
                type: "customValidation"
              };
            }).filter(function (e) {
              return e && e.node && e.error && e.error.message;
            }) : null;
          });
        } catch (e) {
          return Promise.reject(e);
        }

        return Promise.resolve(null);
      }, t.refresh = function () {
        (this || _global).node && (this || _global).node.updateDom({
          recurse: !0
        });
      }, t.startAutoScroll = function (e) {
        var t = this || _global,
            i = (this || _global).scrollableContent,
            n = (0, k.getAbsoluteTop)(i),
            r = i.clientHeight,
            o = n + r;
        e < n + 24 && 0 < i.scrollTop ? (this || _global).autoScrollStep = (n + 24 - e) / 3 : o - 24 < e && r + i.scrollTop < i.scrollHeight ? (this || _global).autoScrollStep = (o - 24 - e) / 3 : (this || _global).autoScrollStep = void 0, (this || _global).autoScrollStep ? (this || _global).autoScrollTimer || ((this || _global).autoScrollTimer = setInterval(function () {
          t.autoScrollStep ? i.scrollTop -= t.autoScrollStep : t.stopAutoScroll();
        }, 50)) : this.stopAutoScroll();
      }, t.stopAutoScroll = function () {
        (this || _global).autoScrollTimer && (clearTimeout((this || _global).autoScrollTimer), delete (this || _global).autoScrollTimer), (this || _global).autoScrollStep && delete (this || _global).autoScrollStep;
      }, t.setDomSelection = function (e) {
        var t, i, n;
        e && ("scrollTop" in e && (this || _global).scrollableContent && ((this || _global).scrollableContent.scrollTop = e.scrollTop), e.paths ? (t = this || _global, i = e.paths.map(function (e) {
          return t.node.findNodeByInternalPath(e);
        }), this.select(i)) : (n = (i = e.path ? (this || _global).node.findNodeByInternalPath(e.path) : null) && e.domName ? i.dom[e.domName] : null, e.range && n ? (e = Object.assign({}, e.range, {
          container: n
        }), (0, k.setSelectionOffset)(e)) : i && i.focus()));
      }, t.getDomSelection = function () {
        var t = _.getNodeFromTarget((this || _global).focusTarget),
            i = (this || _global).focusTarget,
            e = t ? Object.keys(t.dom).find(function (e) {
          return t.dom[e] === i;
        }) : null,
            n = (0, k.getSelectionOffset)();

        return (n = (n = n && "DIV" !== n.container.nodeName ? null : n) && n.container !== i ? null : n) && delete n.container, {
          path: t ? t.getInternalPath() : null,
          domName: e,
          range: n,
          paths: 0 < (this || _global).multiselection.length ? (this || _global).multiselection.nodes.map(function (e) {
            return e.getInternalPath();
          }) : null,
          scrollTop: (this || _global).scrollableContent ? (this || _global).scrollableContent.scrollTop : 0
        };
      }, t.scrollTo = function (e, i) {
        var n,
            t,
            r,
            o,
            s = (this || _global).scrollableContent;
        s ? ((n = this || _global).animateTimeout && (clearTimeout(n.animateTimeout), delete n.animateTimeout), n.animateCallback && (n.animateCallback(!1), delete n.animateCallback), t = s.clientHeight, r = s.scrollHeight - t, o = Math.min(Math.max(e - t / 4, 0), r), function e() {
          var t = s.scrollTop,
              t = o - t;
          3 < Math.abs(t) ? (s.scrollTop += t / 3, n.animateCallback = i, n.animateTimeout = setTimeout(e, 50)) : (i && i(!0), s.scrollTop = o, delete n.animateTimeout, delete n.animateCallback);
        }()) : i && i(!1);
      }, t._createFrame = function () {
        (this || _global).frame = document.createElement("div"), (this || _global).frame.className = "jsoneditor jsoneditor-mode-" + (this || _global).options.mode, (this || _global).container.appendChild((this || _global).frame), (this || _global).contentOuter = document.createElement("div"), (this || _global).contentOuter.className = "jsoneditor-outer";
        var t = this || _global;

        function i(e) {
          t._onEvent && t._onEvent(e);
        }

        var e,
            n,
            r,
            o = {
          target: (this || _global).frame,
          onFocus: (this || _global).options.onFocus || null,
          onBlur: (this || _global).options.onBlur || null
        };
        (this || _global).frameFocusTracker = new a.R(o), (this || _global).frame.onclick = function (e) {
          var t = e.target;
          i(e), "BUTTON" === t.nodeName && e.preventDefault();
        }, (this || _global).frame.oninput = i, (this || _global).frame.onchange = i, (this || _global).frame.onkeydown = i, (this || _global).frame.onkeyup = i, (this || _global).frame.oncut = i, (this || _global).frame.onpaste = i, (this || _global).frame.onmousedown = i, (this || _global).frame.onmouseup = i, (this || _global).frame.onmouseover = i, (this || _global).frame.onmouseout = i, (0, k.addEventListener)((this || _global).frame, "focus", i, !0), (0, k.addEventListener)((this || _global).frame, "blur", i, !0), (this || _global).frame.onfocusin = i, (this || _global).frame.onfocusout = i, (this || _global).options.mainMenuBar && ((0, k.addClassName)((this || _global).contentOuter, "has-main-menu-bar"), (this || _global).menu = document.createElement("div"), (this || _global).menu.className = "jsoneditor-menu", (this || _global).frame.appendChild((this || _global).menu), (o = document.createElement("button")).type = "button", o.className = "jsoneditor-expand-all", o.title = (0, l.Iu)("expandAll"), o.onclick = function () {
          t.expandAll();
        }, (this || _global).menu.appendChild(o), (o = document.createElement("button")).type = "button", o.title = (0, l.Iu)("collapseAll"), o.className = "jsoneditor-collapse-all", o.onclick = function () {
          t.collapseAll();
        }, (this || _global).menu.appendChild(o), (this || _global).options.enableSort && ((o = document.createElement("button")).type = "button", o.className = "jsoneditor-sort", o.title = (0, l.Iu)("sortTitleShort"), o.onclick = function () {
          t.node.showSortModal();
        }, (this || _global).menu.appendChild(o)), (this || _global).options.enableTransform && ((o = document.createElement("button")).type = "button", o.title = (0, l.Iu)("transformTitleShort"), o.className = "jsoneditor-transform", o.onclick = function () {
          t.node.showTransformModal();
        }, (this || _global).menu.appendChild(o)), (this || _global).history && ((e = document.createElement("button")).type = "button", e.className = "jsoneditor-undo jsoneditor-separator", e.title = (0, l.Iu)("undo"), e.onclick = function () {
          t._onUndo();
        }, (this || _global).menu.appendChild(e), (this || _global).dom.undo = e, (n = document.createElement("button")).type = "button", n.className = "jsoneditor-redo", n.title = (0, l.Iu)("redo"), n.onclick = function () {
          t._onRedo();
        }, (this || _global).menu.appendChild(n), (this || _global).dom.redo = n, (this || _global).history.onChange = function () {
          e.disabled = !t.history.canUndo(), n.disabled = !t.history.canRedo();
        }, (this || _global).history.onChange()), (this || _global).options && (this || _global).options.modes && (this || _global).options.modes.length && ((r = this || _global).modeSwitcher = new c.x((this || _global).menu, (this || _global).options.modes, (this || _global).options.mode, function (e) {
          try {
            r.setMode(e), r.modeSwitcher.focus();
          } catch (e) {
            r._onError(e);
          }
        })), (this || _global).options.search && ((this || _global).searchBox = new F(this || _global, (this || _global).menu))), (this || _global).options.navigationBar && ((this || _global).navBar = document.createElement("div"), (this || _global).navBar.className = "jsoneditor-navigation-bar nav-bar-empty", (this || _global).frame.appendChild((this || _global).navBar), (this || _global).treePath = new H((this || _global).navBar, this.getPopupAnchor()), (this || _global).treePath.onSectionSelected((this || _global)._onTreePathSectionSelected.bind(this || _global)), (this || _global).treePath.onContextMenuItemSelected((this || _global)._onTreePathMenuItemSelected.bind(this || _global)));
      }, t._onUndo = function () {
        (this || _global).history && ((this || _global).history.undo(), this._onChange());
      }, t._onRedo = function () {
        (this || _global).history && ((this || _global).history.redo(), this._onChange());
      }, t._onEvent = function (e) {
        if (!_.targetIsColorPicker(e.target)) {
          var t,
              i = _.getNodeFromTarget(e.target);

          if ("keydown" === e.type && this._onKeyDown(e), i && "focus" === e.type && ((this || _global).focusTarget = e.target, (this || _global).options.autocomplete && "focus" === (this || _global).options.autocomplete.trigger && this._showAutoComplete(e.target)), "mousedown" === e.type && this._startDragDistance(e), "mousemove" !== e.type && "mouseup" !== e.type && "click" !== e.type || this._updateDragDistance(e), i && (this || _global).options && (this || _global).options.navigationBar && i && ("keydown" === e.type || "mousedown" === e.type) && (t = this || _global, setTimeout(function () {
            t._updateTreePath(i.getNodePath());
          })), i && i.selected) {
            if ("click" === e.type) {
              if (e.target === i.dom.menu) return void this.showContextMenu(e.target);
              e.hasMoved || this.deselect();
            }

            "mousedown" === e.type && _.onDragStart((this || _global).multiselection.nodes, e);
          } else "mousedown" === e.type && (0, k.hasParentNode)(e.target, (this || _global).content) && (this.deselect(), i && e.target === i.dom.drag ? _.onDragStart(i, e) : i && (e.target === i.dom.field || e.target === i.dom.value || e.target === i.dom.select) || this._onMultiSelectStart(e));

          i && i.onEvent(e);
        }
      }, t._updateTreePath = function (e) {
        var i;

        function n(e) {
          return e.parent ? "array" === e.parent.type ? e.index : e.field : e.field || e.type;
        }

        e && e.length ? ((0, k.removeClassName)((this || _global).navBar, "nav-bar-empty"), i = [], e.forEach(function (e) {
          var t = {
            name: n(e),
            node: e,
            children: []
          };
          e.childs && e.childs.length && e.childs.forEach(function (e) {
            t.children.push({
              name: n(e),
              node: e
            });
          }), i.push(t);
        }), (this || _global).treePath.setPath(i)) : (0, k.addClassName)((this || _global).navBar, "nav-bar-empty");
      }, t._onTreePathSectionSelected = function (e) {
        e && e.node && (e.node.expandTo(), e.node.focus());
      }, t._onTreePathMenuItemSelected = function (e, t) {
        e && e.children.length && (e = e.children.find(function (e) {
          return e.name === t;
        })) && e.node && (this._updateTreePath(e.node.getNodePath()), e.node.expandTo(), e.node.focus());
      }, t._startDragDistance = function (e) {
        (this || _global).dragDistanceEvent = {
          initialTarget: e.target,
          initialPageX: e.pageX,
          initialPageY: e.pageY,
          dragDistance: 0,
          hasMoved: !1
        };
      }, t._updateDragDistance = function (e) {
        (this || _global).dragDistanceEvent || this._startDragDistance(e);
        var t = e.pageX - (this || _global).dragDistanceEvent.initialPageX,
            i = e.pageY - (this || _global).dragDistanceEvent.initialPageY;
        return (this || _global).dragDistanceEvent.dragDistance = Math.sqrt(t * t + i * i), (this || _global).dragDistanceEvent.hasMoved = (this || _global).dragDistanceEvent.hasMoved || 10 < (this || _global).dragDistanceEvent.dragDistance, e.dragDistance = (this || _global).dragDistanceEvent.dragDistance, e.hasMoved = (this || _global).dragDistanceEvent.hasMoved, e.dragDistance;
      }, t._onMultiSelectStart = function (e) {
        var t,
            i = _.getNodeFromTarget(e.target);

        "tree" === (this || _global).options.mode && void 0 === (this || _global).options.onEditable && ((this || _global).multiselection = {
          start: i || null,
          end: null,
          nodes: []
        }, this._startDragDistance(e), (t = this || _global).mousemove || ((this || _global).mousemove = (0, k.addEventListener)(e.view, "mousemove", function (e) {
          t._onMultiSelect(e);
        })), (this || _global).mouseup || ((this || _global).mouseup = (0, k.addEventListener)(e.view, "mouseup", function (e) {
          t._onMultiSelectEnd(e);
        })), e.preventDefault());
      }, t._onMultiSelect = function (e) {
        var t;
        e.preventDefault(), this._updateDragDistance(e), e.hasMoved && ((e = _.getNodeFromTarget(e.target)) && (null == (this || _global).multiselection.start && ((this || _global).multiselection.start = e), (this || _global).multiselection.end = e), this.deselect(), e = (this || _global).multiselection.start, t = (this || _global).multiselection.end || (this || _global).multiselection.start, e && t && ((this || _global).multiselection.nodes = this._findTopLevelNodes(e, t), (this || _global).multiselection.nodes && (this || _global).multiselection.nodes.length && (e = (this || _global).multiselection.nodes[0], (this || _global).multiselection.start === e || (this || _global).multiselection.start.isDescendantOf(e) ? (this || _global).multiselection.direction = "down" : (this || _global).multiselection.direction = "up"), this.select((this || _global).multiselection.nodes)));
      }, t._onMultiSelectEnd = function (e) {
        var t = (this || _global).multiselection.nodes[0];
        t && t.dom.menu && t.dom.menu.focus(), (this || _global).multiselection.start = null, (this || _global).multiselection.end = null, (this || _global).mousemove && ((0, k.removeEventListener)(e.view, "mousemove", (this || _global).mousemove), delete (this || _global).mousemove), (this || _global).mouseup && ((0, k.removeEventListener)(e.view, "mouseup", (this || _global).mouseup), delete (this || _global).mouseup);
      }, t.deselect = function (e) {
        var t = !!(this || _global).multiselection.nodes.length;
        (this || _global).multiselection.nodes.forEach(function (e) {
          e.setSelected(!1);
        }), (this || _global).multiselection.nodes = [], e && ((this || _global).multiselection.start = null, (this || _global).multiselection.end = null), t && (this || _global)._selectionChangedHandler && this._selectionChangedHandler();
      }, t.select = function (e) {
        if (!Array.isArray(e)) return this.select([e]);
        var t;
        e && (this.deselect(), (this || _global).multiselection.nodes = e.slice(0), t = e[0], e.forEach(function (e) {
          e.expandPathToNode(), e.setSelected(!0, e === t);
        }), (this || _global)._selectionChangedHandler && (e = this.getSelection(), this._selectionChangedHandler(e.start, e.end)));
      }, t._findTopLevelNodes = function (e, t) {
        for (var i = e.getNodePath(), n = t.getNodePath(), r = 0; r < i.length && i[r] === n[r];) r++;

        var o,
            e = i[r - 1],
            t = i[r],
            s = n[r];
        return t && s || (e.parent ? e = (s = t = e).parent : (t = e.childs[0], s = e.childs[e.childs.length - 1])), e && t && s ? (t = e.childs.indexOf(t), s = e.childs.indexOf(s), o = Math.min(t, s), t = Math.max(t, s), e.childs.slice(o, t + 1)) : [];
      }, t._showAutoComplete = function (t) {
        var i,
            n = _.getNodeFromTarget(t),
            r = "";

        0 <= t.className.indexOf("jsoneditor-value") && (r = "value"), "" !== (r = 0 <= t.className.indexOf("jsoneditor-field") ? "field" : r) && (i = this || _global, setTimeout(function () {
          var e;
          !n || !("focus" === i.options.autocomplete.trigger || 0 < t.innerText.length) || null === (e = i.options.autocomplete.getOptions(t.innerText, n.getPath(), r, n.editor)) ? i.autocomplete.hideDropDown() : "function" == typeof e.then ? e.then(function (e) {
            null === e ? i.autocomplete.hideDropDown() : e.options ? i.autocomplete.show(t, e.startFrom, e.options) : i.autocomplete.show(t, 0, e);
          }).catch(function (e) {
            console.error(e);
          }) : e.options ? i.autocomplete.show(t, e.startFrom, e.options) : i.autocomplete.show(t, 0, e);
        }, 50));
      }, t._onKeyDown = function (e) {
        var t,
            i = e.which || e.keyCode,
            n = e.altKey,
            r = e.ctrlKey,
            o = e.metaKey,
            s = e.shiftKey,
            a = !1,
            l = (this || _global).focusTarget;
        9 === i && (t = this || _global, setTimeout(function () {
          t.focusTarget !== l && (0, k.selectContentEditable)(t.focusTarget);
        }, 0)), (this || _global).searchBox && (r && 70 === i ? ((this || _global).searchBox.dom.search.focus(), (this || _global).searchBox.dom.search.select(), a = !0) : (114 === i || r && 71 === i) && (s ? (this || _global).searchBox.previous(!0) : (this || _global).searchBox.next(!0), a = !0)), (this || _global).history && (r && !s && 90 === i ? (this._onUndo(), a = !0) : r && s && 90 === i && (this._onRedo(), a = !0)), !(this || _global).options.autocomplete || a || r || n || o || 1 !== e.key.length && 8 !== i && 46 !== i || (a = !1, this._showAutoComplete(e.target)), a && (e.preventDefault(), e.stopPropagation());
      }, t._createTable = function () {
        var e;
        (this || _global).options.navigationBar && (0, k.addClassName)((this || _global).contentOuter, "has-nav-bar"), (this || _global).scrollableContent = document.createElement("div"), (this || _global).scrollableContent.className = "jsoneditor-tree", (this || _global).contentOuter.appendChild((this || _global).scrollableContent), (this || _global).content = document.createElement("div"), (this || _global).content.className = "jsoneditor-tree-inner", (this || _global).scrollableContent.appendChild((this || _global).content), (this || _global).table = document.createElement("table"), (this || _global).table.className = "jsoneditor-tree", (this || _global).content.appendChild((this || _global).table), (this || _global).colgroupContent = document.createElement("colgroup"), "tree" === (this || _global).options.mode && ((e = document.createElement("col")).width = "24px", (this || _global).colgroupContent.appendChild(e)), (e = document.createElement("col")).width = "24px", (this || _global).colgroupContent.appendChild(e), e = document.createElement("col"), (this || _global).colgroupContent.appendChild(e), (this || _global).table.appendChild((this || _global).colgroupContent), (this || _global).tbody = document.createElement("tbody"), (this || _global).table.appendChild((this || _global).tbody), (this || _global).frame.appendChild((this || _global).contentOuter);
      }, t.showContextMenu = function (e, t) {
        var i,
            n = [],
            r = (this || _global).multiselection.nodes.slice();

        n.push({
          text: (0, l.Iu)("duplicateText"),
          title: (0, l.Iu)("duplicateTitle"),
          className: "jsoneditor-duplicate",
          click: function () {
            _.onDuplicate(r);
          }
        }), n.push({
          text: (0, l.Iu)("remove"),
          title: (0, l.Iu)("removeTitle"),
          className: "jsoneditor-remove",
          click: function () {
            _.onRemove(r);
          }
        }), (this || _global).options.onCreateMenu && (i = r.map(function (e) {
          return e.getPath();
        }), n = (this || _global).options.onCreateMenu(n, {
          type: "multiple",
          path: i[0],
          paths: i
        })), new s.x(n, {
          close: t
        }).show(e, this.getPopupAnchor());
      }, t.getPopupAnchor = function () {
        return (this || _global).options.popupAnchor || (this || _global).frame;
      }, t.getSelection = function () {
        var e,
            t,
            i = {
          start: null,
          end: null
        };
        return (this || _global).multiselection.nodes && (this || _global).multiselection.nodes.length && (this || _global).multiselection.nodes.length && (e = (this || _global).multiselection.nodes[0], t = (this || _global).multiselection.nodes[(this || _global).multiselection.nodes.length - 1], "down" === (this || _global).multiselection.direction ? (i.start = e.serialize(), i.end = t.serialize()) : (i.start = t.serialize(), i.end = e.serialize())), i;
      }, t.onSelectionChange = function (e) {
        "function" == typeof e && ((this || _global)._selectionChangedHandler = (0, k.debounce)(e, (this || _global).DEBOUNCE_INTERVAL));
      }, t.setSelection = function (e, t) {
        e && e.dom && e.range && (console.warn("setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options"), this.setDomSelection(e));
        e = this._getNodeInstancesByRange(e, t);
        e.forEach(function (e) {
          e.expandTo();
        }), this.select(e);
      }, t._getNodeInstancesByRange = function (e, t) {
        e && e.path && (i = (this || _global).node.findNodeByPath(e.path), t && t.path && (n = (this || _global).node.findNodeByPath(t.path)));
        var i,
            n,
            r = [];
        if (i instanceof _) if (n instanceof _ && n !== i) {
          if (i.parent === n.parent) {
            t = i.getIndex() < n.getIndex() ? (e = i, n) : (e = n, i);
            var o = e;

            for (r.push(o); o = o.nextSibling(), r.push(o), o && o !== t;);
          } else r = this._findTopLevelNodes(i, n);
        } else r.push(i);
        return r;
      }, t.getNodesByRange = function (e, t) {
        var e = this._getNodeInstancesByRange(e, t),
            i = [];

        return e.forEach(function (e) {
          i.push(e.serialize());
        }), i;
      }, [{
        mode: "tree",
        mixin: t,
        data: "json"
      }, {
        mode: "view",
        mixin: t,
        data: "json"
      }, {
        mode: "form",
        mixin: t,
        data: "json"
      }]);
    },
    2744: function (e, t, i) {
      t.tryRequireAjv = function () {
        try {
          return i(8903);
        } catch (e) {}
      };
    },
    9125: function (e, t, i) {
      t.O = function () {
        try {
          i(4864);
        } catch (e) {
          console.error(e);
        }
      };
    },
    9791: function (G, e, t) {
      "use strict";

      t.r(e), t.d(e, {
        addClassName: function () {
          return P;
        },
        addEventListener: function () {
          return j;
        },
        clear: function () {
          return m;
        },
        compileJSONPointer: function () {
          return $;
        },
        contains: function () {
          return me;
        },
        debounce: function () {
          return ee;
        },
        escapeUnicodeChars: function () {
          return u;
        },
        extend: function () {
          return p;
        },
        findUniqueName: function () {
          return ae;
        },
        formatSize: function () {
          return ge;
        },
        get: function () {
          return B;
        },
        getAbsoluteLeft: function () {
          return b;
        },
        getAbsoluteTop: function () {
          return y;
        },
        getChildPaths: function () {
          return le;
        },
        getColorCSS: function () {
          return L;
        },
        getIndexForPosition: function () {
          return ne;
        },
        getInnerText: function () {
          return k;
        },
        getInputSelection: function () {
          return ie;
        },
        getInternetExplorerVersion: function () {
          return K;
        },
        getPositionForPath: function () {
          return re;
        },
        getSelection: function () {
          return S;
        },
        getSelectionOffset: function () {
          return M;
        },
        getType: function () {
          return f;
        },
        getWindow: function () {
          return A;
        },
        hasParentNode: function () {
          return D;
        },
        improveSchemaError: function () {
          return Y;
        },
        insideRect: function () {
          return q;
        },
        isArray: function () {
          return v;
        },
        isChildOf: function () {
          return X;
        },
        isFirefox: function () {
          return T;
        },
        isObject: function () {
          return W;
        },
        isPromise: function () {
          return U;
        },
        isTimestamp: function () {
          return ue;
        },
        isUrl: function () {
          return I;
        },
        isValidColor: function () {
          return oe;
        },
        isValidValidationError: function () {
          return Q;
        },
        isValidationErrorChanged: function () {
          return fe;
        },
        limitCharacters: function () {
          return pe;
        },
        makeFieldTooltip: function () {
          return se;
        },
        parse: function () {
          return h;
        },
        parsePath: function () {
          return _;
        },
        parseString: function () {
          return de;
        },
        removeAllClassNames: function () {
          return F;
        },
        removeClassName: function () {
          return H;
        },
        removeEventListener: function () {
          return z;
        },
        removeReturnsAndSurroundingWhitespace: function () {
          return E;
        },
        selectContentEditable: function () {
          return Z;
        },
        setEndOfContentEditable: function () {
          return V;
        },
        setSelection: function () {
          return x;
        },
        setSelectionOffset: function () {
          return O;
        },
        sort: function () {
          return ce;
        },
        sortObjectKeys: function () {
          return he;
        },
        stringifyPath: function () {
          return J;
        },
        stripFormatting: function () {
          return w;
        },
        textDiff: function () {
          return te;
        },
        tryJsonRepair: function () {
          return d;
        },
        validate: function () {
          return g;
        }
      });
      t(4987);
      var e = t(233),
          r = t.n(e),
          e = t(3860),
          i = t.n(e),
          n = t(6589),
          o = t(7026),
          s = t(7907);

      function a(e) {
        return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      var l = 10000,
          c = 946684800000;

      function h(t) {
        try {
          return JSON.parse(t);
        } catch (e) {
          throw g(t), e;
        }
      }

      function d(t) {
        try {
          return i()(t);
        } catch (e) {
          return t;
        }
      }

      function u(e) {
        return e.replace(/[\u007F-\uFFFF]/g, function (e) {
          return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
        });
      }

      function g(e) {
        (void 0 !== n ? n : JSON).parse(e);
      }

      function p(e, t) {
        for (var i in t) N(t, i) && (e[i] = t[i]);

        return e;
      }

      function m(e) {
        for (var t in e) N(e, t) && delete e[t];

        return e;
      }

      function f(e) {
        return null === e ? "null" : void 0 === e ? "undefined" : e instanceof Number || "number" == typeof e ? "number" : e instanceof String || "string" == typeof e ? "string" : e instanceof Boolean || "boolean" == typeof e ? "boolean" : e instanceof RegExp ? "regexp" : v(e) ? "array" : "object";
      }

      var C = /^https?:\/\/\S+$/;

      function I(e) {
        return ("string" == typeof e || e instanceof String) && C.test(e);
      }

      function v(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }

      function A(e) {
        return e.ownerDocument.defaultView;
      }

      function b(e) {
        return e.getBoundingClientRect().left + window.pageXOffset || document.scrollLeft || 0;
      }

      function y(e) {
        return e.getBoundingClientRect().top + window.pageYOffset || document.scrollTop || 0;
      }

      function P(e, t) {
        var i = e.className.split(" ");
        -1 === i.indexOf(t) && (i.push(t), e.className = i.join(" "));
      }

      function F(e) {
        e.className = "";
      }

      function H(e, t) {
        var i = e.className.split(" "),
            t = i.indexOf(t);
        -1 !== t && (i.splice(t, 1), e.className = i.join(" "));
      }

      function w(e) {
        for (var t = e.childNodes, i = 0, n = t.length; i < n; i++) {
          var r = t[i],
              o = (r.style && r.removeAttribute("style"), r.attributes);
          if (o) for (var s = o.length - 1; 0 <= s; s--) {
            var a = o[s];
            !0 === a.specified && r.removeAttribute(a.name);
          }
          w(r);
        }
      }

      function V(e) {
        var t;
        document.createRange && ((t = document.createRange()).selectNodeContents(e), t.collapse(!1), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
      }

      function Z(e) {
        var t;
        e && "DIV" === e.nodeName && window.getSelection && document.createRange && ((t = document.createRange()).selectNodeContents(e), (e = window.getSelection()).removeAllRanges(), e.addRange(t));
      }

      function S() {
        if (window.getSelection) {
          var e = window.getSelection();
          if (e.getRangeAt && e.rangeCount) return e.getRangeAt(0);
        }

        return null;
      }

      function x(e) {
        var t;
        e && window.getSelection && ((t = window.getSelection()).removeAllRanges(), t.addRange(e));
      }

      function M() {
        var e = S();
        return e && "startOffset" in e && "endOffset" in e && e.startContainer && e.startContainer === e.endContainer ? {
          startOffset: e.startOffset,
          endOffset: e.endOffset,
          container: e.startContainer.parentNode
        } : null;
      }

      function O(e) {
        var t;
        document.createRange && window.getSelection && window.getSelection() && (t = document.createRange(), e.container.firstChild || e.container.appendChild(document.createTextNode("")), t.setStart(e.container.firstChild, e.startOffset), t.setEnd(e.container.firstChild, e.endOffset), x(t));
      }

      function k(e, t) {
        var i;
        if (void 0 === t && (t = {
          _text: "",
          flush: function () {
            var e = (this || _global)._text;
            return (this || _global)._text = "", e;
          },
          set: function (e) {
            (this || _global)._text = e;
          }
        }), e.nodeValue) return "" !== (i = E(e.nodeValue)) ? t.flush() + i : "";

        if (e.hasChildNodes()) {
          for (var n = e.childNodes, r = "", o = 0, s = n.length; o < s; o++) {
            var a,
                l = n[o];
            "DIV" === l.nodeName || "P" === l.nodeName ? ((a = (a = n[o - 1]) ? a.nodeName : void 0) && "DIV" !== a && "P" !== a && "BR" !== a && ("" !== r && (r += "\n"), t.flush()), r += k(l, t), t.set("\n")) : "BR" === l.nodeName ? (r += t.flush(), t.set("\n")) : r += k(l, t);
          }

          return r;
        }

        return "";
      }

      function E(e) {
        return e.replace(/(\b|^)\s*(\b|$)/g, function (e) {
          return /\n/.exec(e) ? "" : e;
        });
      }

      function D(e, t) {
        for (var i = e ? e.parentNode : void 0; i;) {
          if (i === t) return !0;
          i = i.parentNode;
        }

        return !1;
      }

      function K() {
        var e;
        return -1 === R && (e = -1, "undefined" != typeof navigator && "Microsoft Internet Explorer" === navigator.appName && null != /MSIE ([0-9]+[.0-9]+)/.exec(navigator.userAgent) && (e = parseFloat(RegExp.$1)), R = e), R;
      }

      var R = -1;

      function T() {
        return "undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Firefox");
      }

      function j(e, t, i, n) {
        return e.addEventListener ? (void 0 === n && (n = !1), "mousewheel" === t && T() && (t = "DOMMouseScroll"), e.addEventListener(t, i, n), i) : e.attachEvent ? (e.attachEvent("on" + t, n = function () {
          return i.call(e, window.event);
        }), n) : void 0;
      }

      function z(e, t, i, n) {
        e.removeEventListener ? (void 0 === n && (n = !1), "mousewheel" === t && T() && (t = "DOMMouseScroll"), e.removeEventListener(t, i, n)) : e.detachEvent && e.detachEvent("on" + t, i);
      }

      function X(e, t) {
        for (var i = e.parentNode; i;) {
          if (i === t) return !0;
          i = i.parentNode;
        }

        return !1;
      }

      function _(i) {
        var e = [],
            n = 0;

        function t(e) {
          for (var t = ""; void 0 !== i[n] && i[n] !== e;) t += i[n], n++;

          if (i[n] !== e) throw new Error("Invalid JSON path: unexpected end, character " + e + " expected");
          return t;
        }

        for (; void 0 !== i[n];) if ("." === i[n]) n++, e.push(function () {
          for (var e = ""; void 0 !== i[n] && /[\w$]/.test(i[n]);) e += i[n], n++;

          if ("" === e) throw new Error("Invalid JSON path: property name expected at index " + n);
          return e;
        }());else {
          if ("[" !== i[n]) throw new Error("Invalid JSON path: unexpected character \"" + i[n] + "\" at index " + n);

          if ("'" === i[++n] || "\"" === i[n]) {
            var r = i[n];
            if (n++, e.push(t(r)), i[n] !== r) throw new Error("Invalid JSON path: closing quote ' expected at index " + n);
            n++;
          } else {
            r = t("]").trim();
            if (0 === r.length) throw new Error("Invalid JSON path: array value expected at index " + n);
            r = "*" === r ? r : JSON.parse(r), e.push(r);
          }

          if ("]" !== i[n]) throw new Error("Invalid JSON path: closing bracket ] expected at index " + n);
          n++;
        }

        return e;
      }

      function J(e) {
        return e.map(function (e) {
          return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z0-9_$]+$/) ? "." + e : "[\"" + e + "\"]";
        }).join("");
      }

      function Y(e) {
        var t, i;
        return "enum" === e.keyword && Array.isArray(e.schema) && (i = e.schema) && (5 < (i = i.map(function (e) {
          return JSON.stringify(e);
        })).length && (t = ["(" + (i.length - 5) + " more...)"], (i = i.slice(0, 5)).push(t)), e.message = "should be equal to one of: " + i.join(", ")), "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
      }

      function U(e) {
        return e && "function" == typeof e.then && "function" == typeof e.catch;
      }

      function Q(e) {
        return "object" === a(e) && Array.isArray(e.path) && "string" == typeof e.message;
      }

      function q(e, t, i) {
        i = void 0 !== i ? i : 0;
        return t.left - i >= e.left && t.right + i <= e.right && t.top - i >= e.top && t.bottom + i <= e.bottom;
      }

      function ee(n, r, o) {
        var s;
        return function () {
          var e = this || _global,
              t = arguments,
              i = o && !s;
          clearTimeout(s), s = setTimeout(function () {
            s = null, o || n.apply(e, t);
          }, r), i && n.apply(e, t);
        };
      }

      function te(e, t) {
        for (var i = t.length, n = 0, r = e.length, o = t.length; t.charAt(n) === e.charAt(n) && n < i;) n++;

        for (; t.charAt(o - 1) === e.charAt(r - 1) && n < o && 0 < r;) o--, r--;

        return {
          start: n,
          end: o
        };
      }

      function ie(t) {
        var e,
            i,
            n,
            r,
            o = 0,
            s = 0;
        return "number" == typeof t.selectionStart && "number" == typeof t.selectionEnd ? (o = t.selectionStart, s = t.selectionEnd) : (r = document.selection.createRange()) && r.parentElement() === t && (n = t.value.length, e = t.value.replace(/\r\n/g, "\n"), (i = t.createTextRange()).moveToBookmark(r.getBookmark()), (r = t.createTextRange()).collapse(!1), -1 < i.compareEndPoints("StartToEnd", r) ? o = s = n : (o = -i.moveStart("character", -n), o += e.slice(0, o).split("\n").length - 1, -1 < i.compareEndPoints("EndToEnd", r) ? s = n : (s = -i.moveEnd("character", -n), s += e.slice(0, s).split("\n").length - 1))), {
          startIndex: o,
          endIndex: s,
          start: a(o),
          end: a(s)
        };

        function a(e) {
          e = t.value.substring(0, e);
          return {
            row: (e.match(/\n/g) || []).length + 1,
            column: e.length - e.lastIndexOf("\n")
          };
        }
      }

      function ne(e, t, i) {
        var e = e.value || "";
        return 0 < t && 0 < i ? (e = e.split("\n", t), t = Math.min(e.length, t), i = Math.min(e[t - 1].length, i - 1), i = 1 === t ? i : i + 1, e.slice(0, t - 1).join("\n").length + i) : -1;
      }

      function re(e, t) {
        var i,
            n = [];
        if (!t || !t.length) return n;

        try {
          i = o.parse(e);
        } catch (e) {
          return n;
        }

        return t.forEach(function (e) {
          var t = $(_(e)),
              t = i.pointers[t];
          t && n.push({
            path: e,
            line: t.key ? t.key.line : t.value ? t.value.line : 0,
            column: t.key ? t.key.column : t.value ? t.value.column : 0
          });
        }), n;
      }

      function $(e) {
        return e.map(function (e) {
          return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
        }).join("");
      }

      function L(e) {
        var t = document.createElement("div");
        return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
      }

      function oe(e) {
        return !!L(e);
      }

      function se(i, e) {
        if (!i) return "";
        var n = "";
        return i.title && (n += i.title), i.description && (0 < n.length && (n += "\n"), n += i.description), i.default && (0 < n.length && (n += "\n\n"), n = (n += (0, s.Iu)("default", void 0, e) + "\n") + JSON.stringify(i.default, null, 2)), Array.isArray(i.examples) && 0 < i.examples.length && (0 < n.length && (n += "\n\n"), n += (0, s.Iu)("examples", void 0, e) + "\n", i.examples.forEach(function (e, t) {
          n += JSON.stringify(e, null, 2), t !== i.examples.length - 1 && (n += "\n");
        })), n;
      }

      function B(e, t) {
        for (var i = e, n = 0; n < t.length && null != i; n++) i = i[t[n]];

        return i;
      }

      function ae(e, t) {
        for (var i = e.replace(/ \(copy( \d+)?\)$/, ""), n = i, r = 1; -1 !== t.indexOf(n);) {
          n = i + " (" + ("copy" + (1 < r ? " " + r : "")) + ")";
          r++;
        }

        return n;
      }

      function le(e, t) {
        var i = {};
        if (Array.isArray(e)) for (var n = Math.min(e.length, l), r = 0; r < n; r++) !function t(i, n, r, o) {
          (Array.isArray(i) || W(i)) && !o || (n[r || ""] = !0), W(i) && Object.keys(i).forEach(function (e) {
            t(i[e], n, r + "." + e, o);
          });
        }(e[r], i, "", t);else i[""] = !0;
        return Object.keys(i).sort();
      }

      function ce(e, t, i) {
        var n = t && "." !== t ? _(t) : [],
            r = "desc" === i ? -1 : 1,
            t = e.slice();
        return t.sort(function (e, t) {
          e = B(e, n), t = B(t, n);
          return r * (t < e ? 1 : e < t ? -1 : 0);
        }), t;
      }

      function he(t, e) {
        var i = "desc" === e ? -1 : 1,
            e = Object.keys(t).sort(function (e, t) {
          return i * r()(e, t);
        }),
            n = {};
        return e.forEach(function (e) {
          n[e] = t[e];
        }), n;
      }

      function de(e) {
        if ("" === e) return "";
        var t = e.toLowerCase();
        if ("null" === t) return null;
        if ("true" === t) return !0;
        if ("false" === t) return !1;
        var t = Number(e),
            i = parseFloat(e);
        return isNaN(t) || isNaN(i) ? e : t;
      }

      function ue(e, t) {
        return "number" == typeof t && c < t && isFinite(t) && Math.floor(t) === t && !isNaN(new Date(t).valueOf());
      }

      function ge(e) {
        if (e < 900) return e.toFixed() + " B";
        e /= 1000;
        if (e < 900) return e.toFixed(1) + " KB";
        e /= 1000;
        if (e < 900) return e.toFixed(1) + " MB";
        e /= 1000;
        return e < 900 ? e.toFixed(1) + " GB" : (e / 1000).toFixed(1) + " TB";
      }

      function pe(e, t) {
        return e.length <= t ? e : e.slice(0, t) + "...";
      }

      function W(e) {
        return "object" === a(e) && null !== e && !Array.isArray(e);
      }

      function me(e, t) {
        return -1 !== e.indexOf(t);
      }

      function fe(i, e) {
        if (!e && !i) return !1;
        if (e && !i || !e && i) return !0;
        if (e.length !== i.length) return !0;

        for (var t = 0; t < i.length; ++t) {
          var n = function (t) {
            if (!("error" === i[t].type ? e.find(function (e) {
              return e.line === i[t].line;
            }) : e.find(function (e) {
              return e.dataPath === i[t].dataPath && e.schemaPath === i[t].schemaPath;
            }))) return {
              v: !0
            };
          }(t);

          if ("object" === a(n)) return n.v;
        }

        return !1;
      }

      function N(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
    },
    8037: function (e, t, i) {
      var n;
      if (window.Picker) n = window.Picker;else try {
        n = i(4049);
      } catch (e) {}
      e.exports = n;
    },
    6225: function (i, e, C) {
      function l(e, i) {
        var t, n;
        return i = a(e, i), (e = o.modules[i]) || ("function" == typeof (e = o.payloads[i]) && (t = {
          id: i,
          uri: "",
          exports: n = {},
          packaged: !0
        }, n = e(function (e, t) {
          return s(i, e, t);
        }, n, t) || t.exports, o.modules[i] = n, delete o.payloads[i]), e = o.modules[i] = n || e), e;
      }

      var t, n, r, o, s, c, a;
      i = C.nmd(i), (r = function () {
        return this || _global;
      }()) || "undefined" == typeof window || (r = window), (o = function (e, t, i) {
        "string" != typeof e ? o.original ? o.original.apply(this || _global, arguments) : (console.error("dropping module because define wasn't a string."), console.trace()) : (2 == arguments.length && (i = t), o.modules[e] || (o.payloads[e] = i, o.modules[e] = null));
      }).modules = {}, o.payloads = {}, s = function (e, t, i) {
        if ("string" == typeof t) {
          var n = l(e, t);
          if (null != n) return i && i(), n;
        } else if ("[object Array]" === Object.prototype.toString.call(t)) {
          for (var r = [], o = 0, s = t.length; o < s; ++o) {
            var a = l(e, t[o]);
            if (null == a && c.original) return;
            r.push(a);
          }

          return i && i.apply(null, r) || !0;
        }
      }, c = function (e, t) {
        var i = s("", e, t);
        return null == i && c.original ? c.original.apply(this || _global, arguments) : i;
      }, a = function (e, t) {
        var i;
        if (-1 !== t.indexOf("!")) return i = t.split("!"), a(e, i[0]) + "!" + a(e, i[1]);
        if ("." == t.charAt(0)) for (t = e.split("/").slice(0, -1).join("/") + "/" + t; -1 !== t.indexOf(".") && n != t;) {
          var n = t;
          t = t.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
        }
        return t;
      }, n = r, (t = "ace") && (r[t] || (r[t] = {}), n = r[t]), n.define && n.define.packaged || (o.original = n.define, n.define = o, n.define.packaged = !0), n.require && n.require.packaged || (c.original = n.require, n.require = c, n.require.packaged = !0), ace.define("ace/lib/fixoldbrowsers", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        "undefined" == typeof Element || Element.prototype.remove || Object.defineProperty(Element.prototype, "remove", {
          enumerable: !1,
          writable: !0,
          configurable: !0,
          value: function () {
            (this || _global).parentNode && (this || _global).parentNode.removeChild(this || _global);
          }
        });
      }), ace.define("ace/lib/useragent", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        t.OS = {
          LINUX: "LINUX",
          MAC: "MAC",
          WINDOWS: "WINDOWS"
        }, t.getOS = function () {
          return t.isMac ? t.OS.MAC : t.isLinux ? t.OS.LINUX : t.OS.WINDOWS;
        };
        var n = "object" == typeof navigator ? navigator : {},
            r = (/mac|win|linux/i.exec(n.platform) || ["other"])[0].toLowerCase(),
            o = n.userAgent || "",
            n = n.appName || "";
        t.isWin = "win" == r, t.isMac = "mac" == r, t.isLinux = "linux" == r, t.isIE = "Microsoft Internet Explorer" == n || 0 <= n.indexOf("MSAppHost") ? parseFloat((o.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((o.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]), t.isOldIE = t.isIE && t.isIE < 9, t.isGecko = t.isMozilla = o.match(/ Gecko\/\d+/), t.isOpera = "object" == typeof opera && "[object Opera]" == Object.prototype.toString.call(window.opera), t.isWebKit = parseFloat(o.split("WebKit/")[1]) || void 0, t.isChrome = parseFloat(o.split(" Chrome/")[1]) || void 0, t.isEdge = parseFloat(o.split(" Edge/")[1]) || void 0, t.isAIR = 0 <= o.indexOf("AdobeAIR"), t.isAndroid = 0 <= o.indexOf("Android"), t.isChromeOS = 0 <= o.indexOf(" CrOS "), t.isIOS = /iPad|iPhone|iPod/.test(o) && !window.MSStream, t.isIOS && (t.isMac = !0), t.isMobile = t.isIOS || t.isAndroid;
      }), ace.define("ace/lib/dom", ["require", "exports", "module", "ace/lib/useragent"], function (e, o, t) {
        "use strict";

        var s,
            i,
            e = e("./useragent"),
            a = (o.buildDom = function e(t, i, n) {
          if ("string" == typeof t && t) return c = document.createTextNode(t), i && i.appendChild(c), c;
          if (!Array.isArray(t)) return t && t.appendChild && i && i.appendChild(t), t;

          if ("string" != typeof t[0] || !t[0]) {
            for (var r = [], o = 0; o < t.length; o++) {
              var s = e(t[o], i, n);
              s && r.push(s);
            }

            return r;
          }

          for (var a = document.createElement(t[0]), l = t[1], c = 1, o = c = l && "object" == typeof l && !Array.isArray(l) ? 2 : c; o < t.length; o++) e(t[o], a, n);

          return 2 == c && Object.keys(l).forEach(function (e) {
            var t = l[e];
            "class" === e ? a.className = Array.isArray(t) ? t.join(" ") : t : "function" == typeof t || "value" == e || "$" == e[0] ? a[e] = t : "ref" === e ? n && (n[t] = a) : "style" === e ? "string" == typeof t && (a.style.cssText = t) : null != t && a.setAttribute(e, t);
          }), i && i.appendChild(a), a;
        }, o.getDocumentHead = function (e) {
          return (e = e || document).head || e.getElementsByTagName("head")[0] || e.documentElement;
        }, o.createElement = function (e, t) {
          return document.createElementNS ? document.createElementNS(t || "http://www.w3.org/1999/xhtml", e) : document.createElement(e);
        }, o.removeChildren = function (e) {
          e.innerHTML = "";
        }, o.createTextNode = function (e, t) {
          return (t ? t.ownerDocument : document).createTextNode(e);
        }, o.createFragment = function (e) {
          return (e ? e.ownerDocument : document).createDocumentFragment();
        }, o.hasCssClass = function (e, t) {
          return -1 !== (e.className + "").split(/\s+/g).indexOf(t);
        }, o.addCssClass = function (e, t) {
          o.hasCssClass(e, t) || (e.className += " " + t);
        }, o.removeCssClass = function (e, t) {
          for (var i = e.className.split(/\s+/g);;) {
            var n = i.indexOf(t);
            if (-1 == n) break;
            i.splice(n, 1);
          }

          e.className = i.join(" ");
        }, o.toggleCssClass = function (e, t) {
          for (var i = e.className.split(/\s+/g), n = !0;;) {
            var r = i.indexOf(t);
            if (-1 == r) break;
            n = !1, i.splice(r, 1);
          }

          return n && i.push(t), e.className = i.join(" "), n;
        }, o.setCssClass = function (e, t, i) {
          i ? o.addCssClass(e, t) : o.removeCssClass(e, t);
        }, o.hasCssString = function (e, t) {
          var i,
              n = 0;
          if (i = (t = t || document).querySelectorAll("style")) for (; n < i.length;) if (i[n++].id === e) return !0;
        }, []);

        function l() {
          var e = a;
          a = null, e && e.forEach(function (e) {
            n(e[0], e[1]);
          });
        }

        function n(e, t, i) {
          if ("undefined" != typeof document) {
            if (a) if (i) l();else if (!1 === i) return a.push([e, t]);

            if (!s) {
              var n = i,
                  i = (n = i && i.getRootNode && (n = i.getRootNode()) && n != i ? n : document).ownerDocument || n;
              if (t && o.hasCssString(t, n)) return null;
              t && (e += "\n/*# sourceURL=ace/css/" + t + " */");
              var r = o.createElement("style");
              r.appendChild(i.createTextNode(e)), t && (r.id = t), (n = n == i ? o.getDocumentHead(i) : n).insertBefore(r, n.firstChild);
            }
          }
        }

        o.useStrictCSP = function (e) {
          0 == (s = e) ? l() : a = a || [];
        }, o.importCssString = n, o.importCssStylsheet = function (e, t) {
          o.buildDom(["link", {
            rel: "stylesheet",
            href: e
          }], o.getDocumentHead(t));
        }, o.scrollbarWidth = function (e) {
          var t = o.createElement("ace_inner"),
              i = (t.style.width = "100%", t.style.minWidth = "0px", t.style.height = "200px", t.style.display = "block", o.createElement("ace_outer")),
              n = i.style,
              e = (n.position = "absolute", n.left = "-10000px", n.overflow = "hidden", n.width = "200px", n.minWidth = "0px", n.height = "150px", n.display = "block", i.appendChild(t), e.documentElement),
              r = (e.appendChild(i), t.offsetWidth),
              n = (n.overflow = "scroll", t.offsetWidth);
          return r == n && (n = i.clientWidth), e.removeChild(i), r - n;
        }, o.computedStyle = function (e, t) {
          return window.getComputedStyle(e, "") || {};
        }, o.setStyle = function (e, t, i) {
          e[t] !== i && (e[t] = i);
        }, o.HAS_CSS_ANIMATION = !1, o.HAS_CSS_TRANSFORMS = !1, o.HI_DPI = !e.isWin || "undefined" != typeof window && 1.5 <= window.devicePixelRatio, e.isChromeOS && (o.HI_DPI = !1), "undefined" != typeof document && (i = document.createElement("div"), o.HI_DPI && void 0 !== i.style.transform && (o.HAS_CSS_TRANSFORMS = !0), e.isEdge || void 0 === i.style.animationName || (o.HAS_CSS_ANIMATION = !0), i = null), o.HAS_CSS_TRANSFORMS ? o.translate = function (e, t, i) {
          e.style.transform = "translate(" + Math.round(t) + "px, " + Math.round(i) + "px)";
        } : o.translate = function (e, t, i) {
          e.style.top = Math.round(i) + "px", e.style.left = Math.round(t) + "px";
        };
      }), ace.define("ace/lib/oop", ["require", "exports", "module"], function (e, i, t) {
        "use strict";

        i.inherits = function (e, t) {
          e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          });
        }, i.mixin = function (e, t) {
          for (var i in t) e[i] = t[i];

          return e;
        }, i.implement = function (e, t) {
          i.mixin(e, t);
        };
      }), ace.define("ace/lib/keys", ["require", "exports", "module", "ace/lib/oop"], function (e, t, i) {
        "use strict";

        var o = e("./oop"),
            n = function () {
          var e,
              t,
              i = {
            MODIFIER_KEYS: {
              16: "Shift",
              17: "Ctrl",
              18: "Alt",
              224: "Meta",
              91: "MetaLeft",
              92: "MetaRight",
              93: "ContextMenu"
            },
            KEY_MODS: {
              ctrl: 1,
              alt: 2,
              option: 2,
              shift: 4,
              super: 8,
              meta: 8,
              command: 8,
              cmd: 8,
              control: 1
            },
            FUNCTION_KEYS: {
              8: "Backspace",
              9: "Tab",
              13: "Return",
              19: "Pause",
              27: "Esc",
              32: "Space",
              33: "PageUp",
              34: "PageDown",
              35: "End",
              36: "Home",
              37: "Left",
              38: "Up",
              39: "Right",
              40: "Down",
              44: "Print",
              45: "Insert",
              46: "Delete",
              96: "Numpad0",
              97: "Numpad1",
              98: "Numpad2",
              99: "Numpad3",
              100: "Numpad4",
              101: "Numpad5",
              102: "Numpad6",
              103: "Numpad7",
              104: "Numpad8",
              105: "Numpad9",
              "-13": "NumpadEnter",
              112: "F1",
              113: "F2",
              114: "F3",
              115: "F4",
              116: "F5",
              117: "F6",
              118: "F7",
              119: "F8",
              120: "F9",
              121: "F10",
              122: "F11",
              123: "F12",
              144: "Numlock",
              145: "Scrolllock"
            },
            PRINTABLE_KEYS: {
              32: " ",
              48: "0",
              49: "1",
              50: "2",
              51: "3",
              52: "4",
              53: "5",
              54: "6",
              55: "7",
              56: "8",
              57: "9",
              59: ";",
              61: "=",
              65: "a",
              66: "b",
              67: "c",
              68: "d",
              69: "e",
              70: "f",
              71: "g",
              72: "h",
              73: "i",
              74: "j",
              75: "k",
              76: "l",
              77: "m",
              78: "n",
              79: "o",
              80: "p",
              81: "q",
              82: "r",
              83: "s",
              84: "t",
              85: "u",
              86: "v",
              87: "w",
              88: "x",
              89: "y",
              90: "z",
              107: "+",
              109: "-",
              110: ".",
              186: ";",
              187: "=",
              188: ",",
              189: "-",
              190: ".",
              191: "/",
              192: "`",
              219: "[",
              220: "\\",
              221: "]",
              222: "'",
              111: "/",
              106: "*"
            }
          };

          for (t in i.FUNCTION_KEYS) e = i.FUNCTION_KEYS[t].toLowerCase(), i[e] = parseInt(t, 10);

          for (t in i.PRINTABLE_KEYS) e = i.PRINTABLE_KEYS[t].toLowerCase(), i[e] = parseInt(t, 10);

          o.mixin(i, i.MODIFIER_KEYS), o.mixin(i, i.PRINTABLE_KEYS), o.mixin(i, i.FUNCTION_KEYS), i.enter = i.return, i.escape = i.esc, i.del = i.delete, i[173] = "-";

          for (var n = ["cmd", "ctrl", "alt", "shift"], r = Math.pow(2, n.length); r--;) i.KEY_MODS[r] = n.filter(function (e) {
            return r & i.KEY_MODS[e];
          }).join("-") + "-";

          return i.KEY_MODS[0] = "", i.KEY_MODS[-1] = "input-", i;
        }();

        o.mixin(t, n), t.keyCodeToString = function (e) {
          var t = n[e];
          return (t = "string" != typeof t ? String.fromCharCode(e) : t).toLowerCase();
        };
      }), ace.define("ace/lib/event", ["require", "exports", "module", "ace/lib/keys", "ace/lib/useragent"], function (e, d, t) {
        "use strict";

        var i,
            o = e("./keys"),
            u = e("./useragent"),
            s = null,
            a = 0;

        function r() {
          if (null == i) {
            i = !1;

            try {
              document.createComment("").addEventListener("test", function () {}, {
                get passive() {
                  i = {
                    passive: !1
                  };
                }

              });
            } catch (e) {}
          }

          return i;
        }

        function l(e, t, i) {
          (this || _global).elem = e, (this || _global).type = t, (this || _global).callback = i;
        }

        l.prototype.destroy = function () {
          p((this || _global).elem, (this || _global).type, (this || _global).callback), (this || _global).elem = (this || _global).type = (this || _global).callback = void 0;
        };

        function c(e) {
          return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
        }

        var h,
            g = d.addListener = function (e, t, i, n) {
          e.addEventListener(t, i, r()), n && n.$toDestroy.push(new l(e, t, i));
        },
            p = d.removeListener = function (e, t, i) {
          e.removeEventListener(t, i, r());
        };

        d.stopEvent = function (e) {
          return d.stopPropagation(e), d.preventDefault(e), !1;
        }, d.stopPropagation = function (e) {
          e.stopPropagation && e.stopPropagation();
        }, d.preventDefault = function (e) {
          e.preventDefault && e.preventDefault();
        }, d.getButton = function (e) {
          return "dblclick" == e.type ? 0 : "contextmenu" == e.type || u.isMac && e.ctrlKey && !e.altKey && !e.shiftKey ? 2 : e.button;
        }, d.capture = function (e, t, i) {
          var n = e && e.ownerDocument || document;

          function r(e) {
            t && t(e), i && i(e), p(n, "mousemove", t), p(n, "mouseup", r), p(n, "dragstart", r);
          }

          return g(n, "mousemove", t), g(n, "mouseup", r), g(n, "dragstart", r), r;
        }, d.addMouseWheelListener = function (e, t, i) {
          "onmousewheel" in e ? g(e, "mousewheel", function (e) {
            void 0 !== e.wheelDeltaX ? (e.wheelX = -e.wheelDeltaX / 8, e.wheelY = -e.wheelDeltaY / 8) : (e.wheelX = 0, e.wheelY = -e.wheelDelta / 8), t(e);
          }, i) : "onwheel" in e ? g(e, "wheel", function (e) {
            switch (e.deltaMode) {
              case e.DOM_DELTA_PIXEL:
                e.wheelX = 0.35 * e.deltaX || 0, e.wheelY = 0.35 * e.deltaY || 0;
                break;

              case e.DOM_DELTA_LINE:
              case e.DOM_DELTA_PAGE:
                e.wheelX = 5 * (e.deltaX || 0), e.wheelY = 5 * (e.deltaY || 0);
            }

            t(e);
          }, i) : g(e, "DOMMouseScroll", function (e) {
            e.axis && e.axis == e.HORIZONTAL_AXIS ? (e.wheelX = 5 * (e.detail || 0), e.wheelY = 0) : (e.wheelX = 0, e.wheelY = 5 * (e.detail || 0)), t(e);
          }, i);
        }, d.addMultiMouseDownListener = function (e, i, n, r, t) {
          var o,
              s,
              a,
              l = 0,
              c = {
            2: "dblclick",
            3: "tripleclick",
            4: "quadclick"
          };

          function h(e) {
            var t;
            if (0 !== d.getButton(e) ? l = 0 : 1 < e.detail && !(4 < ++l) || (l = 1), u.isIE && (t = 5 < Math.abs(e.clientX - o) || 5 < Math.abs(e.clientY - s), a && !t || (l = 1), a && clearTimeout(a), a = setTimeout(function () {
              a = null;
            }, i[l - 1] || 600), 1 == l && (o = e.clientX, s = e.clientY)), e._clicks = l, n[r]("mousedown", e), 4 < l) l = 0;else if (1 < l) return n[r](c[l], e);
          }

          (e = Array.isArray(e) ? e : [e]).forEach(function (e) {
            g(e, "mousedown", h, t);
          });
        };

        function m(e, t, i) {
          var n = c(t);

          if (!u.isMac && s) {
            if (t.getModifierState && (t.getModifierState("OS") || t.getModifierState("Win")) && (n |= 8), s.altGr) {
              if (3 == (3 & n)) return;
              s.altGr = 0;
            }

            18 !== i && 17 !== i || (r = "location" in t ? t.location : t.keyLocation, 17 === i && 1 === r ? 1 == s[i] && (a = t.timeStamp) : 18 === i && 3 === n && 2 === r && t.timeStamp - a < 50 && (s.altGr = !0));
          }

          if (i in o.MODIFIER_KEYS && (i = -1), !n && 13 === i) {
            var r = "location" in t ? t.location : t.keyLocation;
            if (3 === r && (e(t, n, -i), t.defaultPrevented)) return;
          }

          if (u.isChromeOS && 8 & n) {
            if (e(t, n, i), t.defaultPrevented) return;
            n &= -9;
          }

          return !!(n || i in o.FUNCTION_KEYS || i in o.PRINTABLE_KEYS) && e(t, n, i);
        }

        function f() {
          s = Object.create(null);
        }

        d.getModifierString = function (e) {
          return o.KEY_MODS[c(e)];
        }, d.addCommandKeyListener = function (e, i, t) {
          var n, r;
          u.isOldGecko || u.isOpera && !("KeyboardEvent" in window) ? (n = null, g(e, "keydown", function (e) {
            n = e.keyCode;
          }, t), g(e, "keypress", function (e) {
            return m(i, e, n);
          }, t)) : (r = null, g(e, "keydown", function (e) {
            s[e.keyCode] = (s[e.keyCode] || 0) + 1;
            var t = m(i, e, e.keyCode);
            return r = e.defaultPrevented, t;
          }, t), g(e, "keypress", function (e) {
            r && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && (d.stopEvent(e), r = null);
          }, t), g(e, "keyup", function (e) {
            s[e.keyCode] = null;
          }, t), s || (f(), g(window, "focus", f)));
        }, "object" == typeof window && window.postMessage && !u.isOldIE && (h = 1, d.nextTick = function (t, i) {
          i = i || window;

          function n(e) {
            e.data == r && (d.stopPropagation(e), p(i, "message", n), t());
          }

          var r = "zero-timeout-message-" + h++;
          g(i, "message", n), i.postMessage(r, "*");
        }), d.$idleBlocked = !1, d.onIdle = function (t, e) {
          return setTimeout(function e() {
            d.$idleBlocked ? setTimeout(e, 100) : t();
          }, e);
        }, d.$idleBlockId = null, d.blockIdle = function (e) {
          d.$idleBlockId && clearTimeout(d.$idleBlockId), d.$idleBlocked = !0, d.$idleBlockId = setTimeout(function () {
            d.$idleBlocked = !1;
          }, e || 100);
        }, d.nextFrame = "object" == typeof window && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame), d.nextFrame ? d.nextFrame = d.nextFrame.bind(window) : d.nextFrame = function (e) {
          setTimeout(e, 17);
        };
      }), ace.define("ace/range", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        function o(e, t, i, n) {
          (this || _global).start = {
            row: e,
            column: t
          }, (this || _global).end = {
            row: i,
            column: n
          };
        }

        !function () {
          (this || _global).isEqual = function (e) {
            return (this || _global).start.row === e.start.row && (this || _global).end.row === e.end.row && (this || _global).start.column === e.start.column && (this || _global).end.column === e.end.column;
          }, (this || _global).toString = function () {
            return "Range: [" + (this || _global).start.row + "/" + (this || _global).start.column + "] -> [" + (this || _global).end.row + "/" + (this || _global).end.column + "]";
          }, (this || _global).contains = function (e, t) {
            return 0 == this.compare(e, t);
          }, (this || _global).compareRange = function (e) {
            var t = e.end,
                e = e.start,
                t = this.compare(t.row, t.column);
            return 1 == t ? 1 == (t = this.compare(e.row, e.column)) ? 2 : 0 == t ? 1 : 0 : -1 == t ? -2 : -1 == (t = this.compare(e.row, e.column)) ? -1 : 1 == t ? 42 : 0;
          }, (this || _global).comparePoint = function (e) {
            return this.compare(e.row, e.column);
          }, (this || _global).containsRange = function (e) {
            return 0 == this.comparePoint(e.start) && 0 == this.comparePoint(e.end);
          }, (this || _global).intersects = function (e) {
            e = this.compareRange(e);
            return -1 == e || 0 == e || 1 == e;
          }, (this || _global).isEnd = function (e, t) {
            return (this || _global).end.row == e && (this || _global).end.column == t;
          }, (this || _global).isStart = function (e, t) {
            return (this || _global).start.row == e && (this || _global).start.column == t;
          }, (this || _global).setStart = function (e, t) {
            "object" == typeof e ? ((this || _global).start.column = e.column, (this || _global).start.row = e.row) : ((this || _global).start.row = e, (this || _global).start.column = t);
          }, (this || _global).setEnd = function (e, t) {
            "object" == typeof e ? ((this || _global).end.column = e.column, (this || _global).end.row = e.row) : ((this || _global).end.row = e, (this || _global).end.column = t);
          }, (this || _global).inside = function (e, t) {
            return 0 == this.compare(e, t) && !this.isEnd(e, t) && !this.isStart(e, t);
          }, (this || _global).insideStart = function (e, t) {
            return 0 == this.compare(e, t) && !this.isEnd(e, t);
          }, (this || _global).insideEnd = function (e, t) {
            return 0 == this.compare(e, t) && !this.isStart(e, t);
          }, (this || _global).compare = function (e, t) {
            return this.isMultiLine() || e !== (this || _global).start.row ? e < (this || _global).start.row ? -1 : e > (this || _global).end.row ? 1 : (this || _global).start.row === e ? t >= (this || _global).start.column ? 0 : -1 : (this || _global).end.row !== e || t <= (this || _global).end.column ? 0 : 1 : t < (this || _global).start.column ? -1 : t > (this || _global).end.column ? 1 : 0;
          }, (this || _global).compareStart = function (e, t) {
            return (this || _global).start.row == e && (this || _global).start.column == t ? -1 : this.compare(e, t);
          }, (this || _global).compareEnd = function (e, t) {
            return (this || _global).end.row == e && (this || _global).end.column == t ? 1 : this.compare(e, t);
          }, (this || _global).compareInside = function (e, t) {
            return (this || _global).end.row == e && (this || _global).end.column == t ? 1 : (this || _global).start.row == e && (this || _global).start.column == t ? -1 : this.compare(e, t);
          }, (this || _global).clipRows = function (e, t) {
            var i, n;
            return (this || _global).end.row > t ? i = {
              row: t + 1,
              column: 0
            } : (this || _global).end.row < e && (i = {
              row: e,
              column: 0
            }), (this || _global).start.row > t ? n = {
              row: t + 1,
              column: 0
            } : (this || _global).start.row < e && (n = {
              row: e,
              column: 0
            }), o.fromPoints(n || (this || _global).start, i || (this || _global).end);
          }, (this || _global).extend = function (e, t) {
            var i,
                n,
                r = this.compare(e, t);
            return 0 == r ? this || _global : (-1 == r ? i = {
              row: e,
              column: t
            } : n = {
              row: e,
              column: t
            }, o.fromPoints(i || (this || _global).start, n || (this || _global).end));
          }, (this || _global).isEmpty = function () {
            return (this || _global).start.row === (this || _global).end.row && (this || _global).start.column === (this || _global).end.column;
          }, (this || _global).isMultiLine = function () {
            return (this || _global).start.row !== (this || _global).end.row;
          }, (this || _global).clone = function () {
            return o.fromPoints((this || _global).start, (this || _global).end);
          }, (this || _global).collapseRows = function () {
            return 0 == (this || _global).end.column ? new o((this || _global).start.row, 0, Math.max((this || _global).start.row, (this || _global).end.row - 1), 0) : new o((this || _global).start.row, 0, (this || _global).end.row, 0);
          }, (this || _global).toScreenRange = function (e) {
            var t = e.documentToScreenPosition((this || _global).start),
                e = e.documentToScreenPosition((this || _global).end);
            return new o(t.row, t.column, e.row, e.column);
          }, (this || _global).moveBy = function (e, t) {
            (this || _global).start.row += e, (this || _global).start.column += t, (this || _global).end.row += e, (this || _global).end.column += t;
          };
        }.call(o.prototype), o.fromPoints = function (e, t) {
          return new o(e.row, e.column, t.row, t.column);
        }, o.comparePoints = function (e, t) {
          return e.row - t.row || e.column - t.column;
        }, o.comparePoints = function (e, t) {
          return e.row - t.row || e.column - t.column;
        }, t.Range = o;
      }), ace.define("ace/lib/lang", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        t.last = function (e) {
          return e[e.length - 1];
        }, t.stringReverse = function (e) {
          return e.split("").reverse().join("");
        }, t.stringRepeat = function (e, t) {
          for (var i = ""; 0 < t;) 1 & t && (i += e), (t >>= 1) && (e += e);

          return i;
        };
        var n = /^\s\s*/,
            r = /\s\s*$/;
        t.stringTrimLeft = function (e) {
          return e.replace(n, "");
        }, t.stringTrimRight = function (e) {
          return e.replace(r, "");
        }, t.copyObject = function (e) {
          var t,
              i = {};

          for (t in e) i[t] = e[t];

          return i;
        }, t.copyArray = function (e) {
          for (var t = [], i = 0, n = e.length; i < n; i++) e[i] && "object" == typeof e[i] ? t[i] = this.copyObject(e[i]) : t[i] = e[i];

          return t;
        }, t.deepCopy = function e(t) {
          if ("object" != typeof t || !t) return t;

          if (Array.isArray(t)) {
            for (var i = [], n = 0; n < t.length; n++) i[n] = e(t[n]);

            return i;
          }

          if ("[object Object]" !== Object.prototype.toString.call(t)) return t;

          for (n in i = {}, t) i[n] = e(t[n]);

          return i;
        }, t.arrayToMap = function (e) {
          for (var t = {}, i = 0; i < e.length; i++) t[e[i]] = 1;

          return t;
        }, t.createMap = function (e) {
          var t,
              i = Object.create(null);

          for (t in e) i[t] = e[t];

          return i;
        }, t.arrayRemove = function (e, t) {
          for (var i = 0; i <= e.length; i++) t === e[i] && e.splice(i, 1);
        }, t.escapeRegExp = function (e) {
          return e.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
        }, t.escapeHTML = function (e) {
          return ("" + e).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
        }, t.getMatchOffsets = function (e, t) {
          var i = [];
          return e.replace(t, function (e) {
            i.push({
              offset: arguments[arguments.length - 2],
              length: e.length
            });
          }), i;
        }, t.deferredCall = function (e) {
          function t() {
            n = null, e();
          }

          function i(e) {
            return i.cancel(), n = setTimeout(t, e || 0), i;
          }

          var n = null;
          return (i.schedule = i).call = function () {
            return this.cancel(), e(), i;
          }, i.cancel = function () {
            return clearTimeout(n), n = null, i;
          }, i.isPending = function () {
            return n;
          }, i;
        }, t.delayedCall = function (e, t) {
          function i() {
            r = null, e();
          }

          function n(e) {
            null == r && (r = setTimeout(i, e || t));
          }

          var r = null;
          return n.delay = function (e) {
            r && clearTimeout(r), r = setTimeout(i, e || t);
          }, (n.schedule = n).call = function () {
            this.cancel(), e();
          }, n.cancel = function () {
            r && clearTimeout(r), r = null;
          }, n.isPending = function () {
            return r;
          }, n;
        };
      }), ace.define("ace/clipboard", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        var n;
        i.exports = {
          lineMode: !1,
          pasteCancelled: function () {
            return !!(n && n > Date.now() - 50) || (n = !1);
          },
          cancel: function () {
            n = Date.now();
          }
        };
      }), ace.define("ace/keyboard/textinput", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent", "ace/lib/dom", "ace/lib/lang", "ace/clipboard", "ace/lib/keys"], function (e, t, i) {
        "use strict";

        var F = e("../lib/event"),
            H = e("../lib/useragent"),
            V = e("../lib/dom"),
            Z = e("../lib/lang"),
            M = e("../clipboard"),
            O = H.isChrome < 18,
            D = H.isIE,
            K = 63 < H.isChrome,
            j = e("../lib/keys"),
            z = j.KEY_MODS,
            X = H.isIOS,
            J = X ? /\s/ : /\n/,
            Y = H.isMobile;
        t.TextInput = function (e, d) {
          var u = V.createElement("textarea"),
              o = (u.className = "ace_text-input", u.setAttribute("wrap", "off"), u.setAttribute("autocorrect", "off"), u.setAttribute("autocapitalize", "off"), u.setAttribute("spellcheck", !1), u.style.opacity = "0", e.insertBefore(u, e.firstChild), !1),
              g = !1,
              s = !1,
              p = !1,
              a = "",
              m = (Y || (u.style.fontSize = "1px"), !1),
              t = !1,
              f = "",
              C = 0,
              I = 0,
              v = 0;

          try {
            var l = document.activeElement === u;
          } catch (e) {}

          F.addListener(u, "blur", function (e) {
            t || (d.onBlur(e), l = !1);
          }, d), F.addListener(u, "focus", function (e) {
            if (!t) {
              if (l = !0, H.isEdge) try {
                if (!document.hasFocus()) return;
              } catch (e) {}
              d.onFocus(e), H.isEdge ? setTimeout(A) : A();
            }
          }, d), (this || _global).$focusScroll = !1, (this || _global).focus = function () {
            if (a || K || "browser" == (this || _global).$focusScroll) return u.focus({
              preventScroll: !0
            });
            var e = u.style.top;
            u.style.position = "fixed", u.style.top = "0px";

            try {
              var t = 0 != u.getBoundingClientRect().top;
            } catch (e) {
              return;
            }

            var i = [];
            if (t) for (var n = u.parentElement; n && 1 == n.nodeType;) i.push(n), n.setAttribute("ace_nocontext", !0), n = !n.parentElement && n.getRootNode ? n.getRootNode().host : n.parentElement;
            u.focus({
              preventScroll: !0
            }), t && i.forEach(function (e) {
              e.removeAttribute("ace_nocontext");
            }), setTimeout(function () {
              u.style.position = "", "0px" == u.style.top && (u.style.top = e);
            }, 0);
          }, (this || _global).blur = function () {
            u.blur();
          }, (this || _global).isFocused = function () {
            return l;
          }, d.on("beforeEndOperation", function () {
            var e = d.curOp,
                t = e && e.command && e.command.name;
            "insertstring" != t && (t = t && (e.docChanged || e.selectionChanged), s && t && (f = u.value = "", k()), A());
          });

          function i(e) {
            S(e, !0);
          }

          function n(e) {
            S(e, !1);
          }

          function r(e) {
            var t = w(e);
            M.pasteCancelled() || ("string" == typeof t ? (t && d.onPaste(t, e), H.isIE && setTimeout(A), F.preventDefault(e)) : (u.value = "", g = !0));
          }

          var A = X ? function (e) {
            var t;
            !l || o && !e || p || ((t = "\n ab" + (e = e || "") + "cde fg\n") != u.value && (u.value = f = t), t = 4 + (e.length || (d.selection.isEmpty() ? 0 : 1)), 4 == C && I == t || u.setSelectionRange(4, t), C = 4, I = t);
          } : function () {
            if (!s && !p && (l || b)) {
              s = !0;
              var e,
                  t,
                  i = 0,
                  n = 0,
                  r = "",
                  o = (d.session && (o = (e = d.selection).getRange(), e = e.cursor.row, i = o.start.column, n = o.end.column, r = d.session.getLine(e), o.start.row != e ? (t = d.session.getLine(e - 1), i = o.start.row < e - 1 ? 0 : i, n += t.length + 1, r = t + "\n" + r) : o.end.row != e ? (t = d.session.getLine(e + 1), n = o.end.row > e + 1 ? t.length : n, n += r.length + 1, r = r + "\n" + t) : Y && 0 < e && (r = "\n" + r, n += 1, i += 1), 400 < r.length && (i < 400 && n < 400 ? r = r.slice(0, 400) : (r = "\n", i == n ? i = n = 0 : (i = 0, n = 1)))), r + "\n\n");
              if (o != f && (u.value = f = o, C = I = o.length), b && (C = u.selectionStart, I = u.selectionEnd), I != n || C != i || u.selectionEnd != I) try {
                u.setSelectionRange(i, n), C = i, I = n;
              } catch (e) {}
              s = !1;
            }
          },
              G = ((this || _global).resetSelection = A, l && d.onFocus(), function (e) {
            return 0 === e.selectionStart && e.selectionEnd >= f.length && e.value === f && f && e.selectionEnd !== I;
          }),
              c = null,
              b = ((this || _global).setInputHandler = function (e) {
            c = e;
          }, !((this || _global).getInputHandler = function () {
            return c;
          })),
              h = function (e, t) {
            if (b = b && !1, g) return A(), e && d.onPaste(e), g = !1, "";

            for (var i = u.selectionStart, n = u.selectionEnd, r = C, o = f.length - I, s = e, a = e.length - i, l = e.length - n, c = 0; 0 < r && f[c] == e[c];) c++, r--;

            for (s = s.slice(c), c = 1; 0 < o && f.length - c > C - 1 && f[f.length - c] == e[e.length - c];) c++, o--;

            a -= c - 1, l -= c - 1;
            var h = s.length - c + 1;
            if (h < 0 && (r = -h, h = 0), s = s.slice(0, h), !(t || s || a || r || o || l)) return "";
            h = !(p = !0);
            return H.isAndroid && ". " == s && (s = "  ", h = !0), s && !r && !o && !a && !l || m ? d.onTextInput(s) : d.onTextInput(s, {
              extendLeft: r,
              extendRight: o,
              restoreStart: a,
              restoreEnd: l
            }), p = !1, f = e, C = i, I = n, v = l, h ? "\n" : s;
          },
              y = function (e) {
            if (s) return x();

            if (e && e.inputType) {
              if ("historyUndo" == e.inputType) return d.execCommand("undo");
              if ("historyRedo" == e.inputType) return d.execCommand("redo");
            }

            var e = u.value,
                t = h(e, !0);
            (500 < e.length || J.test(t) || Y && C < 1 && C == I) && A();
          },
              w = function (e, t, i) {
            var n = e.clipboardData || window.clipboardData;

            if (n && !O) {
              var r = D || i ? "Text" : "text/plain";

              try {
                return t ? !1 !== n.setData(r, t) : n.getData(r);
              } catch (e) {
                if (!i) return w(e, t, !0);
              }
            }
          },
              S = function (e, t) {
            var i = d.getCopyText();
            if (!i) return F.preventDefault(e);
            w(e, i) ? (X && (A(i), o = i, setTimeout(function () {
              o = !1;
            }, 10)), t ? d.onCut() : d.onCopy(), F.preventDefault(e)) : (o = !0, u.value = i, u.select(), setTimeout(function () {
              o = !1, A(), t ? d.onCut() : d.onCopy();
            }));
          },
              x = (F.addCommandKeyListener(u, d.onCommandKey.bind(d), d), F.addListener(u, "select", function (e) {
            s || (o ? o = !1 : G(u) ? (d.selectAll(), A()) : Y && u.selectionStart != C && A());
          }, d), F.addListener(u, "input", y, d), F.addListener(u, "cut", i, d), F.addListener(u, "copy", n, d), F.addListener(u, "paste", r, d), "oncut" in u && "oncopy" in u && "onpaste" in u || F.addListener(e, "keydown", function (e) {
            if ((!H.isMac || e.metaKey) && e.ctrlKey) switch (e.keyCode) {
              case 67:
                n(e);
                break;

              case 86:
                r(e);
                break;

              case 88:
                i(e);
            }
          }, d), function () {
            var e;
            if (s && d.onCompositionUpdate && !d.$readOnly) return m ? E() : void (s.useTextareaForIME ? d.onCompositionUpdate(u.value) : (e = u.value, h(e), s.markerRange && (s.context && (s.markerRange.start.column = s.selectionStart = s.context.compositionStartOffset), s.markerRange.end.column = s.markerRange.start.column + I - s.selectionStart + v)));
          }),
              k = function (e) {
            d.onCompositionEnd && !d.$readOnly && (s = !1, d.onCompositionEnd(), d.off("mousedown", E), e && y());
          };

          function E() {
            t = !0, u.blur(), u.focus(), t = !1;
          }

          var R,
              T = Z.delayedCall(x, 50).schedule.bind(null, null);

          function _() {
            clearTimeout(R), R = setTimeout(function () {
              a && (u.style.cssText = a, a = ""), d.renderer.$isMousePressed = !1, d.renderer.$keepTextAreaAtCursor && d.renderer.$moveTextAreaToCursor();
            }, 0);
          }

          F.addListener(u, "compositionstart", function (e) {
            s || !d.onCompositionStart || d.$readOnly || (s = {}, m || (e.data && (s.useTextareaForIME = !1), setTimeout(x, 0), d._signal("compositionStart"), d.on("mousedown", E), (e = d.getSelectionRange()).end.row = e.start.row, e.end.column = e.start.column, s.markerRange = e, s.selectionStart = C, d.onCompositionStart(s), s.useTextareaForIME ? (f = u.value = "", I = C = 0) : (u.msGetInputContext && (s.context = u.msGetInputContext()), u.getInputContext && (s.context = u.getInputContext()))));
          }, d), F.addListener(u, "compositionupdate", x, d), F.addListener(u, "keyup", function (e) {
            27 == e.keyCode && u.value.length < u.selectionStart && (s || (f = u.value), C = I = -1, A()), T();
          }, d), F.addListener(u, "keydown", T, d), F.addListener(u, "compositionend", k, d), (this || _global).getElement = function () {
            return u;
          }, (this || _global).setCommandMode = function (e) {
            m = e, u.readOnly = !1;
          }, (this || _global).setReadOnly = function (e) {
            m || (u.readOnly = e);
          }, (this || _global).setCopyWithEmptySelection = function (e) {}, (this || _global).onContextMenu = function (e) {
            b = !0, A(), d._emit("nativecontextmenu", {
              target: d,
              domEvent: e
            }), this.moveToMouse(e, !0);
          }, (this || _global).moveToMouse = function (e, t) {
            a = a || u.style.cssText, u.style.cssText = (t ? "z-index:100000;" : "") + (H.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (C + I) * d.renderer.characterWidth * 0.5 + "px;";

            function i(e) {
              V.translate(u, e.clientX - o - 2, Math.min(e.clientY - r - 2, s));
            }

            var t = d.container.getBoundingClientRect(),
                n = V.computedStyle(d.container),
                r = t.top + (parseInt(n.borderTopWidth) || 0),
                o = t.left + (parseInt(t.borderLeftWidth) || 0),
                s = t.bottom - r - u.clientHeight - 2;
            i(e), "mousedown" == e.type && (d.renderer.$isMousePressed = !0, clearTimeout(R), H.isWin && F.capture(d.container, i, _));
          }, (this || _global).onContextMenuClose = _;

          function $(e) {
            d.textInput.onContextMenu(e), _();
          }

          if (F.addListener(u, "mouseup", $, d), F.addListener(u, "mousedown", function (e) {
            e.preventDefault(), _();
          }, d), F.addListener(d.renderer.scroller, "contextmenu", $, d), F.addListener(u, "contextmenu", $, d), X) {
            var L = d,
                B = u;

            function P(e) {
              var t, i, n, r;
              document.activeElement !== B || N || s || L.$mouseHandler.isMousePressed || o || (t = B.selectionStart, i = B.selectionEnd, n = null, (r = 0) == t ? n = j.up : 1 == t ? n = j.home : I < i && "\n" == f[i] ? n = j.end : t < C && " " == f[t - 1] ? (n = j.left, r = z.option) : t < C || t == C && I != C && t == i ? n = j.left : I < i && 2 < f.slice(0, i).split("\n").length ? n = j.down : I < i && " " == f[i - 1] ? (n = j.right, r = z.option) : (I < i || i == I && I != C && t == i) && (n = j.right), t !== i && (r |= z.shift), n && (!L.onCommandKey({}, r, n) && L.commands && (n = j.keyCodeToString(n), (r = L.commands.findKeyCommand(r, n)) && L.execCommand(r)), C = t, I = i, A("")));
            }

            var W = null,
                N = !1;
            B.addEventListener("keydown", function (e) {
              W && clearTimeout(W), N = !0;
            }, !0), B.addEventListener("keyup", function (e) {
              W = setTimeout(function () {
                N = !1;
              }, 100);
            }, !0), document.addEventListener("selectionchange", P), L.on("destroy", function () {
              document.removeEventListener("selectionchange", P);
            });
          }
        }, t.$setUserAgentForTests = function (e, t) {
          Y = e, X = t;
        };
      }), ace.define("ace/mouse/default_handlers", ["require", "exports", "module", "ace/lib/useragent"], function (e, t, i) {
        "use strict";

        var o = e("../lib/useragent");

        function n(t) {
          t.$clickSelection = null;
          var e = t.editor;
          e.setDefaultHandler("mousedown", (this || _global).onMouseDown.bind(t)), e.setDefaultHandler("dblclick", (this || _global).onDoubleClick.bind(t)), e.setDefaultHandler("tripleclick", (this || _global).onTripleClick.bind(t)), e.setDefaultHandler("quadclick", (this || _global).onQuadClick.bind(t)), e.setDefaultHandler("mousewheel", (this || _global).onMouseWheel.bind(t));
          ["select", "startSelect", "selectEnd", "selectAllEnd", "selectByWordsEnd", "selectByLinesEnd", "dragWait", "dragWaitEnd", "focusWait"].forEach(function (e) {
            t[e] = (this || _global)[e];
          }, this || _global), t.selectByLines = (this || _global).extendSelectionBy.bind(t, "getLineRange"), t.selectByWords = (this || _global).extendSelectionBy.bind(t, "getWordRange");
        }

        function s(e, t) {
          return (e.start.row == e.end.row ? 2 * t.column - e.start.column - e.end.column : e.start.row != e.end.row - 1 || e.start.column || e.end.column ? 2 * t.row - e.start.row - e.end.row : t.column - 4) < 0 ? {
            cursor: e.start,
            anchor: e.end
          } : {
            cursor: e.end,
            anchor: e.start
          };
        }

        !function () {
          (this || _global).onMouseDown = function (e) {
            var t = e.inSelection(),
                i = e.getDocumentPosition(),
                n = ((this || _global).mousedownEvent = e, (this || _global).editor),
                r = e.getButton();
            return 0 !== r ? (!n.getSelectionRange().isEmpty() && 1 != r || n.selection.moveToPosition(i), void (2 == r && (n.textInput.onContextMenu(e.domEvent), o.isMozilla || e.preventDefault()))) : ((this || _global).mousedownEvent.time = Date.now(), !t || n.isFocused() || (n.focus(), !(this || _global).$focusTimeout || (this || _global).$clickSelection || n.inMultiSelectMode) ? (this.captureMouse(e), this.startSelect(i, 1 < e.domEvent._clicks), e.preventDefault()) : (this.setState("focusWait"), void this.captureMouse(e)));
          }, (this || _global).startSelect = function (e, t) {
            e = e || (this || _global).editor.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y);
            var i = (this || _global).editor;
            (this || _global).mousedownEvent && ((this || _global).mousedownEvent.getShiftKey() ? i.selection.selectToPosition(e) : t || i.selection.moveToPosition(e), t || this.select(), i.renderer.scroller.setCapture && i.renderer.scroller.setCapture(), i.setStyle("ace_selecting"), this.setState("select"));
          }, (this || _global).select = function () {
            var e,
                t = (this || _global).editor,
                i = t.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y);
            (this || _global).$clickSelection && (e = -1 == (e = (this || _global).$clickSelection.comparePoint(i)) ? (this || _global).$clickSelection.end : 1 == e ? (this || _global).$clickSelection.start : (i = (e = s((this || _global).$clickSelection, i)).cursor, e.anchor), t.selection.setSelectionAnchor(e.row, e.column)), t.selection.selectToPosition(i), t.renderer.scrollCursorIntoView();
          }, (this || _global).extendSelectionBy = function (e) {
            var t,
                i,
                n,
                r = (this || _global).editor,
                o = r.renderer.screenToTextCoordinates((this || _global).x, (this || _global).y),
                e = r.selection[e](o.row, o.column);
            (this || _global).$clickSelection && (i = (this || _global).$clickSelection.comparePoint(e.start), t = (this || _global).$clickSelection.comparePoint(e.end), -1 == i && t <= 0 ? (n = (this || _global).$clickSelection.end, e.end.row == o.row && e.end.column == o.column || (o = e.start)) : 1 == t && 0 <= i ? (n = (this || _global).$clickSelection.start, e.start.row == o.row && e.start.column == o.column || (o = e.end)) : n = -1 == i && 1 == t ? (o = e.end, e.start) : (o = (i = s((this || _global).$clickSelection, o)).cursor, i.anchor), r.selection.setSelectionAnchor(n.row, n.column)), r.selection.selectToPosition(o), r.renderer.scrollCursorIntoView();
          }, (this || _global).selectEnd = (this || _global).selectAllEnd = (this || _global).selectByWordsEnd = (this || _global).selectByLinesEnd = function () {
            (this || _global).$clickSelection = null, (this || _global).editor.unsetStyle("ace_selecting"), (this || _global).editor.renderer.scroller.releaseCapture && (this || _global).editor.renderer.scroller.releaseCapture();
          }, (this || _global).focusWait = function () {
            n = (this || _global).mousedownEvent.x, e = (this || _global).mousedownEvent.y, i = (this || _global).x, t = (this || _global).y;
            var e,
                t,
                i = Math.sqrt(Math.pow(i - n, 2) + Math.pow(t - e, 2)),
                n = Date.now();
            (0 < i || n - (this || _global).mousedownEvent.time > (this || _global).$focusTimeout) && this.startSelect((this || _global).mousedownEvent.getDocumentPosition());
          }, (this || _global).onDoubleClick = function (e) {
            var e = e.getDocumentPosition(),
                t = (this || _global).editor,
                i = t.session.getBracketRange(e);
            i ? (i.isEmpty() && (i.start.column--, i.end.column++), this.setState("select")) : (i = t.selection.getWordRange(e.row, e.column), this.setState("selectByWords")), (this || _global).$clickSelection = i, this.select();
          }, (this || _global).onTripleClick = function (e) {
            var e = e.getDocumentPosition(),
                t = (this || _global).editor,
                i = (this.setState("selectByLines"), t.getSelectionRange());
            i.isMultiLine() && i.contains(e.row, e.column) ? ((this || _global).$clickSelection = t.selection.getLineRange(i.start.row), (this || _global).$clickSelection.end = t.selection.getLineRange(i.end.row).end) : (this || _global).$clickSelection = t.selection.getLineRange(e.row), this.select();
          }, (this || _global).onQuadClick = function (e) {
            var t = (this || _global).editor;
            t.selectAll(), (this || _global).$clickSelection = t.getSelectionRange(), this.setState("selectAll");
          }, (this || _global).onMouseWheel = function (e) {
            var t, i, n, r, o, s, a;
            if (!e.getAccelKey()) return e.getShiftKey() && e.wheelY && !e.wheelX && (e.wheelX = e.wheelY, e.wheelY = 0), t = (this || _global).editor, (this || _global).$lastScroll || ((this || _global).$lastScroll = {
              t: 0,
              vx: 0,
              vy: 0,
              allowed: 0
            }), i = (this || _global).$lastScroll, n = e.domEvent.timeStamp, s = n - i.t, r = s ? e.wheelX / s : i.vx, o = s ? e.wheelY / s : i.vy, s < 550 && (r = (r + i.vx) / 2, o = (o + i.vy) / 2), s = Math.abs(r / o), a = !1, 1 <= s && t.renderer.isScrollableBy(e.wheelX * e.speed, 0) && (a = !0), (a = s <= 1 && t.renderer.isScrollableBy(0, e.wheelY * e.speed) ? !0 : a) ? i.allowed = n : n - i.allowed < 550 && (Math.abs(r) <= 1.5 * Math.abs(i.vx) && Math.abs(o) <= 1.5 * Math.abs(i.vy) ? (a = !0, i.allowed = n) : i.allowed = 0), i.t = n, i.vx = r, i.vy = o, a ? (t.renderer.scrollBy(e.wheelX * e.speed, e.wheelY * e.speed), e.stop()) : void 0;
          };
        }.call(n.prototype), t.DefaultHandlers = n;
      }), ace.define("ace/tooltip", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        e("./lib/oop");
        var n = e("./lib/dom");

        function r(e) {
          (this || _global).isOpen = !1, (this || _global).$element = null, (this || _global).$parentNode = e;
        }

        !function () {
          (this || _global).$init = function () {
            return (this || _global).$element = n.createElement("div"), (this || _global).$element.className = "ace_tooltip", (this || _global).$element.style.display = "none", (this || _global).$parentNode.appendChild((this || _global).$element), (this || _global).$element;
          }, (this || _global).getElement = function () {
            return (this || _global).$element || this.$init();
          }, (this || _global).setText = function (e) {
            this.getElement().textContent = e;
          }, (this || _global).setHtml = function (e) {
            this.getElement().innerHTML = e;
          }, (this || _global).setPosition = function (e, t) {
            this.getElement().style.left = e + "px", this.getElement().style.top = t + "px";
          }, (this || _global).setClassName = function (e) {
            n.addCssClass(this.getElement(), e);
          }, (this || _global).show = function (e, t, i) {
            null != e && this.setText(e), null != t && null != i && this.setPosition(t, i), (this || _global).isOpen || (this.getElement().style.display = "block", (this || _global).isOpen = !0);
          }, (this || _global).hide = function () {
            (this || _global).isOpen && (this.getElement().style.display = "none", (this || _global).isOpen = !1);
          }, (this || _global).getHeight = function () {
            return this.getElement().offsetHeight;
          }, (this || _global).getWidth = function () {
            return this.getElement().offsetWidth;
          }, (this || _global).destroy = function () {
            (this || _global).isOpen = !1, (this || _global).$element && (this || _global).$element.parentNode && (this || _global).$element.parentNode.removeChild((this || _global).$element);
          };
        }.call(r.prototype), t.Tooltip = r;
      }), ace.define("ace/mouse/default_gutter_handler", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/event", "ace/tooltip"], function (e, t, i) {
        "use strict";

        var d = e("../lib/dom"),
            n = e("../lib/oop"),
            u = e("../lib/event"),
            s = e("../tooltip").Tooltip;

        function g(e) {
          s.call(this || _global, e);
        }

        n.inherits(g, s), function () {
          (this || _global).setPosition = function (e, t) {
            var i = window.innerWidth || document.documentElement.clientWidth,
                n = window.innerHeight || document.documentElement.clientHeight,
                r = this.getWidth(),
                o = this.getHeight();
            i < (e += 15) + r && (e -= e + r - i), n < (t += 15) + o && (t -= 20 + o), s.prototype.setPosition.call(this || _global, e, t);
          };
        }.call(g.prototype), t.GutterHandler = function (n) {
          var i,
              r,
              o,
              s = n.editor,
              a = s.renderer.$gutterLayer,
              l = new g(s.container);

          function c() {
            i = i && clearTimeout(i), o && (l.hide(), o = null, s._signal("hideGutterTooltip", l), s.off("mousewheel", c));
          }

          function h(e) {
            l.setPosition(e.x, e.y);
          }

          n.editor.setDefaultHandler("guttermousedown", function (e) {
            if (s.isFocused() && 0 == e.getButton()) {
              var t = a.getRegion(e);

              if ("foldWidgets" != t) {
                var t = e.getDocumentPosition().row,
                    i = s.session.selection;
                if (e.getShiftKey()) i.selectTo(t, 0);else {
                  if (2 == e.domEvent.detail) return s.selectAll(), e.preventDefault();
                  n.$clickSelection = s.selection.getLineRange(t);
                }
                return n.setState("selectByLines"), n.captureMouse(e), e.preventDefault();
              }
            }
          }), n.editor.setDefaultHandler("guttermousemove", function (e) {
            var t = e.domEvent.target || e.domEvent.srcElement;
            if (d.hasCssClass(t, "ace_fold-widget")) return c();
            o && n.$tooltipFollowsMouse && h(e), r = e, i = i || setTimeout(function () {
              i = null, (r && !n.isMousePressed ? function () {
                var e = r.getDocumentPosition().row,
                    t = a.$annotations[e];
                if (!t) return c();

                if (e == s.session.getLength()) {
                  var e = s.renderer.pixelToScreenCoordinates(0, r.y).row,
                      i = r.$pos;
                  if (e > s.session.documentToScreenRow(i.row, i.column)) return c();
                }

                o != t && (o = t.text.join("<br/>"), l.setHtml(o), l.show(), s._signal("showGutterTooltip", l), s.on("mousewheel", c), n.$tooltipFollowsMouse ? h(r) : (e = r.domEvent.target.getBoundingClientRect(), (i = l.getElement().style).left = e.right + "px", i.top = e.bottom + "px"));
              } : c)();
            }, 50);
          }), u.addListener(s.renderer.$gutter, "mouseout", function (e) {
            r = null, o && !i && (i = setTimeout(function () {
              i = null, c();
            }, 50));
          }, s), s.on("changeSession", c);
        };
      }), ace.define("ace/mouse/mouse_event", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent"], function (e, t, i) {
        "use strict";

        var n = e("../lib/event"),
            r = e("../lib/useragent"),
            e = t.MouseEvent = function (e, t) {
          (this || _global).domEvent = e, (this || _global).editor = t, (this || _global).x = (this || _global).clientX = e.clientX, (this || _global).y = (this || _global).clientY = e.clientY, (this || _global).$pos = null, (this || _global).$inSelection = null, (this || _global).propagationStopped = !1, (this || _global).defaultPrevented = !1;
        };

        !function () {
          (this || _global).stopPropagation = function () {
            n.stopPropagation((this || _global).domEvent), (this || _global).propagationStopped = !0;
          }, (this || _global).preventDefault = function () {
            n.preventDefault((this || _global).domEvent), (this || _global).defaultPrevented = !0;
          }, (this || _global).stop = function () {
            this.stopPropagation(), this.preventDefault();
          }, (this || _global).getDocumentPosition = function () {
            return (this || _global).$pos || ((this || _global).$pos = (this || _global).editor.renderer.screenToTextCoordinates((this || _global).clientX, (this || _global).clientY), (this || _global).$pos);
          }, (this || _global).inSelection = function () {
            if (null !== (this || _global).$inSelection) return (this || _global).$inSelection;

            var e,
                t = (this || _global).editor.getSelectionRange();

            return t.isEmpty() ? (this || _global).$inSelection = !1 : (e = this.getDocumentPosition(), (this || _global).$inSelection = t.contains(e.row, e.column)), (this || _global).$inSelection;
          }, (this || _global).getButton = function () {
            return n.getButton((this || _global).domEvent);
          }, (this || _global).getShiftKey = function () {
            return (this || _global).domEvent.shiftKey;
          }, (this || _global).getAccelKey = r.isMac ? function () {
            return (this || _global).domEvent.metaKey;
          } : function () {
            return (this || _global).domEvent.ctrlKey;
          };
        }.call(e.prototype);
      }), ace.define("ace/mouse/dragdrop_handler", ["require", "exports", "module", "ace/lib/dom", "ace/lib/event", "ace/lib/useragent"], function (e, t, i) {
        "use strict";

        var w = e("../lib/dom"),
            S = e("../lib/event"),
            x = e("../lib/useragent");

        function n(t) {
          var i,
              c,
              h,
              e,
              n,
              d,
              r,
              o,
              u,
              g,
              p,
              m = t.editor,
              s = w.createElement("div"),
              a = (s.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5", s.textContent = "\xA0", ["dragWait", "dragWaitEnd", "startDrag", "dragReadyEnd", "onMouseDrag"].forEach(function (e) {
            t[e] = (this || _global)[e];
          }, this || _global), m.on("mousedown", (this || _global).onMouseDown.bind(t)), m.container),
              l = 0;

          function f() {
            var e,
                t,
                i,
                n,
                r,
                o,
                s,
                a,
                l = d;
            d = m.renderer.screenToTextCoordinates(c, h), i = d, t = l, n = Date.now(), e = !t || i.row != t.row, t = !t || i.column != t.column, !g || e || t ? (m.moveCursorToPosition(i), g = n, p = {
              x: c,
              y: h
            }) : 5 < k(p.x, p.y, c, h) ? g = null : 200 <= n - g && (m.renderer.scrollCursorIntoView(), g = null), e = d, t = l, i = Date.now(), n = m.renderer.layerConfig.lineHeight, l = m.renderer.layerConfig.characterWidth, r = m.renderer.scroller.getBoundingClientRect(), r = {
              x: {
                left: c - r.left,
                right: r.right - c
              },
              y: {
                top: h - r.top,
                bottom: r.bottom - h
              }
            }, o = Math.min(r.x.left, r.x.right), s = Math.min(r.y.top, r.y.bottom), a = {
              row: e.row,
              column: e.column
            }, o / l <= 2 && (a.column += r.x.left < r.x.right ? -3 : 2), s / n <= 1 && (a.row += r.y.top < r.y.bottom ? -1 : 1), o = e.row != a.row, l = e.column != a.column, s = !t || e.row != t.row, o || l && !s ? u ? 200 <= i - u && m.renderer.scrollCursorIntoView(a) : u = i : u = null;
          }

          function C() {
            n = m.selection.toOrientedRange(), i = m.session.addMarker(n, "ace_selection", m.getSelectionStyle()), m.clearSelection(), m.isFocused() && m.renderer.$cursorLayer.setBlinking(!1), clearInterval(e), f(), e = setInterval(f, 20), l = 0, S.addListener(document, "mousemove", A);
          }

          function I() {
            clearInterval(e), m.session.removeMarker(i), i = null, m.selection.fromOrientedRange(n), m.isFocused() && !o && m.$resetCursorStyle(), l = 0, g = u = d = n = null, S.removeListener(document, "mousemove", A);
          }

          (this || _global).onDragStart = function (e) {
            var t;
            if ((this || _global).cancelDrag || !a.draggable) return t = this || _global, setTimeout(function () {
              t.startSelect(), t.captureMouse(e);
            }, 0), e.preventDefault();
            n = m.getSelectionRange();
            var i = e.dataTransfer;
            i.effectAllowed = m.getReadOnly() ? "copy" : "copyMove", m.container.appendChild(s), i.setDragImage && i.setDragImage(s, 0, 0), setTimeout(function () {
              m.container.removeChild(s);
            }), i.clearData(), i.setData("Text", m.session.getTextRange()), o = !0, this.setState("drag");
          }, (this || _global).onDragEnd = function (e) {
            a.draggable = !1, o = !1, this.setState(null), m.getReadOnly() || (e = e.dataTransfer.dropEffect, r || "move" != e || m.session.remove(m.getSelectionRange()), m.$resetCursorStyle()), (this || _global).editor.unsetStyle("ace_dragging"), (this || _global).editor.renderer.setCursorStyle("");
          }, (this || _global).onDragEnter = function (e) {
            if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, i || C(), l++, e.dataTransfer.dropEffect = r = y(e), S.preventDefault(e);
          }, (this || _global).onDragOver = function (e) {
            if (!m.getReadOnly() && b(e.dataTransfer)) return c = e.clientX, h = e.clientY, i || (C(), l++), null !== v && (v = null), e.dataTransfer.dropEffect = r = y(e), S.preventDefault(e);
          }, (this || _global).onDragLeave = function (e) {
            if (--l <= 0 && i) return I(), r = null, S.preventDefault(e);
          }, (this || _global).onDrop = function (e) {
            if (d) {
              var t = e.dataTransfer;
              if (o) switch (r) {
                case "move":
                  n = n.contains(d.row, d.column) ? {
                    start: d,
                    end: d
                  } : m.moveText(n, d);
                  break;

                case "copy":
                  n = m.moveText(n, d, !0);
              } else {
                t = t.getData("Text");
                n = {
                  start: d,
                  end: m.session.insert(d, t)
                }, m.focus(), r = null;
              }
              return I(), S.preventDefault(e);
            }
          }, S.addListener(a, "dragstart", (this || _global).onDragStart.bind(t), m), S.addListener(a, "dragend", (this || _global).onDragEnd.bind(t), m), S.addListener(a, "dragenter", (this || _global).onDragEnter.bind(t), m), S.addListener(a, "dragover", (this || _global).onDragOver.bind(t), m), S.addListener(a, "dragleave", (this || _global).onDragLeave.bind(t), m), S.addListener(a, "drop", (this || _global).onDrop.bind(t), m);
          var v = null;

          function A() {
            null == v && (v = setTimeout(function () {
              null != v && i && I();
            }, 20));
          }

          function b(e) {
            e = e.types;
            return !e || Array.prototype.some.call(e, function (e) {
              return "text/plain" == e || "Text" == e;
            });
          }

          function y(e) {
            var t = ["copy", "copymove", "all", "uninitialized"],
                i = x.isMac ? e.altKey : e.ctrlKey,
                n = "uninitialized";

            try {
              n = e.dataTransfer.effectAllowed.toLowerCase();
            } catch (e) {}

            var r = "none";
            return i && 0 <= t.indexOf(n) ? r = "copy" : 0 <= ["move", "copymove", "linkmove", "all", "uninitialized"].indexOf(n) ? r = "move" : 0 <= t.indexOf(n) && (r = "copy"), r;
          }
        }

        function k(e, t, i, n) {
          return Math.sqrt(Math.pow(i - e, 2) + Math.pow(n - t, 2));
        }

        !function () {
          (this || _global).dragWait = function () {
            Date.now() - (this || _global).mousedownEvent.time > (this || _global).editor.getDragDelay() && this.startDrag();
          }, (this || _global).dragWaitEnd = function () {
            (this || _global).editor.container.draggable = !1, this.startSelect((this || _global).mousedownEvent.getDocumentPosition()), this.selectEnd();
          }, (this || _global).dragReadyEnd = function (e) {
            (this || _global).editor.$resetCursorStyle(), (this || _global).editor.unsetStyle("ace_dragging"), (this || _global).editor.renderer.setCursorStyle(""), this.dragWaitEnd();
          }, (this || _global).startDrag = function () {
            (this || _global).cancelDrag = !1;
            var e = (this || _global).editor,
                t = (e.container.draggable = !0, e.renderer.$cursorLayer.setBlinking(!1), e.setStyle("ace_dragging"), x.isWin ? "default" : "move");
            e.renderer.setCursorStyle(t), this.setState("dragReady");
          }, (this || _global).onMouseDrag = function (e) {
            var t = (this || _global).editor.container;
            x.isIE && "dragReady" == (this || _global).state && 3 < k((this || _global).mousedownEvent.x, (this || _global).mousedownEvent.y, (this || _global).x, (this || _global).y) && t.dragDrop(), "dragWait" === (this || _global).state && 0 < k((this || _global).mousedownEvent.x, (this || _global).mousedownEvent.y, (this || _global).x, (this || _global).y) && (t.draggable = !1, this.startSelect((this || _global).mousedownEvent.getDocumentPosition()));
          }, (this || _global).onMouseDown = function (e) {
            var t, i, n;
            (this || _global).$dragEnabled && ((this || _global).mousedownEvent = e, t = (this || _global).editor, i = e.inSelection(), n = e.getButton(), 1 !== (e.domEvent.detail || 1) || 0 !== n || !i || e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey()) || ((this || _global).mousedownEvent.time = Date.now(), "unselectable" in (n = e.domEvent.target || e.domEvent.srcElement) && (n.unselectable = "on"), t.getDragDelay() ? (x.isWebKit && ((this || _global).cancelDrag = !0, t.container.draggable = !0), this.setState("dragWait")) : this.startDrag(), this.captureMouse(e, (this || _global).onMouseDrag.bind(this || _global)), e.defaultPrevented = !0));
          };
        }.call(n.prototype), t.DragdropHandler = n;
      }), ace.define("ace/mouse/touch_handler", ["require", "exports", "module", "ace/mouse/mouse_event", "ace/lib/event", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        var S = e("./mouse_event").MouseEvent,
            n = e("../lib/event"),
            a = e("../lib/dom");

        t.addTouchListeners = function (e, h) {
          var d,
              u,
              g,
              p,
              m,
              t,
              f,
              C,
              o,
              I = "scroll",
              v = 0,
              A = 0,
              b = 0,
              y = 0;

          function r() {
            function t(e) {
              var t,
                  i = e.target.getAttribute("action");
              if ("more" == i || !r) return r = !r, e = h.getCopyText(), t = h.session.getUndoManager().hasUndo(), void o.replaceChild(a.buildDom(r ? ["span", !e && ["span", {
                class: "ace_mobile-button",
                action: "selectall"
              }, "Select All"], e && ["span", {
                class: "ace_mobile-button",
                action: "copy"
              }, "Copy"], e && ["span", {
                class: "ace_mobile-button",
                action: "cut"
              }, "Cut"], n && ["span", {
                class: "ace_mobile-button",
                action: "paste"
              }, "Paste"], t && ["span", {
                class: "ace_mobile-button",
                action: "undo"
              }, "Undo"], ["span", {
                class: "ace_mobile-button",
                action: "find"
              }, "Find"], ["span", {
                class: "ace_mobile-button",
                action: "openCommandPallete"
              }, "Pallete"]] : ["span"]), o.firstChild);
              "paste" == i ? n.readText().then(function (e) {
                h.execCommand(i, e);
              }) : i && ("cut" != i && "copy" != i || (n ? n.writeText(h.getCopyText()) : document.execCommand("copy")), h.execCommand(i)), o.firstChild.style.display = "none", r = !1, "openCommandPallete" != i && h.focus();
            }

            var n = window.navigator && window.navigator.clipboard,
                r = !1;
            o = a.buildDom(["div", {
              class: "ace_mobile-menu",
              ontouchstart: function (e) {
                I = "menu", e.stopPropagation(), e.preventDefault(), h.textInput.focus();
              },
              ontouchend: function (e) {
                e.stopPropagation(), e.preventDefault(), t(e);
              },
              onclick: t
            }, ["span"], ["span", {
              class: "ace_mobile-button",
              action: "more"
            }, "..."]], h.container);
          }

          function i() {
            o || r();
            var e = h.selection.cursor,
                e = h.renderer.textToScreenCoordinates(e.row, e.column),
                t = h.renderer.textToScreenCoordinates(0, 0).pageX,
                i = h.renderer.scrollLeft,
                n = h.container.getBoundingClientRect();
            o.style.top = e.pageY - n.top - 3 + "px", e.pageX - n.left < n.width - 70 ? (o.style.left = "", o.style.right = "10px") : (o.style.right = "", o.style.left = t + i - n.left + "px"), o.style.display = "", o.firstChild.style.display = "none", h.on("input", s);
          }

          function s(e) {
            o && (o.style.display = "none"), h.off("input", s);
          }

          function w() {
            m = null, clearTimeout(m);
            var e = h.selection.getRange(),
                t = e.contains(f.row, f.column);
            !e.isEmpty() && t || (h.selection.moveToPosition(f), h.selection.selectWord()), I = "wait", i();
          }

          n.addListener(e, "contextmenu", function (e) {
            C && h.textInput.getElement().focus();
          }, h), n.addListener(e, "touchstart", function (e) {
            var t = e.touches;
            if (m || 1 < t.length) return clearTimeout(m), m = null, g = -1, void (I = "zoom");
            C = h.$mouseHandler.isMousePressed = !0;
            var i = h.renderer.layerConfig.lineHeight,
                n = h.renderer.layerConfig.lineHeight,
                r = e.timeStamp,
                o = (p = r, t[0]),
                s = o.clientX,
                o = o.clientY,
                s = (Math.abs(d - s) + Math.abs(u - o) > i && (g = -1), d = e.clientX = s, u = e.clientY = o, b = y = 0, new S(e, h));
            if (f = s.getDocumentPosition(), r - g < 500 && 1 == t.length && !v) A++, e.preventDefault(), e.button = 0, m = null, clearTimeout(m), h.selection.moveToPosition(f), (o = 2 <= A ? h.selection.getLineRange(f.row) : h.session.getBracketRange(f)) && !o.isEmpty() ? h.selection.setRange(o) : h.selection.selectWord(), I = "wait";else {
              A = 0;

              var s = h.selection.cursor,
                  t = h.selection.isEmpty() ? s : h.selection.anchor,
                  o = h.renderer.$cursorLayer.getPixelPosition(s, !0),
                  s = h.renderer.$cursorLayer.getPixelPosition(t, !0),
                  t = h.renderer.scroller.getBoundingClientRect(),
                  a = h.renderer.layerConfig.offset,
                  l = h.renderer.scrollLeft,
                  c = function (e, t) {
                return (e /= n) * e + (t = t / i - 0.75) * t;
              };

              if (e.clientX < t.left) return void (I = "zoom");
              o = c(e.clientX - t.left - o.left + l, e.clientY - t.top - o.top + a), c = c(e.clientX - t.left - s.left + l, e.clientY - t.top - s.top + a);
              o < 3.5 && c < 3.5 && (I = c < o ? "cursor" : "anchor"), I = c < 3.5 ? "anchor" : o < 3.5 ? "cursor" : "scroll", m = setTimeout(w, 450);
            }
            g = r;
          }, h), n.addListener(e, "touchend", function (e) {
            C = h.$mouseHandler.isMousePressed = !1, t && clearInterval(t), "zoom" == I ? (I = "", v = 0) : m ? (h.selection.moveToPosition(f), v = 0, i()) : "scroll" == I ? (v += 60, t = setInterval(function () {
              v-- <= 0 && (clearInterval(t), t = null), Math.abs(b) < 0.01 && (b = 0), Math.abs(y) < 0.01 && (y = 0), v < 20 && (b *= 0.9), v < 20 && (y *= 0.9);
              var e = h.session.getScrollTop();
              h.renderer.scrollBy(10 * b, 10 * y), e == h.session.getScrollTop() && (v = 0);
            }, 10), s()) : i(), clearTimeout(m), m = null;
          }, h), n.addListener(e, "touchmove", function (e) {
            m && (clearTimeout(m), m = null);
            var t = e.touches;

            if (!(1 < t.length || "zoom" == I)) {
              var t = t[0],
                  i = d - t.clientX,
                  n = u - t.clientY;

              if ("wait" == I) {
                if (!(4 < i * i + n * n)) return e.preventDefault();
                I = "cursor";
              }

              d = t.clientX, u = t.clientY, e.clientX = t.clientX, e.clientY = t.clientY;
              var t = e.timeStamp,
                  r = t - p;
              p = t, "scroll" == I ? ((t = new S(e, h)).speed = 1, t.wheelX = i, t.wheelY = n, 10 * Math.abs(i) < Math.abs(n) && (i = 0), 10 * Math.abs(n) < Math.abs(i) && (n = 0), 0 != r && (b = i / r, y = n / r), h._emit("mousewheel", t), t.propagationStopped || (b = y = 0)) : (i = new S(e, h).getDocumentPosition(), "cursor" == I ? h.selection.moveCursorToPosition(i) : "anchor" == I && h.selection.setSelectionAnchor(i.row, i.column), h.renderer.scrollCursorIntoView(i), e.preventDefault());
            }
          }, h);
        };
      }), ace.define("ace/lib/net", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        var r = e("./dom");
        t.get = function (e, t) {
          var i = new XMLHttpRequest();
          i.open("GET", e, !0), i.onreadystatechange = function () {
            4 === i.readyState && t(i.responseText);
          }, i.send(null);
        }, t.loadScript = function (e, i) {
          var t = r.getDocumentHead(),
              n = document.createElement("script");
          n.src = e, t.appendChild(n), n.onload = n.onreadystatechange = function (e, t) {
            !t && n.readyState && "loaded" != n.readyState && "complete" != n.readyState || (n = n.onload = n.onreadystatechange = null, t || i());
          };
        }, t.qualifyURL = function (e) {
          var t = document.createElement("a");
          return t.href = e, t.href;
        };
      }), ace.define("ace/lib/event_emitter", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        function o() {
          (this || _global).propagationStopped = !0;
        }

        function s() {
          (this || _global).defaultPrevented = !0;
        }

        var n = {};
        n._emit = n._dispatchEvent = function (e, t) {
          (this || _global)._eventRegistry || ((this || _global)._eventRegistry = {}), (this || _global)._defaultHandlers || ((this || _global)._defaultHandlers = {});
          var i = (this || _global)._eventRegistry[e] || [],
              n = (this || _global)._defaultHandlers[e];

          if (i.length || n) {
            (t = "object" == typeof t && t ? t : {}).type || (t.type = e), t.stopPropagation || (t.stopPropagation = o), t.preventDefault || (t.preventDefault = s);

            for (var i = i.slice(), r = 0; r < i.length && (i[r](t, this || _global), !t.propagationStopped); r++);

            return n && !t.defaultPrevented ? n(t, this || _global) : void 0;
          }
        }, n._signal = function (e, t) {
          if (i = ((this || _global)._eventRegistry || {})[e]) for (var i = i.slice(), n = 0; n < i.length; n++) i[n](t, this || _global);
        }, n.once = function (t, i) {
          var n = this || _global;
          if (this.on(t, function e() {
            n.off(t, e), i.apply(null, arguments);
          }), !i) return new Promise(function (e) {
            i = e;
          });
        }, n.setDefaultHandler = function (e, t) {
          var i,
              n,
              r = (this || _global)._defaultHandlers;
          (r = r || ((this || _global)._defaultHandlers = {
            _disabled_: {}
          }))[e] && (n = r[e], (i = r._disabled_[e]) || (r._disabled_[e] = i = []), i.push(n), -1 != (n = i.indexOf(t)) && i.splice(n, 1)), r[e] = t;
        }, n.removeDefaultHandler = function (e, t) {
          var i,
              n = (this || _global)._defaultHandlers;
          n && (i = n._disabled_[e], n[e] == t ? i && this.setDefaultHandler(e, i.pop()) : i && -1 != (n = i.indexOf(t)) && i.splice(n, 1));
        }, n.on = n.addEventListener = function (e, t, i) {
          (this || _global)._eventRegistry = (this || _global)._eventRegistry || {};
          var n = (this || _global)._eventRegistry[e];
          return -1 == (n = n || ((this || _global)._eventRegistry[e] = [])).indexOf(t) && n[i ? "unshift" : "push"](t), t;
        }, n.off = n.removeListener = n.removeEventListener = function (e, t) {
          (this || _global)._eventRegistry = (this || _global)._eventRegistry || {};
          e = (this || _global)._eventRegistry[e];
          !e || -1 !== (t = e.indexOf(t)) && e.splice(t, 1);
        }, n.removeAllListeners = function (e) {
          e || ((this || _global)._eventRegistry = (this || _global)._defaultHandlers = void 0), (this || _global)._eventRegistry && ((this || _global)._eventRegistry[e] = void 0), (this || _global)._defaultHandlers && ((this || _global)._defaultHandlers[e] = void 0);
        }, t.EventEmitter = n;
      }), ace.define("ace/lib/app_config", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, i) {
        var r = e("./oop"),
            n = e("./event_emitter").EventEmitter,
            o = {
          setOptions: function (t) {
            Object.keys(t).forEach(function (e) {
              this.setOption(e, t[e]);
            }, this || _global);
          },
          getOptions: function (e) {
            var t,
                i = {};
            return e ? Array.isArray(e) || (i = e, e = Object.keys(i)) : (t = (this || _global).$options, e = Object.keys(t).filter(function (e) {
              return !t[e].hidden;
            })), e.forEach(function (e) {
              i[e] = this.getOption(e);
            }, this || _global), i;
          },
          setOption: function (e, t) {
            var i;
            if ((this || _global)["$" + e] !== t) return i = (this || _global).$options[e], i ? i.forwardTo ? (this || _global)[i.forwardTo] && (this || _global)[i.forwardTo].setOption(e, t) : (i.handlesSet || ((this || _global)["$" + e] = t), void (i && i.set && i.set.call(this || _global, t))) : s("misspelled option \"" + e + "\"");
          },
          getOption: function (e) {
            var t = (this || _global).$options[e];
            return t ? t.forwardTo ? (this || _global)[t.forwardTo] && (this || _global)[t.forwardTo].getOption(e) : t && t.get ? t.get.call(this || _global) : (this || _global)["$" + e] : s("misspelled option \"" + e + "\"");
          }
        };

        function s(e) {
          "undefined" != typeof console && console.warn && console.warn.apply(console, arguments);
        }

        function a(e, t) {
          var i = new Error(e);
          i.data = t, "object" == typeof console && console.error && console.error(i), setTimeout(function () {
            throw i;
          });
        }

        function l() {
          (this || _global).$defaultOptions = {};
        }

        !function () {
          r.implement(this || _global, n), (this || _global).defineOptions = function (i, e, n) {
            return i.$options || ((this || _global).$defaultOptions[e] = i.$options = {}), Object.keys(n).forEach(function (e) {
              var t = n[e];
              (t = "string" == typeof t ? {
                forwardTo: t
              } : t).name || (t.name = e), "initialValue" in (i.$options[t.name] = t) && (i["$" + t.name] = t.initialValue);
            }), r.implement(i, o), this || _global;
          }, (this || _global).resetOptions = function (i) {
            Object.keys(i.$options).forEach(function (e) {
              var t = i.$options[e];
              "value" in t && i.setOption(e, t.value);
            });
          }, (this || _global).setDefaultValue = function (e, t, i) {
            if (!e) {
              for (e in (this || _global).$defaultOptions) if ((this || _global).$defaultOptions[e][t]) break;

              if (!(this || _global).$defaultOptions[e][t]) return !1;
            }

            var n = (this || _global).$defaultOptions[e] || ((this || _global).$defaultOptions[e] = {});
            n[t] && (n.forwardTo ? this.setDefaultValue(n.forwardTo, t, i) : n[t].value = i);
          }, (this || _global).setDefaultValues = function (t, i) {
            Object.keys(i).forEach(function (e) {
              this.setDefaultValue(t, e, i[e]);
            }, this || _global);
          }, (this || _global).warn = s, (this || _global).reportError = a;
        }.call(l.prototype), t.AppConfig = l;
      }), ace.define("ace/config", ["require", "exports", "module", "ace/lib/lang", "ace/lib/oop", "ace/lib/net", "ace/lib/dom", "ace/lib/app_config"], function (u, g, p) {
        var e = u("./lib/lang"),
            o = (u("./lib/oop"), u("./lib/net")),
            i = u("./lib/dom"),
            t = u("./lib/app_config").AppConfig,
            m = (p.exports = g = new t(), function () {
          return this || _global || "undefined" != typeof window && window;
        }()),
            f = {
          packaged: !1,
          workerPath: null,
          modePath: null,
          themePath: null,
          basePath: "",
          suffix: ".js",
          $moduleUrls: {},
          loadWorkerFromBlob: !0,
          sharedPopups: !1,
          useStrictCSP: null
        },
            s = (g.get = function (e) {
          if (f.hasOwnProperty(e)) return f[e];
          throw new Error("Unknown config key: " + e);
        }, g.set = function (e, t) {
          if (f.hasOwnProperty(e)) f[e] = t;else if (0 == this.setDefaultValue("", e, t)) throw new Error("Unknown config key: " + e);
          "useStrictCSP" == e && i.useStrictCSP(t);
        }, g.all = function () {
          return e.copyObject(f);
        }, g.$modes = {}, g.moduleUrl = function (e, t) {
          if (f.$moduleUrls[e]) return f.$moduleUrls[e];
          var e = e.split("/"),
              i = "snippets" == (t = t || e[e.length - 2] || "") ? "/" : "-",
              n = e[e.length - 1],
              r = ("worker" == t && "-" == i && (r = new RegExp("^" + t + "[\\-_]|[\\-_]" + t + "$", "g"), n = n.replace(r, "")), (!n || n == t) && 1 < e.length && (n = e[e.length - 2]), f[t + "Path"]);
          return null == r ? r = f.basePath : "/" == i && (t = i = ""), r && "/" != r.slice(-1) && (r += "/"), r + t + i + n + this.get("suffix");
        }, g.setModuleUrl = function (e, t) {
          return f.$moduleUrls[e] = t;
        }, g.$loading = {}, g.loadModule = function (i, e) {
          var t, n;
          Array.isArray(i) && (n = i[0], i = i[1]);

          try {
            t = u(i);
          } catch (e) {}

          if (t && !g.$loading[i]) return e && e(t);

          if (g.$loading[i] || (g.$loading[i] = []), g.$loading[i].push(e), !(1 < g.$loading[i].length)) {
            function r() {
              u([i], function (t) {
                g._emit("load.module", {
                  name: i,
                  module: t
                });

                var e = g.$loading[i];
                g.$loading[i] = null, e.forEach(function (e) {
                  e && e(t);
                });
              });
            }

            if (!g.get("packaged")) return r();
            o.loadScript(g.moduleUrl(i, n), r), s();
          }
        }, function () {
          f.basePath || f.workerPath || f.modePath || f.themePath || Object.keys(f.$moduleUrls).length || (console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver"), s = function () {});
        });

        function n(e) {
          if (m && m.document) {
            f.packaged = e || u.packaged || p.packaged || m.define && C.amdD.packaged;

            for (var t, i = {}, n = "", e = document.currentScript || document._currentScript, r = (e && e.ownerDocument || document).getElementsByTagName("script"), o = 0; o < r.length; o++) {
              var s = r[o],
                  a = s.src || s.getAttribute("src");

              if (a) {
                for (var l = s.attributes, c = 0, h = l.length; c < h; c++) {
                  var d = l[c];
                  0 === d.name.indexOf("data-ace-") && (i[d.name.replace(/^data-ace-/, "").replace(/-(.)/g, function (e, t) {
                    return t.toUpperCase();
                  })] = d.value);
                }

                s = a.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);
                s && (n = s[1]);
              }
            }

            for (t in n && (i.base = i.base || n, i.packaged = !0), i.basePath = i.base, i.workerPath = i.workerPath || i.base, i.modePath = i.modePath || i.base, i.themePath = i.themePath || i.base, delete i.base, i) void 0 !== i[t] && g.set(t, i[t]);
          }
        }

        n(!0), g.init = n, g.version = "1.4.14";
      }), ace.define("ace/mouse/mouse_handler", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent", "ace/mouse/default_handlers", "ace/mouse/default_gutter_handler", "ace/mouse/mouse_event", "ace/mouse/dragdrop_handler", "ace/mouse/touch_handler", "ace/config"], function (e, t, i) {
        "use strict";

        function n(n) {
          function e(e) {
            document.hasFocus && document.hasFocus() && (n.isFocused() || document.activeElement != (n.textInput && n.textInput.getElement())) || window.focus(), n.focus();
          }

          var r = this || _global,
              t = ((this || _global).editor = n, new o(this || _global), new s(this || _global), new a(this || _global), n.renderer.getMouseEventTarget()),
              i = (h.addListener(t, "click", (this || _global).onMouseEvent.bind(this || _global, "click"), n), h.addListener(t, "mousemove", (this || _global).onMouseMove.bind(this || _global, "mousemove"), n), h.addMultiMouseDownListener([t, n.renderer.scrollBarV && n.renderer.scrollBarV.inner, n.renderer.scrollBarH && n.renderer.scrollBarH.inner, n.textInput && n.textInput.getElement()].filter(Boolean), [400, 300, 250], this || _global, "onMouseEvent", n), h.addMouseWheelListener(n.container, (this || _global).onMouseWheel.bind(this || _global, "mousewheel"), n), l(n.container, n), n.renderer.$gutter);
          h.addListener(i, "mousedown", (this || _global).onMouseEvent.bind(this || _global, "guttermousedown"), n), h.addListener(i, "click", (this || _global).onMouseEvent.bind(this || _global, "gutterclick"), n), h.addListener(i, "dblclick", (this || _global).onMouseEvent.bind(this || _global, "gutterdblclick"), n), h.addListener(i, "mousemove", (this || _global).onMouseEvent.bind(this || _global, "guttermousemove"), n), h.addListener(t, "mousedown", e, n), h.addListener(i, "mousedown", e, n), d.isIE && n.renderer.scrollBarV && (h.addListener(n.renderer.scrollBarV.element, "mousedown", e, n), h.addListener(n.renderer.scrollBarH.element, "mousedown", e, n)), n.on("mousemove", function (e) {
            var t, i;
            r.state || r.$dragDelay || !r.$dragEnabled || (e = n.renderer.screenToTextCoordinates(e.x, e.y), t = n.session.selection.getRange(), i = n.renderer, !t.isEmpty() && t.insideStart(e.row, e.column) ? i.setCursorStyle("default") : i.setCursorStyle(""));
          }, n);
        }

        var h = e("../lib/event"),
            d = e("../lib/useragent"),
            o = e("./default_handlers").DefaultHandlers,
            s = e("./default_gutter_handler").GutterHandler,
            u = e("./mouse_event").MouseEvent,
            a = e("./dragdrop_handler").DragdropHandler,
            l = e("./touch_handler").addTouchListeners,
            e = e("../config");
        !function () {
          (this || _global).onMouseEvent = function (e, t) {
            (this || _global).editor.session && (this || _global).editor._emit(e, new u(t, (this || _global).editor));
          }, (this || _global).onMouseMove = function (e, t) {
            var i = (this || _global).editor._eventRegistry && (this || _global).editor._eventRegistry.mousemove;
            i && i.length && (this || _global).editor._emit(e, new u(t, (this || _global).editor));
          }, (this || _global).onMouseWheel = function (e, t) {
            var i = new u(t, (this || _global).editor);
            i.speed = 2 * (this || _global).$scrollSpeed, i.wheelX = t.wheelX, i.wheelY = t.wheelY, (this || _global).editor._emit(e, i);
          }, (this || _global).setState = function (e) {
            (this || _global).state = e;
          }, (this || _global).captureMouse = function (e, t) {
            (this || _global).x = e.x, (this || _global).y = e.y, (this || _global).isMousePressed = !0;

            function i(e) {
              if (e) {
                if (d.isWebKit && !e.which && a.releaseMouse) return a.releaseMouse();
                a.x = e.clientX, a.y = e.clientY, t && t(e), a.mouseEvent = new u(e, a.editor), a.$mouseMoved = !0;
              }
            }

            function n(e) {
              o.off("beforeEndOperation", l), clearInterval(c), o.session && r(), a[a.state + "End"] && a[a.state + "End"](e), a.state = "", a.isMousePressed = s.$isMousePressed = !1, s.$keepTextAreaAtCursor && s.$moveTextAreaToCursor(), a.$onCaptureMouseMove = a.releaseMouse = null, e && a.onMouseEvent("mouseup", e), o.endOperation();
            }

            function r() {
              a[a.state] && a[a.state](), a.$mouseMoved = !1;
            }

            var o = (this || _global).editor,
                s = (this || _global).editor.renderer,
                a = (s.$isMousePressed = !0, this || _global);
            if (d.isOldIE && "dblclick" == e.domEvent.type) return setTimeout(function () {
              n(e);
            });

            var l = function (e) {
              a.releaseMouse && o.curOp.command.name && o.curOp.selectionChanged && (a[a.state + "End"] && a[a.state + "End"](), a.state = "", a.releaseMouse());
            },
                c = (o.on("beforeEndOperation", l), o.startOperation({
              command: {
                name: "mouse"
              }
            }), a.$onCaptureMouseMove = i, a.releaseMouse = h.capture((this || _global).editor.container, i, n), setInterval(r, 20));
          }, (this || _global).releaseMouse = null, (this || _global).cancelContextMenu = function () {
            var t = function (e) {
              e && e.domEvent && "contextmenu" != e.domEvent.type || ((this || _global).editor.off("nativecontextmenu", t), e && e.domEvent && h.stopEvent(e.domEvent));
            }.bind(this || _global);

            setTimeout(t, 10), (this || _global).editor.on("nativecontextmenu", t);
          }, (this || _global).destroy = function () {
            (this || _global).releaseMouse && this.releaseMouse();
          };
        }.call(n.prototype), e.defineOptions(n.prototype, "mouseHandler", {
          scrollSpeed: {
            initialValue: 2
          },
          dragDelay: {
            initialValue: d.isMac ? 150 : 0
          },
          dragEnabled: {
            initialValue: !0
          },
          focusTimeout: {
            initialValue: 0
          },
          tooltipFollowsMouse: {
            initialValue: !0
          }
        }), t.MouseHandler = n;
      }), ace.define("ace/mouse/fold_handler", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        var n = e("../lib/dom");

        t.FoldHandler = function (r) {
          r.on("click", function (e) {
            var t = e.getDocumentPosition(),
                i = r.session,
                t = i.getFoldAt(t.row, t.column, 1),
                t = (t && (e.getAccelKey() ? i.removeFold(t) : i.expandFold(t), e.stop()), e.domEvent && e.domEvent.target);
            t && n.hasCssClass(t, "ace_inline_button") && n.hasCssClass(t, "ace_toggle_wrap") && (i.setOption("wrap", !i.getUseWrapMode()), r.renderer.scrollCursorIntoView());
          }), r.on("gutterclick", function (e) {
            var t, i;
            "foldWidgets" == r.renderer.$gutterLayer.getRegion(e) && (t = e.getDocumentPosition().row, (i = r.session).foldWidgets && i.foldWidgets[t] && r.session.onFoldWidgetClick(t, e), r.isFocused() || r.focus(), e.stop());
          }), r.on("gutterdblclick", function (e) {
            var t, i, n;
            "foldWidgets" == r.renderer.$gutterLayer.getRegion(e) && (n = e.getDocumentPosition().row, (i = (i = (t = r.session).getParentFoldRangeData(n, !0)).range || i.firstRange) && (n = i.start.row, (n = t.getFoldAt(n, t.getLine(n).length, 1)) ? t.removeFold(n) : (t.addFold("...", i), r.renderer.scrollCursorIntoView({
              row: i.start.row,
              column: 0
            }))), e.stop());
          });
        };
      }), ace.define("ace/keyboard/keybinding", ["require", "exports", "module", "ace/lib/keys", "ace/lib/event"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).$editor = e, (this || _global).$data = {
            editor: e
          }, (this || _global).$handlers = [], this.setDefaultHandler(e.commands);
        }

        var r = e("../lib/keys"),
            l = e("../lib/event");
        !function () {
          (this || _global).setDefaultHandler = function (e) {
            this.removeKeyboardHandler((this || _global).$defaultHandler), (this || _global).$defaultHandler = e, this.addKeyboardHandler(e, 0);
          }, (this || _global).setKeyboardHandler = function (e) {
            var t = (this || _global).$handlers;

            if (t[t.length - 1] != e) {
              for (; t[t.length - 1] && t[t.length - 1] != (this || _global).$defaultHandler;) this.removeKeyboardHandler(t[t.length - 1]);

              this.addKeyboardHandler(e, 1);
            }
          }, (this || _global).addKeyboardHandler = function (e, t) {
            var i;
            e && ("function" != typeof e || e.handleKeyboard || (e.handleKeyboard = e), -1 != (i = (this || _global).$handlers.indexOf(e)) && (this || _global).$handlers.splice(i, 1), null == t ? (this || _global).$handlers.push(e) : (this || _global).$handlers.splice(t, 0, e), -1 == i && e.attach && e.attach((this || _global).$editor));
          }, (this || _global).removeKeyboardHandler = function (e) {
            var t = (this || _global).$handlers.indexOf(e);

            return -1 != t && ((this || _global).$handlers.splice(t, 1), e.detach && e.detach((this || _global).$editor), !0);
          }, (this || _global).getKeyboardHandler = function () {
            return (this || _global).$handlers[(this || _global).$handlers.length - 1];
          }, (this || _global).getStatusText = function () {
            var t = (this || _global).$data,
                i = t.editor;
            return (this || _global).$handlers.map(function (e) {
              return e.getStatusText && e.getStatusText(i, t) || "";
            }).filter(Boolean).join(" ");
          }, (this || _global).$callKeyboardHandlers = function (e, t, i, n) {
            for (var r, o = !1, s = (this || _global).$editor.commands, a = (this || _global).$handlers.length; a-- && !((r = (this || _global).$handlers[a].handleKeyboard((this || _global).$data, e, t, i, n)) && r.command && ((o = "null" == r.command || s.exec(r.command, (this || _global).$editor, r.args, n)) && n && -1 != e && 1 != r.passEvent && 1 != r.command.passEvent && l.stopEvent(n), o)););

            return o || -1 != e || (r = {
              command: "insertstring"
            }, o = s.exec("insertstring", (this || _global).$editor, t)), o && (this || _global).$editor._signal && (this || _global).$editor._signal("keyboardActivity", r), o;
          }, (this || _global).onCommandKey = function (e, t, i) {
            var n = r.keyCodeToString(i);
            return this.$callKeyboardHandlers(t, n, i, e);
          }, (this || _global).onTextInput = function (e) {
            return this.$callKeyboardHandlers(-1, e);
          };
        }.call(n.prototype), t.KeyBinding = n;
      }), ace.define("ace/lib/bidiutil", ["require", "exports", "module"], function (e, l, t) {
        "use strict";

        var p = 0,
            m = 0,
            f = !1,
            C = !1,
            I = !1,
            v = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]],
            A = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]],
            b = 0,
            y = 1,
            w = 2,
            S = 3,
            x = 4,
            k = 5,
            E = 6,
            R = 7,
            T = 8,
            _ = 9,
            $ = 10,
            L = 11,
            B = 12,
            W = 13,
            N = 14,
            G = 15,
            P = 16,
            F = 17,
            H = 18,
            n = [H, H, H, H, H, H, H, H, H, E, k, E, T, k, H, H, H, H, H, H, H, H, H, H, H, H, H, H, k, k, k, E, T, x, x, L, L, L, x, x, x, x, x, $, _, $, _, _, w, w, w, w, w, w, w, w, w, w, _, x, x, x, x, x, x, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, x, x, x, x, x, x, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, b, x, x, x, x, H, H, H, H, H, H, k, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, H, _, x, L, L, L, L, x, x, x, x, b, x, x, H, x, x, L, L, w, w, x, b, x, x, x, w, b, x, x, x, x, x],
            r = [T, T, T, T, T, T, T, T, T, T, T, H, H, H, b, y, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, T, k, W, N, G, P, F, _, L, L, L, L, L, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, _, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, T];

        function c(e, t, i, n) {
          var r,
              o,
              s,
              a = p ? A : v,
              l = 0,
              c = -1,
              h = null,
              d = null,
              u = [];
          if (!n) for (h = 0, n = []; h < i; h++) n[h] = V(e[h]);

          for (m = p, I = C = f = !1, d = 0; d < i; d++) {
            if (s = l, u[d] = r = function (e, t, i, n) {
              var r,
                  o,
                  s,
                  a = t[n];

              switch (a) {
                case b:
                case y:
                  f = !1;

                case x:
                case S:
                  return a;

                case w:
                  return f ? S : w;

                case R:
                  return f = !0, y;

                case T:
                  return x;

                case _:
                  return n < 1 || n + 1 >= t.length || (r = i[n - 1]) != w && r != S || (l = t[n + 1]) != w && l != S ? x : (l = f ? S : l) == r ? l : x;

                case $:
                  return (r = 0 < n ? i[n - 1] : k) == w && n + 1 < t.length && t[n + 1] == w ? w : x;

                case L:
                  if (0 < n && i[n - 1] == w) return w;
                  if (f) return x;

                  for (s = n + 1, o = t.length; s < o && t[s] == L;) s++;

                  return s < o && t[s] == w ? w : x;

                case B:
                  for (o = t.length, s = n + 1; s < o && t[s] == B;) s++;

                  if (s < o) {
                    var l = e[n],
                        l = 1425 <= l && l <= 2303 || 64286 == l;
                    if (r = t[s], l && (r == y || r == R)) return y;
                  }

                  return n < 1 || (r = t[n - 1]) == k ? x : i[n - 1];

                case k:
                  return C = !(f = !1), p;

                case E:
                  return I = !0, x;

                case W:
                case N:
                case P:
                case F:
                case G:
                  f = !1;

                case H:
                  return x;
              }
            }(e, n, u, d), s = 240 & (l = a[s][r]), l &= 15, t[d] = o = a[l][5], 0 < s) if (16 == s) {
              for (h = c; h < d; h++) t[h] = 1;

              c = -1;
            } else c = -1;
            if (a[l][6]) -1 == c && (c = d);else if (-1 < c) {
              for (h = c; h < d; h++) t[h] = o;

              c = -1;
            }
            n[d] == k && (t[d] = 0), m |= o;
          }

          if (I) for (h = 0; h < i; h++) if (n[h] == E) {
            t[h] = p;

            for (var g = h - 1; 0 <= g && n[g] == T; g--) t[g] = p;
          }
        }

        function h(e, t, i) {
          if (!(m < e)) if (1 != e || 1 != p || C) for (var n, r, o, s, a = i.length, l = 0; l < a;) {
            if (t[l] >= e) {
              for (n = l + 1; n < a && t[n] >= e;) n++;

              for (r = l, o = n - 1; r < o; r++, o--) s = i[r], i[r] = i[o], i[o] = s;

              l = n;
            }

            l++;
          } else i.reverse();
        }

        function V(e) {
          var t = e.charCodeAt(0),
              i = t >> 8;
          return 0 == i ? 191 < t ? b : n[t] : 5 == i ? /[\u0591-\u05f4]/.test(e) ? y : b : 6 == i ? /[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e) ? B : /[\u0660-\u0669\u066b-\u066c]/.test(e) ? S : 1642 == t ? L : /[\u06f0-\u06f9]/.test(e) ? w : R : 32 == i && t <= 8287 ? r[255 & t] : 254 == i && 65136 <= t ? R : x;
        }

        l.L = b, l.R = y, l.EN = w, l.ON_R = 3, l.AN = 4, l.R_H = 5, l.B = 6, l.RLE = 7, l.DOT = "\xB7", l.doBidiReorder = function (e, t, i) {
          if (e.length < 2) return {};
          var n = e.split(""),
              r = new Array(n.length),
              o = new Array(n.length),
              s = [];
          p = i ? 1 : 0, c(n, s, n.length, t);

          for (var a = 0; a < r.length; r[a] = a, a++);

          h(2, s, r), h(1, s, r);

          for (a = 0; a < r.length - 1; a++) t[a] === S ? s[a] = l.AN : s[a] === y && (t[a] > R && t[a] < W || t[a] === x || t[a] === H) ? s[a] = l.ON_R : 0 < a && "\u0644" === n[a - 1] && /\u0622|\u0623|\u0625|\u0627/.test(n[a]) && (s[a - 1] = s[a] = l.R_H, a++);

          n[n.length - 1] === l.DOT && (s[n.length - 1] = l.B), "\u202B" === n[0] && (s[0] = l.RLE);

          for (a = 0; a < r.length; a++) o[a] = s[r[a]];

          return {
            logicalFromVisual: r,
            bidiLevels: o
          };
        }, l.hasBidiCharacters = function (e, t) {
          for (var i = !1, n = 0; n < e.length; n++) t[n] = V(e.charAt(n)), i || t[n] != y && t[n] != R && t[n] != S || (i = !0);

          return i;
        }, l.getVisualFromLogicalIdx = function (e, t) {
          for (var i = 0; i < t.logicalFromVisual.length; i++) if (t.logicalFromVisual[i] == e) return i;

          return 0;
        };
      }), ace.define("ace/bidihandler", ["require", "exports", "module", "ace/lib/bidiutil", "ace/lib/lang"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).session = e, (this || _global).bidiMap = {}, (this || _global).currentRow = null, (this || _global).bidiUtil = a, (this || _global).charWidths = [], (this || _global).EOL = "\xAC", (this || _global).showInvisibles = !0, (this || _global).isRtlDir = !1, (this || _global).$isRtl = !1, (this || _global).line = "", (this || _global).wrapIndent = 0, (this || _global).EOF = "\xB6", (this || _global).RLE = "\u202B", (this || _global).contentWidth = 0, (this || _global).fontMetrics = null, (this || _global).rtlLineOffset = 0, (this || _global).wrapOffset = 0, (this || _global).isMoveLeftOperation = !1, (this || _global).seenBidi = r.test(e.getValue());
        }

        var a = e("./lib/bidiutil"),
            s = e("./lib/lang"),
            r = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
        !function () {
          (this || _global).isBidiRow = function (e, t, i) {
            return !!(this || _global).seenBidi && (e !== (this || _global).currentRow && ((this || _global).currentRow = e, this.updateRowLine(t, i), this.updateBidiMap()), (this || _global).bidiMap.bidiLevels);
          }, (this || _global).onChange = function (e) {
            (this || _global).seenBidi ? (this || _global).currentRow = null : "insert" == e.action && r.test(e.lines.join("\n")) && ((this || _global).seenBidi = !0, (this || _global).currentRow = null);
          }, (this || _global).getDocumentRow = function () {
            var e = 0,
                t = (this || _global).session.$screenRowCache;
            return e = t.length && 0 <= (t = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow)) ? (this || _global).session.$docRowCache[t] : e;
          }, (this || _global).getSplitIndex = function () {
            var e = 0,
                t = (this || _global).session.$screenRowCache;
            if (t.length) for (var i, n = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow); 0 < (this || _global).currentRow - e && (i = (this || _global).session.$getRowCacheIndex(t, (this || _global).currentRow - e - 1)) === n;) n = i, e++;else e = (this || _global).currentRow;
            return e;
          }, (this || _global).updateRowLine = function (e, t) {
            var i,
                n = (e = void 0 === e ? this.getDocumentRow() : e) === (this || _global).session.getLength() - 1 ? (this || _global).EOF : (this || _global).EOL,
                r = ((this || _global).wrapIndent = 0, (this || _global).line = (this || _global).session.getLine(e), (this || _global).isRtlDir = (this || _global).$isRtl || (this || _global).line.charAt(0) === (this || _global).RLE, (this || _global).session.$useWrapMode ? ((e = (this || _global).session.$wrapData[e]) && (0 < (t = void 0 === t ? this.getSplitIndex() : t) && e.length ? ((this || _global).wrapIndent = e.indent, (this || _global).wrapOffset = (this || _global).wrapIndent * (this || _global).charWidths[a.L], (this || _global).line = t < e.length ? (this || _global).line.substring(e[t - 1], e[t]) : (this || _global).line.substring(e[e.length - 1])) : (this || _global).line = (this || _global).line.substring(0, e[t])), t == e.length && ((this || _global).line += (this || _global).showInvisibles ? n : a.DOT)) : (this || _global).line += (this || _global).showInvisibles ? n : a.DOT, (this || _global).session),
                o = 0;
            (this || _global).line = (this || _global).line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function (e, t) {
              return "\t" === e || r.isFullWidth(e.charCodeAt(0)) ? (i = "\t" === e ? r.getScreenTabSize(t + o) : 2, o += i - 1, s.stringRepeat(a.DOT, i)) : e;
            }), (this || _global).isRtlDir && ((this || _global).fontMetrics.$main.textContent = (this || _global).line.charAt((this || _global).line.length - 1) == a.DOT ? (this || _global).line.substr(0, (this || _global).line.length - 1) : (this || _global).line, (this || _global).rtlLineOffset = (this || _global).contentWidth - (this || _global).fontMetrics.$main.getBoundingClientRect().width);
          }, (this || _global).updateBidiMap = function () {
            var e = [];
            a.hasBidiCharacters((this || _global).line, e) || (this || _global).isRtlDir ? (this || _global).bidiMap = a.doBidiReorder((this || _global).line, e, (this || _global).isRtlDir) : (this || _global).bidiMap = {};
          }, (this || _global).markAsDirty = function () {
            (this || _global).currentRow = null;
          }, (this || _global).updateCharacterWidths = function (e) {
            var t;
            (this || _global).characterWidth !== e.$characterSize.width && ((this || _global).fontMetrics = e, t = (this || _global).characterWidth = e.$characterSize.width, e = e.$measureCharWidth("\u05D4"), (this || _global).charWidths[a.L] = (this || _global).charWidths[a.EN] = (this || _global).charWidths[a.ON_R] = t, (this || _global).charWidths[a.R] = (this || _global).charWidths[a.AN] = e, (this || _global).charWidths[a.R_H] = 0.45 * e, (this || _global).charWidths[a.B] = (this || _global).charWidths[a.RLE] = 0, (this || _global).currentRow = null);
          }, (this || _global).setShowInvisibles = function (e) {
            (this || _global).showInvisibles = e, (this || _global).currentRow = null;
          }, (this || _global).setEolChar = function (e) {
            (this || _global).EOL = e;
          }, (this || _global).setContentWidth = function (e) {
            (this || _global).contentWidth = e;
          }, (this || _global).isRtlLine = function (e) {
            return !!(this || _global).$isRtl || (null != e ? (this || _global).session.getLine(e).charAt(0) == (this || _global).RLE : (this || _global).isRtlDir);
          }, (this || _global).setRtlDirection = function (e, t) {
            for (var i = e.getCursorPosition(), n = e.selection.getSelectionAnchor().row; n <= i.row; n++) t || e.session.getLine(n).charAt(0) !== e.session.$bidiHandler.RLE ? t && e.session.getLine(n).charAt(0) !== e.session.$bidiHandler.RLE && e.session.doc.insert({
              column: 0,
              row: n
            }, e.session.$bidiHandler.RLE) : e.session.doc.removeInLine(n, 0, 1);
          }, (this || _global).getPosLeft = function (e) {
            e -= (this || _global).wrapIndent;
            var t = (this || _global).line.charAt(0) === (this || _global).RLE ? 1 : 0,
                i = t < e ? (this || _global).session.getOverwrite() ? e : e - 1 : t,
                n = a.getVisualFromLogicalIdx(i, (this || _global).bidiMap),
                r = (this || _global).bidiMap.bidiLevels,
                o = 0;
            !(this || _global).session.getOverwrite() && e <= t && r[n] % 2 != 0 && n++;

            for (var s = 0; s < n; s++) o += (this || _global).charWidths[r[s]];

            return !(this || _global).session.getOverwrite() && t < e && r[n] % 2 == 0 && (o += (this || _global).charWidths[r[n]]), (this || _global).wrapIndent && (o += (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset), (this || _global).isRtlDir && (o += (this || _global).rtlLineOffset), o;
          }, (this || _global).getSelections = function (e, t) {
            var i,
                n = (this || _global).bidiMap,
                r = n.bidiLevels,
                o = [],
                s = 0,
                a = Math.min(e, t) - (this || _global).wrapIndent,
                l = Math.max(e, t) - (this || _global).wrapIndent,
                c = !1,
                h = !1,
                d = 0;

            (this || _global).wrapIndent && (s += (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset);

            for (var u, g = 0; g < r.length; g++) u = n.logicalFromVisual[g], i = r[g], (c = a <= u && u < l) && !h ? d = s : !c && h && o.push({
              left: d,
              width: s - d
            }), s += (this || _global).charWidths[i], h = c;

            if (c && g === r.length && o.push({
              left: d,
              width: s - d
            }), (this || _global).isRtlDir) for (var p = 0; p < o.length; p++) o[p].left += (this || _global).rtlLineOffset;
            return o;
          }, (this || _global).offsetToCol = function (e) {
            (this || _global).isRtlDir && (e -= (this || _global).rtlLineOffset);
            var t = 0,
                e = Math.max(e, 0),
                i = 0,
                n = 0,
                r = (this || _global).bidiMap.bidiLevels,
                o = (this || _global).charWidths[r[n]];

            for ((this || _global).wrapIndent && (e -= (this || _global).isRtlDir ? -1 * (this || _global).wrapOffset : (this || _global).wrapOffset); i + o / 2 < e;) {
              if (i += o, n === r.length - 1) {
                o = 0;
                break;
              }

              o = (this || _global).charWidths[r[++n]];
            }

            return 0 === (t = 0 < n && r[n - 1] % 2 != 0 && r[n] % 2 == 0 ? (e < i && n--, (this || _global).bidiMap.logicalFromVisual[n]) : 0 < n && r[n - 1] % 2 == 0 && r[n] % 2 != 0 ? 1 + (i < e ? (this || _global).bidiMap.logicalFromVisual[n] : (this || _global).bidiMap.logicalFromVisual[n - 1]) : (this || _global).isRtlDir && n === r.length - 1 && 0 === o && r[n - 1] % 2 == 0 || !(this || _global).isRtlDir && 0 === n && r[n] % 2 != 0 ? 1 + (this || _global).bidiMap.logicalFromVisual[n] : (0 < n && r[n - 1] % 2 != 0 && 0 !== o && n--, (this || _global).bidiMap.logicalFromVisual[n])) && (this || _global).isRtlDir && t++, t + (this || _global).wrapIndent;
          };
        }.call(n.prototype), t.BidiHandler = n;
      }), ace.define("ace/selection", ["require", "exports", "module", "ace/lib/oop", "ace/lib/lang", "ace/lib/event_emitter", "ace/range"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).session = e, (this || _global).doc = e.getDocument(), this.clearSelection(), (this || _global).cursor = (this || _global).lead = (this || _global).doc.createAnchor(0, 0), (this || _global).anchor = (this || _global).doc.createAnchor(0, 0), (this || _global).$silent = !1;
          var t = this || _global;
          (this || _global).cursor.on("change", function (e) {
            t.$cursorChanged = !0, t.$silent || t._emit("changeCursor"), t.$isEmpty || t.$silent || t._emit("changeSelection"), t.$keepDesiredColumnOnChange || e.old.column == e.value.column || (t.$desiredColumn = null);
          }), (this || _global).anchor.on("change", function () {
            t.$anchorChanged = !0, t.$isEmpty || t.$silent || t._emit("changeSelection");
          });
        }

        var r = e("./lib/oop"),
            o = e("./lib/lang"),
            s = e("./lib/event_emitter").EventEmitter,
            a = e("./range").Range;
        !function () {
          r.implement(this || _global, s), (this || _global).isEmpty = function () {
            return (this || _global).$isEmpty || (this || _global).anchor.row == (this || _global).lead.row && (this || _global).anchor.column == (this || _global).lead.column;
          }, (this || _global).isMultiLine = function () {
            return !(this || _global).$isEmpty && (this || _global).anchor.row != (this || _global).cursor.row;
          }, (this || _global).getCursor = function () {
            return (this || _global).lead.getPosition();
          }, (this || _global).setSelectionAnchor = function (e, t) {
            (this || _global).$isEmpty = !1, (this || _global).anchor.setPosition(e, t);
          }, (this || _global).getAnchor = (this || _global).getSelectionAnchor = function () {
            return (this || _global).$isEmpty ? this.getSelectionLead() : (this || _global).anchor.getPosition();
          }, (this || _global).getSelectionLead = function () {
            return (this || _global).lead.getPosition();
          }, (this || _global).isBackwards = function () {
            var e = (this || _global).anchor,
                t = (this || _global).lead;
            return e.row > t.row || e.row == t.row && e.column > t.column;
          }, (this || _global).getRange = function () {
            var e = (this || _global).anchor,
                t = (this || _global).lead;
            return (this || _global).$isEmpty ? a.fromPoints(t, t) : this.isBackwards() ? a.fromPoints(t, e) : a.fromPoints(e, t);
          }, (this || _global).clearSelection = function () {
            (this || _global).$isEmpty || ((this || _global).$isEmpty = !0, this._emit("changeSelection"));
          }, (this || _global).selectAll = function () {
            this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
          }, (this || _global).setRange = (this || _global).setSelectionRange = function (e, t) {
            var i = t ? e.end : e.start,
                t = t ? e.start : e.end;
            this.$setSelection(i.row, i.column, t.row, t.column);
          }, (this || _global).$setSelection = function (e, t, i, n) {
            var r, o;
            (this || _global).$silent || (r = (this || _global).$isEmpty, o = (this || _global).inMultiSelectMode, (this || _global).$silent = !0, (this || _global).$cursorChanged = (this || _global).$anchorChanged = !1, (this || _global).anchor.setPosition(e, t), (this || _global).cursor.setPosition(i, n), (this || _global).$isEmpty = !a.comparePoints((this || _global).anchor, (this || _global).cursor), (this || _global).$silent = !1, (this || _global).$cursorChanged && this._emit("changeCursor"), ((this || _global).$cursorChanged || (this || _global).$anchorChanged || r != (this || _global).$isEmpty || o) && this._emit("changeSelection"));
          }, (this || _global).$moveSelection = function (e) {
            var t = (this || _global).lead;
            (this || _global).$isEmpty && this.setSelectionAnchor(t.row, t.column), e.call(this || _global);
          }, (this || _global).selectTo = function (e, t) {
            this.$moveSelection(function () {
              this.moveCursorTo(e, t);
            });
          }, (this || _global).selectToPosition = function (e) {
            this.$moveSelection(function () {
              this.moveCursorToPosition(e);
            });
          }, (this || _global).moveTo = function (e, t) {
            this.clearSelection(), this.moveCursorTo(e, t);
          }, (this || _global).moveToPosition = function (e) {
            this.clearSelection(), this.moveCursorToPosition(e);
          }, (this || _global).selectUp = function () {
            this.$moveSelection((this || _global).moveCursorUp);
          }, (this || _global).selectDown = function () {
            this.$moveSelection((this || _global).moveCursorDown);
          }, (this || _global).selectRight = function () {
            this.$moveSelection((this || _global).moveCursorRight);
          }, (this || _global).selectLeft = function () {
            this.$moveSelection((this || _global).moveCursorLeft);
          }, (this || _global).selectLineStart = function () {
            this.$moveSelection((this || _global).moveCursorLineStart);
          }, (this || _global).selectLineEnd = function () {
            this.$moveSelection((this || _global).moveCursorLineEnd);
          }, (this || _global).selectFileEnd = function () {
            this.$moveSelection((this || _global).moveCursorFileEnd);
          }, (this || _global).selectFileStart = function () {
            this.$moveSelection((this || _global).moveCursorFileStart);
          }, (this || _global).selectWordRight = function () {
            this.$moveSelection((this || _global).moveCursorWordRight);
          }, (this || _global).selectWordLeft = function () {
            this.$moveSelection((this || _global).moveCursorWordLeft);
          }, (this || _global).getWordRange = function (e, t) {
            var i;
            return void 0 === t && (e = (i = e || (this || _global).lead).row, t = i.column), (this || _global).session.getWordRange(e, t);
          }, (this || _global).selectWord = function () {
            this.setSelectionRange(this.getWordRange());
          }, (this || _global).selectAWord = function () {
            var e = this.getCursor(),
                e = (this || _global).session.getAWordRange(e.row, e.column);

            this.setSelectionRange(e);
          }, (this || _global).getLineRange = function (e, t) {
            var e = "number" == typeof e ? e : (this || _global).lead.row,
                i = (this || _global).session.getFoldLine(e),
                i = i ? (e = i.start.row, i.end.row) : e;

            return !0 === t ? new a(e, 0, i, (this || _global).session.getLine(i).length) : new a(e, 0, i + 1, 0);
          }, (this || _global).selectLine = function () {
            this.setSelectionRange(this.getLineRange());
          }, (this || _global).moveCursorUp = function () {
            this.moveCursorBy(-1, 0);
          }, (this || _global).moveCursorDown = function () {
            this.moveCursorBy(1, 0);
          }, (this || _global).wouldMoveIntoSoftTab = function (e, t, i) {
            var n = e.column,
                r = e.column + t;
            return i < 0 && (n = e.column - t, r = e.column), (this || _global).session.isTabStop(e) && (this || _global).doc.getLine(e.row).slice(n, r).split(" ").length - 1 == t;
          }, (this || _global).moveCursorLeft = function () {
            var e,
                t = (this || _global).lead.getPosition();

            (e = (this || _global).session.getFoldAt(t.row, t.column, -1)) ? this.moveCursorTo(e.start.row, e.start.column) : 0 === t.column ? 0 < t.row && this.moveCursorTo(t.row - 1, (this || _global).doc.getLine(t.row - 1).length) : (e = (this || _global).session.getTabSize(), this.wouldMoveIntoSoftTab(t, e, -1) && !(this || _global).session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, -e) : this.moveCursorBy(0, -1));
          }, (this || _global).moveCursorRight = function () {
            var e,
                t = (this || _global).lead.getPosition();

            (e = (this || _global).session.getFoldAt(t.row, t.column, 1)) ? this.moveCursorTo(e.end.row, e.end.column) : (this || _global).lead.column == (this || _global).doc.getLine((this || _global).lead.row).length ? (this || _global).lead.row < (this || _global).doc.getLength() - 1 && this.moveCursorTo((this || _global).lead.row + 1, 0) : (e = (this || _global).session.getTabSize(), t = (this || _global).lead, this.wouldMoveIntoSoftTab(t, e, 1) && !(this || _global).session.getNavigateWithinSoftTabs() ? this.moveCursorBy(0, e) : this.moveCursorBy(0, 1));
          }, (this || _global).moveCursorLineStart = function () {
            var e = (this || _global).lead.row,
                t = (this || _global).lead.column,
                i = (this || _global).session.documentToScreenRow(e, t),
                i = (this || _global).session.screenToDocumentPosition(i, 0),
                e = (this || _global).session.getDisplayLine(e, null, i.row, i.column).match(/^\s*/);

            e[0].length == t || (this || _global).session.$useEmacsStyleLineStart || (i.column += e[0].length), this.moveCursorToPosition(i);
          }, (this || _global).moveCursorLineEnd = function () {
            var e,
                t = (this || _global).lead,
                t = (this || _global).session.getDocumentLastRowColumnPosition(t.row, t.column);

            (this || _global).lead.column == t.column && (e = (this || _global).session.getLine(t.row), t.column == e.length && 0 < (e = e.search(/\s+$/)) && (t.column = e)), this.moveCursorTo(t.row, t.column);
          }, (this || _global).moveCursorFileEnd = function () {
            var e = (this || _global).doc.getLength() - 1,
                t = (this || _global).doc.getLine(e).length;

            this.moveCursorTo(e, t);
          }, (this || _global).moveCursorFileStart = function () {
            this.moveCursorTo(0, 0);
          }, (this || _global).moveCursorLongWordRight = function () {
            var e = (this || _global).lead.row,
                t = (this || _global).lead.column,
                i = (this || _global).doc.getLine(e),
                n = i.substring(t),
                r = ((this || _global).session.nonTokenRe.lastIndex = 0, (this || _global).session.tokenRe.lastIndex = 0, (this || _global).session.getFoldAt(e, t, 1));

            if (r) this.moveCursorTo(r.end.row, r.end.column);else {
              if ((this || _global).session.nonTokenRe.exec(n) && (t += (this || _global).session.nonTokenRe.lastIndex, (this || _global).session.nonTokenRe.lastIndex = 0, n = i.substring(t)), t >= i.length) return this.moveCursorTo(e, i.length), this.moveCursorRight(), void (e < (this || _global).doc.getLength() - 1 && this.moveCursorWordRight());
              (this || _global).session.tokenRe.exec(n) && (t += (this || _global).session.tokenRe.lastIndex, (this || _global).session.tokenRe.lastIndex = 0), this.moveCursorTo(e, t);
            }
          }, (this || _global).moveCursorLongWordLeft = function () {
            var e = (this || _global).lead.row,
                t = (this || _global).lead.column;
            if (i = (this || _global).session.getFoldAt(e, t, -1)) this.moveCursorTo(i.start.row, i.start.column);else {
              var i = (this || _global).session.getFoldStringAt(e, t, -1),
                  i = (null == i && (i = (this || _global).doc.getLine(e).substring(0, t)), o.stringReverse(i));

              if ((this || _global).session.nonTokenRe.lastIndex = 0, (this || _global).session.tokenRe.lastIndex = 0, (this || _global).session.nonTokenRe.exec(i) && (t -= (this || _global).session.nonTokenRe.lastIndex, i = i.slice((this || _global).session.nonTokenRe.lastIndex), (this || _global).session.nonTokenRe.lastIndex = 0), t <= 0) return this.moveCursorTo(e, 0), this.moveCursorLeft(), void (0 < e && this.moveCursorWordLeft());
              (this || _global).session.tokenRe.exec(i) && (t -= (this || _global).session.tokenRe.lastIndex, (this || _global).session.tokenRe.lastIndex = 0), this.moveCursorTo(e, t);
            }
          }, (this || _global).$shortWordEndIndex = function (e) {
            var t,
                i = 0,
                n = /\s/,
                r = (this || _global).session.tokenRe;
            if (r.lastIndex = 0, (this || _global).session.tokenRe.exec(e)) i = (this || _global).session.tokenRe.lastIndex;else {
              for (; (t = e[i]) && n.test(t);) i++;

              if (i < 1) for (r.lastIndex = 0; (t = e[i]) && !r.test(t);) if (r.lastIndex = 0, i++, n.test(t)) {
                if (2 < i) {
                  i--;
                  break;
                }

                for (; (t = e[i]) && n.test(t);) i++;

                if (2 < i) break;
              }
            }
            return r.lastIndex = 0, i;
          }, (this || _global).moveCursorShortWordRight = function () {
            var e = (this || _global).lead.row,
                t = (this || _global).lead.column,
                i = (this || _global).doc.getLine(e),
                n = i.substring(t),
                r = (this || _global).session.getFoldAt(e, t, 1);

            if (r) return this.moveCursorTo(r.end.row, r.end.column);

            if (t == i.length) {
              for (var o = (this || _global).doc.getLength(); n = (this || _global).doc.getLine(++e), e < o && /^\s*$/.test(n););

              /^\s+/.test(n) || (n = ""), t = 0;
            }

            r = this.$shortWordEndIndex(n);
            this.moveCursorTo(e, t + r);
          }, (this || _global).moveCursorShortWordLeft = function () {
            var e = (this || _global).lead.row,
                t = (this || _global).lead.column;
            if (n = (this || _global).session.getFoldAt(e, t, -1)) return this.moveCursorTo(n.start.row, n.start.column);

            var i = (this || _global).session.getLine(e).substring(0, t);

            if (0 === t) {
              for (; i = (this || _global).doc.getLine(--e), 0 < e && /^\s*$/.test(i););

              t = i.length, /\s+$/.test(i) || (i = "");
            }

            var n = o.stringReverse(i),
                n = this.$shortWordEndIndex(n);
            return this.moveCursorTo(e, t - n);
          }, (this || _global).moveCursorWordRight = function () {
            (this || _global).session.$selectLongWords ? this.moveCursorLongWordRight() : this.moveCursorShortWordRight();
          }, (this || _global).moveCursorWordLeft = function () {
            (this || _global).session.$selectLongWords ? this.moveCursorLongWordLeft() : this.moveCursorShortWordLeft();
          }, (this || _global).moveCursorBy = function (e, t) {
            var i,
                n = (this || _global).session.documentToScreenPosition((this || _global).lead.row, (this || _global).lead.column),
                r = (0 === t && (0 !== e && ((this || _global).session.$bidiHandler.isBidiRow(n.row, (this || _global).lead.row) ? (i = (this || _global).session.$bidiHandler.getPosLeft(n.column), n.column = Math.round(i / (this || _global).session.$bidiHandler.charWidths[0])) : i = n.column * (this || _global).session.$bidiHandler.charWidths[0]), (this || _global).$desiredColumn ? n.column = (this || _global).$desiredColumn : (this || _global).$desiredColumn = n.column), 0 != e && (this || _global).session.lineWidgets && (this || _global).session.lineWidgets[(this || _global).lead.row] && (r = (this || _global).session.lineWidgets[(this || _global).lead.row], e < 0 ? e -= r.rowsAbove || 0 : 0 < e && (e += r.rowCount - (r.rowsAbove || 0))), (this || _global).session.screenToDocumentPosition(n.row + e, n.column, i));

            0 !== e && 0 === t && r.row === (this || _global).lead.row && (r.column, (this || _global).lead.column), this.moveCursorTo(r.row, r.column + t, 0 === t);
          }, (this || _global).moveCursorToPosition = function (e) {
            this.moveCursorTo(e.row, e.column);
          }, (this || _global).moveCursorTo = function (e, t, i) {
            var n = (this || _global).session.getFoldAt(e, t, 1),
                n = (n && (e = n.start.row, t = n.start.column), (this || _global).$keepDesiredColumnOnChange = !0, (this || _global).session.getLine(e));

            /[\uDC00-\uDFFF]/.test(n.charAt(t)) && n.charAt(t - 1) && ((this || _global).lead.row == e && (this || _global).lead.column == t + 1 ? t -= 1 : t += 1), (this || _global).lead.setPosition(e, t), (this || _global).$keepDesiredColumnOnChange = !1, i || ((this || _global).$desiredColumn = null);
          }, (this || _global).moveCursorToScreen = function (e, t, i) {
            e = (this || _global).session.screenToDocumentPosition(e, t);
            this.moveCursorTo(e.row, e.column, i);
          }, (this || _global).detach = function () {
            (this || _global).lead.detach(), (this || _global).anchor.detach();
          }, (this || _global).fromOrientedRange = function (e) {
            this.setSelectionRange(e, e.cursor == e.start), (this || _global).$desiredColumn = e.desiredColumn || (this || _global).$desiredColumn;
          }, (this || _global).toOrientedRange = function (e) {
            var t = this.getRange();
            return e ? (e.start.column = t.start.column, e.start.row = t.start.row, e.end.column = t.end.column, e.end.row = t.end.row) : e = t, e.cursor = this.isBackwards() ? e.start : e.end, e.desiredColumn = (this || _global).$desiredColumn, e;
          }, (this || _global).getRangeOfMovements = function (e) {
            var t = this.getCursor();

            try {
              e(this || _global);
              var i = this.getCursor();
              return a.fromPoints(t, i);
            } catch (e) {
              return a.fromPoints(t, t);
            } finally {
              this.moveCursorToPosition(t);
            }
          }, (this || _global).toJSON = function () {
            var e;
            return (this || _global).rangeCount ? e = (this || _global).ranges.map(function (e) {
              var t = e.clone();
              return t.isBackwards = e.cursor == e.start, t;
            }) : (e = this.getRange()).isBackwards = this.isBackwards(), e;
          }, (this || _global).fromJSON = function (e) {
            if (null == e.start) {
              if ((this || _global).rangeList && 1 < e.length) {
                this.toSingleRange(e[0]);

                for (var t = e.length; t--;) {
                  var i = a.fromPoints(e[t].start, e[t].end);
                  e[t].isBackwards && (i.cursor = i.start), this.addRange(i, !0);
                }

                return;
              }

              e = e[0];
            }

            (this || _global).rangeList && this.toSingleRange(e), this.setSelectionRange(e, e.isBackwards);
          }, (this || _global).isEqual = function (e) {
            if ((e.length || (this || _global).rangeCount) && e.length != (this || _global).rangeCount) return !1;
            if (!e.length || !(this || _global).ranges) return this.getRange().isEqual(e);

            for (var t = (this || _global).ranges.length; t--;) if (!(this || _global).ranges[t].isEqual(e[t])) return !1;

            return !0;
          };
        }.call(n.prototype), t.Selection = n;
      }), ace.define("ace/tokenizer", ["require", "exports", "module", "ace/config"], function (e, t, i) {
        "use strict";

        function n(e) {
          for (var t in (this || _global).states = e, (this || _global).regExps = {}, (this || _global).matchMappings = {}, (this || _global).states) {
            for (var i = (this || _global).states[t], n = [], r = 0, o = (this || _global).matchMappings[t] = {
              defaultToken: "text"
            }, s = "g", a = [], l = 0; l < i.length; l++) {
              var c,
                  h,
                  d = i[l];
              d.defaultToken && (o.defaultToken = d.defaultToken), d.caseInsensitive && (s = "gi"), null != d.regex && (d.regex instanceof RegExp && (d.regex = d.regex.toString().slice(1, -1)), c = d.regex, h = new RegExp("(?:(" + c + ")|(.))").exec("a").length - 2, Array.isArray(d.token) ? 1 == d.token.length || 1 == h ? d.token = d.token[0] : h - 1 != d.token.length ? (this.reportError("number of classes and regexp groups doesn't match", {
                rule: d,
                groupCount: h - 1
              }), d.token = d.token[0]) : (d.tokenArray = d.token, d.token = null, d.onMatch = (this || _global).$arrayTokens) : "function" != typeof d.token || d.onMatch || (d.onMatch = 1 < h ? (this || _global).$applyToken : d.token), 1 < h && (c = /\\\d/.test(d.regex) ? d.regex.replace(/\\([0-9]+)/g, function (e, t) {
                return "\\" + (parseInt(t, 10) + r + 1);
              }) : (h = 1, this.removeCapturingGroups(d.regex)), d.splitRegex || "string" == typeof d.token || a.push(d)), o[r] = l, r += h, n.push(c), d.onMatch || (d.onMatch = null));
            }

            n.length || (o[0] = 0, n.push("$")), a.forEach(function (e) {
              e.splitRegex = this.createSplitterRegexp(e.regex, s);
            }, this || _global), (this || _global).regExps[t] = new RegExp("(" + n.join(")|(") + ")|($)", s);
          }
        }

        var r = e("./config"),
            I = 2000;
        !function () {
          (this || _global).$setMaxTokenCount = function (e) {
            I = 0 | e;
          }, (this || _global).$applyToken = function (e) {
            var t = (this || _global).splitRegex.exec(e).slice(1),
                i = (this || _global).token.apply(this || _global, t);

            if ("string" == typeof i) return [{
              type: i,
              value: e
            }];

            for (var n = [], r = 0, o = i.length; r < o; r++) t[r] && (n[n.length] = {
              type: i[r],
              value: t[r]
            });

            return n;
          }, (this || _global).$arrayTokens = function (e) {
            if (!e) return [];

            var t = (this || _global).splitRegex.exec(e);

            if (!t) return "text";

            for (var i = [], n = (this || _global).tokenArray, r = 0, o = n.length; r < o; r++) t[r + 1] && (i[i.length] = {
              type: n[r],
              value: t[r + 1]
            });

            return i;
          }, (this || _global).removeCapturingGroups = function (e) {
            return e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function (e, t) {
              return t ? "(?:" : e;
            });
          }, (this || _global).createSplitterRegexp = function (e, t) {
            var s, a, l;
            return -1 != e.indexOf("(?=") && (s = 0, a = !1, l = {}, e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function (e, t, i, n, r, o) {
              return a ? a = "]" != r : r ? a = !0 : n ? (s == l.stack && (l.end = o + 1, l.stack = -1), s--) : i && (s++, 1 != i.length && (l.stack = s, l.start = o)), e;
            }), null != l.end && /^\)*$/.test(e.substr(l.end)) && (e = e.substring(0, l.start) + e.substr(l.end))), "$" != (e = "^" != e.charAt(0) ? "^" + e : e).charAt(e.length - 1) && (e += "$"), new RegExp(e, (t || "").replace("g", ""));
          }, (this || _global).getLineTokens = function (e, t) {
            t && "string" != typeof t ? "#tmp" === (t = (i = t.slice(0))[0]) && (i.shift(), t = i.shift()) : i = [];

            for (var i, n, r = t || "start", o = (o = (this || _global).states[r]) || (this || _global).states[r = "start"], s = (this || _global).matchMappings[r], a = (this || _global).regExps[r], l = [], c = a.lastIndex = 0, h = 0, d = {
              type: null,
              value: ""
            }; n = a.exec(e);) {
              var u,
                  g = s.defaultToken,
                  p = null,
                  m = n[0],
                  f = a.lastIndex;
              f - m.length > c && (u = e.substring(c, f - m.length), d.type == g ? d.value += u : (d.type && l.push(d), d = {
                type: g,
                value: u
              }));

              for (var C = 0; C < n.length - 2; C++) if (void 0 !== n[C + 1]) {
                g = (p = o[s[C]]).onMatch ? p.onMatch(m, r, i, e) : p.token, p.next && (r = "string" == typeof p.next ? p.next : p.next(r, i), (o = (this || _global).states[r]) || (this.reportError("state doesn't exist", r), o = (this || _global).states[r = "start"]), s = (this || _global).matchMappings[r], (a = (this || _global).regExps[r]).lastIndex = c = f), p.consumeLineEnd && (c = f);
                break;
              }

              if (m) if ("string" == typeof g) p && !1 === p.merge || d.type !== g ? (d.type && l.push(d), d = {
                type: g,
                value: m
              }) : d.value += m;else if (g) {
                d.type && l.push(d);

                for (d = {
                  type: null,
                  value: ""
                }, C = 0; C < g.length; C++) l.push(g[C]);
              }
              if (c == e.length) break;

              if (c = f, h++ > I) {
                for (h > 2 * e.length && this.reportError("infinite loop with in ace tokenizer", {
                  startState: t,
                  line: e
                }); c < e.length;) d.type && l.push(d), d = {
                  value: e.substring(c, c += 500),
                  type: "overflow"
                };

                r = "start", i = [];
                break;
              }
            }

            return d.type && l.push(d), 1 < i.length && i[0] !== r && i.unshift("#tmp", r), {
              tokens: l,
              state: i.length ? i : r
            };
          }, (this || _global).reportError = r.reportError;
        }.call(n.prototype), t.Tokenizer = n;
      }), ace.define("ace/mode/text_highlight_rules", ["require", "exports", "module", "ace/lib/lang"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).$rules = {
            start: [{
              token: "empty_line",
              regex: "^$"
            }, {
              defaultToken: "text"
            }]
          };
        }

        var l = e("../lib/lang");
        !function () {
          (this || _global).addRules = function (e, t) {
            if (t) for (var i in e) {
              for (var n = e[i], r = 0; r < n.length; r++) {
                var o = n[r];
                (o.next || o.onMatch) && ("string" == typeof o.next && 0 !== o.next.indexOf(t) && (o.next = t + o.next), o.nextState && 0 !== o.nextState.indexOf(t) && (o.nextState = t + o.nextState));
              }

              (this || _global).$rules[t + i] = n;
            } else for (var i in e) (this || _global).$rules[i] = e[i];
          }, (this || _global).getRules = function () {
            return (this || _global).$rules;
          }, (this || _global).embedRules = function (e, t, i, n, r) {
            e = "function" == typeof e ? new e().getRules() : e;
            if (n) for (var o = 0; o < n.length; o++) n[o] = t + n[o];else for (var s in n = [], e) n.push(t + s);
            if (this.addRules(e, t), i) for (var a = Array.prototype[r ? "push" : "unshift"], o = 0; o < n.length; o++) a.apply((this || _global).$rules[n[o]], l.deepCopy(i));
            (this || _global).$embeds || ((this || _global).$embeds = []), (this || _global).$embeds.push(t);
          }, (this || _global).getEmbeds = function () {
            return (this || _global).$embeds;
          };

          function d(e, t) {
            return "start" == e && !t.length || t.unshift((this || _global).nextState, e), (this || _global).nextState;
          }

          function u(e, t) {
            return t.shift(), t.shift() || "start";
          }

          (this || _global).normalizeRules = function () {
            var c = 0,
                h = (this || _global).$rules;
            Object.keys(h).forEach(function e(t) {
              var i = h[t];
              i.processed = !0;

              for (var n = 0; n < i.length; n++) {
                var r = i[n],
                    o = null,
                    s = (Array.isArray(r) && (o = r, r = {}), !r.regex && r.start && (r.regex = r.start, r.next || (r.next = []), r.next.push({
                  defaultToken: r.token
                }, {
                  token: r.token + ".end",
                  regex: r.end || r.start,
                  next: "pop"
                }), r.token = r.token + ".start", r.push = !0), r.next || r.push);
                if (s && Array.isArray(s) ? ((l = r.stateName) || ("string" != typeof (l = r.token) && (l = l[0] || ""), h[l] && (l += c++)), h[l] = s, e(r.next = l)) : "pop" == s && (r.next = u), r.push && (r.nextState = r.next || r.push, r.next = d, delete r.push), r.rules) for (var a in r.rules) h[a] ? h[a].push && h[a].push.apply(h[a], r.rules[a]) : h[a] = r.rules[a];
                var l = "string" == typeof r ? r : r.include;
                (o = l ? Array.isArray(l) ? l.map(function (e) {
                  return h[e];
                }) : h[l] : o) && (s = [n, 1].concat(o), r.noEscape && (s = s.filter(function (e) {
                  return !e.next;
                })), i.splice.apply(i, s), n--), r.keywordMap && (r.token = this.createKeywordMapper(r.keywordMap, r.defaultToken || "text", r.caseInsensitive), delete r.defaultToken);
              }
            }, this || _global);
          }, (this || _global).createKeywordMapper = function (r, t, o, s) {
            var a = Object.create(null);
            return (this || _global).$keywordList = [], Object.keys(r).forEach(function (e) {
              for (var t = r[e].split(s || "|"), i = t.length; i--;) {
                var n = t[i];
                (this || _global).$keywordList.push(n), o && (n = n.toLowerCase()), a[n] = e;
              }
            }, this || _global), r = null, o ? function (e) {
              return a[e.toLowerCase()] || t;
            } : function (e) {
              return a[e] || t;
            };
          }, (this || _global).getKeywords = function () {
            return (this || _global).$keywords;
          };
        }.call(n.prototype), t.TextHighlightRules = n;
      }), ace.define("ace/mode/behaviour", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).$behaviours = {};
        }

        !function () {
          (this || _global).add = function (e, t, i) {
            switch (void 0) {
              case (this || _global).$behaviours:
                (this || _global).$behaviours = {};

              case (this || _global).$behaviours[e]:
                (this || _global).$behaviours[e] = {};
            }

            (this || _global).$behaviours[e][t] = i;
          }, (this || _global).addBehaviours = function (e) {
            for (var t in e) for (var i in e[t]) this.add(t, i, e[t][i]);
          }, (this || _global).remove = function (e) {
            (this || _global).$behaviours && (this || _global).$behaviours[e] && delete (this || _global).$behaviours[e];
          }, (this || _global).inherit = function (e, t) {
            e = ("function" == typeof e ? new e() : e).getBehaviours(t), this.addBehaviours(e);
          }, (this || _global).getBehaviours = function (e) {
            if (e) {
              for (var t = {}, i = 0; i < e.length; i++) (this || _global).$behaviours[e[i]] && (t[e[i]] = (this || _global).$behaviours[e[i]]);

              return t;
            }

            return (this || _global).$behaviours;
          };
        }.call(n.prototype), t.Behaviour = n;
      }), ace.define("ace/token_iterator", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        function n(e, t, i) {
          (this || _global).$session = e, (this || _global).$row = t, (this || _global).$rowTokens = e.getTokens(t), e = e.getTokenAt(t, i), (this || _global).$tokenIndex = e ? e.index : -1;
        }

        var r = e("./range").Range;
        !function () {
          (this || _global).stepBackward = function () {
            for (--(this || _global).$tokenIndex; (this || _global).$tokenIndex < 0;) {
              if (--(this || _global).$row, (this || _global).$row < 0) return (this || _global).$row = 0, null;
              (this || _global).$rowTokens = (this || _global).$session.getTokens((this || _global).$row), (this || _global).$tokenIndex = (this || _global).$rowTokens.length - 1;
            }

            return (this || _global).$rowTokens[(this || _global).$tokenIndex];
          }, (this || _global).stepForward = function () {
            var e;

            for ((this || _global).$tokenIndex += 1; (this || _global).$tokenIndex >= (this || _global).$rowTokens.length;) {
              if ((this || _global).$row += 1, e = e || (this || _global).$session.getLength(), (this || _global).$row >= e) return (this || _global).$row = e - 1, null;
              (this || _global).$rowTokens = (this || _global).$session.getTokens((this || _global).$row), (this || _global).$tokenIndex = 0;
            }

            return (this || _global).$rowTokens[(this || _global).$tokenIndex];
          }, (this || _global).getCurrentToken = function () {
            return (this || _global).$rowTokens[(this || _global).$tokenIndex];
          }, (this || _global).getCurrentTokenRow = function () {
            return (this || _global).$row;
          }, (this || _global).getCurrentTokenColumn = function () {
            var e = (this || _global).$rowTokens,
                t = (this || _global).$tokenIndex,
                i = e[t].start;
            if (void 0 !== i) return i;

            for (i = 0; 0 < t;) i += e[--t].value.length;

            return i;
          }, (this || _global).getCurrentTokenPosition = function () {
            return {
              row: (this || _global).$row,
              column: this.getCurrentTokenColumn()
            };
          }, (this || _global).getCurrentTokenRange = function () {
            var e = (this || _global).$rowTokens[(this || _global).$tokenIndex],
                t = this.getCurrentTokenColumn();
            return new r((this || _global).$row, t, (this || _global).$row, t + e.value.length);
          };
        }.call(n.prototype), t.TokenIterator = n;
      }), ace.define("ace/mode/behaviour/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/mode/behaviour", "ace/token_iterator", "ace/lib/lang"], function (e, t, i) {
        "use strict";

        function u(e) {
          var t = -1;
          if (e.multiSelect && (t = e.selection.index, l.rangeCount != e.multiSelect.rangeCount && (l = {
            rangeCount: e.multiSelect.rangeCount
          })), l[t]) return m = l[t];
          m = l[t] = {
            autoInsertedBrackets: 0,
            autoInsertedRow: -1,
            autoInsertedLineEnd: "",
            maybeInsertedBrackets: 0,
            maybeInsertedRow: -1,
            maybeInsertedLineStart: "",
            maybeInsertedLineEnd: ""
          };
        }

        function g(e, t, i, n) {
          var r = e.end.row - e.start.row;
          return {
            text: i + t + n,
            selection: [0, e.start.column + 1, r, e.end.column + (r ? 0 : 1)]
          };
        }

        function p(d) {
          this.add("braces", "insertion", function (e, t, i, n, r) {
            var o = i.getCursorPosition(),
                s = n.doc.getLine(o.row);
            if ("{" == r) return u(i), l = i.getSelectionRange(), "" !== (c = n.doc.getTextRange(l)) && "{" !== c && i.getWrapBehavioursEnabled() ? g(l, c, "{", "}") : p.isSaneInsertion(i, n) ? /[\]\}\)]/.test(s[o.column]) || i.inMultiSelectMode || d && d.braces ? (p.recordAutoInsert(i, n, "}"), {
              text: "{}",
              selection: [1, 1]
            }) : (p.recordMaybeInsert(i, n, "{"), {
              text: "{",
              selection: [1, 1]
            }) : void 0;

            if ("}" == r) {
              u(i);
              var a = s.substring(o.column, o.column + 1);
              if ("}" == a) if (null !== n.$findOpeningBracket("}", {
                column: o.column + 1,
                row: o.row
              }) && p.isAutoInsertedClosing(o, s, r)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            } else {
              if ("\n" == r || "\r\n" == r) {
                u(i);
                var l = "";

                if (p.isMaybeInsertedClosing(o, s) && (l = f.stringRepeat("}", m.maybeInsertedBrackets), p.clearMaybeInsertedClosing()), "}" === (a = s.substring(o.column, o.column + 1))) {
                  var c = n.findMatchingBracket({
                    row: o.row,
                    column: o.column + 1
                  }, "}");
                  if (!c) return null;
                  var h = this.$getIndent(n.getLine(c.row));
                } else {
                  if (!l) return void p.clearMaybeInsertedClosing();
                  h = this.$getIndent(s);
                }

                r = h + n.getTabString();
                return {
                  text: "\n" + r + "\n" + h + l,
                  selection: [1, r.length, 1, r.length]
                };
              }

              p.clearMaybeInsertedClosing();
            }
          }), this.add("braces", "deletion", function (e, t, i, n, r) {
            var o = n.doc.getTextRange(r);

            if (!r.isMultiLine() && "{" == o) {
              if (u(i), "}" == n.doc.getLine(r.start.row).substring(r.end.column, r.end.column + 1)) return r.end.column++, r;
              m.maybeInsertedBrackets--;
            }
          }), this.add("parens", "insertion", function (e, t, i, n, r) {
            if ("(" == r) return u(i), o = i.getSelectionRange(), "" !== (s = n.doc.getTextRange(o)) && i.getWrapBehavioursEnabled() ? g(o, s, "(", ")") : p.isSaneInsertion(i, n) ? (p.recordAutoInsert(i, n, ")"), {
              text: "()",
              selection: [1, 1]
            }) : void 0;

            if (")" == r) {
              u(i);
              var o = i.getCursorPosition(),
                  s = n.doc.getLine(o.row),
                  i = s.substring(o.column, o.column + 1);
              if (")" == i) if (null !== n.$findOpeningBracket(")", {
                column: o.column + 1,
                row: o.row
              }) && p.isAutoInsertedClosing(o, s, r)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            }
          }), this.add("parens", "deletion", function (e, t, i, n, r) {
            var o = n.doc.getTextRange(r);
            if (!r.isMultiLine() && "(" == o && (u(i), ")" == n.doc.getLine(r.start.row).substring(r.start.column + 1, r.start.column + 2))) return r.end.column++, r;
          }), this.add("brackets", "insertion", function (e, t, i, n, r) {
            if ("[" == r) return u(i), o = i.getSelectionRange(), "" !== (s = n.doc.getTextRange(o)) && i.getWrapBehavioursEnabled() ? g(o, s, "[", "]") : p.isSaneInsertion(i, n) ? (p.recordAutoInsert(i, n, "]"), {
              text: "[]",
              selection: [1, 1]
            }) : void 0;

            if ("]" == r) {
              u(i);
              var o = i.getCursorPosition(),
                  s = n.doc.getLine(o.row),
                  i = s.substring(o.column, o.column + 1);
              if ("]" == i) if (null !== n.$findOpeningBracket("]", {
                column: o.column + 1,
                row: o.row
              }) && p.isAutoInsertedClosing(o, s, r)) return p.popAutoInsertedClosing(), {
                text: "",
                selection: [1, 1]
              };
            }
          }), this.add("brackets", "deletion", function (e, t, i, n, r) {
            var o = n.doc.getTextRange(r);
            if (!r.isMultiLine() && "[" == o && (u(i), "]" == n.doc.getLine(r.start.row).substring(r.start.column + 1, r.start.column + 2))) return r.end.column++, r;
          }), this.add("string_dquotes", "insertion", function (e, t, i, n, r) {
            var o = n.$mode.$quotes || C;

            if (1 == r.length && o[r] && (!(this || _global).lineCommentStart || -1 == (this || _global).lineCommentStart.indexOf(r))) {
              u(i);
              var s = i.getSelectionRange(),
                  a = n.doc.getTextRange(s);
              if (!("" === a || 1 == a.length && o[a]) && i.getWrapBehavioursEnabled()) return g(s, a, r, r);

              if (!a) {
                var o = i.getCursorPosition(),
                    s = n.doc.getLine(o.row),
                    a = s.substring(o.column - 1, o.column),
                    i = s.substring(o.column, o.column + 1),
                    l = n.getTokenAt(o.row, o.column),
                    c = n.getTokenAt(o.row, o.column + 1);
                if ("\\" == a && l && /escape/.test(l.type)) return null;
                var h,
                    l = l && /string|escape/.test(l.type),
                    d = !c || /string|escape/.test(c.type);
                if (i == r) (h = l !== d) && /string\.end/.test(c.type) && (h = !1);else {
                  if (l && !d) return null;
                  if (l && d) return null;
                  c = n.$mode.tokenRe, l = (c.lastIndex = 0, c.test(a)), d = (c.lastIndex = 0, c.test(a));
                  if (l || d) return null;
                  if (i && !/[\s;,.})\]\\]/.test(i)) return null;
                  n = s[o.column - 2];
                  if (a == r && (n == r || c.test(n))) return null;
                  h = !0;
                }
                return {
                  text: h ? r + r : "",
                  selection: [1, 1]
                };
              }
            }
          }), this.add("string_dquotes", "deletion", function (e, t, i, n, r) {
            var o = n.$mode.$quotes || C,
                s = n.doc.getTextRange(r);
            if (!r.isMultiLine() && o.hasOwnProperty(s) && (u(i), n.doc.getLine(r.start.row).substring(r.start.column + 1, r.start.column + 2) == s)) return r.end.column++, r;
          });
        }

        var m,
            n = e("../../lib/oop"),
            r = e("../behaviour").Behaviour,
            o = e("../../token_iterator").TokenIterator,
            f = e("../../lib/lang"),
            s = ["text", "paren.rparen", "rparen", "paren", "punctuation.operator"],
            a = ["text", "paren.rparen", "rparen", "paren", "punctuation.operator", "comment"],
            l = {},
            C = {
          "\"": "\"",
          "'": "'"
        };
        p.isSaneInsertion = function (e, t) {
          var i = e.getCursorPosition(),
              n = new o(t, i.row, i.column);

          if (!this.$matchTokenType(n.getCurrentToken() || "text", s)) {
            if (/[)}\]]/.test(e.session.getLine(i.row)[i.column])) return !0;
            e = new o(t, i.row, i.column + 1);
            if (!this.$matchTokenType(e.getCurrentToken() || "text", s)) return !1;
          }

          return n.stepForward(), n.getCurrentTokenRow() !== i.row || this.$matchTokenType(n.getCurrentToken() || "text", a);
        }, p.$matchTokenType = function (e, t) {
          return -1 < t.indexOf(e.type || e);
        }, p.recordAutoInsert = function (e, t, i) {
          e = e.getCursorPosition(), t = t.doc.getLine(e.row);
          this.isAutoInsertedClosing(e, t, m.autoInsertedLineEnd[0]) || (m.autoInsertedBrackets = 0), m.autoInsertedRow = e.row, m.autoInsertedLineEnd = i + t.substr(e.column), m.autoInsertedBrackets++;
        }, p.recordMaybeInsert = function (e, t, i) {
          e = e.getCursorPosition(), t = t.doc.getLine(e.row);
          this.isMaybeInsertedClosing(e, t) || (m.maybeInsertedBrackets = 0), m.maybeInsertedRow = e.row, m.maybeInsertedLineStart = t.substr(0, e.column) + i, m.maybeInsertedLineEnd = t.substr(e.column), m.maybeInsertedBrackets++;
        }, p.isAutoInsertedClosing = function (e, t, i) {
          return 0 < m.autoInsertedBrackets && e.row === m.autoInsertedRow && i === m.autoInsertedLineEnd[0] && t.substr(e.column) === m.autoInsertedLineEnd;
        }, p.isMaybeInsertedClosing = function (e, t) {
          return 0 < m.maybeInsertedBrackets && e.row === m.maybeInsertedRow && t.substr(e.column) === m.maybeInsertedLineEnd && t.substr(0, e.column) == m.maybeInsertedLineStart;
        }, p.popAutoInsertedClosing = function () {
          m.autoInsertedLineEnd = m.autoInsertedLineEnd.substr(1), m.autoInsertedBrackets--;
        }, p.clearMaybeInsertedClosing = function () {
          m && (m.maybeInsertedBrackets = 0, m.maybeInsertedRow = -1);
        }, n.inherits(p, r), t.CstyleBehaviour = p;
      }), ace.define("ace/unicode", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        for (var n = [48, 9, 8, 25, 5, 0, 2, 25, 48, 0, 11, 0, 5, 0, 6, 22, 2, 30, 2, 457, 5, 11, 15, 4, 8, 0, 2, 0, 18, 116, 2, 1, 3, 3, 9, 0, 2, 2, 2, 0, 2, 19, 2, 82, 2, 138, 2, 4, 3, 155, 12, 37, 3, 0, 8, 38, 10, 44, 2, 0, 2, 1, 2, 1, 2, 0, 9, 26, 6, 2, 30, 10, 7, 61, 2, 9, 5, 101, 2, 7, 3, 9, 2, 18, 3, 0, 17, 58, 3, 100, 15, 53, 5, 0, 6, 45, 211, 57, 3, 18, 2, 5, 3, 11, 3, 9, 2, 1, 7, 6, 2, 2, 2, 7, 3, 1, 3, 21, 2, 6, 2, 0, 4, 3, 3, 8, 3, 1, 3, 3, 9, 0, 5, 1, 2, 4, 3, 11, 16, 2, 2, 5, 5, 1, 3, 21, 2, 6, 2, 1, 2, 1, 2, 1, 3, 0, 2, 4, 5, 1, 3, 2, 4, 0, 8, 3, 2, 0, 8, 15, 12, 2, 2, 8, 2, 2, 2, 21, 2, 6, 2, 1, 2, 4, 3, 9, 2, 2, 2, 2, 3, 0, 16, 3, 3, 9, 18, 2, 2, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 3, 8, 3, 1, 3, 2, 9, 1, 5, 1, 2, 4, 3, 9, 2, 0, 17, 1, 2, 5, 4, 2, 2, 3, 4, 1, 2, 0, 2, 1, 4, 1, 4, 2, 4, 11, 5, 4, 4, 2, 2, 3, 3, 0, 7, 0, 15, 9, 18, 2, 2, 7, 2, 2, 2, 22, 2, 9, 2, 4, 4, 7, 2, 2, 2, 3, 8, 1, 2, 1, 7, 3, 3, 9, 19, 1, 2, 7, 2, 2, 2, 22, 2, 9, 2, 4, 3, 8, 2, 2, 2, 3, 8, 1, 8, 0, 2, 3, 3, 9, 19, 1, 2, 7, 2, 2, 2, 22, 2, 15, 4, 7, 2, 2, 2, 3, 10, 0, 9, 3, 3, 9, 11, 5, 3, 1, 2, 17, 4, 23, 2, 8, 2, 0, 3, 6, 4, 0, 5, 5, 2, 0, 2, 7, 19, 1, 14, 57, 6, 14, 2, 9, 40, 1, 2, 0, 3, 1, 2, 0, 3, 0, 7, 3, 2, 6, 2, 2, 2, 0, 2, 0, 3, 1, 2, 12, 2, 2, 3, 4, 2, 0, 2, 5, 3, 9, 3, 1, 35, 0, 24, 1, 7, 9, 12, 0, 2, 0, 2, 0, 5, 9, 2, 35, 5, 19, 2, 5, 5, 7, 2, 35, 10, 0, 58, 73, 7, 77, 3, 37, 11, 42, 2, 0, 4, 328, 2, 3, 3, 6, 2, 0, 2, 3, 3, 40, 2, 3, 3, 32, 2, 3, 3, 6, 2, 0, 2, 3, 3, 14, 2, 56, 2, 3, 3, 66, 5, 0, 33, 15, 17, 84, 13, 619, 3, 16, 2, 25, 6, 74, 22, 12, 2, 6, 12, 20, 12, 19, 13, 12, 2, 2, 2, 1, 13, 51, 3, 29, 4, 0, 5, 1, 3, 9, 34, 2, 3, 9, 7, 87, 9, 42, 6, 69, 11, 28, 4, 11, 5, 11, 11, 39, 3, 4, 12, 43, 5, 25, 7, 10, 38, 27, 5, 62, 2, 28, 3, 10, 7, 9, 14, 0, 89, 75, 5, 9, 18, 8, 13, 42, 4, 11, 71, 55, 9, 9, 4, 48, 83, 2, 2, 30, 14, 230, 23, 280, 3, 5, 3, 37, 3, 5, 3, 7, 2, 0, 2, 0, 2, 0, 2, 30, 3, 52, 2, 6, 2, 0, 4, 2, 2, 6, 4, 3, 3, 5, 5, 12, 6, 2, 2, 6, 67, 1, 20, 0, 29, 0, 14, 0, 17, 4, 60, 12, 5, 0, 4, 11, 18, 0, 5, 0, 3, 9, 2, 0, 4, 4, 7, 0, 2, 0, 2, 0, 2, 3, 2, 10, 3, 3, 6, 4, 5, 0, 53, 1, 2684, 46, 2, 46, 2, 132, 7, 6, 15, 37, 11, 53, 10, 0, 17, 22, 10, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 6, 2, 31, 48, 0, 470, 1, 36, 5, 2, 4, 6, 1, 5, 85, 3, 1, 3, 2, 2, 89, 2, 3, 6, 40, 4, 93, 18, 23, 57, 15, 513, 6581, 75, 20939, 53, 1164, 68, 45, 3, 268, 4, 27, 21, 31, 3, 13, 13, 1, 2, 24, 9, 69, 11, 1, 38, 8, 3, 102, 3, 1, 111, 44, 25, 51, 13, 68, 12, 9, 7, 23, 4, 0, 5, 45, 3, 35, 13, 28, 4, 64, 15, 10, 39, 54, 10, 13, 3, 9, 7, 22, 4, 1, 5, 66, 25, 2, 227, 42, 2, 1, 3, 9, 7, 11171, 13, 22, 5, 48, 8453, 301, 3, 61, 3, 105, 39, 6, 13, 4, 6, 11, 2, 12, 2, 4, 2, 0, 2, 1, 2, 1, 2, 107, 34, 362, 19, 63, 3, 53, 41, 11, 5, 15, 17, 6, 13, 1, 25, 2, 33, 4, 2, 134, 20, 9, 8, 25, 5, 0, 2, 25, 12, 88, 4, 5, 3, 5, 3, 5, 3, 2], r = 0, o = [], s = 0; s < n.length; s += 2) o.push(r += n[s]), n[s + 1] && o.push(45, r += n[s + 1]);

        t.wordChars = String.fromCharCode.apply(null, o);
      }), ace.define("ace/mode/text", ["require", "exports", "module", "ace/config", "ace/tokenizer", "ace/mode/text_highlight_rules", "ace/mode/behaviour/cstyle", "ace/unicode", "ace/lib/lang", "ace/token_iterator", "ace/range"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).HighlightRules = o;
        }

        var s = e("../config"),
            r = e("../tokenizer").Tokenizer,
            o = e("./text_highlight_rules").TextHighlightRules,
            a = e("./behaviour/cstyle").CstyleBehaviour,
            l = e("../unicode"),
            b = e("../lib/lang"),
            m = e("../token_iterator").TokenIterator,
            f = e("../range").Range;
        !function () {
          (this || _global).$defaultBehaviour = new a(), (this || _global).tokenRe = new RegExp("^[" + l.wordChars + "\\$_]+", "g"), (this || _global).nonTokenRe = new RegExp("^(?:[^" + l.wordChars + "\\$_]|\\s])+", "g"), (this || _global).getTokenizer = function () {
            return (this || _global).$tokenizer || ((this || _global).$highlightRules = (this || _global).$highlightRules || new (this || _global).HighlightRules((this || _global).$highlightRuleConfig), (this || _global).$tokenizer = new r((this || _global).$highlightRules.getRules())), (this || _global).$tokenizer;
          }, (this || _global).lineCommentStart = "", (this || _global).blockComment = "", (this || _global).toggleCommentLines = function (e, r, i, n) {
            var o = r.doc,
                s = !0,
                a = !0,
                l = 1 / 0,
                c = r.getTabSize(),
                t = !1;

            if ((this || _global).lineCommentStart) {
              m = Array.isArray((this || _global).lineCommentStart) ? (C = (this || _global).lineCommentStart.map(b.escapeRegExp).join("|"), (this || _global).lineCommentStart[0]) : (C = b.escapeRegExp((this || _global).lineCommentStart), (this || _global).lineCommentStart), C = new RegExp("^(\\s*)(?:" + C + ") ?"), t = r.getUseSoftTabs();

              var h = function (e, t) {
                var i,
                    n,
                    r = e.match(C);
                r && (i = r[1].length, n = r[0].length, p(e, i, n) || " " != r[0][n - 1] || n--, o.removeInLine(t, i, n));
              },
                  d = m + " ",
                  u = function (e, t) {
                s && !/\S/.test(e) || (p(e, l, l) ? o.insertInLine({
                  row: t,
                  column: l
                }, d) : o.insertInLine({
                  row: t,
                  column: l
                }, m));
              },
                  g = function (e, t) {
                return C.test(e);
              },
                  p = function (e, t, i) {
                for (var n = 0; t-- && " " == e.charAt(t);) n++;

                if (n % c != 0) return !1;

                for (n = 0; " " == e.charAt(i++);) n++;

                return 2 < c ? n % c != c - 1 : n % c == 0;
              };
            } else {
              if (!(this || _global).blockComment) return !1;

              var m = (this || _global).blockComment.start,
                  f = (this || _global).blockComment.end,
                  C = new RegExp("^(\\s*)(?:" + b.escapeRegExp(m) + ")"),
                  I = new RegExp("(?:" + b.escapeRegExp(f) + ")\\s*$"),
                  u = function (e, t) {
                g(e, t) || s && !/\S/.test(e) || (o.insertInLine({
                  row: t,
                  column: e.length
                }, f), o.insertInLine({
                  row: t,
                  column: l
                }, m));
              },
                  h = function (e, t) {
                var i;
                (i = e.match(I)) && o.removeInLine(t, e.length - i[0].length, e.length), (i = e.match(C)) && o.removeInLine(t, i[1].length, i[0].length);
              },
                  g = function (e, t) {
                if (C.test(e)) return !0;

                for (var i = r.getTokens(t), n = 0; n < i.length; n++) if ("comment" === i[n].type) return !0;
              };
            }

            function v(e) {
              for (var t = i; t <= n; t++) e(o.getLine(t), t);
            }

            var A = 1 / 0;
            v(function (e, t) {
              var i = e.search(/\S/);
              -1 !== i ? (i < l && (l = i), a && !g(e, t) && (a = !1)) : A > e.length && (A = e.length);
            }), l == 1 / 0 && (l = A, a = s = !1), t && l % c != 0 && (l = Math.floor(l / c) * c), v(a ? h : u);
          }, (this || _global).toggleBlockComment = function (e, t, i, n) {
            var r = (this || _global).blockComment;

            if (r) {
              !r.start && r[0] && (r = r[0]);
              var o,
                  s,
                  a = (u = new m(t, n.row, n.column)).getCurrentToken(),
                  l = (t.selection, t.selection.toOrientedRange());

              if (a && /comment/.test(a.type)) {
                for (; a && /comment/.test(a.type);) {
                  if (-1 != (g = a.value.indexOf(r.start))) {
                    var c = u.getCurrentTokenRow(),
                        h = u.getCurrentTokenColumn() + g,
                        d = new f(c, h, c, h + r.start.length);
                    break;
                  }

                  a = u.stepBackward();
                }

                for (var u, g, a = (u = new m(t, n.row, n.column)).getCurrentToken(); a && /comment/.test(a.type);) {
                  if (-1 != (g = a.value.indexOf(r.end))) {
                    var c = u.getCurrentTokenRow(),
                        h = u.getCurrentTokenColumn() + g,
                        p = new f(c, h, c, h + r.end.length);
                    break;
                  }

                  a = u.stepForward();
                }

                p && t.remove(p), d && (t.remove(d), o = d.start.row, s = -r.start.length);
              } else s = r.start.length, o = i.start.row, t.insert(i.end, r.end), t.insert(i.start, r.start);

              l.start.row == o && (l.start.column += s), l.end.row == o && (l.end.column += s), t.selection.fromOrientedRange(l);
            }
          }, (this || _global).getNextLineIndent = function (e, t, i) {
            return this.$getIndent(t);
          }, (this || _global).checkOutdent = function (e, t, i) {
            return !1;
          }, (this || _global).autoOutdent = function (e, t, i) {}, (this || _global).$getIndent = function (e) {
            return e.match(/^\s*/)[0];
          }, (this || _global).createWorker = function (e) {
            return null;
          }, (this || _global).createModeDelegates = function (e) {
            for (var n in (this || _global).$embeds = [], (this || _global).$modes = {}, e) {
              var t, i, r;
              e[n] && (i = (t = e[n]).prototype.$id, (r = s.$modes[i]) || (s.$modes[i] = r = new t()), s.$modes[n] || (s.$modes[n] = r), (this || _global).$embeds.push(n), (this || _global).$modes[n] = r);
            }

            for (var o = ["toggleBlockComment", "toggleCommentLines", "getNextLineIndent", "checkOutdent", "autoOutdent", "transformAction", "getCompletions"], n = 0; n < o.length; n++) !function (e) {
              var t = o[n],
                  i = e[t];

              e[o[n]] = function () {
                return this.$delegator(t, arguments, i);
              };
            }(this || _global);
          }, (this || _global).$delegator = function (e, t, i) {
            var n = t[0] || "start";

            if ("string" != typeof n) {
              if (Array.isArray(n[2])) {
                var r = n[2][n[2].length - 1];
                if (s = (this || _global).$modes[r]) return s[e].apply(s, [n[1]].concat([].slice.call(t, 1)));
              }

              n = n[0] || "start";
            }

            for (var o = 0; o < (this || _global).$embeds.length; o++) if ((this || _global).$modes[(this || _global).$embeds[o]]) {
              var s,
                  a = n.split((this || _global).$embeds[o]);
              if (!a[0] && a[1]) return t[0] = a[1], (s = (this || _global).$modes[(this || _global).$embeds[o]])[e].apply(s, t);
            }

            r = i.apply(this || _global, t);
            return i ? r : void 0;
          }, (this || _global).transformAction = function (e, t, i, n, r) {
            if ((this || _global).$behaviour) {
              var o,
                  s = (this || _global).$behaviour.getBehaviours();

              for (o in s) if (s[o][t]) {
                var a = s[o][t].apply(this || _global, arguments);
                if (a) return a;
              }
            }
          }, (this || _global).getKeywords = function (e) {
            if (!(this || _global).completionKeywords) {
              var t = (this || _global).$tokenizer.rules,
                  i = [];

              for (s in t) for (var n = t[s], r = 0, o = n.length; r < o; r++) if ("string" == typeof n[r].token) /keyword|support|storage/.test(n[r].token) && i.push(n[r].regex);else if ("object" == typeof n[r].token) for (var s, a = 0, l = n[r].token.length; a < l; a++) /keyword|support|storage/.test(n[r].token[a]) && (s = n[r].regex.match(/\(.+?\)/g)[a], i.push(s.substr(1, s.length - 2)));

              (this || _global).completionKeywords = i;
            }

            return e ? i.concat((this || _global).$keywordList || []) : (this || _global).$keywordList;
          }, (this || _global).$createKeywordList = function () {
            return (this || _global).$highlightRules || this.getTokenizer(), (this || _global).$keywordList = (this || _global).$highlightRules.$keywordList || [];
          }, (this || _global).getCompletions = function (e, t, i, n) {
            return ((this || _global).$keywordList || this.$createKeywordList()).map(function (e) {
              return {
                name: e,
                value: e,
                score: 0,
                meta: "keyword"
              };
            });
          }, (this || _global).$id = "ace/mode/text";
        }.call(n.prototype), t.Mode = n;
      }), ace.define("ace/apply_delta", ["require", "exports", "module"], function (e, t, i) {
        "use strict";

        t.applyDelta = function (e, t, i) {
          var n = t.start.row,
              r = t.start.column,
              o = e[n] || "";

          switch (t.action) {
            case "insert":
              1 === t.lines.length ? e[n] = o.substring(0, r) + t.lines[0] + o.substring(r) : (s = [n, 1].concat(t.lines), e.splice.apply(e, s), e[n] = o.substring(0, r) + e[n], e[n + t.lines.length - 1] += o.substring(r));
              break;

            case "remove":
              var s = t.end.column,
                  a = t.end.row;
              n === a ? e[n] = o.substring(0, r) + o.substring(s) : e.splice(n, a - n + 1, o.substring(0, r) + e[a].substring(s));
          }
        };
      }), ace.define("ace/anchor", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, i) {
        "use strict";

        var n = e("./lib/oop"),
            r = e("./lib/event_emitter").EventEmitter,
            e = t.Anchor = function (e, t, i) {
          (this || _global).$onChange = (this || _global).onChange.bind(this || _global), this.attach(e), void 0 === i ? this.setPosition(t.row, t.column) : this.setPosition(t, i);
        };

        !function () {
          function a(e, t, i) {
            i = i ? e.column <= t.column : e.column < t.column;
            return e.row < t.row || e.row == t.row && i;
          }

          n.implement(this || _global, r), (this || _global).getPosition = function () {
            return this.$clipPositionToDocument((this || _global).row, (this || _global).column);
          }, (this || _global).getDocument = function () {
            return (this || _global).document;
          }, (this || _global).$insertRight = !1, (this || _global).onChange = function (e) {
            e.start.row == e.end.row && e.start.row != (this || _global).row || e.start.row > (this || _global).row || (e = function (e, t, i) {
              var n = "insert" == e.action,
                  r = (n ? 1 : -1) * (e.end.row - e.start.row),
                  o = (n ? 1 : -1) * (e.end.column - e.start.column),
                  s = e.start,
                  n = n ? s : e.end;
              if (a(t, s, i)) return {
                row: t.row,
                column: t.column
              };
              if (a(n, t, !i)) return {
                row: t.row + r,
                column: t.column + (t.row == n.row ? o : 0)
              };
              return {
                row: s.row,
                column: s.column
              };
            }(e, {
              row: (this || _global).row,
              column: (this || _global).column
            }, (this || _global).$insertRight), this.setPosition(e.row, e.column, !0));
          }, (this || _global).setPosition = function (e, t, i) {
            i = i ? {
              row: e,
              column: t
            } : this.$clipPositionToDocument(e, t);
            (this || _global).row == i.row && (this || _global).column == i.column || (e = {
              row: (this || _global).row,
              column: (this || _global).column
            }, (this || _global).row = i.row, (this || _global).column = i.column, this._signal("change", {
              old: e,
              value: i
            }));
          }, (this || _global).detach = function () {
            (this || _global).document.off("change", (this || _global).$onChange);
          }, (this || _global).attach = function (e) {
            (this || _global).document = e || (this || _global).document, (this || _global).document.on("change", (this || _global).$onChange);
          }, (this || _global).$clipPositionToDocument = function (e, t) {
            var i = {};
            return e >= (this || _global).document.getLength() ? (i.row = Math.max(0, (this || _global).document.getLength() - 1), i.column = (this || _global).document.getLine(i.row).length) : e < 0 ? (i.row = 0, i.column = 0) : (i.row = e, i.column = Math.min((this || _global).document.getLine(i.row).length, Math.max(0, t))), t < 0 && (i.column = 0), i;
          };
        }.call(e.prototype);
      }), ace.define("ace/document", ["require", "exports", "module", "ace/lib/oop", "ace/apply_delta", "ace/lib/event_emitter", "ace/range", "ace/anchor"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).$lines = [""], 0 === e.length ? (this || _global).$lines = [""] : Array.isArray(e) ? this.insertMergedLines({
            row: 0,
            column: 0
          }, e) : this.insert({
            row: 0,
            column: 0
          }, e);
        }

        var r = e("./lib/oop"),
            o = e("./apply_delta").applyDelta,
            s = e("./lib/event_emitter").EventEmitter,
            a = e("./range").Range,
            l = e("./anchor").Anchor;
        !function () {
          r.implement(this || _global, s), (this || _global).setValue = function (e) {
            var t = this.getLength() - 1;
            this.remove(new a(0, 0, t, this.getLine(t).length)), this.insert({
              row: 0,
              column: 0
            }, e);
          }, (this || _global).getValue = function () {
            return this.getAllLines().join(this.getNewLineCharacter());
          }, (this || _global).createAnchor = function (e, t) {
            return new l(this || _global, e, t);
          }, 0 === "aaa".split(/a/).length ? (this || _global).$split = function (e) {
            return e.replace(/\r\n|\r/g, "\n").split("\n");
          } : (this || _global).$split = function (e) {
            return e.split(/\r\n|\r|\n/);
          }, (this || _global).$detectNewLine = function (e) {
            e = e.match(/^.*?(\r\n|\r|\n)/m);
            (this || _global).$autoNewLine = e ? e[1] : "\n", this._signal("changeNewLineMode");
          }, (this || _global).getNewLineCharacter = function () {
            switch ((this || _global).$newLineMode) {
              case "windows":
                return "\r\n";

              case "unix":
                return "\n";

              default:
                return (this || _global).$autoNewLine || "\n";
            }
          }, (this || _global).$autoNewLine = "", (this || _global).$newLineMode = "auto", (this || _global).setNewLineMode = function (e) {
            (this || _global).$newLineMode !== e && ((this || _global).$newLineMode = e, this._signal("changeNewLineMode"));
          }, (this || _global).getNewLineMode = function () {
            return (this || _global).$newLineMode;
          }, (this || _global).isNewLine = function (e) {
            return "\r\n" == e || "\r" == e || "\n" == e;
          }, (this || _global).getLine = function (e) {
            return (this || _global).$lines[e] || "";
          }, (this || _global).getLines = function (e, t) {
            return (this || _global).$lines.slice(e, t + 1);
          }, (this || _global).getAllLines = function () {
            return this.getLines(0, this.getLength());
          }, (this || _global).getLength = function () {
            return (this || _global).$lines.length;
          }, (this || _global).getTextRange = function (e) {
            return this.getLinesForRange(e).join(this.getNewLineCharacter());
          }, (this || _global).getLinesForRange = function (e) {
            var t, i;
            return e.start.row === e.end.row ? t = [this.getLine(e.start.row).substring(e.start.column, e.end.column)] : ((t = this.getLines(e.start.row, e.end.row))[0] = (t[0] || "").substring(e.start.column), i = t.length - 1, e.end.row - e.start.row == i && (t[i] = t[i].substring(0, e.end.column))), t;
          }, (this || _global).insertLines = function (e, t) {
            return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."), this.insertFullLines(e, t);
          }, (this || _global).removeLines = function (e, t) {
            return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."), this.removeFullLines(e, t);
          }, (this || _global).insertNewLine = function (e) {
            return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."), this.insertMergedLines(e, ["", ""]);
          }, (this || _global).insert = function (e, t) {
            return this.getLength() <= 1 && this.$detectNewLine(t), this.insertMergedLines(e, this.$split(t));
          }, (this || _global).insertInLine = function (e, t) {
            var i = this.clippedPos(e.row, e.column),
                e = this.pos(e.row, e.column + t.length);
            return this.applyDelta({
              start: i,
              end: e,
              action: "insert",
              lines: [t]
            }, !0), this.clonePos(e);
          }, (this || _global).clippedPos = function (e, t) {
            var i = this.getLength(),
                i = (void 0 === e ? e = i : e < 0 ? e = 0 : i <= e && (e = i - 1, t = void 0), this.getLine(e));
            return null == t && (t = i.length), {
              row: e,
              column: t = Math.min(Math.max(t, 0), i.length)
            };
          }, (this || _global).clonePos = function (e) {
            return {
              row: e.row,
              column: e.column
            };
          }, (this || _global).pos = function (e, t) {
            return {
              row: e,
              column: t
            };
          }, (this || _global).$clipPosition = function (e) {
            var t = this.getLength();
            return e.row >= t ? (e.row = Math.max(0, t - 1), e.column = this.getLine(t - 1).length) : (e.row = Math.max(0, e.row), e.column = Math.min(Math.max(e.column, 0), this.getLine(e.row).length)), e;
          }, (this || _global).insertFullLines = function (e, t) {
            var i = 0,
                i = (e = Math.min(Math.max(e, 0), this.getLength())) < this.getLength() ? (t = t.concat([""]), 0) : (t = [""].concat(t), (this || _global).$lines[--e].length);
            this.insertMergedLines({
              row: e,
              column: i
            }, t);
          }, (this || _global).insertMergedLines = function (e, t) {
            var e = this.clippedPos(e.row, e.column),
                i = {
              row: e.row + t.length - 1,
              column: (1 == t.length ? e.column : 0) + t[t.length - 1].length
            };
            return this.applyDelta({
              start: e,
              end: i,
              action: "insert",
              lines: t
            }), this.clonePos(i);
          }, (this || _global).remove = function (e) {
            var t = this.clippedPos(e.start.row, e.start.column),
                e = this.clippedPos(e.end.row, e.end.column);
            return this.applyDelta({
              start: t,
              end: e,
              action: "remove",
              lines: this.getLinesForRange({
                start: t,
                end: e
              })
            }), this.clonePos(t);
          }, (this || _global).removeInLine = function (e, t, i) {
            t = this.clippedPos(e, t), e = this.clippedPos(e, i);
            return this.applyDelta({
              start: t,
              end: e,
              action: "remove",
              lines: this.getLinesForRange({
                start: t,
                end: e
              })
            }, !0), this.clonePos(t);
          }, (this || _global).removeFullLines = function (e, t) {
            e = Math.min(Math.max(0, e), this.getLength() - 1);

            var i = (t = Math.min(Math.max(0, t), this.getLength() - 1)) == this.getLength() - 1 && 0 < e,
                n = t < this.getLength() - 1,
                r = i ? e - 1 : e,
                i = i ? this.getLine(r).length : 0,
                o = n ? t + 1 : t,
                n = n ? 0 : this.getLine(o).length,
                r = new a(r, i, o, n),
                i = (this || _global).$lines.slice(e, t + 1);

            return this.applyDelta({
              start: r.start,
              end: r.end,
              action: "remove",
              lines: this.getLinesForRange(r)
            }), i;
          }, (this || _global).removeNewLine = function (e) {
            e < this.getLength() - 1 && 0 <= e && this.applyDelta({
              start: this.pos(e, this.getLine(e).length),
              end: this.pos(e + 1, 0),
              action: "remove",
              lines: ["", ""]
            });
          }, (this || _global).replace = function (e, t) {
            return e instanceof a || (e = a.fromPoints(e.start, e.end)), 0 === t.length && e.isEmpty() ? e.start : t == this.getTextRange(e) ? e.end : (this.remove(e), t ? this.insert(e.start, t) : e.start);
          }, (this || _global).applyDeltas = function (e) {
            for (var t = 0; t < e.length; t++) this.applyDelta(e[t]);
          }, (this || _global).revertDeltas = function (e) {
            for (var t = e.length - 1; 0 <= t; t--) this.revertDelta(e[t]);
          }, (this || _global).applyDelta = function (e, t) {
            var i = "insert" == e.action;
            (i ? e.lines.length <= 1 && !e.lines[0] : !a.comparePoints(e.start, e.end)) || (i && 20000 < e.lines.length ? this.$splitAndapplyLargeDelta(e, 20000) : (o((this || _global).$lines, e, t), this._signal("change", e)));
          }, (this || _global).$safeApplyDelta = function (e) {
            var t = (this || _global).$lines.length;
            ("remove" == e.action && e.start.row < t && e.end.row < t || "insert" == e.action && e.start.row <= t) && this.applyDelta(e);
          }, (this || _global).$splitAndapplyLargeDelta = function (e, t) {
            for (var i = e.lines, n = i.length - t + 1, r = e.start.row, o = e.start.column, s = 0, a = 0; s < n; s = a) {
              a += t - 1;
              var l = i.slice(s, a);
              l.push(""), this.applyDelta({
                start: this.pos(r + s, o),
                end: this.pos(r + a, o = 0),
                action: e.action,
                lines: l
              }, !0);
            }

            e.lines = i.slice(s), e.start.row = r + s, e.start.column = o, this.applyDelta(e, !0);
          }, (this || _global).revertDelta = function (e) {
            this.$safeApplyDelta({
              start: this.clonePos(e.start),
              end: this.clonePos(e.end),
              action: "insert" == e.action ? "remove" : "insert",
              lines: e.lines.slice()
            });
          }, (this || _global).indexToPosition = function (e, t) {
            for (var i = (this || _global).$lines || this.getAllLines(), n = this.getNewLineCharacter().length, r = t || 0, o = i.length; r < o; r++) if ((e -= i[r].length + n) < 0) return {
              row: r,
              column: e + i[r].length + n
            };

            return {
              row: o - 1,
              column: e + i[o - 1].length + n
            };
          }, (this || _global).positionToIndex = function (e, t) {
            for (var i = (this || _global).$lines || this.getAllLines(), n = this.getNewLineCharacter().length, r = 0, o = Math.min(e.row, i.length), s = t || 0; s < o; ++s) r += i[s].length + n;

            return r + e.column;
          };
        }.call(n.prototype), t.Document = n;
      }), ace.define("ace/background_tokenizer", ["require", "exports", "module", "ace/lib/oop", "ace/lib/event_emitter"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          (this || _global).running = !1, (this || _global).lines = [], (this || _global).states = [], (this || _global).currentLine = 0, (this || _global).tokenizer = e;
          var a = this || _global;

          (this || _global).$worker = function () {
            if (a.running) {
              for (var e = new Date(), t = a.currentLine, i = -1, n = a.doc, r = t; a.lines[t];) t++;

              var o = n.getLength(),
                  s = 0;

              for (a.running = !1; t < o;) {
                for (a.$tokenizeRow(t), i = t; t++, a.lines[t];);

                if (++s % 5 == 0 && 20 < new Date() - e) {
                  a.running = setTimeout(a.$worker, 20);
                  break;
                }
              }

              a.currentLine = t, r <= (i = -1 == i ? t : i) && a.fireUpdateEvent(r, i);
            }
          };
        }

        var r = e("./lib/oop"),
            o = e("./lib/event_emitter").EventEmitter;
        !function () {
          r.implement(this || _global, o), (this || _global).setTokenizer = function (e) {
            (this || _global).tokenizer = e, (this || _global).lines = [], (this || _global).states = [], this.start(0);
          }, (this || _global).setDocument = function (e) {
            (this || _global).doc = e, (this || _global).lines = [], (this || _global).states = [], this.stop();
          }, (this || _global).fireUpdateEvent = function (e, t) {
            this._signal("update", {
              data: {
                first: e,
                last: t
              }
            });
          }, (this || _global).start = function (e) {
            (this || _global).currentLine = Math.min(e || 0, (this || _global).currentLine, (this || _global).doc.getLength()), (this || _global).lines.splice((this || _global).currentLine, (this || _global).lines.length), (this || _global).states.splice((this || _global).currentLine, (this || _global).states.length), this.stop(), (this || _global).running = setTimeout((this || _global).$worker, 700);
          }, (this || _global).scheduleStart = function () {
            (this || _global).running || ((this || _global).running = setTimeout((this || _global).$worker, 700));
          }, (this || _global).$updateOnChange = function (e) {
            var t = e.start.row,
                i = e.end.row - t;
            0 == i ? (this || _global).lines[t] = null : "remove" == e.action ? ((this || _global).lines.splice(t, 1 + i, null), (this || _global).states.splice(t, 1 + i, null)) : ((e = Array(1 + i)).unshift(t, 1), (this || _global).lines.splice.apply((this || _global).lines, e), (this || _global).states.splice.apply((this || _global).states, e)), (this || _global).currentLine = Math.min(t, (this || _global).currentLine, (this || _global).doc.getLength()), this.stop();
          }, (this || _global).stop = function () {
            (this || _global).running && clearTimeout((this || _global).running), (this || _global).running = !1;
          }, (this || _global).getTokens = function (e) {
            return (this || _global).lines[e] || this.$tokenizeRow(e);
          }, (this || _global).getState = function (e) {
            return (this || _global).currentLine == e && this.$tokenizeRow(e), (this || _global).states[e] || "start";
          }, (this || _global).$tokenizeRow = function (e) {
            var t = (this || _global).doc.getLine(e),
                i = (this || _global).states[e - 1],
                t = (this || _global).tokenizer.getLineTokens(t, i, e);

            return (this || _global).states[e] + "" != t.state + "" ? ((this || _global).states[e] = t.state, (this || _global).lines[e + 1] = null, (this || _global).currentLine > e + 1 && ((this || _global).currentLine = e + 1)) : (this || _global).currentLine == e && ((this || _global).currentLine = e + 1), (this || _global).lines[e] = t.tokens;
          };
        }.call(n.prototype), t.BackgroundTokenizer = n;
      }), ace.define("ace/search_highlight", ["require", "exports", "module", "ace/lib/lang", "ace/lib/oop", "ace/range"], function (e, t, i) {
        "use strict";

        function n(e, t, i) {
          this.setRegexp(e), (this || _global).clazz = t, (this || _global).type = i || "text";
        }

        var c = e("./lib/lang"),
            h = (e("./lib/oop"), e("./range").Range);
        !function () {
          (this || _global).MAX_RANGES = 500, (this || _global).setRegexp = function (e) {
            (this || _global).regExp + "" != e + "" && ((this || _global).regExp = e, (this || _global).cache = []);
          }, (this || _global).update = function (e, t, i, n) {
            if ((this || _global).regExp) for (var r = n.firstRow, o = n.lastRow, s = r; s <= o; s++) {
              var a = (this || _global).cache[s];
              null == a && (a = (a = (a = c.getMatchOffsets(i.getLine(s), (this || _global).regExp)).length > (this || _global).MAX_RANGES ? a.slice(0, (this || _global).MAX_RANGES) : a).map(function (e) {
                return new h(s, e.offset, s, e.offset + e.length);
              }), (this || _global).cache[s] = a.length ? a : "");

              for (var l = a.length; l--;) t.drawSingleLineMarker(e, a[l].toScreenRange(i), (this || _global).clazz, n);
            }
          };
        }.call(n.prototype), t.SearchHighlight = n;
      }), ace.define("ace/edit_session/fold_line", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        var n = e("../range").Range;

        function r(e, t) {
          (this || _global).foldData = e, Array.isArray(t) ? (this || _global).folds = t : t = (this || _global).folds = [t];
          e = t[t.length - 1];
          (this || _global).range = new n(t[0].start.row, t[0].start.column, e.end.row, e.end.column), (this || _global).start = (this || _global).range.start, (this || _global).end = (this || _global).range.end, (this || _global).folds.forEach(function (e) {
            e.setFoldLine(this || _global);
          }, this || _global);
        }

        !function () {
          (this || _global).shiftRow = function (t) {
            (this || _global).start.row += t, (this || _global).end.row += t, (this || _global).folds.forEach(function (e) {
              e.start.row += t, e.end.row += t;
            });
          }, (this || _global).addFold = function (e) {
            if (e.sameRow) {
              if (e.start.row < (this || _global).startRow || e.endRow > (this || _global).endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
              (this || _global).folds.push(e), (this || _global).folds.sort(function (e, t) {
                return -e.range.compareEnd(t.start.row, t.start.column);
              }), 0 < (this || _global).range.compareEnd(e.start.row, e.start.column) ? ((this || _global).end.row = e.end.row, (this || _global).end.column = e.end.column) : (this || _global).range.compareStart(e.end.row, e.end.column) < 0 && ((this || _global).start.row = e.start.row, (this || _global).start.column = e.start.column);
            } else if (e.start.row == (this || _global).end.row) (this || _global).folds.push(e), (this || _global).end.row = e.end.row, (this || _global).end.column = e.end.column;else {
              if (e.end.row != (this || _global).start.row) throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
              (this || _global).folds.unshift(e), (this || _global).start.row = e.start.row, (this || _global).start.column = e.start.column;
            }

            e.foldLine = this || _global;
          }, (this || _global).containsRow = function (e) {
            return e >= (this || _global).start.row && e <= (this || _global).end.row;
          }, (this || _global).walk = function (e, t, i) {
            var n,
                r,
                o = 0,
                s = (this || _global).folds,
                a = !0;
            null == t && (t = (this || _global).end.row, i = (this || _global).end.column);

            for (var l = 0; l < s.length; l++) {
              if (-1 == (r = (n = s[l]).range.compareStart(t, i))) return void e(null, t, i, o, a);
              if (!e(null, n.start.row, n.start.column, o, a) && e(n.placeholder, n.start.row, n.start.column, o) || 0 === r) return;
              a = !n.sameRow, o = n.end.column;
            }

            e(null, t, i, o, a);
          }, (this || _global).getNextFoldTo = function (e, t) {
            for (var i, n, r = 0; r < (this || _global).folds.length; r++) {
              if (-1 == (n = (i = (this || _global).folds[r]).range.compareEnd(e, t))) return {
                fold: i,
                kind: "after"
              };
              if (0 === n) return {
                fold: i,
                kind: "inside"
              };
            }

            return null;
          }, (this || _global).addRemoveChars = function (e, t, i) {
            var n,
                r = this.getNextFoldTo(e, t);
            if (r) if (n = r.fold, "inside" == r.kind && n.start.column != t && n.start.row != e) window.console && window.console.log(e, t, n);else if (n.start.row == e) {
              var o,
                  s = (o = (this || _global).folds).indexOf(n);

              for (0 === s && ((this || _global).start.column += i); s < o.length; s++) {
                if ((n = o[s]).start.column += i, !n.sameRow) return;
                n.end.column += i;
              }

              (this || _global).end.column += i;
            }
          }, (this || _global).split = function (e, t) {
            e = this.getNextFoldTo(e, t);
            if (!e || "inside" == e.kind) return null;
            var t = e.fold,
                e = (this || _global).folds,
                i = (this || _global).foldData,
                t = e.indexOf(t),
                n = e[t - 1],
                n = ((this || _global).end.row = n.end.row, (this || _global).end.column = n.end.column, new r(i, e = e.splice(t, e.length - t)));
            return i.splice(i.indexOf(this || _global) + 1, 0, n), n;
          }, (this || _global).merge = function (e) {
            for (var t = e.folds, i = 0; i < t.length; i++) this.addFold(t[i]);

            var n = (this || _global).foldData;
            n.splice(n.indexOf(e), 1);
          }, (this || _global).toString = function () {
            var t = [(this || _global).range.toString() + ": ["];
            return (this || _global).folds.forEach(function (e) {
              t.push("  " + e.toString());
            }), t.push("]"), t.join("\n");
          }, (this || _global).idxToPosition = function (e) {
            for (var t = 0, i = 0; i < (this || _global).folds.length; i++) {
              var n = (this || _global).folds[i];
              if ((e -= n.start.column - t) < 0) return {
                row: n.start.row,
                column: n.start.column + e
              };
              if ((e -= n.placeholder.length) < 0) return n.start;
              t = n.end.column;
            }

            return {
              row: (this || _global).end.row,
              column: (this || _global).end.column + e
            };
          };
        }.call(r.prototype), t.FoldLine = r;
      }), ace.define("ace/range_list", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).ranges = [], (this || _global).$bias = 1;
        }

        var a = e("./range").Range.comparePoints;
        !function () {
          (this || _global).comparePoints = a, (this || _global).pointIndex = function (e, t, i) {
            for (var n = (this || _global).ranges, r = i || 0; r < n.length; r++) {
              var o = n[r],
                  s = a(e, o.end);
              if (0 < s) ;else return o = a(e, o.start), 0 === s ? t && 0 !== o ? -r - 2 : r : 0 < o || 0 === o && !t ? r : -r - 1;
            }

            return -r - 1;
          }, (this || _global).add = function (e) {
            var t = !e.isEmpty(),
                i = this.pointIndex(e.start, t),
                t = this.pointIndex(e.end, t, i = i < 0 ? -i - 1 : i);
            return t < 0 ? t = -t - 1 : t++, (this || _global).ranges.splice(i, t - i, e);
          }, (this || _global).addList = function (e) {
            for (var t = [], i = e.length; i--;) t.push.apply(t, this.add(e[i]));

            return t;
          }, (this || _global).substractPoint = function (e) {
            e = this.pointIndex(e);
            if (0 <= e) return (this || _global).ranges.splice(e, 1);
          }, (this || _global).merge = function () {
            for (var e = [], t = (this || _global).ranges, i = (t = t.sort(function (e, t) {
              return a(e.start, t.start);
            }))[0], n = 1; n < t.length; n++) {
              var r = i,
                  i = t[n],
                  o = a(r.end, i.start);
              o < 0 || (0 != o || r.isEmpty() || i.isEmpty()) && (a(r.end, i.end) < 0 && (r.end.row = i.end.row, r.end.column = i.end.column), t.splice(n, 1), e.push(i), i = r, n--);
            }

            return (this || _global).ranges = t, e;
          }, (this || _global).contains = function (e, t) {
            return 0 <= this.pointIndex({
              row: e,
              column: t
            });
          }, (this || _global).containsPoint = function (e) {
            return 0 <= this.pointIndex(e);
          }, (this || _global).rangeAtPoint = function (e) {
            e = this.pointIndex(e);
            if (0 <= e) return (this || _global).ranges[e];
          }, (this || _global).clipRows = function (e, t) {
            var i = (this || _global).ranges;
            if (i[0].start.row > t || i[i.length - 1].start.row < e) return [];

            for (var e = this.pointIndex({
              row: e,
              column: 0
            }), n = this.pointIndex({
              row: t,
              column: 0
            }, e = e < 0 ? -e - 1 : e), r = (n < 0 && (n = -n - 1), []), o = e; o < n; o++) r.push(i[o]);

            return r;
          }, (this || _global).removeAll = function () {
            return (this || _global).ranges.splice(0, (this || _global).ranges.length);
          }, (this || _global).attach = function (e) {
            (this || _global).session && this.detach(), (this || _global).session = e, (this || _global).onChange = (this || _global).$onChange.bind(this || _global), (this || _global).session.on("change", (this || _global).onChange);
          }, (this || _global).detach = function () {
            (this || _global).session && ((this || _global).session.removeListener("change", (this || _global).onChange), (this || _global).session = null);
          }, (this || _global).$onChange = function (e) {
            for (var t = e.start, i = e.end, n = t.row, r = i.row, o = (this || _global).ranges, s = 0, a = o.length; s < a && !((h = o[s]).end.row >= n); s++);

            if ("insert" == e.action) for (var l = r - n, c = -t.column + i.column; s < a; s++) {
              if ((h = o[s]).start.row > n) break;
              h.start.row == n && h.start.column >= t.column && (h.start.column == t.column && (this || _global).$bias <= 0 || (h.start.column += c, h.start.row += l)), h.end.row == n && h.end.column >= t.column && (h.end.column == t.column && (this || _global).$bias < 0 || (h.end.column == t.column && 0 < c && s < a - 1 && h.end.column > h.start.column && h.end.column == o[s + 1].start.column && (h.end.column -= c), h.end.column += c, h.end.row += l));
            } else for (var h, l = n - r, c = t.column - i.column; s < a; s++) {
              if ((h = o[s]).start.row > r) break;
              h.end.row < r && (n < h.end.row || n == h.end.row && t.column < h.end.column) ? (h.end.row = n, h.end.column = t.column) : h.end.row == r ? h.end.column <= i.column ? (l || h.end.column > t.column) && (h.end.column = t.column, h.end.row = t.row) : (h.end.column += c, h.end.row += l) : h.end.row > r && (h.end.row += l), h.start.row < r && (n < h.start.row || n == h.start.row && t.column < h.start.column) ? (h.start.row = n, h.start.column = t.column) : h.start.row == r ? h.start.column <= i.column ? (l || h.start.column > t.column) && (h.start.column = t.column, h.start.row = t.row) : (h.start.column += c, h.start.row += l) : h.start.row > r && (h.start.row += l);
            }
            if (0 != l && s < a) for (; s < a; s++) (h = o[s]).start.row += l, h.end.row += l;
          };
        }.call(n.prototype), t.RangeList = n;
      }), ace.define("ace/edit_session/fold", ["require", "exports", "module", "ace/range_list", "ace/lib/oop"], function (e, t, i) {
        "use strict";

        var n = e("../range_list").RangeList,
            e = e("../lib/oop"),
            r = t.Fold = function (e, t) {
          (this || _global).foldLine = null, (this || _global).placeholder = t, (this || _global).range = e, (this || _global).start = e.start, (this || _global).end = e.end, (this || _global).sameRow = e.start.row == e.end.row, (this || _global).subFolds = (this || _global).ranges = [];
        };

        function d(e, t) {
          e.row -= t.row, 0 == e.row && (e.column -= t.column);
        }

        function o(e, t) {
          0 == e.row && (e.column += t.column), e.row += t.row;
        }

        e.inherits(r, n), function () {
          (this || _global).toString = function () {
            return "\"" + (this || _global).placeholder + "\" " + (this || _global).range.toString();
          }, (this || _global).setFoldLine = function (t) {
            (this || _global).foldLine = t, (this || _global).subFolds.forEach(function (e) {
              e.setFoldLine(t);
            });
          }, (this || _global).clone = function () {
            var e = (this || _global).range.clone(),
                t = new r(e, (this || _global).placeholder);

            return (this || _global).subFolds.forEach(function (e) {
              t.subFolds.push(e.clone());
            }), t.collapseChildren = (this || _global).collapseChildren, t;
          }, (this || _global).addSubFold = function (e) {
            if (!(this || _global).range.isEqual(e)) {
              o = e, s = (this || _global).start, d(o.start, s), d(o.end, s);

              for (var t = e.start.row, i = e.start.column, n = 0, r = -1; n < (this || _global).subFolds.length && 1 == (r = (this || _global).subFolds[n].range.compare(t, i)); n++);

              var o = (this || _global).subFolds[n],
                  s = 0;

              if (0 == r) {
                if (o.range.containsRange(e)) return o.addSubFold(e);
                s = 1;
              }

              for (var t = e.range.end.row, i = e.range.end.column, a = n, r = -1; a < (this || _global).subFolds.length && 1 == (r = (this || _global).subFolds[a].range.compare(t, i)); a++);

              0 == r && a++;

              for (var l = (this || _global).subFolds.splice(n, a - n, e), c = 0 == r ? l.length - 1 : l.length, h = s; h < c; h++) e.addSubFold(l[h]);

              return e.setFoldLine((this || _global).foldLine), e;
            }
          }, (this || _global).restoreRange = function (e) {
            return e = e, t = (this || _global).start, o(e.start, t), void o(e.end, t);
            var t;
          };
        }.call(r.prototype);
      }), ace.define("ace/edit_session/folding", ["require", "exports", "module", "ace/range", "ace/edit_session/fold_line", "ace/edit_session/fold", "ace/token_iterator"], function (e, t, i) {
        "use strict";

        var c = e("../range").Range,
            u = e("./fold_line").FoldLine,
            g = e("./fold").Fold,
            h = e("../token_iterator").TokenIterator;

        t.Folding = function () {
          (this || _global).getFoldAt = function (e, t, i) {
            var n = this.getFoldLine(e);
            if (!n) return null;

            for (var r = n.folds, o = 0; o < r.length; o++) {
              var s = r[o].range;
              if (s.contains(e, t) && (1 != i || !s.isEnd(e, t) || s.isEmpty()) && (-1 != i || !s.isStart(e, t) || s.isEmpty())) return r[o];
            }
          }, (this || _global).getFoldsInRange = function (e) {
            var t = e.start,
                i = e.end,
                n = (this || _global).$foldData,
                r = [];
            t.column += 1, --i.column;

            for (var o = 0; o < n.length; o++) {
              var s = n[o].range.compareRange(e);

              if (2 != s) {
                if (-2 == s) break;

                for (var a = n[o].folds, l = 0; l < a.length; l++) {
                  var c = a[l];
                  if (-2 == (s = c.range.compareRange(e))) break;

                  if (2 != s) {
                    if (42 == s) break;
                    r.push(c);
                  }
                }
              }
            }

            return --t.column, i.column += 1, r;
          }, (this || _global).getFoldsInRangeList = function (e) {
            var t;
            return Array.isArray(e) ? (t = [], e.forEach(function (e) {
              t = t.concat(this.getFoldsInRange(e));
            }, this || _global)) : t = this.getFoldsInRange(e), t;
          }, (this || _global).getAllFolds = function () {
            for (var e = [], t = (this || _global).$foldData, i = 0; i < t.length; i++) for (var n = 0; n < t[i].folds.length; n++) e.push(t[i].folds[n]);

            return e;
          }, (this || _global).getFoldStringAt = function (e, t, i, n) {
            if (!(n = n || this.getFoldLine(e))) return null;

            for (var r, o = {
              end: {
                column: 0
              }
            }, s = 0; s < n.folds.length; s++) {
              var a,
                  l = (a = n.folds[s]).range.compareEnd(e, t);

              if (-1 == l) {
                r = this.getLine(a.start.row).substring(o.end.column, a.start.column);
                break;
              }

              if (0 === l) return null;
              o = a;
            }

            return r = r || this.getLine(a.start.row).substring(o.end.column), -1 == i ? r.substring(0, t - o.end.column) : 1 == i ? r.substring(t - o.end.column) : r;
          }, (this || _global).getFoldLine = function (e, t) {
            var i = (this || _global).$foldData,
                n = 0;

            for (-1 == (n = t ? i.indexOf(t) : n) && (n = 0); n < i.length; n++) {
              var r = i[n];
              if (r.start.row <= e && r.end.row >= e) return r;
              if (r.end.row > e) return null;
            }

            return null;
          }, (this || _global).getNextFoldLine = function (e, t) {
            var i = (this || _global).$foldData,
                n = 0;

            for (-1 == (n = t ? i.indexOf(t) : n) && (n = 0); n < i.length; n++) {
              var r = i[n];
              if (r.end.row >= e) return r;
            }

            return null;
          }, (this || _global).getFoldedRowCount = function (e, t) {
            for (var i = (this || _global).$foldData, n = t - e + 1, r = 0; r < i.length; r++) {
              var o = i[r],
                  s = o.end.row,
                  o = o.start.row;

              if (t <= s) {
                o < t && (e <= o ? n -= t - o : n = 0);
                break;
              }

              e <= s && (n -= e <= o ? s - o : s - e + 1);
            }

            return n;
          }, (this || _global).$addFoldLine = function (e) {
            return (this || _global).$foldData.push(e), (this || _global).$foldData.sort(function (e, t) {
              return e.start.row - t.start.row;
            }), e;
          }, (this || _global).addFold = function (e, t) {
            var i,
                n = (this || _global).$foldData,
                r = !1,
                o = (e instanceof g ? i = e : (i = new g(t, e)).collapseChildren = t.collapseChildren, this.$clipRangeToDocument(i.range), i.start.row),
                e = i.start.column,
                s = i.end.row,
                t = i.end.column,
                a = this.getFoldAt(o, e, 1),
                l = this.getFoldAt(s, t, -1);
            if (a && l == a) return a.addSubFold(i);
            a && !a.range.isStart(o, e) && this.removeFold(a), l && !l.range.isEnd(s, t) && this.removeFold(l);
            e = this.getFoldsInRange(i.range);
            0 < e.length && (this.removeFolds(e), i.collapseChildren || e.forEach(function (e) {
              i.addSubFold(e);
            }));

            for (var c = 0; c < n.length; c++) {
              var h = n[c];

              if (s == h.start.row) {
                h.addFold(i), r = !0;
                break;
              }

              if (o == h.end.row) {
                if (h.addFold(i), r = !0, !i.sameRow) {
                  var d = n[c + 1];

                  if (d && d.start.row == s) {
                    h.merge(d);
                    break;
                  }
                }

                break;
              }

              if (s <= h.start.row) break;
            }

            return r || (h = this.$addFoldLine(new u((this || _global).$foldData, i))), (this || _global).$useWrapMode ? this.$updateWrapData(h.start.row, h.start.row) : this.$updateRowLengthCache(h.start.row, h.start.row), (this || _global).$modified = !0, this._signal("changeFold", {
              data: i,
              action: "add"
            }), i;
          }, (this || _global).addFolds = function (e) {
            e.forEach(function (e) {
              this.addFold(e);
            }, this || _global);
          }, (this || _global).removeFold = function (e) {
            var t = e.foldLine,
                i = t.start.row,
                n = t.end.row,
                r = (this || _global).$foldData,
                o = t.folds;
            1 == o.length ? r.splice(r.indexOf(t), 1) : t.range.isEnd(e.end.row, e.end.column) ? (o.pop(), t.end.row = o[o.length - 1].end.row, t.end.column = o[o.length - 1].end.column) : t.range.isStart(e.start.row, e.start.column) ? (o.shift(), t.start.row = o[0].start.row, t.start.column = o[0].start.column) : e.sameRow ? o.splice(o.indexOf(e), 1) : ((o = (r = t.split(e.start.row, e.start.column)).folds).shift(), r.start.row = o[0].start.row, r.start.column = o[0].start.column), (this || _global).$updating || ((this || _global).$useWrapMode ? this.$updateWrapData(i, n) : this.$updateRowLengthCache(i, n)), (this || _global).$modified = !0, this._signal("changeFold", {
              data: e,
              action: "remove"
            });
          }, (this || _global).removeFolds = function (e) {
            for (var t = [], i = 0; i < e.length; i++) t.push(e[i]);

            t.forEach(function (e) {
              this.removeFold(e);
            }, this || _global), (this || _global).$modified = !0;
          }, (this || _global).expandFold = function (t) {
            this.removeFold(t), t.subFolds.forEach(function (e) {
              t.restoreRange(e), this.addFold(e);
            }, this || _global), 0 < t.collapseChildren && this.foldAll(t.start.row + 1, t.end.row, t.collapseChildren - 1), t.subFolds = [];
          }, (this || _global).expandFolds = function (e) {
            e.forEach(function (e) {
              this.expandFold(e);
            }, this || _global);
          }, (this || _global).unfold = function (e, t) {
            var i;
            if (null == e) i = new c(0, 0, this.getLength(), 0), null == t && (t = !0);else if ("number" == typeof e) i = new c(e, 0, e, this.getLine(e).length);else if ("row" in e) i = c.fromPoints(e, e);else {
              if (Array.isArray(e)) return n = [], e.forEach(function (e) {
                n = n.concat(this.unfold(e));
              }, this || _global), n;
              i = e;
            }

            for (var n, e = n = this.getFoldsInRangeList(i); 1 == n.length && c.comparePoints(n[0].start, i.start) < 0 && 0 < c.comparePoints(n[0].end, i.end);) this.expandFolds(n), n = this.getFoldsInRangeList(i);

            if (0 != t ? this.removeFolds(n) : this.expandFolds(n), e.length) return e;
          }, (this || _global).isRowFolded = function (e, t) {
            return !!this.getFoldLine(e, t);
          }, (this || _global).getRowFoldEnd = function (e, t) {
            t = this.getFoldLine(e, t);
            return t ? t.end.row : e;
          }, (this || _global).getRowFoldStart = function (e, t) {
            t = this.getFoldLine(e, t);
            return t ? t.start.row : e;
          }, (this || _global).getFoldDisplayLine = function (e, t, i, r, o) {
            null == r && (r = e.start.row), null == o && (o = 0), null == t && (t = e.end.row), null == i && (i = this.getLine(t).length);
            var s = (this || _global).doc,
                a = "";
            return e.walk(function (e, t, i, n) {
              if (!(t < r)) {
                if (t == r) {
                  if (i < o) return;
                  n = Math.max(o, n);
                }

                a += null != e ? e : s.getLine(t).substring(n, i);
              }
            }, t, i), a;
          }, (this || _global).getDisplayLine = function (e, t, i, n) {
            var r = this.getFoldLine(e);
            return r ? this.getFoldDisplayLine(r, e, t, i, n) : (r = (this || _global).doc.getLine(e)).substring(n || 0, t || r.length);
          }, (this || _global).$cloneFoldData = function () {
            var t = [];
            return t = (this || _global).$foldData.map(function (e) {
              e = e.folds.map(function (e) {
                return e.clone();
              });
              return new u(t, e);
            });
          }, (this || _global).toggleFold = function (e) {
            var t = (this || _global).selection.getRange();

            if (t.isEmpty()) {
              var i,
                  n = t.start;
              if (i = this.getFoldAt(n.row, n.column)) return void this.expandFold(i);
              (r = this.findMatchingBracket(n)) ? 1 == t.comparePoint(r) ? t.end = r : (t.start = r, t.start.column++, t.end.column--) : (r = this.findMatchingBracket({
                row: n.row,
                column: n.column + 1
              })) ? (1 == t.comparePoint(r) ? t.end = r : t.start = r, t.start.column++) : t = this.getCommentFoldRange(n.row, n.column) || t;
            } else {
              var r = this.getFoldsInRange(t);
              if (e && r.length) return void this.expandFolds(r);
              1 == r.length && (i = r[0]);
            }

            if ((i = i || this.getFoldAt(t.start.row, t.start.column)) && i.range.toString() == t.toString()) this.expandFold(i);else {
              n = "...";

              if (!t.isMultiLine()) {
                if ((n = this.getTextRange(t)).length < 4) return;
                n = n.trim().substring(0, 2) + "..";
              }

              this.addFold(n, t);
            }
          }, (this || _global).getCommentFoldRange = function (e, t, i) {
            var n = new h(this || _global, e, t),
                r = n.getCurrentToken(),
                o = r && r.type;

            if (r && /^comment|string/.test(o)) {
              "comment" == (o = o.match(/comment|string/)[0]) && (o += "|doc-start");
              var s = new RegExp(o),
                  o = new c();

              if (1 != i) {
                for (; (r = n.stepBackward()) && s.test(r.type););

                n.stepForward();
              }

              if (o.start.row = n.getCurrentTokenRow(), o.start.column = n.getCurrentTokenColumn() + 2, n = new h(this || _global, e, t), -1 != i) {
                var a = -1;

                do {
                  if (r = n.stepForward(), -1 == a) {
                    var l = this.getState(n.$row);
                    s.test(l) || (a = n.$row);
                  } else if (n.$row > a) break;
                } while (r && s.test(r.type));

                r = n.stepBackward();
              } else r = n.getCurrentToken();

              return o.end.row = n.getCurrentTokenRow(), o.end.column = n.getCurrentTokenColumn() + r.value.length - 2, o;
            }
          }, (this || _global).foldAll = function (e, t, i, n) {
            null == i && (i = 100000);
            var r = (this || _global).foldWidgets;

            if (r) {
              t = t || this.getLength();

              for (var o, s = e = e || 0; s < t; s++) null == r[s] && (r[s] = this.getFoldWidget(s)), "start" != r[s] || n && !n(s) || (o = this.getFoldWidgetRange(s)) && o.isMultiLine() && o.end.row <= t && o.start.row >= e && (s = o.end.row, o.collapseChildren = i, this.addFold("...", o));
            }
          }, (this || _global).foldToLevel = function (e) {
            for (this.foldAll(); 0 < e--;) this.unfold(null, !1);
          }, (this || _global).foldAllComments = function () {
            var r = this || _global;
            this.foldAll(null, null, null, function (e) {
              for (var t = r.getTokens(e), i = 0; i < t.length; i++) {
                var n = t[i];
                if ("text" != n.type || !/^\s+$/.test(n.value)) return !!/comment/.test(n.type);
              }
            });
          }, (this || _global).$foldStyles = {
            manual: 1,
            markbegin: 1,
            markbeginend: 1
          }, (this || _global).$foldStyle = "markbegin", (this || _global).setFoldStyle = function (e) {
            if (!(this || _global).$foldStyles[e]) throw new Error("invalid fold style: " + e + "[" + Object.keys((this || _global).$foldStyles).join(", ") + "]");
            (this || _global).$foldStyle != e && ("manual" == ((this || _global).$foldStyle = e) && this.unfold(), e = (this || _global).$foldMode, this.$setFolding(null), this.$setFolding(e));
          }, (this || _global).$setFolding = function (e) {
            (this || _global).$foldMode != e && ((this || _global).$foldMode = e, this.off("change", (this || _global).$updateFoldWidgets), this.off("tokenizerUpdate", (this || _global).$tokenizerUpdateFoldWidgets), this._signal("changeAnnotation"), e && "manual" != (this || _global).$foldStyle ? ((this || _global).foldWidgets = [], (this || _global).getFoldWidget = e.getFoldWidget.bind(e, this || _global, (this || _global).$foldStyle), (this || _global).getFoldWidgetRange = e.getFoldWidgetRange.bind(e, this || _global, (this || _global).$foldStyle), (this || _global).$updateFoldWidgets = (this || _global).updateFoldWidgets.bind(this || _global), (this || _global).$tokenizerUpdateFoldWidgets = (this || _global).tokenizerUpdateFoldWidgets.bind(this || _global), this.on("change", (this || _global).$updateFoldWidgets), this.on("tokenizerUpdate", (this || _global).$tokenizerUpdateFoldWidgets)) : (this || _global).foldWidgets = null);
          }, (this || _global).getParentFoldRangeData = function (e, t) {
            var i = (this || _global).foldWidgets;
            if (!i || t && i[e]) return {};

            for (var n = e - 1; 0 <= n;) {
              var r = i[n];

              if ("start" == (r = null == r ? i[n] = this.getFoldWidget(n) : r)) {
                var o = this.getFoldWidgetRange(n),
                    s = s || o;
                if (o && o.end.row >= e) break;
              }

              n--;
            }

            return {
              range: -1 !== n && o,
              firstRange: s
            };
          }, (this || _global).onFoldWidgetClick = function (e, t) {
            var i = {
              children: (t = t.domEvent).shiftKey,
              all: t.ctrlKey || t.metaKey,
              siblings: t.altKey
            };
            this.$toggleFoldWidget(e, i) || (e = t.target || t.srcElement) && /ace_fold-widget/.test(e.className) && (e.className += " ace_invalid");
          }, (this || _global).$toggleFoldWidget = function (e, t) {
            if ((this || _global).getFoldWidget) {
              var i = this.getFoldWidget(e),
                  n = this.getLine(e),
                  i = "end" === i ? -1 : 1,
                  n = this.getFoldAt(e, -1 == i ? 0 : n.length, i);
              if (n) return t.children || t.all ? this.removeFold(n) : this.expandFold(n), n;
              var r,
                  o,
                  i = this.getFoldWidgetRange(e, !0);
              return i && !i.isMultiLine() && (n = this.getFoldAt(i.start.row, i.start.column, 1)) && i.isEqual(n.range) ? (this.removeFold(n), n) : (t.siblings ? ((n = this.getParentFoldRangeData(e)).range && (r = n.range.start.row + 1, o = n.range.end.row), this.foldAll(r, o, t.all ? 10000 : 0)) : t.children ? (o = i ? i.end.row : this.getLength(), this.foldAll(e + 1, o, t.all ? 10000 : 0)) : i && (t.all && (i.collapseChildren = 10000), this.addFold("...", i)), i);
            }
          }, (this || _global).toggleFoldWidget = function (e) {
            var t,
                i = (this || _global).selection.getCursor().row;

            i = this.getRowFoldStart(i), this.$toggleFoldWidget(i, {}) || (t = (t = this.getParentFoldRangeData(i, !0)).range || t.firstRange) && (i = t.start.row, (i = this.getFoldAt(i, this.getLine(i).length, 1)) ? this.removeFold(i) : this.addFold("...", t));
          }, (this || _global).updateFoldWidgets = function (e) {
            var t = e.start.row,
                i = e.end.row - t;
            0 == i ? (this || _global).foldWidgets[t] = null : "remove" == e.action ? (this || _global).foldWidgets.splice(t, 1 + i, null) : ((e = Array(1 + i)).unshift(t, 1), (this || _global).foldWidgets.splice.apply((this || _global).foldWidgets, e));
          }, (this || _global).tokenizerUpdateFoldWidgets = function (e) {
            e = e.data;
            e.first != e.last && (this || _global).foldWidgets.length > e.first && (this || _global).foldWidgets.splice(e.first, (this || _global).foldWidgets.length);
          };
        };
      }), ace.define("ace/edit_session/bracket_match", ["require", "exports", "module", "ace/token_iterator", "ace/range"], function (e, t, i) {
        "use strict";

        var d = e("../token_iterator").TokenIterator,
            a = e("../range").Range;

        t.BracketMatch = function () {
          (this || _global).findMatchingBracket = function (e, t) {
            if (0 == e.column) return null;
            t = t || this.getLine(e.row).charAt(e.column - 1);
            if ("" == t) return null;
            t = t.match(/([\(\[\{])|([\)\]\}])/);
            return t ? t[1] ? this.$findClosingBracket(t[1], e) : this.$findOpeningBracket(t[2], e) : null;
          }, (this || _global).getBracketRange = function (e) {
            var t,
                i,
                n = this.getLine(e.row),
                r = !0,
                o = n.charAt(e.column - 1),
                s = o && o.match(/([\(\[\{])|([\)\]\}])/);
            if (s || (o = n.charAt(e.column), e = {
              row: e.row,
              column: e.column + 1
            }, s = o && o.match(/([\(\[\{])|([\)\]\}])/), r = !1), !s) return null;

            if (s[1]) {
              if (!(i = this.$findClosingBracket(s[1], e))) return null;
              t = a.fromPoints(e, i), r || (t.end.column++, t.start.column--), t.cursor = t.end;
            } else {
              if (!(i = this.$findOpeningBracket(s[2], e))) return null;
              t = a.fromPoints(i, e), r || (t.start.column++, t.end.column--), t.cursor = t.start;
            }

            return t;
          }, (this || _global).getMatchingBracketRanges = function (e) {
            var t = this.getLine(e.row),
                i = t.charAt(e.column - 1),
                n = i && i.match(/([\(\[\{])|([\)\]\}])/);
            if (n || (i = t.charAt(e.column), e = {
              row: e.row,
              column: e.column + 1
            }, n = i && i.match(/([\(\[\{])|([\)\]\}])/)), !n) return null;
            t = new a(e.row, e.column - 1, e.row, e.column), i = n[1] ? this.$findClosingBracket(n[1], e) : this.$findOpeningBracket(n[2], e);
            return i ? [t, new a(i.row, i.column, i.row, i.column + 1)] : [t];
          }, (this || _global).$brackets = {
            ")": "(",
            "(": ")",
            "]": "[",
            "[": "]",
            "{": "}",
            "}": "{",
            "<": ">",
            ">": "<"
          }, (this || _global).$findOpeningBracket = function (e, t, i) {
            var n = (this || _global).$brackets[e],
                r = 1,
                o = new d(this || _global, t.row, t.column),
                s = o.getCurrentToken();

            if (s = s || o.stepForward()) {
              i = i || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)") + ")+");

              for (var a = t.column - o.getCurrentTokenColumn() - 2, l = s.value;;) {
                for (; 0 <= a;) {
                  var c = l.charAt(a);

                  if (c == n) {
                    if (0 == --r) return {
                      row: o.getCurrentTokenRow(),
                      column: a + o.getCurrentTokenColumn()
                    };
                  } else c == e && (r += 1);

                  --a;
                }

                for (; (s = o.stepBackward()) && !i.test(s.type););

                if (null == s) break;
                a = (l = s.value).length - 1;
              }

              return null;
            }
          }, (this || _global).$findClosingBracket = function (e, t, i) {
            var n = (this || _global).$brackets[e],
                r = 1,
                o = new d(this || _global, t.row, t.column),
                s = o.getCurrentToken();

            if (s = s || o.stepForward()) {
              i = i || new RegExp("(\\.?" + s.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)") + ")+");

              for (var a = t.column - o.getCurrentTokenColumn();;) {
                for (var l = s.value, c = l.length; a < c;) {
                  var h = l.charAt(a);

                  if (h == n) {
                    if (0 == --r) return {
                      row: o.getCurrentTokenRow(),
                      column: a + o.getCurrentTokenColumn()
                    };
                  } else h == e && (r += 1);

                  a += 1;
                }

                for (; (s = o.stepForward()) && !i.test(s.type););

                if (null == s) break;
                a = 0;
              }

              return null;
            }
          };
        };
      }), ace.define("ace/edit_session", ["require", "exports", "module", "ace/lib/oop", "ace/lib/lang", "ace/bidihandler", "ace/config", "ace/lib/event_emitter", "ace/selection", "ace/mode/text", "ace/range", "ace/document", "ace/background_tokenizer", "ace/search_highlight", "ace/edit_session/folding", "ace/edit_session/bracket_match"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          (this || _global).$breakpoints = [], (this || _global).$decorations = [], (this || _global).$frontMarkers = {}, (this || _global).$backMarkers = {}, (this || _global).$markerId = 1, (this || _global).$undoSelect = !0, (this || _global).$foldData = [], (this || _global).id = "session" + ++n.$uid, (this || _global).$foldData.toString = function () {
            return this.join("\n");
          }, this.on("changeFold", (this || _global).onChangeFold.bind(this || _global)), (this || _global).$onChange = (this || _global).onChange.bind(this || _global), "object" == typeof e && e.getLine || (e = new u(e)), this.setDocument(e), (this || _global).selection = new a(this || _global), (this || _global).$bidiHandler = new s(this || _global), l.resetOptions(this || _global), this.setMode(t), l._signal("session", this || _global);
        }

        var r = e("./lib/oop"),
            o = e("./lib/lang"),
            s = e("./bidihandler").BidiHandler,
            l = e("./config"),
            c = e("./lib/event_emitter").EventEmitter,
            a = e("./selection").Selection,
            h = e("./mode/text").Mode,
            d = e("./range").Range,
            u = e("./document").Document,
            g = e("./background_tokenizer").BackgroundTokenizer,
            f = e("./search_highlight").SearchHighlight;
        n.$uid = 0, function () {
          r.implement(this || _global, c), (this || _global).setDocument = function (e) {
            (this || _global).doc && (this || _global).doc.off("change", (this || _global).$onChange), ((this || _global).doc = e).on("change", (this || _global).$onChange), (this || _global).bgTokenizer && (this || _global).bgTokenizer.setDocument(this.getDocument()), this.resetCaches();
          }, (this || _global).getDocument = function () {
            return (this || _global).doc;
          }, (this || _global).$resetRowCache = function (e) {
            if (!e) return (this || _global).$docRowCache = [], void ((this || _global).$screenRowCache = []);
            var t = (this || _global).$docRowCache.length,
                e = this.$getRowCacheIndex((this || _global).$docRowCache, e) + 1;
            e < t && ((this || _global).$docRowCache.splice(e, t), (this || _global).$screenRowCache.splice(e, t));
          }, (this || _global).$getRowCacheIndex = function (e, t) {
            for (var i = 0, n = e.length - 1; i <= n;) {
              var r = i + n >> 1,
                  o = e[r];
              if (o < t) i = 1 + r;else {
                if (!(t < o)) return r;
                n = r - 1;
              }
            }

            return i - 1;
          }, (this || _global).resetCaches = function () {
            (this || _global).$modified = !0, (this || _global).$wrapData = [], (this || _global).$rowLengthCache = [], this.$resetRowCache(0), (this || _global).bgTokenizer && (this || _global).bgTokenizer.start(0);
          }, (this || _global).onChangeFold = function (e) {
            e = e.data;
            this.$resetRowCache(e.start.row);
          }, (this || _global).onChange = function (e) {
            (this || _global).$modified = !0, (this || _global).$bidiHandler.onChange(e), this.$resetRowCache(e.start.row);
            var t = this.$updateInternalDataOnChange(e);
            !(this || _global).$fromUndo && (this || _global).$undoManager && (t && t.length && ((this || _global).$undoManager.add({
              action: "removeFolds",
              folds: t
            }, (this || _global).mergeUndoDeltas), (this || _global).mergeUndoDeltas = !0), (this || _global).$undoManager.add(e, (this || _global).mergeUndoDeltas), (this || _global).mergeUndoDeltas = !0, (this || _global).$informUndoManager.schedule()), (this || _global).bgTokenizer && (this || _global).bgTokenizer.$updateOnChange(e), this._signal("change", e);
          }, (this || _global).setValue = function (e) {
            (this || _global).doc.setValue(e), (this || _global).selection.moveTo(0, 0), this.$resetRowCache(0), this.setUndoManager((this || _global).$undoManager), this.getUndoManager().reset();
          }, (this || _global).getValue = (this || _global).toString = function () {
            return (this || _global).doc.getValue();
          }, (this || _global).getSelection = function () {
            return (this || _global).selection;
          }, (this || _global).getState = function (e) {
            return (this || _global).bgTokenizer.getState(e);
          }, (this || _global).getTokens = function (e) {
            return (this || _global).bgTokenizer.getTokens(e);
          }, (this || _global).getTokenAt = function (e, t) {
            var i = (this || _global).bgTokenizer.getTokens(e),
                n = 0;

            if (null == t) var r = i.length - 1,
                n = this.getLine(e).length;else for (r = 0; r < i.length && !(t <= (n += i[r].value.length)); r++);
            return (e = i[r]) ? (e.index = r, e.start = n - e.value.length, e) : null;
          }, (this || _global).setUndoManager = function (e) {
            var t;
            (this || _global).$undoManager = e, (this || _global).$informUndoManager && (this || _global).$informUndoManager.cancel(), e ? (e.addSession(t = this || _global), (this || _global).$syncInformUndoManager = function () {
              t.$informUndoManager.cancel(), t.mergeUndoDeltas = !1;
            }, (this || _global).$informUndoManager = o.delayedCall((this || _global).$syncInformUndoManager)) : (this || _global).$syncInformUndoManager = function () {};
          }, (this || _global).markUndoGroup = function () {
            (this || _global).$syncInformUndoManager && this.$syncInformUndoManager();
          }, (this || _global).$defaultUndoManager = {
            undo: function () {},
            redo: function () {},
            hasUndo: function () {},
            hasRedo: function () {},
            reset: function () {},
            add: function () {},
            addSelection: function () {},
            startNewGroup: function () {},
            addSession: function () {}
          }, (this || _global).getUndoManager = function () {
            return (this || _global).$undoManager || (this || _global).$defaultUndoManager;
          }, (this || _global).getTabString = function () {
            return this.getUseSoftTabs() ? o.stringRepeat(" ", this.getTabSize()) : "\t";
          }, (this || _global).setUseSoftTabs = function (e) {
            this.setOption("useSoftTabs", e);
          }, (this || _global).getUseSoftTabs = function () {
            return (this || _global).$useSoftTabs && !(this || _global).$mode.$indentWithTabs;
          }, (this || _global).setTabSize = function (e) {
            this.setOption("tabSize", e);
          }, (this || _global).getTabSize = function () {
            return (this || _global).$tabSize;
          }, (this || _global).isTabStop = function (e) {
            return (this || _global).$useSoftTabs && e.column % (this || _global).$tabSize == 0;
          }, (this || _global).setNavigateWithinSoftTabs = function (e) {
            this.setOption("navigateWithinSoftTabs", e);
          }, (this || _global).getNavigateWithinSoftTabs = function () {
            return (this || _global).$navigateWithinSoftTabs;
          }, (this || _global).$overwrite = !1, (this || _global).setOverwrite = function (e) {
            this.setOption("overwrite", e);
          }, (this || _global).getOverwrite = function () {
            return (this || _global).$overwrite;
          }, (this || _global).toggleOverwrite = function () {
            this.setOverwrite(!(this || _global).$overwrite);
          }, (this || _global).addGutterDecoration = function (e, t) {
            (this || _global).$decorations[e] || ((this || _global).$decorations[e] = ""), (this || _global).$decorations[e] += " " + t, this._signal("changeBreakpoint", {});
          }, (this || _global).removeGutterDecoration = function (e, t) {
            (this || _global).$decorations[e] = ((this || _global).$decorations[e] || "").replace(" " + t, ""), this._signal("changeBreakpoint", {});
          }, (this || _global).getBreakpoints = function () {
            return (this || _global).$breakpoints;
          }, (this || _global).setBreakpoints = function (e) {
            (this || _global).$breakpoints = [];

            for (var t = 0; t < e.length; t++) (this || _global).$breakpoints[e[t]] = "ace_breakpoint";

            this._signal("changeBreakpoint", {});
          }, (this || _global).clearBreakpoints = function () {
            (this || _global).$breakpoints = [], this._signal("changeBreakpoint", {});
          }, (this || _global).setBreakpoint = function (e, t) {
            (t = void 0 === t ? "ace_breakpoint" : t) ? (this || _global).$breakpoints[e] = t : delete (this || _global).$breakpoints[e], this._signal("changeBreakpoint", {});
          }, (this || _global).clearBreakpoint = function (e) {
            delete (this || _global).$breakpoints[e], this._signal("changeBreakpoint", {});
          }, (this || _global).addMarker = function (e, t, i, n) {
            var r = (this || _global).$markerId++,
                e = {
              range: e,
              type: i || "line",
              renderer: "function" == typeof i ? i : null,
              clazz: t,
              inFront: !!n,
              id: r
            };
            return n ? ((this || _global).$frontMarkers[r] = e, this._signal("changeFrontMarker")) : ((this || _global).$backMarkers[r] = e, this._signal("changeBackMarker")), r;
          }, (this || _global).addDynamicMarker = function (e, t) {
            var i;
            if (e.update) return i = (this || _global).$markerId++, e.id = i, e.inFront = !!t, t ? ((this || _global).$frontMarkers[i] = e, this._signal("changeFrontMarker")) : ((this || _global).$backMarkers[i] = e, this._signal("changeBackMarker")), e;
          }, (this || _global).removeMarker = function (e) {
            var t = (this || _global).$frontMarkers[e] || (this || _global).$backMarkers[e];
            t && (delete (t.inFront ? (this || _global).$frontMarkers : (this || _global).$backMarkers)[e], this._signal(t.inFront ? "changeFrontMarker" : "changeBackMarker"));
          }, (this || _global).getMarkers = function (e) {
            return e ? (this || _global).$frontMarkers : (this || _global).$backMarkers;
          }, (this || _global).highlight = function (e) {
            var t;
            (this || _global).$searchHighlight || (t = new f(null, "ace_selected-word", "text"), (this || _global).$searchHighlight = this.addDynamicMarker(t)), (this || _global).$searchHighlight.setRegexp(e);
          }, (this || _global).highlightLines = function (e, t, i, n) {
            "number" != typeof t && (i = t, t = e), i = i || "ace_step";
            e = new d(e, 0, t, 1 / 0);
            return e.id = this.addMarker(e, i, "fullLine", n), e;
          }, (this || _global).setAnnotations = function (e) {
            (this || _global).$annotations = e, this._signal("changeAnnotation", {});
          }, (this || _global).getAnnotations = function () {
            return (this || _global).$annotations || [];
          }, (this || _global).clearAnnotations = function () {
            this.setAnnotations([]);
          }, (this || _global).$detectNewLine = function (e) {
            e = e.match(/^.*?(\r?\n)/m);
            (this || _global).$autoNewLine = e ? e[1] : "\n";
          }, (this || _global).getWordRange = function (e, t) {
            var i,
                n = this.getLine(e),
                r = !1,
                o = (i = (r = (r = 0 < t ? !!n.charAt(t - 1).match((this || _global).tokenRe) : r) || !!n.charAt(t).match((this || _global).tokenRe)) ? (this || _global).tokenRe : /^\s+$/.test(n.slice(t - 1, t + 1)) ? /\s/ : (this || _global).nonTokenRe, t);

            if (0 < o) {
              for (; 0 <= --o && n.charAt(o).match(i););

              o++;
            }

            for (var s = t; s < n.length && n.charAt(s).match(i);) s++;

            return new d(e, o, e, s);
          }, (this || _global).getAWordRange = function (e, t) {
            for (var i = this.getWordRange(e, t), n = this.getLine(i.end.row); n.charAt(i.end.column).match(/[ \t]/);) i.end.column += 1;

            return i;
          }, (this || _global).setNewLineMode = function (e) {
            (this || _global).doc.setNewLineMode(e);
          }, (this || _global).getNewLineMode = function () {
            return (this || _global).doc.getNewLineMode();
          }, (this || _global).setUseWorker = function (e) {
            this.setOption("useWorker", e);
          }, (this || _global).getUseWorker = function () {
            return (this || _global).$useWorker;
          }, (this || _global).onReloadTokenizer = function (e) {
            var t = e.data;
            (this || _global).bgTokenizer.start(t.first), this._signal("tokenizerUpdate", e);
          }, (this || _global).$modes = l.$modes, (this || _global).$mode = null, (this || _global).$modeId = null, (this || _global).setMode = function (e, t) {
            if (e && "object" == typeof e) {
              if (e.getTokenizer) return this.$onChangeMode(e);
              var i = e,
                  n = i.path;
            } else n = e || "ace/mode/text";

            if ((this || _global).$modes["ace/mode/text"] || ((this || _global).$modes["ace/mode/text"] = new h()), (this || _global).$modes[n] && !i) return this.$onChangeMode((this || _global).$modes[n]), void (t && t());
            (this || _global).$modeId = n, l.loadModule(["mode", n], function (e) {
              if ((this || _global).$modeId !== n) return t && t();
              (this || _global).$modes[n] && !i ? this.$onChangeMode((this || _global).$modes[n]) : e && e.Mode && (e = new e.Mode(i), i || (((this || _global).$modes[n] = e).$id = n), this.$onChangeMode(e)), t && t();
            }.bind(this || _global)), (this || _global).$mode || this.$onChangeMode((this || _global).$modes["ace/mode/text"], !0);
          }, (this || _global).$onChangeMode = function (e, t) {
            var i, n, r, o;
            t || ((this || _global).$modeId = e.$id), (this || _global).$mode !== e && (i = (this || _global).$mode, (this || _global).$mode = e, this.$stopWorker(), (this || _global).$useWorker && this.$startWorker(), void 0 !== (n = e.getTokenizer()).on && (r = (this || _global).onReloadTokenizer.bind(this || _global), n.on("update", r)), (this || _global).bgTokenizer ? (this || _global).bgTokenizer.setTokenizer(n) : ((this || _global).bgTokenizer = new g(n), (o = this || _global).bgTokenizer.on("update", function (e) {
              o._signal("tokenizerUpdate", e);
            })), (this || _global).bgTokenizer.setDocument(this.getDocument()), (this || _global).tokenRe = e.tokenRe, (this || _global).nonTokenRe = e.nonTokenRe, t || (e.attachToSession && e.attachToSession(this || _global), (this || _global).$options.wrapMethod.set.call(this || _global, (this || _global).$wrapMethod), this.$setFolding(e.foldingRules), (this || _global).bgTokenizer.start(0), this._emit("changeMode", {
              oldMode: i,
              mode: e
            })));
          }, (this || _global).$stopWorker = function () {
            (this || _global).$worker && ((this || _global).$worker.terminate(), (this || _global).$worker = null);
          }, (this || _global).$startWorker = function () {
            try {
              (this || _global).$worker = (this || _global).$mode.createWorker(this || _global);
            } catch (e) {
              l.warn("Could not load worker", e), (this || _global).$worker = null;
            }
          }, (this || _global).getMode = function () {
            return (this || _global).$mode;
          }, (this || _global).$scrollTop = 0, (this || _global).setScrollTop = function (e) {
            (this || _global).$scrollTop === e || isNaN(e) || ((this || _global).$scrollTop = e, this._signal("changeScrollTop", e));
          }, (this || _global).getScrollTop = function () {
            return (this || _global).$scrollTop;
          }, (this || _global).$scrollLeft = 0, (this || _global).setScrollLeft = function (e) {
            (this || _global).$scrollLeft === e || isNaN(e) || ((this || _global).$scrollLeft = e, this._signal("changeScrollLeft", e));
          }, (this || _global).getScrollLeft = function () {
            return (this || _global).$scrollLeft;
          }, (this || _global).getScreenWidth = function () {
            return this.$computeWidth(), (this || _global).lineWidgets ? Math.max(this.getLineWidgetMaxWidth(), (this || _global).screenWidth) : (this || _global).screenWidth;
          }, (this || _global).getLineWidgetMaxWidth = function () {
            if (null != (this || _global).lineWidgetsWidth) return (this || _global).lineWidgetsWidth;
            var t = 0;
            return (this || _global).lineWidgets.forEach(function (e) {
              e && e.screenWidth > t && (t = e.screenWidth);
            }), (this || _global).lineWidgetWidth = t;
          }, (this || _global).$computeWidth = function (e) {
            if ((this || _global).$modified || e) {
              if ((this || _global).$modified = !1, (this || _global).$useWrapMode) return (this || _global).screenWidth = (this || _global).$wrapLimit;

              for (var t = (this || _global).doc.getAllLines(), i = (this || _global).$rowLengthCache, n = 0, r = 0, o = (this || _global).$foldData[r], s = o ? o.start.row : 1 / 0, a = t.length, l = 0; l < a; l++) {
                if (s < l) {
                  if (a <= (l = o.end.row + 1)) break;
                  s = (o = (this || _global).$foldData[r++]) ? o.start.row : 1 / 0;
                }

                null == i[l] && (i[l] = this.$getStringScreenWidth(t[l])[0]), i[l] > n && (n = i[l]);
              }

              (this || _global).screenWidth = n;
            }
          }, (this || _global).getLine = function (e) {
            return (this || _global).doc.getLine(e);
          }, (this || _global).getLines = function (e, t) {
            return (this || _global).doc.getLines(e, t);
          }, (this || _global).getLength = function () {
            return (this || _global).doc.getLength();
          }, (this || _global).getTextRange = function (e) {
            return (this || _global).doc.getTextRange(e || (this || _global).selection.getRange());
          }, (this || _global).insert = function (e, t) {
            return (this || _global).doc.insert(e, t);
          }, (this || _global).remove = function (e) {
            return (this || _global).doc.remove(e);
          }, (this || _global).removeFullLines = function (e, t) {
            return (this || _global).doc.removeFullLines(e, t);
          }, (this || _global).undoChanges = function (e, t) {
            if (e.length) {
              (this || _global).$fromUndo = !0;

              for (var i = e.length - 1; -1 != i; i--) {
                var n = e[i];
                "insert" == n.action || "remove" == n.action ? (this || _global).doc.revertDelta(n) : n.folds && this.addFolds(n.folds);
              }

              !t && (this || _global).$undoSelect && (e.selectionBefore ? (this || _global).selection.fromJSON(e.selectionBefore) : (this || _global).selection.setRange(this.$getUndoSelection(e, !0))), (this || _global).$fromUndo = !1;
            }
          }, (this || _global).redoChanges = function (e, t) {
            if (e.length) {
              (this || _global).$fromUndo = !0;

              for (var i = 0; i < e.length; i++) {
                var n = e[i];
                "insert" != n.action && "remove" != n.action || (this || _global).doc.$safeApplyDelta(n);
              }

              !t && (this || _global).$undoSelect && (e.selectionAfter ? (this || _global).selection.fromJSON(e.selectionAfter) : (this || _global).selection.setRange(this.$getUndoSelection(e, !1))), (this || _global).$fromUndo = !1;
            }
          }, (this || _global).setUndoSelect = function (e) {
            (this || _global).$undoSelect = e;
          }, (this || _global).$getUndoSelection = function (e, t) {
            function i(e) {
              return t ? "insert" !== e.action : "insert" === e.action;
            }

            for (var n, r, o = 0; o < e.length; o++) {
              var s = e[o];
              s.start && (n ? i(s) ? (r = s.start, -1 == n.compare(r.row, r.column) && n.setStart(r), r = s.end, 1 == n.compare(r.row, r.column) && n.setEnd(r)) : (r = s.start, -1 == n.compare(r.row, r.column) && (n = d.fromPoints(s.start, s.start))) : n = i(s) ? d.fromPoints(s.start, s.end) : d.fromPoints(s.start, s.start));
            }

            return n;
          }, (this || _global).replace = function (e, t) {
            return (this || _global).doc.replace(e, t);
          }, (this || _global).moveText = function (e, t, i) {
            var n,
                r,
                o,
                s = this.getTextRange(e),
                a = this.getFoldsInRange(e),
                t = d.fromPoints(t, t);
            return i || (this.remove(e), r = e.start.row - e.end.row, (o = r ? -e.end.column : e.start.column - e.end.column) && (t.start.row == e.end.row && t.start.column > e.end.column && (t.start.column += o), t.end.row == e.end.row && t.end.column > e.end.column && (t.end.column += o)), r && t.start.row >= e.end.row && (t.start.row += r, t.end.row += r)), t.end = this.insert(t.start, s), a.length && (n = e.start, i = t.start, r = i.row - n.row, o = i.column - n.column, this.addFolds(a.map(function (e) {
              return (e = e.clone()).start.row == n.row && (e.start.column += o), e.end.row == n.row && (e.end.column += o), e.start.row += r, e.end.row += r, e;
            }))), t;
          }, (this || _global).indentRows = function (e, t, i) {
            i = i.replace(/\t/g, this.getTabString());

            for (var n = e; n <= t; n++) (this || _global).doc.insertInLine({
              row: n,
              column: 0
            }, i);
          }, (this || _global).outdentRows = function (e) {
            for (var t = e.collapseRows(), i = new d(0, 0, 0, 0), n = this.getTabSize(), r = t.start.row; r <= t.end.row; ++r) {
              var o = this.getLine(r);
              i.start.row = r, i.end.row = r;

              for (var s = 0; s < n && " " == o.charAt(s); ++s);

              s < n && "\t" == o.charAt(s) ? (i.start.column = s, i.end.column = s + 1) : (i.start.column = 0, i.end.column = s), this.remove(i);
            }
          }, (this || _global).$moveLines = function (e, t, i) {
            if (e = this.getRowFoldStart(e), t = this.getRowFoldEnd(t), i < 0) {
              if ((r = this.getRowFoldStart(e + i)) < 0) return 0;
              var n = r - e;
            } else if (0 < i) {
              if ((r = this.getRowFoldEnd(t + i)) > (this || _global).doc.getLength() - 1) return 0;
              n = r - t;
            } else {
              e = this.$clipRowToDocument(e);
              n = (t = this.$clipRowToDocument(t)) - e + 1;
            }

            var r = new d(e, 0, t, Number.MAX_VALUE),
                r = this.getFoldsInRange(r).map(function (e) {
              return (e = e.clone()).start.row += n, e.end.row += n, e;
            }),
                i = 0 == i ? (this || _global).doc.getLines(e, t) : (this || _global).doc.removeFullLines(e, t);
            return (this || _global).doc.insertFullLines(e + n, i), r.length && this.addFolds(r), n;
          }, (this || _global).moveLinesUp = function (e, t) {
            return this.$moveLines(e, t, -1);
          }, (this || _global).moveLinesDown = function (e, t) {
            return this.$moveLines(e, t, 1);
          }, (this || _global).duplicateLines = function (e, t) {
            return this.$moveLines(e, t, 0);
          }, (this || _global).$clipRowToDocument = function (e) {
            return Math.max(0, Math.min(e, (this || _global).doc.getLength() - 1));
          }, (this || _global).$clipColumnToRow = function (e, t) {
            return t < 0 ? 0 : Math.min((this || _global).doc.getLine(e).length, t);
          }, (this || _global).$clipPositionToDocument = function (e, t) {
            var i;
            return t = Math.max(0, t), t = e < 0 ? e = 0 : (i = (this || _global).doc.getLength()) <= e ? (this || _global).doc.getLine(e = i - 1).length : Math.min((this || _global).doc.getLine(e).length, t), {
              row: e,
              column: t
            };
          }, (this || _global).$clipRangeToDocument = function (e) {
            e.start.row < 0 ? (e.start.row = 0, e.start.column = 0) : e.start.column = this.$clipColumnToRow(e.start.row, e.start.column);
            var t = (this || _global).doc.getLength() - 1;
            return e.end.row > t ? (e.end.row = t, e.end.column = (this || _global).doc.getLine(t).length) : e.end.column = this.$clipColumnToRow(e.end.row, e.end.column), e;
          }, (this || _global).$wrapLimit = 80, (this || _global).$useWrapMode = !1, (this || _global).$wrapLimitRange = {
            min: null,
            max: null
          }, (this || _global).setUseWrapMode = function (e) {
            e != (this || _global).$useWrapMode && ((this || _global).$useWrapMode = e, (this || _global).$modified = !0, this.$resetRowCache(0), e && (e = this.getLength(), (this || _global).$wrapData = Array(e), this.$updateWrapData(0, e - 1)), this._signal("changeWrapMode"));
          }, (this || _global).getUseWrapMode = function () {
            return (this || _global).$useWrapMode;
          }, (this || _global).setWrapLimitRange = function (e, t) {
            (this || _global).$wrapLimitRange.min === e && (this || _global).$wrapLimitRange.max === t || ((this || _global).$wrapLimitRange = {
              min: e,
              max: t
            }, (this || _global).$modified = !0, (this || _global).$bidiHandler.markAsDirty(), (this || _global).$useWrapMode && this._signal("changeWrapMode"));
          }, (this || _global).adjustWrapLimit = function (e, t) {
            var i = (this || _global).$wrapLimitRange,
                t = (i.max < 0 && (i = {
              min: t,
              max: t
            }), this.$constrainWrapLimit(e, i.min, i.max));
            return t != (this || _global).$wrapLimit && 1 < t && ((this || _global).$wrapLimit = t, (this || _global).$modified = !0, (this || _global).$useWrapMode && (this.$updateWrapData(0, this.getLength() - 1), this.$resetRowCache(0), this._signal("changeWrapLimit")), !0);
          }, (this || _global).$constrainWrapLimit = function (e, t, i) {
            return t && (e = Math.max(t, e)), e = i ? Math.min(i, e) : e;
          }, (this || _global).getWrapLimit = function () {
            return (this || _global).$wrapLimit;
          }, (this || _global).setWrapLimit = function (e) {
            this.setWrapLimitRange(e, e);
          }, (this || _global).getWrapLimitRange = function () {
            return {
              min: (this || _global).$wrapLimitRange.min,
              max: (this || _global).$wrapLimitRange.max
            };
          }, (this || _global).$updateInternalDataOnChange = function (e) {
            var t = (this || _global).$useWrapMode,
                i = e.action,
                n = e.start,
                r = e.end,
                o = n.row,
                s = r.row,
                a = s - o,
                l = null;
            if ((this || _global).$updating = !0, 0 != a) {
              if ("remove" === i) {
                (this || _global)[t ? "$wrapData" : "$rowLengthCache"].splice(o, a);

                var c = (this || _global).$foldData,
                    l = this.getFoldsInRange(e);
                this.removeFolds(l);
                var h = 0;

                for ((g = this.getFoldLine(r.row)) && (g.addRemoveChars(r.row, r.column, n.column - r.column), g.shiftRow(-a), (d = this.getFoldLine(o)) && d !== g && (d.merge(g), g = d), h = c.indexOf(g) + 1); h < c.length; h++) (g = c[h]).start.row >= r.row && g.shiftRow(-a);

                s = o;
              } else {
                var d = Array(a),
                    u = (d.unshift(o, 0), t ? (this || _global).$wrapData : (this || _global).$rowLengthCache),
                    c = (u.splice.apply(u, d), (this || _global).$foldData),
                    h = 0;

                for ((g = this.getFoldLine(o)) && (0 == (u = g.range.compareInside(n.row, n.column)) ? (g = g.split(n.row, n.column)) && (g.shiftRow(a), g.addRemoveChars(s, 0, r.column - n.column)) : -1 == u && (g.addRemoveChars(o, 0, r.column - n.column), g.shiftRow(a)), h = c.indexOf(g) + 1); h < c.length; h++) (g = c[h]).start.row >= o && g.shiftRow(a);
              }
            } else {
              var g,
                  a = Math.abs(e.start.column - e.end.column);
              "remove" === i && (l = this.getFoldsInRange(e), this.removeFolds(l), a = -a), (g = this.getFoldLine(o)) && g.addRemoveChars(o, n.column, a);
            }
            return t && (this || _global).$wrapData.length != (this || _global).doc.getLength() && console.error("doc.getLength() and $wrapData.length have to be the same!"), (this || _global).$updating = !1, t ? this.$updateWrapData(o, s) : this.$updateRowLengthCache(o, s), l;
          }, (this || _global).$updateRowLengthCache = function (e, t, i) {
            (this || _global).$rowLengthCache[e] = null, (this || _global).$rowLengthCache[t] = null;
          }, (this || _global).$updateWrapData = function (e, t) {
            var s,
                i,
                a = (this || _global).doc.getAllLines(),
                n = this.getTabSize(),
                r = (this || _global).$wrapData,
                o = (this || _global).$wrapLimit,
                l = e;

            for (t = Math.min(t, a.length - 1); l <= t;) (i = this.getFoldLine(l, i)) ? (s = [], i.walk(function (e, t, i, n) {
              var r;

              if (null != e) {
                (r = this.$getDisplayTokens(e, s.length))[0] = p;

                for (var o = 1; o < r.length; o++) r[o] = m;
              } else r = this.$getDisplayTokens(a[t].substring(n, i), s.length);

              s = s.concat(r);
            }.bind(this || _global), i.end.row, a[i.end.row].length + 1), r[i.start.row] = this.$computeWrapSplits(s, o, n), l = i.end.row + 1) : (s = this.$getDisplayTokens(a[l]), r[l] = this.$computeWrapSplits(s, o, n), l++);
          };
          var p = 3,
              m = 4;

          function a(e) {
            return !(e < 4352) && (4352 <= e && e <= 4447 || 4515 <= e && e <= 4519 || 4602 <= e && e <= 4607 || 9001 <= e && e <= 9002 || 11904 <= e && e <= 11929 || 11931 <= e && e <= 12019 || 12032 <= e && e <= 12245 || 12272 <= e && e <= 12283 || 12288 <= e && e <= 12350 || 12353 <= e && e <= 12438 || 12441 <= e && e <= 12543 || 12549 <= e && e <= 12589 || 12593 <= e && e <= 12686 || 12688 <= e && e <= 12730 || 12736 <= e && e <= 12771 || 12784 <= e && e <= 12830 || 12832 <= e && e <= 12871 || 12880 <= e && e <= 13054 || 13056 <= e && e <= 19903 || 19968 <= e && e <= 42124 || 42128 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 55216 <= e && e <= 55238 || 55243 <= e && e <= 55291 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65106 || 65108 <= e && e <= 65126 || 65128 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510);
          }

          (this || _global).$computeWrapSplits = function (r, e, o) {
            if (0 == r.length) return [];
            var s = [],
                t = r.length,
                a = 0,
                l = 0,
                c = (this || _global).$wrapAsCode,
                h = (this || _global).$indentedSoftWrap,
                d = e <= Math.max(2 * o, 8) || !1 === h ? 0 : Math.floor(e / 2);

            function i(e) {
              for (var t = e - a, i = a; i < e; i++) {
                var n = r[i];
                12 !== n && 2 !== n || --t;
              }

              s.length || (u = function () {
                var e = 0;
                if (0 === d) return e;
                if (h) for (var t = 0; t < r.length; t++) {
                  var i = r[t];
                  if (10 == i) e += 1;else if (11 == i) e += o;else if (12 != i) break;
                }
                return c && !1 !== h && (e += o), Math.min(e, d);
              }(), s.indent = u), l += t, s.push(l), a = e;
            }

            for (var u = 0; e - u < t - a;) {
              var n = a + e - u;
              if (10 <= r[n - 1] && 10 <= r[n]) i(n);else if (r[n] == p || r[n] == m) {
                for (; n != a - 1 && r[n] != p; n--);

                if (a < n) i(n);else {
                  for (n = a + e; n < r.length && r[n] == m; n++);

                  if (n == r.length) break;
                  i(n);
                }
              } else {
                for (var g = Math.max(n - (e - (e >> 2)), a - 1); g < n && r[n] < p;) n--;

                if (c) {
                  for (; g < n && r[n] < p;) n--;

                  for (; g < n && 9 == r[n];) n--;
                } else for (; g < n && r[n] < 10;) n--;

                g < n ? i(++n) : (2 == r[n = a + e] && n--, i(n - u));
              }
            }

            return s;
          }, (this || _global).$getDisplayTokens = function (e, t) {
            var i,
                n = [];
            t = t || 0;

            for (var r = 0; r < e.length; r++) {
              var o = e.charCodeAt(r);

              if (9 == o) {
                i = this.getScreenTabSize(n.length + t), n.push(11);

                for (var s = 1; s < i; s++) n.push(12);
              } else 32 == o ? n.push(10) : 39 < o && o < 48 || 57 < o && o < 64 ? n.push(9) : 4352 <= o && a(o) ? n.push(1, 2) : n.push(1);
            }

            return n;
          }, (this || _global).$getStringScreenWidth = function (e, t, i) {
            if (0 == t) return [0, 0];
            var n, r;

            for (null == t && (t = 1 / 0), i = i || 0, r = 0; r < e.length && (9 == (n = e.charCodeAt(r)) ? i += this.getScreenTabSize(i) : 4352 <= n && a(n) ? i += 2 : i += 1, !(t < i)); r++);

            return [i, r];
          }, (this || _global).lineWidgets = null, (this || _global).getRowLength = function (e) {
            var t = 1;
            return (this || _global).lineWidgets && (t += (this || _global).lineWidgets[e] && (this || _global).lineWidgets[e].rowCount || 0), (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + t : t;
          }, (this || _global).getRowLineCount = function (e) {
            return (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + 1 : 1;
          }, (this || _global).getRowWrapIndent = function (e) {
            var t;
            return (this || _global).$useWrapMode ? (e = this.screenToDocumentPosition(e, Number.MAX_VALUE), (t = (this || _global).$wrapData[e.row]).length && t[0] < e.column ? t.indent : 0) : 0;
          }, (this || _global).getScreenLastRowColumn = function (e) {
            e = this.screenToDocumentPosition(e, Number.MAX_VALUE);
            return this.documentToScreenColumn(e.row, e.column);
          }, (this || _global).getDocumentLastRowColumn = function (e, t) {
            e = this.documentToScreenRow(e, t);
            return this.getScreenLastRowColumn(e);
          }, (this || _global).getDocumentLastRowColumnPosition = function (e, t) {
            e = this.documentToScreenRow(e, t);
            return this.screenToDocumentPosition(e, Number.MAX_VALUE / 10);
          }, (this || _global).getRowSplitData = function (e) {
            if ((this || _global).$useWrapMode) return (this || _global).$wrapData[e];
          }, (this || _global).getScreenTabSize = function (e) {
            return (this || _global).$tabSize - (e % (this || _global).$tabSize | 0);
          }, (this || _global).screenToDocumentRow = function (e, t) {
            return this.screenToDocumentPosition(e, t).row;
          }, (this || _global).screenToDocumentColumn = function (e, t) {
            return this.screenToDocumentPosition(e, t).column;
          }, (this || _global).screenToDocumentPosition = function (e, t, i) {
            if (e < 0) return {
              row: 0,
              column: 0
            };

            for (var n, r, o, s = 0, a = 0, l = 0, c = 0, h = (this || _global).$screenRowCache, d = this.$getRowCacheIndex(h, e), u = h.length, g = (o = u && 0 <= d ? (l = h[d], s = (this || _global).$docRowCache[d], e > h[u - 1]) : !u, this.getLength() - 1), p = this.getNextFoldLine(s), m = p ? p.start.row : 1 / 0; l <= e && !(e < l + (c = this.getRowLength(s)) || g <= s);) l += c, m < ++s && (s = p.end.row + 1, m = (p = this.getNextFoldLine(s, p)) ? p.start.row : 1 / 0), o && ((this || _global).$docRowCache.push(s), (this || _global).$screenRowCache.push(l));

            if (p && p.start.row <= s) n = this.getFoldDisplayLine(p), s = p.start.row;else {
              if (l + c <= e || g < s) return {
                row: g,
                column: this.getLine(g).length
              };
              n = this.getLine(s), p = null;
            }
            d = 0, h = Math.floor(e - l);
            return (this || _global).$useWrapMode && (u = (this || _global).$wrapData[s]) && (r = u[h], 0 < h && u.length && (d = u.indent, a = u[h - 1] || u[u.length - 1], n = n.substring(a))), void 0 !== i && (this || _global).$bidiHandler.isBidiRow(l + h, s, h) && (t = (this || _global).$bidiHandler.offsetToCol(i)), a += this.$getStringScreenWidth(n, t - d)[1], (this || _global).$useWrapMode && r <= a && (a = r - 1), p ? p.idxToPosition(a) : {
              row: s,
              column: a
            };
          }, (this || _global).documentToScreenPosition = function (e, t) {
            var i = void 0 === t ? this.$clipPositionToDocument(e.row, e.column) : this.$clipPositionToDocument(e, t),
                n = (e = i.row, t = i.column, 0),
                i = null;
            (a = this.getFoldAt(e, t, 1)) && (e = a.start.row, t = a.start.column);

            for (var r, o, s = 0, a = (this || _global).$docRowCache, l = this.$getRowCacheIndex(a, e), c = a.length, h = (o = c && 0 <= l ? (s = a[l], n = (this || _global).$screenRowCache[l], e > a[c - 1]) : !c, this.getNextFoldLine(s)), d = h ? h.start.row : 1 / 0; s < e;) {
              if (d <= s) {
                if (e < (r = h.end.row + 1)) break;
                d = (h = this.getNextFoldLine(r, h)) ? h.start.row : 1 / 0;
              } else r = s + 1;

              n += this.getRowLength(s), s = r, o && ((this || _global).$docRowCache.push(s), (this || _global).$screenRowCache.push(n));
            }

            var u = "",
                i = h && d <= s ? (u = this.getFoldDisplayLine(h, e, t), h.start.row) : (u = this.getLine(e).substring(0, t), e),
                l = 0;

            if ((this || _global).$useWrapMode) {
              var g = (this || _global).$wrapData[i];

              if (g) {
                for (var p = 0; u.length >= g[p];) n++, p++;

                u = u.substring(g[p - 1] || 0, u.length), l = 0 < p ? g.indent : 0;
              }
            }

            return (this || _global).lineWidgets && (this || _global).lineWidgets[s] && (this || _global).lineWidgets[s].rowsAbove && (n += (this || _global).lineWidgets[s].rowsAbove), {
              row: n,
              column: l + this.$getStringScreenWidth(u)[0]
            };
          }, (this || _global).documentToScreenColumn = function (e, t) {
            return this.documentToScreenPosition(e, t).column;
          }, (this || _global).documentToScreenRow = function (e, t) {
            return this.documentToScreenPosition(e, t).row;
          }, (this || _global).getScreenLength = function () {
            var e = 0,
                t = null;
            if ((this || _global).$useWrapMode) for (var i = (this || _global).$wrapData.length, n = 0, r = 0, o = (t = (this || _global).$foldData[r++]) ? t.start.row : 1 / 0; n < i;) {
              var s = (this || _global).$wrapData[n];
              e += s ? s.length + 1 : 1, o < ++n && (n = t.end.row + 1, o = (t = (this || _global).$foldData[r++]) ? t.start.row : 1 / 0);
            } else for (var e = this.getLength(), a = (this || _global).$foldData, r = 0; r < a.length; r++) e -= (t = a[r]).end.row - t.start.row;
            return (this || _global).lineWidgets && (e += this.$getWidgetScreenLength()), e;
          }, (this || _global).$setFontMetrics = function (o) {
            (this || _global).$enableVarChar && ((this || _global).$getStringScreenWidth = function (e, t, i) {
              if (0 === t) return [0, 0];
              var n, r;

              for (t = t || 1 / 0, i = i || 0, r = 0; r < e.length && !(t < (i += "\t" === (n = e.charAt(r)) ? this.getScreenTabSize(i) : o.getCharacterWidth(n))); r++);

              return [i, r];
            });
          }, (this || _global).destroy = function () {
            (this || _global).bgTokenizer && ((this || _global).bgTokenizer.setDocument(null), (this || _global).bgTokenizer = null), this.$stopWorker(), this.removeAllListeners(), (this || _global).doc && (this || _global).doc.off("change", (this || _global).$onChange), (this || _global).selection.detach();
          }, (this || _global).isFullWidth = a;
        }.call(n.prototype), e("./edit_session/folding").Folding.call(n.prototype), e("./edit_session/bracket_match").BracketMatch.call(n.prototype), l.defineOptions(n.prototype, "session", {
          wrap: {
            set: function (e) {
              e && "off" != e ? "free" == e ? e = !0 : "printMargin" == e ? e = -1 : "string" == typeof e && (e = parseInt(e, 10) || !1) : e = !1, (this || _global).$wrap != e && (((this || _global).$wrap = e) ? (this.setWrapLimitRange(e = "number" == typeof e ? e : null, e), this.setUseWrapMode(!0)) : this.setUseWrapMode(!1));
            },
            get: function () {
              return this.getUseWrapMode() ? -1 == (this || _global).$wrap ? "printMargin" : this.getWrapLimitRange().min ? (this || _global).$wrap : "free" : "off";
            },
            handlesSet: !0
          },
          wrapMethod: {
            set: function (e) {
              (e = "auto" == e ? "text" != (this || _global).$mode.type : "text" != e) != (this || _global).$wrapAsCode && ((this || _global).$wrapAsCode = e, (this || _global).$useWrapMode && ((this || _global).$useWrapMode = !1, this.setUseWrapMode(!0)));
            },
            initialValue: "auto"
          },
          indentedSoftWrap: {
            set: function () {
              (this || _global).$useWrapMode && ((this || _global).$useWrapMode = !1, this.setUseWrapMode(!0));
            },
            initialValue: !0
          },
          firstLineNumber: {
            set: function () {
              this._signal("changeBreakpoint");
            },
            initialValue: 1
          },
          useWorker: {
            set: function (e) {
              (this || _global).$useWorker = e, this.$stopWorker(), e && this.$startWorker();
            },
            initialValue: !0
          },
          useSoftTabs: {
            initialValue: !0
          },
          tabSize: {
            set: function (e) {
              0 < (e = parseInt(e)) && (this || _global).$tabSize !== e && ((this || _global).$modified = !0, (this || _global).$rowLengthCache = [], (this || _global).$tabSize = e, this._signal("changeTabSize"));
            },
            initialValue: 4,
            handlesSet: !0
          },
          navigateWithinSoftTabs: {
            initialValue: !1
          },
          foldStyle: {
            set: function (e) {
              this.setFoldStyle(e);
            },
            handlesSet: !0
          },
          overwrite: {
            set: function (e) {
              this._signal("changeOverwrite");
            },
            initialValue: !1
          },
          newLineMode: {
            set: function (e) {
              (this || _global).doc.setNewLineMode(e);
            },
            get: function () {
              return (this || _global).doc.getNewLineMode();
            },
            handlesSet: !0
          },
          mode: {
            set: function (e) {
              this.setMode(e);
            },
            get: function () {
              return (this || _global).$modeId;
            },
            handlesSet: !0
          }
        }), t.EditSession = n;
      }), ace.define("ace/search", ["require", "exports", "module", "ace/lib/lang", "ace/lib/oop", "ace/range"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).$options = {};
        }

        var I = e("./lib/lang"),
            r = e("./lib/oop"),
            v = e("./range").Range;
        !function () {
          (this || _global).set = function (e) {
            return r.mixin((this || _global).$options, e), this || _global;
          }, (this || _global).getOptions = function () {
            return I.copyObject((this || _global).$options);
          }, (this || _global).setOptions = function (e) {
            (this || _global).$options = e;
          }, (this || _global).find = function (e) {
            var r = (this || _global).$options,
                e = this.$matchIterator(e, r);
            if (!e) return !1;
            var o = null;
            return e.forEach(function (e, t, i, n) {
              return o = new v(e, t, i, n), !(t == n && r.start && r.start.start && 0 != r.skipCurrent && o.isEqual(r.start)) || (o = null, !1);
            }), o;
          }, (this || _global).findAll = function (e) {
            var t = (this || _global).$options;
            if (!t.needle) return [];
            this.$assembleRegExp(t);
            var i = t.range,
                n = i ? e.getLines(i.start.row, i.end.row) : e.doc.getAllLines(),
                r = [],
                o = t.re;

            if (t.$isMultiLine) {
              var s,
                  a = o.length,
                  l = n.length - a;

              e: for (var c = o.offset || 0; c <= l; c++) {
                for (var h = 0; h < a; h++) if (-1 == n[c + h].search(o[h])) continue e;

                var d = n[c],
                    u = n[c + a - 1],
                    d = d.length - d.match(o[0])[0].length,
                    u = u.match(o[a - 1])[0].length;
                s && s.end.row === c && s.end.column > d || (r.push(s = new v(c, d, c + a - 1, u)), 2 < a && (c = c + a - 2));
              }
            } else for (var g = 0; g < n.length; g++) for (var p = I.getMatchOffsets(n[g], o), h = 0; h < p.length; h++) {
              var m = p[h];
              r.push(new v(g, m.offset, g, m.offset + m.length));
            }

            if (i) {
              for (var f = i.start.column, C = i.start.column, g = 0, h = r.length - 1; g < h && r[g].start.column < f && r[g].start.row == i.start.row;) g++;

              for (; g < h && r[h].end.column > C && r[h].end.row == i.end.row;) h--;

              for (r = r.slice(g, h + 1), g = 0, h = r.length; g < h; g++) r[g].start.row += i.start.row, r[g].end.row += i.start.row;
            }

            return r;
          }, (this || _global).replace = function (e, t) {
            var i = (this || _global).$options,
                n = this.$assembleRegExp(i);
            if (i.$isMultiLine) return t;

            if (n) {
              var r = n.exec(e);
              if (!r || r[0].length != e.length) return null;

              if (t = e.replace(n, t), i.preserveCase) {
                t = t.split("");

                for (var o = Math.min(e.length, e.length); o--;) {
                  var s = e[o];
                  s && s.toLowerCase() != s ? t[o] = t[o].toUpperCase() : t[o] = t[o].toLowerCase();
                }

                t = t.join("");
              }

              return t;
            }
          }, (this || _global).$assembleRegExp = function (e, t) {
            if (e.needle instanceof RegExp) return e.re = e.needle;
            var i,
                n = e.needle;
            if (!e.needle) return e.re = !1;

            function r(e) {
              return /\w/.test(e) || i.regExp ? "\\b" : "";
            }

            e.regExp || (n = I.escapeRegExp(n)), e.wholeWord && (i = e, n = r((o = n)[0]) + o + r(o[o.length - 1]));
            var o = e.caseSensitive ? "gm" : "gmi";
            if (e.$isMultiLine = !t && /[\n\r]/.test(n), e.$isMultiLine) return e.re = this.$assembleMultilineRegExp(n, o);

            try {
              var s = new RegExp(n, o);
            } catch (e) {
              s = !1;
            }

            return e.re = s;
          }, (this || _global).$assembleMultilineRegExp = function (e, t) {
            for (var i = e.replace(/\r\n|\r|\n/g, "$\n^").split("\n"), n = [], r = 0; r < i.length; r++) try {
              n.push(new RegExp(i[r], t));
            } catch (e) {
              return !1;
            }

            return n;
          }, (this || _global).$matchIterator = function (h, i) {
            var d = this.$assembleRegExp(i);
            if (!d) return !1;
            var a,
                n,
                l = 1 == i.backwards,
                e = 0 != i.skipCurrent,
                t = i.range,
                r = i.start,
                o = ((r = r || (t ? t[l ? "end" : "start"] : h.selection.getRange())).start && (r = r[e != l ? "end" : "start"]), t ? t.start.row : 0),
                s = t ? t.end.row : h.getLength() - 1;
            return n = i.$isMultiLine ? (a = d.length, function (e, t, i) {
              var n = l ? e - a + 1 : e;

              if (!(n < 0 || n + a > h.getLength())) {
                var r = h.getLine(n),
                    e = r.search(d[0]);

                if (!(!l && e < t || -1 === e)) {
                  for (var o = 1; o < a; o++) if (-1 == (r = h.getLine(n + o)).search(d[o])) return;

                  var s = r.match(d[a - 1])[0].length;
                  if (!(l && t < s)) return !!i(n, e, n + a - 1, s) || void 0;
                }
              }
            }) : l ? function (e, t, i) {
              var n,
                  r = h.getLine(e),
                  o = [];

              for (d.lastIndex = 0; n = d.exec(r);) {
                var s = n[0].length,
                    a = n.index;

                if (!s) {
                  if (a >= r.length) break;
                  d.lastIndex = a += 1;
                }

                if (n.index + s > t) break;
                o.push(n.index, s);
              }

              for (var l = o.length - 1; 0 <= l; l -= 2) {
                var c = o[l - 1];
                if (i(e, c, e, c + (s = o[l]))) return !0;
              }
            } : function (e, t, i) {
              var n = h.getLine(e);

              for (d.lastIndex = t; r = d.exec(n);) {
                var r,
                    o = r[0].length;
                if (i(e, r = r.index, e, r + o)) return !0;
                if (!o && (d.lastIndex = r += 1, r >= n.length)) return !1;
              }
            }, {
              forEach: l ? function (e) {
                var t = r.row;

                if (!n(t, r.column, e)) {
                  for (t--; o <= t; t--) if (n(t, Number.MAX_VALUE, e)) return;

                  if (0 != i.wrap) for (t = s, o = r.row; o <= t; t--) if (n(t, Number.MAX_VALUE, e)) return;
                }
              } : function (e) {
                var t = r.row;

                if (!n(t, r.column, e)) {
                  for (t += 1; t <= s; t++) if (n(t, 0, e)) return;

                  if (0 != i.wrap) for (t = o, s = r.row; t <= s; t++) if (n(t, 0, e)) return;
                }
              }
            };
          };
        }.call(n.prototype), t.Search = n;
      }), ace.define("ace/keyboard/hash_handler", ["require", "exports", "module", "ace/lib/keys", "ace/lib/useragent"], function (e, t, i) {
        "use strict";

        var a = e("../lib/keys"),
            n = e("../lib/useragent"),
            l = a.KEY_MODS;

        function r(e, t) {
          (this || _global).platform = t || (n.isMac ? "mac" : "win"), (this || _global).commands = {}, (this || _global).commandKeyBinding = {}, this.addCommands(e), (this || _global).$singleCommand = !0;
        }

        function o(e, t) {
          r.call(this || _global, e, t), (this || _global).$singleCommand = !1;
        }

        o.prototype = r.prototype, function () {
          function s(e) {
            return "object" == typeof e && e.bindKey && e.bindKey.position || (e.isDefault ? -100 : 0);
          }

          (this || _global).addCommand = function (e) {
            (this || _global).commands[e.name] && this.removeCommand(e), ((this || _global).commands[e.name] = e).bindKey && this._buildKeyHash(e);
          }, (this || _global).removeCommand = function (e, t) {
            var i,
                n = e && ("string" == typeof e ? e : e.name),
                r = (e = (this || _global).commands[n], t || delete (this || _global).commands[n], (this || _global).commandKeyBinding);

            for (i in r) {
              var o,
                  s = r[i];
              s == e ? delete r[i] : Array.isArray(s) && -1 != (o = s.indexOf(e)) && (s.splice(o, 1), 1 == s.length && (r[i] = s[0]));
            }
          }, (this || _global).bindKey = function (e, n, r) {
            if ("object" == typeof e && e && (null == r && (r = e.position), e = e[(this || _global).platform]), e) return "function" == typeof n ? this.addCommand({
              exec: n,
              bindKey: e,
              name: n.name || e
            }) : void e.split("|").forEach(function (e) {
              var t = "",
                  i = (-1 != e.indexOf(" ") && (e = (i = e.split(/\s+/)).pop(), i.forEach(function (e) {
                e = this.parseKeys(e), e = l[e.hashId] + e.key;
                t += (t ? " " : "") + e, this._addCommandToBinding(t, "chainKeys");
              }, this || _global), t += " "), this.parseKeys(e)),
                  e = l[i.hashId] + i.key;

              this._addCommandToBinding(t + e, n, r);
            }, this || _global);
          }, (this || _global)._addCommandToBinding = function (e, t, i) {
            var n = (this || _global).commandKeyBinding;
            if (t) {
              if (!n[e] || (this || _global).$singleCommand) n[e] = t;else {
                Array.isArray(n[e]) ? -1 != (o = n[e].indexOf(t)) && n[e].splice(o, 1) : n[e] = [n[e]], "number" != typeof i && (i = s(t));

                for (var r = n[e], o = 0; o < r.length; o++) if (i < s(r[o])) break;

                r.splice(o, 0, t);
              }
            } else delete n[e];
          }, (this || _global).addCommands = function (i) {
            i && Object.keys(i).forEach(function (e) {
              var t = i[e];

              if (t) {
                if ("string" == typeof t) return this.bindKey(t, e);
                "object" == typeof (t = "function" == typeof t ? {
                  exec: t
                } : t) && (t.name || (t.name = e), this.addCommand(t));
              }
            }, this || _global);
          }, (this || _global).removeCommands = function (t) {
            Object.keys(t).forEach(function (e) {
              this.removeCommand(t[e]);
            }, this || _global);
          }, (this || _global).bindKeys = function (t) {
            Object.keys(t).forEach(function (e) {
              this.bindKey(e, t[e]);
            }, this || _global);
          }, (this || _global)._buildKeyHash = function (e) {
            this.bindKey(e.bindKey, e);
          }, (this || _global).parseKeys = function (e) {
            var t = e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function (e) {
              return e;
            }),
                i = t.pop(),
                n = a[i];
            if (a.FUNCTION_KEYS[n]) i = a.FUNCTION_KEYS[n].toLowerCase();else {
              if (!t.length) return {
                key: i,
                hashId: -1
              };
              if (1 == t.length && "shift" == t[0]) return {
                key: i.toUpperCase(),
                hashId: -1
              };
            }

            for (var r = 0, o = t.length; o--;) {
              var s = a.KEY_MODS[t[o]];
              if (null == s) return "undefined" != typeof console && console.error("invalid modifier " + t[o] + " in " + e), !1;
              r |= s;
            }

            return {
              key: i,
              hashId: r
            };
          }, (this || _global).findKeyCommand = function (e, t) {
            e = l[e] + t;
            return (this || _global).commandKeyBinding[e];
          }, (this || _global).handleKeyboard = function (e, t, i, n) {
            var r, o;
            if (!(n < 0)) return r = l[t] + i, o = (this || _global).commandKeyBinding[r], e.$keyChain && (e.$keyChain += " " + r, o = (this || _global).commandKeyBinding[e.$keyChain] || o), !o || "chainKeys" != o && "chainKeys" != o[o.length - 1] ? (e.$keyChain && (t && 4 != t || 1 != i.length ? (-1 == t || 0 < n) && (e.$keyChain = "") : e.$keyChain = e.$keyChain.slice(0, -r.length - 1)), {
              command: o
            }) : (e.$keyChain = e.$keyChain || r, {
              command: "null"
            });
          }, (this || _global).getStatusText = function (e, t) {
            return t.$keyChain || "";
          };
        }.call(r.prototype), t.HashHandler = r, t.MultiHashHandler = o;
      }), ace.define("ace/commands/command_manager", ["require", "exports", "module", "ace/lib/oop", "ace/keyboard/hash_handler", "ace/lib/event_emitter"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          o.call(this || _global, t, e), (this || _global).byName = (this || _global).commands, this.setDefaultHandler("exec", function (e) {
            return e.command.exec(e.editor, e.args || {});
          });
        }

        var r = e("../lib/oop"),
            o = e("../keyboard/hash_handler").MultiHashHandler,
            s = e("../lib/event_emitter").EventEmitter;
        r.inherits(n, o), function () {
          r.implement(this || _global, s), (this || _global).exec = function (e, t, i) {
            if (Array.isArray(e)) {
              for (var n = e.length; n--;) if (this.exec(e[n], t, i)) return !0;

              return !1;
            }

            if (!(e = "string" == typeof e ? (this || _global).commands[e] : e)) return !1;
            if (t && t.$readOnly && !e.readOnly) return !1;
            if (0 != (this || _global).$checkCommandState && e.isAvailable && !e.isAvailable(t)) return !1;
            var r = {
              editor: t,
              command: e,
              args: i
            };
            return r.returnValue = this._emit("exec", r), this._signal("afterExec", r), !1 !== r.returnValue;
          }, (this || _global).toggleRecording = function (e) {
            if (!(this || _global).$inReplay) return e && e._emit("changeStatus"), (this || _global).recording ? ((this || _global).macro.pop(), this.off("exec", (this || _global).$addCommandToMacro), (this || _global).macro.length || ((this || _global).macro = (this || _global).oldMacro), (this || _global).recording = !1) : ((this || _global).$addCommandToMacro || ((this || _global).$addCommandToMacro = function (e) {
              (this || _global).macro.push([e.command, e.args]);
            }.bind(this || _global)), (this || _global).oldMacro = (this || _global).macro, (this || _global).macro = [], this.on("exec", (this || _global).$addCommandToMacro), (this || _global).recording = !0);
          }, (this || _global).replay = function (t) {
            if (!(this || _global).$inReplay && (this || _global).macro) {
              if ((this || _global).recording) return this.toggleRecording(t);

              try {
                (this || _global).$inReplay = !0, (this || _global).macro.forEach(function (e) {
                  "string" == typeof e ? this.exec(e, t) : this.exec(e[0], t, e[1]);
                }, this || _global);
              } finally {
                (this || _global).$inReplay = !1;
              }
            }
          }, (this || _global).trimMacro = function (e) {
            return e.map(function (e) {
              return "string" != typeof e[0] && (e[0] = e[0].name), e = e[1] ? e : e[0];
            });
          };
        }.call(n.prototype), t.CommandManager = n;
      }), ace.define("ace/commands/default_commands", ["require", "exports", "module", "ace/lib/lang", "ace/config", "ace/range"], function (e, t, i) {
        "use strict";

        var l = e("../lib/lang"),
            n = e("../config"),
            c = e("../range").Range;

        function r(e, t) {
          return {
            win: e,
            mac: t
          };
        }

        t.commands = [{
          name: "showSettingsMenu",
          description: "Show settings menu",
          bindKey: r("Ctrl-,", "Command-,"),
          exec: function (t) {
            n.loadModule("ace/ext/settings_menu", function (e) {
              e.init(t), t.showSettingsMenu();
            });
          },
          readOnly: !0
        }, {
          name: "goToNextError",
          description: "Go to next error",
          bindKey: r("Alt-E", "F4"),
          exec: function (t) {
            n.loadModule("./ext/error_marker", function (e) {
              e.showErrorMarker(t, 1);
            });
          },
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "goToPreviousError",
          description: "Go to previous error",
          bindKey: r("Alt-Shift-E", "Shift-F4"),
          exec: function (t) {
            n.loadModule("./ext/error_marker", function (e) {
              e.showErrorMarker(t, -1);
            });
          },
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "selectall",
          description: "Select all",
          bindKey: r("Ctrl-A", "Command-A"),
          exec: function (e) {
            e.selectAll();
          },
          readOnly: !0
        }, {
          name: "centerselection",
          description: "Center selection",
          bindKey: r(null, "Ctrl-L"),
          exec: function (e) {
            e.centerSelection();
          },
          readOnly: !0
        }, {
          name: "gotoline",
          description: "Go to line...",
          bindKey: r("Ctrl-L", "Command-L"),
          exec: function (e, t) {
            "number" != typeof t || isNaN(t) || e.gotoLine(t), e.prompt({
              $type: "gotoLine"
            });
          },
          readOnly: !0
        }, {
          name: "fold",
          bindKey: r("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
          exec: function (e) {
            e.session.toggleFold(!1);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "unfold",
          bindKey: r("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
          exec: function (e) {
            e.session.toggleFold(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "toggleFoldWidget",
          description: "Toggle fold widget",
          bindKey: r("F2", "F2"),
          exec: function (e) {
            e.session.toggleFoldWidget();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "toggleParentFoldWidget",
          description: "Toggle parent fold widget",
          bindKey: r("Alt-F2", "Alt-F2"),
          exec: function (e) {
            e.session.toggleFoldWidget(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldall",
          description: "Fold all",
          bindKey: r(null, "Ctrl-Command-Option-0"),
          exec: function (e) {
            e.session.foldAll();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldAllComments",
          description: "Fold all comments",
          bindKey: r(null, "Ctrl-Command-Option-0"),
          exec: function (e) {
            e.session.foldAllComments();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "foldOther",
          description: "Fold other",
          bindKey: r("Alt-0", "Command-Option-0"),
          exec: function (e) {
            e.session.foldAll(), e.session.unfold(e.selection.getAllRanges());
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "unfoldall",
          description: "Unfold all",
          bindKey: r("Alt-Shift-0", "Command-Option-Shift-0"),
          exec: function (e) {
            e.session.unfold();
          },
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "findnext",
          description: "Find next",
          bindKey: r("Ctrl-K", "Command-G"),
          exec: function (e) {
            e.findNext();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "findprevious",
          description: "Find previous",
          bindKey: r("Ctrl-Shift-K", "Command-Shift-G"),
          exec: function (e) {
            e.findPrevious();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "center",
          readOnly: !0
        }, {
          name: "selectOrFindNext",
          description: "Select or find next",
          bindKey: r("Alt-K", "Ctrl-G"),
          exec: function (e) {
            e.selection.isEmpty() ? e.selection.selectWord() : e.findNext();
          },
          readOnly: !0
        }, {
          name: "selectOrFindPrevious",
          description: "Select or find previous",
          bindKey: r("Alt-Shift-K", "Ctrl-Shift-G"),
          exec: function (e) {
            e.selection.isEmpty() ? e.selection.selectWord() : e.findPrevious();
          },
          readOnly: !0
        }, {
          name: "find",
          description: "Find",
          bindKey: r("Ctrl-F", "Command-F"),
          exec: function (t) {
            n.loadModule("ace/ext/searchbox", function (e) {
              e.Search(t);
            });
          },
          readOnly: !0
        }, {
          name: "overwrite",
          description: "Overwrite",
          bindKey: "Insert",
          exec: function (e) {
            e.toggleOverwrite();
          },
          readOnly: !0
        }, {
          name: "selecttostart",
          description: "Select to start",
          bindKey: r("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
          exec: function (e) {
            e.getSelection().selectFileStart();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "gotostart",
          description: "Go to start",
          bindKey: r("Ctrl-Home", "Command-Home|Command-Up"),
          exec: function (e) {
            e.navigateFileStart();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "selectup",
          description: "Select up",
          bindKey: r("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
          exec: function (e) {
            e.getSelection().selectUp();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "golineup",
          description: "Go line up",
          bindKey: r("Up", "Up|Ctrl-P"),
          exec: function (e, t) {
            e.navigateUp(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttoend",
          description: "Select to end",
          bindKey: r("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
          exec: function (e) {
            e.getSelection().selectFileEnd();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "gotoend",
          description: "Go to end",
          bindKey: r("Ctrl-End", "Command-End|Command-Down"),
          exec: function (e) {
            e.navigateFileEnd();
          },
          multiSelectAction: "forEach",
          readOnly: !0,
          scrollIntoView: "animate",
          aceCommandGroup: "fileJump"
        }, {
          name: "selectdown",
          description: "Select down",
          bindKey: r("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
          exec: function (e) {
            e.getSelection().selectDown();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "golinedown",
          description: "Go line down",
          bindKey: r("Down", "Down|Ctrl-N"),
          exec: function (e, t) {
            e.navigateDown(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectwordleft",
          description: "Select word left",
          bindKey: r("Ctrl-Shift-Left", "Option-Shift-Left"),
          exec: function (e) {
            e.getSelection().selectWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotowordleft",
          description: "Go to word left",
          bindKey: r("Ctrl-Left", "Option-Left"),
          exec: function (e) {
            e.navigateWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttolinestart",
          description: "Select to line start",
          bindKey: r("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
          exec: function (e) {
            e.getSelection().selectLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotolinestart",
          description: "Go to line start",
          bindKey: r("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
          exec: function (e) {
            e.navigateLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectleft",
          description: "Select left",
          bindKey: r("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
          exec: function (e) {
            e.getSelection().selectLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotoleft",
          description: "Go to left",
          bindKey: r("Left", "Left|Ctrl-B"),
          exec: function (e, t) {
            e.navigateLeft(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectwordright",
          description: "Select word right",
          bindKey: r("Ctrl-Shift-Right", "Option-Shift-Right"),
          exec: function (e) {
            e.getSelection().selectWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotowordright",
          description: "Go to word right",
          bindKey: r("Ctrl-Right", "Option-Right"),
          exec: function (e) {
            e.navigateWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selecttolineend",
          description: "Select to line end",
          bindKey: r("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
          exec: function (e) {
            e.getSelection().selectLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotolineend",
          description: "Go to line end",
          bindKey: r("Alt-Right|End", "Command-Right|End|Ctrl-E"),
          exec: function (e) {
            e.navigateLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectright",
          description: "Select right",
          bindKey: r("Shift-Right", "Shift-Right"),
          exec: function (e) {
            e.getSelection().selectRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "gotoright",
          description: "Go to right",
          bindKey: r("Right", "Right|Ctrl-F"),
          exec: function (e, t) {
            e.navigateRight(t.times);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectpagedown",
          description: "Select page down",
          bindKey: "Shift-PageDown",
          exec: function (e) {
            e.selectPageDown();
          },
          readOnly: !0
        }, {
          name: "pagedown",
          description: "Page down",
          bindKey: r(null, "Option-PageDown"),
          exec: function (e) {
            e.scrollPageDown();
          },
          readOnly: !0
        }, {
          name: "gotopagedown",
          description: "Go to page down",
          bindKey: r("PageDown", "PageDown|Ctrl-V"),
          exec: function (e) {
            e.gotoPageDown();
          },
          readOnly: !0
        }, {
          name: "selectpageup",
          description: "Select page up",
          bindKey: "Shift-PageUp",
          exec: function (e) {
            e.selectPageUp();
          },
          readOnly: !0
        }, {
          name: "pageup",
          description: "Page up",
          bindKey: r(null, "Option-PageUp"),
          exec: function (e) {
            e.scrollPageUp();
          },
          readOnly: !0
        }, {
          name: "gotopageup",
          description: "Go to page up",
          bindKey: "PageUp",
          exec: function (e) {
            e.gotoPageUp();
          },
          readOnly: !0
        }, {
          name: "scrollup",
          description: "Scroll up",
          bindKey: r("Ctrl-Up", null),
          exec: function (e) {
            e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
          },
          readOnly: !0
        }, {
          name: "scrolldown",
          description: "Scroll down",
          bindKey: r("Ctrl-Down", null),
          exec: function (e) {
            e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
          },
          readOnly: !0
        }, {
          name: "selectlinestart",
          description: "Select line start",
          bindKey: "Shift-Home",
          exec: function (e) {
            e.getSelection().selectLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectlineend",
          description: "Select line end",
          bindKey: "Shift-End",
          exec: function (e) {
            e.getSelection().selectLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "togglerecording",
          description: "Toggle recording",
          bindKey: r("Ctrl-Alt-E", "Command-Option-E"),
          exec: function (e) {
            e.commands.toggleRecording(e);
          },
          readOnly: !0
        }, {
          name: "replaymacro",
          description: "Replay macro",
          bindKey: r("Ctrl-Shift-E", "Command-Shift-E"),
          exec: function (e) {
            e.commands.replay(e);
          },
          readOnly: !0
        }, {
          name: "jumptomatching",
          description: "Jump to matching",
          bindKey: r("Ctrl-\\|Ctrl-P", "Command-\\"),
          exec: function (e) {
            e.jumpToMatching();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "selecttomatching",
          description: "Select to matching",
          bindKey: r("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
          exec: function (e) {
            e.jumpToMatching(!0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "expandToMatching",
          description: "Expand to matching",
          bindKey: r("Ctrl-Shift-M", "Ctrl-Shift-M"),
          exec: function (e) {
            e.jumpToMatching(!0, !0);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "animate",
          readOnly: !0
        }, {
          name: "passKeysToBrowser",
          description: "Pass keys to browser",
          bindKey: r(null, null),
          exec: function () {},
          passEvent: !0,
          readOnly: !0
        }, {
          name: "copy",
          description: "Copy",
          exec: function (e) {},
          readOnly: !0
        }, {
          name: "cut",
          description: "Cut",
          exec: function (e) {
            var t = e.$copyWithEmptySelection && e.selection.isEmpty() ? e.selection.getLineRange() : e.selection.getRange();
            e._emit("cut", t), t.isEmpty() || e.session.remove(t), e.clearSelection();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "paste",
          description: "Paste",
          exec: function (e, t) {
            e.$handlePaste(t);
          },
          scrollIntoView: "cursor"
        }, {
          name: "removeline",
          description: "Remove line",
          bindKey: r("Ctrl-D", "Command-D"),
          exec: function (e) {
            e.removeLines();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEachLine"
        }, {
          name: "duplicateSelection",
          description: "Duplicate selection",
          bindKey: r("Ctrl-Shift-D", "Command-Shift-D"),
          exec: function (e) {
            e.duplicateSelection();
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "sortlines",
          description: "Sort lines",
          bindKey: r("Ctrl-Alt-S", "Command-Alt-S"),
          exec: function (e) {
            e.sortLines();
          },
          scrollIntoView: "selection",
          multiSelectAction: "forEachLine"
        }, {
          name: "togglecomment",
          description: "Toggle comment",
          bindKey: r("Ctrl-/", "Command-/"),
          exec: function (e) {
            e.toggleCommentLines();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "toggleBlockComment",
          description: "Toggle block comment",
          bindKey: r("Ctrl-Shift-/", "Command-Shift-/"),
          exec: function (e) {
            e.toggleBlockComment();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "modifyNumberUp",
          description: "Modify number up",
          bindKey: r("Ctrl-Shift-Up", "Alt-Shift-Up"),
          exec: function (e) {
            e.modifyNumber(1);
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "modifyNumberDown",
          description: "Modify number down",
          bindKey: r("Ctrl-Shift-Down", "Alt-Shift-Down"),
          exec: function (e) {
            e.modifyNumber(-1);
          },
          scrollIntoView: "cursor",
          multiSelectAction: "forEach"
        }, {
          name: "replace",
          description: "Replace",
          bindKey: r("Ctrl-H", "Command-Option-F"),
          exec: function (t) {
            n.loadModule("ace/ext/searchbox", function (e) {
              e.Search(t, !0);
            });
          }
        }, {
          name: "undo",
          description: "Undo",
          bindKey: r("Ctrl-Z", "Command-Z"),
          exec: function (e) {
            e.undo();
          }
        }, {
          name: "redo",
          description: "Redo",
          bindKey: r("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
          exec: function (e) {
            e.redo();
          }
        }, {
          name: "copylinesup",
          description: "Copy lines up",
          bindKey: r("Alt-Shift-Up", "Command-Option-Up"),
          exec: function (e) {
            e.copyLinesUp();
          },
          scrollIntoView: "cursor"
        }, {
          name: "movelinesup",
          description: "Move lines up",
          bindKey: r("Alt-Up", "Option-Up"),
          exec: function (e) {
            e.moveLinesUp();
          },
          scrollIntoView: "cursor"
        }, {
          name: "copylinesdown",
          description: "Copy lines down",
          bindKey: r("Alt-Shift-Down", "Command-Option-Down"),
          exec: function (e) {
            e.copyLinesDown();
          },
          scrollIntoView: "cursor"
        }, {
          name: "movelinesdown",
          description: "Move lines down",
          bindKey: r("Alt-Down", "Option-Down"),
          exec: function (e) {
            e.moveLinesDown();
          },
          scrollIntoView: "cursor"
        }, {
          name: "del",
          description: "Delete",
          bindKey: r("Delete", "Delete|Ctrl-D|Shift-Delete"),
          exec: function (e) {
            e.remove("right");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "backspace",
          description: "Backspace",
          bindKey: r("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
          exec: function (e) {
            e.remove("left");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "cut_or_delete",
          description: "Cut or delete",
          bindKey: r("Shift-Delete", null),
          exec: function (e) {
            if (!e.selection.isEmpty()) return !1;
            e.remove("left");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolinestart",
          description: "Remove to line start",
          bindKey: r("Alt-Backspace", "Command-Backspace"),
          exec: function (e) {
            e.removeToLineStart();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolineend",
          description: "Remove to line end",
          bindKey: r("Alt-Delete", "Ctrl-K|Command-Delete"),
          exec: function (e) {
            e.removeToLineEnd();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolinestarthard",
          description: "Remove to line start hard",
          bindKey: r("Ctrl-Shift-Backspace", null),
          exec: function (e) {
            var t = e.selection.getRange();
            t.start.column = 0, e.session.remove(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removetolineendhard",
          description: "Remove to line end hard",
          bindKey: r("Ctrl-Shift-Delete", null),
          exec: function (e) {
            var t = e.selection.getRange();
            t.end.column = Number.MAX_VALUE, e.session.remove(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removewordleft",
          description: "Remove word left",
          bindKey: r("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
          exec: function (e) {
            e.removeWordLeft();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "removewordright",
          description: "Remove word right",
          bindKey: r("Ctrl-Delete", "Alt-Delete"),
          exec: function (e) {
            e.removeWordRight();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "outdent",
          description: "Outdent",
          bindKey: r("Shift-Tab", "Shift-Tab"),
          exec: function (e) {
            e.blockOutdent();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "indent",
          description: "Indent",
          bindKey: r("Tab", "Tab"),
          exec: function (e) {
            e.indent();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "selectionPart"
        }, {
          name: "blockoutdent",
          description: "Block outdent",
          bindKey: r("Ctrl-[", "Ctrl-["),
          exec: function (e) {
            e.blockOutdent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "blockindent",
          description: "Block indent",
          bindKey: r("Ctrl-]", "Ctrl-]"),
          exec: function (e) {
            e.blockIndent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "selectionPart"
        }, {
          name: "insertstring",
          description: "Insert string",
          exec: function (e, t) {
            e.insert(t);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "inserttext",
          description: "Insert text",
          exec: function (e, t) {
            e.insert(l.stringRepeat(t.text || "", t.times || 1));
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "splitline",
          description: "Split line",
          bindKey: r(null, "Ctrl-O"),
          exec: function (e) {
            e.splitLine();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "transposeletters",
          description: "Transpose letters",
          bindKey: r("Alt-Shift-X", "Ctrl-T"),
          exec: function (e) {
            e.transposeLetters();
          },
          multiSelectAction: function (e) {
            e.transposeSelections(1);
          },
          scrollIntoView: "cursor"
        }, {
          name: "touppercase",
          description: "To uppercase",
          bindKey: r("Ctrl-U", "Ctrl-U"),
          exec: function (e) {
            e.toUpperCase();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "tolowercase",
          description: "To lowercase",
          bindKey: r("Ctrl-Shift-U", "Ctrl-Shift-U"),
          exec: function (e) {
            e.toLowerCase();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "autoindent",
          description: "Auto Indent",
          bindKey: r(null, null),
          exec: function (e) {
            e.autoIndent();
          },
          multiSelectAction: "forEachLine",
          scrollIntoView: "animate"
        }, {
          name: "expandtoline",
          description: "Expand to line",
          bindKey: r("Ctrl-Shift-L", "Command-Shift-L"),
          exec: function (e) {
            var t = e.selection.getRange();
            t.start.column = t.end.column = 0, t.end.row++, e.selection.setRange(t, !1);
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "joinlines",
          description: "Join lines",
          bindKey: r(null, null),
          exec: function (e) {
            for (var t = e.selection.isBackwards(), i = t ? e.selection.getSelectionLead() : e.selection.getSelectionAnchor(), n = t ? e.selection.getSelectionAnchor() : e.selection.getSelectionLead(), t = e.session.doc.getLine(i.row).length, r = e.session.doc.getTextRange(e.selection.getRange()).replace(/\n\s*/, " ").length, o = e.session.doc.getLine(i.row), s = i.row + 1; s <= n.row + 1; s++) {
              var a = l.stringTrimLeft(l.stringTrimRight(e.session.doc.getLine(s)));
              o += a = 0 !== a.length ? " " + a : a;
            }

            n.row + 1 < e.session.doc.getLength() - 1 && (o += e.session.doc.getNewLineCharacter()), e.clearSelection(), e.session.doc.replace(new c(i.row, 0, n.row + 2, 0), o), 0 < r ? (e.selection.moveCursorTo(i.row, i.column), e.selection.selectTo(i.row, i.column + r)) : (t = e.session.doc.getLine(i.row).length > t ? t + 1 : t, e.selection.moveCursorTo(i.row, t));
          },
          multiSelectAction: "forEach",
          readOnly: !0
        }, {
          name: "invertSelection",
          description: "Invert selection",
          bindKey: r(null, null),
          exec: function (e) {
            var t = e.session.doc.getLength() - 1,
                i = e.session.doc.getLine(t).length,
                n = e.selection.rangeList.ranges,
                r = [];
            n.length < 1 && (n = [e.selection.getRange()]);

            for (var o = 0; o < n.length; o++) o != n.length - 1 || n[o].end.row === t && n[o].end.column === i || r.push(new c(n[o].end.row, n[o].end.column, t, i)), 0 === o ? 0 === n[o].start.row && 0 === n[o].start.column || r.push(new c(0, 0, n[o].start.row, n[o].start.column)) : r.push(new c(n[o - 1].end.row, n[o - 1].end.column, n[o].start.row, n[o].start.column));

            e.exitMultiSelectMode(), e.clearSelection();

            for (o = 0; o < r.length; o++) e.selection.addRange(r[o], !1);
          },
          readOnly: !0,
          scrollIntoView: "none"
        }, {
          name: "addLineAfter",
          description: "Add new line after the current line",
          exec: function (e) {
            e.selection.clearSelection(), e.navigateLineEnd(), e.insert("\n");
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "addLineBefore",
          description: "Add new line before the current line",
          exec: function (e) {
            e.selection.clearSelection();
            var t = e.getCursorPosition();
            e.selection.moveTo(t.row - 1, Number.MAX_VALUE), e.insert("\n"), 0 === t.row && e.navigateUp();
          },
          multiSelectAction: "forEach",
          scrollIntoView: "cursor"
        }, {
          name: "openCommandPallete",
          description: "Open command pallete",
          bindKey: r("F1", "F1"),
          exec: function (e) {
            e.prompt({
              $type: "commands"
            });
          },
          readOnly: !0
        }, {
          name: "modeSelect",
          description: "Change language mode...",
          bindKey: r(null, null),
          exec: function (e) {
            e.prompt({
              $type: "modes"
            });
          },
          readOnly: !0
        }];

        for (var o = 1; o < 9; o++) t.commands.push({
          name: "foldToLevel" + o,
          description: "Fold To Level " + o,
          level: o,
          exec: function (e) {
            e.session.foldToLevel((this || _global).level);
          },
          scrollIntoView: "center",
          readOnly: !0
        });
      }), ace.define("ace/editor", ["require", "exports", "module", "ace/lib/fixoldbrowsers", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/lib/useragent", "ace/keyboard/textinput", "ace/mouse/mouse_handler", "ace/mouse/fold_handler", "ace/keyboard/keybinding", "ace/edit_session", "ace/search", "ace/range", "ace/lib/event_emitter", "ace/commands/command_manager", "ace/commands/default_commands", "ace/config", "ace/token_iterator", "ace/clipboard"], function (e, t, i) {
        "use strict";

        e("./lib/fixoldbrowsers");

        function r(e, t, i) {
          (this || _global).$toDestroy = [];
          var n = e.getContainerElement();
          (this || _global).container = n, (this || _global).renderer = e, (this || _global).id = "editor" + ++r.$uid, (this || _global).commands = new p(s.isMac ? "mac" : "win", C), "object" == typeof document && ((this || _global).textInput = new a(e.getTextAreaContainer(), this || _global), (this || _global).renderer.textarea = (this || _global).textInput.getElement(), (this || _global).$mouseHandler = new l(this || _global), new c(this || _global)), (this || _global).keyBinding = new h(this || _global), (this || _global).$search = new u().set({
            wrap: !0
          }), (this || _global).$historyTracker = (this || _global).$historyTracker.bind(this || _global), (this || _global).commands.on("exec", (this || _global).$historyTracker), this.$initOperationListeners(), (this || _global)._$emitInputEvent = m.delayedCall(function () {
            this._signal("input", {}), (this || _global).session && (this || _global).session.bgTokenizer && (this || _global).session.bgTokenizer.scheduleStart();
          }.bind(this || _global)), this.on("change", function (e, t) {
            t._$emitInputEvent.schedule(31);
          }), this.setSession(t || i && i.session || new d("")), I.resetOptions(this || _global), i && this.setOptions(i), I._signal("editor", this || _global);
        }

        var o = e("./lib/oop"),
            n = e("./lib/dom"),
            m = e("./lib/lang"),
            s = e("./lib/useragent"),
            a = e("./keyboard/textinput").TextInput,
            l = e("./mouse/mouse_handler").MouseHandler,
            c = e("./mouse/fold_handler").FoldHandler,
            h = e("./keyboard/keybinding").KeyBinding,
            d = e("./edit_session").EditSession,
            u = e("./search").Search,
            f = e("./range").Range,
            g = e("./lib/event_emitter").EventEmitter,
            p = e("./commands/command_manager").CommandManager,
            C = e("./commands/default_commands").commands,
            I = e("./config"),
            v = e("./token_iterator").TokenIterator,
            A = e("./clipboard"),
            b = (r.$uid = 0, !function () {
          o.implement(this || _global, g), (this || _global).$initOperationListeners = function () {
            (this || _global).commands.on("exec", (this || _global).startOperation.bind(this || _global), !0), (this || _global).commands.on("afterExec", (this || _global).endOperation.bind(this || _global), !0), (this || _global).$opResetTimer = m.delayedCall((this || _global).endOperation.bind(this || _global, !0)), this.on("change", function () {
              (this || _global).curOp || (this.startOperation(), (this || _global).curOp.selectionBefore = (this || _global).$lastSel), (this || _global).curOp.docChanged = !0;
            }.bind(this || _global), !0), this.on("changeSelection", function () {
              (this || _global).curOp || (this.startOperation(), (this || _global).curOp.selectionBefore = (this || _global).$lastSel), (this || _global).curOp.selectionChanged = !0;
            }.bind(this || _global), !0);
          }, (this || _global).curOp = null, (this || _global).prevOp = {}, (this || _global).startOperation = function (e) {
            if ((this || _global).curOp) {
              if (!e || (this || _global).curOp.command) return;
              (this || _global).prevOp = (this || _global).curOp;
            }

            e || ((this || _global).previousCommand = null, e = {}), (this || _global).$opResetTimer.schedule(), (this || _global).curOp = (this || _global).session.curOp = {
              command: e.command || {},
              args: e.args,
              scrollTop: (this || _global).renderer.scrollTop
            }, (this || _global).curOp.selectionBefore = (this || _global).selection.toJSON();
          }, (this || _global).endOperation = function (e) {
            if ((this || _global).curOp && (this || _global).session) {
              if (e && !1 === e.returnValue || !(this || _global).session) return (this || _global).curOp = null;

              if ((1 != e || !(this || _global).curOp.command || "mouse" != (this || _global).curOp.command.name) && (this._signal("beforeEndOperation"), (this || _global).curOp)) {
                var e = (this || _global).curOp.command,
                    t = e && e.scrollIntoView;

                if (t) {
                  switch (t) {
                    case "center-animate":
                      t = "animate";

                    case "center":
                      (this || _global).renderer.scrollCursorIntoView(null, 0.5);

                      break;

                    case "animate":
                    case "cursor":
                      (this || _global).renderer.scrollCursorIntoView();

                      break;

                    case "selectionPart":
                      var i = (this || _global).selection.getRange(),
                          n = (this || _global).renderer.layerConfig;

                      (i.start.row >= n.lastRow || i.end.row <= n.firstRow) && (this || _global).renderer.scrollSelectionIntoView((this || _global).selection.anchor, (this || _global).selection.lead);
                  }

                  "animate" == t && (this || _global).renderer.animateScrolling((this || _global).curOp.scrollTop);
                }

                e = (this || _global).selection.toJSON();
                (this || _global).curOp.selectionAfter = e, (this || _global).$lastSel = (this || _global).selection.toJSON(), (this || _global).session.getUndoManager().addSelection(e), (this || _global).prevOp = (this || _global).curOp, (this || _global).curOp = null;
              }
            }
          }, (this || _global).$mergeableCommands = ["backspace", "del", "insertstring"], (this || _global).$historyTracker = function (e) {
            var t, i, n, r;
            (this || _global).$mergeUndoDeltas && (t = (this || _global).prevOp, i = (this || _global).$mergeableCommands, n = t.command && e.command.name == t.command.name, "insertstring" == e.command.name ? (r = e.args, void 0 === (this || _global).mergeNextCommand && ((this || _global).mergeNextCommand = !0), n = n && (this || _global).mergeNextCommand && (!/\s/.test(r) || /\s/.test(t.args)), (this || _global).mergeNextCommand = !0) : n = n && -1 !== i.indexOf(e.command.name), (n = "always" != (this || _global).$mergeUndoDeltas && 2000 < Date.now() - (this || _global).sequenceStartTime ? !1 : n) ? (this || _global).session.mergeUndoDeltas = !0 : -1 !== i.indexOf(e.command.name) && ((this || _global).sequenceStartTime = Date.now()));
          }, (this || _global).setKeyboardHandler = function (t, i) {
            var n;
            t && "string" == typeof t && "ace" != t ? ((this || _global).$keybindingId = t, n = this || _global, I.loadModule(["keybinding", t], function (e) {
              n.$keybindingId == t && n.keyBinding.setKeyboardHandler(e && e.handler), i && i();
            })) : ((this || _global).$keybindingId = null, (this || _global).keyBinding.setKeyboardHandler(t), i && i());
          }, (this || _global).getKeyboardHandler = function () {
            return (this || _global).keyBinding.getKeyboardHandler();
          }, (this || _global).setSession = function (e) {
            var t, i;
            (this || _global).session != e && ((this || _global).curOp && this.endOperation(), (this || _global).curOp = {}, (t = (this || _global).session) && ((this || _global).session.off("change", (this || _global).$onDocumentChange), (this || _global).session.off("changeMode", (this || _global).$onChangeMode), (this || _global).session.off("tokenizerUpdate", (this || _global).$onTokenizerUpdate), (this || _global).session.off("changeTabSize", (this || _global).$onChangeTabSize), (this || _global).session.off("changeWrapLimit", (this || _global).$onChangeWrapLimit), (this || _global).session.off("changeWrapMode", (this || _global).$onChangeWrapMode), (this || _global).session.off("changeFold", (this || _global).$onChangeFold), (this || _global).session.off("changeFrontMarker", (this || _global).$onChangeFrontMarker), (this || _global).session.off("changeBackMarker", (this || _global).$onChangeBackMarker), (this || _global).session.off("changeBreakpoint", (this || _global).$onChangeBreakpoint), (this || _global).session.off("changeAnnotation", (this || _global).$onChangeAnnotation), (this || _global).session.off("changeOverwrite", (this || _global).$onCursorChange), (this || _global).session.off("changeScrollTop", (this || _global).$onScrollTopChange), (this || _global).session.off("changeScrollLeft", (this || _global).$onScrollLeftChange), (i = (this || _global).session.getSelection()).off("changeCursor", (this || _global).$onCursorChange), i.off("changeSelection", (this || _global).$onSelectionChange)), ((this || _global).session = e) ? ((this || _global).$onDocumentChange = (this || _global).onDocumentChange.bind(this || _global), e.on("change", (this || _global).$onDocumentChange), (this || _global).renderer.setSession(e), (this || _global).$onChangeMode = (this || _global).onChangeMode.bind(this || _global), e.on("changeMode", (this || _global).$onChangeMode), (this || _global).$onTokenizerUpdate = (this || _global).onTokenizerUpdate.bind(this || _global), e.on("tokenizerUpdate", (this || _global).$onTokenizerUpdate), (this || _global).$onChangeTabSize = (this || _global).renderer.onChangeTabSize.bind((this || _global).renderer), e.on("changeTabSize", (this || _global).$onChangeTabSize), (this || _global).$onChangeWrapLimit = (this || _global).onChangeWrapLimit.bind(this || _global), e.on("changeWrapLimit", (this || _global).$onChangeWrapLimit), (this || _global).$onChangeWrapMode = (this || _global).onChangeWrapMode.bind(this || _global), e.on("changeWrapMode", (this || _global).$onChangeWrapMode), (this || _global).$onChangeFold = (this || _global).onChangeFold.bind(this || _global), e.on("changeFold", (this || _global).$onChangeFold), (this || _global).$onChangeFrontMarker = (this || _global).onChangeFrontMarker.bind(this || _global), (this || _global).session.on("changeFrontMarker", (this || _global).$onChangeFrontMarker), (this || _global).$onChangeBackMarker = (this || _global).onChangeBackMarker.bind(this || _global), (this || _global).session.on("changeBackMarker", (this || _global).$onChangeBackMarker), (this || _global).$onChangeBreakpoint = (this || _global).onChangeBreakpoint.bind(this || _global), (this || _global).session.on("changeBreakpoint", (this || _global).$onChangeBreakpoint), (this || _global).$onChangeAnnotation = (this || _global).onChangeAnnotation.bind(this || _global), (this || _global).session.on("changeAnnotation", (this || _global).$onChangeAnnotation), (this || _global).$onCursorChange = (this || _global).onCursorChange.bind(this || _global), (this || _global).session.on("changeOverwrite", (this || _global).$onCursorChange), (this || _global).$onScrollTopChange = (this || _global).onScrollTopChange.bind(this || _global), (this || _global).session.on("changeScrollTop", (this || _global).$onScrollTopChange), (this || _global).$onScrollLeftChange = (this || _global).onScrollLeftChange.bind(this || _global), (this || _global).session.on("changeScrollLeft", (this || _global).$onScrollLeftChange), (this || _global).selection = e.getSelection(), (this || _global).selection.on("changeCursor", (this || _global).$onCursorChange), (this || _global).$onSelectionChange = (this || _global).onSelectionChange.bind(this || _global), (this || _global).selection.on("changeSelection", (this || _global).$onSelectionChange), this.onChangeMode(), this.onCursorChange(), this.onScrollTopChange(), this.onScrollLeftChange(), this.onSelectionChange(), this.onChangeFrontMarker(), this.onChangeBackMarker(), this.onChangeBreakpoint(), this.onChangeAnnotation(), (this || _global).session.getUseWrapMode() && (this || _global).renderer.adjustWrapLimit(), (this || _global).renderer.updateFull()) : ((this || _global).selection = null, (this || _global).renderer.setSession(e)), this._signal("changeSession", {
              session: e,
              oldSession: t
            }), (this || _global).curOp = null, t && t._signal("changeEditor", {
              oldEditor: this || _global
            }), e && e._signal("changeEditor", {
              editor: this || _global
            }), e && e.bgTokenizer && e.bgTokenizer.scheduleStart());
          }, (this || _global).getSession = function () {
            return (this || _global).session;
          }, (this || _global).setValue = function (e, t) {
            return (this || _global).session.doc.setValue(e), t ? 1 == t ? this.navigateFileEnd() : -1 == t && this.navigateFileStart() : this.selectAll(), e;
          }, (this || _global).getValue = function () {
            return (this || _global).session.getValue();
          }, (this || _global).getSelection = function () {
            return (this || _global).selection;
          }, (this || _global).resize = function (e) {
            (this || _global).renderer.onResize(e);
          }, (this || _global).setTheme = function (e, t) {
            (this || _global).renderer.setTheme(e, t);
          }, (this || _global).getTheme = function () {
            return (this || _global).renderer.getTheme();
          }, (this || _global).setStyle = function (e) {
            (this || _global).renderer.setStyle(e);
          }, (this || _global).unsetStyle = function (e) {
            (this || _global).renderer.unsetStyle(e);
          }, (this || _global).getFontSize = function () {
            return this.getOption("fontSize") || n.computedStyle((this || _global).container).fontSize;
          }, (this || _global).setFontSize = function (e) {
            this.setOption("fontSize", e);
          }, (this || _global).$highlightBrackets = function () {
            var n;
            (this || _global).$highlightPending || ((n = this || _global).$highlightPending = !0, setTimeout(function () {
              n.$highlightPending = !1;
              var e,
                  t,
                  i = n.session;
              i && i.bgTokenizer && (i.$bracketHighlight && (i.$bracketHighlight.markerIds.forEach(function (e) {
                i.removeMarker(e);
              }), i.$bracketHighlight = null), (e = !(e = i.getMatchingBracketRanges(n.getCursorPosition())) && i.$mode.getMatching ? i.$mode.getMatching(n.session) : e) && (t = "ace_bracket", Array.isArray(e) ? 1 == e.length && (t = "ace_error_bracket") : e = [e], 2 == e.length && (0 == f.comparePoints(e[0].end, e[1].start) ? e = [f.fromPoints(e[0].start, e[1].end)] : 0 == f.comparePoints(e[0].start, e[1].end) && (e = [f.fromPoints(e[1].start, e[0].end)])), i.$bracketHighlight = {
                ranges: e,
                markerIds: e.map(function (e) {
                  return i.addMarker(e, t, "text");
                })
              }));
            }, 50));
          }, (this || _global).$highlightTags = function () {
            var u;
            (this || _global).$highlightTagPending || ((u = this || _global).$highlightTagPending = !0, setTimeout(function () {
              u.$highlightTagPending = !1;
              var e = u.session;

              if (e && e.bgTokenizer) {
                var t = u.getCursorPosition(),
                    i = new v(u.session, t.row, t.column),
                    n = i.getCurrentToken();
                if (!n || !/\b(?:tag-open|tag-name)/.test(n.type)) return e.removeMarker(e.$tagHighlight), void (e.$tagHighlight = null);

                if (-1 === n.type.indexOf("tag-open") || (n = i.stepForward())) {
                  var r = n.value,
                      o = n.value,
                      s = 0,
                      a = i.stepBackward();
                  if ("<" === a.value) for (; a = n, (n = i.stepForward()) && (-1 !== n.type.indexOf("tag-name") ? r === (o = n.value) && ("<" === a.value ? s++ : "</" === a.value && s--) : r === o && "/>" === n.value && s--), n && 0 <= s;);else {
                    do {
                      if (n = a, a = i.stepBackward(), n) if (-1 !== n.type.indexOf("tag-name")) r === n.value && ("<" === a.value ? s++ : "</" === a.value && s--);else if ("/>" === n.value) {
                        for (var l = 0, c = a; c;) {
                          if (-1 !== c.type.indexOf("tag-name") && c.value === r) {
                            s--;
                            break;
                          }

                          if ("<" === c.value) break;
                          c = i.stepBackward(), l++;
                        }

                        for (var h = 0; h < l; h++) i.stepForward();
                      }
                    } while (a && s <= 0);

                    i.stepForward();
                  }
                  if (!n) return e.removeMarker(e.$tagHighlight), void (e.$tagHighlight = null);
                  var t = i.getCurrentTokenRow(),
                      d = i.getCurrentTokenColumn(),
                      t = new f(t, d, t, d + n.value.length),
                      d = e.$backMarkers[e.$tagHighlight];
                  e.$tagHighlight && null != d && 0 !== t.compareRange(d.range) && (e.removeMarker(e.$tagHighlight), e.$tagHighlight = null), e.$tagHighlight || (e.$tagHighlight = e.addMarker(t, "ace_bracket", "text"));
                }
              }
            }, 50));
          }, (this || _global).focus = function () {
            var e = this || _global;
            setTimeout(function () {
              e.isFocused() || e.textInput.focus();
            }), (this || _global).textInput.focus();
          }, (this || _global).isFocused = function () {
            return (this || _global).textInput.isFocused();
          }, (this || _global).blur = function () {
            (this || _global).textInput.blur();
          }, (this || _global).onFocus = function (e) {
            (this || _global).$isFocused || ((this || _global).$isFocused = !0, (this || _global).renderer.showCursor(), (this || _global).renderer.visualizeFocus(), this._emit("focus", e));
          }, (this || _global).onBlur = function (e) {
            (this || _global).$isFocused && ((this || _global).$isFocused = !1, (this || _global).renderer.hideCursor(), (this || _global).renderer.visualizeBlur(), this._emit("blur", e));
          }, (this || _global).$cursorChange = function () {
            (this || _global).renderer.updateCursor(), this.$highlightBrackets(), this.$highlightTags(), this.$updateHighlightActiveLine();
          }, (this || _global).onDocumentChange = function (e) {
            var t = (this || _global).session.$useWrapMode,
                i = e.start.row == e.end.row ? e.end.row : 1 / 0;
            (this || _global).renderer.updateLines(e.start.row, i, t), this._signal("change", e), this.$cursorChange();
          }, (this || _global).onTokenizerUpdate = function (e) {
            e = e.data;

            (this || _global).renderer.updateLines(e.first, e.last);
          }, (this || _global).onScrollTopChange = function () {
            (this || _global).renderer.scrollToY((this || _global).session.getScrollTop());
          }, (this || _global).onScrollLeftChange = function () {
            (this || _global).renderer.scrollToX((this || _global).session.getScrollLeft());
          }, (this || _global).onCursorChange = function () {
            this.$cursorChange(), this._signal("changeSelection");
          }, (this || _global).$updateHighlightActiveLine = function () {
            var e,
                t,
                i = this.getSession();
            (this || _global).$highlightActiveLine && ("line" == (this || _global).$selectionStyle && (this || _global).selection.isMultiLine() || (e = this.getCursorPosition()), (this || _global).renderer.theme && (this || _global).renderer.theme.$selectionColorConflict && !(this || _global).selection.isEmpty() && (e = !1), !(this || _global).renderer.$maxLines || 1 !== (this || _global).session.getLength() || 1 < (this || _global).renderer.$minLines || (e = !1)), i.$highlightLineMarker && !e ? (i.removeMarker(i.$highlightLineMarker.id), i.$highlightLineMarker = null) : !i.$highlightLineMarker && e ? ((t = new f(e.row, e.column, e.row, 1 / 0)).id = i.addMarker(t, "ace_active-line", "screenLine"), i.$highlightLineMarker = t) : e && (i.$highlightLineMarker.start.row = e.row, i.$highlightLineMarker.end.row = e.row, i.$highlightLineMarker.start.column = e.column, i._signal("changeBackMarker"));
          }, (this || _global).onSelectionChange = function (e) {
            var t,
                i,
                n = (this || _global).session,
                n = (n.$selectionMarker && n.removeMarker(n.$selectionMarker), n.$selectionMarker = null, (this || _global).selection.isEmpty() ? this.$updateHighlightActiveLine() : (t = (this || _global).selection.getRange(), i = this.getSelectionStyle(), n.$selectionMarker = n.addMarker(t, "ace_selection", i)), (this || _global).$highlightSelectedWord && this.$getSelectionHighLightRegexp());
            (this || _global).session.highlight(n), this._signal("changeSelection");
          }, (this || _global).$getSelectionHighLightRegexp = function () {
            var e = (this || _global).session,
                t = this.getSelectionRange();

            if (!t.isEmpty() && !t.isMultiLine()) {
              var i = t.start.column,
                  n = t.end.column,
                  e = e.getLine(t.start.row),
                  t = e.substring(i, n);

              if (!(5000 < t.length) && /[\w\d]/.test(t)) {
                t = (this || _global).$search.$assembleRegExp({
                  wholeWord: !0,
                  caseSensitive: !0,
                  needle: t
                }), e = e.substring(i - 1, n + 1);
                if (t.test(e)) return t;
              }
            }
          }, (this || _global).onChangeFrontMarker = function () {
            (this || _global).renderer.updateFrontMarkers();
          }, (this || _global).onChangeBackMarker = function () {
            (this || _global).renderer.updateBackMarkers();
          }, (this || _global).onChangeBreakpoint = function () {
            (this || _global).renderer.updateBreakpoints();
          }, (this || _global).onChangeAnnotation = function () {
            (this || _global).renderer.setAnnotations((this || _global).session.getAnnotations());
          }, (this || _global).onChangeMode = function (e) {
            (this || _global).renderer.updateText(), this._emit("changeMode", e);
          }, (this || _global).onChangeWrapLimit = function () {
            (this || _global).renderer.updateFull();
          }, (this || _global).onChangeWrapMode = function () {
            (this || _global).renderer.onResize(!0);
          }, (this || _global).onChangeFold = function () {
            this.$updateHighlightActiveLine(), (this || _global).renderer.updateFull();
          }, (this || _global).getSelectedText = function () {
            return (this || _global).session.getTextRange(this.getSelectionRange());
          }, (this || _global).getCopyText = function () {
            var e = this.getSelectedText(),
                t = (this || _global).session.doc.getNewLineCharacter(),
                i = !1;

            if (!e && (this || _global).$copyWithEmptySelection) for (var i = !0, n = (this || _global).selection.getAllRanges(), r = 0; r < n.length; r++) {
              var o = n[r];
              r && n[r - 1].start.row == o.start.row || (e += (this || _global).session.getLine(o.start.row) + t);
            }
            var s = {
              text: e
            };
            return this._signal("copy", s), A.lineMode = !!i && s.text, s.text;
          }, (this || _global).onCopy = function () {
            (this || _global).commands.exec("copy", this || _global);
          }, (this || _global).onCut = function () {
            (this || _global).commands.exec("cut", this || _global);
          }, (this || _global).onPaste = function (e, t) {
            (this || _global).commands.exec("paste", this || _global, {
              text: e,
              event: t
            });
          }, (this || _global).$handlePaste = function (e) {
            this._signal("paste", e = "string" == typeof e ? {
              text: e
            } : e);

            var t = e.text,
                e = t === A.lineMode,
                i = (this || _global).session;
            if (!(this || _global).inMultiSelectMode || (this || _global).inVirtualSelectionMode) e ? i.insert({
              row: (this || _global).selection.lead.row,
              column: 0
            }, t) : this.insert(t);else if (e) (this || _global).selection.rangeList.ranges.forEach(function (e) {
              i.insert({
                row: e.start.row,
                column: 0
              }, t);
            });else {
              var n = t.split(/\r\n|\r|\n/),
                  r = (this || _global).selection.rangeList.ranges,
                  e = !(2 != n.length || n[0] && n[1]);
              if (n.length != r.length || e) return (this || _global).commands.exec("insertstring", this || _global, t);

              for (var o = r.length; o--;) {
                var s = r[o];
                s.isEmpty() || i.remove(s), i.insert(s.start, n[o]);
              }
            }
          }, (this || _global).execCommand = function (e, t) {
            return (this || _global).commands.exec(e, this || _global, t);
          }, (this || _global).insert = function (e, t) {
            var i,
                n = (this || _global).session,
                r = n.getMode(),
                o = this.getCursorPosition(),
                s = (!this.getBehavioursEnabled() || t || (i = r.transformAction(n.getState(o.row), "insertion", this || _global, n, e)) && (e === i.text || (this || _global).inVirtualSelectionMode || ((this || _global).session.mergeUndoDeltas = !1, (this || _global).mergeNextCommand = !1), e = i.text), "\t" == e && (e = (this || _global).session.getTabString()), (this || _global).selection.isEmpty() ? (this || _global).session.getOverwrite() && -1 == e.indexOf("\n") && ((s = new f.fromPoints(o, o)).end.column += e.length, (this || _global).session.remove(s)) : (s = this.getSelectionRange(), o = (this || _global).session.remove(s), this.clearSelection()), "\n" != e && "\r\n" != e || (a = n.getLine(o.row), o.column > a.search(/\S|$/) && (t = a.substr(o.column).search(/\S|$/), n.doc.removeInLine(o.row, o.column, o.column + t))), this.clearSelection(), o.column),
                t = n.getState(o.row),
                a = n.getLine(o.row),
                l = r.checkOutdent(t, a, e);
            n.insert(o, e), i && i.selection && (2 == i.selection.length ? (this || _global).selection.setSelectionRange(new f(o.row, s + i.selection[0], o.row, s + i.selection[1])) : (this || _global).selection.setSelectionRange(new f(o.row + i.selection[0], i.selection[1], o.row + i.selection[2], i.selection[3]))), (this || _global).$enableAutoIndent && (n.getDocument().isNewLine(e) && (s = r.getNextLineIndent(t, a.slice(0, o.column), n.getTabString()), n.insert({
              row: o.row + 1,
              column: 0
            }, s)), l && r.autoOutdent(t, n, o.row));
          }, (this || _global).autoIndent = function () {
            for (var e, t, i, n, r, o = (this || _global).session, s = o.getMode(), a = (i = (this || _global).selection.isEmpty() ? (t = 0, o.doc.getLength() - 1) : (t = (e = this.getSelectionRange()).start.row, e.end.row), ""), l = "", c = o.getTabString(), h = t; h <= i; h++) 0 < h && (a = o.getState(h - 1), n = o.getLine(h - 1), l = s.getNextLineIndent(a, n, c)), n = o.getLine(h), l !== (r = s.$getIndent(n)) && (0 < r.length && (r = new f(h, 0, h, r.length), o.remove(r)), 0 < l.length && o.insert({
              row: h,
              column: 0
            }, l)), s.autoOutdent(a, o, h);
          }, (this || _global).onTextInput = function (e, t) {
            if (!t) return (this || _global).keyBinding.onTextInput(e);
            this.startOperation({
              command: {
                name: "insertstring"
              }
            });
            e = (this || _global).applyComposition.bind(this || _global, e, t);
            (this || _global).selection.rangeCount ? this.forEachSelection(e) : e(), this.endOperation();
          }, (this || _global).applyComposition = function (e, t) {
            var i;
            (t.extendLeft || t.extendRight) && ((i = (this || _global).selection.getRange()).start.column -= t.extendLeft, i.end.column += t.extendRight, i.start.column < 0 && (i.start.row--, i.start.column += (this || _global).session.getLine(i.start.row).length + 1), (this || _global).selection.setRange(i), e || i.isEmpty() || this.remove()), !e && (this || _global).selection.isEmpty() || this.insert(e, !0), (t.restoreStart || t.restoreEnd) && ((i = (this || _global).selection.getRange()).start.column -= t.restoreStart, i.end.column -= t.restoreEnd, (this || _global).selection.setRange(i));
          }, (this || _global).onCommandKey = function (e, t, i) {
            return (this || _global).keyBinding.onCommandKey(e, t, i);
          }, (this || _global).setOverwrite = function (e) {
            (this || _global).session.setOverwrite(e);
          }, (this || _global).getOverwrite = function () {
            return (this || _global).session.getOverwrite();
          }, (this || _global).toggleOverwrite = function () {
            (this || _global).session.toggleOverwrite();
          }, (this || _global).setScrollSpeed = function (e) {
            this.setOption("scrollSpeed", e);
          }, (this || _global).getScrollSpeed = function () {
            return this.getOption("scrollSpeed");
          }, (this || _global).setDragDelay = function (e) {
            this.setOption("dragDelay", e);
          }, (this || _global).getDragDelay = function () {
            return this.getOption("dragDelay");
          }, (this || _global).setSelectionStyle = function (e) {
            this.setOption("selectionStyle", e);
          }, (this || _global).getSelectionStyle = function () {
            return this.getOption("selectionStyle");
          }, (this || _global).setHighlightActiveLine = function (e) {
            this.setOption("highlightActiveLine", e);
          }, (this || _global).getHighlightActiveLine = function () {
            return this.getOption("highlightActiveLine");
          }, (this || _global).setHighlightGutterLine = function (e) {
            this.setOption("highlightGutterLine", e);
          }, (this || _global).getHighlightGutterLine = function () {
            return this.getOption("highlightGutterLine");
          }, (this || _global).setHighlightSelectedWord = function (e) {
            this.setOption("highlightSelectedWord", e);
          }, (this || _global).getHighlightSelectedWord = function () {
            return (this || _global).$highlightSelectedWord;
          }, (this || _global).setAnimatedScroll = function (e) {
            (this || _global).renderer.setAnimatedScroll(e);
          }, (this || _global).getAnimatedScroll = function () {
            return (this || _global).renderer.getAnimatedScroll();
          }, (this || _global).setShowInvisibles = function (e) {
            (this || _global).renderer.setShowInvisibles(e);
          }, (this || _global).getShowInvisibles = function () {
            return (this || _global).renderer.getShowInvisibles();
          }, (this || _global).setDisplayIndentGuides = function (e) {
            (this || _global).renderer.setDisplayIndentGuides(e);
          }, (this || _global).getDisplayIndentGuides = function () {
            return (this || _global).renderer.getDisplayIndentGuides();
          }, (this || _global).setShowPrintMargin = function (e) {
            (this || _global).renderer.setShowPrintMargin(e);
          }, (this || _global).getShowPrintMargin = function () {
            return (this || _global).renderer.getShowPrintMargin();
          }, (this || _global).setPrintMarginColumn = function (e) {
            (this || _global).renderer.setPrintMarginColumn(e);
          }, (this || _global).getPrintMarginColumn = function () {
            return (this || _global).renderer.getPrintMarginColumn();
          }, (this || _global).setReadOnly = function (e) {
            this.setOption("readOnly", e);
          }, (this || _global).getReadOnly = function () {
            return this.getOption("readOnly");
          }, (this || _global).setBehavioursEnabled = function (e) {
            this.setOption("behavioursEnabled", e);
          }, (this || _global).getBehavioursEnabled = function () {
            return this.getOption("behavioursEnabled");
          }, (this || _global).setWrapBehavioursEnabled = function (e) {
            this.setOption("wrapBehavioursEnabled", e);
          }, (this || _global).getWrapBehavioursEnabled = function () {
            return this.getOption("wrapBehavioursEnabled");
          }, (this || _global).setShowFoldWidgets = function (e) {
            this.setOption("showFoldWidgets", e);
          }, (this || _global).getShowFoldWidgets = function () {
            return this.getOption("showFoldWidgets");
          }, (this || _global).setFadeFoldWidgets = function (e) {
            this.setOption("fadeFoldWidgets", e);
          }, (this || _global).getFadeFoldWidgets = function () {
            return this.getOption("fadeFoldWidgets");
          }, (this || _global).remove = function (e) {
            (this || _global).selection.isEmpty() && ("left" == e ? (this || _global).selection.selectLeft() : (this || _global).selection.selectRight());
            var t,
                i,
                n,
                e = this.getSelectionRange();
            this.getBehavioursEnabled() && (i = (t = (this || _global).session).getState(e.start.row), i = t.getMode().transformAction(i, "deletion", this || _global, t, e), 0 === e.end.column && "\n" == (n = t.getTextRange(e))[n.length - 1] && (n = t.getLine(e.end.row), /^\s+$/.test(n) && (e.end.column = n.length)), i && (e = i)), (this || _global).session.remove(e), this.clearSelection();
          }, (this || _global).removeWordRight = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectWordRight(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, (this || _global).removeWordLeft = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectWordLeft(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, (this || _global).removeToLineStart = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectLineStart(), (this || _global).selection.isEmpty() && (this || _global).selection.selectLeft(), (this || _global).session.remove(this.getSelectionRange()), this.clearSelection();
          }, (this || _global).removeToLineEnd = function () {
            (this || _global).selection.isEmpty() && (this || _global).selection.selectLineEnd();
            var e = this.getSelectionRange();
            e.start.column == e.end.column && e.start.row == e.end.row && (e.end.column = 0, e.end.row++), (this || _global).session.remove(e), this.clearSelection();
          }, (this || _global).splitLine = function () {
            (this || _global).selection.isEmpty() || ((this || _global).session.remove(this.getSelectionRange()), this.clearSelection());
            var e = this.getCursorPosition();
            this.insert("\n"), this.moveCursorToPosition(e);
          }, (this || _global).transposeLetters = function () {
            var e, t, i, n;
            !(this || _global).selection.isEmpty() || 0 !== (t = (e = this.getCursorPosition()).column) && (n = t < (n = (this || _global).session.getLine(e.row)).length ? (i = n.charAt(t) + n.charAt(t - 1), new f(e.row, t - 1, e.row, t + 1)) : (i = n.charAt(t - 1) + n.charAt(t - 2), new f(e.row, t - 2, e.row, t)), (this || _global).session.replace(n, i), (this || _global).session.selection.moveToPosition(n.end));
          }, (this || _global).toLowerCase = function () {
            var e = this.getSelectionRange(),
                t = ((this || _global).selection.isEmpty() && (this || _global).selection.selectWord(), this.getSelectionRange()),
                i = (this || _global).session.getTextRange(t);

            (this || _global).session.replace(t, i.toLowerCase()), (this || _global).selection.setSelectionRange(e);
          }, (this || _global).toUpperCase = function () {
            var e = this.getSelectionRange(),
                t = ((this || _global).selection.isEmpty() && (this || _global).selection.selectWord(), this.getSelectionRange()),
                i = (this || _global).session.getTextRange(t);

            (this || _global).session.replace(t, i.toUpperCase()), (this || _global).selection.setSelectionRange(e);
          }, (this || _global).indent = function () {
            var e = (this || _global).session,
                t = this.getSelectionRange();
            if (t.start.row < t.end.row) return r = this.$getSelectedRows(), void e.indentRows(r.first, r.last, "\t");

            if (t.start.column < t.end.column) {
              var i = e.getTextRange(t);
              if (!/^\s+$/.test(i)) return r = this.$getSelectedRows(), void e.indentRows(r.first, r.last, "\t");
            }

            var n = e.getLine(t.start.row),
                i = t.start,
                r = e.getTabSize(),
                e = e.documentToScreenColumn(i.row, i.column);
            if ((this || _global).session.getUseSoftTabs()) var o = r - e % r,
                s = m.stringRepeat(" ", o);else {
              for (o = e % r; " " == n[t.start.column - 1] && o;) t.start.column--, o--;

              (this || _global).selection.setSelectionRange(t), s = "\t";
            }
            return this.insert(s);
          }, (this || _global).blockIndent = function () {
            var e = this.$getSelectedRows();

            (this || _global).session.indentRows(e.first, e.last, "\t");
          }, (this || _global).blockOutdent = function () {
            var e = (this || _global).session.getSelection();

            (this || _global).session.outdentRows(e.getRange());
          }, (this || _global).sortLines = function () {
            for (var e = this.$getSelectedRows(), t = (this || _global).session, i = [], n = e.first; n <= e.last; n++) i.push(t.getLine(n));

            i.sort(function (e, t) {
              return e.toLowerCase() < t.toLowerCase() ? -1 : e.toLowerCase() > t.toLowerCase() ? 1 : 0;
            });

            for (var r = new f(0, 0, 0, 0), n = e.first; n <= e.last; n++) {
              var o = t.getLine(n);
              r.start.row = n, r.end.row = n, r.end.column = o.length, t.replace(r, i[n - e.first]);
            }
          }, (this || _global).toggleCommentLines = function () {
            var e = (this || _global).session.getState(this.getCursorPosition().row),
                t = this.$getSelectedRows();

            (this || _global).session.getMode().toggleCommentLines(e, (this || _global).session, t.first, t.last);
          }, (this || _global).toggleBlockComment = function () {
            var e = this.getCursorPosition(),
                t = (this || _global).session.getState(e.row),
                i = this.getSelectionRange();

            (this || _global).session.getMode().toggleBlockComment(t, (this || _global).session, i, e);
          }, (this || _global).getNumberAt = function (e, t) {
            for (var i = /[\-]?[0-9]+(?:\.[0-9]+)?/g, n = (i.lastIndex = 0, (this || _global).session.getLine(e)); i.lastIndex < t;) {
              var r = i.exec(n);
              if (r.index <= t && r.index + r[0].length >= t) return {
                value: r[0],
                start: r.index,
                end: r.index + r[0].length
              };
            }

            return null;
          }, (this || _global).modifyNumber = function (e) {
            var t,
                i,
                n,
                r = (this || _global).selection.getCursor().row,
                o = (this || _global).selection.getCursor().column,
                s = new f(r, o - 1, r, o),
                s = (this || _global).session.getTextRange(s);

            !isNaN(parseFloat(s)) && isFinite(s) ? (s = this.getNumberAt(r, o)) && (n = 0 <= s.value.indexOf(".") ? s.start + s.value.indexOf(".") + 1 : s.end, t = s.start + s.value.length - n, i = parseFloat(s.value), i *= Math.pow(10, t), n !== s.end && o < n ? e *= Math.pow(10, s.end - o - 1) : e *= Math.pow(10, s.end - o), n = (i = (i += e) / Math.pow(10, t)).toFixed(t), e = new f(r, s.start, r, s.end), (this || _global).session.replace(e, n), this.moveCursorTo(r, Math.max(s.start + 1, o + n.length - s.value.length))) : this.toggleWord();
          }, (this || _global).$toggleWordPairs = [["first", "last"], ["true", "false"], ["yes", "no"], ["width", "height"], ["top", "bottom"], ["right", "left"], ["on", "off"], ["x", "y"], ["get", "set"], ["max", "min"], ["horizontal", "vertical"], ["show", "hide"], ["add", "remove"], ["up", "down"], ["before", "after"], ["even", "odd"], ["in", "out"], ["inside", "outside"], ["next", "previous"], ["increase", "decrease"], ["attach", "detach"], ["&&", "||"], ["==", "!="]], (this || _global).toggleWord = function () {
            for (var i, n = (this || _global).selection.getCursor().row, e = (this || _global).selection.getCursor().column, r = ((this || _global).selection.selectWord(), this.getSelectedText()), o = (this || _global).selection.getWordRange().start.column, t = r.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/), s = e - o - 1, a = (s < 0 && (s = 0), 0), l = this || _global, c = (r.match(/[A-Za-z0-9_]+/) && t.forEach(function (e, t) {
              i = a + e.length, a <= s && s <= i && (r = e, l.selection.clearSelection(), l.moveCursorTo(n, a + o), l.selection.selectTo(n, i + o)), a = i;
            }), (this || _global).$toggleWordPairs), h = 0; h < c.length; h++) for (var d = c[h], u = 0; u <= 1; u++) {
              var g = +!u,
                  p = r.match(new RegExp("^\\s?_?(" + m.escapeRegExp(d[u]) + ")\\s?$", "i"));
              p && r.match(new RegExp("([_]|^|\\s)(" + m.escapeRegExp(p[1]) + ")($|\\s)", "g")) && (p = r.replace(new RegExp(m.escapeRegExp(d[u]), "i"), function (e) {
                var t = d[g];
                return e.toUpperCase() == e ? t = t.toUpperCase() : e.charAt(0).toUpperCase() == e.charAt(0) && (t = t.substr(0, 0) + d[g].charAt(0).toUpperCase() + t.substr(1)), t;
              }), this.insert(p));
            }
          }, (this || _global).removeLines = function () {
            var e = this.$getSelectedRows();
            (this || _global).session.removeFullLines(e.first, e.last), this.clearSelection();
          }, (this || _global).duplicateSelection = function () {
            var e,
                t = (this || _global).selection,
                i = (this || _global).session,
                n = t.getRange(),
                r = t.isBackwards();
            n.isEmpty() ? (e = n.start.row, i.duplicateLines(e, e)) : (e = r ? n.start : n.end, i = i.insert(e, i.getTextRange(n), !1), n.start = e, n.end = i, t.setSelectionRange(n, r));
          }, (this || _global).moveLinesDown = function () {
            this.$moveLines(1, !1);
          }, (this || _global).moveLinesUp = function () {
            this.$moveLines(-1, !1);
          }, (this || _global).moveText = function (e, t, i) {
            return (this || _global).session.moveText(e, t, i);
          }, (this || _global).copyLinesUp = function () {
            this.$moveLines(-1, !0);
          }, (this || _global).copyLinesDown = function () {
            this.$moveLines(1, !0);
          }, (this || _global).$moveLines = function (e, t) {
            var i = (this || _global).selection;

            if (!i.inMultiSelectMode || (this || _global).inVirtualSelectionMode) {
              var n = i.toOrientedRange(),
                  r = this.$getSelectedRows(n),
                  o = (this || _global).session.$moveLines(r.first, r.last, t ? 0 : e);

              n.moveBy(o = t && -1 == e ? 0 : o, 0), i.fromOrientedRange(n);
            } else {
              for (var s = i.rangeList.ranges, a = (i.rangeList.detach((this || _global).session), (this || _global).inVirtualSelectionMode = !0, 0), l = 0, c = s.length, h = 0; h < c; h++) {
                for (var d = h, u = (s[h].moveBy(a, 0), (r = this.$getSelectedRows(s[h])).first), g = r.last; ++h < c;) {
                  l && s[h].moveBy(l, 0);
                  var p = this.$getSelectedRows(s[h]);
                  if (t && p.first != g) break;
                  if (!t && p.first > g + 1) break;
                  g = p.last;
                }

                for (h--, a = (this || _global).session.$moveLines(u, g, t ? 0 : e), t && -1 == e && (d = h + 1); d <= h;) s[d].moveBy(a, 0), d++;

                l += a = t ? a : 0;
              }

              i.fromOrientedRange(i.ranges[0]), i.rangeList.attach((this || _global).session), (this || _global).inVirtualSelectionMode = !1;
            }
          }, (this || _global).$getSelectedRows = function (e) {
            return e = (e || this.getSelectionRange()).collapseRows(), {
              first: (this || _global).session.getRowFoldStart(e.start.row),
              last: (this || _global).session.getRowFoldEnd(e.end.row)
            };
          }, (this || _global).onCompositionStart = function (e) {
            (this || _global).renderer.showComposition(e);
          }, (this || _global).onCompositionUpdate = function (e) {
            (this || _global).renderer.setCompositionText(e);
          }, (this || _global).onCompositionEnd = function () {
            (this || _global).renderer.hideComposition();
          }, (this || _global).getFirstVisibleRow = function () {
            return (this || _global).renderer.getFirstVisibleRow();
          }, (this || _global).getLastVisibleRow = function () {
            return (this || _global).renderer.getLastVisibleRow();
          }, (this || _global).isRowVisible = function (e) {
            return e >= this.getFirstVisibleRow() && e <= this.getLastVisibleRow();
          }, (this || _global).isRowFullyVisible = function (e) {
            return e >= (this || _global).renderer.getFirstFullyVisibleRow() && e <= (this || _global).renderer.getLastFullyVisibleRow();
          }, (this || _global).$getVisibleRowCount = function () {
            return (this || _global).renderer.getScrollBottomRow() - (this || _global).renderer.getScrollTopRow() + 1;
          }, (this || _global).$moveByPage = function (e, t) {
            var i = (this || _global).renderer,
                n = (this || _global).renderer.layerConfig,
                r = e * Math.floor(n.height / n.lineHeight),
                e = (!0 === t ? (this || _global).selection.$moveSelection(function () {
              this.moveCursorBy(r, 0);
            }) : !1 === t && ((this || _global).selection.moveCursorBy(r, 0), (this || _global).selection.clearSelection()), i.scrollTop);
            i.scrollBy(0, r * n.lineHeight), null != t && i.scrollCursorIntoView(null, 0.5), i.animateScrolling(e);
          }, (this || _global).selectPageDown = function () {
            this.$moveByPage(1, !0);
          }, (this || _global).selectPageUp = function () {
            this.$moveByPage(-1, !0);
          }, (this || _global).gotoPageDown = function () {
            this.$moveByPage(1, !1);
          }, (this || _global).gotoPageUp = function () {
            this.$moveByPage(-1, !1);
          }, (this || _global).scrollPageDown = function () {
            this.$moveByPage(1);
          }, (this || _global).scrollPageUp = function () {
            this.$moveByPage(-1);
          }, (this || _global).scrollToRow = function (e) {
            (this || _global).renderer.scrollToRow(e);
          }, (this || _global).scrollToLine = function (e, t, i, n) {
            (this || _global).renderer.scrollToLine(e, t, i, n);
          }, (this || _global).centerSelection = function () {
            var e = this.getSelectionRange(),
                e = {
              row: Math.floor(e.start.row + (e.end.row - e.start.row) / 2),
              column: Math.floor(e.start.column + (e.end.column - e.start.column) / 2)
            };

            (this || _global).renderer.alignCursor(e, 0.5);
          }, (this || _global).getCursorPosition = function () {
            return (this || _global).selection.getCursor();
          }, (this || _global).getCursorPositionScreen = function () {
            return (this || _global).session.documentToScreenPosition(this.getCursorPosition());
          }, (this || _global).getSelectionRange = function () {
            return (this || _global).selection.getRange();
          }, (this || _global).selectAll = function () {
            (this || _global).selection.selectAll();
          }, (this || _global).clearSelection = function () {
            (this || _global).selection.clearSelection();
          }, (this || _global).moveCursorTo = function (e, t) {
            (this || _global).selection.moveCursorTo(e, t);
          }, (this || _global).moveCursorToPosition = function (e) {
            (this || _global).selection.moveCursorToPosition(e);
          }, (this || _global).jumpToMatching = function (e, t) {
            var i = this.getCursorPosition(),
                n = new v((this || _global).session, i.row, i.column),
                r = n.getCurrentToken(),
                o = r || n.stepForward();

            if (o) {
              var s,
                  a,
                  l,
                  c = !1,
                  h = {},
                  d = i.column - o.start,
                  u = {
                ")": "(",
                "(": "(",
                "]": "[",
                "[": "[",
                "{": "{",
                "}": "{"
              };

              do {
                if (o.value.match(/[{}()\[\]]/g)) {
                  for (; d < o.value.length && !c; d++) if (u[o.value[d]]) switch (a = u[o.value[d]] + "." + o.type.replace("rparen", "lparen"), isNaN(h[a]) && (h[a] = 0), o.value[d]) {
                    case "(":
                    case "[":
                    case "{":
                      h[a]++;
                      break;

                    case ")":
                    case "]":
                    case "}":
                      h[a]--, -1 === h[a] && (s = "bracket", c = !0);
                  }
                } else -1 !== o.type.indexOf("tag-name") && (isNaN(h[o.value]) && (h[o.value] = 0), "<" === r.value ? h[o.value]++ : "</" === r.value && h[o.value]--, -1 === h[o.value] && (s = "tag", c = !0));
              } while ((c || (r = o, o = n.stepForward(), d = 0), o && !c));

              if (s) {
                if ("bracket" === s) (g = (this || _global).session.getBracketRange(i)) || (l = (g = new f(n.getCurrentTokenRow(), n.getCurrentTokenColumn() + d - 1, n.getCurrentTokenRow(), n.getCurrentTokenColumn() + d - 1)).start, (t || l.row === i.row && Math.abs(l.column - i.column) < 2) && (g = (this || _global).session.getBracketRange(l)));else if ("tag" === s) {
                  if (!o || -1 === o.type.indexOf("tag-name")) return;
                  var g,
                      p = o.value;
                  if (0 === (g = new f(n.getCurrentTokenRow(), n.getCurrentTokenColumn() - 2, n.getCurrentTokenRow(), n.getCurrentTokenColumn() - 2)).compare(i.row, i.column)) for (c = !1; o = r, (r = n.stepBackward()) && (-1 !== r.type.indexOf("tag-close") && g.setEnd(n.getCurrentTokenRow(), n.getCurrentTokenColumn() + 1), o.value === p && -1 !== o.type.indexOf("tag-name") && ("<" === r.value ? h[p]++ : "</" === r.value && h[p]--, 0 === h[p] && (c = !0))), r && !c;);
                  o && o.type.indexOf("tag-name") && (l = g.start).row == i.row && Math.abs(l.column - i.column) < 2 && (l = g.end);
                }
                (l = g && g.cursor || l) && (e ? g && t ? (this || _global).selection.setRange(g) : g && g.isEqual(this.getSelectionRange()) ? this.clearSelection() : (this || _global).selection.selectTo(l.row, l.column) : (this || _global).selection.moveTo(l.row, l.column));
              }
            }
          }, (this || _global).gotoLine = function (e, t, i) {
            (this || _global).selection.clearSelection(), (this || _global).session.unfold({
              row: e - 1,
              column: t || 0
            }), (this || _global).exitMultiSelectMode && this.exitMultiSelectMode(), this.moveCursorTo(e - 1, t || 0), this.isRowFullyVisible(e - 1) || this.scrollToLine(e - 1, !0, i);
          }, (this || _global).navigateTo = function (e, t) {
            (this || _global).selection.moveTo(e, t);
          }, (this || _global).navigateUp = function (e) {
            var t;
            if ((this || _global).selection.isMultiLine() && !(this || _global).selection.isBackwards()) return t = (this || _global).selection.anchor.getPosition(), this.moveCursorToPosition(t);
            (this || _global).selection.clearSelection(), (this || _global).selection.moveCursorBy(-e || -1, 0);
          }, (this || _global).navigateDown = function (e) {
            var t;
            if ((this || _global).selection.isMultiLine() && (this || _global).selection.isBackwards()) return t = (this || _global).selection.anchor.getPosition(), this.moveCursorToPosition(t);
            (this || _global).selection.clearSelection(), (this || _global).selection.moveCursorBy(e || 1, 0);
          }, (this || _global).navigateLeft = function (e) {
            if ((this || _global).selection.isEmpty()) for (e = e || 1; e--;) (this || _global).selection.moveCursorLeft();else {
              var t = this.getSelectionRange().start;
              this.moveCursorToPosition(t);
            }
            this.clearSelection();
          }, (this || _global).navigateRight = function (e) {
            if ((this || _global).selection.isEmpty()) for (e = e || 1; e--;) (this || _global).selection.moveCursorRight();else {
              var t = this.getSelectionRange().end;
              this.moveCursorToPosition(t);
            }
            this.clearSelection();
          }, (this || _global).navigateLineStart = function () {
            (this || _global).selection.moveCursorLineStart(), this.clearSelection();
          }, (this || _global).navigateLineEnd = function () {
            (this || _global).selection.moveCursorLineEnd(), this.clearSelection();
          }, (this || _global).navigateFileEnd = function () {
            (this || _global).selection.moveCursorFileEnd(), this.clearSelection();
          }, (this || _global).navigateFileStart = function () {
            (this || _global).selection.moveCursorFileStart(), this.clearSelection();
          }, (this || _global).navigateWordRight = function () {
            (this || _global).selection.moveCursorWordRight(), this.clearSelection();
          }, (this || _global).navigateWordLeft = function () {
            (this || _global).selection.moveCursorWordLeft(), this.clearSelection();
          }, (this || _global).replace = function (e, t) {
            t && (this || _global).$search.set(t);

            var t = (this || _global).$search.find((this || _global).session),
                i = 0;

            return t && (this.$tryReplace(t, e) && (i = 1), (this || _global).selection.setSelectionRange(t), (this || _global).renderer.scrollSelectionIntoView(t.start, t.end)), i;
          }, (this || _global).replaceAll = function (e, t) {
            t && (this || _global).$search.set(t);

            var i = (this || _global).$search.findAll((this || _global).session),
                n = 0;

            if (!i.length) return n;
            t = this.getSelectionRange();

            (this || _global).selection.moveTo(0, 0);

            for (var r = i.length - 1; 0 <= r; --r) this.$tryReplace(i[r], e) && n++;

            return (this || _global).selection.setSelectionRange(t), n;
          }, (this || _global).$tryReplace = function (e, t) {
            var i = (this || _global).session.getTextRange(e);

            return null !== (t = (this || _global).$search.replace(i, t)) ? (e.end = (this || _global).session.replace(e, t), e) : null;
          }, (this || _global).getLastSearchOptions = function () {
            return (this || _global).$search.getOptions();
          }, (this || _global).find = function (e, t, i) {
            t = t || {}, "string" == typeof e || e instanceof RegExp ? t.needle = e : "object" == typeof e && o.mixin(t, e);

            var n = (this || _global).selection.getRange(),
                e = (null == t.needle && ((e = (this || _global).session.getTextRange(n) || (this || _global).$search.$options.needle) || (n = (this || _global).session.getWordRange(n.start.row, n.start.column), e = (this || _global).session.getTextRange(n)), (this || _global).$search.set({
              needle: e
            })), (this || _global).$search.set(t), t.start || (this || _global).$search.set({
              start: n
            }), (this || _global).$search.find((this || _global).session));

            return t.preventScroll ? e : e ? (this.revealRange(e, i), e) : (t.backwards ? n.start = n.end : n.end = n.start, void (this || _global).selection.setRange(n));
          }, (this || _global).findNext = function (e, t) {
            this.find({
              skipCurrent: !0,
              backwards: !1
            }, e, t);
          }, (this || _global).findPrevious = function (e, t) {
            this.find(e, {
              skipCurrent: !0,
              backwards: !0
            }, t);
          }, (this || _global).revealRange = function (e, t) {
            (this || _global).session.unfold(e), (this || _global).selection.setSelectionRange(e);
            var i = (this || _global).renderer.scrollTop;
            (this || _global).renderer.scrollSelectionIntoView(e.start, e.end, 0.5), !1 !== t && (this || _global).renderer.animateScrolling(i);
          }, (this || _global).undo = function () {
            (this || _global).session.getUndoManager().undo((this || _global).session), (this || _global).renderer.scrollCursorIntoView(null, 0.5);
          }, (this || _global).redo = function () {
            (this || _global).session.getUndoManager().redo((this || _global).session), (this || _global).renderer.scrollCursorIntoView(null, 0.5);
          }, (this || _global).destroy = function () {
            (this || _global).$toDestroy && ((this || _global).$toDestroy.forEach(function (e) {
              e.destroy();
            }), (this || _global).$toDestroy = null), (this || _global).$mouseHandler && (this || _global).$mouseHandler.destroy(), (this || _global).renderer.destroy(), this._signal("destroy", this || _global), (this || _global).session && (this || _global).session.destroy(), (this || _global)._$emitInputEvent && (this || _global)._$emitInputEvent.cancel(), this.removeAllListeners();
          }, (this || _global).setAutoScrollEditorIntoView = function (e) {
            var n, r, o, s, t, i, a;
            e && (o = !1, (r = this || _global).$scrollAnchor || ((this || _global).$scrollAnchor = document.createElement("div")), (s = (this || _global).$scrollAnchor).style.cssText = "position:absolute", (this || _global).container.insertBefore(s, (this || _global).container.firstChild), t = this.on("changeSelection", function () {
              o = !0;
            }), i = (this || _global).renderer.on("beforeRender", function () {
              o && (n = r.renderer.container.getBoundingClientRect());
            }), a = (this || _global).renderer.on("afterRender", function () {
              var e, t, i;
              o && n && (r.isFocused() || r.searchBox && r.searchBox.isFocused()) && (e = (t = r.renderer).$cursorLayer.$pixelPos, t = t.layerConfig, i = e.top - t.offset, null != (o = 0 <= e.top && i + n.top < 0 || !(e.top < t.height && e.top + n.top + t.lineHeight > window.innerHeight) && null) && (s.style.top = i + "px", s.style.left = e.left + "px", s.style.height = t.lineHeight + "px", s.scrollIntoView(o)), o = n = null);
            }), (this || _global).setAutoScrollEditorIntoView = function (e) {
              e || (delete (this || _global).setAutoScrollEditorIntoView, this.off("changeSelection", t), (this || _global).renderer.off("afterRender", a), (this || _global).renderer.off("beforeRender", i));
            });
          }, (this || _global).$resetCursorStyle = function () {
            var e = (this || _global).$cursorStyle || "ace",
                t = (this || _global).renderer.$cursorLayer;
            t && (t.setSmoothBlinking(/smooth/.test(e)), t.isBlinking = !(this || _global).$readOnly && "wide" != e, n.setCssClass(t.element, "ace_slim-cursors", /slim/.test(e)));
          }, (this || _global).prompt = function (t, i, n) {
            var r = this || _global;
            I.loadModule("./ext/prompt", function (e) {
              e.prompt(r, t, i, n);
            });
          };
        }.call(r.prototype), I.defineOptions(r.prototype, "editor", {
          selectionStyle: {
            set: function (e) {
              this.onSelectionChange(), this._signal("changeSelectionStyle", {
                data: e
              });
            },
            initialValue: "line"
          },
          highlightActiveLine: {
            set: function () {
              this.$updateHighlightActiveLine();
            },
            initialValue: !0
          },
          highlightSelectedWord: {
            set: function (e) {
              this.$onSelectionChange();
            },
            initialValue: !0
          },
          readOnly: {
            set: function (e) {
              (this || _global).textInput.setReadOnly(e), this.$resetCursorStyle();
            },
            initialValue: !1
          },
          copyWithEmptySelection: {
            set: function (e) {
              (this || _global).textInput.setCopyWithEmptySelection(e);
            },
            initialValue: !1
          },
          cursorStyle: {
            set: function (e) {
              this.$resetCursorStyle();
            },
            values: ["ace", "slim", "smooth", "wide"],
            initialValue: "ace"
          },
          mergeUndoDeltas: {
            values: [!1, !0, "always"],
            initialValue: !0
          },
          behavioursEnabled: {
            initialValue: !0
          },
          wrapBehavioursEnabled: {
            initialValue: !0
          },
          enableAutoIndent: {
            initialValue: !0
          },
          autoScrollEditorIntoView: {
            set: function (e) {
              this.setAutoScrollEditorIntoView(e);
            }
          },
          keyboardHandler: {
            set: function (e) {
              this.setKeyboardHandler(e);
            },
            get: function () {
              return (this || _global).$keybindingId;
            },
            handlesSet: !0
          },
          value: {
            set: function (e) {
              (this || _global).session.setValue(e);
            },
            get: function () {
              return this.getValue();
            },
            handlesSet: !0,
            hidden: !0
          },
          session: {
            set: function (e) {
              this.setSession(e);
            },
            get: function () {
              return (this || _global).session;
            },
            handlesSet: !0,
            hidden: !0
          },
          showLineNumbers: {
            set: function (e) {
              (this || _global).renderer.$gutterLayer.setShowLineNumbers(e), (this || _global).renderer.$loop.schedule((this || _global).renderer.CHANGE_GUTTER), e && (this || _global).$relativeLineNumbers ? b.attach(this || _global) : b.detach(this || _global);
            },
            initialValue: !0
          },
          relativeLineNumbers: {
            set: function (e) {
              (this || _global).$showLineNumbers && e ? b.attach(this || _global) : b.detach(this || _global);
            }
          },
          placeholder: {
            set: function (e) {
              (this || _global).$updatePlaceholder || ((this || _global).$updatePlaceholder = function () {
                var e = (this || _global).session && ((this || _global).renderer.$composition || this.getValue());
                e && (this || _global).renderer.placeholderNode ? ((this || _global).renderer.off("afterRender", (this || _global).$updatePlaceholder), n.removeCssClass((this || _global).container, "ace_hasPlaceholder"), (this || _global).renderer.placeholderNode.remove(), (this || _global).renderer.placeholderNode = null) : e || (this || _global).renderer.placeholderNode ? !e && (this || _global).renderer.placeholderNode && ((this || _global).renderer.placeholderNode.textContent = (this || _global).$placeholder || "") : ((this || _global).renderer.on("afterRender", (this || _global).$updatePlaceholder), n.addCssClass((this || _global).container, "ace_hasPlaceholder"), (e = n.createElement("div")).className = "ace_placeholder", e.textContent = (this || _global).$placeholder || "", (this || _global).renderer.placeholderNode = e, (this || _global).renderer.content.appendChild((this || _global).renderer.placeholderNode));
              }.bind(this || _global), this.on("input", (this || _global).$updatePlaceholder)), this.$updatePlaceholder();
            }
          },
          hScrollBarAlwaysVisible: "renderer",
          vScrollBarAlwaysVisible: "renderer",
          highlightGutterLine: "renderer",
          animatedScroll: "renderer",
          showInvisibles: "renderer",
          showPrintMargin: "renderer",
          printMarginColumn: "renderer",
          printMargin: "renderer",
          fadeFoldWidgets: "renderer",
          showFoldWidgets: "renderer",
          displayIndentGuides: "renderer",
          showGutter: "renderer",
          fontSize: "renderer",
          fontFamily: "renderer",
          maxLines: "renderer",
          minLines: "renderer",
          scrollPastEnd: "renderer",
          fixedWidthGutter: "renderer",
          theme: "renderer",
          hasCssTransforms: "renderer",
          maxPixelHeight: "renderer",
          useTextareaForIME: "renderer",
          scrollSpeed: "$mouseHandler",
          dragDelay: "$mouseHandler",
          dragEnabled: "$mouseHandler",
          focusTimeout: "$mouseHandler",
          tooltipFollowsMouse: "$mouseHandler",
          firstLineNumber: "session",
          overwrite: "session",
          newLineMode: "session",
          useWorker: "session",
          useSoftTabs: "session",
          navigateWithinSoftTabs: "session",
          tabSize: "session",
          wrap: "session",
          indentedSoftWrap: "session",
          foldStyle: "session",
          mode: "session"
        }), {
          getText: function (e, t) {
            return (Math.abs(e.selection.lead.row - t) || t + 1 + (t < 9 ? "\xB7" : "")) + "";
          },
          getWidth: function (e, t, i) {
            return Math.max(t.toString().length, (i.lastRow + 1).toString().length, 2) * i.characterWidth;
          },
          update: function (e, t) {
            t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER);
          },
          attach: function (e) {
            e.renderer.$gutterLayer.$renderer = this || _global, e.on("changeSelection", (this || _global).update), this.update(null, e);
          },
          detach: function (e) {
            e.renderer.$gutterLayer.$renderer == (this || _global) && (e.renderer.$gutterLayer.$renderer = null), e.off("changeSelection", (this || _global).update), this.update(null, e);
          }
        });
        t.Editor = r;
      }), ace.define("ace/undomanager", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).$maxRev = 0, (this || _global).$fromUndo = !1, this.reset();
        }

        !function () {
          (this || _global).addSession = function (e) {
            (this || _global).$session = e;
          }, (this || _global).add = function (e, t, i) {
            (this || _global).$fromUndo || e != (this || _global).$lastDelta && ((this || _global).$keepRedoStack || ((this || _global).$redoStack.length = 0), !1 !== t && (this || _global).lastDeltas || ((this || _global).lastDeltas = [], (this || _global).$undoStack.push((this || _global).lastDeltas), e.id = (this || _global).$rev = ++(this || _global).$maxRev), "remove" != e.action && "insert" != e.action || ((this || _global).$lastDelta = e), (this || _global).lastDeltas.push(e));
          }, (this || _global).addSelection = function (e, t) {
            (this || _global).selections.push({
              value: e,
              rev: t || (this || _global).$rev
            });
          }, (this || _global).startNewGroup = function () {
            return (this || _global).lastDeltas = null, (this || _global).$rev;
          }, (this || _global).markIgnored = function (e, t) {
            null == t && (t = (this || _global).$rev + 1);

            for (var i = (this || _global).$undoStack, n = i.length; n--;) {
              var r = i[n][0];
              if (r.id <= e) break;
              r.id < t && (r.ignore = !0);
            }

            (this || _global).lastDeltas = null;
          }, (this || _global).getSelection = function (e, t) {
            for (var i = (this || _global).selections, n = i.length; n--;) {
              var r = i[n];
              if (r.rev < e) return r = t ? i[n + 1] : r;
            }
          }, (this || _global).getRevision = function () {
            return (this || _global).$rev;
          }, (this || _global).getDeltas = function (e, t) {
            null == t && (t = (this || _global).$rev + 1);

            for (var i = (this || _global).$undoStack, n = null, r = 0, o = i.length; o--;) {
              var s = i[o][0];

              if (s.id < t && !n && (n = o + 1), s.id <= e) {
                r = o + 1;
                break;
              }
            }

            return i.slice(r, n);
          }, (this || _global).getChangedRanges = function (e, t) {
            null == t && (this || _global).$rev;
          }, (this || _global).getChangedLines = function (e, t) {
            null == t && (this || _global).$rev;
          }, (this || _global).undo = function (e, t) {
            (this || _global).lastDeltas = null;
            var i,
                n = (this || _global).$undoStack;
            if (function (e, t) {
              for (var i = t; i--;) {
                var n = e[i];

                if (n && !n[0].ignore) {
                  for (; i < t - 1;) {
                    var r = function (e, t) {
                      for (var i = e.length; i--;) for (var n = 0; n < t.length; n++) if (!s(e[i], t[n])) {
                        for (; i < e.length;) {
                          for (; n--;) s(t[n], e[i]);

                          n = t.length, i++;
                        }

                        return [e, t];
                      }

                      return e.selectionBefore = t.selectionBefore = e.selectionAfter = t.selectionAfter = null, [t, e];
                    }(e[i], e[i + 1]);

                    e[i] = r[0], e[i + 1] = r[1], i++;
                  }

                  return 1;
                }
              }
            }(n, n.length)) return e = e || (this || _global).$session, (this || _global).$redoStackBaseRev !== (this || _global).$rev && (this || _global).$redoStack.length && ((this || _global).$redoStack = []), (this || _global).$fromUndo = !0, n = n.pop(), i = null, n && (i = e.undoChanges(n, t), (this || _global).$redoStack.push(n), this.$syncRev()), (this || _global).$fromUndo = !1, i;
          }, (this || _global).redo = function (e, t) {
            if ((this || _global).lastDeltas = null, e = e || (this || _global).$session, (this || _global).$fromUndo = !0, (this || _global).$redoStackBaseRev != (this || _global).$rev) {
              for (var i = this.getDeltas((this || _global).$redoStackBaseRev, (this || _global).$rev + 1), n = (this || _global).$redoStack, r = i, o = 0; o < r.length; o++) for (var s = r[o], a = 0; a < s.length; a++) {
                l = void 0;
                c = void 0;
                h = void 0;
                d = void 0;
                u = void 0;
                g = void 0;
                var l = n;
                var c = s[a];

                c = function (e) {
                  return {
                    start: C(e.start),
                    end: C(e.end),
                    action: e.action,
                    lines: e.lines.slice()
                  };
                }(c);

                for (var h = l.length; h--;) {
                  for (var d = l[h], u = 0; u < d.length; u++) {
                    var g = function (e, t) {
                      var i,
                          n,
                          r = "insert" == e.action,
                          o = "insert" == t.action;
                      if (r && o) f(e.start, t.start) < 0 ? I(t, e, 1) : I(e, t, 1);else if (r && !o) 0 <= f(e.start, t.end) ? I(e, t, -1) : (f(e.start, t.start) <= 0 || I(e, m.fromPoints(t.start, e.start), -1), I(t, e, 1));else if (!r && o) 0 <= f(t.start, e.end) ? I(t, e, -1) : (f(t.start, e.start) <= 0 || I(t, m.fromPoints(e.start, t.start), -1), I(e, t, 1));else if (!r && !o) if (0 <= f(t.start, e.end)) I(t, e, -1);else {
                        if (!(f(t.end, e.start) <= 0)) return f(e.start, t.start) < 0 && (e = A(i = e, t.start)), 0 < f(e.end, t.end) && (n = A(e, t.end)), v(t.end, e.start, e.end, -1), n && !i && (e.lines = n.lines, e.start = n.start, e.end = n.end, n = e), [t, i, n].filter(Boolean);
                        I(e, t, -1);
                      }
                      return [t, e];
                    }(d[u], c);

                    c = g[0], 2 != g.length && (g[2] ? (d.splice(u + 1, 1, g[1], g[2]), u++) : g[1] || (d.splice(u, 1), u--));
                  }

                  d.length || l.splice(h, 1);
                }
              }

              (this || _global).$redoStackBaseRev = (this || _global).$rev, (this || _global).$redoStack.forEach(function (e) {
                e[0].id = ++(this || _global).$maxRev;
              }, this || _global);
            }

            var i = (this || _global).$redoStack.pop(),
                p = null;

            return i && (p = e.redoChanges(i, t), (this || _global).$undoStack.push(i), this.$syncRev()), (this || _global).$fromUndo = !1, p;
          }, (this || _global).$syncRev = function () {
            var e = (this || _global).$undoStack,
                e = e[e.length - 1],
                e = e && e[0].id || 0;
            (this || _global).$redoStackBaseRev = e, (this || _global).$rev = e;
          }, (this || _global).reset = function () {
            (this || _global).lastDeltas = null, (this || _global).$lastDelta = null, (this || _global).$undoStack = [], (this || _global).$redoStack = [], (this || _global).$rev = 0, (this || _global).mark = 0, (this || _global).$redoStackBaseRev = (this || _global).$rev, (this || _global).selections = [];
          }, (this || _global).canUndo = function () {
            return 0 < (this || _global).$undoStack.length;
          }, (this || _global).canRedo = function () {
            return 0 < (this || _global).$redoStack.length;
          }, (this || _global).bookmark = function (e) {
            null == e && (e = (this || _global).$rev), (this || _global).mark = e;
          }, (this || _global).isAtBookmark = function () {
            return (this || _global).$rev === (this || _global).mark;
          }, (this || _global).toJSON = function () {}, (this || _global).fromJSON = function () {}, (this || _global).hasUndo = (this || _global).canUndo, (this || _global).hasRedo = (this || _global).canRedo, (this || _global).isClean = (this || _global).isAtBookmark, (this || _global).markClean = (this || _global).bookmark, (this || _global).$prettyPrint = function (e) {
            return e ? r(e) : r((this || _global).$undoStack) + "\n---\n" + r((this || _global).$redoStack);
          };
        }.call(n.prototype);
        var m = e("./range").Range,
            f = m.comparePoints;
        m.comparePoints;

        function C(e) {
          return {
            row: e.row,
            column: e.column
          };
        }

        function r(e) {
          if (e = e || this || _global, Array.isArray(e)) return e.map(r).join("\n");
          var t = "";
          return e.action ? (t = "insert" == e.action ? "+" : "-", t += "[" + e.lines + "]") : e.value && (t = Array.isArray(e.value) ? e.value.map(o).join("\n") : o(e.value)), e.start && (t += o(e)), (e.id || e.rev) && (t += "\t(" + (e.id || e.rev) + ")"), t;
        }

        function o(e) {
          return e.start.row + ":" + e.start.column + "=>" + e.end.row + ":" + e.end.column;
        }

        function s(e, t) {
          var i = "insert" == e.action,
              n = "insert" == t.action;
          if (i && n) {
            if (0 <= f(t.start, e.end)) I(t, e, -1);else {
              if (!(f(t.start, e.start) <= 0)) return;
              I(e, t, 1);
            }
          } else if (i && !n) {
            if (0 <= f(t.start, e.end)) I(t, e, -1);else {
              if (!(f(t.end, e.start) <= 0)) return;
              I(e, t, -1);
            }
          } else if (!i && n) {
            if (0 <= f(t.start, e.start)) I(t, e, 1);else {
              if (!(f(t.start, e.start) <= 0)) return;
              I(e, t, 1);
            }
          } else if (!i && !n) if (0 <= f(t.start, e.start)) I(t, e, 1);else {
            if (!(f(t.end, e.start) <= 0)) return;
            I(e, t, -1);
          }
          return 1;
        }

        function I(e, t, i) {
          v(e.start, t.start, t.end, i), v(e.end, t.start, t.end, i);
        }

        function v(e, t, i, n) {
          e.row == (1 == n ? t : i).row && (e.column += n * (i.column - t.column)), e.row += n * (i.row - t.row);
        }

        function A(e, t) {
          var i = e.lines,
              n = e.end,
              r = (e.end = C(t), e.end.row - e.start.row),
              o = i.splice(r, i.length),
              r = r ? t.column : t.column - e.start.column;
          return i.push(o[0].substring(0, r)), o[0] = o[0].substr(r), {
            start: C(t),
            end: n,
            lines: o,
            action: e.action
          };
        }

        t.UndoManager = n;
      }), ace.define("ace/layer/lines", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          (this || _global).element = e, (this || _global).canvasHeight = t || 500000, (this || _global).element.style.height = 2 * (this || _global).canvasHeight + "px", (this || _global).cells = [], (this || _global).cellCache = [], (this || _global).$offsetCoefficient = 0;
        }

        var s = e("../lib/dom");
        !function () {
          (this || _global).moveContainer = function (e) {
            s.translate((this || _global).element, 0, -(e.firstRowScreen * e.lineHeight % (this || _global).canvasHeight) - e.offset * (this || _global).$offsetCoefficient);
          }, (this || _global).pageChanged = function (e, t) {
            return Math.floor(e.firstRowScreen * e.lineHeight / (this || _global).canvasHeight) !== Math.floor(t.firstRowScreen * t.lineHeight / (this || _global).canvasHeight);
          }, (this || _global).computeLineTop = function (e, t, i) {
            var n = t.firstRowScreen * t.lineHeight,
                n = Math.floor(n / (this || _global).canvasHeight);
            return i.documentToScreenRow(e, 0) * t.lineHeight - n * (this || _global).canvasHeight;
          }, (this || _global).computeLineHeight = function (e, t, i) {
            return t.lineHeight * i.getRowLineCount(e);
          }, (this || _global).getLength = function () {
            return (this || _global).cells.length;
          }, (this || _global).get = function (e) {
            return (this || _global).cells[e];
          }, (this || _global).shift = function () {
            this.$cacheCell((this || _global).cells.shift());
          }, (this || _global).pop = function () {
            this.$cacheCell((this || _global).cells.pop());
          }, (this || _global).push = function (e) {
            if (Array.isArray(e)) {
              (this || _global).cells.push.apply((this || _global).cells, e);

              for (var t = s.createFragment((this || _global).element), i = 0; i < e.length; i++) t.appendChild(e[i].element);

              (this || _global).element.appendChild(t);
            } else (this || _global).cells.push(e), (this || _global).element.appendChild(e.element);
          }, (this || _global).unshift = function (e) {
            if (Array.isArray(e)) {
              (this || _global).cells.unshift.apply((this || _global).cells, e);

              for (var t = s.createFragment((this || _global).element), i = 0; i < e.length; i++) t.appendChild(e[i].element);

              (this || _global).element.firstChild ? (this || _global).element.insertBefore(t, (this || _global).element.firstChild) : (this || _global).element.appendChild(t);
            } else (this || _global).cells.unshift(e), (this || _global).element.insertAdjacentElement("afterbegin", e.element);
          }, (this || _global).last = function () {
            return (this || _global).cells.length ? (this || _global).cells[(this || _global).cells.length - 1] : null;
          }, (this || _global).$cacheCell = function (e) {
            e && (e.element.remove(), (this || _global).cellCache.push(e));
          }, (this || _global).createCell = function (e, t, i, n) {
            var r,
                o = (this || _global).cellCache.pop();

            return o || (r = s.createElement("div"), n && n(r), (this || _global).element.appendChild(r), o = {
              element: r,
              text: "",
              row: e
            }), o.row = e, o;
          };
        }.call(n.prototype), t.Lines = n;
      }), ace.define("ace/layer/gutter", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/lang", "ace/lib/event_emitter", "ace/layer/lines"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).element = f.createElement("div"), (this || _global).element.className = "ace_layer ace_gutter-layer", e.appendChild((this || _global).element), this.setShowFoldWidgets((this || _global).$showFoldWidgets), (this || _global).gutterWidth = 0, (this || _global).$annotations = [], (this || _global).$updateAnnotations = (this || _global).$updateAnnotations.bind(this || _global), (this || _global).$lines = new a((this || _global).element), (this || _global).$lines.$offsetCoefficient = 1;
        }

        var f = e("../lib/dom"),
            r = e("../lib/oop"),
            o = e("../lib/lang"),
            s = e("../lib/event_emitter").EventEmitter,
            a = e("./lines").Lines;

        function c(e) {
          var t = document.createTextNode(""),
              t = (e.appendChild(t), f.createElement("span"));
          return e.appendChild(t), e;
        }

        !function () {
          r.implement(this || _global, s), (this || _global).setSession = function (e) {
            (this || _global).session && (this || _global).session.off("change", (this || _global).$updateAnnotations), ((this || _global).session = e) && e.on("change", (this || _global).$updateAnnotations);
          }, (this || _global).addGutterDecoration = function (e, t) {
            window.console && console.warn && console.warn("deprecated use session.addGutterDecoration"), (this || _global).session.addGutterDecoration(e, t);
          }, (this || _global).removeGutterDecoration = function (e, t) {
            window.console && console.warn && console.warn("deprecated use session.removeGutterDecoration"), (this || _global).session.removeGutterDecoration(e, t);
          }, (this || _global).setAnnotations = function (e) {
            (this || _global).$annotations = [];

            for (var t = 0; t < e.length; t++) {
              var i = e[t],
                  n = i.row,
                  r = (r = (this || _global).$annotations[n]) || ((this || _global).$annotations[n] = {
                text: []
              }),
                  n = (n = i.text) ? o.escapeHTML(n) : i.html || "",
                  n = (-1 === r.text.indexOf(n) && r.text.push(n), i.type);
              "error" == n ? r.className = " ace_error" : "warning" == n && " ace_error" != r.className ? r.className = " ace_warning" : "info" != n || r.className || (r.className = " ace_info");
            }
          }, (this || _global).$updateAnnotations = function (e) {
            var t, i;
            (this || _global).$annotations.length && (t = e.start.row, 0 != (i = e.end.row - t) && ("remove" == e.action ? (this || _global).$annotations.splice(t, 1 + i, null) : ((e = new Array(1 + i)).unshift(t, 1), (this || _global).$annotations.splice.apply((this || _global).$annotations, e))));
          }, (this || _global).update = function (e) {
            (this || _global).config = e;

            for (var t = (this || _global).session, i = e.firstRow, n = Math.min(e.lastRow + e.gutterOffset, t.getLength() - 1), r = ((this || _global).oldLastRow = n, (this || _global).config = e, (this || _global).$lines.moveContainer(e), this.$updateCursorRow(), t.getNextFoldLine(i)), o = r ? r.start.row : 1 / 0, s = null, a = -1, l = i;;) {
              if (o < l && (l = r.end.row + 1, o = (r = t.getNextFoldLine(l, r)) ? r.start.row : 1 / 0), n < l) {
                for (; (this || _global).$lines.getLength() > a + 1;) (this || _global).$lines.pop();

                break;
              }

              (s = (this || _global).$lines.get(++a)) ? s.row = l : (s = (this || _global).$lines.createCell(l, e, (this || _global).session, c), (this || _global).$lines.push(s)), this.$renderCell(s, e, r, l), l++;
            }

            this._signal("afterRender"), this.$updateGutterWidth(e);
          }, (this || _global).$updateGutterWidth = function (e) {
            var t = (this || _global).session,
                i = t.gutterRenderer || (this || _global).$renderer,
                n = t.$firstLineNumber,
                r = (this || _global).$lines.last() ? (this || _global).$lines.last().text : "",
                n = (((this || _global).$fixedWidth || t.$useWrapMode) && (r = t.getLength() + n - 1), i ? i.getWidth(t, r, e) : r.toString().length * e.characterWidth),
                i = (this || _global).$padding || this.$computePadding();
            (n += i.left + i.right) === (this || _global).gutterWidth || isNaN(n) || ((this || _global).gutterWidth = n, (this || _global).element.parentNode.style.width = (this || _global).element.style.width = Math.ceil((this || _global).gutterWidth) + "px", this._signal("changeGutterWidth", n));
          }, (this || _global).$updateCursorRow = function () {
            var e;
            (this || _global).$highlightGutterLine && (e = (this || _global).session.selection.getCursor(), (this || _global).$cursorRow !== e.row && ((this || _global).$cursorRow = e.row));
          }, (this || _global).updateLineHighlight = function () {
            if ((this || _global).$highlightGutterLine) {
              var e = (this || _global).session.selection.cursor.row;

              if ((this || _global).$cursorRow = e, !(this || _global).$cursorCell || (this || _global).$cursorCell.row != e) {
                (this || _global).$cursorCell && ((this || _global).$cursorCell.element.className = (this || _global).$cursorCell.element.className.replace("ace_gutter-active-line ", ""));
                var t = (this || _global).$lines.cells;
                (this || _global).$cursorCell = null;

                for (var i = 0; i < t.length; i++) {
                  var n = t[i];

                  if (n.row >= (this || _global).$cursorRow) {
                    if (n.row > (this || _global).$cursorRow) {
                      var r = (this || _global).session.getFoldLine((this || _global).$cursorRow);

                      if (!(0 < i && r && r.start.row == t[i - 1].row)) break;
                      n = t[i - 1];
                    }

                    n.element.className = "ace_gutter-active-line " + n.element.className, (this || _global).$cursorCell = n;
                    break;
                  }
                }
              }
            }
          }, (this || _global).scrollLines = function (e) {
            var t = (this || _global).config;
            if ((this || _global).config = e, this.$updateCursorRow(), (this || _global).$lines.pageChanged(t, e)) return this.update(e);

            (this || _global).$lines.moveContainer(e);

            var i = Math.min(e.lastRow + e.gutterOffset, (this || _global).session.getLength() - 1),
                n = (this || _global).oldLastRow;
            if ((this || _global).oldLastRow = i, !t || n < e.firstRow) return this.update(e);
            if (i < t.firstRow) return this.update(e);
            if (t.firstRow < e.firstRow) for (var r = (this || _global).session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < r; r--) (this || _global).$lines.shift();
            if (i < n) for (r = (this || _global).session.getFoldedRowCount(i + 1, n); 0 < r; r--) (this || _global).$lines.pop();
            e.firstRow < t.firstRow && (this || _global).$lines.unshift(this.$renderLines(e, e.firstRow, t.firstRow - 1)), n < i && (this || _global).$lines.push(this.$renderLines(e, n + 1, i)), this.updateLineHighlight(), this._signal("afterRender"), this.$updateGutterWidth(e);
          }, (this || _global).$renderLines = function (e, t, i) {
            for (var n = [], r = t, o = (this || _global).session.getNextFoldLine(r), s = o ? o.start.row : 1 / 0; s < r && (r = o.end.row + 1, s = (o = (this || _global).session.getNextFoldLine(r, o)) ? o.start.row : 1 / 0), !(i < r);) {
              var a = (this || _global).$lines.createCell(r, e, (this || _global).session, c);

              this.$renderCell(a, e, o, r), n.push(a), r++;
            }

            return n;
          }, (this || _global).$renderCell = function (e, t, i, n) {
            var r,
                o = e.element,
                s = (this || _global).session,
                a = o.childNodes[0],
                l = o.childNodes[1],
                c = s.$firstLineNumber,
                h = s.$breakpoints,
                d = s.$decorations,
                u = s.gutterRenderer || (this || _global).$renderer,
                g = (this || _global).$showFoldWidgets && s.foldWidgets,
                p = i ? i.start.row : Number.MAX_VALUE,
                m = "ace_gutter-cell ",
                d = ((this || _global).$highlightGutterLine && (n == (this || _global).$cursorRow || i && n < (this || _global).$cursorRow && p <= n && (this || _global).$cursorRow <= i.end.row) && (m += "ace_gutter-active-line ", (this || _global).$cursorCell != e && ((this || _global).$cursorCell && ((this || _global).$cursorCell.element.className = (this || _global).$cursorCell.element.className.replace("ace_gutter-active-line ", "")), (this || _global).$cursorCell = e)), h[n] && (m += h[n]), d[n] && (m += d[n]), (this || _global).$annotations[n] && (m += (this || _global).$annotations[n].className), o.className != m && (o.className = m), !g || null == (r = g[n]) && (r = g[n] = s.getFoldWidget(n)), r ? (m = "ace_fold-widget ace_" + r, "start" == r && n == p && n < i.end.row ? m += " ace_closed" : m += " ace_open", l.className != m && (l.className = m), h = t.lineHeight + "px", f.setStyle(l.style, "height", h), f.setStyle(l.style, "display", "inline-block")) : l && f.setStyle(l.style, "display", "none"), (u ? u.getText(s, n) : n + c).toString());
            return d !== a.data && (a.data = d), f.setStyle(e.element.style, "height", (this || _global).$lines.computeLineHeight(n, t, s) + "px"), f.setStyle(e.element.style, "top", (this || _global).$lines.computeLineTop(n, t, s) + "px"), e.text = d, e;
          }, (this || _global).$fixedWidth = !1, (this || _global).$highlightGutterLine = !0, (this || _global).$renderer = "", (this || _global).setHighlightGutterLine = function (e) {
            (this || _global).$highlightGutterLine = e;
          }, (this || _global).$showLineNumbers = !0, (this || _global).$renderer = "", (this || _global).setShowLineNumbers = function (e) {
            (this || _global).$renderer = !e && {
              getWidth: function () {
                return 0;
              },
              getText: function () {
                return "";
              }
            };
          }, (this || _global).getShowLineNumbers = function () {
            return (this || _global).$showLineNumbers;
          }, (this || _global).$showFoldWidgets = !0, (this || _global).setShowFoldWidgets = function (e) {
            e ? f.addCssClass((this || _global).element, "ace_folding-enabled") : f.removeCssClass((this || _global).element, "ace_folding-enabled"), (this || _global).$showFoldWidgets = e, (this || _global).$padding = null;
          }, (this || _global).getShowFoldWidgets = function () {
            return (this || _global).$showFoldWidgets;
          }, (this || _global).$computePadding = function () {
            if (!(this || _global).element.firstChild) return {
              left: 0,
              right: 0
            };
            var e = f.computedStyle((this || _global).element.firstChild);
            return (this || _global).$padding = {}, (this || _global).$padding.left = (parseInt(e.borderLeftWidth) || 0) + (parseInt(e.paddingLeft) || 0) + 1, (this || _global).$padding.right = (parseInt(e.borderRightWidth) || 0) + (parseInt(e.paddingRight) || 0), (this || _global).$padding;
          }, (this || _global).getRegion = function (e) {
            var t = (this || _global).$padding || this.$computePadding(),
                i = (this || _global).element.getBoundingClientRect();

            return e.x < t.left + i.left ? "markers" : (this || _global).$showFoldWidgets && e.x > i.right - t.right ? "foldWidgets" : void 0;
          };
        }.call(n.prototype), t.Gutter = n;
      }), ace.define("ace/layer/marker", ["require", "exports", "module", "ace/range", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).element = r.createElement("div"), (this || _global).element.className = "ace_layer ace_marker-layer", e.appendChild((this || _global).element);
        }

        var g = e("../range").Range,
            r = e("../lib/dom");
        !function () {
          (this || _global).$padding = 0, (this || _global).setPadding = function (e) {
            (this || _global).$padding = e;
          }, (this || _global).setSession = function (e) {
            (this || _global).session = e;
          }, (this || _global).setMarkers = function (e) {
            (this || _global).markers = e;
          }, (this || _global).elt = function (e, t) {
            var i = -1 != (this || _global).i && (this || _global).element.childNodes[(this || _global).i];
            i ? (this || _global).i++ : (i = document.createElement("div"), (this || _global).element.appendChild(i), (this || _global).i = -1), i.style.cssText = t, i.className = e;
          }, (this || _global).update = function (e) {
            if (e) {
              var t, i;

              for (i in (this || _global).config = e, (this || _global).i = 0, (this || _global).markers) {
                var n,
                    r,
                    o,
                    s = (this || _global).markers[i];
                s.range ? (o = s.range.clipRows(e.firstRow, e.lastRow)).isEmpty() || (o = o.toScreenRange((this || _global).session), s.renderer ? (n = this.$getTop(o.start.row, e), r = (this || _global).$padding + o.start.column * e.characterWidth, s.renderer(t, o, r, n, e)) : "fullLine" == s.type ? this.drawFullLineMarker(t, o, s.clazz, e) : "screenLine" == s.type ? this.drawScreenLineMarker(t, o, s.clazz, e) : o.isMultiLine() ? "text" == s.type ? this.drawTextMarker(t, o, s.clazz, e) : this.drawMultiLineMarker(t, o, s.clazz, e) : this.drawSingleLineMarker(t, o, s.clazz + " ace_start ace_br15", e)) : s.update(t, this || _global, (this || _global).session, e);
              }

              if (-1 != (this || _global).i) for (; (this || _global).i < (this || _global).element.childElementCount;) (this || _global).element.removeChild((this || _global).element.lastChild);
            }
          }, (this || _global).$getTop = function (e, t) {
            return (e - t.firstRowScreen) * t.lineHeight;
          }, (this || _global).drawTextMarker = function (e, t, i, n, r) {
            for (var o, s = (this || _global).session, a = t.start.row, l = t.end.row, c = a, h = 0, d = s.getScreenLastRowColumn(c), u = new g(c, t.start.column, c, h); c <= l; c++) u.start.row = u.end.row = c, u.start.column = c == a ? t.start.column : s.getRowWrapIndent(c), u.end.column = d, o = h, h = d, d = c + 1 < l ? s.getScreenLastRowColumn(c + 1) : c == l ? 0 : t.end.column, this.drawSingleLineMarker(e, u, i + (c == a ? " ace_start" : "") + " ace_br" + ((c == a || c == a + 1 && t.start.column ? 1 : 0) | (o < h ? 2 : 0) | (d < h ? 4 : 0) | (c == l ? 8 : 0)), n, c == l ? 0 : 1, r);
          }, (this || _global).drawMultiLineMarker = function (e, t, i, n, r) {
            var o,
                s = (this || _global).$padding,
                a = n.lineHeight,
                l = this.$getTop(t.start.row, n),
                c = s + t.start.column * n.characterWidth;
            r = r || "", (this || _global).session.$bidiHandler.isBidiRow(t.start.row) ? ((o = t.clone()).end.row = o.start.row, o.end.column = (this || _global).session.getLine(o.start.row).length, this.drawBidiSingleLineMarker(e, o, i + " ace_br1 ace_start", n, null, r)) : this.elt(i + " ace_br1 ace_start", "height:" + a + "px;right:0;top:" + l + "px;left:" + c + "px;" + (r || "")), (this || _global).session.$bidiHandler.isBidiRow(t.end.row) ? ((o = t.clone()).start.row = o.end.row, o.start.column = 0, this.drawBidiSingleLineMarker(e, o, i + " ace_br12", n, null, r)) : (l = this.$getTop(t.end.row, n), c = t.end.column * n.characterWidth, this.elt(i + " ace_br12", "height:" + a + "px;width:" + c + "px;top:" + l + "px;left:" + s + "px;" + (r || ""))), (a = (t.end.row - t.start.row - 1) * n.lineHeight) <= 0 || (l = this.$getTop(t.start.row + 1, n), e = (t.start.column ? 1 : 0) | (t.end.column ? 0 : 8), this.elt(i + (e ? " ace_br" + e : ""), "height:" + a + "px;right:0;top:" + l + "px;left:" + s + "px;" + (r || "")));
          }, (this || _global).drawSingleLineMarker = function (e, t, i, n, r, o) {
            if ((this || _global).session.$bidiHandler.isBidiRow(t.start.row)) return this.drawBidiSingleLineMarker(e, t, i, n, r, o);
            var e = n.lineHeight,
                r = (t.end.column + (r || 0) - t.start.column) * n.characterWidth,
                s = this.$getTop(t.start.row, n),
                t = (this || _global).$padding + t.start.column * n.characterWidth;
            this.elt(i, "height:" + e + "px;width:" + r + "px;top:" + s + "px;left:" + t + "px;" + (o || ""));
          }, (this || _global).drawBidiSingleLineMarker = function (e, t, i, n, r, o) {
            var s = n.lineHeight,
                a = this.$getTop(t.start.row, n),
                l = (this || _global).$padding;

            (this || _global).session.$bidiHandler.getSelections(t.start.column, t.end.column).forEach(function (e) {
              this.elt(i, "height:" + s + "px;width:" + e.width + (r || 0) + "px;top:" + a + "px;left:" + (l + e.left) + "px;" + (o || ""));
            }, this || _global);
          }, (this || _global).drawFullLineMarker = function (e, t, i, n, r) {
            var o = this.$getTop(t.start.row, n),
                s = n.lineHeight;
            t.start.row != t.end.row && (s += this.$getTop(t.end.row, n) - o), this.elt(i, "height:" + s + "px;top:" + o + "px;left:0;right:0;" + (r || ""));
          }, (this || _global).drawScreenLineMarker = function (e, t, i, n, r) {
            t = this.$getTop(t.start.row, n), n = n.lineHeight;
            this.elt(i, "height:" + n + "px;top:" + t + "px;left:0;right:0;" + (r || ""));
          };
        }.call(n.prototype), t.Marker = n;
      }), ace.define("ace/layer/text", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/layer/lines", "ace/lib/event_emitter"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).dom = c, (this || _global).element = (this || _global).dom.createElement("div"), (this || _global).element.className = "ace_layer ace_text-layer", e.appendChild((this || _global).element), (this || _global).$updateEolChar = (this || _global).$updateEolChar.bind(this || _global), (this || _global).$lines = new o((this || _global).element);
        }

        var r = e("../lib/oop"),
            c = e("../lib/dom"),
            C = e("../lib/lang"),
            o = e("./lines").Lines,
            s = e("../lib/event_emitter").EventEmitter;
        !function () {
          r.implement(this || _global, s), (this || _global).EOF_CHAR = "\xB6", (this || _global).EOL_CHAR_LF = "\xAC", (this || _global).EOL_CHAR_CRLF = "\xA4", (this || _global).EOL_CHAR = (this || _global).EOL_CHAR_LF, (this || _global).TAB_CHAR = "\u2014", (this || _global).SPACE_CHAR = "\xB7", (this || _global).$padding = 0, (this || _global).MAX_LINE_LENGTH = 10000, (this || _global).$updateEolChar = function () {
            var e = (this || _global).session.doc,
                e = "\n" == e.getNewLineCharacter() && "windows" != e.getNewLineMode() ? (this || _global).EOL_CHAR_LF : (this || _global).EOL_CHAR_CRLF;
            if ((this || _global).EOL_CHAR != e) return (this || _global).EOL_CHAR = e, !0;
          }, (this || _global).setPadding = function (e) {
            (this || _global).$padding = e, (this || _global).element.style.margin = "0 " + e + "px";
          }, (this || _global).getLineHeight = function () {
            return (this || _global).$fontMetrics.$characterSize.height || 0;
          }, (this || _global).getCharacterWidth = function () {
            return (this || _global).$fontMetrics.$characterSize.width || 0;
          }, (this || _global).$setFontMetrics = function (e) {
            (this || _global).$fontMetrics = e, (this || _global).$fontMetrics.on("changeCharacterSize", function (e) {
              this._signal("changeCharacterSize", e);
            }.bind(this || _global)), this.$pollSizeChanges();
          }, (this || _global).checkForSizeChanges = function () {
            (this || _global).$fontMetrics.checkForSizeChanges();
          }, (this || _global).$pollSizeChanges = function () {
            return (this || _global).$pollSizeChangesTimer = (this || _global).$fontMetrics.$pollSizeChanges();
          }, (this || _global).setSession = function (e) {
            ((this || _global).session = e) && this.$computeTabString();
          }, (this || _global).showInvisibles = !1, (this || _global).showSpaces = !1, (this || _global).showTabs = !1, (this || _global).showEOL = !1, (this || _global).setShowInvisibles = function (e) {
            return (this || _global).showInvisibles != e && ("string" == typeof ((this || _global).showInvisibles = e) ? ((this || _global).showSpaces = /tab/i.test(e), (this || _global).showTabs = /space/i.test(e), (this || _global).showEOL = /eol/i.test(e)) : (this || _global).showSpaces = (this || _global).showTabs = (this || _global).showEOL = e, this.$computeTabString(), !0);
          }, (this || _global).displayIndentGuides = !0, (this || _global).setDisplayIndentGuides = function (e) {
            return (this || _global).displayIndentGuides != e && ((this || _global).displayIndentGuides = e, this.$computeTabString(), !0);
          }, (this || _global).$tabStrings = [], (this || _global).onChangeTabSize = (this || _global).$computeTabString = function () {
            for (var e, t, i, n, r, o, s = (this || _global).session.getTabSize(), a = ((this || _global).tabSize = s, (this || _global).$tabStrings = [0]), l = 1; l < s + 1; l++) (this || _global).showTabs ? ((o = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_tab", o.textContent = C.stringRepeat((this || _global).TAB_CHAR, l), a.push(o)) : a.push((this || _global).dom.createTextNode(C.stringRepeat(" ", l), (this || _global).element));

            (this || _global).displayIndentGuides && ((this || _global).$indentGuideRe = /\s\S| \t|\t |\s$/, e = "ace_indent-guide", t = (this || _global).showSpaces ? " ace_invisible ace_invisible_space" : "", i = (this || _global).showSpaces ? C.stringRepeat((this || _global).SPACE_CHAR, (this || _global).tabSize) : C.stringRepeat(" ", (this || _global).tabSize), n = (this || _global).showTabs ? " ace_invisible ace_invisible_tab" : "", r = (this || _global).showTabs ? C.stringRepeat((this || _global).TAB_CHAR, (this || _global).tabSize) : i, (o = (this || _global).dom.createElement("span")).className = e + t, o.textContent = i, (this || _global).$tabStrings[" "] = o, (o = (this || _global).dom.createElement("span")).className = e + n, o.textContent = r, (this || _global).$tabStrings["\t"] = o);
          }, (this || _global).updateLines = function (e, t, i) {
            if ((this || _global).config.lastRow != e.lastRow || (this || _global).config.firstRow != e.firstRow) return this.update(e);
            (this || _global).config = e;

            for (var n = Math.max(t, e.firstRow), r = Math.min(i, e.lastRow), o = (this || _global).element.childNodes, s = 0, a = e.firstRow; a < n; a++) {
              if (l = (this || _global).session.getFoldLine(a)) {
                if (l.containsRow(n)) {
                  n = l.start.row;
                  break;
                }

                a = l.end.row;
              }

              s++;
            }

            for (var l, c = !1, a = n, h = (l = (this || _global).session.getNextFoldLine(a)) ? l.start.row : 1 / 0; h < a && (a = l.end.row + 1, h = (l = (this || _global).session.getNextFoldLine(a, l)) ? l.start.row : 1 / 0), !(r < a);) {
              var d,
                  u = o[s++];
              u && ((this || _global).dom.removeChildren(u), this.$renderLine(u, a, a == h && l), c && (u.style.top = (this || _global).$lines.computeLineTop(a, e, (this || _global).session) + "px"), d = e.lineHeight * (this || _global).session.getRowLength(a) + "px", u.style.height != d && (c = !0, u.style.height = d)), a++;
            }

            if (c) for (; s < (this || _global).$lines.cells.length;) {
              var g = (this || _global).$lines.cells[s++];
              g.element.style.top = (this || _global).$lines.computeLineTop(g.row, e, (this || _global).session) + "px";
            }
          }, (this || _global).scrollLines = function (e) {
            var t = (this || _global).config;
            if ((this || _global).config = e, (this || _global).$lines.pageChanged(t, e)) return this.update(e);

            (this || _global).$lines.moveContainer(e);

            var i = e.lastRow,
                n = t ? t.lastRow : -1;
            if (!t || n < e.firstRow) return this.update(e);
            if (i < t.firstRow) return this.update(e);
            if (!t || t.lastRow < e.firstRow) return this.update(e);
            if (e.lastRow < t.firstRow) return this.update(e);
            if (t.firstRow < e.firstRow) for (var r = (this || _global).session.getFoldedRowCount(t.firstRow, e.firstRow - 1); 0 < r; r--) (this || _global).$lines.shift();
            if (t.lastRow > e.lastRow) for (r = (this || _global).session.getFoldedRowCount(e.lastRow + 1, t.lastRow); 0 < r; r--) (this || _global).$lines.pop();
            e.firstRow < t.firstRow && (this || _global).$lines.unshift(this.$renderLinesFragment(e, e.firstRow, t.firstRow - 1)), e.lastRow > t.lastRow && (this || _global).$lines.push(this.$renderLinesFragment(e, t.lastRow + 1, e.lastRow));
          }, (this || _global).$renderLinesFragment = function (e, t, i) {
            for (var n = [], r = t, o = (this || _global).session.getNextFoldLine(r), s = o ? o.start.row : 1 / 0; s < r && (r = o.end.row + 1, s = (o = (this || _global).session.getNextFoldLine(r, o)) ? o.start.row : 1 / 0), !(i < r);) {
              var a = (this || _global).$lines.createCell(r, e, (this || _global).session),
                  l = a.element;

              (this || _global).dom.removeChildren(l), c.setStyle(l.style, "height", (this || _global).$lines.computeLineHeight(r, e, (this || _global).session) + "px"), c.setStyle(l.style, "top", (this || _global).$lines.computeLineTop(r, e, (this || _global).session) + "px"), this.$renderLine(l, r, r == s && o), this.$useLineGroups() ? l.className = "ace_line_group" : l.className = "ace_line", n.push(a), r++;
            }

            return n;
          }, (this || _global).update = function (e) {
            (this || _global).$lines.moveContainer(e);

            for (var t = ((this || _global).config = e).firstRow, i = e.lastRow, n = (this || _global).$lines; n.getLength();) n.pop();

            n.push(this.$renderLinesFragment(e, t, i));
          }, (this || _global).$textToken = {
            text: !0,
            rparen: !0,
            lparen: !0
          }, (this || _global).$renderToken = function (e, t, i, n) {
            for (var r, o, s = this || _global, a = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g, l = (this || _global).dom.createFragment((this || _global).element), c = 0; r = a.exec(n);) {
              var h,
                  d,
                  u = r[1],
                  g = r[2],
                  p = r[3],
                  m = r[4],
                  f = r[5];
              !s.showSpaces && g || (h = c != r.index ? n.slice(c, r.index) : "", c = r.index + r[0].length, h && l.appendChild((this || _global).dom.createTextNode(h, (this || _global).element)), u ? (h = s.session.getScreenTabSize(t + r.index), l.appendChild(s.$tabStrings[h].cloneNode(!0)), t += h - 1) : g ? s.showSpaces ? ((d = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_space", d.textContent = C.stringRepeat(s.SPACE_CHAR, g.length), l.appendChild(d)) : l.appendChild((this || _global).com.createTextNode(g, (this || _global).element)) : p ? ((d = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_space ace_invalid", d.textContent = C.stringRepeat(s.SPACE_CHAR, p.length), l.appendChild(d)) : m ? (t += 1, (d = (this || _global).dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = s.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk", d.textContent = s.showSpaces ? s.SPACE_CHAR : m, l.appendChild(d)) : f && (t += 1, (d = (this || _global).dom.createElement("span")).style.width = 2 * s.config.characterWidth + "px", d.className = "ace_cjk", d.textContent = f, l.appendChild(d)));
            }

            return l.appendChild((this || _global).dom.createTextNode(c ? n.slice(c) : n, (this || _global).element)), (this || _global).$textToken[i.type] ? e.appendChild(l) : (o = "ace_" + i.type.replace(/\./g, " ace_"), d = (this || _global).dom.createElement("span"), "fold" == i.type && (d.style.width = i.value.length * (this || _global).config.characterWidth + "px"), d.className = o, d.appendChild(l), e.appendChild(d)), t + n.length;
          }, (this || _global).renderIndentGuide = function (e, t, i) {
            var n = t.search((this || _global).$indentGuideRe);
            if (n <= 0 || i <= n) return t;

            if (" " == t[0]) {
              for (var r = (n -= n % (this || _global).tabSize) / (this || _global).tabSize, o = 0; o < r; o++) e.appendChild((this || _global).$tabStrings[" "].cloneNode(!0));

              return t.substr(n);
            }

            if ("\t" != t[0]) return t;

            for (o = 0; o < n; o++) e.appendChild((this || _global).$tabStrings["\t"].cloneNode(!0));

            return t.substr(n);
          }, (this || _global).$createLineElement = function (e) {
            var t = (this || _global).dom.createElement("div");

            return t.className = "ace_line", t.style.height = (this || _global).config.lineHeight + "px", t;
          }, (this || _global).$renderWrappedLine = function (e, t, i) {
            var n = 0,
                r = 0,
                o = i[0],
                s = 0,
                a = this.$createLineElement();
            e.appendChild(a);

            for (var l = 0; l < t.length; l++) {
              var c = t[l],
                  h = c.value;

              if (0 == l && (this || _global).displayIndentGuides) {
                if (n = h.length, !(h = this.renderIndentGuide(a, h, o))) continue;
                n -= h.length;
              }

              if (n + h.length < o) s = this.$renderToken(a, s, c, h), n += h.length;else {
                for (; n + h.length >= o;) s = this.$renderToken(a, s, c, h.substring(0, o - n)), h = h.substring(o - n), n = o, a = this.$createLineElement(), e.appendChild(a), a.appendChild((this || _global).dom.createTextNode(C.stringRepeat("\xA0", i.indent), (this || _global).element)), s = 0, o = i[++r] || Number.MAX_VALUE;

                0 != h.length && (n += h.length, s = this.$renderToken(a, s, c, h));
              }
            }

            i[i.length - 1] > (this || _global).MAX_LINE_LENGTH && this.$renderOverflowMessage(a, s, null, "", !0);
          }, (this || _global).$renderSimpleLine = function (e, t) {
            var i = 0,
                n = t[0],
                r = n.value;
            (r = (this || _global).displayIndentGuides ? this.renderIndentGuide(e, r) : r) && (i = this.$renderToken(e, i, n, r));

            for (var o = 1; o < t.length; o++) {
              if (i + (r = (n = t[o]).value).length > (this || _global).MAX_LINE_LENGTH) return this.$renderOverflowMessage(e, i, n, r);
              i = this.$renderToken(e, i, n, r);
            }
          }, (this || _global).$renderOverflowMessage = function (e, t, i, n, r) {
            i && this.$renderToken(e, t, i, n.slice(0, (this || _global).MAX_LINE_LENGTH - t));
            i = (this || _global).dom.createElement("span");
            i.className = "ace_inline_button ace_keyword ace_toggle_wrap", i.textContent = r ? "<hide>" : "<click to see more...>", e.appendChild(i);
          }, (this || _global).$renderLine = function (e, t, i) {
            var n,
                r,
                o = e;
            (n = (i = i || 0 == i ? i : (this || _global).session.getFoldLine(t)) ? this.$getFoldLineTokens(t, i) : (this || _global).session.getTokens(t)).length ? (r = (this || _global).session.getRowSplitData(t)) && r.length ? (this.$renderWrappedLine(e, n, r), o = e.lastChild) : (o = e, this.$useLineGroups() && (o = this.$createLineElement(), e.appendChild(o)), this.$renderSimpleLine(o, n)) : this.$useLineGroups() && (o = this.$createLineElement(), e.appendChild(o)), (this || _global).showEOL && o && (i && (t = i.end.row), (r = (this || _global).dom.createElement("span")).className = "ace_invisible ace_invisible_eol", r.textContent = t == (this || _global).session.getLength() - 1 ? (this || _global).EOF_CHAR : (this || _global).EOL_CHAR, o.appendChild(r));
          }, (this || _global).$getFoldLineTokens = function (e, t) {
            var d = (this || _global).session,
                u = [];
            var g = d.getTokens(e);
            return t.walk(function (e, t, i, n, r) {
              if (null != e) u.push({
                type: "fold",
                value: e
              });else if ((g = r ? d.getTokens(t) : g).length) {
                for (var o, s = g, a = n, l = i, c = 0, h = 0; h + s[c].value.length < a;) if (h += s[c].value.length, ++c == s.length) return void !void 0;

                for (h != a && ((o = s[c].value.substring(a - h)).length > l - a && (o = o.substring(0, l - a)), u.push({
                  type: s[c].type,
                  value: o
                }), h = a + o.length, c += 1); h < l && c < s.length;) (o = s[c].value).length + h > l ? u.push({
                  type: s[c].type,
                  value: o.substring(0, l - h)
                }) : u.push(s[c]), h += o.length, c += 1;
              }
            }, t.end.row, (this || _global).session.getLine(t.end.row).length), u;
          }, (this || _global).$useLineGroups = function () {
            return (this || _global).session.getUseWrapMode();
          }, (this || _global).destroy = function () {};
        }.call(n.prototype), t.Text = n;
      }), ace.define("ace/layer/cursor", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).element = c.createElement("div"), (this || _global).element.className = "ace_layer ace_cursor-layer", e.appendChild((this || _global).element), (this || _global).isVisible = !1, (this || _global).isBlinking = !0, (this || _global).blinkInterval = 1000, (this || _global).smoothBlinking = !1, (this || _global).cursors = [], (this || _global).cursor = this.addCursor(), c.addCssClass((this || _global).element, "ace_hidden-cursors"), (this || _global).$updateCursors = (this || _global).$updateOpacity.bind(this || _global);
        }

        var c = e("../lib/dom");
        !function () {
          (this || _global).$updateOpacity = function (e) {
            for (var t = (this || _global).cursors, i = t.length; i--;) c.setStyle(t[i].style, "opacity", e ? "" : "0");
          }, (this || _global).$startCssAnimation = function () {
            for (var e = (this || _global).cursors, t = e.length; t--;) e[t].style.animationDuration = (this || _global).blinkInterval + "ms";

            (this || _global).$isAnimating = !0, setTimeout(function () {
              (this || _global).$isAnimating && c.addCssClass((this || _global).element, "ace_animate-blinking");
            }.bind(this || _global));
          }, (this || _global).$stopCssAnimation = function () {
            (this || _global).$isAnimating = !1, c.removeCssClass((this || _global).element, "ace_animate-blinking");
          }, (this || _global).$padding = 0, (this || _global).setPadding = function (e) {
            (this || _global).$padding = e;
          }, (this || _global).setSession = function (e) {
            (this || _global).session = e;
          }, (this || _global).setBlinking = function (e) {
            e != (this || _global).isBlinking && ((this || _global).isBlinking = e, this.restartTimer());
          }, (this || _global).setBlinkInterval = function (e) {
            e != (this || _global).blinkInterval && ((this || _global).blinkInterval = e, this.restartTimer());
          }, (this || _global).setSmoothBlinking = function (e) {
            e != (this || _global).smoothBlinking && ((this || _global).smoothBlinking = e, c.setCssClass((this || _global).element, "ace_smooth-blinking", e), this.$updateCursors(!0), this.restartTimer());
          }, (this || _global).addCursor = function () {
            var e = c.createElement("div");
            return e.className = "ace_cursor", (this || _global).element.appendChild(e), (this || _global).cursors.push(e), e;
          }, (this || _global).removeCursor = function () {
            var e;
            if (1 < (this || _global).cursors.length) return (e = (this || _global).cursors.pop()).parentNode.removeChild(e), e;
          }, (this || _global).hideCursor = function () {
            (this || _global).isVisible = !1, c.addCssClass((this || _global).element, "ace_hidden-cursors"), this.restartTimer();
          }, (this || _global).showCursor = function () {
            (this || _global).isVisible = !0, c.removeCssClass((this || _global).element, "ace_hidden-cursors"), this.restartTimer();
          }, (this || _global).restartTimer = function () {
            var e,
                t = (this || _global).$updateCursors;
            clearInterval((this || _global).intervalId), clearTimeout((this || _global).timeoutId), this.$stopCssAnimation(), (this || _global).smoothBlinking && ((this || _global).$isSmoothBlinking = !1, c.removeCssClass((this || _global).element, "ace_smooth-blinking")), t(!0), (this || _global).isBlinking && (this || _global).blinkInterval && (this || _global).isVisible ? ((this || _global).smoothBlinking && ((this || _global).$isSmoothBlinking = !0, setTimeout(function () {
              (this || _global).$isSmoothBlinking && c.addCssClass((this || _global).element, "ace_smooth-blinking");
            }.bind(this || _global))), c.HAS_CSS_ANIMATION ? this.$startCssAnimation() : (e = function () {
              (this || _global).timeoutId = setTimeout(function () {
                t(!1);
              }, 0.6 * (this || _global).blinkInterval);
            }.bind(this || _global), (this || _global).intervalId = setInterval(function () {
              t(!0), e();
            }, (this || _global).blinkInterval), e())) : this.$stopCssAnimation();
          }, (this || _global).getPixelPosition = function (e, t) {
            if (!(this || _global).config || !(this || _global).session) return {
              left: 0,
              top: 0
            };
            e = e || (this || _global).session.selection.getCursor();

            var i = (this || _global).session.documentToScreenPosition(e);

            return {
              left: (this || _global).$padding + ((this || _global).session.$bidiHandler.isBidiRow(i.row, e.row) ? (this || _global).session.$bidiHandler.getPosLeft(i.column) : i.column * (this || _global).config.characterWidth),
              top: (i.row - (t ? (this || _global).config.firstRowScreen : 0)) * (this || _global).config.lineHeight
            };
          }, (this || _global).isCursorInView = function (e, t) {
            return 0 <= e.top && e.top < t.maxHeight;
          }, (this || _global).update = function (e) {
            (this || _global).config = e;

            for (var t = (this || _global).session.$selectionMarkers, i = 0, n = 0, i = 0, r = (t = void 0 !== t && 0 !== t.length ? t : [{
              cursor: null
            }]).length; i < r; i++) {
              var o,
                  s,
                  a = this.getPixelPosition(t[i].cursor, !0);
              (a.top > e.height + e.offset || a.top < 0) && 1 < i || (s = (o = (this || _global).cursors[n++] || this.addCursor()).style, (this || _global).drawCursor ? this.drawCursor(o, a, e, t[i], (this || _global).session) : this.isCursorInView(a, e) ? (c.setStyle(s, "display", "block"), c.translate(o, a.left, a.top), c.setStyle(s, "width", Math.round(e.characterWidth) + "px"), c.setStyle(s, "height", e.lineHeight + "px")) : c.setStyle(s, "display", "none"));
            }

            for (; (this || _global).cursors.length > n;) this.removeCursor();

            var l = (this || _global).session.getOverwrite();

            this.$setOverwrite(l), (this || _global).$pixelPos = a, this.restartTimer();
          }, (this || _global).drawCursor = null, (this || _global).$setOverwrite = function (e) {
            e != (this || _global).overwrite && (((this || _global).overwrite = e) ? c.addCssClass((this || _global).element, "ace_overwrite-cursors") : c.removeCssClass((this || _global).element, "ace_overwrite-cursors"));
          }, (this || _global).destroy = function () {
            clearInterval((this || _global).intervalId), clearTimeout((this || _global).timeoutId);
          };
        }.call(n.prototype), t.Cursor = n;
      }), ace.define("ace/scrollbar", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/event", "ace/lib/event_emitter"], function (e, t, i) {
        "use strict";

        function n(e) {
          (this || _global).element = a.createElement("div"), (this || _global).element.className = "ace_scrollbar ace_scrollbar" + (this || _global).classSuffix, (this || _global).inner = a.createElement("div"), (this || _global).inner.className = "ace_scrollbar-inner", (this || _global).inner.textContent = "\xA0", (this || _global).element.appendChild((this || _global).inner), e.appendChild((this || _global).element), this.setVisible(!1), (this || _global).skipEvent = !1, l.addListener((this || _global).element, "scroll", (this || _global).onScroll.bind(this || _global)), l.addListener((this || _global).element, "mousedown", l.preventDefault);
        }

        function r(e, t) {
          n.call(this || _global, e), (this || _global).scrollTop = 0, (this || _global).scrollHeight = 0, t.$scrollbarWidth = (this || _global).width = a.scrollbarWidth(e.ownerDocument), (this || _global).inner.style.width = (this || _global).element.style.width = ((this || _global).width || 15) + 5 + "px", (this || _global).$minWidth = 0;
        }

        function o(e, t) {
          n.call(this || _global, e), (this || _global).scrollLeft = 0, (this || _global).height = t.$scrollbarWidth, (this || _global).inner.style.height = (this || _global).element.style.height = ((this || _global).height || 15) + 5 + "px";
        }

        var s = e("./lib/oop"),
            a = e("./lib/dom"),
            l = e("./lib/event"),
            c = e("./lib/event_emitter").EventEmitter;
        !function () {
          s.implement(this || _global, c), (this || _global).setVisible = function (e) {
            (this || _global).element.style.display = e ? "" : "none", (this || _global).isVisible = e, (this || _global).coeff = 1;
          };
        }.call(n.prototype), s.inherits(r, n), function () {
          (this || _global).classSuffix = "-v", (this || _global).onScroll = function () {
            var e;
            (this || _global).skipEvent || ((this || _global).scrollTop = (this || _global).element.scrollTop, 1 != (this || _global).coeff && (e = (this || _global).element.clientHeight / (this || _global).scrollHeight, (this || _global).scrollTop = (this || _global).scrollTop * (1 - e) / ((this || _global).coeff - e)), this._emit("scroll", {
              data: (this || _global).scrollTop
            })), (this || _global).skipEvent = !1;
          }, (this || _global).getWidth = function () {
            return Math.max((this || _global).isVisible ? (this || _global).width : 0, (this || _global).$minWidth || 0);
          }, (this || _global).setHeight = function (e) {
            (this || _global).element.style.height = e + "px";
          }, (this || _global).setInnerHeight = (this || _global).setScrollHeight = function (e) {
            32768 < ((this || _global).scrollHeight = e) ? ((this || _global).coeff = 32768 / e, e = 32768) : 1 != (this || _global).coeff && ((this || _global).coeff = 1), (this || _global).inner.style.height = e + "px";
          }, (this || _global).setScrollTop = function (e) {
            (this || _global).scrollTop != e && ((this || _global).skipEvent = !0, (this || _global).scrollTop = e, (this || _global).element.scrollTop = e * (this || _global).coeff);
          };
        }.call(r.prototype);
        s.inherits(o, n), function () {
          (this || _global).classSuffix = "-h", (this || _global).onScroll = function () {
            (this || _global).skipEvent || ((this || _global).scrollLeft = (this || _global).element.scrollLeft, this._emit("scroll", {
              data: (this || _global).scrollLeft
            })), (this || _global).skipEvent = !1;
          }, (this || _global).getHeight = function () {
            return (this || _global).isVisible ? (this || _global).height : 0;
          }, (this || _global).setWidth = function (e) {
            (this || _global).element.style.width = e + "px";
          }, (this || _global).setInnerWidth = function (e) {
            (this || _global).inner.style.width = e + "px";
          }, (this || _global).setScrollWidth = function (e) {
            (this || _global).inner.style.width = e + "px";
          }, (this || _global).setScrollLeft = function (e) {
            (this || _global).scrollLeft != e && ((this || _global).skipEvent = !0, (this || _global).scrollLeft = (this || _global).element.scrollLeft = e);
          };
        }.call(o.prototype), t.ScrollBar = r, t.ScrollBarV = r, t.ScrollBarH = o, t.VScrollBar = r, t.HScrollBar = o;
      }), ace.define("ace/renderloop", ["require", "exports", "module", "ace/lib/event"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          (this || _global).onRender = e, (this || _global).pending = !1, (this || _global).changes = 0, (this || _global).$recursionLimit = 2, (this || _global).window = t || window;
          var i = this || _global;

          (this || _global)._flush = function (e) {
            i.pending = !1;
            var t = i.changes;
            t && (r.blockIdle(100), i.changes = 0, i.onRender(t)), i.changes ? i.$recursionLimit-- < 0 || i.schedule() : i.$recursionLimit = 2;
          };
        }

        var r = e("./lib/event");
        !function () {
          (this || _global).schedule = function (e) {
            (this || _global).changes = (this || _global).changes | e, (this || _global).changes && !(this || _global).pending && (r.nextFrame((this || _global)._flush), (this || _global).pending = !0);
          }, (this || _global).clear = function (e) {
            var t = (this || _global).changes;
            return (this || _global).changes = 0, t;
          };
        }.call(n.prototype), t.RenderLoop = n;
      }), ace.define("ace/layer/font_metrics", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/lib/lang", "ace/lib/event", "ace/lib/useragent", "ace/lib/event_emitter"], function (e, t, i) {
        var n = e("../lib/oop"),
            r = e("../lib/dom"),
            o = e("../lib/lang"),
            s = e("../lib/event"),
            a = e("../lib/useragent"),
            l = e("../lib/event_emitter").EventEmitter,
            c = "function" == typeof ResizeObserver,
            e = t.FontMetrics = function (e) {
          (this || _global).el = r.createElement("div"), this.$setMeasureNodeStyles((this || _global).el.style, !0), (this || _global).$main = r.createElement("div"), this.$setMeasureNodeStyles((this || _global).$main.style), (this || _global).$measureNode = r.createElement("div"), this.$setMeasureNodeStyles((this || _global).$measureNode.style), (this || _global).el.appendChild((this || _global).$main), (this || _global).el.appendChild((this || _global).$measureNode), e.appendChild((this || _global).el), (this || _global).$measureNode.textContent = o.stringRepeat("X", 256), (this || _global).$characterSize = {
            width: 0,
            height: 0
          }, c ? this.$addObserver() : this.checkForSizeChanges();
        };

        !function () {
          n.implement(this || _global, l), (this || _global).$characterSize = {
            width: 0,
            height: 0
          }, (this || _global).$setMeasureNodeStyles = function (e, t) {
            e.width = e.height = "auto", e.left = e.top = "0px", e.visibility = "hidden", e.position = "absolute", e.whiteSpace = "pre", a.isIE < 8 ? e["font-family"] = "inherit" : e.font = "inherit", e.overflow = t ? "hidden" : "visible";
          }, (this || _global).checkForSizeChanges = function (e) {
            var t;
            !(e = void 0 === e ? this.$measureSizes() : e) || (this || _global).$characterSize.width === e.width && (this || _global).$characterSize.height === e.height || ((this || _global).$measureNode.style.fontWeight = "bold", t = this.$measureSizes(), (this || _global).$measureNode.style.fontWeight = "", (this || _global).$characterSize = e, (this || _global).charSizes = Object.create(null), (this || _global).allowBoldFonts = t && t.width === e.width && t.height === e.height, this._emit("changeCharacterSize", {
              data: e
            }));
          }, (this || _global).$addObserver = function () {
            var t = this || _global;
            (this || _global).$observer = new window.ResizeObserver(function (e) {
              t.checkForSizeChanges();
            }), (this || _global).$observer.observe((this || _global).$measureNode);
          }, (this || _global).$pollSizeChanges = function () {
            if ((this || _global).$pollSizeChangesTimer || (this || _global).$observer) return (this || _global).$pollSizeChangesTimer;
            var t = this || _global;
            return (this || _global).$pollSizeChangesTimer = s.onIdle(function e() {
              t.checkForSizeChanges(), s.onIdle(e, 500);
            }, 500);
          }, (this || _global).setPolling = function (e) {
            e ? this.$pollSizeChanges() : (this || _global).$pollSizeChangesTimer && (clearInterval((this || _global).$pollSizeChangesTimer), (this || _global).$pollSizeChangesTimer = 0);
          }, (this || _global).$measureSizes = function (e) {
            e = {
              height: (e || (this || _global).$measureNode).clientHeight,
              width: (e || (this || _global).$measureNode).clientWidth / 256
            };
            return 0 === e.width || 0 === e.height ? null : e;
          }, (this || _global).$measureCharWidth = function (e) {
            return (this || _global).$main.textContent = o.stringRepeat(e, 256), (this || _global).$main.getBoundingClientRect().width / 256;
          }, (this || _global).getCharacterWidth = function (e) {
            var t = (this || _global).charSizes[e];
            return t = void 0 === t ? (this || _global).charSizes[e] = this.$measureCharWidth(e) / (this || _global).$characterSize.width : t;
          }, (this || _global).destroy = function () {
            clearInterval((this || _global).$pollSizeChangesTimer), (this || _global).$observer && (this || _global).$observer.disconnect(), (this || _global).el && (this || _global).el.parentNode && (this || _global).el.parentNode.removeChild((this || _global).el);
          }, (this || _global).$getZoom = function e(t) {
            return t && t.parentElement ? (window.getComputedStyle(t).zoom || 1) * e(t.parentElement) : 1;
          }, (this || _global).$initTransformMeasureNodes = function () {
            function e(e, t) {
              return ["div", {
                style: "position: absolute;top:" + e + "px;left:" + t + "px;"
              }];
            }

            (this || _global).els = r.buildDom([e(0, 0), e(200, 0), e(0, 200), e(200, 200)], (this || _global).el);
          }, (this || _global).transformCoordinates = function (e, t) {
            function i(e, t, i) {
              var n = e[1] * t[0] - e[0] * t[1];
              return [(-t[1] * i[0] + t[0] * i[1]) / n, (+e[1] * i[0] - e[0] * i[1]) / n];
            }

            function n(e, t) {
              return [e[0] - t[0], e[1] - t[1]];
            }

            function r(e, t) {
              return [e[0] + t[0], e[1] + t[1]];
            }

            function o(e, t) {
              return [e * t[0], e * t[1]];
            }

            function s(e) {
              e = e.getBoundingClientRect();
              return [e.left, e.top];
            }

            e = e && o(1 / this.$getZoom((this || _global).el), e), (this || _global).els || this.$initTransformMeasureNodes();
            var a = s((this || _global).els[0]),
                l = s((this || _global).els[1]),
                c = s((this || _global).els[2]),
                h = s((this || _global).els[3]),
                h = i(n(h, l), n(h, c), n(r(l, c), r(h, a))),
                l = o(1 + h[0], n(l, a)),
                c = o(1 + h[1], n(c, a));
            if (t) return d = h[0] * t[0] / 200 + h[1] * t[1] / 200 + 1, t = r(o(t[0], l), o(t[1], c)), r(o(1 / d / 200, t), a);
            var d = n(e, a),
                t = i(n(l, o(h[0], d)), n(c, o(h[1], d)), d);
            return o(200, t);
          };
        }.call(e.prototype);
      }), ace.define("ace/virtual_renderer", ["require", "exports", "module", "ace/lib/oop", "ace/lib/dom", "ace/config", "ace/layer/gutter", "ace/layer/marker", "ace/layer/text", "ace/layer/cursor", "ace/scrollbar", "ace/scrollbar", "ace/renderloop", "ace/layer/font_metrics", "ace/lib/event_emitter", "ace/lib/useragent"], function (e, t, i) {
        "use strict";

        function n(e, t) {
          var i = this || _global,
              e = ((this || _global).container = e || a.createElement("div"), a.addCssClass((this || _global).container, "ace_editor"), a.HI_DPI && a.addCssClass((this || _global).container, "ace_hidpi"), this.setTheme(t), null == o.get("useStrictCSP") && o.set("useStrictCSP", !1), (this || _global).$gutter = a.createElement("div"), (this || _global).$gutter.className = "ace_gutter", (this || _global).container.appendChild((this || _global).$gutter), (this || _global).$gutter.setAttribute("aria-hidden", !0), (this || _global).scroller = a.createElement("div"), (this || _global).scroller.className = "ace_scroller", (this || _global).container.appendChild((this || _global).scroller), (this || _global).content = a.createElement("div"), (this || _global).content.className = "ace_content", (this || _global).scroller.appendChild((this || _global).content), (this || _global).$gutterLayer = new s((this || _global).$gutter), (this || _global).$gutterLayer.on("changeGutterWidth", (this || _global).onGutterResize.bind(this || _global)), (this || _global).$markerBack = new l((this || _global).content), (this || _global).$textLayer = new c((this || _global).content));
          (this || _global).canvas = e.element, (this || _global).$markerFront = new l((this || _global).content), (this || _global).$cursorLayer = new h((this || _global).content), (this || _global).$horizScroll = !1, (this || _global).$vScroll = !1, (this || _global).scrollBar = (this || _global).scrollBarV = new u((this || _global).container, this || _global), (this || _global).scrollBarH = new d((this || _global).container, this || _global), (this || _global).scrollBarV.on("scroll", function (e) {
            i.$scrollAnimation || i.session.setScrollTop(e.data - i.scrollMargin.top);
          }), (this || _global).scrollBarH.on("scroll", function (e) {
            i.$scrollAnimation || i.session.setScrollLeft(e.data - i.scrollMargin.left);
          }), (this || _global).scrollTop = 0, (this || _global).scrollLeft = 0, (this || _global).cursorPos = {
            row: 0,
            column: 0
          }, (this || _global).$fontMetrics = new p((this || _global).container), (this || _global).$textLayer.$setFontMetrics((this || _global).$fontMetrics), (this || _global).$textLayer.on("changeCharacterSize", function (e) {
            i.updateCharacterSize(), i.onResize(!0, i.gutterWidth, i.$size.width, i.$size.height), i._signal("changeCharacterSize", e);
          }), (this || _global).$size = {
            width: 0,
            height: 0,
            scrollerHeight: 0,
            scrollerWidth: 0,
            $dirty: !0
          }, (this || _global).layerConfig = {
            width: 1,
            padding: 0,
            firstRow: 0,
            firstRowScreen: 0,
            lastRow: 0,
            lineHeight: 0,
            characterWidth: 0,
            minHeight: 1,
            maxHeight: 1,
            offset: 0,
            height: 1,
            gutterOffset: 1
          }, (this || _global).scrollMargin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            v: 0,
            h: 0
          }, (this || _global).margin = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            v: 0,
            h: 0
          }, (this || _global).$keepTextAreaAtCursor = !C.isIOS, (this || _global).$loop = new g((this || _global).$renderChanges.bind(this || _global), (this || _global).container.ownerDocument.defaultView), (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.updateCharacterSize(), this.setPadding(4), o.resetOptions(this || _global), o._signal("renderer", this || _global);
        }

        var r = e("./lib/oop"),
            a = e("./lib/dom"),
            o = e("./config"),
            s = e("./layer/gutter").Gutter,
            l = e("./layer/marker").Marker,
            c = e("./layer/text").Text,
            h = e("./layer/cursor").Cursor,
            d = e("./scrollbar").HScrollBar,
            u = e("./scrollbar").VScrollBar,
            g = e("./renderloop").RenderLoop,
            p = e("./layer/font_metrics").FontMetrics,
            m = e("./lib/event_emitter").EventEmitter,
            f = ".ace_br1 {border-top-left-radius    : 3px;}.ace_br2 {border-top-right-radius   : 3px;}.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}.ace_br4 {border-bottom-right-radius: 3px;}.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}.ace_br8 {border-bottom-left-radius : 3px;}.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}.ace_editor {position: relative;overflow: hidden;padding: 0;font: 12px/normal 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;direction: ltr;text-align: left;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}.ace_scroller {position: absolute;overflow: hidden;top: 0;bottom: 0;background-color: inherit;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;cursor: text;}.ace_content {position: absolute;box-sizing: border-box;min-width: 100%;contain: style size layout;font-variant-ligatures: no-common-ligatures;}.ace_dragging .ace_scroller:before{position: absolute;top: 0;left: 0;right: 0;bottom: 0;content: '';background: rgba(250, 250, 250, 0.01);z-index: 1000;}.ace_dragging.ace_dark .ace_scroller:before{background: rgba(0, 0, 0, 0.01);}.ace_selecting, .ace_selecting * {cursor: text !important;}.ace_gutter {position: absolute;overflow : hidden;width: auto;top: 0;bottom: 0;left: 0;cursor: default;z-index: 4;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;contain: style size layout;}.ace_gutter-active-line {position: absolute;left: 0;right: 0;}.ace_scroller.ace_scroll-left {box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;}.ace_gutter-cell {position: absolute;top: 0;left: 0;right: 0;padding-left: 19px;padding-right: 6px;background-repeat: no-repeat;}.ace_gutter-cell.ace_error {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==\");background-repeat: no-repeat;background-position: 2px center;}.ace_gutter-cell.ace_warning {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==\");background-position: 2px center;}.ace_gutter-cell.ace_info {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=\");background-position: 2px center;}.ace_dark .ace_gutter-cell.ace_info {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC\");}.ace_scrollbar {contain: strict;position: absolute;right: 0;bottom: 0;z-index: 6;}.ace_scrollbar-inner {position: absolute;cursor: text;left: 0;top: 0;}.ace_scrollbar-v{overflow-x: hidden;overflow-y: scroll;top: 0;}.ace_scrollbar-h {overflow-x: scroll;overflow-y: hidden;left: 0;}.ace_print-margin {position: absolute;height: 100%;}.ace_text-input {position: absolute;z-index: 0;width: 0.5em;height: 1em;opacity: 0;background: transparent;-moz-appearance: none;appearance: none;border: none;resize: none;outline: none;overflow: hidden;font: inherit;padding: 0 1px;margin: 0 -1px;contain: strict;-ms-user-select: text;-moz-user-select: text;-webkit-user-select: text;user-select: text;white-space: pre!important;}.ace_text-input.ace_composition {background: transparent;color: inherit;z-index: 1000;opacity: 1;}.ace_composition_placeholder { color: transparent }.ace_composition_marker { border-bottom: 1px solid;position: absolute;border-radius: 0;margin-top: 1px;}[ace_nocontext=true] {transform: none!important;filter: none!important;clip-path: none!important;mask : none!important;contain: none!important;perspective: none!important;mix-blend-mode: initial!important;z-index: auto;}.ace_layer {z-index: 1;position: absolute;overflow: hidden;word-wrap: normal;white-space: pre;height: 100%;width: 100%;box-sizing: border-box;pointer-events: none;}.ace_gutter-layer {position: relative;width: auto;text-align: right;pointer-events: auto;height: 1000000px;contain: style size layout;}.ace_text-layer {font: inherit !important;position: absolute;height: 1000000px;width: 1000000px;contain: style size layout;}.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {contain: style size layout;position: absolute;top: 0;left: 0;right: 0;}.ace_hidpi .ace_text-layer,.ace_hidpi .ace_gutter-layer,.ace_hidpi .ace_content,.ace_hidpi .ace_gutter {contain: strict;will-change: transform;}.ace_hidpi .ace_text-layer > .ace_line, .ace_hidpi .ace_text-layer > .ace_line_group {contain: strict;}.ace_cjk {display: inline-block;text-align: center;}.ace_cursor-layer {z-index: 4;}.ace_cursor {z-index: 4;position: absolute;box-sizing: border-box;border-left: 2px solid;transform: translatez(0);}.ace_multiselect .ace_cursor {border-left-width: 1px;}.ace_slim-cursors .ace_cursor {border-left-width: 1px;}.ace_overwrite-cursors .ace_cursor {border-left-width: 0;border-bottom: 1px solid;}.ace_hidden-cursors .ace_cursor {opacity: 0.2;}.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {opacity: 0;}.ace_smooth-blinking .ace_cursor {transition: opacity 0.18s;}.ace_animate-blinking .ace_cursor {animation-duration: 1000ms;animation-timing-function: step-end;animation-name: blink-ace-animate;animation-iteration-count: infinite;}.ace_animate-blinking.ace_smooth-blinking .ace_cursor {animation-duration: 1000ms;animation-timing-function: ease-in-out;animation-name: blink-ace-animate-smooth;}@keyframes blink-ace-animate {from, to { opacity: 1; }60% { opacity: 0; }}@keyframes blink-ace-animate-smooth {from, to { opacity: 1; }45% { opacity: 1; }60% { opacity: 0; }85% { opacity: 0; }}.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {position: absolute;z-index: 3;}.ace_marker-layer .ace_selection {position: absolute;z-index: 5;}.ace_marker-layer .ace_bracket {position: absolute;z-index: 6;}.ace_marker-layer .ace_error_bracket {position: absolute;border-bottom: 1px solid #DE5555;border-radius: 0;}.ace_marker-layer .ace_active-line {position: absolute;z-index: 2;}.ace_marker-layer .ace_selected-word {position: absolute;z-index: 4;box-sizing: border-box;}.ace_line .ace_fold {box-sizing: border-box;display: inline-block;height: 11px;margin-top: -2px;vertical-align: middle;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=\");background-repeat: no-repeat, repeat-x;background-position: center center, top left;color: transparent;border: 1px solid black;border-radius: 2px;cursor: pointer;pointer-events: auto;}.ace_dark .ace_fold {}.ace_fold:hover{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII=\"),url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC\");}.ace_tooltip {background-color: #FFF;background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));border: 1px solid gray;border-radius: 1px;box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);color: black;max-width: 100%;padding: 3px 4px;position: fixed;z-index: 999999;box-sizing: border-box;cursor: default;white-space: pre;word-wrap: break-word;line-height: normal;font-style: normal;font-weight: normal;letter-spacing: normal;pointer-events: none;}.ace_folding-enabled > .ace_gutter-cell {padding-right: 13px;}.ace_fold-widget {box-sizing: border-box;margin: 0 -12px 0 1px;display: none;width: 11px;vertical-align: top;background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==\");background-repeat: no-repeat;background-position: center;border-radius: 3px;border: 1px solid transparent;cursor: pointer;}.ace_folding-enabled .ace_fold-widget {display: inline-block;   }.ace_fold-widget.ace_end {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==\");}.ace_fold-widget.ace_closed {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==\");}.ace_fold-widget:hover {border: 1px solid rgba(0, 0, 0, 0.3);background-color: rgba(255, 255, 255, 0.2);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);}.ace_fold-widget:active {border: 1px solid rgba(0, 0, 0, 0.4);background-color: rgba(0, 0, 0, 0.05);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);}.ace_dark .ace_fold-widget {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC\");}.ace_dark .ace_fold-widget.ace_end {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==\");}.ace_dark .ace_fold-widget.ace_closed {background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==\");}.ace_dark .ace_fold-widget:hover {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);background-color: rgba(255, 255, 255, 0.1);}.ace_dark .ace_fold-widget:active {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);}.ace_inline_button {border: 1px solid lightgray;display: inline-block;margin: -1px 8px;padding: 0 5px;pointer-events: auto;cursor: pointer;}.ace_inline_button:hover {border-color: gray;background: rgba(200,200,200,0.2);display: inline-block;pointer-events: auto;}.ace_fold-widget.ace_invalid {background-color: #FFB4B4;border-color: #DE5555;}.ace_fade-fold-widgets .ace_fold-widget {transition: opacity 0.4s ease 0.05s;opacity: 0;}.ace_fade-fold-widgets:hover .ace_fold-widget {transition: opacity 0.05s ease 0.05s;opacity:1;}.ace_underline {text-decoration: underline;}.ace_bold {font-weight: bold;}.ace_nobold .ace_bold {font-weight: normal;}.ace_italic {font-style: italic;}.ace_error-marker {background-color: rgba(255, 0, 0,0.2);position: absolute;z-index: 9;}.ace_highlight-marker {background-color: rgba(255, 255, 0,0.2);position: absolute;z-index: 8;}.ace_mobile-menu {position: absolute;line-height: 1.5;border-radius: 4px;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;background: white;box-shadow: 1px 3px 2px grey;border: 1px solid #dcdcdc;color: black;}.ace_dark > .ace_mobile-menu {background: #333;color: #ccc;box-shadow: 1px 3px 2px grey;border: 1px solid #444;}.ace_mobile-button {padding: 2px;cursor: pointer;overflow: hidden;}.ace_mobile-button:hover {background-color: #eee;opacity:1;}.ace_mobile-button:active {background-color: #ddd;}.ace_placeholder {font-family: arial;transform: scale(0.9);transform-origin: left;white-space: pre;opacity: 0.7;margin: 0 10px;}",
            C = e("./lib/useragent"),
            I = C.isIE;
        a.importCssString(f, "ace_editor.css", !1);
        !function () {
          (this || _global).CHANGE_CURSOR = 1, (this || _global).CHANGE_MARKER = 2, (this || _global).CHANGE_GUTTER = 4, (this || _global).CHANGE_SCROLL = 8, (this || _global).CHANGE_LINES = 16, (this || _global).CHANGE_TEXT = 32, (this || _global).CHANGE_SIZE = 64, (this || _global).CHANGE_MARKER_BACK = 128, (this || _global).CHANGE_MARKER_FRONT = 256, (this || _global).CHANGE_FULL = 512, (this || _global).CHANGE_H_SCROLL = 1024, r.implement(this || _global, m), (this || _global).updateCharacterSize = function () {
            (this || _global).$textLayer.allowBoldFonts != (this || _global).$allowBoldFonts && ((this || _global).$allowBoldFonts = (this || _global).$textLayer.allowBoldFonts, this.setStyle("ace_nobold", !(this || _global).$allowBoldFonts)), (this || _global).layerConfig.characterWidth = (this || _global).characterWidth = (this || _global).$textLayer.getCharacterWidth(), (this || _global).layerConfig.lineHeight = (this || _global).lineHeight = (this || _global).$textLayer.getLineHeight(), this.$updatePrintMargin(), a.setStyle((this || _global).scroller.style, "line-height", (this || _global).lineHeight + "px");
          }, (this || _global).setSession = function (e) {
            (this || _global).session && (this || _global).session.doc.off("changeNewLineMode", (this || _global).onChangeNewLineMode), ((this || _global).session = e) && (this || _global).scrollMargin.top && e.getScrollTop() <= 0 && e.setScrollTop(-(this || _global).scrollMargin.top), (this || _global).$cursorLayer.setSession(e), (this || _global).$markerBack.setSession(e), (this || _global).$markerFront.setSession(e), (this || _global).$gutterLayer.setSession(e), (this || _global).$textLayer.setSession(e), e && ((this || _global).$loop.schedule((this || _global).CHANGE_FULL), (this || _global).session.$setFontMetrics((this || _global).$fontMetrics), (this || _global).scrollBarH.scrollLeft = (this || _global).scrollBarV.scrollTop = null, (this || _global).onChangeNewLineMode = (this || _global).onChangeNewLineMode.bind(this || _global), this.onChangeNewLineMode(), (this || _global).session.doc.on("changeNewLineMode", (this || _global).onChangeNewLineMode));
          }, (this || _global).updateLines = function (e, t, i) {
            if (void 0 === t && (t = 1 / 0), (this || _global).$changedLines ? ((this || _global).$changedLines.firstRow > e && ((this || _global).$changedLines.firstRow = e), (this || _global).$changedLines.lastRow < t && ((this || _global).$changedLines.lastRow = t)) : (this || _global).$changedLines = {
              firstRow: e,
              lastRow: t
            }, (this || _global).$changedLines.lastRow < (this || _global).layerConfig.firstRow) {
              if (!i) return;
              (this || _global).$changedLines.lastRow = (this || _global).layerConfig.lastRow;
            }

            (this || _global).$changedLines.firstRow > (this || _global).layerConfig.lastRow || (this || _global).$loop.schedule((this || _global).CHANGE_LINES);
          }, (this || _global).onChangeNewLineMode = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT), (this || _global).$textLayer.$updateEolChar(), (this || _global).session.$bidiHandler.setEolChar((this || _global).$textLayer.EOL_CHAR);
          }, (this || _global).onChangeTabSize = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT | (this || _global).CHANGE_MARKER), (this || _global).$textLayer.onChangeTabSize();
          }, (this || _global).updateText = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
          }, (this || _global).updateFull = function (e) {
            e ? this.$renderChanges((this || _global).CHANGE_FULL, !0) : (this || _global).$loop.schedule((this || _global).CHANGE_FULL);
          }, (this || _global).updateFontSize = function () {
            (this || _global).$textLayer.checkForSizeChanges();
          }, (this || _global).$changes = 0, (this || _global).$updateSizeAsync = function () {
            (this || _global).$loop.pending ? (this || _global).$size.$dirty = !0 : this.onResize();
          }, (this || _global).onResize = function (e, t, i, n) {
            if (!(2 < (this || _global).resizing)) {
              0 < (this || _global).resizing ? (this || _global).resizing++ : (this || _global).resizing = e ? 1 : 0;
              var r = (this || _global).container,
                  r = (n = n || r.clientHeight || r.scrollHeight, i = i || r.clientWidth || r.scrollWidth, this.$updateCachedSize(e, t, i, n));
              if (!(this || _global).$size.scrollerHeight || !i && !n) return (this || _global).resizing = 0;
              e && ((this || _global).$gutterLayer.$padding = null), e ? this.$renderChanges(r | (this || _global).$changes, !0) : (this || _global).$loop.schedule(r | (this || _global).$changes), (this || _global).resizing && ((this || _global).resizing = 0), (this || _global).scrollBarH.scrollLeft = (this || _global).scrollBarV.scrollTop = null;
            }
          }, (this || _global).$updateCachedSize = function (e, t, i, n) {
            n -= (this || _global).$extraHeight || 0;
            var r = 0,
                o = (this || _global).$size,
                s = {
              width: o.width,
              height: o.height,
              scrollerHeight: o.scrollerHeight,
              scrollerWidth: o.scrollerWidth
            };
            return n && (e || o.height != n) && (o.height = n, r |= (this || _global).CHANGE_SIZE, o.scrollerHeight = o.height, (this || _global).$horizScroll && (o.scrollerHeight -= (this || _global).scrollBarH.getHeight()), (this || _global).scrollBarV.element.style.bottom = (this || _global).scrollBarH.getHeight() + "px", r |= (this || _global).CHANGE_SCROLL), i && (e || o.width != i) && (r |= (this || _global).CHANGE_SIZE, o.width = i, null == t && (t = (this || _global).$showGutter ? (this || _global).$gutter.offsetWidth : 0), (this || _global).gutterWidth = t, a.setStyle((this || _global).scrollBarH.element.style, "left", t + "px"), a.setStyle((this || _global).scroller.style, "left", t + (this || _global).margin.left + "px"), o.scrollerWidth = Math.max(0, i - t - (this || _global).scrollBarV.getWidth() - (this || _global).margin.h), a.setStyle((this || _global).$gutter.style, "left", (this || _global).margin.left + "px"), t = (this || _global).scrollBarV.getWidth() + "px", a.setStyle((this || _global).scrollBarH.element.style, "right", t), a.setStyle((this || _global).scroller.style, "right", t), a.setStyle((this || _global).scroller.style, "bottom", (this || _global).scrollBarH.getHeight()), ((this || _global).session && (this || _global).session.getUseWrapMode() && this.adjustWrapLimit() || e) && (r |= (this || _global).CHANGE_FULL)), o.$dirty = !i || !n, r && this._signal("resize", s), r;
          }, (this || _global).onGutterResize = function (e) {
            e = (this || _global).$showGutter ? e : 0;
            e != (this || _global).gutterWidth && ((this || _global).$changes |= this.$updateCachedSize(!0, e, (this || _global).$size.width, (this || _global).$size.height)), (this || _global).session.getUseWrapMode() && this.adjustWrapLimit() || (this || _global).$size.$dirty ? (this || _global).$loop.schedule((this || _global).CHANGE_FULL) : this.$computeLayerConfig();
          }, (this || _global).adjustWrapLimit = function () {
            var e = (this || _global).$size.scrollerWidth - 2 * (this || _global).$padding,
                e = Math.floor(e / (this || _global).characterWidth);
            return (this || _global).session.adjustWrapLimit(e, (this || _global).$showPrintMargin && (this || _global).$printMarginColumn);
          }, (this || _global).setAnimatedScroll = function (e) {
            this.setOption("animatedScroll", e);
          }, (this || _global).getAnimatedScroll = function () {
            return (this || _global).$animatedScroll;
          }, (this || _global).setShowInvisibles = function (e) {
            this.setOption("showInvisibles", e), (this || _global).session.$bidiHandler.setShowInvisibles(e);
          }, (this || _global).getShowInvisibles = function () {
            return this.getOption("showInvisibles");
          }, (this || _global).getDisplayIndentGuides = function () {
            return this.getOption("displayIndentGuides");
          }, (this || _global).setDisplayIndentGuides = function (e) {
            this.setOption("displayIndentGuides", e);
          }, (this || _global).setShowPrintMargin = function (e) {
            this.setOption("showPrintMargin", e);
          }, (this || _global).getShowPrintMargin = function () {
            return this.getOption("showPrintMargin");
          }, (this || _global).setPrintMarginColumn = function (e) {
            this.setOption("printMarginColumn", e);
          }, (this || _global).getPrintMarginColumn = function () {
            return this.getOption("printMarginColumn");
          }, (this || _global).getShowGutter = function () {
            return this.getOption("showGutter");
          }, (this || _global).setShowGutter = function (e) {
            return this.setOption("showGutter", e);
          }, (this || _global).getFadeFoldWidgets = function () {
            return this.getOption("fadeFoldWidgets");
          }, (this || _global).setFadeFoldWidgets = function (e) {
            this.setOption("fadeFoldWidgets", e);
          }, (this || _global).setHighlightGutterLine = function (e) {
            this.setOption("highlightGutterLine", e);
          }, (this || _global).getHighlightGutterLine = function () {
            return this.getOption("highlightGutterLine");
          }, (this || _global).$updatePrintMargin = function () {
            var e;
            ((this || _global).$showPrintMargin || (this || _global).$printMarginEl) && ((this || _global).$printMarginEl || ((e = a.createElement("div")).className = "ace_layer ace_print-margin-layer", (this || _global).$printMarginEl = a.createElement("div"), (this || _global).$printMarginEl.className = "ace_print-margin", e.appendChild((this || _global).$printMarginEl), (this || _global).content.insertBefore(e, (this || _global).content.firstChild)), (e = (this || _global).$printMarginEl.style).left = Math.round((this || _global).characterWidth * (this || _global).$printMarginColumn + (this || _global).$padding) + "px", e.visibility = (this || _global).$showPrintMargin ? "visible" : "hidden", (this || _global).session && -1 == (this || _global).session.$wrap && this.adjustWrapLimit());
          }, (this || _global).getContainerElement = function () {
            return (this || _global).container;
          }, (this || _global).getMouseEventTarget = function () {
            return (this || _global).scroller;
          }, (this || _global).getTextAreaContainer = function () {
            return (this || _global).container;
          }, (this || _global).$moveTextAreaToCursor = function () {
            var e, t, i, n, r, o, s;
            (this || _global).$isMousePressed || (e = (this || _global).textarea.style, o = (this || _global).$composition, (this || _global).$keepTextAreaAtCursor || o ? (i = (this || _global).$cursorLayer.$pixelPos) && (o && o.markerRange && (i = (this || _global).$cursorLayer.getPixelPosition(o.markerRange.start, !0)), s = (this || _global).layerConfig, t = i.top, i = i.left, t -= s.offset, n = o && o.useTextareaForIME ? (this || _global).lineHeight : I ? 0 : 1, t < 0 || t > s.height - n ? a.translate((this || _global).textarea, 0, 0) : (s = 1, r = (this || _global).$size.height - n, o ? o.useTextareaForIME ? (o = (this || _global).textarea.value, s = (this || _global).characterWidth * (this || _global).session.$getStringScreenWidth(o)[0]) : t += (this || _global).lineHeight + 2 : t += (this || _global).lineHeight, (i -= (this || _global).scrollLeft) > (this || _global).$size.scrollerWidth - s && (i = (this || _global).$size.scrollerWidth - s), i += (this || _global).gutterWidth + (this || _global).margin.left, a.setStyle(e, "height", n + "px"), a.setStyle(e, "width", s + "px"), a.translate((this || _global).textarea, Math.min(i, (this || _global).$size.scrollerWidth - s), Math.min(t, r)))) : a.translate((this || _global).textarea, -100, 0));
          }, (this || _global).getFirstVisibleRow = function () {
            return (this || _global).layerConfig.firstRow;
          }, (this || _global).getFirstFullyVisibleRow = function () {
            return (this || _global).layerConfig.firstRow + (0 === (this || _global).layerConfig.offset ? 0 : 1);
          }, (this || _global).getLastFullyVisibleRow = function () {
            var e = (this || _global).layerConfig,
                t = e.lastRow;
            return (this || _global).session.documentToScreenRow(t, 0) * e.lineHeight - (this || _global).session.getScrollTop() > e.height - e.lineHeight ? t - 1 : t;
          }, (this || _global).getLastVisibleRow = function () {
            return (this || _global).layerConfig.lastRow;
          }, (this || _global).$padding = null, (this || _global).setPadding = function (e) {
            (this || _global).$padding = e, (this || _global).$textLayer.setPadding(e), (this || _global).$cursorLayer.setPadding(e), (this || _global).$markerFront.setPadding(e), (this || _global).$markerBack.setPadding(e), (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.$updatePrintMargin();
          }, (this || _global).setScrollMargin = function (e, t, i, n) {
            var r = (this || _global).scrollMargin;
            r.top = 0 | e, r.bottom = 0 | t, r.right = 0 | n, r.left = 0 | i, r.v = r.top + r.bottom, r.h = r.left + r.right, r.top && (this || _global).scrollTop <= 0 && (this || _global).session && (this || _global).session.setScrollTop(-r.top), this.updateFull();
          }, (this || _global).setMargin = function (e, t, i, n) {
            var r = (this || _global).margin;
            r.top = 0 | e, r.bottom = 0 | t, r.right = 0 | n, r.left = 0 | i, r.v = r.top + r.bottom, r.h = r.left + r.right, this.$updateCachedSize(!0, (this || _global).gutterWidth, (this || _global).$size.width, (this || _global).$size.height), this.updateFull();
          }, (this || _global).getHScrollBarAlwaysVisible = function () {
            return (this || _global).$hScrollBarAlwaysVisible;
          }, (this || _global).setHScrollBarAlwaysVisible = function (e) {
            this.setOption("hScrollBarAlwaysVisible", e);
          }, (this || _global).getVScrollBarAlwaysVisible = function () {
            return (this || _global).$vScrollBarAlwaysVisible;
          }, (this || _global).setVScrollBarAlwaysVisible = function (e) {
            this.setOption("vScrollBarAlwaysVisible", e);
          }, (this || _global).$updateScrollBarV = function () {
            var e = (this || _global).layerConfig.maxHeight,
                t = (this || _global).$size.scrollerHeight;
            !(this || _global).$maxLines && (this || _global).$scrollPastEnd && (e -= (t - (this || _global).lineHeight) * (this || _global).$scrollPastEnd, (this || _global).scrollTop > e - t && (e = (this || _global).scrollTop + t, (this || _global).scrollBarV.scrollTop = null)), (this || _global).scrollBarV.setScrollHeight(e + (this || _global).scrollMargin.v), (this || _global).scrollBarV.setScrollTop((this || _global).scrollTop + (this || _global).scrollMargin.top);
          }, (this || _global).$updateScrollBarH = function () {
            (this || _global).scrollBarH.setScrollWidth((this || _global).layerConfig.width + 2 * (this || _global).$padding + (this || _global).scrollMargin.h), (this || _global).scrollBarH.setScrollLeft((this || _global).scrollLeft + (this || _global).scrollMargin.left);
          }, (this || _global).$frozen = !1, (this || _global).freeze = function () {
            (this || _global).$frozen = !0;
          }, (this || _global).unfreeze = function () {
            (this || _global).$frozen = !1;
          }, (this || _global).$renderChanges = function (e, t) {
            if ((this || _global).$changes && (e |= (this || _global).$changes, (this || _global).$changes = 0), (this || _global).session && (this || _global).container.offsetWidth && !(this || _global).$frozen && (e || t)) {
              if ((this || _global).$size.$dirty) return (this || _global).$changes |= e, this.onResize(!0);
              (this || _global).lineHeight || (this || _global).$textLayer.checkForSizeChanges(), this._signal("beforeRender", e), (this || _global).session && (this || _global).session.$bidiHandler && (this || _global).session.$bidiHandler.updateCharacterWidths((this || _global).$fontMetrics);
              var i,
                  n,
                  t = (this || _global).layerConfig;
              return ((e & (this || _global).CHANGE_FULL || e & (this || _global).CHANGE_SIZE || e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_LINES || e & (this || _global).CHANGE_SCROLL || e & (this || _global).CHANGE_H_SCROLL) && (e |= this.$computeLayerConfig() | (this || _global).$loop.clear(), t.firstRow != (this || _global).layerConfig.firstRow && t.firstRowScreen == (this || _global).layerConfig.firstRowScreen && 0 < (i = (this || _global).scrollTop + (t.firstRow - (this || _global).layerConfig.firstRow) * (this || _global).lineHeight) && ((this || _global).scrollTop = i, e = (e |= (this || _global).CHANGE_SCROLL) | (this.$computeLayerConfig() | (this || _global).$loop.clear())), t = (this || _global).layerConfig, this.$updateScrollBarV(), e & (this || _global).CHANGE_H_SCROLL && this.$updateScrollBarH(), a.translate((this || _global).content, -(this || _global).scrollLeft, -t.offset), i = t.width + 2 * (this || _global).$padding + "px", n = t.minHeight + "px", a.setStyle((this || _global).content.style, "width", i), a.setStyle((this || _global).content.style, "height", n)), e & (this || _global).CHANGE_H_SCROLL && (a.translate((this || _global).content, -(this || _global).scrollLeft, -t.offset), (this || _global).scroller.className = (this || _global).scrollLeft <= 0 ? "ace_scroller" : "ace_scroller ace_scroll-left"), e & (this || _global).CHANGE_FULL) ? ((this || _global).$changedLines = null, (this || _global).$textLayer.update(t), (this || _global).$showGutter && (this || _global).$gutterLayer.update(t), (this || _global).$markerBack.update(t), (this || _global).$markerFront.update(t), (this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor(), void this._signal("afterRender", e)) : (e & (this || _global).CHANGE_SCROLL ? ((this || _global).$changedLines = null, e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_LINES ? (this || _global).$textLayer.update(t) : (this || _global).$textLayer.scrollLines(t), (this || _global).$showGutter && (e & (this || _global).CHANGE_GUTTER || e & (this || _global).CHANGE_LINES ? (this || _global).$gutterLayer.update(t) : (this || _global).$gutterLayer.scrollLines(t)), (this || _global).$markerBack.update(t), (this || _global).$markerFront.update(t), (this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor()) : (e & (this || _global).CHANGE_TEXT ? ((this || _global).$changedLines = null, (this || _global).$textLayer.update(t), (this || _global).$showGutter && (this || _global).$gutterLayer.update(t)) : e & (this || _global).CHANGE_LINES ? (this.$updateLines() || e & (this || _global).CHANGE_GUTTER && (this || _global).$showGutter) && (this || _global).$gutterLayer.update(t) : e & (this || _global).CHANGE_TEXT || e & (this || _global).CHANGE_GUTTER ? (this || _global).$showGutter && (this || _global).$gutterLayer.update(t) : e & (this || _global).CHANGE_CURSOR && (this || _global).$highlightGutterLine && (this || _global).$gutterLayer.updateLineHighlight(t), e & (this || _global).CHANGE_CURSOR && ((this || _global).$cursorLayer.update(t), this.$moveTextAreaToCursor()), e & ((this || _global).CHANGE_MARKER | (this || _global).CHANGE_MARKER_FRONT) && (this || _global).$markerFront.update(t), e & ((this || _global).CHANGE_MARKER | (this || _global).CHANGE_MARKER_BACK) && (this || _global).$markerBack.update(t)), void this._signal("afterRender", e));
            }

            (this || _global).$changes |= e;
          }, (this || _global).$autosize = function () {
            var e = (this || _global).session.getScreenLength() * (this || _global).lineHeight,
                t = (this || _global).$maxLines * (this || _global).lineHeight,
                i = Math.min(t, Math.max(((this || _global).$minLines || 1) * (this || _global).lineHeight, e)) + (this || _global).scrollMargin.v + ((this || _global).$extraHeight || 0);

            (this || _global).$horizScroll && (i += (this || _global).scrollBarH.getHeight());
            t = !((i = (this || _global).$maxPixelHeight && i > (this || _global).$maxPixelHeight ? (this || _global).$maxPixelHeight : i) <= 2 * (this || _global).lineHeight) && t < e;
            i == (this || _global).desiredHeight && (this || _global).$size.height == (this || _global).desiredHeight && t == (this || _global).$vScroll || (t != (this || _global).$vScroll && ((this || _global).$vScroll = t, (this || _global).scrollBarV.setVisible(t)), e = (this || _global).container.clientWidth, (this || _global).container.style.height = i + "px", this.$updateCachedSize(!0, (this || _global).$gutterWidth, e, i), (this || _global).desiredHeight = i, this._signal("autosize"));
          }, (this || _global).$computeLayerConfig = function () {
            var e,
                t = (this || _global).session,
                i = (this || _global).$size,
                n = i.height <= 2 * (this || _global).lineHeight,
                r = (this || _global).session.getScreenLength() * (this || _global).lineHeight,
                o = this.$getLongestLine(),
                s = !n && ((this || _global).$hScrollBarAlwaysVisible || i.scrollerWidth - o - 2 * (this || _global).$padding < 0),
                a = (this || _global).$horizScroll !== s,
                s = (a && ((this || _global).$horizScroll = s, (this || _global).scrollBarH.setVisible(s)), (this || _global).$vScroll),
                l = ((this || _global).$maxLines && 1 < (this || _global).lineHeight && this.$autosize(), i.scrollerHeight + (this || _global).lineHeight),
                c = !(this || _global).$maxLines && (this || _global).$scrollPastEnd ? (i.scrollerHeight - (this || _global).lineHeight) * (this || _global).$scrollPastEnd : 0,
                h = (r += c, (this || _global).scrollMargin),
                n = ((this || _global).session.setScrollTop(Math.max(-h.top, Math.min((this || _global).scrollTop, r - i.scrollerHeight + h.bottom))), (this || _global).session.setScrollLeft(Math.max(-h.left, Math.min((this || _global).scrollLeft, o + 2 * (this || _global).$padding - i.scrollerWidth + h.right))), !n && ((this || _global).$vScrollBarAlwaysVisible || i.scrollerHeight - r + c < 0 || (this || _global).scrollTop > h.top)),
                c = s !== n,
                h = (c && ((this || _global).$vScroll = n, (this || _global).scrollBarV.setVisible(n)), (this || _global).scrollTop % (this || _global).lineHeight),
                s = Math.ceil(l / (this || _global).lineHeight) - 1,
                s = (n = Math.max(0, Math.round(((this || _global).scrollTop - h) / (this || _global).lineHeight))) + s,
                d = (this || _global).lineHeight,
                n = t.screenToDocumentRow(n, 0),
                u = t.getFoldLine(n),
                t = (u && (n = u.start.row), u = t.documentToScreenRow(n, 0), e = t.getRowLength(n) * d, s = Math.min(t.screenToDocumentRow(s, 0), t.getLength() - 1), l = i.scrollerHeight + t.getRowLength(s) * d + e, h = (this || _global).scrollTop - u * d, 0);

            return (this || _global).layerConfig.width == o && !a || (t = (this || _global).CHANGE_H_SCROLL), (a || c) && (t |= this.$updateCachedSize(!0, (this || _global).gutterWidth, i.width, i.height), this._signal("scrollbarVisibilityChanged"), c && (o = this.$getLongestLine())), (this || _global).layerConfig = {
              width: o,
              padding: (this || _global).$padding,
              firstRow: n,
              firstRowScreen: u,
              lastRow: s,
              lineHeight: d,
              characterWidth: (this || _global).characterWidth,
              minHeight: l,
              maxHeight: r,
              offset: h,
              gutterOffset: d ? Math.max(0, Math.ceil((h + i.height - i.scrollerHeight) / d)) : 0,
              height: (this || _global).$size.scrollerHeight
            }, (this || _global).session.$bidiHandler && (this || _global).session.$bidiHandler.setContentWidth(o - (this || _global).$padding), t;
          }, (this || _global).$updateLines = function () {
            if ((this || _global).$changedLines) {
              var e = (this || _global).$changedLines.firstRow,
                  t = (this || _global).$changedLines.lastRow,
                  i = ((this || _global).$changedLines = null, (this || _global).layerConfig);
              if (!(e > i.lastRow + 1 || t < i.firstRow)) return t === 1 / 0 ? ((this || _global).$showGutter && (this || _global).$gutterLayer.update(i), void (this || _global).$textLayer.update(i)) : ((this || _global).$textLayer.updateLines(i, e, t), !0);
            }
          }, (this || _global).$getLongestLine = function () {
            var e = (this || _global).session.getScreenWidth();

            return (this || _global).showInvisibles && !(this || _global).session.$useWrapMode && (e += 1), (this || _global).$textLayer && e > (this || _global).$textLayer.MAX_LINE_LENGTH && (e = (this || _global).$textLayer.MAX_LINE_LENGTH + 30), Math.max((this || _global).$size.scrollerWidth - 2 * (this || _global).$padding, Math.round(e * (this || _global).characterWidth));
          }, (this || _global).updateFrontMarkers = function () {
            (this || _global).$markerFront.setMarkers((this || _global).session.getMarkers(!0)), (this || _global).$loop.schedule((this || _global).CHANGE_MARKER_FRONT);
          }, (this || _global).updateBackMarkers = function () {
            (this || _global).$markerBack.setMarkers((this || _global).session.getMarkers()), (this || _global).$loop.schedule((this || _global).CHANGE_MARKER_BACK);
          }, (this || _global).addGutterDecoration = function (e, t) {
            (this || _global).$gutterLayer.addGutterDecoration(e, t);
          }, (this || _global).removeGutterDecoration = function (e, t) {
            (this || _global).$gutterLayer.removeGutterDecoration(e, t);
          }, (this || _global).updateBreakpoints = function (e) {
            (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
          }, (this || _global).setAnnotations = function (e) {
            (this || _global).$gutterLayer.setAnnotations(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
          }, (this || _global).updateCursor = function () {
            (this || _global).$loop.schedule((this || _global).CHANGE_CURSOR);
          }, (this || _global).hideCursor = function () {
            (this || _global).$cursorLayer.hideCursor();
          }, (this || _global).showCursor = function () {
            (this || _global).$cursorLayer.showCursor();
          }, (this || _global).scrollSelectionIntoView = function (e, t, i) {
            this.scrollCursorIntoView(e, i), this.scrollCursorIntoView(t, i);
          }, (this || _global).scrollCursorIntoView = function (e, t, i) {
            var n, r, o;
            0 !== (this || _global).$size.scrollerHeight && (n = (e = (this || _global).$cursorLayer.getPixelPosition(e)).left, e = e.top, o = i && i.top || 0, i = i && i.bottom || 0, e < (r = (this || _global).$scrollAnimation ? (this || _global).session.getScrollTop() : (this || _global).scrollTop) + o ? (t && r + o > e + (this || _global).lineHeight && (e -= t * (this || _global).$size.scrollerHeight), 0 === e && (e = -(this || _global).scrollMargin.top), (this || _global).session.setScrollTop(e)) : r + (this || _global).$size.scrollerHeight - i < e + (this || _global).lineHeight && (t && r + (this || _global).$size.scrollerHeight - i < e - (this || _global).lineHeight && (e += t * (this || _global).$size.scrollerHeight), (this || _global).session.setScrollTop(e + (this || _global).lineHeight + i - (this || _global).$size.scrollerHeight)), n < (o = (this || _global).scrollLeft) ? (n < (this || _global).$padding + 2 * (this || _global).layerConfig.characterWidth && (n = -(this || _global).scrollMargin.left), (this || _global).session.setScrollLeft(n)) : o + (this || _global).$size.scrollerWidth < n + (this || _global).characterWidth ? (this || _global).session.setScrollLeft(Math.round(n + (this || _global).characterWidth - (this || _global).$size.scrollerWidth)) : o <= (this || _global).$padding && n - o < (this || _global).characterWidth && (this || _global).session.setScrollLeft(0));
          }, (this || _global).getScrollTop = function () {
            return (this || _global).session.getScrollTop();
          }, (this || _global).getScrollLeft = function () {
            return (this || _global).session.getScrollLeft();
          }, (this || _global).getScrollTopRow = function () {
            return (this || _global).scrollTop / (this || _global).lineHeight;
          }, (this || _global).getScrollBottomRow = function () {
            return Math.max(0, Math.floor(((this || _global).scrollTop + (this || _global).$size.scrollerHeight) / (this || _global).lineHeight) - 1);
          }, (this || _global).scrollToRow = function (e) {
            (this || _global).session.setScrollTop(e * (this || _global).lineHeight);
          }, (this || _global).alignCursor = function (e, t) {
            var e = (this || _global).$cursorLayer.getPixelPosition(e = "number" == typeof e ? {
              row: e,
              column: 0
            } : e),
                i = (this || _global).$size.scrollerHeight - (this || _global).lineHeight,
                e = e.top - i * (t || 0);

            return (this || _global).session.setScrollTop(e), e;
          }, (this || _global).STEPS = 8, (this || _global).$calcSteps = function (e, t) {
            for (var i, n, r = 0, o = (this || _global).STEPS, s = [], r = 0; r < o; ++r) s.push((i = r / (this || _global).STEPS, (t - (n = e)) * (Math.pow(i - 1, 3) + 1) + n));

            return s;
          }, (this || _global).scrollToLine = function (e, t, i, n) {
            e = (this || _global).$cursorLayer.getPixelPosition({
              row: e,
              column: 0
            }).top, t && (e -= (this || _global).$size.scrollerHeight / 2), t = (this || _global).scrollTop;
            (this || _global).session.setScrollTop(e), !1 !== i && this.animateScrolling(t, n);
          }, (this || _global).animateScrolling = function (e, t) {
            var i = (this || _global).scrollTop;

            if ((this || _global).$animatedScroll) {
              var n = this || _global;

              if (e != i) {
                if ((this || _global).$scrollAnimation) {
                  var r = (this || _global).$scrollAnimation.steps;
                  if (r.length && (e = r[0]) == i) return;
                }

                var o = n.$calcSteps(e, i);
                (this || _global).$scrollAnimation = {
                  from: e,
                  to: i,
                  steps: o
                }, clearInterval((this || _global).$timer), n.session.setScrollTop(o.shift()), n.session.$scrollTop = i, (this || _global).$timer = setInterval(function () {
                  if (!n.session) return clearInterval(n.$timer);
                  o.length ? (n.session.setScrollTop(o.shift()), n.session.$scrollTop = i) : null != i ? (n.session.$scrollTop = -1, n.session.setScrollTop(i), i = null) : (n.$timer = clearInterval(n.$timer), n.$scrollAnimation = null, t && t());
                }, 10);
              }
            }
          }, (this || _global).scrollToY = function (e) {
            (this || _global).scrollTop !== e && ((this || _global).$loop.schedule((this || _global).CHANGE_SCROLL), (this || _global).scrollTop = e);
          }, (this || _global).scrollToX = function (e) {
            (this || _global).scrollLeft !== e && ((this || _global).scrollLeft = e), (this || _global).$loop.schedule((this || _global).CHANGE_H_SCROLL);
          }, (this || _global).scrollTo = function (e, t) {
            (this || _global).session.setScrollTop(t), (this || _global).session.setScrollLeft(e);
          }, (this || _global).scrollBy = function (e, t) {
            t && (this || _global).session.setScrollTop((this || _global).session.getScrollTop() + t), e && (this || _global).session.setScrollLeft((this || _global).session.getScrollLeft() + e);
          }, (this || _global).isScrollableBy = function (e, t) {
            return t < 0 && (this || _global).session.getScrollTop() >= 1 - (this || _global).scrollMargin.top || 0 < t && (this || _global).session.getScrollTop() + (this || _global).$size.scrollerHeight - (this || _global).layerConfig.maxHeight < -1 + (this || _global).scrollMargin.bottom || e < 0 && (this || _global).session.getScrollLeft() >= 1 - (this || _global).scrollMargin.left || 0 < e && (this || _global).session.getScrollLeft() + (this || _global).$size.scrollerWidth - (this || _global).layerConfig.width < -1 + (this || _global).scrollMargin.right || void 0;
          }, (this || _global).pixelToScreenCoordinates = function (e, t) {
            (this || _global).$hasCssTransforms ? (n = {
              top: 0,
              left: 0
            }, e = (i = (this || _global).$fontMetrics.transformCoordinates([e, t]))[1] - (this || _global).gutterWidth - (this || _global).margin.left, t = i[0]) : n = (this || _global).scroller.getBoundingClientRect();
            var i = e + (this || _global).scrollLeft - n.left - (this || _global).$padding,
                e = i / (this || _global).characterWidth,
                t = Math.floor((t + (this || _global).scrollTop - n.top) / (this || _global).lineHeight),
                n = (this || _global).$blockCursor ? Math.floor(e) : Math.round(e);
            return {
              row: t,
              column: n,
              side: 0 < e - n ? 1 : -1,
              offsetX: i
            };
          }, (this || _global).screenToTextCoordinates = function (e, t) {
            (this || _global).$hasCssTransforms ? (i = {
              top: 0,
              left: 0
            }, e = (n = (this || _global).$fontMetrics.transformCoordinates([e, t]))[1] - (this || _global).gutterWidth - (this || _global).margin.left, t = n[0]) : i = (this || _global).scroller.getBoundingClientRect();
            var i,
                n = e + (this || _global).scrollLeft - i.left - (this || _global).$padding,
                e = n / (this || _global).characterWidth,
                e = (this || _global).$blockCursor ? Math.floor(e) : Math.round(e),
                t = Math.floor((t + (this || _global).scrollTop - i.top) / (this || _global).lineHeight);
            return (this || _global).session.screenToDocumentPosition(t, Math.max(e, 0), n);
          }, (this || _global).textToScreenCoordinates = function (e, t) {
            var i = (this || _global).scroller.getBoundingClientRect(),
                t = (this || _global).session.documentToScreenPosition(e, t),
                e = (this || _global).$padding + ((this || _global).session.$bidiHandler.isBidiRow(t.row, e) ? (this || _global).session.$bidiHandler.getPosLeft(t.column) : Math.round(t.column * (this || _global).characterWidth)),
                t = t.row * (this || _global).lineHeight;

            return {
              pageX: i.left + e - (this || _global).scrollLeft,
              pageY: i.top + t - (this || _global).scrollTop
            };
          }, (this || _global).visualizeFocus = function () {
            a.addCssClass((this || _global).container, "ace_focus");
          }, (this || _global).visualizeBlur = function () {
            a.removeCssClass((this || _global).container, "ace_focus");
          }, (this || _global).showComposition = function (e) {
            ((this || _global).$composition = e).cssText || (e.cssText = (this || _global).textarea.style.cssText), null == e.useTextareaForIME && (e.useTextareaForIME = (this || _global).$useTextareaForIME), (this || _global).$useTextareaForIME ? (a.addCssClass((this || _global).textarea, "ace_composition"), (this || _global).textarea.style.cssText = "", this.$moveTextAreaToCursor(), (this || _global).$cursorLayer.element.style.display = "none") : e.markerId = (this || _global).session.addMarker(e.markerRange, "ace_composition_marker", "text");
          }, (this || _global).setCompositionText = function (e) {
            var t = (this || _global).session.selection.cursor;
            this.addToken(e, "composition_placeholder", t.row, t.column), this.$moveTextAreaToCursor();
          }, (this || _global).hideComposition = function () {
            var e;
            (this || _global).$composition && ((this || _global).$composition.markerId && (this || _global).session.removeMarker((this || _global).$composition.markerId), a.removeCssClass((this || _global).textarea, "ace_composition"), (this || _global).textarea.style.cssText = (this || _global).$composition.cssText, e = (this || _global).session.selection.cursor, this.removeExtraToken(e.row, e.column), (this || _global).$composition = null, (this || _global).$cursorLayer.element.style.display = "");
          }, (this || _global).addToken = function (e, t, i, n) {
            var r = (this || _global).session,
                o = (r.bgTokenizer.lines[i] = null, {
              type: t,
              value: e
            }),
                s = r.getTokens(i);
            if (null == n) s.push(o);else for (var a = 0, l = 0; l < s.length; l++) {
              var c = s[l];

              if (n <= (a += c.value.length)) {
                var h = c.value.length - (a - n),
                    d = c.value.slice(0, h),
                    h = c.value.slice(h);
                s.splice(l, 1, {
                  type: c.type,
                  value: d
                }, o, {
                  type: c.type,
                  value: h
                });
                break;
              }
            }
            this.updateLines(i, i);
          }, (this || _global).removeExtraToken = function (e, t) {
            this.updateLines(e, e);
          }, (this || _global).setTheme = function (i, n) {
            var e,
                r = this || _global;

            function t(e) {
              if (r.$themeId != i) return n && n();
              if (!e || !e.cssClass) throw new Error("couldn't load module " + i + " or it didn't call define");
              e.$id && (r.$themeId = e.$id), a.importCssString(e.cssText, e.cssClass, r.container), r.theme && a.removeCssClass(r.container, r.theme.cssClass);
              var t = "padding" in e ? e.padding : "padding" in (r.theme || {}) ? 4 : r.$padding;
              r.$padding && t != r.$padding && r.setPadding(t), r.$theme = e.cssClass, r.theme = e, a.addCssClass(r.container, e.cssClass), a.setCssClass(r.container, "ace_dark", e.isDark), r.$size && (r.$size.width = 0, r.$updateSizeAsync()), r._dispatchEvent("themeLoaded", {
                theme: e
              }), n && n();
            }

            (this || _global).$themeId = i, r._dispatchEvent("themeChange", {
              theme: i
            }), i && "string" != typeof i ? t(i) : (e = i || (this || _global).$options.theme.initialValue, o.loadModule(["theme", e], t));
          }, (this || _global).getTheme = function () {
            return (this || _global).$themeId;
          }, (this || _global).setStyle = function (e, t) {
            a.setCssClass((this || _global).container, e, !1 !== t);
          }, (this || _global).unsetStyle = function (e) {
            a.removeCssClass((this || _global).container, e);
          }, (this || _global).setCursorStyle = function (e) {
            a.setStyle((this || _global).scroller.style, "cursor", e);
          }, (this || _global).setMouseCursor = function (e) {
            a.setStyle((this || _global).scroller.style, "cursor", e);
          }, (this || _global).attachToShadowRoot = function () {
            a.importCssString(f, "ace_editor.css", (this || _global).container);
          }, (this || _global).destroy = function () {
            this.freeze(), (this || _global).$fontMetrics.destroy(), (this || _global).$cursorLayer.destroy(), this.removeAllListeners(), (this || _global).container.textContent = "";
          };
        }.call(n.prototype), o.defineOptions(n.prototype, "renderer", {
          animatedScroll: {
            initialValue: !1
          },
          showInvisibles: {
            set: function (e) {
              (this || _global).$textLayer.setShowInvisibles(e) && (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
            },
            initialValue: !1
          },
          showPrintMargin: {
            set: function () {
              this.$updatePrintMargin();
            },
            initialValue: !0
          },
          printMarginColumn: {
            set: function () {
              this.$updatePrintMargin();
            },
            initialValue: 80
          },
          printMargin: {
            set: function (e) {
              "number" == typeof e && ((this || _global).$printMarginColumn = e), (this || _global).$showPrintMargin = !!e, this.$updatePrintMargin();
            },
            get: function () {
              return (this || _global).$showPrintMargin && (this || _global).$printMarginColumn;
            }
          },
          showGutter: {
            set: function (e) {
              (this || _global).$gutter.style.display = e ? "block" : "none", (this || _global).$loop.schedule((this || _global).CHANGE_FULL), this.onGutterResize();
            },
            initialValue: !0
          },
          fadeFoldWidgets: {
            set: function (e) {
              a.setCssClass((this || _global).$gutter, "ace_fade-fold-widgets", e);
            },
            initialValue: !1
          },
          showFoldWidgets: {
            set: function (e) {
              (this || _global).$gutterLayer.setShowFoldWidgets(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            },
            initialValue: !0
          },
          displayIndentGuides: {
            set: function (e) {
              (this || _global).$textLayer.setDisplayIndentGuides(e) && (this || _global).$loop.schedule((this || _global).CHANGE_TEXT);
            },
            initialValue: !0
          },
          highlightGutterLine: {
            set: function (e) {
              (this || _global).$gutterLayer.setHighlightGutterLine(e), (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            },
            initialValue: !0
          },
          hScrollBarAlwaysVisible: {
            set: function (e) {
              (this || _global).$hScrollBarAlwaysVisible && (this || _global).$horizScroll || (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL);
            },
            initialValue: !1
          },
          vScrollBarAlwaysVisible: {
            set: function (e) {
              (this || _global).$vScrollBarAlwaysVisible && (this || _global).$vScroll || (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL);
            },
            initialValue: !1
          },
          fontSize: {
            set: function (e) {
              "number" == typeof e && (e += "px"), (this || _global).container.style.fontSize = e, this.updateFontSize();
            },
            initialValue: 12
          },
          fontFamily: {
            set: function (e) {
              (this || _global).container.style.fontFamily = e, this.updateFontSize();
            }
          },
          maxLines: {
            set: function (e) {
              this.updateFull();
            }
          },
          minLines: {
            set: function (e) {
              (this || _global).$minLines < 562949953421311 || ((this || _global).$minLines = 0), this.updateFull();
            }
          },
          maxPixelHeight: {
            set: function (e) {
              this.updateFull();
            },
            initialValue: 0
          },
          scrollPastEnd: {
            set: function (e) {
              (this || _global).$scrollPastEnd != (e = +e || 0) && ((this || _global).$scrollPastEnd = e, (this || _global).$loop.schedule((this || _global).CHANGE_SCROLL));
            },
            initialValue: 0,
            handlesSet: !0
          },
          fixedWidthGutter: {
            set: function (e) {
              (this || _global).$gutterLayer.$fixedWidth = !!e, (this || _global).$loop.schedule((this || _global).CHANGE_GUTTER);
            }
          },
          theme: {
            set: function (e) {
              this.setTheme(e);
            },
            get: function () {
              return (this || _global).$themeId || (this || _global).theme;
            },
            initialValue: "./theme/textmate",
            handlesSet: !0
          },
          hasCssTransforms: {},
          useTextareaForIME: {
            initialValue: !C.isMobile && !C.isIE
          }
        }), t.VirtualRenderer = n;
      }), ace.define("ace/worker/worker_client", ["require", "exports", "module", "ace/lib/oop", "ace/lib/net", "ace/lib/event_emitter", "ace/config"], function (a, e, t) {
        "use strict";

        var i = a("../lib/oop"),
            n = a("../lib/net"),
            c = a("../lib/event_emitter").EventEmitter,
            h = a("../config");

        function l(e) {
          return "undefined" == typeof Worker ? {
            postMessage: function () {},
            terminate: function () {}
          } : h.get("loadWorkerFromBlob") ? (t = function (t) {
            t = "importScripts('" + n.qualifyURL(t) + "');";

            try {
              return new Blob([t], {
                type: "application/javascript"
              });
            } catch (e) {
              var i = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder)();
              return i.append(t), i.getBlob("application/javascript");
            }
          }(e), t = (window.URL || window.webkitURL).createObjectURL(t), new Worker(t)) : new Worker(e);
          var t;
        }

        function d(e) {
          e.postMessage || (e = (this || _global).$createWorkerFromOldConfig.apply(this || _global, arguments)), (this || _global).$worker = e, (this || _global).$sendDeltaQueue = (this || _global).$sendDeltaQueue.bind(this || _global), (this || _global).changeListener = (this || _global).changeListener.bind(this || _global), (this || _global).onMessage = (this || _global).onMessage.bind(this || _global), (this || _global).callbackId = 1, (this || _global).callbacks = {}, (this || _global).$worker.onmessage = (this || _global).onMessage;
        }

        (function () {
          i.implement(this || _global, c), (this || _global).$createWorkerFromOldConfig = function (e, t, i, n, r) {
            var o, s;
            return a.nameToUrl && !a.toUrl && (a.toUrl = a.nameToUrl), h.get("packaged") || !a.toUrl ? n = n || h.moduleUrl(t, "worker") : (o = (this || _global).$normalizePath, n = n || o(a.toUrl("ace/worker/worker.js", null, "_")), s = {}, e.forEach(function (e) {
              s[e] = o(a.toUrl(e, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
            })), (this || _global).$worker = l(n), r && this.send("importScripts", r), (this || _global).$worker.postMessage({
              init: !0,
              tlns: s,
              module: t,
              classname: i
            }), (this || _global).$worker;
          }, (this || _global).onMessage = function (e) {
            var t = e.data;

            switch (t.type) {
              case "event":
                this._signal(t.name, {
                  data: t.data
                });

                break;

              case "call":
                var i = (this || _global).callbacks[t.id];
                i && (i(t.data), delete (this || _global).callbacks[t.id]);
                break;

              case "error":
                this.reportError(t.data);
                break;

              case "log":
                window.console && console.log && console.log.apply(console, t.data);
            }
          }, (this || _global).reportError = function (e) {
            window.console && console.error && console.error(e);
          }, (this || _global).$normalizePath = function (e) {
            return n.qualifyURL(e);
          }, (this || _global).terminate = function () {
            this._signal("terminate", {}), (this || _global).deltaQueue = null, (this || _global).$worker.terminate(), (this || _global).$worker = null, (this || _global).$doc && (this || _global).$doc.off("change", (this || _global).changeListener), (this || _global).$doc = null;
          }, (this || _global).send = function (e, t) {
            (this || _global).$worker.postMessage({
              command: e,
              args: t
            });
          }, (this || _global).call = function (e, t, i) {
            var n;
            i && (n = (this || _global).callbackId++, (this || _global).callbacks[n] = i, t.push(n)), this.send(e, t);
          }, (this || _global).emit = function (e, t) {
            try {
              t.data && t.data.err && (t.data.err = {
                message: t.data.err.message,
                stack: t.data.err.stack,
                code: t.data.err.code
              }), (this || _global).$worker.postMessage({
                event: e,
                data: {
                  data: t.data
                }
              });
            } catch (e) {
              console.error(e.stack);
            }
          }, (this || _global).attachToDocument = function (e) {
            (this || _global).$doc && this.terminate(), (this || _global).$doc = e, this.call("setValue", [e.getValue()]), e.on("change", (this || _global).changeListener);
          }, (this || _global).changeListener = function (e) {
            (this || _global).deltaQueue || ((this || _global).deltaQueue = [], setTimeout((this || _global).$sendDeltaQueue, 0)), "insert" == e.action ? (this || _global).deltaQueue.push(e.start, e.lines) : (this || _global).deltaQueue.push(e.start, e.end);
          }, (this || _global).$sendDeltaQueue = function () {
            var e = (this || _global).deltaQueue;
            e && ((this || _global).deltaQueue = null, 50 < e.length && e.length > (this || _global).$doc.getLength() >> 1 ? this.call("setValue", [(this || _global).$doc.getValue()]) : this.emit("change", {
              data: e
            }));
          };
        }).call(d.prototype);
        e.UIWorkerClient = function (e, t, i) {
          var n = null,
              r = !1,
              o = Object.create(c),
              s = [],
              a = new d({
            messageBuffer: s,
            terminate: function () {},
            postMessage: function (e) {
              s.push(e), n && (r ? setTimeout(l) : l());
            }
          }),
              l = (a.setEmitSync = function (e) {
            r = e;
          }, function () {
            var e = s.shift();
            e.command ? n[e.command].apply(n, e.args) : e.event && o._signal(e.event, e.data);
          });
          return o.postMessage = function (e) {
            a.onMessage({
              data: e
            });
          }, o.callback = function (e, t) {
            this.postMessage({
              type: "call",
              id: t,
              data: e
            });
          }, o.emit = function (e, t) {
            this.postMessage({
              type: "event",
              name: e,
              data: t
            });
          }, h.loadModule(["worker", t], function (e) {
            for (n = new e[i](o); s.length;) l();
          }), a;
        }, e.WorkerClient = d, e.createWorker = l;
      }), ace.define("ace/placeholder", ["require", "exports", "module", "ace/range", "ace/lib/event_emitter", "ace/lib/oop"], function (e, t, i) {
        "use strict";

        function n(e, t, i, n, r, o) {
          var s = this || _global,
              t = ((this || _global).length = t, (this || _global).session = e, (this || _global).doc = e.getDocument(), (this || _global).mainClass = r, (this || _global).othersClass = o, (this || _global).$onUpdate = (this || _global).onUpdate.bind(this || _global), (this || _global).doc.on("change", (this || _global).$onUpdate), (this || _global).$others = n, (this || _global).$onCursorChange = function () {
            setTimeout(function () {
              s.onCursorChange();
            });
          }, (this || _global).$pos = i, e.getUndoManager().$undoStack || e.getUndoManager().$undostack || {
            length: -1
          });
          (this || _global).$undoStackDepth = t.length, this.setup(), e.selection.on("changeCursor", (this || _global).$onCursorChange);
        }

        var l = e("./range").Range,
            r = e("./lib/event_emitter").EventEmitter,
            o = e("./lib/oop");
        !function () {
          o.implement(this || _global, r), (this || _global).setup = function () {
            var t = this || _global,
                i = (this || _global).doc,
                e = (this || _global).session,
                n = ((this || _global).selectionBefore = e.selection.toJSON(), e.selection.inMultiSelectMode && e.selection.toSingleRange(), (this || _global).pos = i.createAnchor((this || _global).$pos.row, (this || _global).$pos.column), (this || _global).pos);
            n.$insertRight = !0, n.detach(), n.markerId = e.addMarker(new l(n.row, n.column, n.row, n.column + (this || _global).length), (this || _global).mainClass, null, !1), (this || _global).others = [], (this || _global).$others.forEach(function (e) {
              e = i.createAnchor(e.row, e.column);
              e.$insertRight = !0, e.detach(), t.others.push(e);
            }), e.setUndoSelect(!1);
          }, (this || _global).showOtherMarkers = function () {
            var t, i;
            (this || _global).othersActive || (t = (this || _global).session, (i = this || _global).othersActive = !0, (this || _global).others.forEach(function (e) {
              e.markerId = t.addMarker(new l(e.row, e.column, e.row, e.column + i.length), i.othersClass, null, !1);
            }));
          }, (this || _global).hideOtherMarkers = function () {
            if ((this || _global).othersActive) {
              (this || _global).othersActive = !1;

              for (var e = 0; e < (this || _global).others.length; e++) (this || _global).session.removeMarker((this || _global).others[e].markerId);
            }
          }, (this || _global).onUpdate = function (e) {
            if ((this || _global).$updating) return this.updateAnchors(e);
            var t = e;

            if (t.start.row === t.end.row && t.start.row === (this || _global).pos.row) {
              (this || _global).$updating = !0;
              var i = "insert" === e.action ? t.end.column - t.start.column : t.start.column - t.end.column,
                  n = t.start.column >= (this || _global).pos.column && t.start.column <= (this || _global).pos.column + (this || _global).length + 1,
                  r = t.start.column - (this || _global).pos.column;
              if (this.updateAnchors(e), n && ((this || _global).length += i), n && !(this || _global).session.$fromUndo) if ("insert" === e.action) for (var o = (this || _global).others.length - 1; 0 <= o; o--) {
                var s = {
                  row: (a = (this || _global).others[o]).row,
                  column: a.column + r
                };

                (this || _global).doc.insertMergedLines(s, e.lines);
              } else if ("remove" === e.action) for (o = (this || _global).others.length - 1; 0 <= o; o--) {
                var a,
                    s = {
                  row: (a = (this || _global).others[o]).row,
                  column: a.column + r
                };

                (this || _global).doc.remove(new l(s.row, s.column, s.row, s.column - i));
              }
              (this || _global).$updating = !1, this.updateMarkers();
            }
          }, (this || _global).updateAnchors = function (e) {
            (this || _global).pos.onChange(e);

            for (var t = (this || _global).others.length; t--;) (this || _global).others[t].onChange(e);

            this.updateMarkers();
          }, (this || _global).updateMarkers = function () {
            if (!(this || _global).$updating) {
              var i = this || _global,
                  n = (this || _global).session,
                  e = function (e, t) {
                n.removeMarker(e.markerId), e.markerId = n.addMarker(new l(e.row, e.column, e.row, e.column + i.length), t, null, !1);
              };

              e((this || _global).pos, (this || _global).mainClass);

              for (var t = (this || _global).others.length; t--;) e((this || _global).others[t], (this || _global).othersClass);
            }
          }, (this || _global).onCursorChange = function (e) {
            var t;
            !(this || _global).$updating && (this || _global).session && ((t = (this || _global).session.selection.getCursor()).row === (this || _global).pos.row && t.column >= (this || _global).pos.column && t.column <= (this || _global).pos.column + (this || _global).length ? (this.showOtherMarkers(), this._emit("cursorEnter", e)) : (this.hideOtherMarkers(), this._emit("cursorLeave", e)));
          }, (this || _global).detach = function () {
            (this || _global).session.removeMarker((this || _global).pos && (this || _global).pos.markerId), this.hideOtherMarkers(), (this || _global).doc.off("change", (this || _global).$onUpdate), (this || _global).session.selection.off("changeCursor", (this || _global).$onCursorChange), (this || _global).session.setUndoSelect(!0), (this || _global).session = null;
          }, (this || _global).cancel = function () {
            if (-1 !== (this || _global).$undoStackDepth) {
              for (var e = (this || _global).session.getUndoManager(), t = (e.$undoStack || e.$undostack).length - (this || _global).$undoStackDepth, i = 0; i < t; i++) e.undo((this || _global).session, !0);

              (this || _global).selectionBefore && (this || _global).session.selection.fromJSON((this || _global).selectionBefore);
            }
          };
        }.call(n.prototype), t.PlaceHolder = n;
      }), ace.define("ace/mouse/multi_select_handler", ["require", "exports", "module", "ace/lib/event", "ace/lib/useragent"], function (e, t, i) {
        var x = e("../lib/event"),
            k = e("../lib/useragent");

        function E(e, t) {
          return e.row == t.row && e.column == t.column;
        }

        t.onMouseDown = function (e) {
          var t = e.domEvent,
              i = t.altKey,
              n = t.shiftKey,
              r = t.ctrlKey,
              o = e.getAccelKey(),
              s = e.getButton();
          if (r && k.isMac && (s = t.button), e.editor.inMultiSelectMode && 2 == s) e.editor.textInput.onContextMenu(e.domEvent);else if (r || i || o) {
            if (0 === s) {
              var a,
                  l,
                  c,
                  h,
                  d,
                  u,
                  g,
                  p,
                  m = e.editor,
                  f = m.selection,
                  C = m.inMultiSelectMode,
                  I = e.getDocumentPosition(),
                  v = f.getCursor(),
                  v = e.inSelection() || f.isEmpty() && E(I, v),
                  A = e.x,
                  b = e.y,
                  y = m.session,
                  w = m.renderer.pixelToScreenCoordinates(A, b),
                  S = w;
              if (m.$mouseHandler.$enableJumpToDef) r && i || o && i ? a = n ? "block" : "add" : i && m.$blockSelectEnabled && (a = "block");else if (o && !i) {
                if (a = "add", !C && n) return;
              } else i && m.$blockSelectEnabled && (a = "block");
              if (a && k.isMac && t.ctrlKey && m.$mouseHandler.cancelContextMenu(), "add" == a) !C && v || (C || (l = f.toOrientedRange(), m.addSelectionMarker(l)), c = f.rangeList.rangeAtPoint(I), m.inVirtualSelectionMode = !0, n && (c = null, l = f.ranges[0] || l, m.removeSelectionMarker(l)), m.once("mouseup", function () {
                var e = f.toOrientedRange();
                c && e.isEmpty() && E(c.cursor, e.cursor) ? f.substractPoint(e.cursor) : (n ? f.substractPoint(l.cursor) : l && (m.removeSelectionMarker(l), f.addRange(l)), f.addRange(e)), m.inVirtualSelectionMode = !1;
              }));else if ("block" == a) return e.stop(), m.inVirtualSelectionMode = !0, d = [], u = function () {
                var e = m.renderer.pixelToScreenCoordinates(A, b),
                    t = y.screenToDocumentPosition(e.row, e.column, e.offsetX);
                E(S, e) && E(t, f.lead) || (S = e, m.selection.moveToPosition(t), m.renderer.scrollCursorIntoView(), m.removeSelectionMarkers(d), d = f.rectangularRangeBlock(S, w), m.$mouseHandler.$clickSelection && 1 == d.length && d[0].isEmpty() && (d[0] = m.$mouseHandler.$clickSelection.clone()), d.forEach(m.addSelectionMarker, m), m.updateSelectionMarkers());
              }, C && !o ? f.toSingleRange() : !C && o && (h = f.toOrientedRange(), m.addSelectionMarker(h)), n ? w = y.documentToScreenPosition(f.lead) : f.moveToPosition(I), S = {
                row: -1,
                column: -1
              }, g = u, x.capture(m.container, function (e) {
                A = e.clientX, b = e.clientY;
              }, function (e) {
                u(), clearInterval(p), m.removeSelectionMarkers(d), d.length || (d = [f.toOrientedRange()]), h && (m.removeSelectionMarker(h), f.toSingleRange(h));

                for (var t = 0; t < d.length; t++) f.addRange(d[t]);

                m.inVirtualSelectionMode = !1, m.$mouseHandler.$clickSelection = null;
              }), p = setInterval(function () {
                g();
              }, 20), e.preventDefault();
            }
          } else 0 === s && e.editor.inMultiSelectMode && e.editor.exitMultiSelectMode();
        };
      }), ace.define("ace/commands/multi_select_commands", ["require", "exports", "module", "ace/keyboard/hash_handler"], function (e, t, i) {
        t.defaultCommands = [{
          name: "addCursorAbove",
          description: "Add cursor above",
          exec: function (e) {
            e.selectMoreLines(-1);
          },
          bindKey: {
            win: "Ctrl-Alt-Up",
            mac: "Ctrl-Alt-Up"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorBelow",
          description: "Add cursor below",
          exec: function (e) {
            e.selectMoreLines(1);
          },
          bindKey: {
            win: "Ctrl-Alt-Down",
            mac: "Ctrl-Alt-Down"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorAboveSkipCurrent",
          description: "Add cursor above (skip current)",
          exec: function (e) {
            e.selectMoreLines(-1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Up",
            mac: "Ctrl-Alt-Shift-Up"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "addCursorBelowSkipCurrent",
          description: "Add cursor below (skip current)",
          exec: function (e) {
            e.selectMoreLines(1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Down",
            mac: "Ctrl-Alt-Shift-Down"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectMoreBefore",
          description: "Select more before",
          exec: function (e) {
            e.selectMore(-1);
          },
          bindKey: {
            win: "Ctrl-Alt-Left",
            mac: "Ctrl-Alt-Left"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectMoreAfter",
          description: "Select more after",
          exec: function (e) {
            e.selectMore(1);
          },
          bindKey: {
            win: "Ctrl-Alt-Right",
            mac: "Ctrl-Alt-Right"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectNextBefore",
          description: "Select next before",
          exec: function (e) {
            e.selectMore(-1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Left",
            mac: "Ctrl-Alt-Shift-Left"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "selectNextAfter",
          description: "Select next after",
          exec: function (e) {
            e.selectMore(1, !0);
          },
          bindKey: {
            win: "Ctrl-Alt-Shift-Right",
            mac: "Ctrl-Alt-Shift-Right"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }, {
          name: "toggleSplitSelectionIntoLines",
          description: "Split into lines",
          exec: function (e) {
            1 < e.multiSelect.rangeCount ? e.multiSelect.joinSelections() : e.multiSelect.splitIntoLines();
          },
          bindKey: {
            win: "Ctrl-Alt-L",
            mac: "Ctrl-Alt-L"
          },
          readOnly: !0
        }, {
          name: "splitSelectionIntoLines",
          description: "Split into lines",
          exec: function (e) {
            e.multiSelect.splitIntoLines();
          },
          readOnly: !0
        }, {
          name: "alignCursors",
          description: "Align cursors",
          exec: function (e) {
            e.alignCursors();
          },
          bindKey: {
            win: "Ctrl-Alt-A",
            mac: "Ctrl-Alt-A"
          },
          scrollIntoView: "cursor"
        }, {
          name: "findAll",
          description: "Find all",
          exec: function (e) {
            e.findAll();
          },
          bindKey: {
            win: "Ctrl-Alt-K",
            mac: "Ctrl-Alt-G"
          },
          scrollIntoView: "cursor",
          readOnly: !0
        }], t.multiSelectCommands = [{
          name: "singleSelection",
          description: "Single selection",
          bindKey: "esc",
          exec: function (e) {
            e.exitMultiSelectMode();
          },
          scrollIntoView: "cursor",
          readOnly: !0,
          isAvailable: function (e) {
            return e && e.inMultiSelectMode;
          }
        }];
        e = e("../keyboard/hash_handler").HashHandler;
        t.keyboardHandler = new e(t.multiSelectCommands);
      }), ace.define("ace/multi_select", ["require", "exports", "module", "ace/range_list", "ace/range", "ace/selection", "ace/mouse/multi_select_handler", "ace/lib/event", "ace/lib/lang", "ace/commands/multi_select_commands", "ace/search", "ace/edit_session", "ace/editor", "ace/config"], function (e, r, t) {
        var i = e("./range_list").RangeList,
            A = e("./range").Range,
            u = e("./selection").Selection,
            o = e("./mouse/multi_select_handler").onMouseDown,
            s = e("./lib/event"),
            g = e("./lib/lang"),
            a = e("./commands/multi_select_commands");
        r.commands = a.defaultCommands.concat(a.multiSelectCommands);
        var l = new (e("./search").Search)();
        var n = e("./edit_session").EditSession,
            n = (!function () {
          (this || _global).getSelectionMarkers = function () {
            return (this || _global).$selectionMarkers;
          };
        }.call(n.prototype), !function () {
          (this || _global).ranges = null, (this || _global).rangeList = null, (this || _global).addRange = function (e, t) {
            if (e) {
              if (!(this || _global).inMultiSelectMode && 0 === (this || _global).rangeCount) {
                var i = this.toOrientedRange();
                if ((this || _global).rangeList.add(i), (this || _global).rangeList.add(e), 2 != (this || _global).rangeList.ranges.length) return (this || _global).rangeList.removeAll(), t || this.fromOrientedRange(e);
                (this || _global).rangeList.removeAll(), (this || _global).rangeList.add(i), this.$onAddRange(i);
              }

              e.cursor || (e.cursor = e.end);
              i = (this || _global).rangeList.add(e);
              return this.$onAddRange(e), i.length && this.$onRemoveRange(i), 1 < (this || _global).rangeCount && !(this || _global).inMultiSelectMode && (this._signal("multiSelect"), (this || _global).inMultiSelectMode = !0, (this || _global).session.$undoSelect = !1, (this || _global).rangeList.attach((this || _global).session)), t || this.fromOrientedRange(e);
            }
          }, (this || _global).toSingleRange = function (e) {
            e = e || (this || _global).ranges[0];

            var t = (this || _global).rangeList.removeAll();

            t.length && this.$onRemoveRange(t), e && this.fromOrientedRange(e);
          }, (this || _global).substractPoint = function (e) {
            e = (this || _global).rangeList.substractPoint(e);
            if (e) return this.$onRemoveRange(e), e[0];
          }, (this || _global).mergeOverlappingRanges = function () {
            var e = (this || _global).rangeList.merge();

            e.length && this.$onRemoveRange(e);
          }, (this || _global).$onAddRange = function (e) {
            (this || _global).rangeCount = (this || _global).rangeList.ranges.length, (this || _global).ranges.unshift(e), this._signal("addRange", {
              range: e
            });
          }, (this || _global).$onRemoveRange = function (e) {
            var t;
            (this || _global).rangeCount = (this || _global).rangeList.ranges.length, 1 == (this || _global).rangeCount && (this || _global).inMultiSelectMode && (t = (this || _global).rangeList.ranges.pop(), e.push(t), (this || _global).rangeCount = 0);

            for (var i = e.length; i--;) {
              var n = (this || _global).ranges.indexOf(e[i]);

              (this || _global).ranges.splice(n, 1);
            }

            this._signal("removeRange", {
              ranges: e
            }), 0 === (this || _global).rangeCount && (this || _global).inMultiSelectMode && ((this || _global).inMultiSelectMode = !1, this._signal("singleSelect"), (this || _global).session.$undoSelect = !0, (this || _global).rangeList.detach((this || _global).session)), (t = t || (this || _global).ranges[0]) && !t.isEqual(this.getRange()) && this.fromOrientedRange(t);
          }, (this || _global).$initRangeList = function () {
            (this || _global).rangeList || ((this || _global).rangeList = new i(), (this || _global).ranges = [], (this || _global).rangeCount = 0);
          }, (this || _global).getAllRanges = function () {
            return (this || _global).rangeCount ? (this || _global).rangeList.ranges.concat() : [this.getRange()];
          }, (this || _global).splitIntoLines = function () {
            for (var e = (this || _global).ranges.length ? (this || _global).ranges : [this.getRange()], t = [], i = 0; i < e.length; i++) {
              var n = e[i],
                  r = n.start.row,
                  o = n.end.row;
              if (r === o) t.push(n.clone());else {
                for (t.push(new A(r, n.start.column, r, (this || _global).session.getLine(r).length)); ++r < o;) t.push(this.getLineRange(r, !0));

                t.push(new A(o, 0, o, n.end.column));
              }
              0 != i || this.isBackwards() || (t = t.reverse());
            }

            this.toSingleRange();

            for (i = t.length; i--;) this.addRange(t[i]);
          }, (this || _global).joinSelections = function () {
            var e = (this || _global).rangeList.ranges,
                t = e[e.length - 1],
                e = A.fromPoints(e[0].start, t.end);
            this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start);
          }, (this || _global).toggleBlockSelection = function () {
            var e, t;
            1 < (this || _global).rangeCount ? (t = (e = (this || _global).rangeList.ranges)[e.length - 1], e = A.fromPoints(e[0].start, t.end), this.toSingleRange(), this.setSelectionRange(e, t.cursor == t.start)) : (e = (this || _global).session.documentToScreenPosition((this || _global).cursor), t = (this || _global).session.documentToScreenPosition((this || _global).anchor), this.rectangularRangeBlock(e, t).forEach((this || _global).addRange, this || _global));
          }, (this || _global).rectangularRangeBlock = function (e, t, i) {
            var n,
                r,
                o,
                s,
                a,
                l,
                c,
                h = [],
                d = e.column < t.column,
                u = (s = d ? (n = e.column, r = t.column, o = e.offsetX, t.offsetX) : (n = t.column, r = e.column, o = t.offsetX, e.offsetX), e.row < t.row);
            l = u ? (a = e.row, t.row) : (a = t.row, e.row), n < 0 && (n = 0), (a = a < 0 ? 0 : a) == l && (i = !0);

            for (var g, p, m = a; m <= l; m++) {
              var f = A.fromPoints((this || _global).session.screenToDocumentPosition(m, n, o), (this || _global).session.screenToDocumentPosition(m, r, s));

              if (f.isEmpty()) {
                if (c && (g = f.end, p = c, g.row == p.row && g.column == p.column)) break;
                c = f.end;
              }

              f.cursor = d ? f.start : f.end, h.push(f);
            }

            if (u && h.reverse(), !i) {
              for (var C = h.length - 1; h[C].isEmpty() && 0 < C;) C--;

              if (0 < C) for (var I = 0; h[I].isEmpty();) I++;

              for (var v = C; I <= v; v--) h[v].isEmpty() && h.splice(v, 1);
            }

            return h;
          };
        }.call(u.prototype), e("./editor").Editor);

        function c(e) {
          var t, i;

          function n(e) {
            i && (t.renderer.setMouseCursor(""), i = !1);
          }

          e.$multiselectOnSessionChange || (e.$onAddRange = e.$onAddRange.bind(e), e.$onRemoveRange = e.$onRemoveRange.bind(e), e.$onMultiSelect = e.$onMultiSelect.bind(e), e.$onSingleSelect = e.$onSingleSelect.bind(e), e.$multiselectOnSessionChange = r.onSessionChange.bind(e), e.$checkMultiselectChange = e.$checkMultiselectChange.bind(e), e.$multiselectOnSessionChange(e), e.on("changeSession", e.$multiselectOnSessionChange), e.on("mousedown", o), e.commands.addCommands(a.defaultCommands), (t = e).textInput && (e = t.textInput.getElement(), i = !1, s.addListener(e, "keydown", function (e) {
            e = 18 == e.keyCode && !(e.ctrlKey || e.shiftKey || e.metaKey);
            t.$blockSelectEnabled && e ? i || (t.renderer.setMouseCursor("crosshair"), i = !0) : i && n();
          }, t), s.addListener(e, "keyup", n, t), s.addListener(e, "blur", n, t)));
        }

        !function () {
          (this || _global).updateSelectionMarkers = function () {
            (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).addSelectionMarker = function (e) {
            e.cursor || (e.cursor = e.end);
            var t = this.getSelectionStyle();
            return e.marker = (this || _global).session.addMarker(e, "ace_selection", t), (this || _global).session.$selectionMarkers.push(e), (this || _global).session.selectionMarkerCount = (this || _global).session.$selectionMarkers.length, e;
          }, (this || _global).removeSelectionMarker = function (e) {
            e.marker && ((this || _global).session.removeMarker(e.marker), -1 != (e = (this || _global).session.$selectionMarkers.indexOf(e)) && (this || _global).session.$selectionMarkers.splice(e, 1), (this || _global).session.selectionMarkerCount = (this || _global).session.$selectionMarkers.length);
          }, (this || _global).removeSelectionMarkers = function (e) {
            for (var t = (this || _global).session.$selectionMarkers, i = e.length; i--;) {
              var n = e[i];
              n.marker && ((this || _global).session.removeMarker(n.marker), -1 != (n = t.indexOf(n)) && t.splice(n, 1));
            }

            (this || _global).session.selectionMarkerCount = t.length;
          }, (this || _global).$onAddRange = function (e) {
            this.addSelectionMarker(e.range), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).$onRemoveRange = function (e) {
            this.removeSelectionMarkers(e.ranges), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
          }, (this || _global).$onMultiSelect = function (e) {
            (this || _global).inMultiSelectMode || ((this || _global).inMultiSelectMode = !0, this.setStyle("ace_multiselect"), (this || _global).keyBinding.addKeyboardHandler(a.keyboardHandler), (this || _global).commands.setDefaultHandler("exec", (this || _global).$onMultiSelectExec), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers());
          }, (this || _global).$onSingleSelect = function (e) {
            (this || _global).session.multiSelect.inVirtualMode || ((this || _global).inMultiSelectMode = !1, this.unsetStyle("ace_multiselect"), (this || _global).keyBinding.removeKeyboardHandler(a.keyboardHandler), (this || _global).commands.removeDefaultHandler("exec", (this || _global).$onMultiSelectExec), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers(), this._emit("changeSelection"));
          }, (this || _global).$onMultiSelectExec = function (e) {
            var t,
                i = e.command,
                n = e.editor;
            if (n.multiSelect) return i.multiSelectAction ? t = "forEach" == i.multiSelectAction ? n.forEachSelection(i, e.args) : "forEachLine" == i.multiSelectAction ? n.forEachSelection(i, e.args, !0) : "single" == i.multiSelectAction ? (n.exitMultiSelectMode(), i.exec(n, e.args || {})) : i.multiSelectAction(n, e.args || {}) : (t = i.exec(n, e.args || {}), n.multiSelect.addRange(n.multiSelect.toOrientedRange()), n.multiSelect.mergeOverlappingRanges()), t;
          }, (this || _global).forEachSelection = function (e, t, i) {
            if (!(this || _global).inVirtualSelectionMode) {
              var n,
                  r = i && i.keepOrder,
                  o = 1 == i || i && i.$byLines,
                  s = (this || _global).session,
                  i = (this || _global).selection,
                  a = i.rangeList,
                  l = (r ? i : a).ranges;
              if (!l.length) return e.exec ? e.exec(this || _global, t || {}) : e(this || _global, t || {});
              var r = i._eventRegistry,
                  c = (i._eventRegistry = {}, new u(s));
              (this || _global).inVirtualSelectionMode = !0;

              for (var h = l.length; h--;) {
                if (o) for (; 0 < h && l[h].start.row == l[h - 1].end.row;) h--;
                c.fromOrientedRange(l[h]), c.index = h, (this || _global).selection = s.selection = c;
                var d = e.exec ? e.exec(this || _global, t || {}) : e(this || _global, t || {});
                n || void 0 === d || (n = d), c.toOrientedRange(l[h]);
              }

              c.detach(), (this || _global).selection = s.selection = i, (this || _global).inVirtualSelectionMode = !1, i._eventRegistry = r, i.mergeOverlappingRanges(), i.ranges[0] && i.fromOrientedRange(i.ranges[0]);
              a = (this || _global).renderer.$scrollAnimation;
              return this.onCursorChange(), this.onSelectionChange(), a && a.from == a.to && (this || _global).renderer.animateScrolling(a.from), n;
            }
          }, (this || _global).exitMultiSelectMode = function () {
            (this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode && (this || _global).multiSelect.toSingleRange();
          }, (this || _global).getSelectedText = function () {
            var e = "";

            if ((this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode) {
              for (var t = (this || _global).multiSelect.rangeList.ranges, i = [], n = 0; n < t.length; n++) i.push((this || _global).session.getTextRange(t[n]));

              var r = (this || _global).session.getDocument().getNewLineCharacter();

              (e = i.join(r)).length == (i.length - 1) * r.length && (e = "");
            } else (this || _global).selection.isEmpty() || (e = (this || _global).session.getTextRange(this.getSelectionRange()));

            return e;
          }, (this || _global).$checkMultiselectChange = function (e, t) {
            var i;
            (this || _global).inMultiSelectMode && !(this || _global).inVirtualSelectionMode && (i = (this || _global).multiSelect.ranges[0], (this || _global).multiSelect.isEmpty() && t == (this || _global).multiSelect.anchor || ((i = t == (this || _global).multiSelect.anchor ? i.cursor == i.start ? i.end : i.start : i.cursor).row != t.row || (this || _global).session.$clipPositionToDocument(i.row, i.column).column != t.column ? (this || _global).multiSelect.toSingleRange((this || _global).multiSelect.toOrientedRange()) : (this || _global).multiSelect.mergeOverlappingRanges()));
          }, (this || _global).findAll = function (e, t, i) {
            (t = t || {}).needle = e || t.needle, null == t.needle && (n = (this || _global).selection.isEmpty() ? (this || _global).selection.getWordRange() : (this || _global).selection.getRange(), t.needle = (this || _global).session.getTextRange(n)), (this || _global).$search.set(t);

            var n,
                r = (this || _global).$search.findAll((this || _global).session);

            if (!r.length) return 0;
            var o = (this || _global).multiSelect;
            i || o.toSingleRange(r[0]);

            for (var s = r.length; s--;) o.addRange(r[s], !0);

            return n && o.rangeList.rangeAtPoint(n.start) && o.addRange(n, !0), r.length;
          }, (this || _global).selectMoreLines = function (e, t) {
            var i,
                n,
                r,
                o = (this || _global).selection.toOrientedRange(),
                s = o.cursor == o.end,
                a = (this || _global).session.documentToScreenPosition(o.cursor),
                l = ((this || _global).selection.$desiredColumn && (a.column = (this || _global).selection.$desiredColumn), (this || _global).session.screenToDocumentPosition(a.row + e, a.column));

            e = o.isEmpty() ? l : (i = (this || _global).session.documentToScreenPosition(s ? o.end : o.start), (this || _global).session.screenToDocumentPosition(i.row + e, i.column)), s ? (n = A.fromPoints(l, e)).cursor = n.start : (n = A.fromPoints(e, l)).cursor = n.end, n.desiredColumn = a.column, (this || _global).selection.inMultiSelectMode ? t && (r = o.cursor) : (this || _global).selection.addRange(o), (this || _global).selection.addRange(n), r && (this || _global).selection.substractPoint(r);
          }, (this || _global).transposeSelections = function (e) {
            for (var t = (this || _global).session, i = t.multiSelect, n = i.ranges, r = n.length; r--;) (s = n[r]).isEmpty() && (a = t.getWordRange(s.start.row, s.start.column), s.start.row = a.start.row, s.start.column = a.start.column, s.end.row = a.end.row, s.end.column = a.end.column);

            i.mergeOverlappingRanges();

            for (var o = [], r = n.length; r--;) {
              var s = n[r];
              o.unshift(t.getTextRange(s));
            }

            e < 0 ? o.unshift(o.pop()) : o.push(o.shift());

            for (r = n.length; r--;) {
              var a = (s = n[r]).clone();
              t.replace(s, o[r]), s.start.row = a.start.row, s.start.column = a.start.column;
            }

            i.fromOrientedRange(i.ranges[0]);
          }, (this || _global).selectMore = function (e, t, i) {
            var n,
                r = (this || _global).session,
                o = r.multiSelect.toOrientedRange();
            o.isEmpty() && ((o = r.getWordRange(o.start.row, o.start.column)).cursor = -1 == e ? o.start : o.end, (this || _global).multiSelect.addRange(o), i) || (i = r.getTextRange(o), r = r, i = i, n = e, l.$options.wrap = !0, l.$options.needle = i, l.$options.backwards = -1 == n, (i = l.find(r)) && (i.cursor = -1 == e ? i.start : i.end, (this || _global).session.unfold(i), (this || _global).multiSelect.addRange(i), (this || _global).renderer.scrollCursorIntoView(null, 0.5)), t && (this || _global).multiSelect.substractPoint(o.cursor));
          }, (this || _global).alignCursors = function () {
            var r = (this || _global).session,
                t = r.multiSelect,
                e = t.ranges,
                i = -1,
                n = e.filter(function (e) {
              if (e.cursor.row == i) return !0;
              i = e.cursor.row;
            });

            if (e.length && n.length != e.length - 1) {
              n.forEach(function (e) {
                t.substractPoint(e.cursor);
              });
              var o = 0,
                  s = 1 / 0,
                  a = e.map(function (e) {
                var e = e.cursor,
                    t = r.getLine(e.row).substr(e.column).search(/\S/g);
                return e.column > o && (o = e.column), (t = -1 == t ? 0 : t) < s && (s = t), t;
              });
              e.forEach(function (e, t) {
                var i = e.cursor,
                    n = o - i.column,
                    t = a[t] - s;
                t < n ? r.insert(i, g.stringRepeat(" ", n - t)) : r.remove(new A(i.row, i.column, i.row, i.column - n + t)), e.start.column = e.end.column = o, e.start.row = e.end.row = i.row, e.cursor = e.end;
              }), t.fromOrientedRange(e[0]), (this || _global).renderer.updateCursor(), (this || _global).renderer.updateBackMarkers();
            } else {
              var n = (this || _global).selection.getRange(),
                  l = n.start.row,
                  c = n.end.row,
                  e = l == c;

              if (e) {
                for (var h, d = (this || _global).session.getLength(); h = (this || _global).session.getLine(c), /[=:]/.test(h) && ++c < d;);

                for (; h = (this || _global).session.getLine(l), /[=:]/.test(h) && 0 < --l;);

                l < 0 && (l = 0), d <= c && (c = d - 1);
              }

              var u = (this || _global).session.removeFullLines(l, c),
                  u = this.$reAlignText(u, e);

              (this || _global).session.insert({
                row: l,
                column: 0
              }, u.join("\n") + "\n"), e || (n.start.column = 0, n.end.column = u[u.length - 1].length), (this || _global).selection.setRange(n);
            }
          }, (this || _global).$reAlignText = function (e, t) {
            var i,
                n,
                r,
                o = !0,
                s = !0;
            return e.map(function (e) {
              var t = e.match(/(\s*)(.*?)(\s*)([=:].*)/);
              return t ? (null == i ? (i = t[1].length, n = t[2].length, r = t[3].length) : (i + n + r != t[1].length + t[2].length + t[3].length && (s = !1), i != t[1].length && (o = !1), i > t[1].length && (i = t[1].length), n < t[2].length && (n = t[2].length), r > t[3].length && (r = t[3].length)), t) : [e];
            }).map(t ? l : o ? s ? function (e) {
              return e[2] ? a(i + n - e[2].length) + e[2] + a(r) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            } : l : function (e) {
              return e[2] ? a(i) + e[2] + a(r) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            });

            function a(e) {
              return g.stringRepeat(" ", e);
            }

            function l(e) {
              return e[2] ? a(i) + e[2] + a(n - e[2].length + r) + e[4].replace(/^([=:])\s+/, "$1 ") : e[0];
            }
          };
        }.call(n.prototype), r.onSessionChange = function (e) {
          var t = e.session,
              e = (t && !t.multiSelect && (t.$selectionMarkers = [], t.selection.$initRangeList(), t.multiSelect = t.selection), (this || _global).multiSelect = t && t.multiSelect, e.oldSession);
          e && (e.multiSelect.off("addRange", (this || _global).$onAddRange), e.multiSelect.off("removeRange", (this || _global).$onRemoveRange), e.multiSelect.off("multiSelect", (this || _global).$onMultiSelect), e.multiSelect.off("singleSelect", (this || _global).$onSingleSelect), e.multiSelect.lead.off("change", (this || _global).$checkMultiselectChange), e.multiSelect.anchor.off("change", (this || _global).$checkMultiselectChange)), t && (t.multiSelect.on("addRange", (this || _global).$onAddRange), t.multiSelect.on("removeRange", (this || _global).$onRemoveRange), t.multiSelect.on("multiSelect", (this || _global).$onMultiSelect), t.multiSelect.on("singleSelect", (this || _global).$onSingleSelect), t.multiSelect.lead.on("change", (this || _global).$checkMultiselectChange), t.multiSelect.anchor.on("change", (this || _global).$checkMultiselectChange)), t && (this || _global).inMultiSelectMode != t.selection.inMultiSelectMode && (t.selection.inMultiSelectMode ? this.$onMultiSelect() : this.$onSingleSelect());
        }, r.MultiSelect = c, e("./config").defineOptions(n.prototype, "editor", {
          enableMultiselect: {
            set: function (e) {
              c(this || _global), e ? (this.on("changeSession", (this || _global).$multiselectOnSessionChange), this.on("mousedown", o)) : (this.off("changeSession", (this || _global).$multiselectOnSessionChange), this.off("mousedown", o));
            },
            value: !0
          },
          enableBlockSelect: {
            set: function (e) {
              (this || _global).$blockSelectEnabled = e;
            },
            value: !0
          }
        });
      }), ace.define("ace/mode/folding/fold_mode", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        var h = e("../../range").Range,
            e = t.FoldMode = function () {};

        !function () {
          (this || _global).foldingStartMarker = null, (this || _global).foldingStopMarker = null, (this || _global).getFoldWidget = function (e, t, i) {
            e = e.getLine(i);
            return (this || _global).foldingStartMarker.test(e) ? "start" : "markbeginend" == t && (this || _global).foldingStopMarker && (this || _global).foldingStopMarker.test(e) ? "end" : "";
          }, (this || _global).getFoldWidgetRange = function (e, t, i) {
            return null;
          }, (this || _global).indentationBlock = function (e, t, i) {
            var n = /\S/,
                r = e.getLine(t),
                o = r.search(n);

            if (-1 != o) {
              for (var s, i = i || r.length, a = e.getLength(), r = t, l = t; ++t < a;) {
                var c = e.getLine(t).search(n);

                if (-1 != c) {
                  if (c <= o) {
                    c = e.getTokenAt(t, 0);
                    if (!c || "string" !== c.type) break;
                  }

                  l = t;
                }
              }

              return r < l ? (s = e.getLine(l).length, new h(r, i, l, s)) : void 0;
            }
          }, (this || _global).openingBracketBlock = function (e, t, i, n, r) {
            i = {
              row: i,
              column: n + 1
            }, n = e.$findClosingBracket(t, i, r);
            if (n) return t = e.foldWidgets[n.row], "start" == (t = null == t ? e.getFoldWidget(n.row) : t) && n.row > i.row && (n.row--, n.column = e.getLine(n.row).length), h.fromPoints(i, n);
          }, (this || _global).closingBracketBlock = function (e, t, i, n, r) {
            i = {
              row: i,
              column: n
            }, n = e.$findOpeningBracket(t, i);
            if (n) return n.column++, i.column--, h.fromPoints(n, i);
          };
        }.call(e.prototype);
      }), ace.define("ace/theme/textmate", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        t.isDark = !1, t.cssClass = "ace-tm", t.cssText = ".ace-tm .ace_gutter {background: #f0f0f0;color: #333;}.ace-tm .ace_print-margin {width: 1px;background: #e8e8e8;}.ace-tm .ace_fold {background-color: #6B72E6;}.ace-tm {background-color: #FFFFFF;color: black;}.ace-tm .ace_cursor {color: black;}.ace-tm .ace_invisible {color: rgb(191, 191, 191);}.ace-tm .ace_storage,.ace-tm .ace_keyword {color: blue;}.ace-tm .ace_constant {color: rgb(197, 6, 11);}.ace-tm .ace_constant.ace_buildin {color: rgb(88, 72, 246);}.ace-tm .ace_constant.ace_language {color: rgb(88, 92, 246);}.ace-tm .ace_constant.ace_library {color: rgb(6, 150, 14);}.ace-tm .ace_invalid {background-color: rgba(255, 0, 0, 0.1);color: red;}.ace-tm .ace_support.ace_function {color: rgb(60, 76, 114);}.ace-tm .ace_support.ace_constant {color: rgb(6, 150, 14);}.ace-tm .ace_support.ace_type,.ace-tm .ace_support.ace_class {color: rgb(109, 121, 222);}.ace-tm .ace_keyword.ace_operator {color: rgb(104, 118, 135);}.ace-tm .ace_string {color: rgb(3, 106, 7);}.ace-tm .ace_comment {color: rgb(76, 136, 107);}.ace-tm .ace_comment.ace_doc {color: rgb(0, 102, 255);}.ace-tm .ace_comment.ace_doc.ace_tag {color: rgb(128, 159, 191);}.ace-tm .ace_constant.ace_numeric {color: rgb(0, 0, 205);}.ace-tm .ace_variable {color: rgb(49, 132, 149);}.ace-tm .ace_xml-pe {color: rgb(104, 104, 91);}.ace-tm .ace_entity.ace_name.ace_function {color: #0000A2;}.ace-tm .ace_heading {color: rgb(12, 7, 255);}.ace-tm .ace_list {color:rgb(185, 6, 144);}.ace-tm .ace_meta.ace_tag {color:rgb(0, 22, 142);}.ace-tm .ace_string.ace_regex {color: rgb(255, 0, 0)}.ace-tm .ace_marker-layer .ace_selection {background: rgb(181, 213, 255);}.ace-tm.ace_multiselect .ace_selection.ace_start {box-shadow: 0 0 3px 0px white;}.ace-tm .ace_marker-layer .ace_step {background: rgb(252, 255, 0);}.ace-tm .ace_marker-layer .ace_stack {background: rgb(164, 229, 101);}.ace-tm .ace_marker-layer .ace_bracket {margin: -1px 0 0 -1px;border: 1px solid rgb(192, 192, 192);}.ace-tm .ace_marker-layer .ace_active-line {background: rgba(0, 0, 0, 0.07);}.ace-tm .ace_gutter-active-line {background-color : #dcdcdc;}.ace-tm .ace_marker-layer .ace_selected-word {background: rgb(250, 250, 255);border: 1px solid rgb(200, 200, 250);}.ace-tm .ace_indent-guide {background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;}", t.$id = "ace/theme/textmate", e("../lib/dom").importCssString(t.cssText, t.cssClass, !1);
      }), ace.define("ace/line_widgets", ["require", "exports", "module", "ace/lib/dom"], function (e, t, i) {
        "use strict";

        var r = e("./lib/dom");

        function n(e) {
          (this || _global).session = e, ((this || _global).session.widgetManager = this || _global).session.getRowLength = (this || _global).getRowLength, (this || _global).session.$getWidgetScreenLength = (this || _global).$getWidgetScreenLength, (this || _global).updateOnChange = (this || _global).updateOnChange.bind(this || _global), (this || _global).renderWidgets = (this || _global).renderWidgets.bind(this || _global), (this || _global).measureWidgets = (this || _global).measureWidgets.bind(this || _global), (this || _global).session._changedWidgets = [], (this || _global).$onChangeEditor = (this || _global).$onChangeEditor.bind(this || _global), (this || _global).session.on("change", (this || _global).updateOnChange), (this || _global).session.on("changeFold", (this || _global).updateOnFold), (this || _global).session.on("changeEditor", (this || _global).$onChangeEditor);
        }

        !function () {
          (this || _global).getRowLength = function (e) {
            var t = (this || _global).lineWidgets && (this || _global).lineWidgets[e] && (this || _global).lineWidgets[e].rowCount || 0;
            return (this || _global).$useWrapMode && (this || _global).$wrapData[e] ? (this || _global).$wrapData[e].length + 1 + t : 1 + t;
          }, (this || _global).$getWidgetScreenLength = function () {
            var t = 0;
            return (this || _global).lineWidgets.forEach(function (e) {
              e && e.rowCount && !e.hidden && (t += e.rowCount);
            }), t;
          }, (this || _global).$onChangeEditor = function (e) {
            this.attach(e.editor);
          }, (this || _global).attach = function (e) {
            e && e.widgetManager && e.widgetManager != (this || _global) && e.widgetManager.detach(), (this || _global).editor != e && (this.detach(), ((this || _global).editor = e) && (e.widgetManager = this || _global, e.renderer.on("beforeRender", (this || _global).measureWidgets), e.renderer.on("afterRender", (this || _global).renderWidgets)));
          }, (this || _global).detach = function (e) {
            var t = (this || _global).editor;
            t && ((this || _global).editor = null, t.widgetManager = null, t.renderer.off("beforeRender", (this || _global).measureWidgets), t.renderer.off("afterRender", (this || _global).renderWidgets), (t = (this || _global).session.lineWidgets) && t.forEach(function (e) {
              e && e.el && e.el.parentNode && (e._inDocument = !1, e.el.parentNode.removeChild(e.el));
            }));
          }, (this || _global).updateOnFold = function (e, t) {
            var i = t.lineWidgets;

            if (i && e.action) {
              for (var t = e.data, n = t.start.row, r = t.end.row, o = "add" == e.action, s = n + 1; s < r; s++) i[s] && (i[s].hidden = o);

              i[r] && (o ? i[n] ? i[r].hidden = o : i[n] = i[r] : (i[n] == i[r] && (i[n] = void 0), i[r].hidden = o));
            }
          }, (this || _global).updateOnChange = function (e) {
            var t,
                i,
                n,
                r = (this || _global).session.lineWidgets;
            r && (t = e.start.row, 0 != (i = e.end.row - t) && ("remove" == e.action ? (n = r.splice(t + 1, i), !r[t] && n[n.length - 1] && (r[t] = n.pop()), n.forEach(function (e) {
              e && this.removeLineWidget(e);
            }, this || _global)) : (n = new Array(i), r[t] && null != r[t].column && e.start.column > r[t].column && t++, n.unshift(t, 0), r.splice.apply(r, n)), this.$updateRows()));
          }, (this || _global).$updateRows = function () {
            var i,
                e = (this || _global).session.lineWidgets;
            e && (i = !0, e.forEach(function (e, t) {
              if (e) for (i = !1, e.row = t; e.$oldWidget;) e.$oldWidget.row = t, e = e.$oldWidget;
            }), i && ((this || _global).session.lineWidgets = null));
          }, (this || _global).$registerLineWidget = function (e) {
            (this || _global).session.lineWidgets || ((this || _global).session.lineWidgets = new Array((this || _global).session.getLength()));
            var t = (this || _global).session.lineWidgets[e.row];
            return t && (e.$oldWidget = t).el && t.el.parentNode && (t.el.parentNode.removeChild(t.el), t._inDocument = !1), (this || _global).session.lineWidgets[e.row] = e;
          }, (this || _global).addLineWidget = function (e) {
            if (this.$registerLineWidget(e), e.session = (this || _global).session, !(this || _global).editor) return e;
            var t,
                i = (this || _global).editor.renderer,
                n = (e.html && !e.el && (e.el = r.createElement("div"), e.el.innerHTML = e.html), e.el && (r.addCssClass(e.el, "ace_lineWidgetContainer"), e.el.style.position = "absolute", e.el.style.zIndex = 5, i.container.appendChild(e.el), e._inDocument = !0, e.coverGutter || (e.el.style.zIndex = 3), null == e.pixelHeight && (e.pixelHeight = e.el.offsetHeight)), null == e.rowCount && (e.rowCount = e.pixelHeight / i.layerConfig.lineHeight), (this || _global).session.getFoldAt(e.row, 0));
            return (e.$fold = n) && (t = (this || _global).session.lineWidgets, e.row != n.end.row || t[n.start.row] ? e.hidden = !0 : t[n.start.row] = e), (this || _global).session._emit("changeFold", {
              data: {
                start: {
                  row: e.row
                }
              }
            }), this.$updateRows(), this.renderWidgets(null, i), this.onWidgetChanged(e), e;
          }, (this || _global).removeLineWidget = function (e) {
            if (e._inDocument = !1, e.session = null, e.el && e.el.parentNode && e.el.parentNode.removeChild(e.el), e.editor && e.editor.destroy) try {
              e.editor.destroy();
            } catch (e) {}

            if ((this || _global).session.lineWidgets) {
              var t = (this || _global).session.lineWidgets[e.row];
              if (t == e) (this || _global).session.lineWidgets[e.row] = e.$oldWidget, e.$oldWidget && this.onWidgetChanged(e.$oldWidget);else for (; t;) {
                if (t.$oldWidget == e) {
                  t.$oldWidget = e.$oldWidget;
                  break;
                }

                t = t.$oldWidget;
              }
            }

            (this || _global).session._emit("changeFold", {
              data: {
                start: {
                  row: e.row
                }
              }
            }), this.$updateRows();
          }, (this || _global).getWidgetsAtRow = function (e) {
            for (var t = (this || _global).session.lineWidgets, i = t && t[e], n = []; i;) n.push(i), i = i.$oldWidget;

            return n;
          }, (this || _global).onWidgetChanged = function (e) {
            (this || _global).session._changedWidgets.push(e), (this || _global).editor && (this || _global).editor.renderer.updateFull();
          }, (this || _global).measureWidgets = function (e, t) {
            var i = (this || _global).session._changedWidgets,
                n = t.layerConfig;

            if (i && i.length) {
              for (var r = 1 / 0, o = 0; o < i.length; o++) {
                var s = i[o];

                if (s && s.el && s.session == (this || _global).session) {
                  if (!s._inDocument) {
                    if ((this || _global).session.lineWidgets[s.row] != s) continue;
                    s._inDocument = !0, t.container.appendChild(s.el);
                  }

                  s.h = s.el.offsetHeight, s.fixedWidth || (s.w = s.el.offsetWidth, s.screenWidth = Math.ceil(s.w / n.characterWidth));
                  var a = s.h / n.lineHeight;
                  s.coverLine && (a -= (this || _global).session.getRowLineCount(s.row)) < 0 && (a = 0), s.rowCount != a && (s.rowCount = a, s.row < r && (r = s.row));
                }
              }

              r != 1 / 0 && ((this || _global).session._emit("changeFold", {
                data: {
                  start: {
                    row: r
                  }
                }
              }), (this || _global).session.lineWidgetWidth = null), (this || _global).session._changedWidgets = [];
            }
          }, (this || _global).renderWidgets = function (e, t) {
            var i = t.layerConfig,
                n = (this || _global).session.lineWidgets;

            if (n) {
              for (var r = Math.min((this || _global).firstRow, i.firstRow), o = Math.max((this || _global).lastRow, i.lastRow, n.length); 0 < r && !n[r];) r--;

              (this || _global).firstRow = i.firstRow, (this || _global).lastRow = i.lastRow, t.$cursorLayer.config = i;

              for (var s = r; s <= o; s++) {
                var a,
                    l = n[s];
                l && l.el && (l.hidden ? l.el.style.top = -100 - (l.pixelHeight || 0) + "px" : (l._inDocument || (l._inDocument = !0, t.container.appendChild(l.el)), a = t.$cursorLayer.getPixelPosition({
                  row: s,
                  column: 0
                }, !0).top, l.coverLine || (a += i.lineHeight * (this || _global).session.getRowLineCount(l.row)), l.el.style.top = a - i.offset + "px", a = l.coverGutter ? 0 : t.gutterWidth, l.fixedWidth || (a -= t.scrollLeft), l.el.style.left = a + "px", l.fullWidth && l.screenWidth && (l.el.style.minWidth = i.width + 2 * i.padding + "px"), l.fixedWidth ? l.el.style.right = t.scrollBar.getWidth() + "px" : l.el.style.right = ""));
              }
            }
          };
        }.call(n.prototype), t.LineWidgets = n;
      }), ace.define("ace/ext/error_marker", ["require", "exports", "module", "ace/line_widgets", "ace/lib/dom", "ace/range"], function (e, t, i) {
        "use strict";

        var c = e("../line_widgets").LineWidgets,
            h = e("../lib/dom"),
            a = e("../range").Range;

        function d(e, t, i) {
          var n = e.getAnnotations().sort(a.comparePoints);

          if (n.length) {
            var r = function (e, t, i) {
              for (var n = 0, r = e.length - 1; n <= r;) {
                var o = n + r >> 1,
                    s = i(t, e[o]);
                if (0 < s) n = 1 + o;else {
                  if (!(s < 0)) return o;
                  r = o - 1;
                }
              }

              return -(n + 1);
            }(n, {
              row: t,
              column: -1
            }, a.comparePoints),
                o = ((r = r < 0 ? -r - 1 : r) >= n.length ? r = 0 < i ? 0 : n.length - 1 : 0 === r && i < 0 && (r = n.length - 1), n[r]);

            if (o && i) {
              if (o.row === t) {
                for (; (o = n[r += i]) && o.row === t;);

                if (!o) return n.slice();
              }

              var s = [];

              for (t = o.row; s[i < 0 ? "unshift" : "push"](o), (o = n[r += i]) && o.row == t;);

              return s.length && s;
            }
          }
        }

        t.showErrorMarker = function (e, t) {
          var i,
              n = e.session,
              r = (n.widgetManager || (n.widgetManager = new c(n), n.widgetManager.attach(e)), e.getCursorPosition()),
              o = r.row,
              s = n.widgetManager.getWidgetsAtRow(o).filter(function (e) {
            return "errorMarker" == e.type;
          })[0],
              o = (s ? s.destroy() : o -= t, d(n, o, t));

          if (o) {
            t = o[0];
            r.column = (t.pos && "number" != typeof t.column ? t.pos.sc : t.column) || 0, r.row = t.row, i = e.renderer.$gutterLayer.$annotations[r.row];
          } else {
            if (s) return;
            i = {
              text: ["Looks good!"],
              className: "ace_ok"
            };
          }

          e.session.unfold(r.row), e.selection.moveToPosition(r);

          function a(e, t, i) {
            if (0 === t && ("esc" === i || "return" === i)) return l.destroy(), {
              command: "null"
            };
          }

          var l = {
            row: r.row,
            fixedWidth: !0,
            coverGutter: !0,
            el: h.createElement("div"),
            type: "errorMarker"
          },
              o = l.el.appendChild(h.createElement("div")),
              t = l.el.appendChild(h.createElement("div")),
              s = (t.className = "error_widget_arrow " + i.className, e.renderer.$cursorLayer.getPixelPosition(r).left);
          t.style.left = s + e.renderer.gutterWidth - 5 + "px", l.el.className = "error_widget_wrapper", o.className = "error_widget " + i.className, o.innerHTML = i.text.join("<br>"), o.appendChild(h.createElement("div"));
          l.destroy = function () {
            e.$mouseHandler.isMousePressed || (e.keyBinding.removeKeyboardHandler(a), n.widgetManager.removeLineWidget(l), e.off("changeSelection", l.destroy), e.off("changeSession", l.destroy), e.off("mouseup", l.destroy), e.off("change", l.destroy));
          }, e.keyBinding.addKeyboardHandler(a), e.on("changeSelection", l.destroy), e.on("changeSession", l.destroy), e.on("mouseup", l.destroy), e.on("change", l.destroy), e.session.widgetManager.addLineWidget(l), l.el.onmousedown = e.focus.bind(e), e.renderer.scrollCursorIntoView(null, 0.5, {
            bottom: l.el.offsetHeight
          });
        }, h.importCssString("    .error_widget_wrapper {        background: inherit;        color: inherit;        border:none    }    .error_widget {        border-top: solid 2px;        border-bottom: solid 2px;        margin: 5px 0;        padding: 10px 40px;        white-space: pre-wrap;    }    .error_widget.ace_error, .error_widget_arrow.ace_error{        border-color: #ff5a5a    }    .error_widget.ace_warning, .error_widget_arrow.ace_warning{        border-color: #F1D817    }    .error_widget.ace_info, .error_widget_arrow.ace_info{        border-color: #5a5a5a    }    .error_widget.ace_ok, .error_widget_arrow.ace_ok{        border-color: #5aaa5a    }    .error_widget_arrow {        position: absolute;        border: solid 5px;        border-top-color: transparent!important;        border-right-color: transparent!important;        border-left-color: transparent!important;        top: -5px;    }", "error_marker.css", !1);
      }), ace.define("ace/ace", ["require", "exports", "module", "ace/lib/fixoldbrowsers", "ace/lib/dom", "ace/lib/event", "ace/range", "ace/editor", "ace/edit_session", "ace/undomanager", "ace/virtual_renderer", "ace/worker/worker_client", "ace/keyboard/hash_handler", "ace/placeholder", "ace/multi_select", "ace/mode/folding/fold_mode", "ace/theme/textmate", "ace/ext/error_marker", "ace/config"], function (e, o, t) {
        "use strict";

        e("./lib/fixoldbrowsers");
        var s = e("./lib/dom"),
            a = e("./lib/event"),
            i = e("./range").Range,
            l = e("./editor").Editor,
            n = e("./edit_session").EditSession,
            r = e("./undomanager").UndoManager,
            c = e("./virtual_renderer").VirtualRenderer;
        e("./worker/worker_client"), e("./keyboard/hash_handler"), e("./placeholder"), e("./multi_select"), e("./mode/folding/fold_mode"), e("./theme/textmate"), e("./ext/error_marker"), o.config = e("./config"), o.require = e, o.define = C.amdD, o.edit = function (e, t) {
          if ("string" == typeof e) {
            var i = e;
            if (!(e = document.getElementById(i))) throw new Error("ace.edit can't find div #" + i);
          }

          if (e && e.env && e.env.editor instanceof l) return e.env.editor;
          var n,
              i = "",
              i = (e && /input|textarea/i.test(e.tagName) ? (i = (n = e).value, e = s.createElement("pre"), n.parentNode.replaceChild(e, n)) : e && (i = e.textContent, e.innerHTML = ""), o.createEditSession(i)),
              e = new l(new c(e), i, t),
              r = {
            document: i,
            editor: e,
            onResize: e.resize.bind(e, null)
          };
          return n && (r.textarea = n), a.addListener(window, "resize", r.onResize), e.on("destroy", function () {
            a.removeListener(window, "resize", r.onResize), r.editor.container.env = null;
          }), e.container.env = e.env = r, e;
        }, o.createEditSession = function (e, t) {
          e = new n(e, t);
          return e.setUndoManager(new r()), e;
        }, o.Range = i, o.Editor = l, o.EditSession = n, o.UndoManager = r, o.VirtualRenderer = c, o.version = o.config.version;
      }), ace.require(["ace/ace"], function (e) {
        for (var t in e && (e.config.init(!0), e.define = ace.define), window.ace || (window.ace = e), e) e.hasOwnProperty(t) && (window.ace[t] = e[t]);

        window.ace.default = window.ace, i && (i.exports = window.ace);
      });
    },
    3330: function (t, e, i) {
      t = i.nmd(t), ace.define("ace/ext/searchbox", ["require", "exports", "module", "ace/lib/dom", "ace/lib/lang", "ace/lib/event", "ace/keyboard/hash_handler", "ace/lib/keys"], function (e, t, i) {
        "use strict";

        function n(e, t, i) {
          var n = r.createElement("div");
          r.buildDom(["div", {
            class: "ace_search right"
          }, ["span", {
            action: "hide",
            class: "ace_searchbtn_close"
          }], ["div", {
            class: "ace_search_form"
          }, ["input", {
            class: "ace_search_field",
            placeholder: "Search for",
            spellcheck: "false"
          }], ["span", {
            action: "findPrev",
            class: "ace_searchbtn prev"
          }, "\u200B"], ["span", {
            action: "findNext",
            class: "ace_searchbtn next"
          }, "\u200B"], ["span", {
            action: "findAll",
            class: "ace_searchbtn",
            title: "Alt-Enter"
          }, "All"]], ["div", {
            class: "ace_replace_form"
          }, ["input", {
            class: "ace_search_field",
            placeholder: "Replace with",
            spellcheck: "false"
          }], ["span", {
            action: "replaceAndFindNext",
            class: "ace_searchbtn"
          }, "Replace"], ["span", {
            action: "replaceAll",
            class: "ace_searchbtn"
          }, "All"]], ["div", {
            class: "ace_search_options"
          }, ["span", {
            action: "toggleReplace",
            class: "ace_button",
            title: "Toggle Replace mode",
            style: "float:left;margin-top:-2px;padding:0 5px;"
          }, "+"], ["span", {
            class: "ace_search_counter"
          }], ["span", {
            action: "toggleRegexpMode",
            class: "ace_button",
            title: "RegExp Search"
          }, ".*"], ["span", {
            action: "toggleCaseSensitive",
            class: "ace_button",
            title: "CaseSensitive Search"
          }, "Aa"], ["span", {
            action: "toggleWholeWords",
            class: "ace_button",
            title: "Whole Word Search"
          }, "\\b"], ["span", {
            action: "searchInSelection",
            class: "ace_button",
            title: "Search In Selection"
          }, "S"]]], n), (this || _global).element = n.firstChild, (this || _global).setSession = (this || _global).setSession.bind(this || _global), this.$init(), this.setEditor(e), r.importCssString(a, "ace_searchbox", e.container);
        }

        var r = e("../lib/dom"),
            o = e("../lib/lang"),
            s = e("../lib/event"),
            a = ".ace_search {background-color: #ddd;color: #666;border: 1px solid #cbcbcb;border-top: 0 none;overflow: hidden;margin: 0;padding: 4px 6px 0 4px;position: absolute;top: 0;z-index: 99;white-space: normal;}.ace_search.left {border-left: 0 none;border-radius: 0px 0px 5px 0px;left: 0;}.ace_search.right {border-radius: 0px 0px 0px 5px;border-right: 0 none;right: 0;}.ace_search_form, .ace_replace_form {margin: 0 20px 4px 0;overflow: hidden;line-height: 1.9;}.ace_replace_form {margin-right: 0;}.ace_search_form.ace_nomatch {outline: 1px solid red;}.ace_search_field {border-radius: 3px 0 0 3px;background-color: white;color: black;border: 1px solid #cbcbcb;border-right: 0 none;outline: 0;padding: 0;font-size: inherit;margin: 0;line-height: inherit;padding: 0 6px;min-width: 17em;vertical-align: top;min-height: 1.8em;box-sizing: content-box;}.ace_searchbtn {border: 1px solid #cbcbcb;line-height: inherit;display: inline-block;padding: 0 6px;background: #fff;border-right: 0 none;border-left: 1px solid #dcdcdc;cursor: pointer;margin: 0;position: relative;color: #666;}.ace_searchbtn:last-child {border-radius: 0 3px 3px 0;border-right: 1px solid #cbcbcb;}.ace_searchbtn:disabled {background: none;cursor: default;}.ace_searchbtn:hover {background-color: #eef1f6;}.ace_searchbtn.prev, .ace_searchbtn.next {padding: 0px 0.7em}.ace_searchbtn.prev:after, .ace_searchbtn.next:after {content: \"\";border: solid 2px #888;width: 0.5em;height: 0.5em;border-width:  2px 0 0 2px;display:inline-block;transform: rotate(-45deg);}.ace_searchbtn.next:after {border-width: 0 2px 2px 0 ;}.ace_searchbtn_close {background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;border-radius: 50%;border: 0 none;color: #656565;cursor: pointer;font: 16px/16px Arial;padding: 0;height: 14px;width: 14px;top: 9px;right: 7px;position: absolute;}.ace_searchbtn_close:hover {background-color: #656565;background-position: 50% 100%;color: white;}.ace_button {margin-left: 2px;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-o-user-select: none;-ms-user-select: none;user-select: none;overflow: hidden;opacity: 0.7;border: 1px solid rgba(100,100,100,0.23);padding: 1px;box-sizing:    border-box!important;color: black;}.ace_button:hover {background-color: #eee;opacity:1;}.ace_button:active {background-color: #ddd;}.ace_button.checked {border-color: #3399ff;opacity:1;}.ace_search_options{margin-bottom: 3px;text-align: right;-webkit-user-select: none;-moz-user-select: none;-o-user-select: none;-ms-user-select: none;user-select: none;clear: both;}.ace_search_counter {float: left;font-family: arial;padding: 0 8px;}",
            l = e("../keyboard/hash_handler").HashHandler,
            c = e("../lib/keys");
        r.importCssString(a, "ace_searchbox", !1);
        !function () {
          (this || _global).setEditor = function (e) {
            e.searchBox = this || _global, e.renderer.scroller.appendChild((this || _global).element), (this || _global).editor = e;
          }, (this || _global).setSession = function (e) {
            (this || _global).searchRange = null, this.$syncOptions(!0);
          }, (this || _global).$initElements = function (e) {
            (this || _global).searchBox = e.querySelector(".ace_search_form"), (this || _global).replaceBox = e.querySelector(".ace_replace_form"), (this || _global).searchOption = e.querySelector("[action=searchInSelection]"), (this || _global).replaceOption = e.querySelector("[action=toggleReplace]"), (this || _global).regExpOption = e.querySelector("[action=toggleRegexpMode]"), (this || _global).caseSensitiveOption = e.querySelector("[action=toggleCaseSensitive]"), (this || _global).wholeWordOption = e.querySelector("[action=toggleWholeWords]"), (this || _global).searchInput = (this || _global).searchBox.querySelector(".ace_search_field"), (this || _global).replaceInput = (this || _global).replaceBox.querySelector(".ace_search_field"), (this || _global).searchCounter = e.querySelector(".ace_search_counter");
          }, (this || _global).$init = function () {
            var e = (this || _global).element,
                n = (this.$initElements(e), this || _global);
            s.addListener(e, "mousedown", function (e) {
              setTimeout(function () {
                n.activeInput.focus();
              }, 0), s.stopPropagation(e);
            }), s.addListener(e, "click", function (e) {
              var t = (e.target || e.srcElement).getAttribute("action");
              t && n[t] ? n[t]() : n.$searchBarKb.commands[t] && n.$searchBarKb.commands[t].exec(n), s.stopPropagation(e);
            }), s.addCommandKeyListener(e, function (e, t, i) {
              i = c.keyCodeToString(i), t = n.$searchBarKb.findKeyCommand(t, i);
              t && t.exec && (t.exec(n), s.stopEvent(e));
            }), (this || _global).$onChange = o.delayedCall(function () {
              n.find(!1, !1);
            }), s.addListener((this || _global).searchInput, "input", function () {
              n.$onChange.schedule(20);
            }), s.addListener((this || _global).searchInput, "focus", function () {
              n.activeInput = n.searchInput, n.searchInput.value && n.highlight();
            }), s.addListener((this || _global).replaceInput, "focus", function () {
              n.activeInput = n.replaceInput, n.searchInput.value && n.highlight();
            });
          }, (this || _global).$closeSearchBarKb = new l([{
            bindKey: "Esc",
            name: "closeSearchBar",
            exec: function (e) {
              e.searchBox.hide();
            }
          }]), (this || _global).$searchBarKb = new l(), (this || _global).$searchBarKb.bindKeys({
            "Ctrl-f|Command-f": function (e) {
              var t = e.isReplace = !e.isReplace;
              e.replaceBox.style.display = t ? "" : "none", e.replaceOption.checked = !1, e.$syncOptions(), e.searchInput.focus();
            },
            "Ctrl-H|Command-Option-F": function (e) {
              e.editor.getReadOnly() || (e.replaceOption.checked = !0, e.$syncOptions(), e.replaceInput.focus());
            },
            "Ctrl-G|Command-G": function (e) {
              e.findNext();
            },
            "Ctrl-Shift-G|Command-Shift-G": function (e) {
              e.findPrev();
            },
            esc: function (e) {
              setTimeout(function () {
                e.hide();
              });
            },
            Return: function (e) {
              e.activeInput == e.replaceInput && e.replace(), e.findNext();
            },
            "Shift-Return": function (e) {
              e.activeInput == e.replaceInput && e.replace(), e.findPrev();
            },
            "Alt-Return": function (e) {
              e.activeInput == e.replaceInput && e.replaceAll(), e.findAll();
            },
            Tab: function (e) {
              (e.activeInput == e.replaceInput ? e.searchInput : e.replaceInput).focus();
            }
          }), (this || _global).$searchBarKb.addCommands([{
            name: "toggleRegexpMode",
            bindKey: {
              win: "Alt-R|Alt-/",
              mac: "Ctrl-Alt-R|Ctrl-Alt-/"
            },
            exec: function (e) {
              e.regExpOption.checked = !e.regExpOption.checked, e.$syncOptions();
            }
          }, {
            name: "toggleCaseSensitive",
            bindKey: {
              win: "Alt-C|Alt-I",
              mac: "Ctrl-Alt-R|Ctrl-Alt-I"
            },
            exec: function (e) {
              e.caseSensitiveOption.checked = !e.caseSensitiveOption.checked, e.$syncOptions();
            }
          }, {
            name: "toggleWholeWords",
            bindKey: {
              win: "Alt-B|Alt-W",
              mac: "Ctrl-Alt-B|Ctrl-Alt-W"
            },
            exec: function (e) {
              e.wholeWordOption.checked = !e.wholeWordOption.checked, e.$syncOptions();
            }
          }, {
            name: "toggleReplace",
            exec: function (e) {
              e.replaceOption.checked = !e.replaceOption.checked, e.$syncOptions();
            }
          }, {
            name: "searchInSelection",
            exec: function (e) {
              e.searchOption.checked = !e.searchRange, e.setSearchRange(e.searchOption.checked && e.editor.getSelectionRange()), e.$syncOptions();
            }
          }]), (this || _global).setSearchRange = function (e) {
            ((this || _global).searchRange = e) ? (this || _global).searchRangeMarker = (this || _global).editor.session.addMarker(e, "ace_active-line") : (this || _global).searchRangeMarker && ((this || _global).editor.session.removeMarker((this || _global).searchRangeMarker), (this || _global).searchRangeMarker = null);
          }, (this || _global).$syncOptions = function (e) {
            r.setCssClass((this || _global).replaceOption, "checked", (this || _global).searchRange), r.setCssClass((this || _global).searchOption, "checked", (this || _global).searchOption.checked), (this || _global).replaceOption.textContent = (this || _global).replaceOption.checked ? "-" : "+", r.setCssClass((this || _global).regExpOption, "checked", (this || _global).regExpOption.checked), r.setCssClass((this || _global).wholeWordOption, "checked", (this || _global).wholeWordOption.checked), r.setCssClass((this || _global).caseSensitiveOption, "checked", (this || _global).caseSensitiveOption.checked);

            var t = (this || _global).editor.getReadOnly();

            (this || _global).replaceOption.style.display = t ? "none" : "", (this || _global).replaceBox.style.display = (this || _global).replaceOption.checked && !t ? "" : "none", this.find(!1, !1, e);
          }, (this || _global).highlight = function (e) {
            (this || _global).editor.session.highlight(e || (this || _global).editor.$search.$options.re), (this || _global).editor.renderer.updateBackMarkers();
          }, (this || _global).find = function (e, t, i) {
            e = !(this || _global).editor.find((this || _global).searchInput.value, {
              skipCurrent: e,
              backwards: t,
              wrap: !0,
              regExp: (this || _global).regExpOption.checked,
              caseSensitive: (this || _global).caseSensitiveOption.checked,
              wholeWord: (this || _global).wholeWordOption.checked,
              preventScroll: i,
              range: (this || _global).searchRange
            }) && (this || _global).searchInput.value;
            r.setCssClass((this || _global).searchBox, "ace_nomatch", e), (this || _global).editor._emit("findSearchBox", {
              match: !e
            }), this.highlight(), this.updateCounter();
          }, (this || _global).updateCounter = function () {
            var e = (this || _global).editor,
                t = e.$search.$options.re,
                i = 0,
                n = 0;

            if (t) {
              var r,
                  o,
                  s = (this || _global).searchRange ? e.session.getTextRange((this || _global).searchRange) : e.getValue(),
                  a = e.session.doc.positionToIndex(e.selection.anchor);

              for ((this || _global).searchRange && (a -= e.session.doc.positionToIndex((this || _global).searchRange.start)), t.lastIndex = 0; (o = t.exec(s)) && ((r = o.index) <= a && n++, !(999 < ++i)) && (o[0] || (t.lastIndex = r += 1, !(r >= s.length))););
            }

            (this || _global).searchCounter.textContent = n + " of " + (999 < i ? "999+" : i);
          }, (this || _global).findNext = function () {
            this.find(!0, !1);
          }, (this || _global).findPrev = function () {
            this.find(!0, !0);
          }, (this || _global).findAll = function () {
            var e = !(this || _global).editor.findAll((this || _global).searchInput.value, {
              regExp: (this || _global).regExpOption.checked,
              caseSensitive: (this || _global).caseSensitiveOption.checked,
              wholeWord: (this || _global).wholeWordOption.checked
            }) && (this || _global).searchInput.value;
            r.setCssClass((this || _global).searchBox, "ace_nomatch", e), (this || _global).editor._emit("findSearchBox", {
              match: !e
            }), this.highlight(), this.hide();
          }, (this || _global).replace = function () {
            (this || _global).editor.getReadOnly() || (this || _global).editor.replace((this || _global).replaceInput.value);
          }, (this || _global).replaceAndFindNext = function () {
            (this || _global).editor.getReadOnly() || ((this || _global).editor.replace((this || _global).replaceInput.value), this.findNext());
          }, (this || _global).replaceAll = function () {
            (this || _global).editor.getReadOnly() || (this || _global).editor.replaceAll((this || _global).replaceInput.value);
          }, (this || _global).hide = function () {
            (this || _global).active = !1, this.setSearchRange(null), (this || _global).editor.off("changeSession", (this || _global).setSession), (this || _global).element.style.display = "none", (this || _global).editor.keyBinding.removeKeyboardHandler((this || _global).$closeSearchBarKb), (this || _global).editor.focus();
          }, (this || _global).show = function (e, t) {
            (this || _global).active = !0, (this || _global).editor.on("changeSession", (this || _global).setSession), (this || _global).element.style.display = "", (this || _global).replaceOption.checked = t, e && ((this || _global).searchInput.value = e), (this || _global).searchInput.focus(), (this || _global).searchInput.select(), (this || _global).editor.keyBinding.addKeyboardHandler((this || _global).$closeSearchBarKb), this.$syncOptions(!0);
          }, (this || _global).isFocused = function () {
            var e = document.activeElement;
            return e == (this || _global).searchInput || e == (this || _global).replaceInput;
          };
        }.call(n.prototype), t.SearchBox = n, t.Search = function (e, t) {
          (e.searchBox || new n(e)).show(e.session.getTextRange(), t);
        };
      }), ace.require(["ace/ext/searchbox"], function (e) {
        t && (t.exports = e);
      });
    },
    4091: function (t, e, i) {
      t = i.nmd(t), ace.define("ace/mode/json_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text_highlight_rules"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).$rules = {
            start: [{
              token: "variable",
              regex: "[\"](?:(?:\\\\.)|(?:[^\"\\\\]))*?[\"]\\s*(?=:)"
            }, {
              token: "string",
              regex: "\"",
              next: "string"
            }, {
              token: "constant.numeric",
              regex: "0[xX][0-9a-fA-F]+\\b"
            }, {
              token: "constant.numeric",
              regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
            }, {
              token: "constant.language.boolean",
              regex: "(?:true|false)\\b"
            }, {
              token: "text",
              regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
            }, {
              token: "comment",
              regex: "\\/\\/.*$"
            }, {
              token: "comment.start",
              regex: "\\/\\*",
              next: "comment"
            }, {
              token: "paren.lparen",
              regex: "[[({]"
            }, {
              token: "paren.rparen",
              regex: "[\\])}]"
            }, {
              token: "text",
              regex: "\\s+"
            }],
            string: [{
              token: "constant.language.escape",
              regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
            }, {
              token: "string",
              regex: "\"|$",
              next: "start"
            }, {
              defaultToken: "string"
            }],
            comment: [{
              token: "comment.end",
              regex: "\\*\\/",
              next: "start"
            }, {
              defaultToken: "comment"
            }]
          };
        }

        var r = e("../lib/oop"),
            e = e("./text_highlight_rules").TextHighlightRules;
        r.inherits(n, e), t.JsonHighlightRules = n;
      }), ace.define("ace/mode/matching_brace_outdent", ["require", "exports", "module", "ace/range"], function (e, t, i) {
        "use strict";

        function n() {}

        var r = e("../range").Range;
        !function () {
          (this || _global).checkOutdent = function (e, t) {
            return !!/^\s+$/.test(e) && /^\s*\}/.test(t);
          }, (this || _global).autoOutdent = function (e, t) {
            var i = e.getLine(t).match(/^(\s*\})/);
            if (!i) return 0;
            var i = i[1].length,
                n = e.findMatchingBracket({
              row: t,
              column: i
            });
            if (!n || n.row == t) return 0;
            n = this.$getIndent(e.getLine(n.row));
            e.replace(new r(t, 0, t, i - 1), n);
          }, (this || _global).$getIndent = function (e) {
            return e.match(/^\s*/)[0];
          };
        }.call(n.prototype), t.MatchingBraceOutdent = n;
      }), ace.define("ace/mode/folding/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/range", "ace/mode/folding/fold_mode"], function (e, t, i) {
        "use strict";

        var n = e("../../lib/oop"),
            h = e("../../range").Range,
            e = e("./fold_mode").FoldMode,
            t = t.FoldMode = function (e) {
          e && ((this || _global).foldingStartMarker = new RegExp((this || _global).foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + e.start)), (this || _global).foldingStopMarker = new RegExp((this || _global).foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + e.end)));
        };

        n.inherits(t, e), function () {
          (this || _global).foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/, (this || _global).foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/, (this || _global).singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/, (this || _global).tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/, (this || _global).startRegionRe = /^\s*(\/\*|\/\/)#?region\b/, (this || _global)._getFoldWidgetBase = (this || _global).getFoldWidget, (this || _global).getFoldWidget = function (e, t, i) {
            var n = e.getLine(i);
            if ((this || _global).singleLineBlockCommentRe.test(n) && !(this || _global).startRegionRe.test(n) && !(this || _global).tripleStarBlockCommentRe.test(n)) return "";
            e = this._getFoldWidgetBase(e, t, i);
            return !e && (this || _global).startRegionRe.test(n) ? "start" : e;
          }, (this || _global).getFoldWidgetRange = function (e, t, i, n) {
            var r = e.getLine(i);
            if ((this || _global).startRegionRe.test(r)) return this.getCommentRegionBlock(e, r, i);
            var o = r.match((this || _global).foldingStartMarker);

            if (o) {
              var s = o.index;
              if (o[1]) return this.openingBracketBlock(e, o[1], i, s);
              var a = e.getCommentFoldRange(i, s + o[0].length, 1);
              return a && !a.isMultiLine() && (n ? a = this.getSectionRange(e, i) : "all" != t && (a = null)), a;
            }

            if ("markbegin" !== t) return (o = r.match((this || _global).foldingStopMarker)) ? (s = o.index + o[0].length, o[1] ? this.closingBracketBlock(e, o[1], i, s) : e.getCommentFoldRange(i, s, -1)) : void 0;
          }, (this || _global).getSectionRange = function (e, t) {
            for (var i = (a = e.getLine(t)).search(/\S/), n = t, r = a.length, o = t += 1, s = e.getLength(); ++t < s;) {
              var a,
                  l = (a = e.getLine(t)).search(/\S/);

              if (-1 !== l) {
                if (l < i) break;
                var c = this.getFoldWidgetRange(e, "all", t);

                if (c) {
                  if (c.start.row <= n) break;
                  if (c.isMultiLine()) t = c.end.row;else if (i == l) break;
                }

                o = t;
              }
            }

            return new h(n, r, o, e.getLine(o).length);
          }, (this || _global).getCommentRegionBlock = function (e, t, i) {
            for (var n = t.search(/\s*$/), r = e.getLength(), o = i, s = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/, a = 1; ++i < r;) {
              t = e.getLine(i);
              var l = s.exec(t);
              if (l && (l[1] ? a-- : a++, !a)) break;
            }

            if (o < i) return new h(o, n, i, t.length);
          };
        }.call(t.prototype);
      }), ace.define("ace/mode/json", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/json_highlight_rules", "ace/mode/matching_brace_outdent", "ace/mode/behaviour/cstyle", "ace/mode/folding/cstyle", "ace/worker/worker_client"], function (e, t, i) {
        "use strict";

        function n() {
          (this || _global).HighlightRules = s, (this || _global).$outdent = new a(), (this || _global).$behaviour = new l(), (this || _global).foldingRules = new c();
        }

        var r = e("../lib/oop"),
            o = e("./text").Mode,
            s = e("./json_highlight_rules").JsonHighlightRules,
            a = e("./matching_brace_outdent").MatchingBraceOutdent,
            l = e("./behaviour/cstyle").CstyleBehaviour,
            c = e("./folding/cstyle").FoldMode,
            h = e("../worker/worker_client").WorkerClient;
        r.inherits(n, o), function () {
          (this || _global).lineCommentStart = "//", (this || _global).blockComment = {
            start: "/*",
            end: "*/"
          }, (this || _global).getNextLineIndent = function (e, t, i) {
            var n = this.$getIndent(t);
            return "start" == e && t.match(/^.*[\{\(\[]\s*$/) && (n += i), n;
          }, (this || _global).checkOutdent = function (e, t, i) {
            return (this || _global).$outdent.checkOutdent(t, i);
          }, (this || _global).autoOutdent = function (e, t, i) {
            (this || _global).$outdent.autoOutdent(t, i);
          }, (this || _global).createWorker = function (t) {
            var e = new h(["ace"], "ace/mode/json_worker", "JsonWorker");
            return e.attachToDocument(t.getDocument()), e.on("annotate", function (e) {
              t.setAnnotations(e.data);
            }), e.on("terminate", function () {
              t.clearAnnotations();
            }), e;
          }, (this || _global).$id = "ace/mode/json";
        }.call(n.prototype), t.Mode = n;
      }), ace.require(["ace/mode/json"], function (e) {
        t && (t.exports = e);
      });
    },
    8903: function (e, t, g) {
      "use strict";

      var s = g(5689),
          l = g(3969),
          p = g(5255),
          c = g(4293),
          m = g(3508),
          f = g(3368),
          C = g(742),
          I = g(9394),
          v = g(3724),
          e = ((e.exports = w).prototype.validate = function (e, t) {
        var i;

        if ("string" == typeof e) {
          if (!(i = this.getSchema(e))) throw new Error("no schema with key or ref \"" + e + "\"");
        } else {
          e = this._addSchema(e);
          i = e.validate || this._compile(e);
        }

        e = i(t);
        !0 !== i.$async && ((this || _global).errors = i.errors);
        return e;
      }, w.prototype.compile = function (e, t) {
        e = this._addSchema(e, void 0, t);
        return e.validate || this._compile(e);
      }, w.prototype.addSchema = function (e, t, i, n) {
        if (Array.isArray(e)) {
          for (var r = 0; r < e.length; r++) this.addSchema(e[r], void 0, i, n);

          return this || _global;
        }

        var o = this._getId(e);

        if (void 0 !== o && "string" != typeof o) throw new Error("schema id must be string");
        return h(this || _global, t = l.normalizeId(t || o)), (this || _global)._schemas[t] = this._addSchema(e, i, n, !0), this || _global;
      }, w.prototype.addMetaSchema = function (e, t, i) {
        return this.addSchema(e, t, i, !0), this || _global;
      }, w.prototype.validateSchema = function (e, t) {
        var i = e.$schema;
        if (void 0 !== i && "string" != typeof i) throw new Error("$schema must be a string");
        if (!(i = i || (this || _global)._opts.defaultMeta || function (e) {
          var t = e._opts.meta;
          return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(A) ? A : void 0, e._opts.defaultMeta;
        }(this || _global))) return (this || _global).logger.warn("meta-schema not available"), !((this || _global).errors = null);
        i = this.validate(i, e);

        if (!i && t) {
          e = "schema is invalid: " + this.errorsText();
          if ("log" != (this || _global)._opts.validateSchema) throw new Error(e);

          (this || _global).logger.error(e);
        }

        return i;
      }, w.prototype.getSchema = function (e) {
        var t = i(this || _global, e);

        switch (typeof t) {
          case "object":
            return t.validate || this._compile(t);

          case "string":
            return this.getSchema(t);

          case "undefined":
            return function (e, t) {
              var i = l.schema.call(e, {
                schema: {}
              }, t);
              {
                var n, r, o;
                if (i) return n = i.schema, r = i.root, i = i.baseId, o = s.call(e, n, r, void 0, i), e._fragments[t] = new c({
                  ref: t,
                  fragment: !0,
                  schema: n,
                  root: r,
                  baseId: i,
                  validate: o
                }), o;
              }
            }(this || _global, e);
        }
      }, w.prototype.removeSchema = function (e) {
        if (e instanceof RegExp) return n(this || _global, (this || _global)._schemas, e), n(this || _global, (this || _global)._refs, e), this || _global;

        switch (typeof e) {
          case "undefined":
            return n(this || _global, (this || _global)._schemas), n(this || _global, (this || _global)._refs), (this || _global)._cache.clear(), this || _global;

          case "string":
            var t = i(this || _global, e);
            return t && (this || _global)._cache.del(t.cacheKey), delete (this || _global)._schemas[e], delete (this || _global)._refs[e], this || _global;

          case "object":
            t = (this || _global)._opts.serialize, t = t ? t(e) : e, t = ((this || _global)._cache.del(t), this._getId(e));
            t && (t = l.normalizeId(t), delete (this || _global)._schemas[t], delete (this || _global)._refs[t]);
        }

        return this || _global;
      }, w.prototype.addFormat = function (e, t) {
        "string" == typeof t && (t = new RegExp(t));
        return (this || _global)._formats[e] = t, this || _global;
      }, w.prototype.errorsText = function (e, t) {
        if (!(e = e || (this || _global).errors)) return "No errors";

        for (var i = void 0 === (t = t || {}).separator ? ", " : t.separator, n = void 0 === t.dataVar ? "data" : t.dataVar, r = "", o = 0; o < e.length; o++) {
          var s = e[o];
          s && (r += n + s.dataPath + " " + s.message + i);
        }

        return r.slice(0, -i.length);
      }, w.prototype._addSchema = function (e, t, i, n) {
        if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");

        var r = (this || _global)._opts.serialize,
            r = r ? r(e) : e,
            o = (this || _global)._cache.get(r);

        if (o) return o;
        n = n || !1 !== (this || _global)._opts.addUsedSchema;
        o = l.normalizeId(this._getId(e));
        o && n && h(this || _global, o);
        var s,
            t = !1 !== (this || _global)._opts.validateSchema && !t;
        t && !(s = o && o == l.normalizeId(e.$schema)) && this.validateSchema(e, !0);
        var a = l.ids.call(this || _global, e),
            a = new c({
          id: o,
          schema: e,
          localRefs: a,
          cacheKey: r,
          meta: i
        });
        "#" != o[0] && n && ((this || _global)._refs[o] = a);
        (this || _global)._cache.put(r, a), t && s && this.validateSchema(e, !0);
        return a;
      }, w.prototype._compile = function (i, e) {
        if (i.compiling) return (i.validate = r).schema = i.schema, r.errors = null, r.root = e || r, !0 === i.schema.$async && (r.$async = !0), r;
        var t, n;
        i.compiling = !0, i.meta && (t = (this || _global)._opts, (this || _global)._opts = (this || _global)._metaOpts);

        try {
          n = s.call(this || _global, i.schema, e, i.localRefs);
        } catch (e) {
          throw delete i.validate, e;
        } finally {
          i.compiling = !1, i.meta && ((this || _global)._opts = t);
        }

        return i.validate = n, i.refs = n.refs, i.refVal = n.refVal, i.root = n.root, n;

        function r() {
          var e = i.validate,
              t = e.apply(this || _global, arguments);
          return r.errors = e.errors, t;
        }
      }, w.prototype.compileAsync = g(9677), g(7931)),
          e = (w.prototype.addKeyword = e.add, w.prototype.getKeyword = e.get, w.prototype.removeKeyword = e.remove, w.prototype.validateKeyword = e.validate, g(5359)),
          A = (w.ValidationError = e.Validation, w.MissingRefError = e.MissingRef, w.$dataMetaSchema = I, "http://json-schema.org/draft-07/schema"),
          b = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"],
          y = ["/properties"];

      function w(e) {
        if (!((this || _global) instanceof w)) return new w(e);
        e = (this || _global)._opts = v.copy(e) || {};
        var t = this || _global,
            i = t._opts.logger;
        if (!1 === i) t.logger = {
          log: E,
          warn: E,
          error: E
        };else {
          if (!("object" == typeof (i = void 0 === i ? console : i) && i.log && i.warn && i.error)) throw new Error("logger must implement log, warn and error methods");
          t.logger = i;
        }

        if ((this || _global)._schemas = {}, (this || _global)._refs = {}, (this || _global)._fragments = {}, (this || _global)._formats = f(e.format), (this || _global)._cache = e.cache || new p(), (this || _global)._loadingSchemas = {}, (this || _global)._compilations = [], (this || _global).RULES = C(), (this || _global)._getId = function (e) {
          switch (e.schemaId) {
            case "auto":
              return k;

            case "id":
              return S;

            default:
              return x;
          }
        }(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = m), (this || _global)._metaOpts = function (e) {
          for (var t = v.copy(e._opts), i = 0; i < b.length; i++) delete t[b[i]];

          return t;
        }(this || _global), e.formats) {
          var n,
              r = this || _global;

          for (n in r._opts.formats) {
            var o = r._opts.formats[n];
            r.addFormat(n, o);
          }
        }

        if (e.keywords) {
          var s,
              a = this || _global;

          for (s in a._opts.keywords) {
            var l = a._opts.keywords[s];
            a.addKeyword(s, l);
          }
        }

        var c,
            t = this || _global,
            h = (t._opts.$data && (c = g(894), t.addMetaSchema(c, c.$id, !0)), !1 !== t._opts.meta && (c = g(6680), t._opts.$data && (c = I(c, y)), t.addMetaSchema(c, A, !0), t._refs["http://json-schema.org/schema"] = A), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
          metaSchema: {
            type: "boolean"
          }
        }), this || _global),
            d = h._opts.schemas;
        if (d) if (Array.isArray(d)) h.addSchema(d);else for (var u in d) h.addSchema(d[u], u);
      }

      function i(e, t) {
        return t = l.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
      }

      function n(e, t, i) {
        for (var n in t) {
          var r = t[n];
          r.meta || i && !i.test(n) || (e._cache.del(r.cacheKey), delete t[n]);
        }
      }

      function S(e) {
        return e.$id && (this || _global).logger.warn("schema $id ignored", e.$id), e.id;
      }

      function x(e) {
        return e.id && (this || _global).logger.warn("schema id ignored", e.id), e.$id;
      }

      function k(e) {
        if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
        return e.$id || e.id;
      }

      function h(e, t) {
        if (e._schemas[t] || e._refs[t]) throw new Error("schema with key or id \"" + t + "\" already exists");
      }

      function E() {}
    },
    5255: function (e) {
      "use strict";

      e = e.exports = function () {
        (this || _global)._cache = {};
      };

      e.prototype.put = function (e, t) {
        (this || _global)._cache[e] = t;
      }, e.prototype.get = function (e) {
        return (this || _global)._cache[e];
      }, e.prototype.del = function (e) {
        delete (this || _global)._cache[e];
      }, e.prototype.clear = function () {
        (this || _global)._cache = {};
      };
    },
    9677: function (e, t, i) {
      "use strict";

      var n = i(5359).MissingRef;

      function r(t, s, i) {
        var a = this || _global;
        if ("function" != typeof (this || _global)._opts.loadSchema) throw new Error("options.loadSchema should be a function");
        "function" == typeof s && (i = s, s = void 0);
        var e = l(t).then(function () {
          var e = a._addSchema(t, void 0, s);

          return e.validate || function r(o) {
            try {
              return a._compile(o);
            } catch (e) {
              if (e instanceof n) return t(e);
              throw e;
            }

            function t(e) {
              var t = e.missingSchema;
              if (n(t)) throw new Error("Schema " + t + " is loaded but " + e.missingRef + " cannot be resolved");
              e = a._loadingSchemas[t];
              return e || (e = a._loadingSchemas[t] = a._opts.loadSchema(t)).then(i, i), e.then(function (e) {
                if (!n(t)) return l(e).then(function () {
                  n(t) || a.addSchema(e, t, void 0, s);
                });
              }).then(function () {
                return r(o);
              });

              function i() {
                delete a._loadingSchemas[t];
              }

              function n(e) {
                return a._refs[e] || a._schemas[e];
              }
            }
          }(e);
        });
        return i && e.then(function (e) {
          i(null, e);
        }, i), e;

        function l(e) {
          e = e.$schema;
          return e && !a.getSchema(e) ? r.call(a, {
            $ref: e
          }, !0) : Promise.resolve();
        }
      }

      e.exports = r;
    },
    5359: function (e, t, i) {
      "use strict";

      var n = i(3969);

      function r(e, t, i) {
        (this || _global).message = i || r.message(e, t), (this || _global).missingRef = n.url(e, t), (this || _global).missingSchema = n.normalizeId(n.fullPath((this || _global).missingRef));
      }

      function o(e) {
        return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e;
      }

      e.exports = {
        Validation: o(function (e) {
          (this || _global).message = "validation failed", (this || _global).errors = e, (this || _global).ajv = (this || _global).validation = !0;
        }),
        MissingRef: o(r)
      }, r.message = function (e, t) {
        return "can't resolve reference " + t + " from id " + e;
      };
    },
    3368: function (e, t, i) {
      "use strict";

      var n = i(3724),
          r = /^(\d\d\d\d)-(\d\d)-(\d\d)$/,
          o = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          s = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i,
          i = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
          a = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
          l = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
          c = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,
          h = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
          d = /^(?:\/(?:[^~/]|~0|~1)*)*$/,
          u = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
          g = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;

      function p(e) {
        return n.copy(p[e = "full" == e ? "full" : "fast"]);
      }

      function m(e) {
        e = e.match(r);
        if (!e) return !1;
        var t = +e[1],
            i = +e[2],
            e = +e[3];
        return 1 <= i && i <= 12 && 1 <= e && e <= (2 != i || (e = t) % 4 != 0 || e % 100 == 0 && e % 400 != 0 ? o[i] : 29);
      }

      function f(e, t) {
        e = e.match(s);
        if (!e) return !1;
        var i = e[1],
            n = e[2],
            r = e[3],
            e = e[5];
        return (i <= 23 && n <= 59 && r <= 59 || 23 == i && 59 == n && 60 == r) && (!t || e);
      }

      (e.exports = p).fast = {
        date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
        time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
        "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
        uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
        "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
        "uri-template": l,
        url: c,
        email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
        hostname: i,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: A,
        uuid: h,
        "json-pointer": d,
        "json-pointer-uri-fragment": u,
        "relative-json-pointer": g
      }, p.full = {
        date: m,
        time: f,
        "date-time": function (e) {
          e = e.split(C);
          return 2 == e.length && m(e[0]) && f(e[1], !0);
        },
        uri: function (e) {
          return I.test(e) && a.test(e);
        },
        "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
        "uri-template": l,
        url: c,
        email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
        hostname: i,
        ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
        ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
        regex: A,
        uuid: h,
        "json-pointer": d,
        "json-pointer-uri-fragment": u,
        "relative-json-pointer": g
      };
      var C = /t|\s/i;
      var I = /\/|:/;
      var v = /[^\\]\\Z/;

      function A(e) {
        if (v.test(e)) return !1;

        try {
          return new RegExp(e), !0;
        } catch (e) {
          return !1;
        }
      }
    },
    5689: function (e, t, i) {
      "use strict";

      var E = i(3969),
          R = i(3724),
          T = i(5359),
          _ = i(3508),
          $ = i(1869),
          L = R.ucs2length,
          B = i(2303),
          W = T.Validation;

      function N(e, s, a, t) {
        var l = this || _global,
            c = (this || _global)._opts,
            h = [void 0],
            d = {},
            u = [],
            i = {},
            g = [],
            n = {},
            p = [],
            r = (s = s || {
          schema: e,
          refVal: h,
          refs: d
        }, function (e, t, i) {
          var n = G.call(this || _global, e, t, i);
          return 0 <= n ? {
            index: n,
            compiling: !0
          } : (n = (this || _global)._compilations.length, (this || _global)._compilations[n] = {
            schema: e,
            root: t,
            baseId: i
          }, {
            index: n,
            compiling: !1
          });
        }.call(this || _global, e, s, t)),
            o = (this || _global)._compilations[r.index];
        if (r.compiling) return o.callValidate = v;
        var m = (this || _global)._formats,
            f = (this || _global).RULES;

        try {
          var C = A(e, s, a, t),
              I = (o.validate = C, o.callValidate);
          return I && (I.schema = C.schema, I.errors = null, I.refs = C.refs, I.refVal = C.refVal, I.root = C.root, I.$async = C.$async, c.sourceCode && (I.source = C.source)), C;
        } finally {
          !function (e, t, i) {
            e = G.call(this || _global, e, t, i);
            0 <= e && (this || _global)._compilations.splice(e, 1);
          }.call(this || _global, e, s, t);
        }

        function v() {
          var e = o.validate,
              t = e.apply(this || _global, arguments);
          return v.errors = e.errors, t;
        }

        function A(e, t, i, n) {
          var r = !t || t.schema == e;
          if (t.schema != s.schema) return N.call(l, e, t, i, n);
          i = !0 === e.$async, n = $({
            isTop: !0,
            schema: e,
            isRoot: r,
            baseId: n,
            root: t,
            schemaPath: "",
            errSchemaPath: "#",
            errorPath: "\"\"",
            MissingRefError: T.MissingRef,
            RULES: f,
            validate: $,
            util: R,
            resolve: E,
            resolveRef: b,
            usePattern: S,
            useDefault: x,
            useCustomRule: k,
            opts: c,
            formats: m,
            logger: l.logger,
            self: l
          }), n = Z(h, H) + Z(u, P) + Z(g, F) + Z(p, V) + n;
          c.processCode && (n = c.processCode(n, e));

          try {
            var o = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", n)(l, f, m, s, h, g, p, B, L, W);
            h[0] = o;
          } catch (e) {
            throw l.logger.error("Error compiling schema, function code:", n), e;
          }

          return o.schema = e, o.errors = null, o.refs = d, o.refVal = h, o.root = r ? o : t, i && (o.$async = !0), !0 === c.sourceCode && (o.source = {
            code: n,
            patterns: u,
            defaults: g
          }), o;
        }

        function b(e, t, i) {
          t = E.url(e, t);
          var n = d[t];
          if (void 0 !== n) return w(r = h[n], o = "refVal[" + n + "]");

          if (!i && s.refs) {
            n = s.refs[t];
            if (void 0 !== n) return w(r = s.refVal[n], o = y(t, r));
          }

          var r,
              o = y(t),
              i = E.call(l, A, s, t);
          if (void 0 !== i || (n = a && a[t]) && (i = E.inlineRef(n, c.inlineRefs) ? n : N.call(l, n, s, a, e)), void 0 !== i) return r = i, n = d[n = t], h[n] = r, w(i, o);
          delete d[t];
        }

        function y(e, t) {
          var i = h.length;
          return h[i] = t, "refVal" + (d[e] = i);
        }

        function w(e, t) {
          return "object" == typeof e || "boolean" == typeof e ? {
            code: t,
            schema: e,
            inline: !0
          } : {
            code: t,
            $async: e && !!e.$async
          };
        }

        function S(e) {
          var t = i[e];
          return void 0 === t && (t = i[e] = u.length, u[t] = e), "pattern" + t;
        }

        function x(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
              return "" + e;

            case "string":
              return R.toQuotedString(e);

            case "object":
              if (null === e) return "null";

              var t = _(e),
                  i = n[t];

              return void 0 === i && (i = n[t] = g.length, g[i] = e), "default" + i;
          }
        }

        function k(e, t, i, n) {
          if (!1 !== l._opts.validateSchema) {
            var r = e.definition.dependencies;
            if (r && !r.every(function (e) {
              return Object.prototype.hasOwnProperty.call(i, e);
            })) throw new Error("parent schema must have all required keywords: " + r.join(","));
            r = e.definition.validateSchema;
            if (r) if (!r(t)) {
              r = "keyword schema is invalid: " + l.errorsText(r.errors);
              if ("log" != l._opts.validateSchema) throw new Error(r);
              l.logger.error(r);
            }
          }

          var o,
              r = e.definition.compile,
              s = e.definition.inline,
              a = e.definition.macro;
          if (r) o = r.call(l, t, i, n);else if (a) o = a.call(l, t, i, n), !1 !== c.validateSchema && l.validateSchema(o, !0);else if (s) o = s.call(l, n, e.keyword, t, i);else if (!(o = e.definition.validate)) return;
          if (void 0 === o) throw new Error("custom keyword \"" + e.keyword + "\"failed to compile");
          r = p.length;
          return {
            code: "customRule" + r,
            validate: p[r] = o
          };
        }
      }

      function G(e, t, i) {
        for (var n = 0; n < (this || _global)._compilations.length; n++) {
          var r = (this || _global)._compilations[n];
          if (r.schema == e && r.root == t && r.baseId == i) return n;
        }

        return -1;
      }

      function P(e, t) {
        return "var pattern" + e + " = new RegExp(" + R.toQuotedString(t[e]) + ");";
      }

      function F(e) {
        return "var default" + e + " = defaults[" + e + "];";
      }

      function H(e, t) {
        return void 0 === t[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
      }

      function V(e) {
        return "var customRule" + e + " = customRules[" + e + "];";
      }

      function Z(e, t) {
        if (!e.length) return "";

        for (var i = "", n = 0; n < e.length; n++) i += t(n, e);

        return i;
      }

      e.exports = N;
    },
    3969: function (e, t, i) {
      "use strict";

      var g = i(7533),
          p = i(2303),
          m = i(3724),
          a = i(4293),
          n = i(500);

      function l(e, t, i) {
        var n = (this || _global)._refs[i];

        if ("string" == typeof n) {
          if (!(this || _global)._refs[n]) return l.call(this || _global, e, t, n);
          n = (this || _global)._refs[n];
        }

        if ((n = n || (this || _global)._schemas[i]) instanceof a) return u(n.schema, (this || _global)._opts.inlineRefs) ? n.schema : n.validate || this._compile(n);
        var r,
            o,
            s,
            n = c.call(this || _global, t, i);
        return n && (r = n.schema, t = n.root, s = n.baseId), r instanceof a ? o = r.validate || e.call(this || _global, r.schema, t, void 0, s) : void 0 !== r && (o = u(r, (this || _global)._opts.inlineRefs) ? r : e.call(this || _global, r, t, void 0, s)), o;
      }

      function c(e, t) {
        var i = g.parse(t),
            n = C(i),
            r = f(this._getId(e.schema));

        if (0 === Object.keys(e.schema).length || n !== r) {
          var n = I(n),
              o = (this || _global)._refs[n];
          if ("string" == typeof o) return function (e, t, i) {
            t = c.call(this || _global, e, t);
            {
              var n, r;
              if (t) return n = t.schema, r = t.baseId, e = t.root, (t = this._getId(n)) && (r = v(r, t)), s.call(this || _global, i, r, n, e);
            }
          }.call(this || _global, e, o, i);
          if (o instanceof a) o.validate || this._compile(o), e = o;else {
            if (!((o = (this || _global)._schemas[n]) instanceof a)) return;
            if (o.validate || this._compile(o), n == I(t)) return {
              schema: o,
              root: e,
              baseId: r
            };
            e = o;
          }
          if (!e.schema) return;
          r = f(this._getId(e.schema));
        }

        return s.call(this || _global, i, r, e.schema, e);
      }

      (e.exports = l).normalizeId = I, l.fullPath = f, l.url = v, l.ids = function (e) {
        var t = I(this._getId(e)),
            c = {
          "": t
        },
            h = {
          "": f(t, !1)
        },
            d = {},
            u = this || _global;
        return n(e, {
          allKeys: !0
        }, function (e, t, i, n, r, o, s) {
          if ("" !== t) {
            var a = u._getId(e),
                l = c[n],
                n = h[n] + "/" + r;

            if (void 0 !== s && (n += "/" + ("number" == typeof s ? s : m.escapeFragment(s))), "string" == typeof a) {
              a = l = I(l ? g.resolve(l, a) : a), r = u._refs[a];

              if ((r = "string" == typeof r ? u._refs[r] : r) && r.schema) {
                if (!p(e, r.schema)) throw new Error("id \"" + a + "\" resolves to more than one schema");
              } else if (a != I(n)) if ("#" == a[0]) {
                if (d[a] && !p(e, d[a])) throw new Error("id \"" + a + "\" resolves to more than one schema");
                d[a] = e;
              } else u._refs[a] = n;
            }

            c[t] = l, h[t] = n;
          }
        }), d;
      }, l.inlineRef = u, l.schema = c;
      var h = m.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);

      function s(e, t, i, n) {
        if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
          for (var r = e.fragment.split("/"), o = 1; o < r.length; o++) {
            var s = r[o];

            if (s) {
              if (void 0 === (i = i[s = m.unescapeFragment(s)])) break;
              h[s] || ((s = this._getId(i)) && (t = v(t, s)), i.$ref && (s = v(t, i.$ref), (s = c.call(this || _global, n, s)) && (i = s.schema, n = s.root, t = s.baseId)));
            }
          }

          return void 0 !== i && i !== n.schema ? {
            schema: i,
            root: n,
            baseId: t
          } : void 0;
        }
      }

      var d = m.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);

      function u(e, t) {
        return !1 !== t && (void 0 === t || !0 === t ? function e(t) {
          var i;

          if (Array.isArray(t)) {
            for (var n = 0; n < t.length; n++) if ("object" == typeof (i = t[n]) && !e(i)) return !1;
          } else for (var r in t) {
            if ("$ref" == r) return !1;
            if ("object" == typeof (i = t[r]) && !e(i)) return !1;
          }

          return !0;
        }(e) : t ? function e(t) {
          var i,
              n = 0;

          if (Array.isArray(t)) {
            for (var r = 0; r < t.length; r++) if ("object" == typeof (i = t[r]) && (n += e(i)), n == 1 / 0) return 1 / 0;
          } else for (var o in t) {
            if ("$ref" == o) return 1 / 0;
            if (d[o]) n++;else if ("object" == typeof (i = t[o]) && (n += e(i) + 1), n == 1 / 0) return 1 / 0;
          }

          return n;
        }(e) <= t : void 0);
      }

      function f(e, t) {
        return !1 !== t && (e = I(e)), C(g.parse(e));
      }

      function C(e) {
        return g.serialize(e).split("#")[0] + "#";
      }

      var r = /#\/?$/;

      function I(e) {
        return e ? e.replace(r, "") : "";
      }

      function v(e, t) {
        return t = I(t), g.resolve(e, t);
      }
    },
    742: function (e, t, i) {
      "use strict";

      var o = i(9646),
          s = i(3724).toHash;

      e.exports = function () {
        var n = [{
          type: "number",
          rules: [{
            maximum: ["exclusiveMaximum"]
          }, {
            minimum: ["exclusiveMinimum"]
          }, "multipleOf", "format"]
        }, {
          type: "string",
          rules: ["maxLength", "minLength", "pattern", "format"]
        }, {
          type: "array",
          rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
        }, {
          type: "object",
          rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", {
            properties: ["additionalProperties", "patternProperties"]
          }]
        }, {
          rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"]
        }],
            r = ["type", "$comment"];
        return n.all = s(r), n.types = s(["number", "integer", "string", "array", "object", "boolean", "null"]), n.forEach(function (e) {
          e.rules = e.rules.map(function (e) {
            var t, i;
            return "object" == typeof e && (i = e[t = Object.keys(e)[0]], e = t, i.forEach(function (e) {
              r.push(e), n.all[e] = !0;
            })), r.push(e), n.all[e] = {
              keyword: e,
              code: o[e],
              implements: i
            };
          }), n.all.$comment = {
            keyword: "$comment",
            code: o.$comment
          }, e.type && (n.types[e.type] = e);
        }), n.keywords = s(r.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), n.custom = {}, n;
      };
    },
    4293: function (e, t, i) {
      "use strict";

      var n = i(3724);

      e.exports = function (e) {
        n.copy(e, this || _global);
      };
    },
    6887: function (e) {
      "use strict";

      e.exports = function (e) {
        for (var t, i = 0, n = e.length, r = 0; r < n;) i++, 55296 <= (t = e.charCodeAt(r++)) && t <= 56319 && r < n && 56320 == (64512 & (t = e.charCodeAt(r))) && r++;

        return i;
      };
    },
    3724: function (e, t, i) {
      "use strict";

      function o(e, t, i, n) {
        var r = n ? " !== " : " === ",
            o = n ? " || " : " && ",
            s = n ? "!" : "",
            a = n ? "" : "!";

        switch (e) {
          case "null":
            return t + r + "null";

          case "array":
            return s + "Array.isArray(" + t + ")";

          case "object":
            return "(" + s + t + o + "typeof " + t + r + "\"object\"" + o + a + "Array.isArray(" + t + "))";

          case "integer":
            return "(typeof " + t + r + "\"number\"" + o + a + "(" + t + " % 1)" + o + t + r + t + (i ? o + s + "isFinite(" + t + ")" : "") + ")";

          case "number":
            return "(typeof " + t + r + "\"" + e + "\"" + (i ? o + s + "isFinite(" + t + ")" : "") + ")";

          default:
            return "typeof " + t + r + "\"" + e + "\"";
        }
      }

      e.exports = {
        copy: function (e, t) {
          for (var i in t = t || {}, e) t[i] = e[i];

          return t;
        },
        checkDataType: o,
        checkDataTypes: function (e, t, i) {
          {
            if (1 === e.length) return o(e[0], t, i, !0);
            var n,
                r = "",
                e = a(e);

            for (n in e.array && e.object && (r = e.null ? "(" : "(!" + t + " || ", r += "typeof " + t + " !== \"object\")", delete e.null, delete e.array, delete e.object), e.number && delete e.integer, e) r += (r ? " && " : "") + o(n, t, i, !0);

            return r;
          }
        },
        coerceToTypes: function (e, t) {
          {
            if (!Array.isArray(t)) return s[t] ? [t] : "array" === e && "array" === t ? ["array"] : void 0;

            for (var i = [], n = 0; n < t.length; n++) {
              var r = t[n];
              (s[r] || "array" === e && "array" === r) && (i[i.length] = r);
            }

            if (i.length) return i;
          }
        },
        toHash: a,
        getProperty: h,
        escapeQuotes: l,
        equal: i(2303),
        ucs2length: i(6887),
        varOccurences: function (e, t) {
          t += "[^0-9]";
          e = e.match(new RegExp(t, "g"));
          return e ? e.length : 0;
        },
        varReplace: function (e, t, i) {
          return t += "([^0-9])", i = i.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), i + "$1");
        },
        schemaHasRules: function (e, t) {
          if ("boolean" == typeof e) return !e;

          for (var i in e) if (t[i]) return !0;
        },
        schemaHasRulesExcept: function (e, t, i) {
          if ("boolean" == typeof e) return !e && "not" != i;

          for (var n in e) if (n != i && t[n]) return !0;
        },
        schemaUnknownRules: function (e, t) {
          if ("boolean" != typeof e) for (var i in e) if (!t[i]) return i;
        },
        toQuotedString: c,
        getPathExpr: function (e, t, i, n) {
          return g(e, i ? "'/' + " + t + (n ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : n ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
        },
        getPath: function (e, t, i) {
          i = c(i ? "/" + p(t) : h(t));
          return g(e, i);
        },
        getData: function (e, t, i) {
          var n, r, o;
          if ("" === e) return "rootData";

          if ("/" == e[0]) {
            if (!d.test(e)) throw new Error("Invalid JSON-pointer: " + e);
            n = e, r = "rootData";
          } else {
            if (!(o = e.match(u))) throw new Error("Invalid JSON-pointer: " + e);

            if (e = +o[1], "#" == (n = o[2])) {
              if (t <= e) throw new Error("Cannot access property/index " + e + " levels up, current level is " + t);
              return i[t - e];
            }

            if (t < e) throw new Error("Cannot access data " + e + " levels up, current level is " + t);
            if (r = "data" + (t - e || ""), !n) return r;
          }

          for (var s = r, a = n.split("/"), l = 0; l < a.length; l++) {
            var c = a[l];
            c && (r += h(m(c)), s += " && " + r);
          }

          return s;
        },
        unescapeFragment: function (e) {
          return m(decodeURIComponent(e));
        },
        unescapeJsonPointer: m,
        escapeFragment: function (e) {
          return encodeURIComponent(p(e));
        },
        escapeJsonPointer: p
      };
      var s = a(["string", "number", "integer", "boolean", "null"]);

      function a(e) {
        for (var t = {}, i = 0; i < e.length; i++) t[e[i]] = !0;

        return t;
      }

      var n = /^[a-z$_][a-z$_0-9]*$/i,
          r = /'|\\/g;

      function h(e) {
        return "number" == typeof e ? "[" + e + "]" : n.test(e) ? "." + e : "['" + l(e) + "']";
      }

      function l(e) {
        return e.replace(r, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
      }

      function c(e) {
        return "'" + l(e) + "'";
      }

      var d = /^\/(?:[^~]|~0|~1)*$/,
          u = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;

      function g(e, t) {
        return "\"\"" == e ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
      }

      function p(e) {
        return e.replace(/~/g, "~0").replace(/\//g, "~1");
      }

      function m(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
      }
    },
    9394: function (e) {
      "use strict";

      var l = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"];

      e.exports = function (e, t) {
        for (var i = 0; i < t.length; i++) {
          e = JSON.parse(JSON.stringify(e));

          for (var n = t[i].split("/"), r = e, o = 1; o < n.length; o++) r = r[n[o]];

          for (o = 0; o < l.length; o++) {
            var s = l[o],
                a = r[s];
            a && (r[s] = {
              anyOf: [a, {
                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
              }]
            });
          }
        }

        return e;
      };
    },
    5868: function (e, t, i) {
      "use strict";

      i = i(6680);
      e.exports = {
        $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
        definitions: {
          simpleTypes: i.definitions.simpleTypes
        },
        type: "object",
        dependencies: {
          schema: ["validate"],
          $data: ["validate"],
          statements: ["inline"],
          valid: {
            not: {
              required: ["macro"]
            }
          }
        },
        properties: {
          type: i.properties.type,
          schema: {
            type: "boolean"
          },
          statements: {
            type: "boolean"
          },
          dependencies: {
            type: "array",
            items: {
              type: "string"
            }
          },
          metaSchema: {
            type: "object"
          },
          modifying: {
            type: "boolean"
          },
          valid: {
            type: "boolean"
          },
          $data: {
            type: "boolean"
          },
          async: {
            type: "boolean"
          },
          errors: {
            anyOf: [{
              type: "boolean"
            }, {
              const: "full"
            }]
          }
        }
      };
    },
    1796: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r,
            o,
            s,
            a,
            l = " ",
            c = e.level,
            h = e.dataLevel,
            d = e.schema[t],
            u = e.schemaPath + e.util.getProperty(t),
            g = e.errSchemaPath + "/" + t,
            p = !e.opts.allErrors,
            m = "data" + (h || ""),
            f = e.opts.$data && d && d.$data,
            C = f ? (l += " var schema" + c + " = " + e.util.getData(d.$data, h, e.dataPathArr) + "; ", "schema" + c) : d,
            I = "maximum" == t,
            v = I ? "exclusiveMaximum" : "exclusiveMinimum",
            A = e.schema[v],
            b = e.opts.$data && A && A.$data,
            y = I ? "<" : ">",
            w = I ? ">" : "<",
            S = void 0;
        if (!f && "number" != typeof d && void 0 !== d) throw new Error(t + " must be number");
        if (!b && void 0 !== A && "number" != typeof A && "boolean" != typeof A) throw new Error(v + " must be number or boolean");
        b ? (h = e.util.getData(A.$data, h, e.dataPathArr), o = "exclIsNumber" + c, s = "' + " + (a = "op" + c) + " + '", S = v, (x = x || []).push(l = l + (" var schemaExcl" + c + " = " + h + "; ") + (" var " + (n = "exclusive" + c) + "; var " + (r = "exclType" + c) + " = typeof " + (h = "schemaExcl" + c) + "; if (" + r + " != 'boolean' && " + r + " != 'undefined' && " + r + " != 'number') { ")), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: {} ", !1 !== e.opts.messages && (l += " , message: '" + v + " should be boolean' "), e.opts.verbose && (l += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ", k = l, l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } else if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + r + " == 'number' ? ( (" + n + " = " + C + " === undefined || " + h + " " + y + "= " + C + ") ? " + m + " " + w + "= " + h + " : " + m + " " + w + " " + C + " ) : ( (" + n + " = " + h + " === true) ? " + m + " " + w + "= " + C + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { var op" + c + " = " + n + " ? '" + y + "' : '" + y + "='; ", void 0 === d && (g = e.errSchemaPath + "/" + (S = v), C = h, f = b)) : (s = y, (o = "number" == typeof A) && f ? (a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " ( " + C + " === undefined || " + A + " " + y + "= " + C + " ? " + m + " " + w + "= " + A + " : " + m + " " + w + " " + C + " ) || " + m + " !== " + m + ") { ") : (o && void 0 === d ? (n = !0, g = e.errSchemaPath + "/" + (S = v), C = A, w += "=") : (o && (C = Math[I ? "min" : "max"](A, d)), A === (!o || C) ? (n = !0, g = e.errSchemaPath + "/" + (S = v), w += "=") : (n = !1, s += "=")), a = "'" + s + "'", l += " if ( ", f && (l += " (" + C + " !== undefined && typeof " + C + " != 'number') || "), l += " " + m + " " + w + " " + C + " || " + m + " !== " + m + ") { ")), S = S || t;
        (x = x || []).push(l), l = "", !1 !== e.createErrors ? (l += " { keyword: '" + (S || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(g) + " , params: { comparison: " + a + ", limit: " + C + ", exclusive: " + n + " } ", !1 !== e.opts.messages && (l = l + " , message: 'should be " + s + " " + (f ? "' + " + C : C + "'")), e.opts.verbose && (l = (l += " , schema:  ") + (f ? "validate.schema" + u : "" + d) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), l += " } ") : l += " {} ";
        var x,
            k = l;
        return l = x.pop(), !e.compositeRule && p ? e.async ? l += " throw new ValidationError([" + k + "]); " : l += " validate.errors = [" + k + "]; return false; " : l += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l += " } ", p && (l += " else { "), l;
      };
    },
    2407: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (o || ""),
            d = e.opts.$data && s && s.$data,
            o = d ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s;
        if (!d && "number" != typeof s) throw new Error(t + " must be number");
        n += "if ( ", d && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || ");
        var r = t,
            u = [],
            r = (u.push(n += " " + h + ".length " + ("maxItems" == t ? ">" : "<") + " " + o + ") { "), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (r || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n = (n = (n += " , message: 'should NOT have ") + ("maxItems" == t ? "more" : "fewer") + " than ") + (d ? "' + " + o + " + '" : "" + s) + " items' "), e.opts.verbose && (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", n),
            n = u.pop();
        return !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
      };
    },
    1250: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (o || ""),
            d = e.opts.$data && s && s.$data,
            o = d ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s;
        if (!d && "number" != typeof s) throw new Error(t + " must be number");
        n += "if ( ", d && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || "), !1 === e.opts.unicode ? n += " " + h + ".length " : n += " ucs2length(" + h + ") ";
        var r = t,
            u = [],
            r = (u.push(n += " " + ("maxLength" == t ? ">" : "<") + " " + o + ") { "), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (r || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n = (n = (n += " , message: 'should NOT be ") + ("maxLength" == t ? "longer" : "shorter") + " than ") + (d ? "' + " + o + " + '" : "" + s) + " characters' "), e.opts.verbose && (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", n),
            n = u.pop();
        return !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
      };
    },
    2596: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (o || ""),
            d = e.opts.$data && s && s.$data,
            o = d ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s;
        if (!d && "number" != typeof s) throw new Error(t + " must be number");
        n += "if ( ", d && (n += " (" + o + " !== undefined && typeof " + o + " != 'number') || ");
        var r = t,
            u = [],
            r = (u.push(n += " Object.keys(" + h + ").length " + ("maxProperties" == t ? ">" : "<") + " " + o + ") { "), n = "", !1 !== e.createErrors ? (n += " { keyword: '" + (r || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + o + " } ", !1 !== e.opts.messages && (n = (n = (n += " , message: 'should NOT have ") + ("maxProperties" == t ? "more" : "fewer") + " than ") + (d ? "' + " + o + " + '" : "" + s) + " properties' "), e.opts.verbose && (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", n),
            n = u.pop();
        return !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
      };
    },
    9486: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.schema[t],
            o = e.schemaPath + e.util.getProperty(t),
            s = e.errSchemaPath + "/" + t,
            a = !e.opts.allErrors,
            l = e.util.copy(e),
            c = "",
            h = (l.level++, "valid" + l.level),
            d = l.baseId,
            u = !0,
            g = r;
        if (g) for (var p, m = -1, f = g.length - 1; m < f;) p = g[m += 1], (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)) && (u = !1, l.schema = p, l.schemaPath = o + "[" + m + "]", l.errSchemaPath = s + "/" + m, n += "  " + e.validate(l) + " ", l.baseId = d, a && (n += " if (" + h + ") { ", c += "}"));
        return a && (n += u ? " if (true) { " : " " + c.slice(0, -1) + " "), n;
      };
    },
    5347: function (e) {
      "use strict";

      e.exports = function (t, e, i) {
        var n = " ",
            r = t.level,
            o = t.dataLevel,
            s = t.schema[e],
            a = t.schemaPath + t.util.getProperty(e),
            l = t.errSchemaPath + "/" + e,
            e = !t.opts.allErrors,
            o = "data" + (o || ""),
            c = "valid" + r,
            r = "errs__" + r,
            h = t.util.copy(t),
            d = "",
            u = (h.level++, "valid" + h.level);

        if (s.every(function (e) {
          return t.opts.strictKeywords ? "object" == typeof e && 0 < Object.keys(e).length || !1 === e : t.util.schemaHasRules(e, t.RULES.all);
        })) {
          var g = h.baseId,
              p = (n += " var " + r + " = errors; var " + c + " = false;  ", t.compositeRule),
              m = (t.compositeRule = h.compositeRule = !0, s);
          if (m) for (var f, C = -1, I = m.length - 1; C < I;) f = m[C += 1], h.schema = f, h.schemaPath = a + "[" + C + "]", h.errSchemaPath = l + "/" + C, n += "  " + t.validate(h) + " ", h.baseId = g, n += " " + c + " = " + c + " || " + u + "; if (!" + c + ") { ", d += "}";
          t.compositeRule = h.compositeRule = p, n += " " + d + " if (!" + c + ") {   var err =   ", !1 !== t.createErrors ? (n += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(l) + " , params: {} ", !1 !== t.opts.messages && (n += " , message: 'should match some schema in anyOf' "), t.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + o + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && e && (t.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += " } else {  errors = " + r + "; if (vErrors !== null) { if (" + r + ") vErrors.length = " + r + "; else vErrors = null; } ", t.opts.allErrors && (n += " } ");
        } else e && (n += " if (true) { ");

        return n;
      };
    },
    923: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.schema[t],
            t = e.errSchemaPath + "/" + t,
            r = (e.opts.allErrors, e.util.toQuotedString(r));
        return !0 === e.opts.$comment ? n += " console.log(" + r + ");" : "function" == typeof e.opts.$comment && (n += " self._opts.$comment(" + r + ", " + e.util.toQuotedString(t) + ", validate.root.schema);"), n;
      };
    },
    2617: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            c = "data" + (o || ""),
            h = "valid" + r,
            d = e.opts.$data && s && s.$data,
            s = (d && (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; "), d || (n += " var schema" + r + " = validate.schema" + a + ";"), []),
            o = (s.push(n += "var " + h + " = equal(" + c + ", schema" + r + "); if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValue: schema" + r + " } ", !1 !== e.opts.messages && (n += " , message: 'should be equal to constant' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n),
            n = s.pop();
        return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + o + "]); " : n += " validate.errors = [" + o + "]; return false; " : n += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
      };
    },
    2119: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            o = "data" + (o || ""),
            c = "valid" + r,
            h = "errs__" + r,
            d = e.util.copy(e),
            u = (d.level++, "valid" + d.level),
            r = "i" + r,
            g = d.dataLevel = e.dataLevel + 1,
            p = "data" + g,
            m = e.baseId,
            f = e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all),
            r = (n += "var " + h + " = errors;var " + c + ";", f ? (c = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.schema = s, d.schemaPath = a, d.errSchemaPath = t, n += " var " + u + " = false; for (var " + r + " = 0; " + r + " < " + o + ".length; " + r + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, r, e.opts.jsonPointers, !0), s = o + "[" + r + "]", d.dataPathArr[g] = r, g = e.validate(d), d.baseId = m, e.util.varOccurences(g, p) < 2 ? n += " " + e.util.varReplace(g, p, s) + " " : n += " var " + p + " = " + s + "; " + g + " ", n += " if (" + u + ") break; }  ", e.compositeRule = d.compositeRule = c, n += "  if (!" + u + ") {") : n += " if (" + o + ".length == 0) {", []),
            m = (r.push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (n += " , message: 'should contain a valid item' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + o + " "), n += " } ") : n += " {} ", n),
            n = r.pop();
        return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + m + "]); " : n += " validate.errors = [" + m + "]; return false; " : n += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ", f && (n += "  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; } "), e.opts.allErrors && (n += " } "), n;
      };
    },
    1793: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r,
            o,
            s = " ",
            a = e.level,
            l = e.dataLevel,
            c = e.schema[t],
            h = e.schemaPath + e.util.getProperty(t),
            d = e.errSchemaPath + "/" + t,
            u = !e.opts.allErrors,
            g = "data" + (l || ""),
            p = "valid" + a,
            m = "errs__" + a,
            f = e.opts.$data && c && c.$data,
            C = f ? (s += " var schema" + a + " = " + e.util.getData(c.$data, l, e.dataPathArr) + "; ", "schema" + a) : c,
            I = "definition" + a,
            v = (this || _global).definition,
            A = "";

        if (f && v.$data) {
          var b = "keywordValidate" + a,
              y = v.validateSchema;
          s += " var " + I + " = RULES.custom['" + t + "'].definition; var " + b + " = " + I + ".validate;";
        } else {
          if (!(k = e.useCustomRule(this || _global, c, e.schema, e))) return;
          C = "validate.schema" + h, b = k.code, n = v.compile, r = v.inline, o = v.macro;
        }

        var w,
            S,
            x,
            k,
            E,
            t = b + ".errors",
            c = "i" + a,
            R = "ruleErr" + a,
            T = v.async;
        if (T && !e.async) throw new Error("async keyword in sync schema");
        return r || o || (s += t + " = null;"), s += "var " + m + " = errors;var " + p + ";", f && v.$data && (A += "}", s += " if (" + C + " === undefined) { " + p + " = true; } else { ", y && (A += "}", s += " " + p + " = " + I + ".validateSchema(" + C + "); if (" + p + ") { ")), r ? v.statements ? s += " " + k.validate + " " : s += " " + p + " = " + k.validate + "; " : o ? (A = "", (f = e.util.copy(e)).level++, w = "valid" + f.level, f.schema = k.validate, f.schemaPath = "", y = e.compositeRule, e.compositeRule = f.compositeRule = !0, I = e.validate(f).replace(/validate\.schema/g, b), e.compositeRule = f.compositeRule = y, s += " " + I) : ((E = E || []).push(s), s = "", s += "  " + b + ".call( ", e.opts.passContext ? s += "this" : s += "self", n || !1 === v.schema ? s += " , " + g + " " : s += " , " + C + " , " + g + " , validate.schema" + e.schemaPath + " ", s += " , (dataPath || '')", "\"\"" != e.errorPath && (s += " + " + e.errorPath), k = s += " , " + (S = l ? "data" + (l - 1 || "") : "parentData") + " , " + (x = l ? e.dataPathArr[l] : "parentDataProperty") + " , rootData )  ", s = E.pop(), !1 === v.errors ? (s += " " + p + " = ", T && (s += "await "), s += k + "; ") : s += T ? " var " + (t = "customErrors" + a) + " = null; try { " + p + " = await " + k + "; } catch (e) { " + p + " = false; if (e instanceof ValidationError) " + t + " = e.errors; else throw e; } " : " " + t + " = null; " + p + " = " + k + "; "), v.modifying && (s += " if (" + S + ") " + g + " = " + S + "[" + x + "];"), s += "" + A, v.valid ? u && (s += " if (true) { ") : (s += " if ( ", void 0 === v.valid ? s = s + " !" + (o ? "" + w : p) : s += " " + !v.valid + " ", f = (this || _global).keyword, (E = E || []).push(s += ") { "), (E = E || []).push(s = ""), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + (this || _global).keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + (this || _global).keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", y = s, s = E.pop(), !e.compositeRule && u ? e.async ? s += " throw new ValidationError([" + y + "]); " : s += " validate.errors = [" + y + "]; return false; " : s += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", I = s, s = E.pop(), r ? v.errors ? "full" != v.errors && (s += "  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + R + " = vErrors[" + c + "]; if (" + R + ".dataPath === undefined) " + R + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + R + ".schemaPath === undefined) { " + R + ".schemaPath = \"" + d + "\"; } ", e.opts.verbose && (s += " " + R + ".schema = " + C + "; " + R + ".data = " + g + "; "), s += " } ") : !1 === v.errors ? s += " " + I + " " : (s += " if (" + m + " == errors) { " + I + " } else {  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + R + " = vErrors[" + c + "]; if (" + R + ".dataPath === undefined) " + R + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + R + ".schemaPath === undefined) { " + R + ".schemaPath = \"" + d + "\"; } ", e.opts.verbose && (s += " " + R + ".schema = " + C + "; " + R + ".data = " + g + "; "), s += " } } ") : o ? (s += "   var err =   ", !1 !== e.createErrors ? (s += " { keyword: '" + (f || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { keyword: '" + (this || _global).keyword + "' } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"" + (this || _global).keyword + "\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && u && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; ")) : !1 === v.errors ? s += " " + I + " " : (s += " if (Array.isArray(" + t + ")) { if (vErrors === null) vErrors = " + t + "; else vErrors = vErrors.concat(" + t + "); errors = vErrors.length;  for (var " + c + "=" + m + "; " + c + "<errors; " + c + "++) { var " + R + " = vErrors[" + c + "]; if (" + R + ".dataPath === undefined) " + R + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + R + ".schemaPath = \"" + d + "\";  ", e.opts.verbose && (s += " " + R + ".schema = " + C + "; " + R + ".data = " + g + "; "), s += " } } else { " + I + " } "), s += " } ", u && (s += " else { ")), s;
      };
    },
    9115: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r = " ",
            o = e.level,
            s = e.dataLevel,
            a = e.schema[t],
            l = e.schemaPath + e.util.getProperty(t),
            c = e.errSchemaPath + "/" + t,
            h = !e.opts.allErrors,
            d = "data" + (s || ""),
            t = "errs__" + o,
            u = e.util.copy(e),
            g = "",
            p = (u.level++, "valid" + u.level),
            m = {},
            f = {},
            C = e.opts.ownProperties;

        for ($ in a) "__proto__" != $ && (B = a[$], (n = Array.isArray(B) ? f : m)[$] = B);

        var I = e.errorPath;

        for ($ in r = r + ("var " + t + " = errors;") + ("var missing" + o + ";"), f) if ((n = f[$]).length) {
          if (r += " if ( " + d + e.util.getProperty($) + " !== undefined ", C && (r += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), h) {
            r += " && ( ";
            var v = n;
            if (v) for (var A = -1, b = v.length - 1; A < b;) k = v[A += 1], A && (r += " || "), r += " ( ( " + (_ = d + (T = e.util.getProperty(k))) + " === undefined ", C && (r += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), r += ") && (missing" + o + " = " + e.util.toQuotedString(e.opts.jsonPointers ? k : T) + ") ) ";
            r += ")) {  ";
            var y = "missing" + o,
                w = "' + " + y + " + '",
                S = (e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(I, y, !0) : I + " + " + y), S || []),
                y = (S.push(r), r = "", !1 !== e.createErrors ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + n.length + ", deps: '" + e.util.escapeQuotes(1 == n.length ? n[0] : n.join(", ")) + "' } ", !1 !== e.opts.messages && (r += " , message: 'should have ", 1 == n.length ? r += "property " + e.util.escapeQuotes(n[0]) : r += "properties " + e.util.escapeQuotes(n.join(", ")), r += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ") : r += " {} ", r),
                r = S.pop();
            !e.compositeRule && h ? e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
          } else {
            r += " ) { ";
            var x = n;
            if (x) for (var k, E = -1, R = x.length - 1; E < R;) {
              k = x[E += 1];

              var T = e.util.getProperty(k),
                  w = e.util.escapeQuotes(k),
                  _ = d + T;

              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(I, k, e.opts.jsonPointers)), r += " if ( " + _ + " === undefined ", C && (r += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(k) + "') "), r += ") {  var err =   ", !1 !== e.createErrors ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes($) + "', missingProperty: '" + w + "', depsCount: " + n.length + ", deps: '" + e.util.escapeQuotes(1 == n.length ? n[0] : n.join(", ")) + "' } ", !1 !== e.opts.messages && (r += " , message: 'should have ", 1 == n.length ? r += "property " + e.util.escapeQuotes(n[0]) : r += "properties " + e.util.escapeQuotes(n.join(", ")), r += " when property " + e.util.escapeQuotes($) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }

          r += " }   ", h && (g += "}", r += " else { ");
        }

        e.errorPath = I;
        var $,
            L = u.baseId;

        for ($ in m) {
          var B = m[$];
          (e.opts.strictKeywords ? "object" == typeof B && 0 < Object.keys(B).length || !1 === B : e.util.schemaHasRules(B, e.RULES.all)) && (r += " " + p + " = true; if ( " + d + e.util.getProperty($) + " !== undefined ", C && (r += " && Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes($) + "') "), r += ") { ", u.schema = B, u.schemaPath = l + e.util.getProperty($), u.errSchemaPath = c + "/" + e.util.escapeFragment($), r += "  " + e.validate(u) + " ", u.baseId = L, r += " }  ", h && (r += " if (" + p + ") { ", g += "}"));
        }

        return h && (r += "   " + g + " if (" + t + " == errors) {"), r;
      };
    },
    9317: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            c = "data" + (o || ""),
            h = "valid" + r,
            d = e.opts.$data && s && s.$data,
            s = (d && (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; "), "i" + r),
            o = "schema" + r,
            o = (d || (n += " var " + o + " = validate.schema" + a + ";"), n += "var " + h + ";", d && (n += " if (schema" + r + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + r + ")) " + h + " = false; else {"), n += h + " = false;for (var " + s + "=0; " + s + "<" + o + ".length; " + s + "++) if (equal(" + c + ", " + o + "[" + s + "])) { " + h + " = true; break; }", d && (n += "  }  "), []),
            s = (o.push(n += " if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { allowedValues: schema" + r + " } ", !1 !== e.opts.messages && (n += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n),
            n = o.pop();
        return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + s + "]); " : n += " validate.errors = [" + s + "]; return false; " : n += " var err = " + s + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " }", l && (n += " else { "), n;
      };
    },
    8327: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            c = "data" + (o || "");
        if (!1 === e.opts.format) return l && (n += " if (true) { "), n;
        var h,
            d = e.opts.$data && s && s.$data,
            o = d ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s,
            u = e.opts.unknownFormats,
            g = Array.isArray(u);
        if (d) n += " var " + (h = "format" + r) + " = formats[" + o + "]; var " + (p = "isObject" + r) + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + (f = "formatType" + r) + " = " + p + " && " + h + ".type || 'string'; if (" + p + ") { ", e.async && (n += " var async" + r + " = " + h + ".async; "), n += " " + h + " = " + h + ".validate; } if (  ", d && (n += " (" + o + " !== undefined && typeof " + o + " != 'string') || "), n += " (", "ignore" != u && (n += " (" + o + " && !" + h + " ", g && (n += " && self._opts.unknownFormats.indexOf(" + o + ") == -1 "), n += ") || "), n += " (" + h + " && " + f + " == '" + i + "' && !(typeof " + h + " == 'function' ? ", e.async ? n += " (async" + r + " ? await " + h + "(" + c + ") : " + h + "(" + c + ")) " : n += " " + h + "(" + c + ") ", n += " : " + h + ".test(" + c + "))))) {";else {
          if (!(h = e.formats[s])) {
            if ("ignore" == u) return e.logger.warn("unknown format \"" + s + "\" ignored in schema at path \"" + e.errSchemaPath + "\""), l && (n += " if (true) { "), n;
            if (g && 0 <= u.indexOf(s)) return l && (n += " if (true) { "), n;
            throw new Error("unknown format \"" + s + "\" is used in schema at path \"" + e.errSchemaPath + "\"");
          }

          var p,
              m,
              f = (p = "object" == typeof h && !(h instanceof RegExp) && h.validate) && h.type || "string";
          if (p && (m = !0 === h.async, h = h.validate), f != i) return l && (n += " if (true) { "), n;

          if (m) {
            if (!e.async) throw new Error("async format in sync schema");
            n += " if (!(await " + (C = "formats" + e.util.getProperty(s) + ".validate") + "(" + c + "))) { ";
          } else {
            n += " if (! ";
            var C = "formats" + e.util.getProperty(s);
            p && (C += ".validate"), n = n + ("function" == typeof h ? " " + C + "(" + c + ") " : " " + C + ".test(" + c + ") ") + ") { ";
          }
        }
        r = [], r.push(n), n = "", !1 !== e.createErrors ? (n = (n += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { format:  ") + (d ? "" + o : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (n = (n += " , message: 'should match format \"") + (d ? "' + " + o + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (n = (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", g = n, n = r.pop();
        return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + g + "]); " : n += " validate.errors = [" + g + "]; return false; " : n += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", l && (n += " else { "), n;
      };
    },
    5926: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r = " ",
            o = e.level,
            s = e.dataLevel,
            a = e.schema[t],
            l = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            s = "data" + (s || ""),
            h = "valid" + o,
            d = "errs__" + o,
            u = e.util.copy(e),
            g = (u.level++, "valid" + u.level),
            p = e.schema.then,
            m = e.schema.else,
            p = void 0 !== p && (e.opts.strictKeywords ? "object" == typeof p && 0 < Object.keys(p).length || !1 === p : e.util.schemaHasRules(p, e.RULES.all)),
            m = void 0 !== m && (e.opts.strictKeywords ? "object" == typeof m && 0 < Object.keys(m).length || !1 === m : e.util.schemaHasRules(m, e.RULES.all)),
            f = u.baseId;
        return p || m ? (u.createErrors = !1, u.schema = a, u.schemaPath = l, u.errSchemaPath = t, r += " var " + d + " = errors; var " + h + " = true;  ", a = e.compositeRule, e.compositeRule = u.compositeRule = !0, r += "  " + e.validate(u) + " ", u.baseId = f, u.createErrors = !0, r += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }  ", e.compositeRule = u.compositeRule = a, p ? (r += " if (" + g + ") {  ", u.schema = e.schema.then, u.schemaPath = e.schemaPath + ".then", u.errSchemaPath = e.errSchemaPath + "/then", r += "  " + e.validate(u) + " ", u.baseId = f, r += " " + h + " = " + g + "; ", p && m ? r += " var " + (n = "ifClause" + o) + " = 'then'; " : n = "'then'", r += " } ", m && (r += " else { ")) : r += " if (!" + g + ") { ", m && (u.schema = e.schema.else, u.schemaPath = e.schemaPath + ".else", u.errSchemaPath = e.errSchemaPath + "/else", r += "  " + e.validate(u) + " ", u.baseId = f, r += " " + h + " = " + g + "; ", p && m ? r += " var " + (n = "ifClause" + o) + " = 'else'; " : n = "'else'", r += " } "), r += " if (!" + h + ") {   var err =   ", !1 !== e.createErrors ? (r += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { failingKeyword: " + n + " } ", !1 !== e.opts.messages && (r += " , message: 'should match \"' + " + n + " + '\" schema' "), e.opts.verbose && (r += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + s + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " }   ", c && (r += " else { ")) : c && (r += " if (true) { "), r;
      };
    },
    9646: function (e, t, i) {
      "use strict";

      e.exports = {
        $ref: i(2331),
        allOf: i(9486),
        anyOf: i(5347),
        $comment: i(923),
        const: i(2617),
        contains: i(2119),
        dependencies: i(9115),
        enum: i(9317),
        format: i(8327),
        if: i(5926),
        items: i(392),
        maximum: i(1796),
        minimum: i(1796),
        maxItems: i(2407),
        minItems: i(2407),
        maxLength: i(1250),
        minLength: i(1250),
        maxProperties: i(2596),
        minProperties: i(2596),
        multipleOf: i(6039),
        not: i(7946),
        oneOf: i(9344),
        pattern: i(9737),
        properties: i(2537),
        propertyNames: i(2127),
        required: i(1204),
        uniqueItems: i(1985),
        validate: i(1869)
      };
    },
    392: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (o || ""),
            t = "valid" + r,
            o = "errs__" + r,
            d = e.util.copy(e),
            u = "",
            g = (d.level++, "valid" + d.level),
            r = "i" + r,
            p = d.dataLevel = e.dataLevel + 1,
            m = "data" + p,
            f = e.baseId;

        if (n += "var " + o + " = errors;var " + t + ";", Array.isArray(s)) {
          var C,
              I,
              v = e.schema.additionalItems,
              A = (!1 === v && (n += " " + t + " = " + h + ".length <= " + s.length + "; ", C = l, l = e.errSchemaPath + "/additionalItems", (I = I || []).push(n += "  if (!" + t + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + s.length + " } ", !1 !== e.opts.messages && (n += " , message: 'should NOT have more than " + s.length + " items' "), e.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", t = n, n = I.pop(), !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + t + "]); " : n += " validate.errors = [" + t + "]; return false; " : n += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } ", l = C, c && (u += "}", n += " else { ")), s);
          if (A) for (var b = -1, y = A.length - 1; b < y;) {
            var w,
                S,
                x = A[b += 1];
            (e.opts.strictKeywords ? "object" == typeof x && 0 < Object.keys(x).length || !1 === x : e.util.schemaHasRules(x, e.RULES.all)) && (n += " " + g + " = true; if (" + h + ".length > " + b + ") { ", w = h + "[" + b + "]", d.schema = x, d.schemaPath = a + "[" + b + "]", d.errSchemaPath = l + "/" + b, d.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), d.dataPathArr[p] = b, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? n += " " + e.util.varReplace(S, m, w) + " " : n += " var " + m + " = " + w + "; " + S + " ", n += " }  ", c && (n += " if (" + g + ") { ", u += "}"));
          }
          "object" == typeof v && (e.opts.strictKeywords ? "object" == typeof v && 0 < Object.keys(v).length || !1 === v : e.util.schemaHasRules(v, e.RULES.all)) && (d.schema = v, d.schemaPath = e.schemaPath + ".additionalItems", d.errSchemaPath = e.errSchemaPath + "/additionalItems", n += " " + g + " = true; if (" + h + ".length > " + s.length + ") {  for (var " + r + " = " + s.length + "; " + r + " < " + h + ".length; " + r + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, r, e.opts.jsonPointers, !0), w = h + "[" + r + "]", d.dataPathArr[p] = r, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? n += " " + e.util.varReplace(S, m, w) + " " : n += " var " + m + " = " + w + "; " + S + " ", c && (n += " if (!" + g + ") break; "), n += " } }  ", c && (n += " if (" + g + ") { ", u += "}"));
        } else (e.opts.strictKeywords ? "object" == typeof s && 0 < Object.keys(s).length || !1 === s : e.util.schemaHasRules(s, e.RULES.all)) && (d.schema = s, d.schemaPath = a, d.errSchemaPath = l, n += "  for (var " + r + " = 0; " + r + " < " + h + ".length; " + r + "++) { ", d.errorPath = e.util.getPathExpr(e.errorPath, r, e.opts.jsonPointers, !0), w = h + "[" + r + "]", d.dataPathArr[p] = r, S = e.validate(d), d.baseId = f, e.util.varOccurences(S, m) < 2 ? n += " " + e.util.varReplace(S, m, w) + " " : n += " var " + m + " = " + w + "; " + S + " ", c && (n += " if (!" + g + ") break; "), n += " }");

        return c && (n += " " + u + " if (" + o + " == errors) {"), n;
      };
    },
    6039: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (o || ""),
            d = e.opts.$data && s && s.$data,
            o = d ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s;
        if (!d && "number" != typeof s) throw new Error(t + " must be number");
        n += "var division" + r + ";if (", d && (n += " " + o + " !== undefined && ( typeof " + o + " != 'number' || "), n += " (division" + r + " = " + h + " / " + o + ", ", e.opts.multipleOfPrecision ? n += " Math.abs(Math.round(division" + r + ") - division" + r + ") > 1e-" + e.opts.multipleOfPrecision + " " : n += " division" + r + " !== parseInt(division" + r + ") ", n += " ) ", d && (n += "  )  ");
        t = [], t.push(n += " ) {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { multipleOf: " + o + " } ", !1 !== e.opts.messages && (n = n + " , message: 'should be multiple of " + (d ? "' + " + o : o + "'")), e.opts.verbose && (n = (n += " , schema:  ") + (d ? "validate.schema" + a : "" + s) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), n += " } ") : n += " {} ", r = n, n = t.pop();
        return !e.compositeRule && c ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", c && (n += " else { "), n;
      };
    },
    7946: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r,
            o = " ",
            s = e.level,
            a = e.dataLevel,
            l = e.schema[t],
            c = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            h = !e.opts.allErrors,
            a = "data" + (a || ""),
            s = "errs__" + s,
            d = e.util.copy(e),
            u = (d.level++, "valid" + d.level);
        return (e.opts.strictKeywords ? "object" == typeof l && 0 < Object.keys(l).length || !1 === l : e.util.schemaHasRules(l, e.RULES.all)) ? (d.schema = l, d.schemaPath = c, d.errSchemaPath = t, o += " var " + s + " = errors;  ", l = e.compositeRule, e.compositeRule = d.compositeRule = !0, d.createErrors = !1, d.opts.allErrors && (r = d.opts.allErrors, d.opts.allErrors = !1), o += " " + e.validate(d) + " ", d.createErrors = !0, r && (d.opts.allErrors = r), e.compositeRule = d.compositeRule = l, (n = n || []).push(o += " if (" + u + ") {   "), o = "", !1 !== e.createErrors ? (o += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should NOT be valid' "), e.opts.verbose && (o += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), o += " } ") : o += " {} ", r = o, o = n.pop(), !e.compositeRule && h ? e.async ? o += " throw new ValidationError([" + r + "]); " : o += " validate.errors = [" + r + "]; return false; " : o += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", o += " } else {  errors = " + s + "; if (vErrors !== null) { if (" + s + ") vErrors.length = " + s + "; else vErrors = null; } ", e.opts.allErrors && (o += " } ")) : (o += "  var err =   ", !1 !== e.createErrors ? (o += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: {} ", !1 !== e.opts.messages && (o += " , message: 'should NOT be valid' "), e.opts.verbose && (o += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + a + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h && (o += " if (false) { ")), o;
      };
    },
    9344: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            t = !e.opts.allErrors,
            o = "data" + (o || ""),
            c = "valid" + r,
            h = "errs__" + r,
            d = e.util.copy(e),
            u = "",
            g = (d.level++, "valid" + d.level),
            p = d.baseId,
            m = "prevValid" + r,
            f = "passingSchemas" + r,
            r = (n += "var " + h + " = errors , " + m + " = false , " + c + " = false , " + f + " = null; ", e.compositeRule),
            C = (e.compositeRule = d.compositeRule = !0, s);
        if (C) for (var I, v = -1, A = C.length - 1; v < A;) I = C[v += 1], (e.opts.strictKeywords ? "object" == typeof I && 0 < Object.keys(I).length || !1 === I : e.util.schemaHasRules(I, e.RULES.all)) ? (d.schema = I, d.schemaPath = a + "[" + v + "]", d.errSchemaPath = l + "/" + v, n += "  " + e.validate(d) + " ", d.baseId = p) : n += " var " + g + " = true; ", v && (n += " if (" + g + " && " + m + ") { " + c + " = false; " + f + " = [" + f + ", " + v + "]; } else { ", u += "}"), n += " if (" + g + ") { " + c + " = " + m + " = true; " + f + " = " + v + "; }";
        return e.compositeRule = d.compositeRule = r, n += u + "if (!" + c + ") {   var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { passingSchemas: " + f + " } ", !1 !== e.opts.messages && (n += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + o + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && t && (e.async ? n += " throw new ValidationError(vErrors); " : n += " validate.errors = vErrors; return false; "), n += "} else {  errors = " + h + "; if (vErrors !== null) { if (" + h + ") vErrors.length = " + h + "; else vErrors = null; }", e.opts.allErrors && (n += " } "), n;
      };
    },
    9737: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            c = "data" + (o || ""),
            h = e.opts.$data && s && s.$data,
            o = h ? (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; ", "schema" + r) : s,
            r = h ? "(new RegExp(" + o + "))" : e.usePattern(s),
            d = (n += "if ( ", h && (n += " (" + o + " !== undefined && typeof " + o + " != 'string') || "), []),
            r = (d.push(n += " !" + r + ".test(" + c + ") ) {   "), n = "", !1 !== e.createErrors ? (n = (n += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { pattern:  ") + (h ? "" + o : "" + e.util.toQuotedString(s)) + "  } ", !1 !== e.opts.messages && (n = (n += " , message: 'should match pattern \"") + (h ? "' + " + o + " + '" : "" + e.util.escapeQuotes(s)) + "\"' "), e.opts.verbose && (n = (n = (n += " , schema:  ") + (h ? "validate.schema" + a : "" + e.util.toQuotedString(s))) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n),
            n = d.pop();
        return !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + r + "]); " : n += " validate.errors = [" + r + "]; return false; " : n += " var err = " + r + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += "} ", l && (n += " else { "), n;
      };
    },
    2537: function (e) {
      "use strict";

      e.exports = function (e, t, G) {
        var i,
            n = " ",
            r = e.level,
            o = e.dataLevel,
            P = e.schema[t],
            s = e.schemaPath + e.util.getProperty(t),
            a = e.errSchemaPath + "/" + t,
            l = !e.opts.allErrors,
            c = "data" + (o || ""),
            t = "errs__" + r,
            h = e.util.copy(e),
            d = "",
            u = (h.level++, "valid" + h.level),
            g = "key" + r,
            p = "idx" + r,
            m = h.dataLevel = e.dataLevel + 1,
            f = "data" + m,
            C = "dataProperties" + r,
            o = Object.keys(P || {}).filter(M),
            F = e.schema.patternProperties || {},
            I = Object.keys(F).filter(M),
            v = e.schema.additionalProperties,
            H = o.length || I.length,
            V = !1 === v,
            Z = "object" == typeof v && Object.keys(v).length,
            A = e.opts.removeAdditional,
            b = V || Z || A,
            y = e.opts.ownProperties,
            w = e.baseId,
            S = e.schema.required;

        function M(e) {
          return "__proto__" !== e;
        }

        if (S && (!e.opts.$data || !S.$data) && S.length < e.opts.loopRequired && (i = e.util.toHash(S)), n += "var " + t + " = errors;var " + u + " = true;", y && (n += " var " + C + " = undefined;"), b) {
          if (n += y ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ", H) {
            if (n += " var isAdditional" + r + " = !(false ", o.length) if (8 < o.length) n += " || validate.schema" + s + ".hasOwnProperty(" + g + ") ";else {
              var O = o;
              if (O) for (var D = -1, K = O.length - 1; D < K;) x = O[D += 1], n += " || " + g + " == " + e.util.toQuotedString(x) + " ";
            }

            if (I.length) {
              var j = I;
              if (j) for (var z = -1, X = j.length - 1; z < X;) B = j[z += 1], n += " || " + e.usePattern(B) + ".test(" + g + ") ";
            }

            n += " ); if (isAdditional" + r + ") { ";
          }

          "all" == A ? n += " delete " + c + "[" + g + "]; " : (E = e.errorPath, S = "' + " + g + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers)), V ? A ? n += " delete " + c + "[" + g + "]; " : (R = a, a = e.errSchemaPath + "/additionalProperties", (_ = _ || []).push(n += " " + u + " = false; "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { additionalProperty: '" + S + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is an invalid additional property" : n += "should NOT have additional properties", n += "' "), e.opts.verbose && (n += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", $ = n, n = _.pop(), !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + $ + "]); " : n += " validate.errors = [" + $ + "]; return false; " : n += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = R, l && (n += " break; ")) : Z && ("failing" == A ? (n += " var " + t + " = errors;  ", b = e.compositeRule, e.compositeRule = h.compositeRule = !0, h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), W = c + "[" + g + "]", h.dataPathArr[m] = g, N = e.validate(h), h.baseId = w, e.util.varOccurences(N, f) < 2 ? n += " " + e.util.varReplace(N, f, W) + " " : n += " var " + f + " = " + W + "; " + N + " ", n += " if (!" + u + ") { errors = " + t + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + g + "]; }  ", e.compositeRule = h.compositeRule = b) : (h.schema = v, h.schemaPath = e.schemaPath + ".additionalProperties", h.errSchemaPath = e.errSchemaPath + "/additionalProperties", h.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), W = c + "[" + g + "]", h.dataPathArr[m] = g, N = e.validate(h), h.baseId = w, e.util.varOccurences(N, f) < 2 ? n += " " + e.util.varReplace(N, f, W) + " " : n += " var " + f + " = " + W + "; " + N + " ", l && (n += " if (!" + u + ") break; "))), e.errorPath = E), H && (n += " } "), n += " }  ", l && (n += " if (" + u + ") { ", d += "}");
        }

        var J = e.opts.useDefaults && !e.compositeRule;

        if (o.length) {
          var Y = o;
          if (Y) for (var x, U = -1, Q = Y.length - 1; U < Q;) {
            var q,
                k,
                E,
                R,
                T,
                _,
                $,
                L = P[x = Y[U += 1]];

            (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (W = c + (T = e.util.getProperty(x)), q = J && void 0 !== L.default, h.schema = L, h.schemaPath = s + T, h.errSchemaPath = a + "/" + e.util.escapeFragment(x), h.errorPath = e.util.getPath(e.errorPath, x, e.opts.jsonPointers), h.dataPathArr[m] = e.util.toQuotedString(x), N = e.validate(h), h.baseId = w, e.util.varOccurences(N, f) < 2 ? (N = e.util.varReplace(N, f, W), k = W) : n += " var " + (k = f) + " = " + W + "; ", q ? n += " " + N + " " : (i && i[x] ? (n += " if ( " + k + " === undefined ", y && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), n += ") { " + u + " = false; ", E = e.errorPath, R = a, T = e.util.escapeQuotes(x), e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(E, x, e.opts.jsonPointers)), a = e.errSchemaPath + "/required", (_ = _ || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(a) + " , params: { missingProperty: '" + T + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + T + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", $ = n, n = _.pop(), !e.compositeRule && l ? e.async ? n += " throw new ValidationError([" + $ + "]); " : n += " validate.errors = [" + $ + "]; return false; " : n += " var err = " + $ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", a = R, e.errorPath = E, n += " } else { ") : l ? (n += " if ( " + k + " === undefined ", y && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), n += ") { " + u + " = true; } else { ") : (n += " if (" + k + " !== undefined ", y && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(x) + "') "), n += " ) { "), n += " " + N + " } ")), l && (n += " if (" + u + ") { ", d += "}");
          }
        }

        if (I.length) {
          var ee = I;
          if (ee) for (var B, te = -1, ie = ee.length - 1; te < ie;) {
            var W,
                N,
                L = F[B = ee[te += 1]];
            (e.opts.strictKeywords ? "object" == typeof L && 0 < Object.keys(L).length || !1 === L : e.util.schemaHasRules(L, e.RULES.all)) && (h.schema = L, h.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(B), h.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(B), n = (n += y ? " " + C + " = " + C + " || Object.keys(" + c + "); for (var " + p + "=0; " + p + "<" + C + ".length; " + p + "++) { var " + g + " = " + C + "[" + p + "]; " : " for (var " + g + " in " + c + ") { ") + " if (" + e.usePattern(B) + ".test(" + g + ")) { ", h.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers), W = c + "[" + g + "]", h.dataPathArr[m] = g, N = e.validate(h), h.baseId = w, e.util.varOccurences(N, f) < 2 ? n += " " + e.util.varReplace(N, f, W) + " " : n += " var " + f + " = " + W + "; " + N + " ", l && (n += " if (!" + u + ") break; "), n += " } ", l && (n += " else " + u + " = true; "), n += " }  ", l && (n += " if (" + u + ") { ", d += "}"));
          }
        }

        return l && (n += " " + d + " if (" + t + " == errors) {"), n;
      };
    },
    2127: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r,
            o,
            s,
            a,
            l,
            c,
            h = " ",
            d = e.level,
            u = e.dataLevel,
            g = e.schema[t],
            p = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            m = !e.opts.allErrors,
            u = "data" + (u || ""),
            f = "errs__" + d,
            C = e.util.copy(e),
            I = (C.level++, "valid" + C.level);
        return h += "var " + f + " = errors;", (e.opts.strictKeywords ? "object" == typeof g && 0 < Object.keys(g).length || !1 === g : e.util.schemaHasRules(g, e.RULES.all)) && (C.schema = g, C.schemaPath = p, C.errSchemaPath = t, g = "idx" + d, r = "i" + d, o = "' + " + (n = "key" + d) + " + '", s = "data" + (C.dataLevel = e.dataLevel + 1), c = "dataProperties" + d, l = e.opts.ownProperties, a = e.baseId, l && (h += " var " + c + " = undefined; "), h = h + (l ? " " + c + " = " + c + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + c + ".length; " + g + "++) { var " + n + " = " + c + "[" + g + "]; " : " for (var " + n + " in " + u + ") { ") + " var startErrs" + d + " = errors; ", l = n, c = e.compositeRule, e.compositeRule = C.compositeRule = !0, g = e.validate(C), C.baseId = a, e.util.varOccurences(g, s) < 2 ? h += " " + e.util.varReplace(g, s, l) + " " : h += " var " + s + " = " + l + "; " + g + " ", e.compositeRule = C.compositeRule = c, h += " if (!" + I + ") { for (var " + r + "=startErrs" + d + "; " + r + "<errors; " + r + "++) { vErrors[" + r + "].propertyName = " + n + "; }   var err =   ", !1 !== e.createErrors ? (h += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { propertyName: '" + o + "' } ", !1 !== e.opts.messages && (h += " , message: 'property name \\'" + o + "\\' is invalid' "), e.opts.verbose && (h += " , schema: validate.schema" + p + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), h += " } ") : h += " {} ", h += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && m && (e.async ? h += " throw new ValidationError(vErrors); " : h += " validate.errors = vErrors; return false; "), m && (h += " break; "), h += " } }"), m && (h += "  if (" + f + " == errors) {"), h;
      };
    },
    2331: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r,
            o = " ",
            s = e.level,
            a = e.dataLevel,
            l = e.schema[t],
            t = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (a || ""),
            s = "valid" + s;
        if ("#" == l || "#/" == l) r = e.isRoot ? (n = e.async, "validate") : (n = !0 === e.root.schema.$async, "root.refVal[0]");else {
          var d = e.resolveRef(e.baseId, l, e.isRoot);

          if (void 0 === d) {
            var u = e.MissingRefError.message(e.baseId, l);

            if ("fail" == e.opts.missingRefs) {
              e.logger.error(u);
              (g = g || []).push(o), o = "", !1 !== e.createErrors ? (o += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { ref: '" + e.util.escapeQuotes(l) + "' } ", !1 !== e.opts.messages && (o += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(l) + "' "), e.opts.verbose && (o += " , schema: " + e.util.toQuotedString(l) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), o += " } ") : o += " {} ";
              t = o, o = g.pop();
              !e.compositeRule && c ? e.async ? o += " throw new ValidationError([" + t + "]); " : o += " validate.errors = [" + t + "]; return false; " : o += " var err = " + t + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (o += " if (false) { ");
            } else {
              if ("ignore" != e.opts.missingRefs) throw new e.MissingRefError(e.baseId, l, u);
              e.logger.warn(u), c && (o += " if (true) { ");
            }
          } else d.inline ? ((t = e.util.copy(e)).level++, u = "valid" + t.level, t.schema = d.schema, t.schemaPath = "", t.errSchemaPath = l, o += " " + e.validate(t).replace(/validate\.schema/g, d.code) + " ", c && (o += " if (" + u + ") { ")) : (n = !0 === d.$async || e.async && !1 !== d.$async, r = d.code);
        }

        if (r) {
          (g = g || []).push(o), o = "", e.opts.passContext ? o += " " + r + ".call(this, " : o += " " + r + "( ", o += " " + h + ", (dataPath || '')", "\"\"" != e.errorPath && (o += " + " + e.errorPath);
          var g,
              l = a ? "data" + (a - 1 || "") : "parentData",
              t = o += " , " + l + " , " + (a ? e.dataPathArr[a] : "parentDataProperty") + ", rootData)  ";

          if (o = g.pop(), n) {
            if (!e.async) throw new Error("async schema referenced by sync schema");
            c && (o += " var " + s + "; "), o += " try { await " + t + "; ", c && (o += " " + s + " = true; "), o += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (o += " " + s + " = false; "), o += " } ", c && (o += " if (" + s + ") { ");
          } else o += " if (!" + t + ") { if (vErrors === null) vErrors = " + r + ".errors; else vErrors = vErrors.concat(" + r + ".errors); errors = vErrors.length; } ", c && (o += " else { ");
        }

        return o;
      };
    },
    1204: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n = " ",
            r = e.level,
            o = e.dataLevel,
            s = e.schema[t],
            a = e.schemaPath + e.util.getProperty(t),
            l = e.errSchemaPath + "/" + t,
            t = !e.opts.allErrors,
            c = "data" + (o || ""),
            h = "valid" + r,
            d = e.opts.$data && s && s.$data,
            o = (d && (n += " var schema" + r + " = " + e.util.getData(s.$data, o, e.dataPathArr) + "; "), "schema" + r);
        if (!d) if (s.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
          var u = [],
              g = s;
          if (g) for (var p = -1, m = g.length - 1; p < m;) {
            var f = g[p += 1],
                C = e.schema.properties[f];
            C && (e.opts.strictKeywords ? "object" == typeof C && 0 < Object.keys(C).length || !1 === C : e.util.schemaHasRules(C, e.RULES.all)) || (u[u.length] = f);
          }
        } else u = s;

        if (d || u.length) {
          var I = e.errorPath,
              s = d || u.length >= e.opts.loopRequired,
              v = e.opts.ownProperties;
          if (t) {
            if (n += " var missing" + r + "; ", s) {
              d || (n += " var " + o + " = validate.schema" + a + "; ");
              var A = "' + " + (k = "schema" + r + "[" + (w = "i" + r) + "]") + " + '";
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(I, k, e.opts.jsonPointers)), n += " var " + h + " = true; ", d && (n += " if (schema" + r + " === undefined) " + h + " = true; else if (!Array.isArray(schema" + r + ")) " + h + " = false; else {"), n += " for (var " + w + " = 0; " + w + " < " + o + ".length; " + w + "++) { " + h + " = " + c + "[" + o + "[" + w + "]] !== undefined ", v && (n += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + o + "[" + w + "]) "), n += "; if (!" + h + ") break; } ", d && (n += "  }  ");
              (x = x || []).push(n += "  if (!" + h + ") {   "), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + A + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + A + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
              var b = n,
                  n = x.pop();
              !e.compositeRule && t ? e.async ? n += " throw new ValidationError([" + b + "]); " : n += " validate.errors = [" + b + "]; return false; " : n += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ";
            } else {
              n += " if ( ";
              var y = u;
              if (y) for (var w = -1, S = y.length - 1; w < S;) R = y[w += 1], w && (n += " || "), n += " ( ( " + (L = c + ($ = e.util.getProperty(R))) + " === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(R) + "') "), n += ") && (missing" + r + " = " + e.util.toQuotedString(e.opts.jsonPointers ? R : $) + ") ) ";
              n += ") {  ";
              A = "' + " + (k = "missing" + r) + " + '";
              e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(I, k, !0) : I + " + " + k);
              (x = x || []).push(n), n = "", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + A + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + A + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ";
              var x,
                  b = n;
              n = x.pop(), !e.compositeRule && t ? e.async ? n += " throw new ValidationError([" + b + "]); " : n += " validate.errors = [" + b + "]; return false; " : n += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n += " } else { ";
            }
          } else if (s) {
            d || (n += " var " + o + " = validate.schema" + a + "; ");
            var k,
                A = "' + " + (k = "schema" + r + "[" + (w = "i" + r) + "]") + " + '";
            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(I, k, e.opts.jsonPointers)), d && (n += " if (" + o + " && !Array.isArray(" + o + ")) {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + A + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + A + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + o + " !== undefined) { "), n += " for (var " + w + " = 0; " + w + " < " + o + ".length; " + w + "++) { if (" + c + "[" + o + "[" + w + "]] === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + o + "[" + w + "]) "), n += ") {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + A + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + A + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d && (n += "  }  ");
          } else {
            var E = u;
            if (E) for (var R, T = -1, _ = E.length - 1; T < _;) {
              R = E[T += 1];
              var $ = e.util.getProperty(R),
                  A = e.util.escapeQuotes(R),
                  L = c + $;
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(I, R, e.opts.jsonPointers)), n += " if ( " + L + " === undefined ", v && (n += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + e.util.escapeQuotes(R) + "') "), n += ") {  var err =   ", !1 !== e.createErrors ? (n += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingProperty: '" + A + "' } ", !1 !== e.opts.messages && (n += " , message: '", e.opts._errorDataPathProperty ? n += "is a required property" : n += "should have required property \\'" + A + "\\'", n += "' "), e.opts.verbose && (n += " , schema: validate.schema" + a + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), n += " } ") : n += " {} ", n += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
          }
          e.errorPath = I;
        } else t && (n += " if (true) {");

        return n;
      };
    },
    1985: function (e) {
      "use strict";

      e.exports = function (e, t, i) {
        var n,
            r = " ",
            o = e.level,
            s = e.dataLevel,
            a = e.schema[t],
            l = e.schemaPath + e.util.getProperty(t),
            t = e.errSchemaPath + "/" + t,
            c = !e.opts.allErrors,
            h = "data" + (s || ""),
            d = "valid" + o,
            u = e.opts.$data && a && a.$data,
            s = u ? (r += " var schema" + o + " = " + e.util.getData(a.$data, s, e.dataPathArr) + "; ", "schema" + o) : a;
        return (a || u) && !1 !== e.opts.uniqueItems ? (u && (r += " var " + d + "; if (" + s + " === false || " + s + " === undefined) " + d + " = true; else if (typeof " + s + " != 'boolean') " + d + " = false; else { "), r += " var i = " + h + ".length , " + d + " = true , j; if (i > 1) { ", o = e.schema.items && e.schema.items.type, s = Array.isArray(o), !o || "object" == o || "array" == o || s && (0 <= o.indexOf("object") || 0 <= o.indexOf("array")) ? r += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + h + "[i], " + h + "[j])) { " + d + " = false; break outer; } } } " : (r = (r += " var itemIndices = {}, item; for (;i--;) { var item = " + h + "[i]; ") + " if (" + e.util["checkDataType" + (s ? "s" : "")](o, "item", e.opts.strictNumbers, !0) + ") continue; ", s && (r += " if (typeof item == 'string') item = '\"' + item; "), r += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } "), r += " } ", u && (r += "  }  "), (n = n || []).push(r += " if (!" + d + ") {   "), r = "", !1 !== e.createErrors ? (r += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(t) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (r += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (r = (r += " , schema:  ") + (u ? "validate.schema" + l : "" + a) + "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ", o = r, r = n.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + o + "]); " : r += " validate.errors = [" + o + "]; return false; " : r += " var err = " + o + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", c && (r += " else { ")) : c && (r += " if (true) { "), r;
      };
    },
    1869: function (e) {
      "use strict";

      e.exports = function (n, e, G) {
        var t = "",
            i = !0 === n.schema.$async,
            r = n.util.schemaHasRulesExcept(n.schema, n.RULES.all, "$ref"),
            o = n.self._getId(n.schema);

        if (n.opts.strictKeywords) {
          var s = n.util.schemaUnknownRules(n.schema, n.RULES.keywords);

          if (s) {
            s = "unknown keyword: " + s;
            if ("log" !== n.opts.strictKeywords) throw new Error(s);
            n.logger.warn(s);
          }
        }

        if (n.isTop && (t += " var validate = ", i && (n.async = !0, t += "async "), t += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", o && (n.opts.sourceCode || n.opts.processCode) && (t += " /*# sourceURL=" + o + " */ ")), "boolean" == typeof n.schema || !r && !n.schema.$ref) return l = n.level, c = n.dataLevel, T = n.schema[e = "false schema"], A = n.schemaPath + n.util.getProperty(e), b = n.errSchemaPath + "/" + e, g = !n.opts.allErrors, h = "data" + (c || ""), u = "valid" + l, !1 === n.schema ? (n.isTop ? g = !0 : t += " var " + u + " = false; ", (W = W || []).push(t), t = "", !1 !== n.createErrors ? (t += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: {} ", !1 !== n.opts.messages && (t += " , message: 'boolean schema is false' "), n.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = W.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ") : n.isTop ? t += i ? " return data; " : " validate.errors = null; return true; " : t += " var " + u + " = true; ", n.isTop && (t += " }; return validate; "), t;

        if (n.isTop) {
          var a = n.isTop,
              l = n.level = 0,
              c = n.dataLevel = 0,
              h = "data";

          if (n.rootId = n.resolve.fullPath(n.self._getId(n.root.schema)), n.baseId = n.baseId || n.rootId, delete n.isTop, n.dataPathArr = [""], void 0 !== n.schema.default && n.opts.useDefaults && n.opts.strictDefaults) {
            var d = "default is ignored in the schema root";
            if ("log" !== n.opts.strictDefaults) throw new Error(d);
            n.logger.warn(d);
          }

          t = (t += " var vErrors = null; ") + " var errors = 0;     " + " if (rootData === undefined) rootData = data; ";
        } else {
          l = n.level, h = "data" + ((c = n.dataLevel) || "");
          if (o && (n.baseId = n.resolve.url(n.baseId, o)), i && !n.async) throw new Error("async schema in sync schema");
          t += " var errs_" + l + " = errors;";
        }

        var u = "valid" + l,
            g = !n.opts.allErrors,
            p = "",
            m = "",
            f = n.schema.type,
            C = Array.isArray(f);

        if (f && n.opts.nullable && !0 === n.schema.nullable && (C ? -1 == f.indexOf("null") && (f = f.concat("null")) : "null" != f && (f = [f, "null"], C = !0)), C && 1 == f.length && (f = f[0], C = !1), n.schema.$ref && r) {
          if ("fail" == n.opts.extendRefs) throw new Error("$ref: validation keywords used in schema at path \"" + n.errSchemaPath + "\" (see option extendRefs)");
          !0 !== n.opts.extendRefs && (r = !1, n.logger.warn("$ref: keywords ignored in schema at path \"" + n.errSchemaPath + "\""));
        }

        if (n.schema.$comment && n.opts.$comment && (t += " " + n.RULES.all.$comment.code(n, "$comment")), f) {
          n.opts.coerceTypes && (I = n.util.coerceToTypes(n.opts.coerceTypes, f));
          var I,
              v = n.RULES.types[f];

          if (I || C || !0 === v || v && !z(v)) {
            var A = n.schemaPath + ".type",
                b = n.errSchemaPath + "/type",
                A = n.schemaPath + ".type",
                b = n.errSchemaPath + "/type";

            if (t += " if (" + n.util[C ? "checkDataTypes" : "checkDataType"](f, h, n.opts.strictNumbers, !0) + ") { ", I) {
              var y = "dataType" + l,
                  w = "coerced" + l,
                  S = (t += " var " + y + " = typeof " + h + "; var " + w + " = undefined; ", "array" == n.opts.coerceTypes && (t += " if (" + y + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + y + " = typeof " + h + "; if (" + n.util.checkDataType(n.schema.type, h, n.opts.strictNumbers) + ") " + w + " = " + h + "; } "), t += " if (" + w + " !== undefined) ; ", I);
              if (S) for (var x, k = -1, P = S.length - 1; k < P;) "string" == (x = S[k += 1]) ? t += " else if (" + y + " == 'number' || " + y + " == 'boolean') " + w + " = '' + " + h + "; else if (" + h + " === null) " + w + " = ''; " : "number" == x || "integer" == x ? (t += " else if (" + y + " == 'boolean' || " + h + " === null || (" + y + " == 'string' && " + h + " && " + h + " == +" + h + " ", "integer" == x && (t += " && !(" + h + " % 1)"), t += ")) " + w + " = +" + h + "; ") : "boolean" == x ? t += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + w + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + w + " = true; " : "null" == x ? t += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + w + " = null; " : "array" == n.opts.coerceTypes && "array" == x && (t += " else if (" + y + " == 'string' || " + y + " == 'number' || " + y + " == 'boolean' || " + h + " == null) " + w + " = [" + h + "]; ");
              (W = W || []).push(t += " else {   "), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + A + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ";
              var E = t,
                  s = (t = W.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c ? "data" + (c - 1 || "") : "parentData");
              t = t + (" } if (" + w + " !== undefined) {  ") + (" " + h + " = " + w + "; "), c || (t += "if (" + s + " !== undefined)"), t += " " + s + "[" + (c ? n.dataPathArr[c] : "parentDataProperty") + "] = " + w + "; } ";
            } else {
              E = ((W = W || []).push(t), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + A + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", t);
              t = W.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            }

            t += " } ";
          }
        }

        if (n.schema.$ref && !r) t += " " + n.RULES.all.$ref.code(n, "$ref") + " ", g && (t = (t += " } if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");else {
          var R = n.RULES;
          if (R) for (var F = -1, H = R.length - 1; F < H;) if (z(v = R[F += 1])) {
            if (v.type && (t += " if (" + n.util.checkDataType(v.type, h, n.opts.strictNumbers) + ") { "), n.opts.useDefaults) if ("object" == v.type && n.schema.properties) {
              var T = n.schema.properties,
                  _ = Object.keys(T);

              if (_) for (var V, Z = -1, M = _.length - 1; Z < M;) if (void 0 !== (B = T[V = _[Z += 1]]).default) {
                var $ = h + n.util.getProperty(V);

                if (n.compositeRule) {
                  if (n.opts.strictDefaults) {
                    d = "default is ignored for: " + $;
                    if ("log" !== n.opts.strictDefaults) throw new Error(d);
                    n.logger.warn(d);
                  }
                } else t += " if (" + $ + " === undefined ", "empty" == n.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == n.opts.useDefaults ? t += " " + n.useDefault(B.default) + " " : t += " " + JSON.stringify(B.default) + " ", t += "; ";
              }
            } else if ("array" == v.type && Array.isArray(n.schema.items)) {
              var L = n.schema.items;
              if (L) for (var B, k = -1, O = L.length - 1; k < O;) if (void 0 !== (B = L[k += 1]).default) {
                $ = h + "[" + k + "]";

                if (n.compositeRule) {
                  if (n.opts.strictDefaults) {
                    d = "default is ignored for: " + $;
                    if ("log" !== n.opts.strictDefaults) throw new Error(d);
                    n.logger.warn(d);
                  }
                } else t += " if (" + $ + " === undefined ", "empty" == n.opts.useDefaults && (t += " || " + $ + " === null || " + $ + " === '' "), t += " ) " + $ + " = ", "shared" == n.opts.useDefaults ? t += " " + n.useDefault(B.default) + " " : t += " " + JSON.stringify(B.default) + " ", t += "; ";
              }
            }
            var W,
                D = v.rules;
            if (D) for (var N, K = -1, j = D.length - 1; K < j;) !X(N = D[K += 1]) || (N = N.code(n, N.keyword, v.type)) && (t += " " + N + " ", g && (p += "}"));
            g && (t += " " + p + " ", p = ""), v.type && (t += " } ", f && f === v.type && !I && (t += " else { ", A = n.schemaPath + ".type", b = n.errSchemaPath + "/type", (W = W || []).push(t), t = "", !1 !== n.createErrors ? (t = (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + n.errorPath + " , schemaPath: " + n.util.toQuotedString(b) + " , params: { type: '") + (C ? "" + f.join(",") : "" + f) + "' } ", !1 !== n.opts.messages && (t = (t += " , message: 'should be ") + (C ? "" + f.join(",") : "" + f) + "' "), n.opts.verbose && (t += " , schema: validate.schema" + A + " , parentSchema: validate.schema" + n.schemaPath + " , data: " + h + " "), t += " } ") : t += " {} ", E = t, t = W.pop(), !n.compositeRule && g ? n.async ? t += " throw new ValidationError([" + E + "]); " : t += " validate.errors = [" + E + "]; return false; " : t += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } ")), g && (t = (t += " if (errors === ") + (a ? "0" : "errs_" + l) + ") { ", m += "}");
          }
        }

        function z(e) {
          for (var t = e.rules, i = 0; i < t.length; i++) if (X(t[i])) return 1;
        }

        function X(e) {
          return void 0 !== n.schema[e.keyword] || e.implements && function (e) {
            for (var t = e.implements, i = 0; i < t.length; i++) if (void 0 !== n.schema[t[i]]) return 1;
          }(e);
        }

        return g && (t += " " + m + " "), a ? t = t + (i ? " if (errors === 0) return data;            else throw new ValidationError(vErrors); " : " validate.errors = vErrors;  return errors === 0;       ") + " }; return validate;" : t += " var " + u + " = errors === errs_" + l + ";", t;
      };
    },
    7931: function (e, t, i) {
      "use strict";

      var a = /^[a-z_$][a-z0-9_$-]*$/i,
          l = i(1793),
          n = i(5868);

      function r(e, t) {
        r.errors = null;
        var i = (this || _global)._validateKeyword = (this || _global)._validateKeyword || this.compile(n, !0);
        if (i(e)) return !0;
        if (r.errors = i.errors, t) throw new Error("custom keyword definition is invalid: " + this.errorsText(i.errors));
        return !1;
      }

      e.exports = {
        add: function (e, t) {
          var s = (this || _global).RULES;
          if (s.keywords[e]) throw new Error("Keyword " + e + " is already defined");
          if (!a.test(e)) throw new Error("Keyword " + e + " is not a valid identifier");

          if (t) {
            this.validateKeyword(t, !0);
            var i = t.type;
            if (Array.isArray(i)) for (var n = 0; n < i.length; n++) o(e, i[n], t);else o(e, i, t);
            var r = t.metaSchema;
            r && (t.$data && (this || _global)._opts.$data && (r = {
              anyOf: [r, {
                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
              }]
            }), t.validateSchema = this.compile(r, !0));
          }

          function o(e, t, i) {
            for (var n, r = 0; r < s.length; r++) {
              var o = s[r];

              if (o.type == t) {
                n = o;
                break;
              }
            }

            n || s.push(n = {
              type: t,
              rules: []
            });
            i = {
              keyword: e,
              definition: i,
              custom: !0,
              code: l,
              implements: i.implements
            };
            n.rules.push(i), s.custom[e] = i;
          }

          return s.keywords[e] = s.all[e] = !0, this || _global;
        },
        get: function (e) {
          var t = (this || _global).RULES.custom[e];
          return t ? t.definition : (this || _global).RULES.keywords[e] || !1;
        },
        remove: function (e) {
          var t = (this || _global).RULES;
          delete t.keywords[e], delete t.all[e], delete t.custom[e];

          for (var i = 0; i < t.length; i++) for (var n = t[i].rules, r = 0; r < n.length; r++) if (n[r].keyword == e) {
            n.splice(r, 1);
            break;
          }

          return this || _global;
        },
        validate: r
      };
    },
    2303: function (e) {
      "use strict";

      e.exports = function e(t, i) {
        if (t === i) return !0;

        if (t && i && "object" == typeof t && "object" == typeof i) {
          if (t.constructor !== i.constructor) return !1;
          var n, r, o;

          if (Array.isArray(t)) {
            if ((n = t.length) != i.length) return !1;

            for (r = n; 0 != r--;) if (!e(t[r], i[r])) return !1;

            return !0;
          }

          if (t.constructor === RegExp) return t.source === i.source && t.flags === i.flags;
          if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === i.valueOf();
          if (t.toString !== Object.prototype.toString) return t.toString() === i.toString();
          if ((n = (o = Object.keys(t)).length) !== Object.keys(i).length) return !1;

          for (r = n; 0 != r--;) if (!Object.prototype.hasOwnProperty.call(i, o[r])) return !1;

          for (r = n; 0 != r--;) {
            var s = o[r];
            if (!e(t[s], i[s])) return !1;
          }

          return !0;
        }

        return t != t && i != i;
      };
    },
    3508: function (e) {
      "use strict";

      e.exports = function (e, t) {
        var n,
            l = "boolean" == typeof (t = "function" == typeof (t = t || {}) ? {
          cmp: t
        } : t).cycles && t.cycles,
            c = t.cmp && (n = t.cmp, function (i) {
          return function (e, t) {
            e = {
              key: e,
              value: i[e]
            }, t = {
              key: t,
              value: i[t]
            };
            return n(e, t);
          };
        }),
            h = [];
        return function e(t) {
          if (void 0 !== (t = t && t.toJSON && "function" == typeof t.toJSON ? t.toJSON() : t)) {
            if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
            if ("object" != typeof t) return JSON.stringify(t);

            if (Array.isArray(t)) {
              for (r = "[", o = 0; o < t.length; o++) o && (r += ","), r += e(t[o]) || "null";

              return r + "]";
            }

            if (null === t) return "null";

            if (-1 !== h.indexOf(t)) {
              if (l) return JSON.stringify("__cycle__");
              throw new TypeError("Converting circular structure to JSON");
            }

            for (var i = h.push(t) - 1, n = Object.keys(t).sort(c && c(t)), r = "", o = 0; o < n.length; o++) {
              var s = n[o],
                  a = e(t[s]);
              a && (r && (r += ","), r += JSON.stringify(s) + ":" + a);
            }

            return h.splice(i, 1), "{" + r + "}";
          }
        }(e);
      };
    },
    233: function (e) {
      e.exports = function t(e, i) {
        "use strict";

        function n(e) {
          return t.insensitive && ("" + e).toLowerCase() || "" + e;
        }

        var r,
            o,
            s = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
            a = /(^[ ]*|[ ]*$)/g,
            l = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
            c = /^0x[0-9a-f]+$/i,
            h = /^0/,
            e = n(e).replace(a, "") || "",
            i = n(i).replace(a, "") || "",
            d = e.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
            u = i.replace(s, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
            a = parseInt(e.match(c), 16) || 1 !== d.length && e.match(l) && Date.parse(e),
            s = parseInt(i.match(c), 16) || a && i.match(l) && Date.parse(i) || null;

        if (s) {
          if (a < s) return -1;
          if (s < a) return 1;
        }

        for (var g = 0, p = Math.max(d.length, u.length); g < p; g++) {
          if (r = !(d[g] || "").match(h) && parseFloat(d[g]) || d[g] || 0, o = !(u[g] || "").match(h) && parseFloat(u[g]) || u[g] || 0, isNaN(r) !== isNaN(o)) return isNaN(r) ? 1 : -1;
          if (typeof r != typeof o && (r += "", o += ""), r < o) return -1;
          if (o < r) return 1;
        }

        return 0;
      };
    },
    5156: function (e, t) {
      !function (e) {
        "use strict";

        function w(e) {
          return null !== e && "[object Array]" === Object.prototype.toString.call(e);
        }

        function S(e) {
          return null !== e && "[object Object]" === Object.prototype.toString.call(e);
        }

        function x(e, t) {
          if (e === t) return !0;
          if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(t)) return !1;

          if (!0 === w(e)) {
            if (e.length !== t.length) return !1;

            for (var i = 0; i < e.length; i++) if (!1 === x(e[i], t[i])) return !1;

            return !0;
          }

          if (!0 !== S(e)) return !1;
          var n,
              r,
              o = {};

          for (n in e) if (hasOwnProperty.call(e, n)) {
            if (!1 === x(e[n], t[n])) return !1;
            o[n] = !0;
          }

          for (r in t) if (hasOwnProperty.call(t, r) && !0 !== o[r]) return !1;

          return !0;
        }

        function k(e) {
          if ("" === e || !1 === e || null === e) return !0;
          if (w(e) && 0 === e.length) return !0;

          if (S(e)) {
            for (var t in e) if (e.hasOwnProperty(t)) return !1;

            return !0;
          }

          return !1;
        }

        var r = "function" == typeof String.prototype.trimLeft ? function (e) {
          return e.trimLeft();
        } : function (e) {
          return e.match(/^\s*(.*)/)[1];
        },
            h = {
          0: "number",
          1: "any",
          2: "string",
          3: "array",
          4: "object",
          5: "boolean",
          6: "expression",
          7: "null",
          8: "Array<number>",
          9: "Array<string>"
        },
            s = "UnquotedIdentifier",
            a = "QuotedIdentifier",
            l = "Rbracket",
            c = "Rparen",
            d = "Comma",
            u = "Colon",
            o = "Rbrace",
            g = "Number",
            E = "Current",
            R = "Expref",
            T = "Pipe",
            _ = "Flatten",
            p = "Star",
            m = "Filter",
            f = "Lbrace",
            C = "Lbracket",
            I = "Lparen",
            v = "Literal",
            A = {
          ".": "Dot",
          "*": p,
          ",": d,
          ":": u,
          "{": f,
          "}": o,
          "]": l,
          "(": I,
          ")": c,
          "@": E
        },
            b = {
          "<": !0,
          ">": !0,
          "=": !0,
          "!": !0
        },
            y = {
          " ": !0,
          "\t": !0,
          "\n": !0
        };

        function $(e) {
          return "0" <= e && e <= "9" || "-" === e;
        }

        function i() {}

        i.prototype = {
          tokenize: function (e) {
            var t,
                i,
                n = [];

            for ((this || _global)._current = 0; (this || _global)._current < e.length;) if ("a" <= (o = e[(this || _global)._current]) && o <= "z" || "A" <= o && o <= "Z" || "_" === o) r = (this || _global)._current, t = this._consumeUnquotedIdentifier(e), n.push({
              type: s,
              value: t,
              start: r
            });else if (void 0 !== A[e[(this || _global)._current]]) n.push({
              type: A[e[(this || _global)._current]],
              value: e[(this || _global)._current],
              start: (this || _global)._current
            }), (this || _global)._current++;else if ($(e[(this || _global)._current])) i = this._consumeNumber(e), n.push(i);else if ("[" === e[(this || _global)._current]) i = this._consumeLBracket(e), n.push(i);else if ("\"" === e[(this || _global)._current]) r = (this || _global)._current, t = this._consumeQuotedIdentifier(e), n.push({
              type: a,
              value: t,
              start: r
            });else if ("'" === e[(this || _global)._current]) r = (this || _global)._current, t = this._consumeRawStringLiteral(e), n.push({
              type: v,
              value: t,
              start: r
            });else if ("`" === e[(this || _global)._current]) {
              var r = (this || _global)._current,
                  o = this._consumeLiteral(e);

              n.push({
                type: v,
                value: o,
                start: r
              });
            } else if (void 0 !== b[e[(this || _global)._current]]) n.push(this._consumeOperator(e));else if (void 0 !== y[e[(this || _global)._current]]) (this || _global)._current++;else if ("&" === e[(this || _global)._current]) r = (this || _global)._current, (this || _global)._current++, "&" === e[(this || _global)._current] ? ((this || _global)._current++, n.push({
              type: "And",
              value: "&&",
              start: r
            })) : n.push({
              type: R,
              value: "&",
              start: r
            });else {
              if ("|" !== e[(this || _global)._current]) throw (o = new Error("Unknown character:" + e[(this || _global)._current])).name = "LexerError", o;
              r = (this || _global)._current, (this || _global)._current++, "|" === e[(this || _global)._current] ? ((this || _global)._current++, n.push({
                type: "Or",
                value: "||",
                start: r
              })) : n.push({
                type: T,
                value: "|",
                start: r
              });
            }

            return n;
          },
          _consumeUnquotedIdentifier: function (e) {
            var t,
                i = (this || _global)._current;

            for ((this || _global)._current++; (this || _global)._current < e.length && ("a" <= (t = e[(this || _global)._current]) && t <= "z" || "A" <= t && t <= "Z" || "0" <= t && t <= "9" || "_" === t);) (this || _global)._current++;

            return e.slice(i, (this || _global)._current);
          },
          _consumeQuotedIdentifier: function (e) {
            for (var t = (this || _global)._current, i = ((this || _global)._current++, e.length); "\"" !== e[(this || _global)._current] && (this || _global)._current < i;) {
              var n = (this || _global)._current;
              "\\" !== e[n] || "\\" !== e[n + 1] && "\"" !== e[n + 1] ? n++ : n += 2, (this || _global)._current = n;
            }

            return (this || _global)._current++, JSON.parse(e.slice(t, (this || _global)._current));
          },
          _consumeRawStringLiteral: function (e) {
            for (var t = (this || _global)._current, i = ((this || _global)._current++, e.length); "'" !== e[(this || _global)._current] && (this || _global)._current < i;) {
              var n = (this || _global)._current;
              "\\" !== e[n] || "\\" !== e[n + 1] && "'" !== e[n + 1] ? n++ : n += 2, (this || _global)._current = n;
            }

            return (this || _global)._current++, e.slice(t + 1, (this || _global)._current - 1).replace("\\'", "'");
          },
          _consumeNumber: function (e) {
            for (var t = (this || _global)._current, i = ((this || _global)._current++, e.length); $(e[(this || _global)._current]) && (this || _global)._current < i;) (this || _global)._current++;

            var n = parseInt(e.slice(t, (this || _global)._current));
            return {
              type: g,
              value: n,
              start: t
            };
          },
          _consumeLBracket: function (e) {
            var t = (this || _global)._current;
            return (this || _global)._current++, "?" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: m,
              value: "[?",
              start: t
            }) : "]" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: _,
              value: "[]",
              start: t
            }) : {
              type: C,
              value: "[",
              start: t
            };
          },
          _consumeOperator: function (e) {
            var t = (this || _global)._current,
                i = e[t];
            return (this || _global)._current++, "!" === i ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "NE",
              value: "!=",
              start: t
            }) : {
              type: "Not",
              value: "!",
              start: t
            } : "<" === i ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "LTE",
              value: "<=",
              start: t
            }) : {
              type: "LT",
              value: "<",
              start: t
            } : ">" === i ? "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "GTE",
              value: ">=",
              start: t
            }) : {
              type: "GT",
              value: ">",
              start: t
            } : "=" === i && "=" === e[(this || _global)._current] ? ((this || _global)._current++, {
              type: "EQ",
              value: "==",
              start: t
            }) : void 0;
          },
          _consumeLiteral: function (e) {
            (this || _global)._current++;

            for (var t = (this || _global)._current, i = e.length; "`" !== e[(this || _global)._current] && (this || _global)._current < i;) {
              var n = (this || _global)._current;
              "\\" !== e[n] || "\\" !== e[n + 1] && "`" !== e[n + 1] ? n++ : n += 2, (this || _global)._current = n;
            }

            t = (t = r(e.slice(t, (this || _global)._current))).replace("\\`", "`"), t = this._looksLikeJSON(t) ? JSON.parse(t) : JSON.parse("\"" + t + "\"");
            return (this || _global)._current++, t;
          },
          _looksLikeJSON: function (e) {
            if ("" === e) return !1;
            if (0 <= "[{\"".indexOf(e[0])) return !0;
            if (0 <= ["true", "false", "null"].indexOf(e)) return !0;
            if (!(0 <= "-0123456789".indexOf(e[0]))) return !1;

            try {
              return JSON.parse(e), !0;
            } catch (e) {
              return !1;
            }
          }
        };
        var L = {};

        function B() {}

        function W(e) {
          (this || _global).runtime = e;
        }

        function N(e) {
          (this || _global)._interpreter = e, (this || _global).functionTable = {
            abs: {
              _func: (this || _global)._functionAbs,
              _signature: [{
                types: [0]
              }]
            },
            avg: {
              _func: (this || _global)._functionAvg,
              _signature: [{
                types: [8]
              }]
            },
            ceil: {
              _func: (this || _global)._functionCeil,
              _signature: [{
                types: [0]
              }]
            },
            contains: {
              _func: (this || _global)._functionContains,
              _signature: [{
                types: [2, 3]
              }, {
                types: [1]
              }]
            },
            ends_with: {
              _func: (this || _global)._functionEndsWith,
              _signature: [{
                types: [2]
              }, {
                types: [2]
              }]
            },
            floor: {
              _func: (this || _global)._functionFloor,
              _signature: [{
                types: [0]
              }]
            },
            length: {
              _func: (this || _global)._functionLength,
              _signature: [{
                types: [2, 3, 4]
              }]
            },
            map: {
              _func: (this || _global)._functionMap,
              _signature: [{
                types: [6]
              }, {
                types: [3]
              }]
            },
            max: {
              _func: (this || _global)._functionMax,
              _signature: [{
                types: [8, 9]
              }]
            },
            merge: {
              _func: (this || _global)._functionMerge,
              _signature: [{
                types: [4],
                variadic: !0
              }]
            },
            max_by: {
              _func: (this || _global)._functionMaxBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            sum: {
              _func: (this || _global)._functionSum,
              _signature: [{
                types: [8]
              }]
            },
            starts_with: {
              _func: (this || _global)._functionStartsWith,
              _signature: [{
                types: [2]
              }, {
                types: [2]
              }]
            },
            min: {
              _func: (this || _global)._functionMin,
              _signature: [{
                types: [8, 9]
              }]
            },
            min_by: {
              _func: (this || _global)._functionMinBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            type: {
              _func: (this || _global)._functionType,
              _signature: [{
                types: [1]
              }]
            },
            keys: {
              _func: (this || _global)._functionKeys,
              _signature: [{
                types: [4]
              }]
            },
            values: {
              _func: (this || _global)._functionValues,
              _signature: [{
                types: [4]
              }]
            },
            sort: {
              _func: (this || _global)._functionSort,
              _signature: [{
                types: [9, 8]
              }]
            },
            sort_by: {
              _func: (this || _global)._functionSortBy,
              _signature: [{
                types: [3]
              }, {
                types: [6]
              }]
            },
            join: {
              _func: (this || _global)._functionJoin,
              _signature: [{
                types: [2]
              }, {
                types: [9]
              }]
            },
            reverse: {
              _func: (this || _global)._functionReverse,
              _signature: [{
                types: [2, 3]
              }]
            },
            to_array: {
              _func: (this || _global)._functionToArray,
              _signature: [{
                types: [1]
              }]
            },
            to_string: {
              _func: (this || _global)._functionToString,
              _signature: [{
                types: [1]
              }]
            },
            to_number: {
              _func: (this || _global)._functionToNumber,
              _signature: [{
                types: [1]
              }]
            },
            not_null: {
              _func: (this || _global)._functionNotNull,
              _signature: [{
                types: [1],
                variadic: !0
              }]
            }
          };
        }

        L.EOF = 0, L[s] = 0, L[a] = 0, L[l] = 0, L[c] = 0, L[d] = 0, L[o] = 0, L[g] = 0, L[E] = 0, L[R] = 0, L.Pipe = 1, L.Or = 2, L.And = 3, L.EQ = 5, L.GT = 5, L.LT = 5, L.GTE = 5, L.LTE = 5, L.NE = 5, L[_] = 9, L.Star = 20, L[m] = 21, L.Dot = 40, L.Not = 45, L[f] = 50, L[C] = 55, L[I] = 60, B.prototype = {
          parse: function (e) {
            this._loadTokens(e), (this || _global).index = 0;
            var t,
                e = this.expression(0);
            if ("EOF" !== this._lookahead(0)) throw t = this._lookaheadToken(0), (t = new Error("Unexpected token type: " + t.type + ", value: " + t.value)).name = "ParserError", t;
            return e;
          },
          _loadTokens: function (e) {
            var t = new i().tokenize(e);
            t.push({
              type: "EOF",
              value: "",
              start: e.length
            }), (this || _global).tokens = t;
          },
          expression: function (e) {
            for (var t = this._lookaheadToken(0), i = (this._advance(), this.nud(t)), n = this._lookahead(0); e < L[n];) this._advance(), i = this.led(n, i), n = this._lookahead(0);

            return i;
          },
          _lookahead: function (e) {
            return (this || _global).tokens[(this || _global).index + e].type;
          },
          _lookaheadToken: function (e) {
            return (this || _global).tokens[(this || _global).index + e];
          },
          _advance: function () {
            (this || _global).index++;
          },
          nud: function (e) {
            var t, i;

            switch (e.type) {
              case v:
                return {
                  type: "Literal",
                  value: e.value
                };

              case s:
                return {
                  type: "Field",
                  name: e.value
                };

              case a:
                var n = {
                  type: "Field",
                  name: e.value
                };
                if (this._lookahead(0) === I) throw new Error("Quoted identifier not allowed for function names.");
                return n;

              case "Not":
                return {
                  type: "NotExpression",
                  children: [t = this.expression(L.Not)]
                };

              case p:
                return t = null, {
                  type: "ValueProjection",
                  children: [{
                    type: "Identity"
                  }, t = this._lookahead(0) === l ? {
                    type: "Identity"
                  } : this._parseProjectionRHS(L.Star)]
                };

              case m:
                return this.led(e.type, {
                  type: "Identity"
                });

              case f:
                return this._parseMultiselectHash();

              case _:
                return {
                  type: "Projection",
                  children: [{
                    type: _,
                    children: [{
                      type: "Identity"
                    }]
                  }, t = this._parseProjectionRHS(L.Flatten)]
                };

              case C:
                return this._lookahead(0) === g || this._lookahead(0) === u ? (t = this._parseIndexExpression(), this._projectIfSlice({
                  type: "Identity"
                }, t)) : this._lookahead(0) === p && this._lookahead(1) === l ? (this._advance(), this._advance(), {
                  type: "Projection",
                  children: [{
                    type: "Identity"
                  }, t = this._parseProjectionRHS(L.Star)]
                }) : this._parseMultiselectList();

              case E:
                return {
                  type: E
                };

              case R:
                return {
                  type: "ExpressionReference",
                  children: [i = this.expression(L.Expref)]
                };

              case I:
                for (var r = []; this._lookahead(0) !== c;) this._lookahead(0) === E ? (i = {
                  type: E
                }, this._advance()) : i = this.expression(0), r.push(i);

                return this._match(c), r[0];

              default:
                this._errorToken(e);

            }
          },
          led: function (e, t) {
            var i;

            switch (e) {
              case "Dot":
                var n = L.Dot;
                return this._lookahead(0) !== p ? {
                  type: "Subexpression",
                  children: [t, i = this._parseDotRHS(n)]
                } : (this._advance(), {
                  type: "ValueProjection",
                  children: [t, i = this._parseProjectionRHS(n)]
                });

              case T:
                return i = this.expression(L.Pipe), {
                  type: T,
                  children: [t, i]
                };

              case "Or":
                return {
                  type: "OrExpression",
                  children: [t, i = this.expression(L.Or)]
                };

              case "And":
                return {
                  type: "AndExpression",
                  children: [t, i = this.expression(L.And)]
                };

              case I:
                for (var r, n = t.name, o = []; this._lookahead(0) !== c;) this._lookahead(0) === E ? (r = {
                  type: E
                }, this._advance()) : r = this.expression(0), this._lookahead(0) === d && this._match(d), o.push(r);

                return this._match(c), {
                  type: "Function",
                  name: n,
                  children: o
                };

              case m:
                n = this.expression(0);
                return this._match(l), {
                  type: "FilterProjection",
                  children: [t, i = this._lookahead(0) === _ ? {
                    type: "Identity"
                  } : this._parseProjectionRHS(L.Filter), n]
                };

              case _:
                return {
                  type: "Projection",
                  children: [{
                    type: _,
                    children: [t]
                  }, this._parseProjectionRHS(L.Flatten)]
                };

              case "EQ":
              case "NE":
              case "GT":
              case "GTE":
              case "LT":
              case "LTE":
                return this._parseComparator(t, e);

              case C:
                n = this._lookaheadToken(0);
                return n.type === g || n.type === u ? (i = this._parseIndexExpression(), this._projectIfSlice(t, i)) : (this._match(p), this._match(l), {
                  type: "Projection",
                  children: [t, i = this._parseProjectionRHS(L.Star)]
                });

              default:
                this._errorToken(this._lookaheadToken(0));

            }
          },
          _match: function (e) {
            var t;
            if (this._lookahead(0) !== e) throw t = this._lookaheadToken(0), (e = new Error("Expected " + e + ", got: " + t.type)).name = "ParserError", e;

            this._advance();
          },
          _errorToken: function (e) {
            e = new Error("Invalid token (" + e.type + "): \"" + e.value + "\"");
            throw e.name = "ParserError", e;
          },
          _parseIndexExpression: function () {
            var e;
            return this._lookahead(0) === u || this._lookahead(1) === u ? this._parseSliceExpression() : (e = {
              type: "Index",
              value: this._lookaheadToken(0).value
            }, this._advance(), this._match(l), e);
          },
          _projectIfSlice: function (e, t) {
            e = {
              type: "IndexExpression",
              children: [e, t]
            };
            return "Slice" === t.type ? {
              type: "Projection",
              children: [e, this._parseProjectionRHS(L.Star)]
            } : e;
          },
          _parseSliceExpression: function () {
            for (var e, t = [null, null, null], i = 0, n = this._lookahead(0); n !== l && i < 3;) {
              if (n === u) i++, this._advance();else {
                if (n !== g) throw e = this._lookahead(0), (e = new Error("Syntax error, unexpected token: " + e.value + "(" + e.type + ")")).name = "Parsererror", e;
                t[i] = this._lookaheadToken(0).value, this._advance();
              }
              n = this._lookahead(0);
            }

            return this._match(l), {
              type: "Slice",
              children: t
            };
          },
          _parseComparator: function (e, t) {
            return {
              type: "Comparator",
              name: t,
              children: [e, this.expression(L[t])]
            };
          },
          _parseDotRHS: function (e) {
            var t = this._lookahead(0);

            return 0 <= [s, a, p].indexOf(t) ? this.expression(e) : t === C ? (this._match(C), this._parseMultiselectList()) : t === f ? (this._match(f), this._parseMultiselectHash()) : void 0;
          },
          _parseProjectionRHS: function (e) {
            var t, i;
            if (L[this._lookahead(0)] < 10) t = {
              type: "Identity"
            };else if (this._lookahead(0) === C) t = this.expression(e);else if (this._lookahead(0) === m) t = this.expression(e);else {
              if ("Dot" !== this._lookahead(0)) throw i = this._lookaheadToken(0), (i = new Error("Sytanx error, unexpected token: " + i.value + "(" + i.type + ")")).name = "ParserError", i;
              this._match("Dot"), t = this._parseDotRHS(e);
            }
            return t;
          },
          _parseMultiselectList: function () {
            for (var e = []; this._lookahead(0) !== l;) {
              var t = this.expression(0);
              if (e.push(t), this._lookahead(0) === d && (this._match(d), this._lookahead(0) === l)) throw new Error("Unexpected token Rbracket");
            }

            return this._match(l), {
              type: "MultiSelectList",
              children: e
            };
          },
          _parseMultiselectHash: function () {
            for (var e, t, i = [], n = [s, a];;) {
              if (e = this._lookaheadToken(0), n.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
              if (e = e.value, this._advance(), this._match(u), t = this.expression(0), i.push({
                type: "KeyValuePair",
                name: e,
                value: t
              }), this._lookahead(0) === d) this._match(d);else if (this._lookahead(0) === o) {
                this._match(o);

                break;
              }
            }

            return {
              type: "MultiSelectHash",
              children: i
            };
          }
        }, W.prototype = {
          search: function (e, t) {
            return this.visit(e, t);
          },
          visit: function (e, t) {
            var i, n, r, o, s, a;

            switch (e.type) {
              case "Field":
                return null !== t && S(t) ? void 0 === (l = t[e.name]) ? null : l : null;

              case "Subexpression":
                for (u = this.visit(e.children[0], t), f = 1; f < e.children.length; f++) if (null === (u = this.visit(e.children[1], u))) return null;

                return u;

              case "IndexExpression":
                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);

              case "Index":
                if (!w(t)) return null;
                var l = e.value;
                return u = void 0 === (u = t[l = l < 0 ? t.length + l : l]) ? null : u;

              case "Slice":
                if (!w(t)) return null;
                var l = e.children.slice(0),
                    l = this.computeSliceParams(t.length, l),
                    c = l[0],
                    h = l[1],
                    d = l[2],
                    u = [];
                if (0 < d) for (f = c; f < h; f += d) u.push(t[f]);else for (f = c; h < f; f += d) u.push(t[f]);
                return u;

              case "Projection":
                var g = this.visit(e.children[0], t);
                if (!w(g)) return null;

                for (p = [], f = 0; f < g.length; f++) null !== (n = this.visit(e.children[1], g[f])) && p.push(n);

                return p;

              case "ValueProjection":
                if (!S(g = this.visit(e.children[0], t))) return null;

                for (var p = [], m = function (e) {
                  for (var t = Object.keys(e), i = [], n = 0; n < t.length; n++) i.push(e[t[n]]);

                  return i;
                }(g), f = 0; f < m.length; f++) null !== (n = this.visit(e.children[1], m[f])) && p.push(n);

                return p;

              case "FilterProjection":
                if (!w(g = this.visit(e.children[0], t))) return null;
                var C = [],
                    I = [];

                for (f = 0; f < g.length; f++) k(i = this.visit(e.children[2], g[f])) || C.push(g[f]);

                for (var v = 0; v < C.length; v++) null !== (n = this.visit(e.children[1], C[v])) && I.push(n);

                return I;

              case "Comparator":
                switch (r = this.visit(e.children[0], t), o = this.visit(e.children[1], t), e.name) {
                  case "EQ":
                    u = x(r, o);
                    break;

                  case "NE":
                    u = !x(r, o);
                    break;

                  case "GT":
                    u = o < r;
                    break;

                  case "GTE":
                    u = o <= r;
                    break;

                  case "LT":
                    u = r < o;
                    break;

                  case "LTE":
                    u = r <= o;
                    break;

                  default:
                    throw new Error("Unknown comparator: " + e.name);
                }

                return u;

              case _:
                var A = this.visit(e.children[0], t);
                if (!w(A)) return null;
                var b = [];

                for (f = 0; f < A.length; f++) w(n = A[f]) ? b.push.apply(b, n) : b.push(n);

                return b;

              case "Identity":
                return t;

              case "MultiSelectList":
                if (null === t) return null;

                for (p = [], f = 0; f < e.children.length; f++) p.push(this.visit(e.children[f], t));

                return p;

              case "MultiSelectHash":
                if (null === t) return null;

                for (p = {}, f = 0; f < e.children.length; f++) p[(a = e.children[f]).name] = this.visit(a.value, t);

                return p;

              case "OrExpression":
                return i = k(i = this.visit(e.children[0], t)) ? this.visit(e.children[1], t) : i;

              case "AndExpression":
                return !0 === k(r = this.visit(e.children[0], t)) ? r : this.visit(e.children[1], t);

              case "NotExpression":
                return k(r = this.visit(e.children[0], t));

              case "Literal":
                return e.value;

              case T:
                return s = this.visit(e.children[0], t), this.visit(e.children[1], s);

              case E:
                return t;

              case "Function":
                var y = [];

                for (f = 0; f < e.children.length; f++) y.push(this.visit(e.children[f], t));

                return (this || _global).runtime.callFunction(e.name, y);

              case "ExpressionReference":
                l = e.children[0];
                return l.jmespathType = R, l;

              default:
                throw new Error("Unknown node type: " + e.type);
            }
          },
          computeSliceParams: function (e, t) {
            var i = t[0],
                n = t[1],
                t = t[2],
                r = [null, null, null];
            if (null === t) t = 1;else if (0 === t) throw (o = new Error("Invalid slice, step cannot be 0")).name = "RuntimeError", o;
            var o = t < 0,
                i = null === i ? o ? e - 1 : 0 : this.capSliceRange(e, i, t),
                n = null === n ? o ? -1 : e : this.capSliceRange(e, n, t);
            return r[0] = i, r[1] = n, r[2] = t, r;
          },
          capSliceRange: function (e, t, i) {
            return t < 0 ? (t += e) < 0 && (t = i < 0 ? -1 : 0) : e <= t && (t = i < 0 ? e - 1 : e), t;
          }
        }, N.prototype = {
          callFunction: function (e, t) {
            var i = (this || _global).functionTable[e];
            if (void 0 === i) throw new Error("Unknown function: " + e + "()");
            return this._validateArgs(e, t, i._signature), i._func.call(this || _global, t);
          },
          _validateArgs: function (e, t, i) {
            var n;

            if (i[i.length - 1].variadic) {
              if (t.length < i.length) throw n = 1 === i.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + i.length + n + " but received " + t.length);
            } else if (t.length !== i.length) throw n = 1 === i.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + i.length + n + " but received " + t.length);

            for (var r = 0; r < i.length; r++) {
              for (var o, s = !1, a = i[r].types, l = this._getTypeName(t[r]), c = 0; c < a.length; c++) if (this._typeMatches(l, a[c], t[r])) {
                s = !0;
                break;
              }

              if (!s) throw o = a.map(function (e) {
                return h[e];
              }).join(","), new Error("TypeError: " + e + "() expected argument " + (r + 1) + " to be type " + o + " but received type " + h[l] + " instead.");
            }
          },
          _typeMatches: function (e, t, i) {
            if (1 === t) return !0;
            if (9 !== t && 8 !== t && 3 !== t) return e === t;
            if (3 === t) return 3 === e;

            if (3 === e) {
              var n;
              8 === t ? n = 0 : 9 === t && (n = 2);

              for (var r = 0; r < i.length; r++) if (!this._typeMatches(this._getTypeName(i[r]), n, i[r])) return !1;

              return !0;
            }
          },
          _getTypeName: function (e) {
            switch (Object.prototype.toString.call(e)) {
              case "[object String]":
                return 2;

              case "[object Number]":
                return 0;

              case "[object Array]":
                return 3;

              case "[object Boolean]":
                return 5;

              case "[object Null]":
                return 7;

              case "[object Object]":
                return e.jmespathType === R ? 6 : 4;
            }
          },
          _functionStartsWith: function (e) {
            return 0 === e[0].lastIndexOf(e[1]);
          },
          _functionEndsWith: function (e) {
            var t = e[0],
                e = e[1];
            return -1 !== t.indexOf(e, t.length - e.length);
          },
          _functionReverse: function (e) {
            var t;
            if (2 !== this._getTypeName(e[0])) return (t = e[0].slice(0)).reverse(), t;

            for (var i = e[0], n = "", r = i.length - 1; 0 <= r; r--) n += i[r];

            return n;
          },
          _functionAbs: function (e) {
            return Math.abs(e[0]);
          },
          _functionCeil: function (e) {
            return Math.ceil(e[0]);
          },
          _functionAvg: function (e) {
            for (var t = 0, i = e[0], n = 0; n < i.length; n++) t += i[n];

            return t / i.length;
          },
          _functionContains: function (e) {
            return 0 <= e[0].indexOf(e[1]);
          },
          _functionFloor: function (e) {
            return Math.floor(e[0]);
          },
          _functionLength: function (e) {
            return (S(e[0]) ? Object.keys(e[0]) : e[0]).length;
          },
          _functionMap: function (e) {
            for (var t = [], i = (this || _global)._interpreter, n = e[0], r = e[1], o = 0; o < r.length; o++) t.push(i.visit(n, r[o]));

            return t;
          },
          _functionMerge: function (e) {
            for (var t = {}, i = 0; i < e.length; i++) {
              var n,
                  r = e[i];

              for (n in r) t[n] = r[n];
            }

            return t;
          },
          _functionMax: function (e) {
            if (0 < e[0].length) {
              if (0 === this._getTypeName(e[0][0])) return Math.max.apply(Math, e[0]);

              for (var t = e[0], i = t[0], n = 1; n < t.length; n++) i.localeCompare(t[n]) < 0 && (i = t[n]);

              return i;
            }

            return null;
          },
          _functionMin: function (e) {
            if (0 < e[0].length) {
              if (0 === this._getTypeName(e[0][0])) return Math.min.apply(Math, e[0]);

              for (var t = e[0], i = t[0], n = 1; n < t.length; n++) t[n].localeCompare(i) < 0 && (i = t[n]);

              return i;
            }

            return null;
          },
          _functionSum: function (e) {
            for (var t = 0, i = e[0], n = 0; n < i.length; n++) t += i[n];

            return t;
          },
          _functionType: function (e) {
            switch (this._getTypeName(e[0])) {
              case 0:
                return "number";

              case 2:
                return "string";

              case 3:
                return "array";

              case 4:
                return "object";

              case 5:
                return "boolean";

              case 6:
                return "expref";

              case 7:
                return "null";
            }
          },
          _functionKeys: function (e) {
            return Object.keys(e[0]);
          },
          _functionValues: function (e) {
            for (var t = e[0], i = Object.keys(t), n = [], r = 0; r < i.length; r++) n.push(t[i[r]]);

            return n;
          },
          _functionJoin: function (e) {
            var t = e[0];
            return e[1].join(t);
          },
          _functionToArray: function (e) {
            return 3 === this._getTypeName(e[0]) ? e[0] : [e[0]];
          },
          _functionToString: function (e) {
            return 2 === this._getTypeName(e[0]) ? e[0] : JSON.stringify(e[0]);
          },
          _functionToNumber: function (e) {
            var t = this._getTypeName(e[0]);

            return 0 === t ? e[0] : 2 !== t || (t = +e[0], isNaN(t)) ? null : t;
          },
          _functionNotNull: function (e) {
            for (var t = 0; t < e.length; t++) if (7 !== this._getTypeName(e[t])) return e[t];

            return null;
          },
          _functionSort: function (e) {
            e = e[0].slice(0);
            return e.sort(), e;
          },
          _functionSortBy: function (e) {
            var t = e[0].slice(0);
            if (0 === t.length) return t;

            var r = (this || _global)._interpreter,
                o = e[1],
                s = this._getTypeName(r.visit(o, t[0]));

            if ([0, 2].indexOf(s) < 0) throw new Error("TypeError");

            for (var a = this || _global, i = [], n = 0; n < t.length; n++) i.push([n, t[n]]);

            i.sort(function (e, t) {
              var i = r.visit(o, e[1]),
                  n = r.visit(o, t[1]);
              if (a._getTypeName(i) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(i));
              if (a._getTypeName(n) !== s) throw new Error("TypeError: expected " + s + ", received " + a._getTypeName(n));
              return n < i ? 1 : i < n ? -1 : e[0] - t[0];
            });

            for (var l = 0; l < i.length; l++) t[l] = i[l][1];

            return t;
          },
          _functionMaxBy: function (e) {
            for (var t, i, n = e[1], r = e[0], o = this.createKeyFunction(n, [0, 2]), s = -1 / 0, a = 0; a < r.length; a++) s < (i = o(r[a])) && (s = i, t = r[a]);

            return t;
          },
          _functionMinBy: function (e) {
            for (var t, i, n = e[1], r = e[0], o = this.createKeyFunction(n, [0, 2]), s = 1 / 0, a = 0; a < r.length; a++) (i = o(r[a])) < s && (s = i, t = r[a]);

            return t;
          },
          createKeyFunction: function (i, n) {
            var r = this || _global,
                o = (this || _global)._interpreter;
            return function (e) {
              var t,
                  e = o.visit(i, e);
              if (n.indexOf(r._getTypeName(e)) < 0) throw t = "TypeError: expected one of " + n + ", received " + r._getTypeName(e), new Error(t);
              return e;
            };
          }
        }, e.tokenize = function (e) {
          return new i().tokenize(e);
        }, e.compile = function (e) {
          return new B().parse(e);
        }, e.search = function (e, t) {
          var i = new B(),
              n = new W(r = new N()),
              r = (r._interpreter = n, i.parse(t));
          return n.search(r, e);
        }, e.strictDeepEqual = x;
      }(t);
    },
    500: function (e) {
      "use strict";

      var m = e.exports = function (e, t, i) {
        "function" == typeof t && (i = t, t = {}), function e(t, i, n, r, o, s, a, l, c, h) {
          if (r && "object" == typeof r && !Array.isArray(r)) {
            for (var d in i(r, o, s, a, l, c, h), r) {
              var u = r[d];

              if (Array.isArray(u)) {
                if (d in m.arrayKeywords) for (var g = 0; g < u.length; g++) e(t, i, n, u[g], o + "/" + d + "/" + g, s, o, d, r, g);
              } else if (d in m.propsKeywords) {
                if (u && "object" == typeof u) for (var p in u) e(t, i, n, u[p], o + "/" + d + "/" + f(p), s, o, d, r, p);
              } else (d in m.keywords || t.allKeys && !(d in m.skipKeywords)) && e(t, i, n, u, o + "/" + d, s, o, d, r);
            }

            n(r, o, s, a, l, c, h);
          }
        }(t, "function" == typeof (i = t.cb || i) ? i : i.pre || function () {}, i.post || function () {}, e, "", e);
      };

      function f(e) {
        return e.replace(/~/g, "~0").replace(/\//g, "~1");
      }

      m.keywords = {
        additionalItems: !0,
        items: !0,
        contains: !0,
        additionalProperties: !0,
        propertyNames: !0,
        not: !0
      }, m.arrayKeywords = {
        items: !0,
        allOf: !0,
        anyOf: !0,
        oneOf: !0
      }, m.propsKeywords = {
        definitions: !0,
        properties: !0,
        patternProperties: !0,
        dependencies: !0
      }, m.skipKeywords = {
        default: !0,
        enum: !0,
        const: !0,
        required: !0,
        maximum: !0,
        minimum: !0,
        exclusiveMaximum: !0,
        exclusiveMinimum: !0,
        multipleOf: !0,
        maxLength: !0,
        minLength: !0,
        pattern: !0,
        format: !0,
        maxItems: !0,
        minItems: !0,
        uniqueItems: !0,
        maxProperties: !0,
        minProperties: !0
      };
    },
    7026: function (e, t) {
      "use strict";

      var b = {
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "\t",
        "\"": "\"",
        "/": "/",
        "\\": "\\"
      },
          y = "a".charCodeAt(),
          i = (t.parse = function (r, e, t) {
        var n = {},
            i = 0,
            o = 0,
            s = 0,
            a = t && t.bigint && "undefined" != typeof BigInt;
        return {
          data: l("", !0),
          pointers: n
        };

        function l(e, t) {
          c(), m(e, "value");
          var i,
              n = u();

          switch (n) {
            case "t":
              d("rue"), i = !0;
              break;

            case "f":
              d("alse"), i = !1;
              break;

            case "n":
              d("ull"), i = null;
              break;

            case "\"":
              i = h();
              break;

            case "[":
              i = function (e) {
                c();
                var t = [],
                    i = 0;
                if ("]" == u()) return t;
                g();

                for (;;) {
                  var n = e + "/" + i,
                      n = (t.push(l(n)), c(), u());
                  if ("]" == n) break;
                  "," != n && v(), c(), i++;
                }

                return t;
              }(e);

              break;

            case "{":
              i = function (e) {
                c();
                var t = {};
                if ("}" == u()) return t;
                g();

                for (;;) {
                  var i = C(),
                      n = ("\"" != u() && v(), h()),
                      r = e + "/" + w(n),
                      i = (f(r, "key", i), m(r, "keyEnd"), c(), ":" != u() && v(), c(), t[n] = l(r), c(), u());
                  if ("}" == i) break;
                  "," != i && v(), c();
                }

                return t;
              }(e);

              break;

            default:
              g(), 0 <= "-0123456789".indexOf(n) ? i = function () {
                var e = "",
                    t = !0;
                "-" == r[s] && (e += u());
                e += ("0" == r[s] ? u : p)(), "." == r[s] && (e += u() + p(), t = !1);
                "e" != r[s] && "E" != r[s] || (e += u(), "+" != r[s] && "-" != r[s] || (e += u()), e += p(), t = !1);
                var i = +e;
                return a && t && (i > Number.MAX_SAFE_INTEGER || i < Number.MIN_SAFE_INTEGER) ? BigInt(e) : i;
              }() : I();
          }

          return m(e, "valueEnd"), c(), t && s < r.length && I(), i;
        }

        function c() {
          e: for (; s < r.length;) {
            switch (r[s]) {
              case " ":
                o++;
                break;

              case "\t":
                o += 4;
                break;

              case "\r":
                o = 0;
                break;

              case "\n":
                o = 0, i++;
                break;

              default:
                break e;
            }

            s++;
          }
        }

        function h() {
          for (var e, t = ""; "\"" != (e = u());) "\\" == e ? (e = u()) in b ? t += b[e] : "u" == e ? t += function () {
            var e = 4,
                t = 0;

            for (; e--;) {
              t <<= 4;
              var i = u().toLowerCase();
              "a" <= i && i <= "f" ? t += i.charCodeAt() - y + 10 : "0" <= i && i <= "9" ? t += +i : v();
            }

            return String.fromCharCode(t);
          }() : v() : t += e;

          return t;
        }

        function d(e) {
          for (var t = 0; t < e.length; t++) u() !== e[t] && v();
        }

        function u() {
          A();
          var e = r[s];
          return s++, o++, e;
        }

        function g() {
          s--, o--;
        }

        function p() {
          for (var e = ""; "0" <= r[s] && r[s] <= "9";) e += u();

          if (e.length) return e;
          A(), I();
        }

        function m(e, t) {
          f(e, t, C());
        }

        function f(e, t, i) {
          n[e] = n[e] || {}, n[e][t] = i;
        }

        function C() {
          return {
            line: i,
            column: o,
            pos: s
          };
        }

        function I() {
          throw new SyntaxError("Unexpected token " + r[s] + " in JSON at position " + s);
        }

        function v() {
          g(), I();
        }

        function A() {
          if (s >= r.length) throw new SyntaxError("Unexpected end of JSON input");
        }
      }, t.stringify = function (e, t, i) {
        if (v(e)) {
          var n = 0;

          switch (typeof (u = "object" == typeof i ? i.space : i)) {
            case "number":
              var r = 10 < u ? 10 : u < 0 ? 0 : Math.floor(u),
                  u = r && I(r, " "),
                  o = r,
                  s = r;
              break;

            case "string":
              u = u.slice(0, 10);

              for (var a = s = o = 0; a < u.length; a++) {
                switch (u[a]) {
                  case " ":
                    s++;
                    break;

                  case "\t":
                    s += 4;
                    break;

                  case "\r":
                    s = 0;
                    break;

                  case "\n":
                    s = 0, n++;
                    break;

                  default:
                    throw new Error("whitespace characters not allowed in JSON");
                }

                o++;
              }

              break;

            default:
              u = void 0;
          }

          var l = "",
              c = {},
              h = 0,
              d = 0,
              g = 0,
              p = i && i.es6 && "function" == typeof Map;
          return function l(c, h, d) {
            C(d, "value");

            switch (typeof c) {
              case "number":
              case "bigint":
              case "boolean":
                m("" + c);
                break;

              case "string":
                m(A(c));
                break;

              case "object":
                null === c ? m("null") : "function" == typeof c.toJSON ? m(A(c.toJSON())) : Array.isArray(c) ? e() : p ? c.constructor.BYTES_PER_ELEMENT ? e() : c instanceof Map ? i() : c instanceof Set ? i(!0) : t() : t();
            }

            C(d, "valueEnd");

            function e() {
              if (c.length) {
                m("[");

                for (var e = h + 1, t = 0; t < c.length; t++) {
                  t && m(","), f(e);
                  var i = v(c[t]) ? c[t] : null,
                      n = d + "/" + t;
                  l(i, e, n);
                }

                f(h), m("]");
              } else m("[]");
            }

            function t() {
              var e = Object.keys(c);

              if (e.length) {
                m("{");

                for (var t = h + 1, i = 0; i < e.length; i++) {
                  var n,
                      r = e[i],
                      o = c[r];
                  v(o) && (i && m(","), n = d + "/" + w(r), f(t), C(n, "key"), m(A(r)), C(n, "keyEnd"), m(":"), u && m(" "), l(o, t, n));
                }

                f(h), m("}");
              } else m("{}");
            }

            function i(e) {
              if (c.size) {
                m("{");

                for (var t = h + 1, i = !0, n = c.entries(), r = n.next(); !r.done;) {
                  var o,
                      s = r.value,
                      a = s[0],
                      s = !!e || s[1];
                  v(s) && (i || m(","), i = !1, o = d + "/" + w(a), f(t), C(o, "key"), m(A(a)), C(o, "keyEnd"), m(":"), u && m(" "), l(s, t, o)), r = n.next();
                }

                f(h), m("}");
              } else m("{}");
            }
          }(e, 0, ""), {
            json: l,
            pointers: c
          };
        }

        function m(e) {
          d += e.length, g += e.length, l += e;
        }

        function f(e) {
          if (u) {
            for (l += "\n" + I(e, u), h++, d = 0; e--;) n ? (h += n, d = s) : d += s, g += o;

            g += 1;
          }
        }

        function C(e, t) {
          c[e] = c[e] || {}, c[e][t] = {
            line: h,
            column: d,
            pos: g
          };
        }

        function I(e, t) {
          return Array(e + 1).join(t);
        }
      }, ["number", "bigint", "boolean", "string", "object"]);

      function v(e) {
        return 0 <= i.indexOf(typeof e);
      }

      var n = /"|\\/g,
          r = /[\b]/g,
          o = /\f/g,
          s = /\n/g,
          a = /\r/g,
          l = /\t/g;

      function A(e) {
        return "\"" + (e = e.replace(n, "\\$&").replace(o, "\\f").replace(r, "\\b").replace(s, "\\n").replace(a, "\\r").replace(l, "\\t")) + "\"";
      }

      var c = /~/g,
          h = /\//g;

      function w(e) {
        return e.replace(c, "~0").replace(h, "~1");
      }
    },
    483: function (e, t) {
      var i, n;
      !function () {
        "use strict";

        n = [], void 0 !== (n = "function" == typeof (i = function () {
          "use strict";

          function C(e) {
            if (typeof Node === "object") return e instanceof Node;else return e && typeof e === "object" && typeof e.nodeType === "number";
          }

          function I(e) {
            return typeof e === "string";
          }

          function v() {
            var o = [];
            return {
              watch: o.push.bind(o),
              trigger: function (e, t) {
                var i = true;
                var n = {
                  detail: t,
                  preventDefault: function e() {
                    i = false;
                  }
                };

                for (var r = 0; r < o.length; r++) o[r](e, n);

                return i;
              }
            };
          }

          function r(e) {
            return window.getComputedStyle(e).display === "none";
          }

          function o(e) {
            (this || _global).elem = e;
          }

          function A(e, t) {
            return o.make(e("parent")).clazz("pico-overlay").clazz(e("overlayClass", "")).stylize({
              display: "none",
              position: "fixed",
              top: "0px",
              left: "0px",
              height: "100%",
              width: "100%",
              zIndex: 10000
            }).stylize(e("overlayStyles", {
              opacity: 0.5,
              background: "#000"
            })).onClick(function () {
              if (e("overlayClose", true)) t();
            });
          }

          o.make = function (e, t) {
            if (typeof e === "string") e = document.querySelector(e);
            var i = document.createElement(t || "div");
            (e || document.body).appendChild(i);
            return new o(i);
          }, o.prototype = {
            child: function (e) {
              return o.make((this || _global).elem, e);
            },
            stylize: function (e) {
              e = e || {};
              if (typeof e.opacity !== "undefined") e.filter = "alpha(opacity=" + e.opacity * 100 + ")";

              for (var t in e) if (e.hasOwnProperty(t)) (this || _global).elem.style[t] = e[t];

              return this || _global;
            },
            clazz: function (e) {
              (this || _global).elem.className += " " + e;
              return this || _global;
            },
            html: function (e) {
              if (C(e)) (this || _global).elem.appendChild(e);else (this || _global).elem.innerHTML = e;
              return this || _global;
            },
            onClick: function (e) {
              (this || _global).elem.addEventListener("click", e);

              return this || _global;
            },
            destroy: function () {
              (this || _global).elem.parentNode.removeChild((this || _global).elem);
            },
            hide: function () {
              (this || _global).elem.style.display = "none";
            },
            show: function () {
              (this || _global).elem.style.display = "block";
            },
            attr: function (e, t) {
              if (t !== undefined) (this || _global).elem.setAttribute(e, t);
              return this || _global;
            },
            anyAncestor: function (e) {
              var t = (this || _global).elem;

              while (t) if (e(new o(t))) return true;else t = t.parentNode;

              return false;
            },
            isVisible: function () {
              return !r((this || _global).elem);
            }
          };
          var s = 1;

          function b(e, i) {
            var t = e("width", "auto");
            if (typeof t === "number") t = "" + t + "px";
            var n = e("modalId", "pico-" + s++);
            var r = o.make(e("parent")).clazz("pico-content").clazz(e("modalClass", "")).stylize({
              display: "none",
              position: "fixed",
              zIndex: 10001,
              left: "50%",
              top: "38.1966%",
              maxHeight: "90%",
              boxSizing: "border-box",
              width: t,
              "-ms-transform": "translate(-50%,-38.1966%)",
              "-moz-transform": "translate(-50%,-38.1966%)",
              "-webkit-transform": "translate(-50%,-38.1966%)",
              "-o-transform": "translate(-50%,-38.1966%)",
              transform: "translate(-50%,-38.1966%)"
            }).stylize(e("modalStyles", {
              overflow: "auto",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "5px"
            })).html(e("content")).attr("id", n).attr("role", "dialog").attr("aria-labelledby", e("ariaLabelledBy")).attr("aria-describedby", e("ariaDescribedBy", n)).onClick(function (e) {
              var t = new o(e.target).anyAncestor(function (e) {
                return /\bpico-close\b/.test(e.elem.className);
              });
              if (t) i();
            });
            return r;
          }

          function y(e, t) {
            if (t("closeButton", true)) return e.child("button").html(t("closeHtml", "&#xD7;")).clazz("pico-close").clazz(t("closeClass", "")).stylize(t("closeStyles", {
              borderRadius: "2px",
              border: 0,
              padding: 0,
              cursor: "pointer",
              height: "15px",
              width: "15px",
              position: "absolute",
              top: "5px",
              right: "5px",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "15px",
              background: "#CCC"
            })).attr("aria-label", t("close-label", "Close"));
          }

          function w(e) {
            return function () {
              return e().elem;
            };
          }

          var S = v(),
              c = v();

          function x(o, s) {
            function t(e, t) {
              var i = e.msMatchesSelector || e.webkitMatchesSelector || e.matches;
              return i.call(e, t);
            }

            function n(e) {
              if (r(e) || t(e, ":disabled") || e.hasAttribute("contenteditable")) return false;else return e.hasAttribute("tabindex") || t(e, "input,select,textarea,button,a[href],area[href],iframe");
            }

            function a(e) {
              var t = e.getElementsByTagName("*");

              for (var i = 0; i < t.length; i++) if (n(t[i])) return t[i];
            }

            function l(e) {
              var t = e.getElementsByTagName("*");

              for (var i = t.length; i--;) if (n(t[i])) return t[i];
            }

            var i;
            o.beforeShow(function e() {
              i = document.activeElement;
            });
            o.afterShow(function e() {
              if (s()) {
                var t = a(o.modalElem());
                if (t) t.focus();
              }
            });
            o.afterClose(function e() {
              if (s() && i) i.focus();
              i = null;
            });
            c.watch(function e(t) {
              if (s() && o.isVisible()) {
                var i = a(o.modalElem());
                var n = l(o.modalElem());
                var r = t.shiftKey ? i : n;

                if (r === document.activeElement) {
                  (t.shiftKey ? n : i).focus();
                  t.preventDefault();
                }
              }
            });
          }

          function k(e, t) {
            var i;
            var n = new o(document.body);
            e.beforeShow(function () {
              i = n.elem.style.overflow;
              if (t()) n.stylize({
                overflow: "hidden"
              });
            });
            e.afterClose(function () {
              n.stylize({
                overflow: i
              });
            });
          }

          return document.documentElement.addEventListener("keydown", function e(t) {
            var i = t.which || t.keyCode;
            if (i === 27) S.trigger();else if (i === 9) c.trigger(t);
          }), function e(n) {
            if (I(n) || C(n)) n = {
              content: n
            };
            var r = v();
            var t = v();
            var i = v();
            var o = v();
            var s = v();

            function a(e, t) {
              var i = n[e];
              if (typeof i === "function") i = i(t);
              return i === undefined ? t : i;
            }

            var l = f.bind(window, "modal");
            var c = f.bind(window, "overlay");
            var h = f.bind(window, "close");
            var d;

            function u(e) {
              c().hide();
              l().hide();
              s.trigger(d, e);
            }

            function g(e) {
              if (o.trigger(d, e)) u(e);
            }

            function p(e) {
              return function () {
                e.apply(this || _global, arguments);
                return d;
              };
            }

            var m;

            function f(e, t) {
              if (!m) {
                var i = b(a, g);
                m = {
                  modal: i,
                  overlay: A(a, g),
                  close: y(i, a)
                };
                r.trigger(d, t);
              }

              return m[e];
            }

            d = {
              modalElem: w(l),
              closeElem: w(h),
              overlayElem: w(c),
              buildDom: p(f.bind(null, null)),
              isVisible: function () {
                return !!(m && l && l().isVisible());
              },
              show: function (e) {
                if (t.trigger(d, e)) {
                  c().show();
                  h();
                  l().show();
                  i.trigger(d, e);
                }

                return this || _global;
              },
              close: p(g),
              forceClose: p(u),
              destroy: function () {
                l().destroy();
                c().destroy();
                c = l = h = undefined;
              },
              options: function (t) {
                Object.keys(t).map(function (e) {
                  n[e] = t[e];
                });
              },
              afterCreate: p(r.watch),
              beforeShow: p(t.watch),
              afterShow: p(i.watch),
              beforeClose: p(o.watch),
              afterClose: p(s.watch)
            };
            x(d, a.bind(null, "focus", true));
            k(d, a.bind(null, "bodyOverflow", true));
            S.watch(function e() {
              if (a("escCloses", true) && d.isVisible()) d.close();
            });
            return d;
          };
        }) ? i.apply(t, n) : i) && (e.exports = n);
      }();
    },
    7533: function (e, t) {
      /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
      !function (e) {
        "use strict";

        function he() {
          for (var e = arguments.length, t = Array(e), i = 0; i < e; i++) t[i] = arguments[i];

          if (t.length > 1) {
            t[0] = t[0].slice(0, -1);
            var n = t.length - 1;

            for (var r = 1; r < n; ++r) t[r] = t[r].slice(1, -1);

            t[n] = t[n].slice(1);
            return t.join("");
          } else return t[0];
        }

        function de(e) {
          return "(?:" + e + ")";
        }

        function n(e) {
          return e === undefined ? "undefined" : e === null ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
        }

        function p(e) {
          return e.toUpperCase();
        }

        function b(e) {
          return e !== undefined && e !== null ? e instanceof Array ? e : typeof e.length !== "number" || e.split || e.setInterval || e.call ? [e] : Array.prototype.slice.call(e) : [];
        }

        function x(e, t) {
          var i = e;
          if (t) for (var n in t) i[n] = t[n];
          return i;
        }

        function t(e) {
          var t = "[A-Za-z]",
              G = "[\\x0D]",
              i = "[0-9]",
              P = "[\\x22]",
              n = he(i, "[A-Fa-f]"),
              F = "[\\x0A]",
              H = "[\\x20]",
              r = de(de("%[EFef]" + n + "%" + n + n + "%" + n + n) + "|" + de("%[89A-Fa-f]" + n + "%" + n + n) + "|" + de("%" + n + n)),
              o = "[\\:\\/\\?\\#\\[\\]\\@]",
              s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
              a = he(o, s),
              l = e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
              c = e ? "[\\uE000-\\uF8FF]" : "[]",
              h = he(t, i, "[\\-\\.\\_\\~]", l),
              d = de(t + he(t, i, "[\\+\\-\\.]") + "*"),
              u = de(de(r + "|" + he(h, s, "[\\:]")) + "*"),
              V = de(de("25[0-5]") + "|" + de("2[0-4]" + i) + "|" + de("1" + i + i) + "|" + de("[1-9]" + i) + "|" + i),
              g = de(de("25[0-5]") + "|" + de("2[0-4]" + i) + "|" + de("1" + i + i) + "|" + de("0?[1-9]" + i) + "|0?0?" + i),
              p = de(g + "\\." + g + "\\." + g + "\\." + g),
              m = de(n + "{1,4}"),
              f = de(de(m + "\\:" + m) + "|" + p),
              C = de(de(m + "\\:") + "{6}" + f),
              I = de("\\:\\:" + de(m + "\\:") + "{5}" + f),
              v = de(de(m) + "?\\:\\:" + de(m + "\\:") + "{4}" + f),
              Z = de(de(de(m + "\\:") + "{0,1}" + m) + "?\\:\\:" + de(m + "\\:") + "{3}" + f),
              M = de(de(de(m + "\\:") + "{0,2}" + m) + "?\\:\\:" + de(m + "\\:") + "{2}" + f),
              O = de(de(de(m + "\\:") + "{0,3}" + m) + "?\\:\\:" + m + "\\:" + f),
              D = de(de(de(m + "\\:") + "{0,4}" + m) + "?\\:\\:" + f),
              K = de(de(de(m + "\\:") + "{0,5}" + m) + "?\\:\\:" + m),
              j = de(de(de(m + "\\:") + "{0,6}" + m) + "?\\:\\:"),
              A = de([C, I, v, Z, M, O, D, K, j].join("|")),
              b = de(de(h + "|" + r) + "+"),
              z = de(A + "\\%25" + b),
              X = de(A + de("\\%25|\\%(?!" + n + "{2})") + b),
              J = de("[vV]" + n + "+\\." + he(h, s, "[\\:]") + "+"),
              Y = de("\\[" + de(X + "|" + A + "|" + J) + "\\]"),
              y = de(de(r + "|" + he(h, s)) + "*"),
              w = de(Y + "|" + p + "(?!" + y + ")" + "|" + y),
              S = de(i + "*"),
              x = de(de(u + "@") + "?" + w + de("\\:" + S) + "?"),
              k = de(r + "|" + he(h, s, "[\\:\\@]")),
              U = de(k + "*"),
              E = de(k + "+"),
              Q = de(de(r + "|" + he(h, s, "[\\@]")) + "+"),
              R = de(de("\\/" + U) + "*"),
              T = de("\\/" + de(E + R) + "?"),
              _ = de(Q + R),
              $ = de(E + R),
              L = "(?!" + k + ")",
              q = de(R + "|" + T + "|" + _ + "|" + $ + "|" + L),
              B = de(de(k + "|" + he("[\\/\\?]", c)) + "*"),
              W = de(de(k + "|[\\/\\?]") + "*"),
              N = de(de("\\/\\/" + x + R) + "|" + T + "|" + $ + "|" + L),
              ee = de(d + "\\:" + N + de("\\?" + B) + "?" + de("\\#" + W) + "?"),
              te = de(de("\\/\\/" + x + R) + "|" + T + "|" + _ + "|" + L),
              ie = de(te + de("\\?" + B) + "?" + de("\\#" + W) + "?"),
              ne = de(ee + "|" + ie),
              re = de(d + "\\:" + N + de("\\?" + B) + "?"),
              oe = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + R + "|" + T + "|" + $ + "|" + L + ")") + de("\\?(" + B + ")") + "?" + de("\\#(" + W + ")") + "?$",
              se = "^(){0}" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + R + "|" + T + "|" + _ + "|" + L + ")") + de("\\?(" + B + ")") + "?" + de("\\#(" + W + ")") + "?$",
              ae = "^(" + d + ")\\:" + de(de("\\/\\/(" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?)") + "?(" + R + "|" + T + "|" + $ + "|" + L + ")") + de("\\?(" + B + ")") + "?$",
              le = "^" + de("\\#(" + W + ")") + "?$",
              ce = "^" + de("(" + u + ")@") + "?(" + w + ")" + de("\\:(" + S + ")") + "?$";

          return {
            NOT_SCHEME: new RegExp(he("[^]", t, i, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(he("[^\\%\\:]", h, s), "g"),
            NOT_HOST: new RegExp(he("[^\\%\\[\\]\\:]", h, s), "g"),
            NOT_PATH: new RegExp(he("[^\\%\\/\\:\\@]", h, s), "g"),
            NOT_PATH_NOSCHEME: new RegExp(he("[^\\%\\/\\@]", h, s), "g"),
            NOT_QUERY: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]", c), "g"),
            NOT_FRAGMENT: new RegExp(he("[^\\%]", h, s, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(he("[^]", h, s), "g"),
            UNRESERVED: new RegExp(h, "g"),
            OTHER_CHARS: new RegExp(he("[^\\%]", h, a), "g"),
            PCT_ENCODED: new RegExp(r, "g"),
            IPV4ADDRESS: new RegExp("^(" + p + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + A + ")" + de(de("\\%25|\\%(?!" + n + "{2})") + "(" + b + ")") + "?\\]?$")
          };
        }

        var a = t(false),
            l = t(true),
            y = function () {
          function i(e, t) {
            var i = [];
            var n = true;
            var r = false;
            var o = undefined;

            try {
              for (var s = e[Symbol.iterator](), a; !(n = (a = s.next()).done); n = true) {
                i.push(a.value);
                if (t && i.length === t) break;
              }
            } catch (e) {
              r = true;
              o = e;
            } finally {
              try {
                if (!n && s["return"]) s["return"]();
              } finally {
                if (r) throw o;
              }
            }

            return i;
          }

          return function (e, t) {
            if (Array.isArray(e)) return e;else if (Symbol.iterator in Object(e)) return i(e, t);else throw new TypeError("Invalid attempt to destructure non-iterable instance");
          };
        }(),
            k = function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, i = Array(e.length); t < e.length; t++) i[t] = e[t];

            return i;
          } else return Array.from(e);
        },
            W = 2147483647,
            N = 36,
            G = 1,
            P = 26,
            E = 38,
            R = 700,
            F = 72,
            H = 128,
            V = "-",
            T = /^xn--/,
            _ = /[^\0-\x7E]/,
            $ = /[\x2E\u3002\uFF0E\uFF61]/g,
            L = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
            o = N - G,
            Z = Math.floor,
            M = String.fromCharCode;

        function O(e) {
          throw new RangeError(L[e]);
        }

        function B(e, t) {
          var i = [];
          var n = e.length;

          while (n--) i[n] = t(e[n]);

          return i;
        }

        function D(e, t) {
          var i = e.split("@");
          var n = "";

          if (i.length > 1) {
            n = i[0] + "@";
            e = i[1];
          }

          e = e.replace($, ".");
          var r = e.split(".");
          var o = B(r, t).join(".");
          return n + o;
        }

        function K(e) {
          var t = [];
          var i = 0;
          var n = e.length;

          while (i < n) {
            var r = e.charCodeAt(i++);

            if (r >= 55296 && r <= 56319 && i < n) {
              var o = e.charCodeAt(i++);
              if ((o & 64512) == 56320) t.push(((r & 1023) << 10) + (o & 1023) + 65536);else {
                t.push(r);
                i--;
              }
            } else t.push(r);
          }

          return t;
        }

        var j,
            z = function e(t) {
          if (t - 48 < 10) return t - 22;
          if (t - 65 < 26) return t - 65;
          if (t - 97 < 26) return t - 97;
          return N;
        },
            X = function e(t, i) {
          return t + 22 + 75 * (t < 26) - ((i != 0) << 5);
        },
            J = function e(t, i, n) {
          var r = 0;
          t = n ? Z(t / R) : t >> 1;
          t += Z(t / i);

          for (; t > o * P >> 1; r += N) t = Z(t / o);

          return Z(r + (o + 1) * t / (t + E));
        },
            Y = function e(t) {
          var i = [];
          var n = t.length;
          var r = 0;
          var o = H;
          var s = F;
          var a = t.lastIndexOf(V);
          if (a < 0) a = 0;

          for (var l = 0; l < a; ++l) {
            if (t.charCodeAt(l) >= 128) O("not-basic");
            i.push(t.charCodeAt(l));
          }

          for (var c = a > 0 ? a + 1 : 0; c < n;) {
            var h = r;

            for (var d = 1, u = N;; u += N) {
              if (c >= n) O("invalid-input");
              var g = z(t.charCodeAt(c++));
              if (g >= N || g > Z((W - r) / d)) O("overflow");
              r += g * d;
              var p = u <= s ? G : u >= s + P ? P : u - s;
              if (g < p) break;
              var m = N - p;
              if (d > Z(W / m)) O("overflow");
              d *= m;
            }

            var f = i.length + 1;
            s = J(r - h, f, h == 0);
            if (Z(r / f) > W - o) O("overflow");
            o += Z(r / f);
            r %= f;
            i.splice(r++, 0, o);
          }

          return String.fromCodePoint.apply(String, i);
        },
            U = function e(t) {
          var i = [];
          t = K(t);
          var n = t.length;
          var r = H;
          var o = 0;
          var s = F;
          var a = true;
          var l = false;
          var c = undefined;

          try {
            for (var h = t[Symbol.iterator](), d; !(a = (d = h.next()).done); a = true) {
              var u = d.value;
              if (u < 128) i.push(M(u));
            }
          } catch (e) {
            l = true;
            c = e;
          } finally {
            try {
              if (!a && h.return) h.return();
            } finally {
              if (l) throw c;
            }
          }

          var g = i.length;
          var p = g;
          if (g) i.push(V);

          while (p < n) {
            var m = W;
            var f = true;
            var C = false;
            var I = undefined;

            try {
              for (var v = t[Symbol.iterator](), A; !(f = (A = v.next()).done); f = true) {
                var b = A.value;
                if (b >= r && b < m) m = b;
              }
            } catch (e) {
              C = true;
              I = e;
            } finally {
              try {
                if (!f && v.return) v.return();
              } finally {
                if (C) throw I;
              }
            }

            var y = p + 1;
            if (m - r > Z((W - o) / y)) O("overflow");
            o += (m - r) * y;
            r = m;
            var w = true;
            var S = false;
            var x = undefined;

            try {
              for (var k = t[Symbol.iterator](), E; !(w = (E = k.next()).done); w = true) {
                var R = E.value;
                if (R < r && ++o > W) O("overflow");

                if (R == r) {
                  var T = o;

                  for (var _ = N;; _ += N) {
                    var $ = _ <= s ? G : _ >= s + P ? P : _ - s;
                    if (T < $) break;
                    var L = T - $;
                    var B = N - $;
                    i.push(M(X($ + L % B, 0)));
                    T = Z(L / B);
                  }

                  i.push(M(X(T, 0)));
                  s = J(o, y, p == g);
                  o = 0;
                  ++p;
                }
              }
            } catch (e) {
              S = true;
              x = e;
            } finally {
              try {
                if (!w && k.return) k.return();
              } finally {
                if (S) throw x;
              }
            }

            ++o;
            ++r;
          }

          return i.join("");
        },
            Q,
            q,
            C = {
          version: "2.1.0",
          ucs2: {
            decode: K,
            encode: function e(t) {
              return String.fromCodePoint.apply(String, k(t));
            }
          },
          decode: Y,
          encode: U,
          toASCII: function e(t) {
            return D(t, function (e) {
              return _.test(e) ? "xn--" + U(e) : e;
            });
          },
          toUnicode: function e(t) {
            return D(t, function (e) {
              return T.test(e) ? Y(e.slice(4).toLowerCase()) : e;
            });
          }
        },
            h = {};

        function m(e) {
          var t = e.charCodeAt(0);
          var i = void 0;
          if (t < 16) i = "%0" + t.toString(16).toUpperCase();else if (t < 128) i = "%" + t.toString(16).toUpperCase();else if (t < 2048) i = "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();else i = "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase();
          return i;
        }

        function c(e) {
          var t = "";
          var i = 0;
          var n = e.length;

          while (i < n) {
            var r = parseInt(e.substr(i + 1, 2), 16);

            if (r < 128) {
              t += String.fromCharCode(r);
              i += 3;
            } else if (r >= 194 && r < 224) {
              if (n - i >= 6) {
                var o = parseInt(e.substr(i + 4, 2), 16);
                t += String.fromCharCode((r & 31) << 6 | o & 63);
              } else t += e.substr(i, 6);

              i += 6;
            } else if (r >= 224) {
              if (n - i >= 9) {
                var s = parseInt(e.substr(i + 4, 2), 16);
                var a = parseInt(e.substr(i + 7, 2), 16);
                t += String.fromCharCode((r & 15) << 12 | (s & 63) << 6 | a & 63);
              } else t += e.substr(i, 9);

              i += 9;
            } else {
              t += e.substr(i, 3);
              i += 3;
            }
          }

          return t;
        }

        function d(e, i) {
          function t(e) {
            var t = c(e);
            return !t.match(i.UNRESERVED) ? e : t;
          }

          if (e.scheme) e.scheme = String(e.scheme).replace(i.PCT_ENCODED, t).toLowerCase().replace(i.NOT_SCHEME, "");
          if (e.userinfo !== undefined) e.userinfo = String(e.userinfo).replace(i.PCT_ENCODED, t).replace(i.NOT_USERINFO, m).replace(i.PCT_ENCODED, p);
          if (e.host !== undefined) e.host = String(e.host).replace(i.PCT_ENCODED, t).toLowerCase().replace(i.NOT_HOST, m).replace(i.PCT_ENCODED, p);
          if (e.path !== undefined) e.path = String(e.path).replace(i.PCT_ENCODED, t).replace(e.scheme ? i.NOT_PATH : i.NOT_PATH_NOSCHEME, m).replace(i.PCT_ENCODED, p);
          if (e.query !== undefined) e.query = String(e.query).replace(i.PCT_ENCODED, t).replace(i.NOT_QUERY, m).replace(i.PCT_ENCODED, p);
          if (e.fragment !== undefined) e.fragment = String(e.fragment).replace(i.PCT_ENCODED, t).replace(i.NOT_FRAGMENT, m).replace(i.PCT_ENCODED, p);
          return e;
        }

        function w(e) {
          return e.replace(/^0*(.*)/, "$1") || "0";
        }

        function S(e, t) {
          var i = e.match(t.IPV4ADDRESS) || [];
          var n = y(i, 2),
              r = n[1];
          if (r) return r.split(".").map(w).join(".");else return e;
        }

        function ee(e, t) {
          var i = e.match(t.IPV6ADDRESS) || [];
          var n = y(i, 3),
              r = n[1],
              o = n[2];

          if (r) {
            var s = r.toLowerCase().split("::").reverse(),
                a = y(s, 2),
                l = a[0],
                c = a[1];
            var h = c ? c.split(":").map(w) : [];
            var d = l.split(":").map(w);
            var u = t.IPV4ADDRESS.test(d[d.length - 1]);
            var g = u ? 7 : 8;
            var p = d.length - g;
            var m = Array(g);

            for (var f = 0; f < g; ++f) m[f] = h[f] || d[p + f] || "";

            if (u) m[g - 1] = S(m[g - 1], t);
            var C = m.reduce(function (e, t, i) {
              if (!t || t === "0") {
                var n = e[e.length - 1];
                if (n && n.index + n.length === i) n.length++;else e.push({
                  index: i,
                  length: 1
                });
              }

              return e;
            }, []);
            var I = C.sort(function (e, t) {
              return t.length - e.length;
            })[0];
            var v = void 0;

            if (I && I.length > 1) {
              var A = m.slice(0, I.index);
              var b = m.slice(I.index + I.length);
              v = A.join(":") + "::" + b.join(":");
            } else v = m.join(":");

            if (o) v += "%" + o;
            return v;
          } else return e;
        }

        var te = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,
            ie = "".match(/(){0}/)[1] === undefined;

        function s(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var i = {};
          var n = t.iri !== false ? l : a;
          if (t.reference === "suffix") e = (t.scheme ? t.scheme + ":" : "") + "//" + e;
          var r = e.match(te);

          if (r) {
            if (ie) {
              i.scheme = r[1];
              i.userinfo = r[3];
              i.host = r[4];
              i.port = parseInt(r[5], 10);
              i.path = r[6] || "";
              i.query = r[7];
              i.fragment = r[8];
              if (isNaN(i.port)) i.port = r[5];
            } else {
              i.scheme = r[1] || undefined;
              i.userinfo = e.indexOf("@") !== -1 ? r[3] : undefined;
              i.host = e.indexOf("//") !== -1 ? r[4] : undefined;
              i.port = parseInt(r[5], 10);
              i.path = r[6] || "";
              i.query = e.indexOf("?") !== -1 ? r[7] : undefined;
              i.fragment = e.indexOf("#") !== -1 ? r[8] : undefined;
              if (isNaN(i.port)) i.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? r[4] : undefined;
            }

            if (i.host) i.host = ee(S(i.host, n), n);
            if (i.scheme === undefined && i.userinfo === undefined && i.host === undefined && i.port === undefined && !i.path && i.query === undefined) i.reference = "same-document";else if (i.scheme === undefined) i.reference = "relative";else if (i.fragment === undefined) i.reference = "absolute";else i.reference = "uri";
            if (t.reference && t.reference !== "suffix" && t.reference !== i.reference) i.error = i.error || "URI is not a " + t.reference + " reference.";
            var o = h[(t.scheme || i.scheme || "").toLowerCase()];

            if (!t.unicodeSupport && (!o || !o.unicodeSupport)) {
              if (i.host && (t.domainHost || o && o.domainHost)) try {
                i.host = C.toASCII(i.host.replace(n.PCT_ENCODED, c).toLowerCase());
              } catch (e) {
                i.error = i.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
              }
              d(i, a);
            } else d(i, n);

            if (o && o.parse) o.parse(i, t);
          } else i.error = i.error || "URI can not be parsed.";

          return i;
        }

        function ne(e, t) {
          var i = t.iri !== false ? l : a;
          var n = [];

          if (e.userinfo !== undefined) {
            n.push(e.userinfo);
            n.push("@");
          }

          if (e.host !== undefined) n.push(ee(S(String(e.host), i), i).replace(i.IPV6ADDRESS, function (e, t, i) {
            return "[" + t + (i ? "%25" + i : "") + "]";
          }));

          if (typeof e.port === "number" || typeof e.port === "string") {
            n.push(":");
            n.push(String(e.port));
          }

          return n.length ? n.join("") : undefined;
        }

        var re = /^\.\.?\//,
            oe = /^\/\.(\/|$)/,
            se = /^\/\.\.(\/|$)/,
            ae = /^\/?(?:.|\n)*?(?=\/|$)/;

        function u(e) {
          var t = [];

          while (e.length) if (e.match(re)) e = e.replace(re, "");else if (e.match(oe)) e = e.replace(oe, "/");else if (e.match(se)) {
            e = e.replace(se, "/");
            t.pop();
          } else if (e === "." || e === "..") e = "";else {
            var i = e.match(ae);

            if (i) {
              var n = i[0];
              e = e.slice(n.length);
              t.push(n);
            } else throw new Error("Unexpected dot segment condition");
          }

          return t.join("");
        }

        function g(t) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var e = i.iri ? l : a;
          var n = [];
          var r = h[(i.scheme || t.scheme || "").toLowerCase()];
          if (r && r.serialize) r.serialize(t, i);
          if (t.host) if (e.IPV6ADDRESS.test(t.host)) ;else if (i.domainHost || r && r.domainHost) try {
            t.host = !i.iri ? C.toASCII(t.host.replace(e.PCT_ENCODED, c).toLowerCase()) : C.toUnicode(t.host);
          } catch (e) {
            t.error = t.error || "Host's domain name can not be converted to " + (!i.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
          }
          d(t, e);

          if (i.reference !== "suffix" && t.scheme) {
            n.push(t.scheme);
            n.push(":");
          }

          var o = ne(t, i);

          if (o !== undefined) {
            if (i.reference !== "suffix") n.push("//");
            n.push(o);
            if (t.path && t.path.charAt(0) !== "/") n.push("/");
          }

          if (t.path !== undefined) {
            var s = t.path;
            if (!i.absolutePath && (!r || !r.absolutePath)) s = u(s);
            if (o === undefined) s = s.replace(/^\/\//, "/%2F");
            n.push(s);
          }

          if (t.query !== undefined) {
            n.push("?");
            n.push(t.query);
          }

          if (t.fragment !== undefined) {
            n.push("#");
            n.push(t.fragment);
          }

          return n.join("");
        }

        function le(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var n = arguments[3];
          var r = {};

          if (!n) {
            e = s(g(e, i), i);
            t = s(g(t, i), i);
          }

          i = i || {};

          if (!i.tolerant && t.scheme) {
            r.scheme = t.scheme;
            r.userinfo = t.userinfo;
            r.host = t.host;
            r.port = t.port;
            r.path = u(t.path || "");
            r.query = t.query;
          } else {
            if (t.userinfo !== undefined || t.host !== undefined || t.port !== undefined) {
              r.userinfo = t.userinfo;
              r.host = t.host;
              r.port = t.port;
              r.path = u(t.path || "");
              r.query = t.query;
            } else {
              if (!t.path) {
                r.path = e.path;
                if (t.query !== undefined) r.query = t.query;else r.query = e.query;
              } else {
                if (t.path.charAt(0) === "/") r.path = u(t.path);else {
                  if ((e.userinfo !== undefined || e.host !== undefined || e.port !== undefined) && !e.path) r.path = "/" + t.path;else if (!e.path) r.path = t.path;else r.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path;
                  r.path = u(r.path);
                }
                r.query = t.query;
              }

              r.userinfo = e.userinfo;
              r.host = e.host;
              r.port = e.port;
            }

            r.scheme = e.scheme;
          }

          r.fragment = t.fragment;
          return r;
        }

        function ce(e, t, i) {
          var n = x({
            scheme: "null"
          }, i);
          return g(le(s(e, n), s(t, n), n, true), n);
        }

        function ue(e, t) {
          if (typeof e === "string") e = g(s(e, t), t);else if (n(e) === "object") e = s(g(e, t), t);
          return e;
        }

        function ge(e, t, i) {
          if (typeof e === "string") e = g(s(e, i), i);else if (n(e) === "object") e = g(e, i);
          if (typeof t === "string") t = g(s(t, i), i);else if (n(t) === "object") t = g(t, i);
          return e === t;
        }

        function pe(e, t) {
          return e && e.toString().replace(!t || !t.iri ? a.ESCAPE : l.ESCAPE, m);
        }

        function I(e, t) {
          return e && e.toString().replace(!t || !t.iri ? a.PCT_ENCODED : l.PCT_ENCODED, c);
        }

        var i = {
          scheme: "http",
          domainHost: true,
          parse: function e(t, i) {
            if (!t.host) t.error = t.error || "HTTP URIs must have a host.";
            return t;
          },
          serialize: function e(t, i) {
            var n = String(t.scheme).toLowerCase() === "https";
            if (t.port === (n ? 443 : 80) || t.port === "") t.port = undefined;
            if (!t.path) t.path = "/";
            return t;
          }
        },
            me = {
          scheme: "https",
          domainHost: i.domainHost,
          parse: i.parse,
          serialize: i.serialize
        };

        function fe(e) {
          return typeof e.secure === "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
        }

        var r = {
          scheme: "ws",
          domainHost: true,
          parse: function e(t, i) {
            var n = t;
            n.secure = fe(n);
            n.resourceName = (n.path || "/") + (n.query ? "?" + n.query : "");
            n.path = undefined;
            n.query = undefined;
            return n;
          },
          serialize: function e(t, i) {
            if (t.port === (fe(t) ? 443 : 80) || t.port === "") t.port = undefined;

            if (typeof t.secure === "boolean") {
              t.scheme = t.secure ? "wss" : "ws";
              t.secure = undefined;
            }

            if (t.resourceName) {
              var n = t.resourceName.split("?"),
                  r = y(n, 2),
                  o = r[0],
                  s = r[1];
              t.path = o && o !== "/" ? o : undefined;
              t.query = s;
              t.resourceName = undefined;
            }

            t.fragment = undefined;
            return t;
          }
        },
            Ce = {
          scheme: "wss",
          domainHost: r.domainHost,
          parse: r.parse,
          serialize: r.serialize
        },
            Ie = {},
            ve,
            Ae = "[A-Za-z0-9\\-\\.\\_\\~" + (true ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]",
            f = "[0-9A-Fa-f]",
            be = de(de("%[EFef]" + f + "%" + f + f + "%" + f + f) + "|" + de("%[89A-Fa-f]" + f + "%" + f + f) + "|" + de("%" + f + f)),
            ye = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",
            we,
            Se = he("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", "[\\\"\\\\]"),
            xe = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",
            ke = new RegExp(Ae, "g"),
            v = new RegExp(be, "g"),
            Ee = new RegExp(he("[^]", ye, "[\\.]", "[\\\"]", Se), "g"),
            Re = new RegExp(he("[^]", Ae, xe), "g"),
            Te = Re;

        function A(e) {
          var t = c(e);
          return !t.match(ke) ? e : t;
        }

        var _e = {
          scheme: "mailto",
          parse: function e(t, i) {
            var n = t;
            var r = n.to = n.path ? n.path.split(",") : [];
            n.path = undefined;

            if (n.query) {
              var o = false;
              var s = {};
              var a = n.query.split("&");

              for (var l = 0, c = a.length; l < c; ++l) {
                var h = a[l].split("=");

                switch (h[0]) {
                  case "to":
                    var d = h[1].split(",");

                    for (var u = 0, g = d.length; u < g; ++u) r.push(d[u]);

                    break;

                  case "subject":
                    n.subject = I(h[1], i);
                    break;

                  case "body":
                    n.body = I(h[1], i);
                    break;

                  default:
                    o = true;
                    s[I(h[0], i)] = I(h[1], i);
                    break;
                }
              }

              if (o) n.headers = s;
            }

            n.query = undefined;

            for (var p = 0, m = r.length; p < m; ++p) {
              var f = r[p].split("@");
              f[0] = I(f[0]);
              if (!i.unicodeSupport) try {
                f[1] = C.toASCII(I(f[1], i).toLowerCase());
              } catch (e) {
                n.error = n.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
              } else f[1] = I(f[1], i).toLowerCase();
              r[p] = f.join("@");
            }

            return n;
          },
          serialize: function e(t, i) {
            var n = t;
            var r = b(t.to);

            if (r) {
              for (var o = 0, s = r.length; o < s; ++o) {
                var a = String(r[o]);
                var l = a.lastIndexOf("@");
                var c = a.slice(0, l).replace(v, A).replace(v, p).replace(Ee, m);
                var h = a.slice(l + 1);

                try {
                  h = !i.iri ? C.toASCII(I(h, i).toLowerCase()) : C.toUnicode(h);
                } catch (e) {
                  n.error = n.error || "Email address's domain name can not be converted to " + (!i.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }

                r[o] = c + "@" + h;
              }

              n.path = r.join(",");
            }

            var d = t.headers = t.headers || {};
            if (t.subject) d["subject"] = t.subject;
            if (t.body) d["body"] = t.body;
            var u = [];

            for (var g in d) if (d[g] !== Ie[g]) u.push(g.replace(v, A).replace(v, p).replace(Re, m) + "=" + d[g].replace(v, A).replace(v, p).replace(Te, m));

            if (u.length) n.query = u.join("&");
            return n;
          }
        },
            $e = /^([^\:]+)\:(.*)/,
            Le = {
          scheme: "urn",
          parse: function e(t, i) {
            var n = t.path && t.path.match($e);
            var r = t;

            if (n) {
              var o = i.scheme || r.scheme || "urn";
              var s = n[1].toLowerCase();
              var a = n[2];
              var l = o + ":" + (i.nid || s);
              var c = h[l];
              r.nid = s;
              r.nss = a;
              r.path = undefined;
              if (c) r = c.parse(r, i);
            } else r.error = r.error || "URN can not be parsed.";

            return r;
          },
          serialize: function e(t, i) {
            var n = i.scheme || t.scheme || "urn";
            var r = t.nid;
            var o = n + ":" + (i.nid || r);
            var s = h[o];
            if (s) t = s.serialize(t, i);
            var a = t;
            var l = t.nss;
            a.path = (r || i.nid) + ":" + l;
            return a;
          }
        },
            Be = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,
            We = {
          scheme: "urn:uuid",
          parse: function e(t, i) {
            var n = t;
            n.uuid = n.nss;
            n.nss = undefined;
            if (!i.tolerant && (!n.uuid || !n.uuid.match(Be))) n.error = n.error || "UUID is not valid.";
            return n;
          },
          serialize: function e(t, i) {
            var n = t;
            n.nss = (t.uuid || "").toLowerCase();
            return n;
          }
        };
        h[i.scheme] = i, h[me.scheme] = me, h[r.scheme] = r, h[Ce.scheme] = Ce, h[_e.scheme] = _e, h[Le.scheme] = Le, h[We.scheme] = We, e.SCHEMES = h, e.pctEncChar = m, e.pctDecChars = c, e.parse = s, e.removeDotSegments = u, e.serialize = g, e.resolveComponents = le, e.resolve = ce, e.normalize = ue, e.equal = ge, e.escapeComponent = pe, e.unescapeComponent = I, Object.defineProperty(e, "__esModule", {
          value: true
        });
      }(t);
    },
    4049: function (e) {
      e.exports = function () {
        "use strict";

        var s = function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        },
            e = function () {
          function n(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || false;
              n.configurable = true;
              if ("value" in n) n.writable = true;
              Object.defineProperty(e, n.key, n);
            }
          }

          return function (e, t, i) {
            if (t) n(e.prototype, t);
            if (i) n(e, i);
            return e;
          };
        }(),
            m = function () {
          function i(e, t) {
            var i = [];
            var n = true;
            var r = false;
            var o = undefined;

            try {
              for (var s = e[Symbol.iterator](), a; !(n = (a = s.next()).done); n = true) {
                i.push(a.value);
                if (t && i.length === t) break;
              }
            } catch (e) {
              r = true;
              o = e;
            } finally {
              try {
                if (!n && s["return"]) s["return"]();
              } finally {
                if (r) throw o;
              }
            }

            return i;
          }

          return function (e, t) {
            if (Array.isArray(e)) return e;else if (Symbol.iterator in Object(e)) return i(e, t);else throw new TypeError("Invalid attempt to destructure non-iterable instance");
          };
        }(),
            r = (String.prototype.startsWith = String.prototype.startsWith || function (e) {
          return this.indexOf(e) === 0;
        }, String.prototype.padStart = String.prototype.padStart || function (e, t) {
          var i = this || _global;

          while (i.length < e) i = t + i;

          return i;
        }, {
          cb: "0f8ff",
          tqw: "aebd7",
          q: "-ffff",
          qmrn: "7fffd4",
          zr: "0ffff",
          bg: "5f5dc",
          bsq: "e4c4",
          bck: "---",
          nch: "ebcd",
          b: "--ff",
          bvt: "8a2be2",
          brwn: "a52a2a",
          brw: "deb887",
          ctb: "5f9ea0",
          hrt: "7fff-",
          chcT: "d2691e",
          cr: "7f50",
          rnw: "6495ed",
          crns: "8dc",
          crms: "dc143c",
          cn: "-ffff",
          Db: "--8b",
          Dcn: "-8b8b",
          Dgnr: "b8860b",
          Dgr: "a9a9a9",
          Dgrn: "-64-",
          Dkhk: "bdb76b",
          Dmgn: "8b-8b",
          Dvgr: "556b2f",
          Drng: "8c-",
          Drch: "9932cc",
          Dr: "8b--",
          Dsmn: "e9967a",
          Dsgr: "8fbc8f",
          DsTb: "483d8b",
          DsTg: "2f4f4f",
          Dtrq: "-ced1",
          Dvt: "94-d3",
          ppnk: "1493",
          pskb: "-bfff",
          mgr: "696969",
          grb: "1e90ff",
          rbrc: "b22222",
          rwht: "af0",
          stg: "228b22",
          chs: "-ff",
          gnsb: "dcdcdc",
          st: "8f8ff",
          g: "d7-",
          gnr: "daa520",
          gr: "808080",
          grn: "-8-0",
          grnw: "adff2f",
          hnw: "0fff0",
          htpn: "69b4",
          nnr: "cd5c5c",
          ng: "4b-82",
          vr: "0",
          khk: "0e68c",
          vnr: "e6e6fa",
          nrb: "0f5",
          wngr: "7cfc-",
          mnch: "acd",
          Lb: "add8e6",
          Lcr: "08080",
          Lcn: "e0ffff",
          Lgnr: "afad2",
          Lgr: "d3d3d3",
          Lgrn: "90ee90",
          Lpnk: "b6c1",
          Lsmn: "a07a",
          Lsgr: "20b2aa",
          Lskb: "87cefa",
          LsTg: "778899",
          Lstb: "b0c4de",
          Lw: "e0",
          m: "-ff-",
          mgrn: "32cd32",
          nn: "af0e6",
          mgnt: "-ff",
          mrn: "8--0",
          mqm: "66cdaa",
          mmb: "--cd",
          mmrc: "ba55d3",
          mmpr: "9370db",
          msg: "3cb371",
          mmsT: "7b68ee",
          "": "-fa9a",
          mtr: "48d1cc",
          mmvt: "c71585",
          mnLb: "191970",
          ntc: "5fffa",
          mstr: "e4e1",
          mccs: "e4b5",
          vjw: "dead",
          nv: "--80",
          c: "df5e6",
          v: "808-0",
          vrb: "6b8e23",
          rng: "a5-",
          rngr: "45-",
          rch: "da70d6",
          pgnr: "eee8aa",
          pgrn: "98fb98",
          ptrq: "afeeee",
          pvtr: "db7093",
          ppwh: "efd5",
          pchp: "dab9",
          pr: "cd853f",
          pnk: "c0cb",
          pm: "dda0dd",
          pwrb: "b0e0e6",
          prp: "8-080",
          cc: "663399",
          r: "--",
          sbr: "bc8f8f",
          rb: "4169e1",
          sbrw: "8b4513",
          smn: "a8072",
          nbr: "4a460",
          sgrn: "2e8b57",
          ssh: "5ee",
          snn: "a0522d",
          svr: "c0c0c0",
          skb: "87ceeb",
          sTb: "6a5acd",
          sTgr: "708090",
          snw: "afa",
          n: "-ff7f",
          stb: "4682b4",
          tn: "d2b48c",
          t: "-8080",
          thst: "d8bfd8",
          tmT: "6347",
          trqs: "40e0d0",
          vt: "ee82ee",
          whT: "5deb3",
          wht: "",
          hts: "5f5f5",
          w: "-",
          wgrn: "9acd32"
        });

        function a(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var i = t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString();
          return i || "0";
        }

        var o = function () {
          function p(e, t, i, n) {
            s(this || _global, p);
            var g = this || _global;

            function r(e) {
              if (e.startsWith("hsl")) {
                var t = e.match(/([\-\d\.e]+)/g).map(Number),
                    i = m(t, 4),
                    n = i[0],
                    r = i[1],
                    o = i[2],
                    s = i[3];
                if (s === undefined) s = 1;
                n /= 360;
                r /= 100;
                o /= 100;
                g.hsla = [n, r, o, s];
              } else if (e.startsWith("rgb")) {
                var a = e.match(/([\-\d\.e]+)/g).map(Number),
                    l = m(a, 4),
                    c = l[0],
                    h = l[1],
                    d = l[2],
                    u = l[3];
                if (u === undefined) u = 1;
                g.rgba = [c, h, d, u];
              } else if (e.startsWith("#")) g.rgba = p.hexToRgb(e);else g.rgba = p.nameToRgb(e) || p.hexToRgb(e);
            }

            if (e === undefined) ;else if (Array.isArray(e)) (this || _global).rgba = e;else if (i === undefined) {
              var o = e && "" + e;
              if (o) r(o.toLowerCase());
            } else (this || _global).rgba = [e, t, i, n === undefined ? 1 : n];
          }

          e(p, [{
            key: "printRGB",
            value: function e(t) {
              var i = t ? (this || _global).rgba : (this || _global).rgba.slice(0, 3),
                  n = i.map(function (e, t) {
                return a(e, t === 3 ? 3 : 0);
              });
              return t ? "rgba(" + n + ")" : "rgb(" + n + ")";
            }
          }, {
            key: "printHSL",
            value: function e(t) {
              var i = [360, 100, 100, 1],
                  n = ["", "%", "%", ""];
              var r = t ? (this || _global).hsla : (this || _global).hsla.slice(0, 3),
                  o = r.map(function (e, t) {
                return a(e * i[t], t === 3 ? 3 : 1) + n[t];
              });
              return t ? "hsla(" + o + ")" : "hsl(" + o + ")";
            }
          }, {
            key: "printHex",
            value: function e(t) {
              var i = (this || _global).hex;
              return t ? i : i.substring(0, 7);
            }
          }, {
            key: "rgba",
            get: function e() {
              if ((this || _global)._rgba) return (this || _global)._rgba;
              if (!(this || _global)._hsla) throw new Error("No color is set");
              return (this || _global)._rgba = p.hslToRgb((this || _global)._hsla);
            },
            set: function e(t) {
              if (t.length === 3) t[3] = 1;
              (this || _global)._rgba = t;
              (this || _global)._hsla = null;
            }
          }, {
            key: "rgbString",
            get: function e() {
              return this.printRGB();
            }
          }, {
            key: "rgbaString",
            get: function e() {
              return this.printRGB(true);
            }
          }, {
            key: "hsla",
            get: function e() {
              if ((this || _global)._hsla) return (this || _global)._hsla;
              if (!(this || _global)._rgba) throw new Error("No color is set");
              return (this || _global)._hsla = p.rgbToHsl((this || _global)._rgba);
            },
            set: function e(t) {
              if (t.length === 3) t[3] = 1;
              (this || _global)._hsla = t;
              (this || _global)._rgba = null;
            }
          }, {
            key: "hslString",
            get: function e() {
              return this.printHSL();
            }
          }, {
            key: "hslaString",
            get: function e() {
              return this.printHSL(true);
            }
          }, {
            key: "hex",
            get: function e() {
              var t = (this || _global).rgba,
                  i = t.map(function (e, t) {
                return t < 3 ? e.toString(16) : Math.round(e * 255).toString(16);
              });
              return "#" + i.map(function (e) {
                return e.padStart(2, "0");
              }).join("");
            },
            set: function e(t) {
              (this || _global).rgba = p.hexToRgb(t);
            }
          }], [{
            key: "hexToRgb",
            value: function e(t) {
              var i = (t.startsWith("#") ? t.slice(1) : t).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
              if (!i.match(/^([0-9a-fA-F]{8})$/)) throw new Error("Unknown hex color; " + t);
              var n = i.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (e) {
                return parseInt(e, 16);
              });
              n[3] = n[3] / 255;
              return n;
            }
          }, {
            key: "nameToRgb",
            value: function e(t) {
              var i = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4),
                  n = r[i];
              return n === undefined ? n : p.hexToRgb(n.replace(/\-/g, "00").padStart(6, "f"));
            }
          }, {
            key: "rgbToHsl",
            value: function e(t) {
              var i = m(t, 4),
                  n = i[0],
                  r = i[1],
                  o = i[2],
                  s = i[3];
              n /= 255;
              r /= 255;
              o /= 255;
              var a = Math.max(n, r, o),
                  l = Math.min(n, r, o);
              var c = void 0,
                  h = void 0,
                  d = (a + l) / 2;
              if (a === l) c = h = 0;else {
                var u = a - l;
                h = d > 0.5 ? u / (2 - a - l) : u / (a + l);

                switch (a) {
                  case n:
                    c = (r - o) / u + (r < o ? 6 : 0);
                    break;

                  case r:
                    c = (o - n) / u + 2;
                    break;

                  case o:
                    c = (n - r) / u + 4;
                    break;
                }

                c /= 6;
              }
              return [c, h, d, s];
            }
          }, {
            key: "hslToRgb",
            value: function e(t) {
              var i = m(t, 4),
                  n = i[0],
                  r = i[1],
                  o = i[2],
                  s = i[3];
              var a = void 0,
                  l = void 0,
                  c = void 0;
              if (r === 0) a = l = c = o;else {
                var h = function e(t, i, n) {
                  if (n < 0) n += 1;
                  if (n > 1) n -= 1;
                  if (n < 1 / 6) return t + (i - t) * 6 * n;
                  if (n < 1 / 2) return i;
                  if (n < 2 / 3) return t + (i - t) * (2 / 3 - n) * 6;
                  return t;
                };

                var d = o < 0.5 ? o * (1 + r) : o + r - o * r,
                    u = 2 * o - d;
                a = h(u, d, n + 1 / 3);
                l = h(u, d, n);
                c = h(u, d, n - 1 / 3);
              }
              var g = [a * 255, l * 255, c * 255].map(Math.round);
              g[3] = s;
              return g;
            }
          }]);
          return p;
        }(),
            i = function () {
          function o() {
            s(this || _global, o);
            (this || _global)._events = [];
          }

          e(o, [{
            key: "add",
            value: function e(t, i, n) {
              t.addEventListener(i, n, false);

              (this || _global)._events.push({
                target: t,
                type: i,
                handler: n
              });
            }
          }, {
            key: "remove",
            value: function e(i, n, r) {
              (this || _global)._events = (this || _global)._events.filter(function (e) {
                var t = true;
                if (i && i !== e.target) t = false;
                if (n && n !== e.type) t = false;
                if (r && r !== e.handler) t = false;
                if (t) o._doRemove(e.target, e.type, e.handler);
                return !t;
              });
            }
          }, {
            key: "destroy",
            value: function e() {
              (this || _global)._events.forEach(function (e) {
                return o._doRemove(e.target, e.type, e.handler);
              });

              (this || _global)._events = [];
            }
          }], [{
            key: "_doRemove",
            value: function e(t, i, n) {
              t.removeEventListener(i, n, false);
            }
          }]);
          return o;
        }();

        function l(e) {
          var t = document.createElement("div");
          t.innerHTML = e;
          return t.firstElementChild;
        }

        function c(e, h, d) {
          var u = false;

          function g(e, t, i) {
            return Math.max(t, Math.min(e, i));
          }

          function n(e, t, i) {
            if (i) u = true;
            if (!u) return;
            e.preventDefault();
            var n = h.getBoundingClientRect(),
                r = n.width,
                o = n.height,
                s = t.clientX,
                a = t.clientY;
            var l = g(s - n.left, 0, r),
                c = g(a - n.top, 0, o);
            d(l / r, c / o);
          }

          function t(e, t) {
            var i = e.buttons === undefined ? e.which : e.buttons;
            if (i === 1) n(e, e, t);else u = false;
          }

          function i(e, t) {
            if (e.touches.length === 1) n(e, e.touches[0], t);else u = false;
          }

          e.add(h, "mousedown", function (e) {
            t(e, true);
          });
          e.add(h, "touchstart", function (e) {
            i(e, true);
          });
          e.add(window, "mousemove", t);
          e.add(h, "touchmove", i);
          e.add(window, "mouseup", function (e) {
            u = false;
          });
          e.add(h, "touchend", function (e) {
            u = false;
          });
          e.add(h, "touchcancel", function (e) {
            u = false;
          });
        }

        var b = "linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em",
            y = 360,
            h = "keydown",
            d = "mousedown",
            u = "focusin";

        function w(e, t) {
          return (t || document).querySelector(e);
        }

        function g(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        function p(e, t, i, n, r) {
          e.add(t, h, function (e) {
            if (i.indexOf(e.key) >= 0) {
              if (r) g(e);
              n(e);
            }
          });
        }

        var t = function () {
          function t(e) {
            s(this || _global, t);
            (this || _global).settings = {
              popup: "right",
              layout: "default",
              alpha: true,
              editor: true,
              editorFormat: "hex",
              cancelButton: false,
              defaultColor: "#0cf"
            };
            (this || _global)._events = new i();
            (this || _global).onChange = null;
            (this || _global).onDone = null;
            (this || _global).onOpen = null;
            (this || _global).onClose = null;
            this.setOptions(e);
          }

          e(t, [{
            key: "setOptions",
            value: function e(t) {
              var i = this || _global;
              if (!t) return;
              var n = (this || _global).settings;

              function r(e, t, i) {
                for (var n in e) {
                  if (i && i.indexOf(n) >= 0) continue;
                  t[n] = e[n];
                }
              }

              if (t instanceof HTMLElement) n.parent = t;else {
                if (n.parent && t.parent && n.parent !== t.parent) {
                  (this || _global)._events.remove(n.parent);

                  (this || _global)._popupInited = false;
                }

                r(t, n);
                if (t.onChange) (this || _global).onChange = t.onChange;
                if (t.onDone) (this || _global).onDone = t.onDone;
                if (t.onOpen) (this || _global).onOpen = t.onOpen;
                if (t.onClose) (this || _global).onClose = t.onClose;
                var o = t.color || t.colour;
                if (o) this._setColor(o);
              }
              var s = n.parent;

              if (s && n.popup && !(this || _global)._popupInited) {
                var a = function e(t) {
                  return i.openHandler(t);
                };

                (this || _global)._events.add(s, "click", a);

                p((this || _global)._events, s, [" ", "Spacebar", "Enter"], a);
                (this || _global)._popupInited = true;
              } else if (t.parent && !n.popup) this.show();
            }
          }, {
            key: "openHandler",
            value: function e(t) {
              if (this.show()) {
                t && t.preventDefault();
                (this || _global).settings.parent.style.pointerEvents = "none";
                var i = t && t.type === h ? (this || _global)._domEdit : (this || _global).domElement;
                setTimeout(function () {
                  return i.focus();
                }, 100);
                if ((this || _global).onOpen) this.onOpen((this || _global).colour);
              }
            }
          }, {
            key: "closeHandler",
            value: function e(t) {
              var i = t && t.type;
              var n = false;
              if (!t) n = true;else if (i === d || i === u) {
                var r = ((this || _global).__containedEvent || 0) + 100;
                if (t.timeStamp > r) n = true;
              } else {
                g(t);
                n = true;
              }

              if (n && this.hide()) {
                (this || _global).settings.parent.style.pointerEvents = "";
                if (i !== d) (this || _global).settings.parent.focus();
                if ((this || _global).onClose) this.onClose((this || _global).colour);
              }
            }
          }, {
            key: "movePopup",
            value: function e(t, i) {
              this.closeHandler();
              this.setOptions(t);
              if (i) this.openHandler();
            }
          }, {
            key: "setColor",
            value: function e(t, i) {
              this._setColor(t, {
                silent: i
              });
            }
          }, {
            key: "_setColor",
            value: function e(t, i) {
              if (typeof t === "string") t = t.trim();
              if (!t) return;
              i = i || {};
              var n = void 0;

              try {
                n = new o(t);
              } catch (e) {
                if (i.failSilently) return;
                throw e;
              }

              if (!(this || _global).settings.alpha) {
                var r = n.hsla;
                r[3] = 1;
                n.hsla = r;
              }

              (this || _global).colour = (this || _global).color = n;

              this._setHSLA(null, null, null, null, i);
            }
          }, {
            key: "setColour",
            value: function e(t, i) {
              this.setColor(t, i);
            }
          }, {
            key: "show",
            value: function e() {
              var t = (this || _global).settings.parent;
              if (!t) return false;

              if ((this || _global).domElement) {
                var i = this._toggleDOM(true);

                this._setPosition();

                return i;
              }

              var n = (this || _global).settings.template || "<div class=\"picker_wrapper\" tabindex=\"-1\"><div class=\"picker_arrow\"></div><div class=\"picker_hue picker_slider\"><div class=\"picker_selector\"></div></div><div class=\"picker_sl\"><div class=\"picker_selector\"></div></div><div class=\"picker_alpha picker_slider\"><div class=\"picker_selector\"></div></div><div class=\"picker_editor\"><input aria-label=\"Type a color name or hex value\"/></div><div class=\"picker_sample\"></div><div class=\"picker_done\"><button>Ok</button></div><div class=\"picker_cancel\"><button>Cancel</button></div></div>";
              var r = l(n);
              (this || _global).domElement = r;
              (this || _global)._domH = w(".picker_hue", r);
              (this || _global)._domSL = w(".picker_sl", r);
              (this || _global)._domA = w(".picker_alpha", r);
              (this || _global)._domEdit = w(".picker_editor input", r);
              (this || _global)._domSample = w(".picker_sample", r);
              (this || _global)._domOkay = w(".picker_done button", r);
              (this || _global)._domCancel = w(".picker_cancel button", r);
              r.classList.add("layout_" + (this || _global).settings.layout);
              if (!(this || _global).settings.alpha) r.classList.add("no_alpha");
              if (!(this || _global).settings.editor) r.classList.add("no_editor");
              if (!(this || _global).settings.cancelButton) r.classList.add("no_cancel");

              this._ifPopup(function () {
                return r.classList.add("popup");
              });

              this._setPosition();

              if ((this || _global).colour) this._updateUI();else this._setColor((this || _global).settings.defaultColor);

              this._bindEvents();

              return true;
            }
          }, {
            key: "hide",
            value: function e() {
              return this._toggleDOM(false);
            }
          }, {
            key: "destroy",
            value: function e() {
              (this || _global)._events.destroy();

              if ((this || _global).domElement) (this || _global).settings.parent.removeChild((this || _global).domElement);
            }
          }, {
            key: "_bindEvents",
            value: function e() {
              var i = this || _global;
              var n = this || _global,
                  r = (this || _global).domElement,
                  o = (this || _global)._events;

              function s(e, t, i) {
                o.add(e, t, i);
              }

              s(r, "click", function (e) {
                return e.preventDefault();
              });
              c(o, (this || _global)._domH, function (e, t) {
                return n._setHSLA(e);
              });
              c(o, (this || _global)._domSL, function (e, t) {
                return n._setHSLA(null, e, 1 - t);
              });
              if ((this || _global).settings.alpha) c(o, (this || _global)._domA, function (e, t) {
                return n._setHSLA(null, null, null, 1 - t);
              });
              var t = (this || _global)._domEdit;
              {
                s(t, "input", function (e) {
                  n._setColor((this || _global).value, {
                    fromEditor: true,
                    failSilently: true
                  });
                });
                s(t, "focus", function (e) {
                  var t = this || _global;
                  if (t.selectionStart === t.selectionEnd) t.select();
                });
              }

              this._ifPopup(function () {
                var e = function e(t) {
                  return i.closeHandler(t);
                };

                s(window, d, e);
                s(window, u, e);
                p(o, r, ["Esc", "Escape"], e);

                var t = function e(t) {
                  i.__containedEvent = t.timeStamp;
                };

                s(r, d, t);
                s(r, u, t);
                s(i._domCancel, "click", e);
              });

              var a = function e(t) {
                i._ifPopup(function () {
                  return i.closeHandler(t);
                });

                if (i.onDone) i.onDone(i.colour);
              };

              s((this || _global)._domOkay, "click", a);
              p(o, r, ["Enter"], a);
            }
          }, {
            key: "_setPosition",
            value: function e() {
              var i = (this || _global).settings.parent,
                  n = (this || _global).domElement;
              if (i !== n.parentNode) i.appendChild(n);

              this._ifPopup(function (e) {
                if (getComputedStyle(i).position === "static") i.style.position = "relative";
                var t = e === true ? "popup_right" : "popup_" + e;
                ["popup_top", "popup_bottom", "popup_left", "popup_right"].forEach(function (e) {
                  if (e === t) n.classList.add(e);else n.classList.remove(e);
                });
                n.classList.add(t);
              });
            }
          }, {
            key: "_setHSLA",
            value: function e(t, i, n, r, o) {
              o = o || {};
              var s = (this || _global).colour,
                  a = s.hsla;
              [t, i, n, r].forEach(function (e, t) {
                if (e || e === 0) a[t] = e;
              });
              s.hsla = a;

              this._updateUI(o);

              if ((this || _global).onChange && !o.silent) this.onChange(s);
            }
          }, {
            key: "_updateUI",
            value: function e(t) {
              if (!(this || _global).domElement) return;
              t = t || {};
              var i = (this || _global).colour,
                  n = i.hsla,
                  r = "hsl(" + n[0] * y + ", 100%, 50%)",
                  o = i.hslString,
                  s = i.hslaString;
              var a = (this || _global)._domH,
                  l = (this || _global)._domSL,
                  c = (this || _global)._domA,
                  h = w(".picker_selector", a),
                  d = w(".picker_selector", l),
                  u = w(".picker_selector", c);

              function g(e, t, i) {
                t.style.left = i * 100 + "%";
              }

              function p(e, t, i) {
                t.style.top = i * 100 + "%";
              }

              g(a, h, n[0]);
              (this || _global)._domSL.style.backgroundColor = (this || _global)._domH.style.color = r;
              g(l, d, n[1]);
              p(l, d, 1 - n[2]);
              l.style.color = o;
              p(c, u, 1 - n[3]);
              var m = o,
                  f = m.replace("hsl", "hsla").replace(")", ", 0)"),
                  C = "linear-gradient(" + [m, f] + ")";
              (this || _global)._domA.style.background = C + ", " + b;

              if (!t.fromEditor) {
                var I = (this || _global).settings.editorFormat,
                    v = (this || _global).settings.alpha;
                var A = void 0;

                switch (I) {
                  case "rgb":
                    A = i.printRGB(v);
                    break;

                  case "hsl":
                    A = i.printHSL(v);
                    break;

                  default:
                    A = i.printHex(v);
                }

                (this || _global)._domEdit.value = A;
              }

              (this || _global)._domSample.style.color = s;
            }
          }, {
            key: "_ifPopup",
            value: function e(t, i) {
              if ((this || _global).settings.parent && (this || _global).settings.popup) t && t((this || _global).settings.popup);else i && i();
            }
          }, {
            key: "_toggleDOM",
            value: function e(t) {
              var i = (this || _global).domElement;
              if (!i) return false;
              var n = t ? "" : "none",
                  r = i.style.display !== n;
              if (r) i.style.display = n;
              return r;
            }
          }]);
          return t;
        }(),
            n = document.createElement("style");

        return n.textContent = ".picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:\"\";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:\"\";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:\"\";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:\"\";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}", document.documentElement.firstElementChild.appendChild(n), t.StyleElement = n, t;
      }();
    },
    402: function (e, t) {
      "use strict";

      function i(e, t) {
        if (!((this || _global) instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
        (this || _global).message = e + " (char " + t + ")", (this || _global).char = t, (this || _global).stack = new Error().stack;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), ((t.default = i).prototype = new Error()).constructor = Error;
    },
    3860: function (e, t, i) {
      e.exports = i(7490).default;
    },
    7490: function (e, t, i) {
      "use strict";

      t.default = function (e) {
        I = "", v = 0, A = (C = e).charAt(0), b = "", y = d, k();
        var t = y;
        if (T(), E(), "" === b) return I;

        if (t === y && x()) {
          for (var i = ""; t === y && x();) I = (0, o.insertBeforeLastWhitespace)(I, ","), i += I, I = "", T(), E();

          return "[\n".concat(i).concat(I, "\n]");
        }

        throw new r.default("Unexpected characters", v - b.length);
      };

      var r = (t = i(402)) && t.__esModule ? t : {
        default: t
      },
          o = i(9422);
      var n = 0,
          s = 1,
          a = 2,
          l = 3,
          c = 4,
          h = 5,
          d = 6,
          u = {
        "": !0,
        "{": !0,
        "}": !0,
        "[": !0,
        "]": !0,
        ":": !0,
        ",": !0,
        "(": !0,
        ")": !0,
        ";": !0,
        "+": !0
      },
          g = {
        "\"": "\"",
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "\t"
      },
          p = {
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t"
      },
          m = {
        null: "null",
        true: "true",
        false: "false"
      },
          f = {
        None: "null",
        True: "true",
        False: "false"
      },
          C = "",
          I = "",
          v = 0,
          A = "",
          b = "",
          y = d;

      function w() {
        v++, A = C.charAt(v);
      }

      function S() {
        w(), "\\" === A && w();
      }

      function x() {
        return y === n && ("[" === b || "{" === b) || y === a || y === s || y === l;
      }

      function k() {
        if (I += b, y = d, b = "", u[A]) y = n, b = A, w();else if ((0, o.isDigit)(A) || "-" === A) {
          if (y = s, "-" === A) {
            if (b += A, w(), !(0, o.isDigit)(A)) throw new r.default("Invalid number, digit expected", v);
          } else "0" === A && (b += A, w());

          for (; (0, o.isDigit)(A);) b += A, w();

          if ("." === A) {
            if (b += A, w(), !(0, o.isDigit)(A)) throw new r.default("Invalid number, digit expected", v);

            for (; (0, o.isDigit)(A);) b += A, w();
          }

          if ("e" === A || "E" === A) {
            if (b += A, w(), "+" !== A && "-" !== A || (b += A, w()), !(0, o.isDigit)(A)) throw new r.default("Invalid number, digit expected", v);

            for (; (0, o.isDigit)(A);) b += A, w();
          }
        } else "\\" === A && "\"" === C.charAt(v + 1) ? (w(), R(S)) : R(w);
        y === c && (b = (0, o.normalizeWhitespace)(b), k()), y === h && (y = d, b = "", k());
      }

      function E() {
        "," === b && (b = "", y = d, k());
      }

      function R(e) {
        if ((0, o.isQuote)(A)) {
          var t = (0, o.normalizeQuote)(A),
              i = (0, o.isSingleQuote)(A) ? o.isSingleQuote : o.isDoubleQuote;

          for (b += "\"", y = a, e(); "" !== A && !i(A);) if ("\\" === A) {
            if (e(), void 0 !== g[A]) b += "\\" + A, e();else if ("u" === A) {
              b += "\\u", e();

              for (var n = 0; n < 4; n++) {
                if (!(0, o.isHex)(A)) throw new r.default("Invalid unicode character", v - b.length);
                b += A, e();
              }
            } else {
              if ("'" !== A) throw new r.default("Invalid escape character \"\\" + A + "\"", v);
              b += "'", e();
            }
          } else p[A] ? b += p[A] : b += "\"" === A ? "\\\"" : A, e();

          if ((0, o.normalizeQuote)(A) !== t) throw new r.default("End of string expected", v - b.length);
          return b += "\"", void e();
        }

        if ((0, o.isAlpha)(A)) for (y = l; (0, o.isAlpha)(A) || (0, o.isDigit)(A) || "$" === A;) b += A, w();else if ((0, o.isWhitespace)(A) || (0, o.isSpecialWhitespace)(A)) for (y = c; (0, o.isWhitespace)(A) || (0, o.isSpecialWhitespace)(A);) b += A, w();else if ("/" === A && "*" === C[v + 1]) {
          for (y = h; "" !== A && ("*" !== A || "*" === A && "/" !== C[v + 1]);) b += A, w();

          "*" === A && "/" === C[v + 1] && (b += A, w(), b += A, w());
        } else if ("/" === A && "/" === C[v + 1]) for (y = h; "" !== A && "\n" !== A;) b += A, w();else {
          y = d;

          for (; "" !== A;) b += A, w();

          throw new r.default("Syntax error in part \"" + b + "\"", v - b.length);
        }
      }

      function T() {
        if (y === n && "{" === b) {
          if (k(), y === n && "}" === b) k();else {
            for (;;) {
              if (y !== l && y !== s || (y = a, b = "\"".concat(b, "\"")), y !== a) throw new r.default("Object key expected", v - b.length);
              if (k(), y === n && ":" === b) k();else {
                if (!x()) throw new r.default("Colon expected", v - b.length);
                I = (0, o.insertBeforeLastWhitespace)(I, ":");
              }

              if (T(), y === n && "," === b) {
                if (k(), y === n && "}" === b) {
                  I = (0, o.stripLastOccurrence)(I, ",");
                  break;
                }

                if ("" === b) {
                  I = (0, o.stripLastOccurrence)(I, ",");
                  break;
                }
              } else {
                if (y !== a && y !== s && y !== l) break;
                I = (0, o.insertBeforeLastWhitespace)(I, ",");
              }
            }

            y === n && "}" === b ? k() : I = (0, o.insertBeforeLastWhitespace)(I, "}");
          }
        } else if (y === n && "[" === b) {
          if (k(), y === n && "]" === b) k();else {
            for (;;) if (T(), y === n && "," === b) {
              if (k(), y === n && "]" === b) {
                I = (0, o.stripLastOccurrence)(I, ",");
                break;
              }

              if ("" === b) {
                I = (0, o.stripLastOccurrence)(I, ",");
                break;
              }
            } else {
              if (!x()) break;
              I = (0, o.insertBeforeLastWhitespace)(I, ",");
            }

            y === n && "]" === b ? k() : I = (0, o.insertBeforeLastWhitespace)(I, "]");
          }
        } else if (y === a) for (k(); y === n && "+" === b;) {
          var e;
          b = "", k(), y === a && (e = I.lastIndexOf("\""), I = I.substring(0, e) + b.substring(1), b = "", k());
        } else if (y === s) k();else {
          if (y !== l) throw "" === b ? new r.default("Unexpected end of json string", v - b.length) : new r.default("Value expected", v - b.length);
          if (m[b]) k();else {
            if (f[b]) return void (b = f[b], k());
            var t = b,
                i = I.length;
            if (b = "", k(), y === n && "(" === b) return void (b = "", k(), T(), y === n && ")" === b && (b = "", k(), y === n && ";" === b && (b = "", k())));

            for (I = (0, o.insertAtIndex)(I, "\"".concat(t), i); y === l || y === s;) k();

            I += "\"";
          }
        }
      }
    },
    9422: function (e, t) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isAlpha = function (e) {
        return r.test(e);
      }, t.isHex = function (e) {
        return o.test(e);
      }, t.isDigit = function (e) {
        return s.test(e);
      }, t.isWhitespace = a, t.isSpecialWhitespace = l, t.normalizeWhitespace = function (e) {
        for (var t = "", i = 0; i < e.length; i++) {
          var n = e[i];
          t += l(n) ? " " : n;
        }

        return t;
      }, t.isQuote = function (e) {
        return !0 === i[e] || !0 === n[e];
      }, t.isSingleQuote = function (e) {
        return !0 === i[e];
      }, t.isDoubleQuote = function (e) {
        return !0 === n[e];
      }, t.normalizeQuote = function (e) {
        return !0 !== i[e] ? !0 !== n[e] ? e : "\"" : "'";
      }, t.stripLastOccurrence = function (e, t) {
        t = e.lastIndexOf(t);
        return -1 !== t ? e.substring(0, t) + e.substring(t + 1) : e;
      }, t.insertBeforeLastWhitespace = function (e, t) {
        var i = e.length;
        if (!a(e[i - 1])) return e + t;

        for (; a(e[i - 1]);) i--;

        return e.substring(0, i) + t + e.substring(i);
      }, t.insertAtIndex = function (e, t, i) {
        return e.substring(0, i) + t + e.substring(i);
      };
      var i = {
        "'": !0,
        "\u2018": !0,
        "\u2019": !0,
        "`": !0,
        "\xB4": !0
      },
          n = {
        "\"": !0,
        "\u201C": !0,
        "\u201D": !0
      };
      var r = /^[a-zA-Z_]$/;
      var o = /^[0-9a-fA-F]$/;
      var s = /^[0-9]$/;

      function a(e) {
        return " " === e || "\t" === e || "\n" === e || "\r" === e;
      }

      function l(e) {
        return "\xA0" === e || "\u2000" <= e && e <= "\u200A" || "\u202F" === e || "\u205F" === e || "\u3000" === e;
      }
    },
    894: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON Schema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");
    },
    7171: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"id\":\"http://json-schema.org/draft-04/schema#\",\"$schema\":\"http://json-schema.org/draft-04/schema#\",\"description\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"positiveInteger\":{\"type\":\"integer\",\"minimum\":0},\"positiveIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/positiveInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1,\"uniqueItems\":true}},\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"$schema\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"multipleOf\":{\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"boolean\",\"default\":false},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"boolean\",\"default\":false},\"maxLength\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minLength\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minItems\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxProperties\":{\"$ref\":\"#/definitions/positiveInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/positiveIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"anyOf\":[{\"type\":\"boolean\"},{\"$ref\":\"#\"}],\"default\":{}},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"dependencies\":{\"exclusiveMaximum\":[\"maximum\"],\"exclusiveMinimum\":[\"minimum\"]},\"default\":{}}");
    },
    6273: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-06/schema#\",\"$id\":\"http://json-schema.org/draft-06/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":{},\"examples\":{\"type\":\"array\",\"items\":{}},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":{}},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":{},\"enum\":{\"type\":\"array\",\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":{}}");
    },
    6680: function (e) {
      "use strict";

      e.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");
    }
  }, r = {}, n.amdD = function () {
    throw new Error("define cannot be used indirect");
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
      enumerable: !0,
      get: t[i]
    });
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.nmd = function (e) {
    return e.paths = [], e.children || (e.children = []), e;
  }, n(3161);

  function n(e) {
    var t = r[e];
    if (void 0 !== t) return t.exports;
    t = r[e] = {
      id: e,
      loaded: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, n), t.loaded = !0, t.exports;
  }

  var i, r;
}); //# sourceMappingURL=jsoneditor.map

export default exports;
export const JSONEditor = exports.JSONEditor;